console.log('globalvisio © easy-live.fr');  
var G;
if (!isdefined(G)) {
	G = {};
}
 
if (!isdefined(G.vo)) {
	G.vo = {}; 
}

/**
 * @constructor
 */
G.vo.ResponsiveManager = function(){

	/** @type {G.vo.ResponsiveBreak} */
	this.responsiveBreak = null;

	this.responsiveBreaksInit = function () {
		$(window).resize(this.responsiveBreaksSearch.bind(this));
		this.responsiveBreaksSearch();
	};

	this.responsiveBreaksSearch = function (event) {
		if (this.useResizeTimeoutID && event != null) {
			clearTimeout(this.useResizeTimeoutID);
			this.useResizeTimeoutID = setTimeout(this.searchResponsiveBreaks.bind(this), this.resizeTimeoutDuration);
			return;
		}

		/** @type {G.vo.ResponsiveBreak[]} */
		var breaks = G.config.RESPONSIVE_BREAKS;
		/** @type {number} */
		var
			i,
			len = breaks.length,
			winWidth = $(window).outerWidth()
		;

		for(i = 0; i < len; ++i) {
			if (winWidth > breaks[i].min) {
				if (this.responsiveBreak == breaks[i])
					return;
				this.responsiveBreak = breaks[i];
				
				document.body.cleanClasses('responsive--');
				document.body.classList.add('responsive--' + this.responsiveBreak.id);

				$(document).trigger($.Event('responsiveBreak', {
					responsiveBreak: this.responsiveBreak
				}));
				break;
			}
		}
	}
};


if (!isdefined(G.Responsive)) {
	G.Responsive = new G.vo.ResponsiveManager();
}

var G;

if (!isdefined(G))
	G = {};

if (!isdefined(G.config))
	G.config = {};

G.config.LOCALE_ACCENTS_MAP = {
	"Á": "a",
	"á": "a",
	"à": "a",
	"À": "a",
	"Â": "a",
	"â": "a",
	"Ä": "a",
	"ä": "a",
	"Ç": "c",
	"ç": "c",
	"É": "e",
	"é": "e",
	"È": "e",
	"è": "e",
	"Ê": "e",
	"ê": "e",
	"Ë": "e",
	"ë": "e",
	"Í": "i",
	"í": "i",
	"Ì": "i",
	"ì": "i",
	"Î": "i",
	"î": "i",
	"Ï": "i",
	"ï": "i",
	"Ó": "o",
	"ó": "o",
	"Ò": "o",
	"ò": "o",
	"Ô": "o",
	"ô": "o",
	"Ö": "o",
	"ö": "o",
	"ß": "s",
	"Ú": "u",
	"ú": "u",
	"Ù": "u",
	"ù": "u",
	"Û": "u",
	"û": "u",
	"Ü": "u",
	"ü": "u",
	"Ý": "y",
	"ý": "y",
	"Ỳ": "y",
	"ỳ": "y",
	"Ŷ": "y",
	"ŷ": "y",
	"Ÿ": "y",
	"ÿ": "y"
};

/**
 *
 * @param name {string}
 * @param o {Object.<{string, string|[]}>}
 */
G.config.localeAddFolder = function(name, o){
	G.config.LOCALE[G.model.lang || 'fr'][name] = o;
};

/**
 * Returns a localized string corresponding to the passed-in reference path.
 * @param path       {string}       path to reference using a "uiid.uiid.uiid" structure definition
 * @param dico       ?{{}}          dictionnary to look into, if omitted will use default localization dictionnary G.config.LOCALE
 * @param ornull     ?{boolean}     whether to return null or an empty string if localized reference is not found
 * @return           {null|string|Array}     localized reference
 * @see  G.config.LOCALE
 */
G.config.LOCALE_RETRIEVE = function (path, dico, ornull) {
	var tokens, pointer;

	if (!dico)
		dico = G.config.LOCALE[G.model.lang || 'fr'];

	try {
		pointer = dico;
		tokens = path.split('.');
		for (var i = 0, ilen = tokens.length; i < ilen; ++i)
			pointer = pointer[tokens[i]];
		return pointer;
	}
	catch (err) {
		console.warn('[G.config.LOCALE_RETRIEVE] Unable to retrieve path: "' + path + '"');
		return ornull === true ? null : path;
	}
};

/**
 * Localizes a date value.
 * @param d {Date}   date to be localized
 * @return {string}  localized date
 */
G.config.LOCALE_DATE = function (d) {
	var s = '';
	if (d !== null && d != '') {
		s += digits2(d.getDate())
			+ '/' + digits2(d.getMonth() + 1)
			+ '/<span class="hide--mobile">' + d.getFullYear().toString().substr(0, 2) + '</span>'
			+ d.getFullYear().toString().substr(2, 2);
		s += ' ';
		s += digits2(d.getHours()) + ':' + digits2(d.getMinutes());
	}
	return s;
};

/**
 * @type {{}}
 */
G.config.LOCALE = {
	fr: {
		date: {
			days: ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'],
			daysShort: ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'],
			monthes: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
			monthesShort: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc'],
		},
		pickaday: {
			firstDay: 1,
			previousMonth: 'Mois précédent',
			nextMonth: 'Mois suivant',
			months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
			weekdays: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
			weekdaysShort: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
		},
		highchart: {
			addNote: 'Ajouter une annotation',
			removeNote: 'Supprimer une annotation',
			deleteGraphRow: 'Supprimer',
			subtitleFromTo: 'Période du {DATE_FROM} au {DATE_TO}',
			contextButtonTitle: 'Exporter le graphique',
			decimalPoint: ',',
			downloadCSV: 'Télécharger au format CSV',
			downloadJPEG: 'Télécharger en image JPEG',
			downloadPDF: 'Télécharger en document PDF',
			downloadPNG: 'Télécharger en image PNG',
			downloadSVG: 'Télécharger en document Vectoriel',
			downloadXLS: 'Télécharger au format Excel',
			viewData: 'Accès au tableau',
			drillUpText: 'Retour à {series.name}',
			invalidDate: '',
			loading: 'Chargement en cours…',
			months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
			noData: 'Aucune donnée à afficher',
			printChart: 'Imprimer',
			range: 'Plage',
			resetZoom: 'Réinitialiser le zoom',
			resetZoomTitle: 'Réinitialiser le zoom au niveau 1:1',
			shortMonths: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc'],
			shortWeekdays: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
			thousandsSep: ' ',
			weekdays: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
		},
		hch: {
			graphSave: 'Enregistrer la présentation',
			graphName: 'Nom de la présentation',
			graphSetName: 'Veuillez définir un nom pour la présentation',
			seriesSort: 'Changer la profondeur de la série',
			seriesDelete: 'Effacer la série',
			seriesResetColor: 'Redéfinir la couleur de la série',
			subtitleFromTo: 'Période du {DATE_FROM} au {DATE_TO}',
			subtitleFromToSingle: '{DATE_FROM}',
			overwritePendingChanges: 'Des modifications à votre graphique n\'ont pas été enregistrées. Voulez-vous poursuivre cette action et perdre ces dernières ?',

			addNotePointSelectLabel: 'Point associé',
			addNotePointSelectDefault: 'Veuillez sélectionner un point',
			addNoteDateLabel: 'Période',
			addNoteDateInfo: 'Vous pouvez saisir les dates librement ou la définir en cliquant dans le graphique une fois le curseur placé dans les champs de période.',
			addNoteDateFromLabel: 'du',
			addNoteDateFromPlaceholder: 'DD/MM/AAAA HH:MM',
			addNoteDateToLabel: 'au',
			addNoteDateToPlaceholder: 'DD/MM/AAAA HH:MM',
			addNoteTitlePlaceholder: 'Titre',
			addNoteDescPlaceholder: 'Commentaire',
			addNoteSubmitLabel: 'Ajouter',
			addNoteCloseLabel: 'Fermer',
			addNoteNotPossibleToPieChart: 'Vous ne pouvez pas ajouter les annotations sur un graphique camembert',

			deleteNoteNoteSelectLabel: 'Selectionnez l\'annotation',
			deleteNoteSubmitLabel: 'Supprimer',
			deleteNoteCloseLabel: 'Fermer',
			range: 'Plage'
		},
		datatable: {
			processing: "Traitement en cours...",
			search: "Rechercher&nbsp;:",
			lengthMenu: "Afficher _MENU_ &eacute;l&eacute;ments",
			info: "Affichage de l'&eacute;lement _START_ &agrave; _END_ sur _TOTAL_ &eacute;l&eacute;ments",
			infoEmpty: "Affichage de l'&eacute;lement 0 &agrave; 0 sur 0 &eacute;l&eacute;ments",
			infoFiltered: "(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)",
			infoPostFix: "",
			selectAll: "Tout sélectionner",
			selectNone: "Tout désélectionner",
			loadingRecords: "Chargement en cours...",
			zeroRecords: "Aucun &eacute;l&eacute;ment &agrave; afficher",
			emptyTable: "Aucune donnée disponible dans le tableau",
			paginate: {
				first: "Premier",
				previous: "Pr&eacute;c&eacute;dent",
				next: "Suivant",
				last: "Dernier"
			},
			aria: {
				sortAscending: ": activer pour trier la colonne par ordre croissant",
				sortDescending: ": activer pour trier la colonne par ordre décroissant"
			},
			buttons: {
				selectAll: "Tout sélectionner",
				selectNone: "Rien sélectionner",
				"collection": "Collection",
				"colvis": "Visibilité colonnes",
				"colvisRestore": "Rétablir visibilité",
				"copy": "Copier",
				"copySuccess": {
					"1": "1 ligne copiée dans le presse-papier",
					"_": "%d lignes copiées dans le presse-papier"
				},
				"copyTitle": "Copier dans le presse-papier",
				"csv": "CSV",
				"excel": "Excel",
				"pageLength": {
					"1": "Afficher 1 ligne",
					"-1": "Afficher toutes les lignes",
					"_": "Afficher %d lignes"
				},
				"pdf": "PDF",
				"print": "Imprimer",
				"copyKeys": "Appuyez sur ctrl ou u2318 + C pour copier les données du tableau dans votre presse-papier.",
				"createState": "Créer un état",
				"removeAllStates": "Supprimer tous les états",
				"removeState": "Supprimer",
				"renameState": "Renommer",
				"savedStates": "États sauvegardés",
				"stateRestore": "État %d",
				"updateState": "Mettre à jour"
			},
			select: {
				rows: {
					_: "%d lignes sélectionnées",
					0: "Cliquer sur une ligne pour la sélectionner",
					1: "1 ligne sélectionnée"
				}
			},
			"editor": {
				"close": "Fermer",
				"create": {
					"title": "Créer une nouvelle entrée",
					"button": "Nouveau",
					"submit": "Créer"
				},
				"edit": {
					"button": "Éditer",
					"title": "Éditer Entrée",
					"submit": "Mettre à jour"
				},
				"remove": {
					"button": "Supprimer",
					"title": "Supprimer",
					"submit": "Supprimer",
					"confirm": {
						"1": "Êtes-vous sûr de vouloir supprimer 1 ligne ?",
						"_": "Êtes-vous sûr de vouloir supprimer %d lignes ?"
					}
				},
				"multi": {
					"title": "Valeurs multiples",
					"info": "Les éléments sélectionnés contiennent différentes valeurs pour cette entrée. Pour modifier et définir tous les éléments de cette entrée à la même valeur, cliquez ou tapez ici, sinon ils conserveront leurs valeurs individuelles.",
					"restore": "Annuler les modifications",
					"noMulti": "Ce champ peut être modifié individuellement, mais ne fait pas partie d'un groupe. "
				},
				"error": {
					"system": "Une erreur système s'est produite (<a target=\"\\\"rel=\"nofollow\"href=\"\\\">Plus d'information</a>)."
				}
			}
		},
		listSites: {
			multisiteNoAlerts: "Aucune alerte active",
			monositeNoAlerts: "Aucune alerte active",
			siblingAlertsCount: '{num} dernières alertes identiques',
			siblingAlertCount: 'dernière alerte identique',

			siblingAlertDetailFromTo: 'début : {from} - fin : {to}',
			siblingAlertDetailFrom: 'début : {from}',
			siblingShowInSite: '› Détailler cette alerte dans la vue du site'
		},
		siteAccess: {
			deniedTitle: "Accès refusé",
			deniedText: "Vous n'avez pas accès à ce site.<br>Vous avez été redirigé vers votre tableau de bord."
		},	
		indicator: {
			aucunesDonneesDisponibles: 'Aucunes données disponibles',
			performanceReal: 'Réel',
			performanceAdjusted: 'Ajusté',
			performanceObjective: 'Cible',
			performancePercentAxisTitle: 'Pourcentage (%)',
			performanceDjuAxisTitle: 'DJU',
			performanceDelta: 'Écart',
			performanceDjuReal: 'DJU Réel',
			performanceDjuRef: 'DJU de référence',
			obsoleteTooltip: "La valeur affichée est obsolète",
			fictitiousTooltip: "La valeur affichée est fictive",
			noHeatingCurveConfigured: "Il n'y a pas de courbe de chauffe configurée",
			writeParamsProgrammed: "L'écriture des paramètres a été programmée",
			notifyByEmail: "Vous serez notifié du résultat de l'opération par mail",
			total: "Total",
			online: "En ligne",
			offline: "Hors ligne",
			notInstalled: "Non installé",
			page: {
				createTitle: "Création d'une page",
				editTitle: "Édition de la page",
				pageSavedTitle: "Page sauvegardée",
				position: "Position",
				logo: "Logo",
				logoHelp: "Optionnel"
			},
			edition: {
				createTitle: "Création d'un indicateur",
				previewAlt: "Aperçu de l'indicateur en fonction du type",

				sections: "Sections",
				sectionSavedTitle: "Section sauvegardée",
				indicatorType: "Type d'indicateur",
				rightLevel: "Niveau de droit",
				planningWriteLevel: "Niveau droit d'écriture",
				planningWriteLevelHelp: "Un utilisateur ayant un niveau de droit inferieurs ne pourra pas modifier le planning",
				description: "Description",
				icon: "Icône",
				chooseIcon: "Veuillez choisir une icône",
				active: "Actif",

				editTitle: "Édition d'un indicateur",
				editTitleGeneric: "Édition de l'indicateur",
				next: "Suivant",
				previous: "Précédent",
				confirmEditQuestion: "Êtes-vous sûrs de vouloir modifier l'indicateur ?",
				confirmEdit: "Modifier",

				createdTitle: "L'indicateur a été créé",
    			createdText: "Vous pouvez le visualiser sur le tableau de bord du site.",
				updatedText: "L'indicateur a été modifié. Vous pouvez le visualiser sur le tableau de bord du site.",
				goToDashboard: "Aller sur le tableau de bord du site",
				dimensionHelp: "Format d'affichage (Largeur : Hauteur).",

				dimension: "Dimension",
				equipment: "Équipement",
				point: "Point",
				points: "Points",
				options: "Options",
				couleur: "Couleur",
				type: "Type",
				typeGraphique: "Type de graphique",

				mode: {
					label: "Mode",
					standard: "Standard",
					condition: "Condition",
					counter: "Compteur",
					help: "Le mode détermine le type de données renvoyées. Par exemple le mode Compteur renvoie des données de consommation"
				},

				comment: "Commentaire",
				commentHelp: "Affiche une ligne d'information dans l'indicateur",

				operator: "Opérateur",
				threshold: "Seuil",

				noAssociatedChart: "Pas de graphique associé",
				noAssociatedChartHelp: "Il n'y a pas de bouton \"+\" pour afficher un graphique",

				suffix: "Suffixe",
				suffixHelp: "Remplace les unités affichées par défaut",

				trend: "Tendance",
				trendHelp: "Affiche les variations par rapport à la période précédente",

				browsable: "Navigable",
				browsableHelp: "Permet de naviguer entre différentes périodes, selon la période définie par l'utilisateur",

				chartOptions: "Options associées au graphique",

				minimum: "Minimum",
				minimumHelp: "Affecte le minimum sur le graphique associé",
				maximum: "Maximum",
				maximumHelp: "Affecte le maximum sur le graphique associé",

				period: "Période",

				chart: "Graphique",
				chartHelp: "Si sélectionné, un graphique sera affiché au lieu des points",

				object: "Objet",

				calculation: "Calcul",
				calculationFormula: "Formule de calcul",

				size: "Taille",
				label: "Label",
				formula: "Formule",
				customization: "Personnalisation",
				steps: "Paliers",
				configuration: "Configuration",
				status: "État",
				to: "À",
				preview: "Aperçu",
				terminalRegulation: "Régulation terminale",
				legendTitle: "Titre de la légende",
				dataType: "Type de données",
				subDataType: "Sous-type de données",
				allAlarms: "Toutes les alarmes:",
				activeAlarmsOnly: "Uniquement les alarmes actives",

				rules: {
					title: "Règles",
					valueDisplay: "Affichage valeur",
					substitutedValue: "Valeur substituée",
					status: {
						normal: "Normal",
						success: "Succès",
						warning: "Avertissement",
						alert: "Alerte"
					}
				},

				consumption: {
					ratio: "Ratio",
					ratioHelp: "Applique un ratio sur les données de consommations",
					limit: "Limite",
					limitHelp: "Nombre maximum de points à afficher",
					topConsoModeHelp: "Définit le mode d'affichage utilisé pour la consommation principale",

					analysis: "Analyse",
					analysisHelp: "Affiche un panneau latéral avec analyser plus finement les données",

					labelConsumption: "Label Consommation",
					labelConsumptionHelp: "Label affiché au dessus de la valeur",

					labelTrend: "Label Tendance",
					labelTrendHelp: "Label affiché au dessus de la tendance",

					chartStackedBars: "Barres empliées",
					chartStackedBarsHelp: "Les barres sont empilées sur le graphique"
				},

				img: {
					previewTitle: "Aperçu",
					previewAlt: "Aperçu de l'indicateur image",
					configurationTitle: "Configuration",

					sourceSite: "Image du site",
					sourceZone: "Image de la zone",
					sourceCustom: "Image personnalisée",

					associatedZone: "Zone associée",
					customImageLabel: "Image personnalisée"
				},

				trio: {
					modeTitle: "Mode",
					onePoint: "1 point",
					twoPoints: "2 points",
					threePoints: "3 points",

					primary: "Primaire",
					secondary: "Secondaire",
					tertiary: "Tertiaire"
				},

				integrated: "Intégré",
				chartOnDashboard: "Le graphique est affiché sur le dashboard",
				advancedAnalysis: "Analyse avancée",
				advancedAnalysisHelp: "Mise à disposition des éléments d'analyse avancée (DJU, calcul par jour, somme, moyenne...)",
				zone: "Zone",
				default: "Défaut",
				toggler: "Toggler",
				textLabelOn: "Texte label on",
				textDisplayedOn: "Texte affiché sur valeur on",
				textLabelOff: "Texte label off",
				textDisplayedOff: "Texte affiché sur valeur off",
				none: "Aucun",
				multi: "Multiple",
				invert: "Inversé",
				live: "Temps réel",
				alarmsCount: "Nombre d'alarmes",
				occupantsCount: "Nombre d'occupants",
				dwellingsCount: "Nombre de logements",
				mealsPerDayCount: "Nombre de repas / jour",
				surface: "Surface",
				housesInZone: "Nb. logements d'une zone",
				ecsLoopLength: "ECS bouclage longueur",
				dju: "DJU",
				djuRatioHelp: "Affiche un ratio par DJU",
				textArea: "Zone de texte",
				gauge: "Gauge",
				sliderMode: "Mode du slider",
				sliderDisplayMode: "Définit le mode d'affichage du slider",
				associatedToChart: "associée au graphique",
				minimumLegendHelp: "Affecte le minimum de la légende du graphique",
				maximumLegendHelp: "Affecte le maximum de la légende du graphique",
				startAndEndDate: "Début / Fin",
				startDate: "Début",
				endDate: "Fin",

				displayValueForDate: "Permet d'afficher la valeur d'un indicateur pour une date donnée",
				sectionCreation: "Création d'une section",
				editSection: "Édition de la section",
				unsupportedIndicatorType: "Ce type d'indicateur n'est actuellement pas pris en charge pour cette interface d'édition",
				interventionCountDisplay: "nombre d'interventions à afficher",
				heatingCurvesAutoAdded: "Les nouvelles courbes de chauffe seront ajoutées automatiquement à l'indicateur.",
				history: "Historique",
				historyMonthlyHelp: "Enregistre les valeurs de consommations mensuellement",
				heatmapColorPaletteHelp: "Définit la palette de couleurs utilisée pour afficher les valeurs sur la carte thermique",
				heatmapColorPalette: "Palette de couleurs",
				heatmapColorPaletteNeutral: "Neutre",
				heatmapColorPaletteHot: "Chaud",
				heatmapColorPaletteCold: "Froid",
				selectZone: "Sélectionner une zone",
				minMaxValidationError: "Pour chaque palier, la valeur minimale doit être inférieure à la valeur maximale",
				stepsOverlapValidationError: "Les paliers ne doivent pas se superposer",
				noModelAvailable: "Aucun modèle disponible",
				modelApplied: "Modèle appliqué",
				applyModel: "Appliquer un modèle",
				applyModelWarning: "Attention, cette action effacera vos paliers existants",
				sliderPreviewHelp: "Représentation visuelle des paliers configurés",
				photovoltaicPower: "Puissance photovoltaïque installée kWc",
				addRealtimeButtonHelp: "Ajoute un bouton pour récupérer la valeur en temps réel",
				showDateFilter: "Afficher le filtre date",
				sourcePoints: "Source des points",
				currentSite: "Site courant",
				estateChildSites: "Sites enfants patrimoines",
				dateFilter: "Filtre date",
				loadAllHeatingCurves: "Charger dynamiquement toutes les courbes de chauffe du site",
				formulaHelp: "Applique une formule (format: #value# /10)",
				odyssee: "Odyssee",

                displaySiteInExpandAgregated: "Afficher le site associé au point sur le détail de l’indicateur",

                display: "Affichage",
                displaySiteInLastHistoryPoint: "Afficher le site associé au point sur le détail de l’indicateur"
			},
			description: {
				"action": "Cet indicateur permet l'écriture d’un point, comme une consigne de température ou l'activation d’un mode",
				"action_multi": "Cet indicateur permet l'écriture de plusieurs points, comme une consigne de température ou l'activation d’un mode",
				"agrege": "Cet indicateur permet d'afficher des données synthétisées et de retourner le nombre d’équipements inférieurs ou supérieurs à un seuil",
				"alarme": "Cet indicateur permet de présenter un tableau avec les alarmes (actives ou non) du site",
				"raw": "Cet indicateur présente les données brutes sans aucune transformation ou calcul",
				"calcul": "Cet indicateur permet de montrer une valeur calculée à partir de plusieurs autres données",
				"piechart": "Cet indicateur permet de visualiser les données sous forme de graphique en camembert",
				"co2": "Cet indicateur permet d'assurer le suivi de la qualité d’air intérieur, avec des données groupées par palier de centaines de ppm pour faciliter l’analyse. Il inclut un indice de confinement d'air pour évaluer la qualité de l'air",
				"conso": "Cet indicateur permet l'affichage des consommations sur une période donnée (mensuelle, annuelle), avec des options pour l'affichage de la tendance et d’un ratio (par m2, logement…)",
				"conso_global": "Cet indicateur permet une comparaison des consommations d’année en année",
				"last_alarms": "Cet indicateur affiche la liste des dernières alarmes reçues",
				"ecart": "Cet indicateur permet d'afficher la différence entre 2 valeurs, comme ECS départ/bouclage ou chauffage départ/retour",
				"event": "Cet indicateur affiche les événements ou activités survenus récemment",
				"graphique": "Cet indicateur permet de visualiser des données sous forme de graphique (ligne, barres, etc.)",
				"multi_chart": "Cet indicateur associe une liste de graphiques à un graphique par défaut : un sélecteur avec recherche permet de basculer d’un graphique à l’autre sans fermer la fenêtre, tout en conservant la période de visualisation",
				"html": "Cet indicateur permet d'afficher du contenu personnalisé en HTML",
				"img": "Cet indicateur permet d'afficher une image liée à un site ou une image importée",
				"multi": "Cet indicateur permet l'affichage de plusieurs points dans un indicateur, avec un graphique associé montrant les données brutes des points",
				"odyradar": "Cet indicateur fournit des données spécifiques liées au radar Odyssée",
				"odyradar_conso": "Cet indicateur affiche les données de consommation via le radar Odyssée",
				"odysel": "Cet indicateur permet d'afficher des informations spécifiques au module Odysel",
				"odyssee": "Cet indicateur permet d'afficher des informations spécifiques au système Odyssee",
				"qualiteair": "Cet indicateur affiche les mesures liées à la qualité de l'air",
				"perf": "Cet indicateur permet de suivre les performances générales",
				"perf_solar": "Cet indicateur permet de visualiser les performances liées à la production d'énergie solaire",
				"planning": "Cet indicateur permet la gestion d’un programme horaire d’un automate",
				"slider": "Cet indicateur permet l'affichage d’une donnée sous forme de palier, par exemple la température ECS/Bouclage ou la pression",
				"tank": "Cet indicateur permet l'affichage du taux de remplissage d’une cuve",
				"temperature": "Cet indicateur permet d'afficher le nombre d’heures supérieures à un seuil défini, et peut associer jusqu’à 8 points/sondes à l’indicateur",
				"valeur": "Cet indicateur affiche la dernière valeur d'un point d'un équipement",
				"last_interventions": "Cet indicateur affiche la liste des dernières interventions effectuées",
				"heating_curve": "Cet indicateur permet la gestion d’une ou plusieurs courbe(s) de chauffe d’un automate, avec des modes disponibles (2, 3, 4 ou 5 points, ou pente)",
				"last_histo_points": "Cet indicateur permet de retourner les valeurs d’un ensemble de points à une date/heure donnée, utilisé par exemple pour la relève des index compteur ou la supervision des températures ECS du patrimoine",
				"inventory_equipment": "Cet indicateur permet d'afficher le nombre d’équipements en ligne ou hors ligne",
				"top_conso": "Cet indicateur permet d'afficher les compteurs les plus consommateurs",
				"array": "Cet indicateur permet d'afficher un ensemble de points sous forme de tableau",
				"postit": "Cet indicateur permet d'afficher des notes ou des informations rapides sous forme de post-it",
				"block_info_general": "Cet indicateur présente les informations générales d’un site, telles que le chef de projet, l’architecture, ou encore la date des premières données disponibles",
				"block_info_infrastructure": "Cet indicateur affiche les informations relatives à l’infrastructure du site, comme l’adresse, la surface en mètres carrés, et d’autres caractéristiques physiques",
				"block_info_attributes_site": "Cet indicateur met en avant les attributs spécifiques du site, tels que le type d’isolant ou le système de production d’eau chaude sanitaire utilisé",
				"block_info_inventory_site": "Cet indicateur fournit un aperçu de l’inventaire du site, notamment le nombre d’équipements, leur répartition par fournisseur ou par type d’automate",
				"trio": "Cet indicateur permet de visualiser la consommation d’énergie ou de ressources spécifiques, tout en intégrant des objectifs cibles et des tendances d’évolution",
				"terminal_regulation": "Cet indicateur est un thermostat permettant de gérer une zone, avec lecture de la température ambiante/humidité/consigne calculée et écriture des consignes (occupation/inoccupation/été/hiver)",
				"humidity": "Cet indicateur permet d'afficher le nombre d’heures supérieures à un seuil défini, et peut associer jusqu’à 8 points/sondes à l’indicateur",
				"heatmapchart": "Cet indicateur permet l'affichage des données horaires (comptage ou données brutes) sur une semaine sous forme de carte thermique"
			}
		},
		hud: {
			allAssetsLabel: "Tout le patrimoine",
			datatype: {
				brand: 'marque',
				site: 'site',
				enterprise: 'entreprise'
			},
			search: {
				patterns: {
					equipment: "eq",
					enterprise: "en",
					favorite: "fa",
					site: "si",
					synopsis: "sy",
					user: "ut",
					projectType: "tp"
				},
				labels: {
					equipment: "équipements",
					enterprise: "entreprises",
					favorite: "favoris",
					site: "sites",
					synopsis: "synoptiques",
					user: "utilisateurs",
					projectType: "type de projet"
				}
			},
			addLabels: {
				equipment: 'Ajouter un équipement',
				report: 'Ajouter un rapport',
				synopsis: 'Ajouter un synoptique',
			},
			feedbackTitles: {
				search: 'Recherche',
				sites: 'Parcourir les sites',
				companies: 'Parcourir les entreprises',
				favorites: 'Vos favoris',
				site_settings: 'Configuration du site',
				admin: 'Administration',
				news: 'Actualités',
				sections: 'Sections',
				user: 'Votre compte'
			},

			favorite_none: "Vous n'avez pas encore créé de favoris",
			favorite_added_in_progress: "La page est en cours d'ajout dans vos favoris",
			favorite_added: "La page a été ajoutée aux favoris",
			favorite_removed: "Le favori a été supprimé",

			searchResultsNoInput: "<span class='hide--narrow-down'>Veuillez </span>saisir au moins {searchMinCaracters} caractères",
			searchResultsNoResult: "<span class='hide--narrow-down'>La recherche « <em>{pattern}</em> » ne produit </span>aucun résultat",
			searchResultsDefault: "<span class='hide--narrow-down'>Affichage de </span>{numResults} résultats<span class='hide--narrow-down'> pour la recherche « <em>{pattern}</em> »</span>",
		},
		sections: {
			dashboardAssets: "Synthèse",
			alertsAssets: "Alertes",
			dataAssets: "Données",
			documentsAssets: "Documents",
			prestationAssets: "Suivi Prestations",
			historyPrestationAssets: "Historique",
			interventionStatisticsAssets: "Statistiques",
			dashboard: "Synthèse",
			prestation: "Suivi Prestation",
			historyPrestation: "Historique",
			dashboardPage: "Synthèse Page",
			alerts: "Alertes",
			exploitation: "Exploitation",
			data: "Données",
			documents: "Documents",
			siteSettings: "Inventaire",
			consumption: "Consommation",
			maintenance: "Maintenance",
			reportAssets: "Rapports",
			showMonitoringTable: "Suivi",
            monitoringparkv2: "Parc"
		},
		synopsis: {
			refresh: "Rafraîchir",
			panelOpener: "Plus d'informations",
			applyChanges: "Appliquer",
			reset: "Restaurer"
		},
		general: {
			fromTo: 'du {DATE_FROM} au {DATE_TO}',
			saveInProgress: 'Enregistrement en cours',
			saveSuccess: 'Enregistrement effectué avec succès',
			deleteSuccess: 'Suppression effectué avec succès',
			writingInProgress: 'Écriture en cours',
			writingSuccess: 'Écriture effectuée avec succès',
			writingRequestSinceTo: "Demande d'écriture depuis {DATE}",
			openedConnection: 'Connexion ouverte',
			impossibleConnection: 'Connexion impossible',
			connectionInProgress: 'Connexion en cours',
			serviceUnavailable: 'Service indisponible',
			commandsSent: 'Commandes envoyées',
			notifyMail: 'Demande prise en compte, vous serez informé du résultat par mail',
			errorHasOccured: 'Une erreur est survenue',
			invalidValue: 'Valeur incorrecte',
			connected: 'Connecté',
			disconnected: 'Déconnecté',
			disconnection: 'Déconnexion',
			waitingForConnection: 'En attente de connexion',
			documentSaved: 'Document enregistré avec succès',
			documentDeletionConfirm: 'Confirmez vous la demande de suppression du document?',
			documentDeletionSuccess: 'Suppresssion du document effectué',
			documentDeletionRequestSuccess: 'Demande de suppresssion prise en compte, elle sera effective sous 24h',
			userAlarmsNotificationDeletionConfirm: 'Êtes vous sûr de vouloir supprimer les notifications d\'alarme?',
			dysfonctionnementTitle: 'Signaler un dysfonctionnement',
			dysfonctionnementSentSucess: 'Le dysfonctionnement a été signalé.',
			saveConfirmation: "Enregistré",
			nom: 'Nom',
			yes: 'Oui',
			no: 'Non',
			none: 'Aucun',
			priority: 'Priorité',
			value: 'Valeur',
			date: 'Date',
			title: 'Titre',
			subtitle: 'Sous-titre',
			page: 'Page',
			anyMatchingPoint: 'Aucun point correspondant',
			red: 'Rouge',
			orange: 'Orange',
			green: 'Vert',
			add: 'Ajouter',
			create: 'Créer',
			pleaseFillATitle: 'Veuillez renseigner un titre',
			anyRulesConfigured: 'Aucune règle configurée',
			warningClearForm: "Attention cette action va réinitialiser le formulaire. Êtes-vous sur de vouloir effectuer cette action ?",
			noNotification: "Il n'y a aucune notification",
			objPointConfirmDeleteWhenPointAssociated: "Cette suppression supprimera également son point virtuel associé. Êtes-vous sûr de vouloir supprimer ?",
			row_data_is_editable: "Les données de la ligne sont éditables",
			row_data_update_in_progress: "Les données de la ligne sont en cours de traitement",
			modifications_are_being_processed: "Des modifications sont en cours de traitement. Nous vous recommandons de recharger la page régulièrement afin de visualiser les dernières données.",
			please_save_your_modifications: "Veuillez sauvegarder vos modifications",
			save: "Sauvegarder",
			comment: "Commentaire",
			unit: "Unité",
			delete: "Supprimer",
			deleted: "Supprimé",
			cancel: "Annuler",
            update: "Modifier",
			deleteAlert: "Suppression d'une alerte",
			confirmationDeleteComponent: "Cette action sera irrémédiable, êtes-vous sûrs de vouloir supprimer ce composant ?",
			error: "Erreur",
			alarmDeleted: "L'alarme à été supprimée",
			"fileSizeExceed500Ko": "Le fichier a une taille supérieure à 500 Ko",
			confirmationDeleteDeviceModbus: "Êtes-vous sûr·e de vouloir supprimer l’équipement Modbus ?",
            confirmationChangeModelKeepPointsTitle: "Changer le modèle par {MODEL_NAME}",
            confirmationChangeModelKeepPointsText: "Les points existants seront conservés. Attention, des incohérences peuvent apparaître si les points actuels ne correspondent pas au nouveau modèle.",
            confirmationChangeModelResetPointsTitle: "Changer le modèle par {MODEL_NAME} et remplacer les points",
            confirmationChangeModelResetPointsText: "Tous les points existants seront supprimés et remplacés par ceux du nouveau modèle. Cette action est irréversible.",
            confirmationChangeModelAddNewPointsTitle: "Changer le modèle par {MODEL_NAME} et ajouter les points manquants",
            confirmationChangeModelAddNewPointsText: "Les points existants seront conservés. Les points du nouveau modèle manquants seront ajoutés. Cette action est irréversible.",
            selectModelBeforeChangingTitle: "Sélection du modèle requise",
			pageWillBeReloaded: "La page va être rechargée",
			noDeviceModelAvailable: "Aucun modèle disponible",
			deleteDeviceWithName: "Suppression de l'équipement '{NAME}'",
			deleteZoneWithName: "Suppression de la zone '{NAME}'",
			deleteSynopticWithName: "Suppression du synoptique '{NAME}'",
			deleteObjectWithName: "Suppression de l'objet '{NAME}'",
			deleteElementWithName: "Suppression de l'élément '{NAME}'",
			deleteChartData: "Suppression d'une donnée d'un graphique",
			deleteChartReference: "Suppression d'une référence d'un graphique",
			confirmationDeletionElement: "Êtes-vous sûr·e de vouloir supprimer cet élément ?",
			deletionElement: "Suppression de l'élément",
			color: { default: 'Défaut', gray: 'Gris', blue: 'Bleu', lightBlue: 'Bleu clair', brown: 'Marron', yellow: 'Jaune', orange: 'Orange', red: 'Rouge', pink: 'Rose', lightGreen: 'Vert clair', purple: 'Violet', green: 'Vert', black: 'Noir', darkPurple: 'Violet foncé', darkPink: 'Rose foncé', lightRed: 'Rouge clair', lightOrange: 'Orange clair' },
			completeRequiredFields: "Veuillez remplir les champs obligatoires",
            field_required: "Le champ {FIELD} est obligatoire",
            site: "Site"
        },
		se: {
			groupsListSubtitle: "##NUM## composants",
			compsListShowAll: "Tous les composants",
			noLabel: '[nom vide]',
			groupLabel: 'Groupe "##GROUP##"',
			dragButtonLabel: 'Changer l\'ordre',
			groupListButtonLabel: 'Afficher le groupe',
			editButtonLabel: 'Modifier',
			templateGroupSimple: 'Icônes simples',
			templateGroupVentilation: 'Ventilations',
			templateGroupPump: 'Pompes',

			previousComp: 'Composant précédent',
			groupList: 'Liste du groupe',
			nextComp: 'Composant suivant',

			anySummary: 'Pour toute valeur alors...',
			equalsSummary: 'Si la valeur est égale à ##VALUE## alors...',
			differentSummary: 'Si la valeur est différente de ##VALUE## alors...',
			inferiorSummary: 'Si la valeur est inférieure à ##VALUE## alors...',
			superiorSummary: 'Si la valeur est supérieure à ##VALUE## alors...',
			defectsSummary: 'Si ##POINT-ID## est égal à ##VALUE## alors...',
			pointIdNullSummary: 'point non-defini',

			templateGroupMajor: 'Élements majeurs',
			templateGroupCore: 'Styles génériques',
			defaultColorLabel: 'Couleur d\'icône par défaut',
			defaultBackgroundLabel: 'Couleur de fond par défaut',
			templateGroupToggler: 'Toggler',
			templateTogglerOn: 'toggler actif',
			templateTogglerOff: 'toggler inactif',

			orientation: "flux",
			"synopsis-link": "lien vers synoptique",
			point: "point lecture",
			input: "point écriture",
			separator: "séparateur",
			"synopsis-title": "titre dans synoptique",
			title: "titre"
		},
		zone: {
			thead_name: 'Nom',
			thead_date: 'Date',
			last_histo: 'Derniers historiques',
		},
		trumbowyg: {
			viewHTML: 'Voir le HTML',
			undo: 'Annuler',
			redo: 'Refaire',
			formatting: 'Format',
			p: 'Paragraphe',
			blockquote: 'Citation',
			code: 'Code',
			header: 'Titre',
			bold: 'Gras',
			italic: 'Italique',
			strikethrough: 'Barré',
			underline: 'Souligné',
			strong: 'Fort',
			em: 'Emphase',
			del: 'Supprimé',
			superscript: 'Exposant',
			subscript: 'Indice',
			unorderedList: 'Liste à puces',
			orderedList: 'Liste ordonnée',
			insertImage: 'Insérer une image',
			insertVideo: 'Insérer une video',
			link: 'Lien',
			createLink: 'Insérer un lien',
			unlink: 'Supprimer le lien',
			_self: 'Même onglet (par défaut)',
			_blank: 'Nouvel onglet',
			justifyLeft: 'Aligner à gauche',
			justifyCenter: 'Centrer',
			justifyRight: 'Aligner à droite',
			justifyFull: 'Justifier',
			horizontalRule: 'Insérer un séparateur horizontal',
			removeformat: 'Supprimer formatage',
			fullscreen: 'Plein écran',
			close: 'Fermer',
			submit: 'Valider',
			reset: 'Annuler',
			required: 'Obligatoire',
			description: 'Description',
			title: 'Titre',
			text: 'Texte',
			target: 'Cible'
		},
		tableConsumption: {
			"consumption": "consommation",
			"gap": "écart",
			"vehicle": "véhicule",
			"vehicles": "véhicules",
			"manufacturing": "fabrication",
			"photovoltaic": "photovoltaïque",
			"target_mileage": "cible kilométrage",
			"real_mileage": "réel kilométrage",
			"real": "réel",
			"ratio": "ratio",
			"target": "cible",
			"goal": "cible",
			"real_consumption": "consommation réel",
			"heating_consumption": "consommation chauffage",
			"correction": "correction",
			"temperature": "température",
			"water": "eau",
			"energy": "énergie",
			"general": "général",
			"heating": "chauffage",
			"cold_water": "eau froide",
			"dhw": "ECS",
			"occupation": "occupation",
			"target_production": "Cible production",
			"production": "Production",
			"target_self_consumption": "Cible autoconsommation",
			"self_consumption": "Autoconsommation",
			"counters": "Compteurs",
			"input": "Saisie",
		},
        editorConsumption: {
            "save": "Sauvegarder",
            "addCategory": "Ajouter une catégorie",
            "addComponent": "Ajouter un composant",
            "newComponent": "Nouveau composant",
            "newCategory": "Nouvelle catégorie",
            "noComponent": "Aucun composant. Cliquez ci-dessous pour en ajouter.",
            "componentCount_one": "composant",
            "componentCount_other": "composants",
            "categoryNamePlaceholder": "Nom de la catégorie",
            "fieldSourcePoints": "Source des points (Équipement/Objet)",
            "fieldPoint": "Point",
            "fieldLabel": "Label",
            "fieldAnnotation": "Annotation",
            "fieldStyle": "Style",
            "fieldDisplayCounterMode": "Mode d'affichage compteur",
            "placeholderLabel": "Nom affiché…",
            "placeholderAnnotation": "Ajouter une annotation…",
            "optNone": "Aucun",
            "optDefault": "Défaut",
            "groupMetar": "Metar",
            "groupEquipment": "Équipement",
            "groupObject": "Objet"
        },
        comment: {
            add_comment: "Ajout d'un commentaire",
            access_documentation: "Accès à la documentation",
			my_tickets: "Mes tickets",
            type: "Type",
            object: "Objet",
            description: "Description",
            date: "Date",
            internal: "Interne",
            type_comment: "Commentaire",
            type_intervention: "Intervention",
            type_update: "Mise à jour",
            site: "Site",
            equipment: "Équipement",
            none: "Aucun",
			low: "Faible",
			normal: "Normal",
			high: "Élevé",
			critical: "Critique",
        }
	},
	en: {
		date: {
			days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
			daysShort: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
			monthes: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
			monthesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
		},
		pickaday: {
			firstDay: 1,
			previousMonth: 'Next month',
			nextMonth: 'Previous month',
			months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
			weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
			weekdaysShort: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
		},
		highchart: {
			addNote: 'Add a note',
			removeNote: 'Remove a note',
			contextButtonTitle: 'Chart context menu',
			decimalPoint: '.',
			downloadCSV: 'Download CSV document',
			downloadJPEG: 'Download JPEG image',
			downloadPDF: 'Download PDF document',
			downloadPNG: 'Download PNG image',
			downloadSVG: 'Download SVG vector image',
			downloadXLS: 'Download XLS',
			viewData: 'Access table',
			drillUpText: 'Back to {series.name}',
			invalidDate: '',
			loading: 'Loading…',
			months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
			noData: 'No data to display',
			printChart: 'Print chart',
			range: 'Range',
			resetZoom: 'Reset zoom',
			resetZoomTitle: 'Reset zoom level 1:1',
			shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
			shortWeekdays: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
			thousandsSep: ',',
			weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
		},
		indicator: {
			aucunesDonneesDisponibles: 'No data available',
			performanceReal: 'Real',
			performanceAdjusted: 'Adjusted',
			performanceObjective: 'Objective',
			performancePercentAxisTitle: 'Percentage (%)',
			performanceDjuAxisTitle: 'DJU',
			performanceDelta: 'Gap',
			performanceDjuReal: 'DJU Real',
			performanceDjuRef: 'DJU reference',
			obsoleteTooltip: "Displayed value is obsolete",
			fictitiousTooltip: "Displayed value is fictitious",
			noHeatingCurveConfigured: "There is no heating curve configured",
			writeParamsProgrammed: "Parameter writing has been programmed",
			notifyByEmail: "You will be notified of the result of the operation by e-mail",
			total: "Total",
			online: "Online",
			offline: "Offline",
			notInstalled: "Not installed",
			page: {
				createTitle: "Create a page",
				editTitle: "Edit page",
				pageSavedTitle: "Page saved",
				position: "Position",
				logo: "Logo",
				logoHelp: "Optional"
			},
			edition: {
				createTitle: "Create an indicator",
				previewAlt: "Indicator preview based on type",

				sections: "Sections",
				sectionSavedTitle: "Section saved",
				indicatorType: "Indicator type",
				rightLevel: "Permission level",
				planningWriteLevel: "Write permission level",
				planningWriteLevelHelp: "A user with a lower permission level will not be able to modify the schedule",
				description: "Description",
				icon: "Icon",
				chooseIcon: "Please choose an icon",
				active: "Active",

				editTitle: "Edit an indicator",
				editTitleGeneric: "Edit indicator",
				next: "Next",
				previous: "Previous",
				confirmEditQuestion: "Are you sure you want to update the indicator?",
				confirmEdit: "Update",

				createdTitle: "The indicator has been created",
    			createdText: "You can view it on the site's dashboard.",
				updatedText: "The indicator has been updated. You can view it on the site's dashboard.",
				goToDashboard: "Go to the site's dashboard",
				dimensionHelp: "Display format (Width : Height).",

				dimension: "Dimension",
				equipment: "Equipment",
				point: "Point",
				points: "Points",
				options: "Options",
				couleur: "Color",
				type: "Type",
				typeGraphique: "Chart type",

				mode: {
				label: "Mode",
				standard: "Standard",
				condition: "Condition",
				counter: "Counter",
				help: "The mode determines the type of data returned. For example, Counter mode returns consumption data"
				},

				comment: "Comment",
				commentHelp: "Displays an information line in the indicator",

				operator: "Operator",
				threshold: "Threshold",

				allAlarms: "All alarms:",
				activeAlarmsOnly: "Active alarms only",

				noAssociatedChart: "No associated chart",
				noAssociatedChartHelp: "There is no \"+\" button to display a chart",

				suffix: "Suffix",
				suffixHelp: "Replaces the default displayed units",

				trend: "Trend",
				trendHelp: "Shows variations compared to the previous period",

				browsable: "Browsable",
				browsableHelp: "Allows navigating between different periods, according to the user-defined period",

				chartOptions: "Chart related options",
				minimum: "Minimum",
				minimumHelp: "Affects the minimum on the associated chart",
				maximum: "Maximum",
				maximumHelp: "Affects the maximum on the associated chart",

				period: "Period",
				chart: "Chart",
				chartHelp: "If selected, a chart will be displayed instead of points",

				object: "Object",

				calculation: "Calculation",
				calculationFormula: "Calculation formula",

				size: "Size",
				label: "Label",
				formula: "Formula",
				customization: "Customization",
				steps: "Steps",
				configuration: "Configuration",
				status: "Status",
				to: "To",
				preview: "Preview",
				terminalRegulation: "Terminal Regulation",
				legendTitle: "Legend Title",
				dataType: "Data Type",
				subDataType: "Sub-Data Type",

				integrated: "Integrated",
				chartOnDashboard: "The chart is displayed on the dashboard",
				advancedAnalysis: "Advanced Analysis",
				advancedAnalysisHelp: "Provides advanced analysis elements (DJU, calculation per day, sum, average...)",
				zone: "Zone",
				default: "Default",
				toggler: "Toggler",
				textLabelOn: "Text label on",
				textDisplayedOn: "Text displayed on value on",
				textLabelOff: "Text label off",
				textDisplayedOff: "Text displayed on value off",
				none: "None",
				multi: "Multiple",
				invert: "Inverted",
				live: "Real-time",
				alarmsCount: "Number of alarms",
				occupantsCount: "Number of occupants",
				dwellingsCount: "Number of dwellings",
				mealsPerDayCount: "Number of meals / day",
				surface: "Surface",
				housesInZone: "Number of dwellings in a zone",
				ecsLoopLength: "ECS loop length",
				dju: "DJU",
				djuRatioHelp: "Displays a ratio per DJU",
				textArea: "Text area",
				gauge: "Gauge",
				sliderMode: "Slider mode",
				sliderDisplayMode: "Defines the slider display mode",
				associatedToChart: "associated to chart",
				minimumLegendHelp: "Affects the minimum of the chart legend",
				maximumLegendHelp: "Affects the maximum of the chart legend",
				startAndEndDate: "Start / End",
				startDate: "Start",
				endDate: "End",

				displayValueForDate: "Displays the value of an indicator for a given date",
				sectionCreation: "Section creation",
				editSection: "Edit section",
				unsupportedIndicatorType: "This indicator type is not currently supported for this editing interface",
				interventionCountDisplay: "Number of interventions to display",
				heatingCurvesAutoAdded: "New heating curves will be automatically added to the indicator.",
				history: "History",
				historyMonthlyHelp: "Saves consumption values monthly",
				heatmapColorPaletteHelp: "Defines the color palette used to display values on the heat map",
				heatmapColorPalette: "Color palette",
				heatmapColorPaletteNeutral: "Neutral",
				heatmapColorPaletteHot: "Warm",
				heatmapColorPaletteCold: "Cold",
				selectZone: "Select a zone",
				minMaxValidationError: "For each level, the minimum value must be less than the maximum value",
				stepsOverlapValidationError: "Steps must not overlap",
				noModelAvailable: "No model available",
				modelApplied: "Model applied",
				applyModel: "Apply a model",
				applyModelWarning: "Warning, this action will delete your existing steps",
				sliderPreviewHelp: "Visual representation of the configured steps",
				photovoltaicPower: "Installed photovoltaic power kWc",
				addRealtimeButtonHelp: "Adds a button to retrieve the real-time value",
				showDateFilter: "Show date filter",
				sourcePoints: "Point source",
				currentSite: "Current site",
				estateChildSites: "Child estate sites",
				dateFilter: "Date filter",
				loadAllHeatingCurves: "Dynamically load all heating curves from the site",
				formulaHelp: "Applies a formula (format: #value# /10)",
				odyssee: "Odyssee",

                displaySiteInExpandAgregated: "View the website associated with the indicator's details",

                display: "Display",
                displaySiteInLastHistoryPoint: "Display the website associated with the item in the indicator details",

				rules: {
					title: "Rules",
					valueDisplay: "Value display",
					substitutedValue: "Substituted value",
					status: {
						normal: "Normal",
						success: "Success",
						warning: "Warning",
						alert: "Alert"
					}
				},

				consumption: {
					ratio: "Ratio",
					ratioHelp: "Applies a ratio to consumption data",
					limit: "Limit",
					limitHelp: "Maximum number of points to display",
					topConsoModeHelp: "Sets the display mode used for the main consumption",

					analysis: "Analysis",
					analysisHelp: "Displays a side panel to analyze the data in more detail",

					labelConsumption: "Consumption label",
					labelConsumptionHelp: "Label displayed above the value",

					labelTrend: "Trend label",
					labelTrendHelp: "Label displayed above the trend",

					chartStackedBars: "Stacked bars",
					chartStackedBarsHelp: "Bars are stacked on the chart"
				},

				img: {
					previewTitle: "Preview",
					previewAlt: "Preview of the image indicator",
					configurationTitle: "Configuration",

					sourceSite: "Site image",
					sourceZone: "Zone image",
					sourceCustom: "Custom image",

					associatedZone: "Associated zone",
					customImageLabel: "Custom image"
				},


				trio: {
					modeTitle: "Mode",
					onePoint: "1 point",
					twoPoints: "2 points",
					threePoints: "3 points",

					primary: "Primary",
					secondary: "Secondary",
					tertiary: "Tertiary"
				}
			},
			description: {
				"action": "This indicator allows writing a single point, such as a temperature setpoint or activating a mode.",
				"action_multi": "This indicator allows writing multiple points, such as temperature setpoints or activating modes.",
				"agrege": "This indicator displays aggregated data and returns the number of devices below or above a given threshold.",
				"alarme": "This indicator presents a table with the site's alarms (active or not).",
				"raw": "This indicator displays raw data with no transformation or calculation.",
				"calcul": "This indicator shows a value calculated from several other data points.",
				"piechart": "This indicator visualizes data as a pie chart.",
				"co2": "This indicator tracks indoor air quality (IAQ), grouping measurements by hundred-ppm steps to ease analysis. It includes an air confinement index to assess air quality.",
				"conso": "This indicator displays consumption over a given period (monthly, yearly), with options for trend display and a ratio (per m², per dwelling, etc.).",
				"conso_global": "This indicator compares consumption year over year.",
				"last_alarms": "This indicator lists the most recent alarms received.",
				"ecart": "This indicator shows the difference between two values, such as DHW supply/recirculation or heating supply/return.",
				"event": "This indicator displays recent events or activities.",
				"graphique": "This indicator visualizes data as a chart (line, bar, etc.).",
				"multi_chart": "This indicator associates a list of charts with a default chart: a searchable selector lets you switch from one chart to another without closing the window, while keeping the selected viewing period.",
				"html": "This indicator displays custom HTML content.",
				"img": "This indicator displays an image related to a site or an imported image.",
				"multi": "This indicator displays multiple points within a single widget, with an associated chart showing the raw data of those points.",
				"odyradar": "This indicator provides data specific to the Odyssée radar.",
				"odyradar_conso": "This indicator displays consumption data via the Odyssée radar.",
				"odysel": "This indicator shows information specific to the Odysel module.",
				"odyssee": "This indicator shows information specific to the Odyssee system.",
				"qualiteair": "This indicator displays air quality measurements.",
				"perf": "This indicator tracks overall performance.",
				"perf_solar": "This indicator visualizes performance related to solar energy production.",
				"planning": "This indicator manages a PLC time schedule.",
				"slider": "This indicator displays a value on a banded/stepped scale, for example DHW/recirculation temperature or pressure.",
				"tank": "This indicator shows the fill level of a tank.",
				"temperature": "This indicator displays the number of hours above a defined threshold and can associate up to 8 points/sensors.",
				"valeur": "This indicator displays the latest value of a device point.",
				"last_interventions": "This indicator lists the most recent interventions performed.",
				"heating_curve": "This indicator manages one or more PLC heating curves, with available modes (2, 3, 4 or 5 points, or slope).",
				"last_histo_points": "This indicator returns the values of a set of points at a specific date/time, e.g., for meter index readings or supervising DHW temperatures across the asset portfolio.",
				"inventory_equipment": "This indicator shows the number of devices that are online or offline.",
				"top_conso": "This indicator displays the most energy-consuming meters.",
				"array": "This indicator displays a set of points in a table.",
				"postit": "This indicator displays notes or quick information as sticky notes.",
				"block_info_general": "This indicator presents general site information, such as the project manager, architecture, and the date of the first available data.",
				"block_info_infrastructure": "This indicator shows information related to the site's infrastructure, such as the address, floor area (m²), and other physical characteristics.",
				"block_info_attributes_site": "This indicator highlights specific site attributes, such as the type of insulation or the domestic hot water (DHW) production system used.",
				"block_info_inventory_site": "This indicator provides an overview of the site's inventory, including the number of devices and their distribution by vendor or PLC type.",
				"trio": "This indicator visualizes energy or resource consumption while integrating target objectives and trend evolution.",
				"terminal_regulation": "This indicator is a thermostat to manage a zone, reading room temperature/humidity/calculated setpoint and writing setpoints (occupied/unoccupied/summer/winter).",
				"humidity": "This indicator displays the number of hours above a defined threshold and can associate up to 8 points/sensors.",
				"heatmapchart": "This indicator displays hourly data (metering or raw data) over a week as a heatmap."
			}
		},
		hch: {
			graphSave: 'Save graph settings',
			graphName: 'Graph name',
			graphSetName: 'Please set a name for the graph',
			seriesDelete: 'Delete series',
			seriesSort: 'Change serie depth',
			seriesResetColor: 'Set series color',
			subtitleFromTo: 'Period from {DATE_FROM} to {DATE_TO}',
			subtitleFromToSingle: '{DATE_FROM}',
			overwritePendingChanges: 'Changes have been made to graph settings. Do you want to ignore this warning and proceed anyway?',

			addNotePointSelectLabel: 'Linked point',
			addNotePointSelectDefault: 'Please select a point',
			addNoteDateLabel: 'Period',
			addNoteDateInfo: 'You can type the dates or define them by clicking the graph when the cursor is set in the field.',
			addNoteDateFromLabel: 'from',
			addNoteDateFromPlaceholder: 'DD/MM/YYYY HH:MM',
			addNoteDateToLabel: 'to',
			addNoteDateToPlaceholder: 'DD/MM/YYYY HH:MM',
			addNoteTitlePlaceholder: 'Title',
			addNoteDescPlaceholder: 'Comment',
			addNoteSubmitLabel: 'Add',
			addNoteCloseLabel: 'Close',
			addNoteNotPossibleToPieChart: 'You cannot add annotations to a pie chart',

			deleteNoteNoteSelectLabel: 'Please select a note',
			deleteNoteSubmitLabel: 'Delete',
			deleteNoteCloseLabel: 'Close', 
			range: 'Range'
		},
		datatable: {
			processing: 'Processing...',
			search: 'Search&nbsp;:',
			lengthMenu: 'Showing _MENU_ entries',
			info: 'Showing _START_ to _END_ of _TOTAL_ entries',
			infoEmpty: 'Showing 0 to 0 of 0 entries',
			infoFiltered: '(filtered from _MAX_ total entries)',
			infoPostFix: '',
			loadingRecords: 'Loading...',
			zeroRecords: 'No matching records found',
			emptyTable: 'No matching records found',
			paginate: {
				first: 'First',
				previous: 'Previous',
				next: 'Next',
				last: 'Last'
			},
			"buttons": {
				"collection": "Collection <span class='ui-button-icon-primary ui-icon ui-icon-triangle-1-s'/>",
				"colvis": "Column Visibility",
				"colvisRestore": "Restore visibility",
				"copy": "Copy",
				"copyKeys": "Press ctrl or u2318 + C to copy the table data to your system clipboard.<br><br>To cancel, click this message or press escape.",
				"copySuccess": {
					"1": "Copied 1 row to clipboard",
					"_": "Copied %d rows to clipboard"
				},
				"copyTitle": "Copy to Clipboard",
				"csv": "CSV",
				"excel": "Excel",
				"pageLength": {
					"-1": "Show all rows",
					"_": "Show %d rows"
				},
				"pdf": "PDF",
				"print": "Print",
				"updateState": "Update",
				"stateRestore": "State %d",
				"savedStates": "Saved States",
				"renameState": "Rename",
				"removeState": "Remove",
				"removeAllStates": "Remove All States",
				"createState": "Create State"
			},
			aria: {
				sortAscending: ': activate to sort column ascending',
				sortDescending: ': activate to sort column descending'
			},
			"editor": {
				"close": "Close",
				"create": {
					"button": "New",
					"title": "Create new entry",
					"submit": "Create"
				},
				"edit": {
					"button": "Edit",
					"title": "Edit Entry",
					"submit": "Update"
				},
				"remove": {
					"button": "Delete",
					"title": "Delete",
					"submit": "Delete",
					"confirm": {
						"1": "Are you sure you wish to delete 1 row?",
						"_": "Are you sure you wish to delete %d rows?"
					}
				},
				"error": {
					"system": "A system error has occurred (<a target=\"\\\"rel=\"nofollow\"href=\"\\\">More information</a>)."
				},
				"multi": {
					"title": "Multiple Values",
					"info": "The selected items contain different values for this input. To edit and set all items for this input to the same value, click or tap here, otherwise they will retain their individual values.",
					"restore": "Undo Changes",
					"noMulti": "This input can be edited individually, but not part of a group. "
				}
			}
		},
		listSites: {
			multisiteNoAlerts: "No active alert",
			monositeNoAlerts: "No active alert",
			siblingAlertsCount: '{num} last identicals alerts',
			siblingAlertCount: 'last identical alert',

			siblingAlertDetailFromTo: 'from : {from} - to : {to}',
			siblingAlertDetailFrom: 'from : {from}',
			siblingShowInSite: '› Show this alert in the site interface'
		},
		siteAccess: {
			deniedTitle: "Access Denied",
			deniedText: "You do not have access to this site.<br>You have been redirected to your dashboard."
		},	
		hud: {
			allAssetsLabel: 'Estates',
			datatype: {
				brand: 'brand',
				site: 'site',
				enterprise: 'enterprise',
			},
			search: {
				patterns: {
					equipment: "eq",
					enterprise: "en",
					favorite: "fa",
					site: "si",
					synopsis: "sy",
					user: "us"
				},
				labels: {
					equipment: "equipment",
					enterprise: "enterprises",
					favorite: "favorites",
					site: "sites",
					synopsis: "synopsis",
					user: "users"
				}
			},
			addLabels: {
				equipment: 'Add a device',
				report: 'Add a report',
				synopsis: 'Add a synopsis',
			},
			feedbackTitles: {
				search: 'Search',
				sites: 'Browse sites',
				companies: 'Browse companies',
				favorites: 'Your favorites',
				site_settings: 'Site configuration',
				admin: 'Administration',
				news: 'News',
				sections: 'Sections',
				user: 'Your account'
			},

			favorite_none: "No favorite created yet",
			favorite_added_in_progress: "The page is being added to your favorites",
			favorite_added: "Page has been added to favorites",
			favorite_removed: "Favorite has been removed",

			searchResultsNoInput: "Please fill at least {searchMinCaracters} characters.",
			searchResultsNoResult: "The query {pattern} has no result.",
			searchResultsDefault: "Display {numResults} results for the query {pattern}.",

			searchDefaultPlaceholder: 'Search',
			browseDefaultPlaceholder: 'Browse',
			administration: 'Administration',
			myParc: "My stock",
			maintenance: 'Maintenance',
			supervision: 'Monitoring',
			userLogout: 'Logout',
			userSettings: 'Account parameters'
		},
		sections: {
			dashboardAssets: 'Dashboard',
			alertsAssets: 'Alerts',
			dataAssets: 'Data',
			documentsAssets: 'Documents',
			interventionStatisticsAssets: "Statistics",
			dashboard: 'Dashboard',
			alerts: 'Alerts',
			exploitation: 'Exploitation',
			data: 'Data',
			documents: 'Documents',
			siteSettings: 'Inventory',
			consumption: "Consumption",
			maintenance: 'Maintenance',
			reportAssets: "Reports",
			showMonitoringTable: "Follow-up",
            monitoringparkv2: "Park"
		},
		synopsis: {
			refresh: 'Refresh',
			panelOpener: 'More information',
			applyChanges: 'Apply',
			reset: 'Restore'
		},
		general: {
			fromTo: 'from {DATE_FROM} to {DATE_TO}',
			saveInProgress: 'Save in progress',
			saveSuccess: 'Saved with success',
			deleteSuccess: 'Deleted with success',
			writingInProgress: 'Writing in progress',
			writingRequestSinceTo: "Write request since {DATE}",
			openedConnection: 'Connection opened',
			impossibleConnection: 'Impossible connection',
			connectionInProgress: 'Connection in progress',
			serviceUnavailable: 'Unavailable service',
			commandsSent: 'Commands sent',
			notifyMail: 'Request has been taken, you will be informed of the result by mail',
			errorHasOccured: 'A error has occured',
			invalidValue: 'Invalid value',
			connected: 'Connected',
			disconnected: 'Disconnected',
			disconnection: 'Disconnection',
			waitingForConnection: 'Waiting for connection',
			documentSaved: 'Document saved',
			documentDeletionConfirm: 'Can you confirm the document deletion?',
			documentDeletionSuccess: 'Document deletion done',
			documentDeletionRequestSuccess: 'Deletion accepted, it will be effective within 24h',
			userAlarmsNotificationDeletionConfirm: 'Can you confirm the alarms notifications deletion?',
			dysfonctionnementTitle: 'Report malfunction',
			dysfonctionnementSentSucess: 'The malfunction has been reported.',
			saveConfirmation: "Sent",
			nom: 'Name',
			yes: 'Yes',
			no: 'No',
			none: 'None',
			priority: 'Priority',
			value: 'Value',
			date: 'Date',
			anyMatchingPoint: 'Any matching point',
			red: 'Red',
			orange: 'Orange',
			green: 'Green',
			add: 'Add',
			create: 'Create',
			pleaseFillATitle: 'Please fill a title',
			anyRulesConfigured: 'Any rule configured',
			noNotification: "There is no notification",
			objPointConfirmDeleteWhenPointAssociated: "This deletion will also delete its associated virtual point. Are you sure you want to delete ?",
			warningClearForm: "Warning: this action will reset the form. Are you sure you want to perform this action ?",
			row_data_is_editable: "Row data is editable",
			row_data_update_in_progress: "Row data is currently being processed",
			modifications_are_being_processed: "Changes are currently being processed. We recommend refreshing the page regularly to view the latest data.",
			please_save_your_modifications: "Please save your changes",
			save: "Save",
			comment: "Comment",
			unit: "Unit",
			delete: "Delete",
			deleted: "Deleted",
			cancel: "Cancel",
            update: "Edit",
            deleteAlert: "Deleting an alert",
			confirmationDeleteComponent: "This action cannot be undone. Are you sure you want to delete this component ?",
			error: "Error",
			alarmDeleted: "Alarm has been deleted",
			"fileSizeExceed500Ko": "File size greater than 500 Kb",
			confirmationDeleteDeviceModbus: "Are you sure you want to delete the Modbus device ?",
            confirmationChangeModelKeepPointsTitle: "Switch model to {MODEL_NAME}",
            confirmationChangeModelKeepPointsText: "Existing points will be kept. Warning: inconsistencies may occur if the current points do not match the new model.",
            confirmationChangeModelResetPointsTitle: "Switch model to {MODEL_NAME} and replace points",
            confirmationChangeModelResetPointsText: "All existing points will be deleted and replaced by those of the new model. This action is irreversible.",
            confirmationChangeModelAddNewPointsTitle: "Switch model to {MODEL_NAME} and add missing points",
            confirmationChangeModelAddNewPointsText: "Existing points will be kept. Missing points from the new model will be added. This action is irreversible.",
			selectModelBeforeChangingTitle: "Model selection required",
			pageWillBeReloaded: "The page will be reloaded",
			noDeviceModelAvailable: "No model available",
			deleteDeviceWithName: "Deleting equipment '{NAME}'",
			deleteZoneWithName: "Deleting area '{NAME}'",
			deleteSynopticWithName: "Deleting overview '{NAME}'",
			deleteObjectWithName: "Deleting object '{NAME}'",
			deleteElementWithName: "Deleting element '{NAME}'",
			deleteChartData: "Deleting data from a chart",
            deleteChartReference: "Deleting a reference from a chart",
			confirmationDeletionElement: "Are you sure you want to delete this item ?",
			deletionElement: "Deleting the element",
			color: { default: 'Default', gray: 'Gray', blue: 'Blue', lightBlue: 'Light Blue', brown: 'Brown', yellow: 'Yellow', orange: 'Orange', red: 'Red', pink: 'Pink', lightGreen: 'Light Green', purple: 'Purple', green: 'Green', black: 'Black', darkPurple: 'Dark Purple', darkPink: 'Dark Pink', lightRed: 'Light Red', lightOrange: 'Light Orange' },
			completeRequiredFields: "Please complete all required fields",
            field_required: "The field {FIELD} is required",
            site: "Site"
        },
		se: {
			groupsListSubtitle: '##NUM## components',
			compsListShowAll: 'Every components',
			noLabel: '[empty name]',
			groupLabel: 'Group \'##GROUP##\'',
			dragButtonLabel: 'Change order',
			groupListButtonLabel: 'Display the group',
			editButtonLabel: 'Modify',
			templateGroupSimple: 'Simple icons',
			templateGroupVentilation: 'Ventilations',
			templateGroupPump: 'Pumps',

			previousComp: 'Previous component',
			groupList: 'Group list',
			nextComp: 'Next component',

			anySummary: 'For any value...',
			equalsSummary: 'If value equals ##VALUE## so...',
			differentSummary: 'If value is different than ##VALUE## so...',
			inferiorSummary: 'If value is lower than ##VALUE## so...',
			superiorSummary: 'If value is higher than ##VALUE## so...',
			defectsSummary: 'Si ##POINT-ID## equals ##VALUE## so...',
			pointIdNullSummary: 'undefined point',

			templateGroupMajor: 'Major elements',
			templateGroupCore: 'Common styles',
			defaultColorLabel: 'Default color incon',
			defaultBackgroundLabel: 'Default background color',
			templateGroupToggler: 'Toggler',
			templateTogglerOn: 'active toggler',
			templateTogglerOff: 'inactive toggler',

			orientation: 'flow',
			'synopsis-link': 'link to synopsis',
			point: 'reading point',
			input: 'writing point',
			separator: 'separator',
			'synopsis-title': 'title in synopsis',
			title: 'title'
		},
		zone: {
			thead_name: 'Name',
			thead_date: 'Date',
			last_histo: 'Last data',
		},
		trumbowyg: {
			viewHTML: "View HTML",
			undo: "Undo",
			redo: "Redo",
			formatting: "Formatting",
			p: "Paragraph",
			blockquote: "Quote",
			code: "Code",
			header: "Header",
			bold: "Bold",
			italic: "Italic",
			strikethrough: "Strikethrough",
			underline: "Underline",
			strong: "Strong",
			em: "Emphasis",
			del: "Deleted",
			superscript: "Superscript",
			subscript: "Subscript",
			unorderedList: "Unordered list",
			orderedList: "Ordered list",
			insertImage: "Insert Image",
			link: "Link",
			createLink: "Insert link",
			unlink: "Remove link",
			_self: "Same tab (default)",
			_blank: "New tab",
			justifyLeft: "Align Left",
			justifyCenter: "Align Center",
			justifyRight: "Align Right",
			justifyFull: "Align Justify",
			horizontalRule: "Insert horizontal rule",
			removeformat: "Remove format",
			fullscreen: "Fullscreen",
			close: "Close",
			submit: "Confirm",
			reset: "Cancel",
			required: "Required",
			description: "Description",
			title: "Title",
			text: "Text",
			target: "Target"
		},
		tableConsumption: {
			"consumption": "consumption",
			"gap": "gap",
			"vehicle": "vehicle",
			"vehicles": "vehicles",
			"manufacturing": "manufacturing",
			"photovoltaic": "photovoltaic",
			"target_mileage": "target mileage",
			"real_mileage": "real mileage",
			"real": "real",
			"ratio": "ratio",
			"target": "target",
			"goal": "goal",
			"real_consumption": "real consumption",
			"heating_consumption": "heating consumption",
			"correction": "correction",
			"temperature": "temperature",
			"water": "water",
			"energy": "energy",
			"general": "general",
			"heating": "heating",
			"cold_water": "cold water",
			"dhw": "dhw",
			"occupation": "occupation",
			"target_production": "Target production",
			"production": "Production",
			"target_self_consumption": "Target self consumption",
			"self_consumption": "Self consumption",
			"counters": "Counters",
			"input": "Input",
		},
        editorConsumption: {
            "save": "Save",
            "addCategory": "Add a category",
            "addComponent": "Add a component",
            "newComponent": "New component",
            "newCategory": "New category",
            "noComponent": "No component. Click below to add one.",
            "componentCount_one": "component",
            "componentCount_other": "components",
            "categoryNamePlaceholder": "Category name",
            "fieldSourcePoints": "Point source (Equipment/Object)",
            "fieldPoint": "Point",
            "fieldLabel": "Label",
            "fieldAnnotation": "Annotation",
            "fieldStyle": "Style",
            "fieldDisplayCounterMode": "Counter display mode",
            "placeholderLabel": "Displayed name…",
            "placeholderAnnotation": "Add an annotation…",
            "optNone": "None",
            "optDefault": "Default",
            "groupMetar": "Metar",
            "groupEquipment": "Equipment",
            "groupObject": "Object"
        },
        comment: {
            add_comment: "Add a comment",
            access_documentation: "Access documentation",
			my_tickets: "My tickets",
            type: "Type",
            object: "Subject",
            description: "Description",
            date: "Date",
            internal: "Internal",
            type_comment: "Comment",
            type_intervention: "Intervention",
            type_update: "Update",
            site: "Site",
            equipment: "Equipment",
            none: "None",
			low: "Low",
			normal: "Medium",
			high: "High",
			critical: "Critical",
        }
	},
	de: {
		date: {
			days: ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'],
			daysShort: ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'],
			monthes: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
			monthesShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez']
		},
		pickaday: {
			firstDay: 1,
			previousMonth: 'Nächsten Monat',
			nextMonth: 'Vorheriger Monat',
			months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
			weekdays: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
			weekdaysShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa']
		},
		highchart: {
			addNote: 'Eine Anmerkung hinzufügen',
			removeNote: 'Löschen einer Annotation',
			contextButtonTitle: 'Grafikmenü einblenden',
			decimalPoint: '.',
			downloadCSV: 'Download als CSV-Dokument',
			downloadJPEG: 'Download als JPEG-Bild',
			downloadPDF: 'Download als PDF-Dokument',
			downloadPNG: 'Download als PNG-Bild',
			downloadSVG: 'Download als SVG-Bild',
			downloadXLS: 'Download als XLS-Dokument',
			viewData: 'Tabelle einblenden',
			drillUpText: 'Zurück zu {series.name}',
			invalidDate: '',
			loading: 'Daten werden geladen...',
			months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
			noData: 'Keine Daten verfügbar',
			printChart: 'Grafik drucken',
			range: 'Range',
			resetZoom: 'Zoom zurücksetzen',
			resetZoomTitle: 'Zoom zurücksetzen',
			shortMonths: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
			shortWeekdays: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
			thousandsSep: ',',
			weekdays: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag']
		},
		indicator: {
			aucunesDonneesDisponibles: 'Keine Daten verfügbar',
			performanceReal: 'Istwert',
			performanceAdjusted: 'Adjusted',
			performanceObjective: 'Sollwert',
			performancePercentAxisTitle: 'Prozentsatz (%)',
			performanceDjuAxisTitle: 'DJU',
			performanceDelta: 'Toleranzbereich',
			performanceDjuReal: 'DJU Réel',
			performanceDjuRef: 'DJU de référence',
			obsoleteTooltip: "Angezeigter Wert ist veraltet",
			fictitiousTooltip: "Der angezeigte Wert ist fiktiv",
			noHeatingCurveConfigured: "Es ist keine Heizkurve konfiguriert",
			writeParamsProgrammed: "Das Schreiben der Einstellungen wurde programmiert",
			notifyByEmail: "Sie werden über das Ergebnis der Operation per E-Mail benachrichtigt",
			total: "Insgesamt",
			online: "Online",
			offline: "Offline",
			notInstalled: "Nicht installiert",
			page: {
				createTitle: "Seite erstellen",
				editTitle: "Seite bearbeiten",
				pageSavedTitle: "Seite gespeichert",
				position: "Position",
				logo: "Logo",
				logoHelp: "Optional"
			},
			edition: {
				createTitle: "Indikator erstellen",
				previewAlt: "Vorschau des Indikators je nach Typ",

				sections: "Abschnitte",
				sectionSavedTitle: "Abschnitt gespeichert",
				indicatorType: "Indikator-Typ",
				rightLevel: "Berechtigungsstufe",
				planningWriteLevel: "Schreibberechtigungsstufe",
				planningWriteLevelHelp: "Ein Benutzer mit einer niedrigeren Berechtigungsstufe kann den Zeitplan nicht ändern",
				description: "Beschreibung",
				icon: "Symbol",
				chooseIcon: "Bitte wählen Sie ein Symbol",
				active: "Aktiv",

				editTitle: "Indikator bearbeiten",
				editTitleGeneric: "Indikator bearbeiten",
				next: "Weiter",
				previous: "Zurück",
				confirmEditQuestion: "Sind Sie sicher, dass Sie den Indikator ändern möchten?",
				confirmEdit: "Ändern",

				createdTitle: "Der Indikator wurde erstellt",
    			createdText: "Sie können ihn im Dashboard der Site anzeigen.",
				updatedText: "Der Indikator wurde geändert. Sie können ihn im Dashboard der Site anzeigen.",
				goToDashboard: "Zum Dashboard der Site",
				dimensionHelp: "Anzeigeformat (Breite : Höhe).",

				dimension: "Dimension",
				equipment: "Ausrüstung",
				point: "Punkt",
				points: "Punkte",
				options: "Optionen",
				couleur: "Farbe",
				type: "Typ",
				typeGraphique: "Diagrammtyp",

				mode: {
					label: "Modus",
					standard: "Standard",
					condition: "Bedingung",
					counter: "Zähler",
					help: "Der Modus bestimmt den Typ der zurückgegebenen Daten. Zum Beispiel liefert der Modus Zähler Verbrauchsdaten"
				},

				comment: "Kommentar",
				commentHelp: "Zeigt eine Informationszeile im Indikator an",

				operator: "Operator",
				threshold: "Schwelle",
				allAlarms: "Alle Alarme:",
				activeAlarmsOnly: "Nur aktive Alarme",

				noAssociatedChart: "Kein zugeordnetes Diagramm",
				noAssociatedChartHelp: "Es gibt keine \"+\"-Schaltfläche, um ein Diagramm anzuzeigen",

				suffix: "Suffix",
				suffixHelp: "Ersetzt die standardmäßig angezeigten Einheiten",

				trend: "Trend",
				trendHelp: "Zeigt Abweichungen im Vergleich zur vorherigen Periode an",

				browsable: "Navigierbar",
				browsableHelp: "Ermöglicht die Navigation zwischen verschiedenen Zeiträumen, entsprechend dem vom Benutzer definierten Zeitraum",

				chartOptions: "Diagrammoptionen",
				minimum: "Minimum",
				minimumHelp: "Beeinflusst das Minimum im zugeordneten Diagramm",
				maximum: "Maximum",
				maximumHelp: "Beeinflusst das Maximum im zugeordneten Diagramm",

				period: "Zeitraum",
				chart: "Diagramm",
				chartHelp: "Wenn diese Option ausgewählt ist, wird anstelle der Punkte ein Diagramm angezeigt",

				object: "Objekt",

				calculation: "Berechnung",
				calculationFormula: "Berechnungsformel",

				size: "Größe",
				label: "Beschriftung",
				formula: "Formel",
				customization: "Anpassung",
				steps: "Schritte",
				configuration: "Konfiguration",
				status: "Status",
				to: "Zu",
				preview: "Vorschau",
				terminalRegulation: "Endregelung",
				legendTitle: "Legende Titel",
				dataType: "Datentyp",
				subDataType: "Unter-Datentyp",
				
				integrated: "Integriert",
				chartOnDashboard: "Das Diagramm wird auf dem Dashboard angezeigt",
				advancedAnalysis: "Erweiterte Analyse",
				advancedAnalysisHelp: "Bietet erweiterte Analysefunktionen (DJU, Berechnung pro Tag, Summe, Durchschnitt...)",
				zone: "Zone",
				default: "Standard",
				toggler: "Schalter",
				textLabelOn: "Textbeschriftung an",
				textDisplayedOn: "Text angezeigt bei Wert an",
				textLabelOff: "Textbeschriftung aus",
				textDisplayedOff: "Text angezeigt bei Wert aus",
				none: "Keine",
				multi: "Mehrfach",
				invert: "Invertiert",
				live: "Echtzeit",
				alarmsCount: "Anzahl der Alarme",
				occupantsCount: "Anzahl der Bewohner",
				dwellingsCount: "Anzahl der Wohnungen",
				mealsPerDayCount: "Anzahl der Mahlzeiten / Tag",
				surface: "Oberfläche",
				housesInZone: "Anzahl der Wohnungen in einer Zone",
				ecsLoopLength: "ECS-Schleifenlänge",
				dju: "DJU",
				djuRatioHelp: "Zeigt ein Verhältnis pro DJU an",
				textArea: "Textbereich",
				gauge: "Gauge",
				sliderMode: "Schiebereglermodus",
				sliderDisplayMode: "Definiert den Anzeigemodus des Schiebereglers",
				associatedToChart: "mit Diagramm verknüpft",
				minimumLegendHelp: "Beeinflusst das Minimum der Diagrammlegende",
				maximumLegendHelp: "Beeinflusst das Maximum der Diagrammlegende",
				showDateFilter: "Datumsfilter anzeigen",
				sourcePoints: "Punktquelle",
				currentSite: "Aktuelle Site",
				estateChildSites: "Untergeordnete Bestand-Sites",
				dateFilter: "Datumsfilter",
				loadAllHeatingCurves: "Alle Heizungskurven der Website dynamisch laden",
				startAndEndDate: "Start / Ende",
				startDate: "Start",
				endDate: "Ende",

				displayValueForDate: "Zeigt den Wert eines Indikators für ein bestimmtes Datum an",
				sectionCreation: "Abschnitterstellung",
				editSection: "Abschnitt bearbeiten",
				unsupportedIndicatorType: "Dieser Indikatortyp wird derzeit für diese Bearbeitungsschnittstelle nicht unterstützt",
				interventionCountDisplay: "Anzahl der anzuzeigenden Interventionen",
				heatingCurvesAutoAdded: "Neue Heizkurven werden dem Indikator automatisch hinzugefügt.",
				history: "Historie",
				historyMonthlyHelp: "Speichert die Verbrauchswerte monatlich",
				heatmapColorPaletteHelp: "Definiert die Farbpalette zur Anzeige der Werte auf der Wärmekarte",
				heatmapColorPalette: "Farbpalette",
				heatmapColorPaletteNeutral: "Neutral",
				heatmapColorPaletteHot: "Warm",
				heatmapColorPaletteCold: "Kalt",
				selectZone: "Zone auswählen",
				minMaxValidationError: "Für jede Stufe muss der Mindestwert kleiner als der Höchstwert sein",
				stepsOverlapValidationError: "Die Stufen dürfen sich nicht überschneiden",
				noModelAvailable: "Kein Modell verfügbar",
				modelApplied: "Modell angewendet",
				applyModel: "Modell anwenden",
				applyModelWarning: "Warnung: Diese Aktion löscht Ihre vorhandenen Schritte",
				sliderPreviewHelp: "Visuelle Darstellung der konfigurierten Stufen",
				photovoltaicPower: "Installierte Photovoltaikleistung kWc",
				addRealtimeButtonHelp: "Fügt eine Schaltfläche hinzu, um den Echtzeit-Wert abzurufen",
				formulaHelp: "Wendet eine Formel an (Format: #value# /10)",
				odyssee: "Odyssee",

                displaySiteInExpandAgregated: "Die Website anzeigen, die mit dem Punkt in der Detailansicht des Indikators verknüpft ist",

                display: "Anzeige",
                displaySiteInLastHistoryPoint: "Die zum Punkt gehörende Seite mit den Details zum Indikator anzeigen",

				rules: {
					title: "Regeln",
					valueDisplay: "Wertanzeige",
					substitutedValue: "Ersatzwert",
					status: {
						normal: "Normal",
						success: "Erfolg",
						warning: "Warnung",
						alert: "Alarm"
					}
				},

				consumption: {
					ratio: "Verhältnis",
					ratioHelp: "Wendet ein Verhältnis auf Verbrauchsdaten an",
					limit: "Grenze",
					limitHelp: "Maximale Anzahl an anzuzeigenden Punkten",
					topConsoModeHelp: "Legt den Anzeigemodus für den Hauptverbrauch fest",

					analysis: "Analyse",
					analysisHelp: "Zeigt ein Seitenpanel an, um die Daten detaillierter zu analysieren",

					labelConsumption: "Verbrauchslabel",
					labelConsumptionHelp: "Label, das über dem Wert angezeigt wird",

					labelTrend: "Trendlabel",
					labelTrendHelp: "Label, das über dem Trend angezeigt wird",

					chartStackedBars: "Gestapelte Balken",
					chartStackedBarsHelp: "Die Balken werden im Diagramm gestapelt"
				},

				img: {
					previewTitle: "Vorschau",
					previewAlt: "Vorschau des Bildindikators",
					configurationTitle: "Konfiguration",

					sourceSite: "Standortbild",
					sourceZone: "Zonenbild",
					sourceCustom: "Benutzerdefiniertes Bild",

					associatedZone: "Zugeordnete Zone",
					customImageLabel: "Benutzerdefiniertes Bild"
				},

				trio: {
					modeTitle: "Modus",
					onePoint: "1 Punkt",
					twoPoints: "2 Punkte",
					threePoints: "3 Punkte",

					primary: "Primär",
					secondary: "Sekundär",
					tertiary: "Tertiär"
				}
			},
			description: {
				"action": "Dieser Indikator erlaubt das Schreiben eines einzelnen Punktes, z. B. eines Temperatur-Sollwerts oder das Aktivieren eines Modus.",
				"action_multi": "Dieser Indikator erlaubt das Schreiben mehrerer Punkte, z. B. Temperatur-Sollwerte oder das Aktivieren von Modi.",
				"agrege": "Dieser Indikator zeigt aggregierte Daten an und gibt die Anzahl der Geräte unterhalb oder oberhalb eines Schwellwerts zurück.",
				"alarme": "Dieser Indikator stellt eine Tabelle mit den Alarmen der Anlage dar (aktiv oder nicht aktiv).",
				"raw": "Dieser Indikator zeigt Rohdaten ohne jegliche Transformation oder Berechnung.",
				"calcul": "Dieser Indikator zeigt einen aus mehreren anderen Datenpunkten berechneten Wert.",
				"piechart": "Dieser Indikator visualisiert Daten als Kreisdiagramm.",
				"co2": "Dieser Indikator überwacht die Innenraumluftqualität (IAQ) und gruppiert Messwerte in Hundert-ppm-Stufen zur leichteren Analyse. Er beinhaltet einen Luftstau-Index zur Bewertung der Luftqualität.",
				"conso": "Dieser Indikator zeigt Verbräuche für einen Zeitraum (monatlich, jährlich) mit Optionen für Trendanzeige und Verhältnis (pro m², pro Wohnung usw.).",
				"conso_global": "Dieser Indikator vergleicht Verbräuche im Jahresvergleich.",
				"last_alarms": "Dieser Indikator listet die zuletzt eingegangenen Alarme auf.",
				"ecart": "Dieser Indikator zeigt die Differenz zwischen zwei Werten, z. B. TWW-Vorlauf/Zirkulation oder Heizung Vorlauf/Rücklauf.",
				"event": "Dieser Indikator zeigt kürzlich aufgetretene Ereignisse oder Aktivitäten.",
				"graphique": "Dieser Indikator visualisiert Daten als Diagramm (Linie, Balken usw.).",
				"multi_chart": "Dieser Indikator verknüpft eine Liste von Diagrammen mit einem Standarddiagramm: Über eine durchsuchbare Auswahl kann zwischen den Diagrammen gewechselt werden, ohne das Fenster zu schließen, wobei der gewählte Anzeigezeitraum beibehalten wird.",
				"html": "Dieser Indikator zeigt benutzerdefinierte HTML-Inhalte an.",
				"img": "Dieser Indikator zeigt ein anlagenbezogenes oder importiertes Bild an.",
				"multi": "Dieser Indikator zeigt mehrere Punkte in einem Widget an und enthält ein zugehöriges Diagramm mit den Rohdaten dieser Punkte.",
				"odyradar": "Dieser Indikator liefert spezifische Daten des Odyssée-Radars.",
				"odyradar_conso": "Dieser Indikator zeigt Verbrauchsdaten über das Odyssée-Radar an.",
				"odysel": "Dieser Indikator zeigt Informationen zum Odysel-Modul.",
				"odyssee": "Dieser Indikator zeigt Informationen zum Odyssee-System.",
				"qualiteair": "Dieser Indikator zeigt Messwerte zur Luftqualität an.",
				"perf": "Dieser Indikator verfolgt die Gesamtleistung.",
				"perf_solar": "Dieser Indikator visualisiert die Leistung der Stromerzeugung aus Solarenergie.",
				"planning": "Dieser Indikator verwaltet ein SPS-Zeitprogramm.",
				"slider": "Dieser Indikator zeigt einen Wert auf einer gestuften Skala (Bänder) an, z. B. TWW-/Zirkulationstemperatur oder Druck.",
				"tank": "Dieser Indikator zeigt den Füllstand eines Tanks an.",
				"temperature": "Dieser Indikator zeigt die Anzahl der Stunden über einem definierten Schwellwert an und kann bis zu 8 Punkte/Sensoren zuordnen.",
				"valeur": "Dieser Indikator zeigt den letzten Wert eines Gerätepunktes an.",
				"last_interventions": "Dieser Indikator listet die zuletzt durchgeführten Einsätze auf.",
				"heating_curve": "Dieser Indikator verwaltet eine oder mehrere Heizkurven der SPS mit verfügbaren Modi (2, 3, 4 oder 5 Punkte bzw. Steigung).",
				"last_histo_points": "Dieser Indikator gibt die Werte einer Punktmenge zu einem bestimmten Datum/Uhrzeit zurück, z. B. für Zählerstandsablesungen oder die Überwachung von TWW-Temperaturen im Bestand.",
				"inventory_equipment": "Dieser Indikator zeigt die Anzahl der Geräte an, die online bzw. offline sind.",
				"top_conso": "Dieser Indikator zeigt die verbrauchsstärksten Zähler an.",
				"array": "Dieser Indikator zeigt eine Menge von Punkten in Tabellenform an.",
				"postit": "Dieser Indikator zeigt Notizen oder Kurzinfos als Haftnotizen an.",
				"block_info_general": "Dieser Indikator stellt allgemeine Standortinformationen dar, z. B. Projektleitung, Architektur und Datum der ersten verfügbaren Daten.",
				"block_info_infrastructure": "Dieser Indikator zeigt Informationen zur Standortinfrastruktur an, z. B. Adresse, Fläche (m²) und weitere physische Merkmale.",
				"block_info_attributes_site": "Dieser Indikator hebt standortspezifische Merkmale hervor, z. B. die Art der Dämmung oder das eingesetzte System zur Trinkwarmwasser- (TWW)-Erzeugung.",
				"block_info_inventory_site": "Dieser Indikator bietet einen Überblick über das Standortinventar, einschließlich Anzahl der Geräte und deren Verteilung nach Anbieter oder SPS-Typ.",
				"trio": "Dieser Indikator visualisiert den Energie- bzw. Ressourcenverbrauch und integriert Zielwerte sowie Trendentwicklungen.",
				"terminal_regulation": "Dieser Indikator ist ein Thermostat zur Zonenregelung mit Raumtemperatur-/Feuchte-/berechnetem Sollwert und dem Schreiben von Sollwerten (Belegt/Unbelegt/Sommer/Winter).",
				"humidity": "Dieser Indikator zeigt die Anzahl der Stunden über einem definierten Schwellwert an und kann bis zu 8 Punkte/Sensoren zuordnen.",
				"heatmapchart": "Dieser Indikator stellt stündliche Daten (Zähl- oder Rohdaten) einer Woche als Heatmap dar."
			}
		},
		hch: {
			graphSave: 'Grafikeinstellungen speichern',
			graphName: 'Graphikname',
			graphSetName: 'Bitte geben Sie einen Namen für die Grafik ein',
			seriesDelete: 'Serie löschen',
			seriesSort: 'Reihenfolge ändern',
			seriesResetColor: 'Serienfarbe einstellen',
			subtitleFromTo: 'Zeitraum vom {DATE_FROM} bis zum {DATE_TO}',
			subtitleFromToSingle: '{DATE_FROM}',
			overwritePendingChanges: 'Es wurden Änderungen an den Grafikeinstellungen vorgenommen. Möchten Sie diese Warnung ignorieren und trotzdem fortfahren?',

			addNotePointSelectLabel: 'Zugehöriger Punkt',
			addNotePointSelectDefault: 'Bitte wählen Sie ein Element aus',
			addNoteDateLabel: 'Zeitraum',
			addNoteDateInfo: 'Sie können die Daten frei eingeben oder durch Anklicken in der Grafik definieren, nachdem Sie den Cursor in die Periodenfelder gestellt haben.',
			addNoteDateFromLabel: 'von',
			addNoteDateFromPlaceholder: 'DD/MM/AAAA HH:MM',
			addNoteDateToLabel: 'zu',
			addNoteDateToPlaceholder: 'DD/MM/AAAA HH:MM',
			addNoteTitlePlaceholder: 'Titel',
			addNoteDescPlaceholder: 'Kommentar',
			addNoteSubmitLabel: 'Hinzufügen',
			addNoteCloseLabel: 'Schließen',
			addNoteNotPossibleToPieChart: 'Sie können keine Anmerkungen zu einem Tortendiagramm hinzufügen',

			deleteNoteNoteSelectLabel: 'Wählen Sie die Annotation aus',
			deleteNoteSubmitLabel: 'Löschen Sie',
			deleteNoteCloseLabel: 'schließen',
			range: 'Range'
		},
		datatable: {
			processing: 'Bitte warten...',
			search: 'Suchen&nbsp;:',
			lengthMenu: '_MENU_ Einträge anzeigen',
			info: '_START_ bis _END_ von _TOTAL_ Einträgen',
			infoEmpty: 'Keine Daten vorhanden',
			infoFiltered: 'gefiltert von _MAX_ Einträgen',
			infoPostFix: '',
			loadingRecords: 'Wird geladen...',
			zeroRecords: 'Keine Einträge vorhanden',
			emptyTable: 'Keine Daten in der Tabelle vorhanden',
			paginate: {
				first: 'Erster',
				previous: 'Vorheriger',
				next: 'Nächster',
				last: 'Letzter'
			},
			aria: {
				sortAscending: ': aktivieren, um Spalte aufsteigend zu sortieren',
				sortDescending: ': aktivieren, um Spalte absteigend zu sortieren'
			},
			"buttons": {
				"print": "Drucken",
				"copy": "Kopieren",
				"copyTitle": "In Zwischenablage kopieren",
				"copySuccess": {
					"1": "1 Zeile kopiert",
					"_": "%d Zeilen kopiert"
				},
				"collection": "Aktionen <span class=\"ui-button-icon-primary ui-icon ui-icon-triangle-1-s\"></span>",
				"colvis": "Spaltensichtbarkeit",
				"colvisRestore": "Sichtbarkeit wiederherstellen",
				"csv": "CSV",
				"excel": "Excel",
				"pageLength": {
					"1": "Zeige 1 Zeile",
					"-1": "Alle Zeilen anzeigen",
					"_": "Zeige %d Zeilen"
				},
				"pdf": "PDF",
				"createState": "Ansicht erstellen",
				"removeAllStates": "Alle Ansichten entfernen",
				"removeState": "Entfernen",
				"renameState": "Umbenennen",
				"savedStates": "Gespeicherte Ansicht",
				"stateRestore": "Ansicht %d",
				"updateState": "Aktualisieren",
				"copyKeys": "Taste <i>STRG&lt;\\/i&gt; oder <i>⌘&lt;\\/i&gt; + <i>C&lt;\\/i&gt; drücken um die Tabelle<br />in den Zwischenspeicher zu kopieren.<br /><br />Um den Vorgang abzubrechen, Nachricht anklicken oder Escape-Taste drücken.</i></i></i>"
			},
			"editor": {
				"close": "Schließen",
				"create": {
					"button": "Neu",
					"title": "Neuen Eintrag erstellen",
					"submit": "Erstellen"
				},
				"remove": {
					"confirm": {
						"1": "Soll diese Zeile gelöscht werden?",
						"_": "Sollen %d Zeilen gelöscht werden?"
					},
					"button": "Entfernen",
					"title": "Entfernen",
					"submit": "Entfernen"
				},
				"error": {
					"system": "Ein Systemfehler ist aufgetreten"
				},
				"multi": {
					"title": "Mehrere Werte",
					"restore": "Änderungen zurücksetzen",
					"noMulti": "Dieses Feld kann nur einzeln bearbeitet werden, nicht als Teil einer Mengen-Änderung.",
					"info": "Die ausgewählten Elemente enthalten mehrere Werte für dieses Feld. Um alle Elemente für dieses Feld zu bearbeiten und auf denselben Wert zu setzen, hier klicken oder tippen, andernfalls behalten diese ihre individuellen Werte bei."
				},
				"edit": {
					"button": "Bearbeiten",
					"title": "Eintrag bearbeiten",
					"submit": "Bearbeiten"
				}
			}
		},
		listSites: {
			multisiteNoAlerts: "Keine aktive Warnung zur Anzeige",
			monositeNoAlerts: 'Keine aktive Warnung zur Anzeige',
			siblingAlertsCount: '{num} letzte Identifikations-Alarme',
			siblingAlertCount: 'letzte Identifikations-Alarme',

			siblingAlertDetailFromTo: 'bis : {from} - zu : {to}',
			siblingAlertDetailFrom: 'bis : {from}',
			siblingShowInSite: '› Zeigen Sie diese Warnung in der Benutzeroberfläche der Website an'
		},
		siteAccess: {
			deniedTitle: "Zugriff verweigert",
			deniedText: "Sie haben keinen Zugriff auf diesen Standort.<br>Sie wurden zu Ihrem Dashboard weitergeleitet."
		},
		hud: {
			allAssetsLabel: 'Objekte',
			datatype: {
				brand: '[DE] Marque',
				site: 'Standort',
				enterprise: 'Firma',
			},
			search: {
				patterns: {
					equipment: "ge",
					enterprise: "fi",
					favorite: "fa",
					site: "st",
					synopsis: "zu",
					user: "be"
				},
				labels: {
					equipment: "Gerät",
					enterprise: "Firma",
					favorite: "Favoriten",
					site: "Standort",
					synopsis: "Zusammenfassung",
					user: "Benutzer"
				}
			},
			addLabels: {
				equipment: 'Hinzufügen einer Ausrüstung',
				report: 'Einen Bericht hinzufügen',
				synopsis: 'Ein synopsis hinzufügen',
			},
			feedbackTitles: {
				search: 'Suchen',
				sites: 'Standorte durchsuchen',
				companies: 'Firma durchsuchen',
				favorites: 'Ihre Favoriten',
				site_settings: 'Standorteinstellungen',
				admin: 'Verwaltung',
				news: 'Nachrichten',
				sections: 'Sections',
				user: 'mein Konto'
			},

			favorite_none: "Es wurde noch kein Favorit erstellt",
			favorite_added_in_progress: "Die Seite wird gerade zu Ihren Favoriten hinzugefügt",
			favorite_added: "Seite wurde zu den Favoriten hinzugefügt",
			favorite_removed: "Favorit wurde entfernt",

			searchResultsNoInput: "Bitte mindestens {searchMinCaracters} Zeichen eingeben.",
			searchResultsNoResult: "Die Abfrage {pattern} liefert kein Ergebnis.",
			searchResultsDefault: "{numResults} Ergebnisse für die Abfrage anzeigen {pattern}.",

			searchDefaultPlaceholder: 'Suchen',
			browseDefaultPlaceholder: 'Durchsuchen',
			administration: 'Administration',
			myParc: "Objekte",
			maintenance: 'Wartung',
			supervision: 'Monitoring',
			userLogout: 'Abmelden',
			userSettings: 'Konto'
		},
		sections: {
			dashboardAssets: 'Dashboard',
			alertsAssets: 'Alarme',
			dataAssets: 'Daten',
			documentsAssets: 'Dokumente',
			interventionStatisticsAssets: "Statistiken",
			dashboard: 'Dashboard',
			alerts: 'Alarme',
			exploitation: 'Nutzung',
			data: 'Daten',
			documents: 'Dokumente',
			siteSettings: 'Übersicht',
			consumption: "Verbrauch",
			maintenance: 'Wartung',
			reportAssets: "Berichte",
			showMonitoringTable: "Nachbereitung",
            monitoringparkv2: "Park"
		},
		synopsis: {
			refresh: 'Aktualisieren',
			panelOpener: 'Mehr Informationen',
			applyChanges: 'Anwenden',
			reset: 'Wiederherstellen'
		},
		general: {
			fromTo: 'vom {DATE_FROM} bis zum {DATE_TO}',
			saveInProgress: 'speichern...',
			saveSuccess: 'Speichern erfolgreich',
			deleteSuccess: 'Löschen erfolgreich',
			writingInProgress: 'schreiben...',
			writingRequestSinceTo: "Schreibanfrage seit {DATE}",
			openedConnection: 'Verbindungsaufbau erfolgreich',
			impossibleConnection: 'Verbindungsaufbau nicht möglich',
			connectionInProgress: 'Verbindungsaufbau...',
			serviceUnavailable: 'Dienst nicht verfügbar',
			commandsSent: 'Gesendete Befehle',
			notifyMail: 'Request has been taken, you will be informed of the result by mail',
			errorHasOccured: 'Es ist ein Fehler aufgetreten',
			invalidValue: 'Ungültiger Wert',
			connected: 'Verbunden',
			disconnected: 'Getrennt',
			disconnection: 'Verbindung trennen...',
			waitingForConnection: 'Auf Verbindungsaufbau warten',
			documentSaved: 'Dokument gespeichert.',
			documentDeletionConfirm: 'Können Sie das Löschen des Dokuments bestätigen?',
			documentDeletionSuccess: 'Löschung des durchgeführten Dokuments',
			documentDeletionRequestSuccess: 'Löschung akzeptiert, sie wird innerhalb von 24h wirksam.',
			userAlarmsNotificationDeletionConfirm: 'Können Sie das Löschen der Alarmmeldungen bestätigen?',
			dysfonctionnementTitle: 'Fehlfunktion melden',
			dysfonctionnementSentSucess: 'Fehlfunktion erfolgreich gemeldet',
			saveConfirmation: "Gespeicherte",
			nom: 'Name',
			yes: 'Ja',
			no: 'Nein',
			none: 'Keine',
			priority: 'Priorität',
			value: 'Value',
			date: 'Date',
			anyMatchingPoint: 'Kein Anpassungspunkt',
			red: 'Rot',
			orange: 'Orange',
			green: 'Grün',
			add: 'Hinzufügen',
			create: 'Erschaffen',
			pleaseFillATitle: 'Bitte geben Sie einen Titel ein',
			anyRulesConfigured: 'Jede konfigurierte Regel',
			noNotification: "Es gibt keine Benachrichtigung",
			objPointConfirmDeleteWhenPointAssociated: "Durch das Löschen wird auch sein zugehöriger virtueller Punkt entfernt. Sind Sie sicher, dass Sie löschen möchten ?",
			warningClearForm: "Achtung, diese Aktion wird das Formular zurücksetzen. Sind Sie sicher, dass Sie diese Aktion ausführen möchten ?",
			row_data_is_editable: "Die Daten in der Zeile können bearbeitet werden",
			row_data_update_in_progress: "Die Daten in der Zeile werden bearbeitet",
			modifications_are_being_processed: "Änderungen werden derzeit verarbeitet. Wir empfehlen, die Seite regelmäßig neu zu laden, um die neuesten Daten anzuzeigen.",
			please_save_your_modifications: "Bitte speichern Sie Ihre Änderungen",
			save: "Speichern",
			comment: "Kommentar",
			unit: "Einheit",
			delete: "Löschen",
			deleted: "Gelöscht",
			cancel: "Abbrechen",
            update: "Ändern",
            deleteAlert: "Löschen einer Warnung",
			confirmationDeleteComponent: "Diese Aktion wird unwiderruflich sein. Sind Sie sicher, dass Sie diese Komponente löschen möchten ?",
			error: "Fehler",
			alarmDeleted: "Der Alarm wurde gelöscht",
			"fileSizeExceed500Ko": "Die Datei hat eine Größe von mehr als 500 KB",
			confirmationDeleteDeviceModbus: "Sind Sie sicher, dass Sie das Modbus-Gerät löschen möchten ?",
            confirmationChangeModelKeepPointsTitle: "Modell auf {MODEL_NAME} wechseln",
            confirmationChangeModelKeepPointsText: "Bestehende Punkte werden beibehalten. Achtung: Es können Inkonsistenzen auftreten, wenn die aktuellen Punkte nicht dem neuen Modell entsprechen.",
            confirmationChangeModelResetPointsTitle: "Modell auf {MODEL_NAME} wechseln und Punkte ersetzen",
            confirmationChangeModelResetPointsText: "Alle bestehenden Punkte werden gelöscht und durch die des neuen Modells ersetzt. Diese Aktion ist unwiderruflich.",
            confirmationChangeModelAddNewPointsTitle: "Modell auf {MODEL_NAME} wechseln und fehlende Punkte hinzufügen",
            confirmationChangeModelAddNewPointsText: "Bestehende Punkte werden beibehalten. Fehlende Punkte des neuen Modells werden hinzugefügt. Diese Aktion ist unwiderruflich.",
			selectModelBeforeChangingTitle: "Modellauswahl erforderlich",
			pageWillBeReloaded: "Die Seite wird neu geladen",
			noDeviceModelAvailable: "Keine Vorlage verfügbar",
			deleteDeviceWithName: "Löschen der Ausrüstung '{NAME}'",
			deleteZoneWithName: "Löschen des Bereichs '{NAME}'",
			deleteSynopticWithName: "Löschen der Übersicht '{NAME}'",
			deleteObjectWithName: "Löschen des Objekts '{NAME}'",
			deleteElementWithName: "Löschen des Elements '{NAME}'",
			deleteChartData: "Löschen von Daten aus einem Diagramm",
            deleteChartReference: "Entfernen einer Referenz aus einem Diagramm",
			confirmationDeletionElement: "Möchten Sie dieses Element wirklich löschen ?",
			deletionElement: "Löschen des Elements",
			color: { default: 'Standard', gray: 'Grau', blue: 'Blau', lightBlue: 'Hellblau', brown: 'Braun', yellow: 'Gelb', orange: 'Orange', red: 'Rot', pink: 'Rosa', lightGreen: 'Hellgrün', purple: 'Lila', green: 'Grün', black: 'Schwarz', darkPurple: 'Dunkellila', darkPink: 'Dunkelrosa', lightRed: 'Hellrot', lightOrange: 'Hellorange' },
			completeRequiredFields: "Bitte füllen Sie alle erforderlichen Felder aus",
            field_required: "Das Feld {FIELD} ist erforderlich",
            site: "Standort"
        },
		se: {
			groupsListSubtitle: '##NUM## komponenten',
			compsListShowAll: 'Alle Komponenten',
			noLabel: '[empty name]',
			groupLabel: 'Group \'##GROUP##\'',
			dragButtonLabel: 'Änderungsauftrag',
			groupListButtonLabel: 'Die Gruppe anzeigen',
			editButtonLabel: 'Modifizieren',
			templateGroupSimple: 'Einfache Symbole',
			templateGroupVentilation: 'Ventilationen',
			templateGroupPump: 'Pumpen',

			previousComp: 'Vorherige Komponente',
			groupList: 'Gruppenliste',
			nextComp: 'Nächste Komponente',

			anySummary: 'Für einen beliebigen Wert...',
			equalsSummary: 'Wenn der Wert und ##VALUE## gleich sind, dann...',
			differentSummary: 'Wenn sich der Wert von ##VALUE## unterscheidet, dann...',
			inferiorSummary: 'Wenn der Wert kleiner ist als ##VALUE##, dann...',
			superiorSummary: 'Wenn der Wert größer ist als ##VALUE##, dann...',
			defectsSummary: 'Wenn ##POINT-ID## und ##VALUE## gleich sind, dann...',
			pointIdNullSummary: 'undefinierter Punkt',

			templateGroupMajor: 'Wichtige Elemente',
			templateGroupCore: 'Standard Stile',
			defaultColorLabel: 'Standard Farbsymbol',
			defaultBackgroundLabel: 'Standard Hintergrundfarbe',
			templateGroupToggler: 'Toggler',
			templateTogglerOn: 'aktiver Toggler',
			templateTogglerOff: 'inaktiver Toggler',

			orientation: 'flow',
			'synopsis-link': 'Link zur Übersicht',
			point: 'Punkt lesen',
			input: 'Punkt schreiben',
			separator: 'Abscheider',
			'synopsis-title': 'Übersichtstitel',
			title: 'Titel'
		},
		zone: {
			thead_name: 'Name',
			thead_date: 'Datum',
			last_histo: 'Letzte Daten',
		},
		trumbowyg: {
			viewHTML: 'HTML anzeigen',
			undo: 'Rückgängig',
			redo: 'Wiederholen',
			formatting: 'Formatierung',
			p: 'Absatz',
			blockquote: 'Zitat',
			code: 'Code',
			header: 'Überschrift',
			bold: 'Fett',
			italic: 'Kursiv',
			strikethrough: 'Durchgestrichen',
			underline: 'Unterstrichen',
			strong: 'Wichtig',
			em: 'Betont',
			del: 'Gelöscht',
			unorderedList: 'Ungeordnete Liste',
			orderedList: 'Geordnete Liste',
			image: 'Bild',
			insertImage: 'Bild einfügen',
			insertVideo: 'Video einfügen',
			link: 'Link',
			createLink: 'Link einfügen',
			unlink: 'Link entfernen',
			justifyLeft: 'Links ausrichten',
			justifyCenter: 'Zentrieren',
			justifyRight: 'Rechts ausrichten',
			justifyFull: 'Blocksatz',
			horizontalRule: 'Horizontale Linie einfügen',
			removeformat: 'Formatierung entfernen',
			fullscreen: 'Vollbild',
			close: 'Schließen',
			submit: 'Bestätigen',
			reset: 'Abbrechen',
			required: 'Erforderlich',
			description: 'Beschreibung',
			title: 'Titel',
			text: 'Text'
		},
        tableConsumption: {
            "consumption": "Verbrauch",
            "gap": "Differenz",
            "vehicle": "Fahrzeug",
            "vehicles": "Fahrzeuge",
            "manufacturing": "Herstellung",
            "photovoltaic": "Photovoltaik",
            "target_mileage": "Zielkilometerleistung",
            "real_mileage": "tatsächliche Kilometerleistung",
            "real": "tatsächlich",
            "ratio": "Verhältnis",
            "target": "Ziel",
            "goal": "Ziel",
            "real_consumption": "tatsächlicher Verbrauch",
            "heating_consumption": "Heizungsverbrauch",
            "correction": "Korrektur",
            "temperature": "Temperatur",
            "water": "Wasser",
            "energy": "Energie",
            "general": "allgemein",
            "heating": "Heizung",
            "cold_water": "Kaltwasser",
            "dhw": "Warmwasser",
            "occupation": "Belegung",
            "target_production": "Produktionsziel",
            "production": "Produktion",
            "target_self_consumption": "Ziel Eigenverbrauch",
            "self_consumption": "Eigenverbrauch",
            "counters": "Zähler",
            "input": "Eingabe"
        },
        editorConsumption: {
            "save": "Speichern",
            "addCategory": "Kategorie hinzufügen",
            "addComponent": "Komponente hinzufügen",
            "newComponent": "Neue Komponente",
            "newCategory": "Neue Kategorie",
            "noComponent": "Keine Komponente. Klicken Sie unten, um eine hinzuzufügen.",
            "componentCount_one": "Komponente",
            "componentCount_other": "Komponenten",
            "categoryNamePlaceholder": "Kategoriename",
            "fieldSourcePoints": "Punktquelle (Gerät/Objekt)",
            "fieldPoint": "Punkt",
            "fieldLabel": "Bezeichnung",
            "fieldAnnotation": "Anmerkung",
            "fieldStyle": "Stil",
            "fieldDisplayCounterMode": "Zähler-Anzeigemodus",
            "placeholderLabel": "Angezeigter Name…",
            "placeholderAnnotation": "Anmerkung hinzufügen…",
            "optNone": "Keine",
            "optDefault": "Standard",
            "groupMetar": "Metar",
            "groupEquipment": "Gerät",
            "groupObject": "Objekt"
        },
        comment: {
            add_comment: "Kommentar hinzufügen",
            access_documentation: "Zugang zur Dokumentation",
			my_tickets: "Meine Fahrkarten",
            type: "Typ",
            object: "Betreff",
            description: "Beschreibung",
            date: "Datum",
            internal: "Intern",
            type_comment: "Kommentar",
            type_intervention: "Einsatz",
            type_update: "Aktualisierung",
            site: "Standort",
            equipment: "Ausrüstung",
            none: "Keine",
			low: "Niedrige",
			normal: "Normal",
			high: "Hoch",
			critical: "Kritisch",
        }
	}
};

/**   ---------------------------------------------------------------------------------------
 *      UTILITIES
 *    ---------------------------------------------------------------------------------------
 */
/**
 * Converts a [0,255] number to an hexadecimal string XX.
 * @param c {number}
 * @returns {string}
 */
var c2hex = function (c) {
	if (c < 0)
		c = 0;
	if (c > 255)
		c = 255;

	/** @type {string} */
	var h = c.toString(16);
	return h.length == 1 ? '0' + h : h;
};

/**
 * Converts a RGV definition to an hexadecimal string.
 *
 * @param r {number} [0,255] red component number
 * @param g {number} [0,255] red component number
 * @param b {number} [0,255] red component number
 * @returns {string}
 */
var rgbToHex = function (r, g, b, a) {
	var str = "#" + c2hex(r) + c2hex(g) + c2hex(b);
	if (isan(a)) {
		str += c2hex(a);
	}
	return str;
};

var objectToString = function (o) {
	return Object.prototype.toString.call(o);
};
var degToRad = function (deg) {
	return deg / 180 * Math.PI;
};
var digits2 = function (v) {
	return v < 10 ? '0' + v : v;
};
var keepNumeric = function (v) {
	if (!isfilled(v))
		return null;
	return v.match(/\d/g).join("");
};
var isfilled = function (arg) {
	return typeof arg === 'string' && arg.length > 0;
};
var isarray = function (arg) {
	if (Array.isArray) {
		return Array.isArray(arg);
	}
	return objectToString(arg) === '[object Array]';
};
var isarrayempty = function (arg) {
	return arg.length == 0;
};
var isbool = function (arg) {
	return typeof arg === 'boolean';
};
var isobj = function (arg) {
	return (typeof arg === "object" || typeof arg === 'function') && (arg !== null) && (arg !== undefined)
};
var isstring = function (arg) {
	return typeof arg === 'string';
};
var isan = function (arg) {
	return (typeof arg === 'number')
		&& (!isNaN(arg))
		&& (arg !== Number.POSITIVE_INFINITY)
		&& (arg !== Number.NEGATIVE_INFINITY)
		;
};
var exists = function (v) {
	return typeof v !== 'undefined' && v !== null;
};
var appendIfMissing = function (input, str) {
	if (!input.value.includes(str)) {
		input.value += str;
	}
	return true;
};
var isStrEmpty = function(str) {
	return (!str || str.length === 0 );
};
var decimalToHexString = function (n) {
	if (n < 0)
		n = 0xFFFFFFFF + n + 1;
	return n.toString(16).toUpperCase();
};

/**
 * Normalise une valeur hexadécimale (A-F) avec longueur maximale.
 * @param {*} value
 * @param {number} maxLength
 * @returns {string}
 */
var normalizeHex = function (value, maxLength) {
	return String(value || '')
		.toUpperCase()
		.replace(/[^0-9A-F]/g, '')
		.slice(0, maxLength);
};

var isHexadecimal = function(v) {
	return /^#([0-9A-F]{3}){1,2}$/i.test(v);
};

function pad(number, length) {
	var str = '' + number;
	while (str.length < length) {
		str = '0' + str;
	}
	return str;
}

var escapeHtml = function (str) {
	if (str === null || str === undefined) {
		return "";
	}
	return String(str)
		.replace(/&/g, "&amp;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;")
		.replace(/"/g, "&quot;")
		.replace(/'/g, "&#039;");
}

var generatorPassword = function(passwordLength = 15) {
	var chars = "0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ";
	var password = "";
	for (var i = 0; i <= passwordLength; i++) {
		var randomNumber = Math.floor(Math.random() * chars.length);
		password += chars.substring(randomNumber, randomNumber +1);
	}
	return password;
}

/**
 * Fonction formattant un nombre pour l'affichage inspiré de la fonction number_format de php
 *
 * @param {(number|string)} number
 * @param {number} decimals
 * @param {?string} decimalSeparator
 * @param {?string} thousandsSeparator
 *
 * @returns {string}
 */
var numberFormat = function(number, decimals = 0, decimalSeparator = ".", thousandsSeparator = ",") {
	if (number == null || !isFinite(number)) {
		return number == null ? "" : number.toString();
	}

	if (!decimals) {
		var len = number.toString().split('.').length;
		decimals = len > 1 ? len : 0;
	}

	if (!decimalSeparator) decimalSeparator = '.';
	if (!thousandsSeparator) thousandsSeparator = ',';

	number = parseFloat(number);

	var hasDecimals = (number % 1 !== 0);

	if (!hasDecimals) {
		decimals = 0;
	}

	number = number.toFixed(decimals);

	number = number.replace(".", decimalSeparator);

	var splitNum = number.split(decimalSeparator);
	splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
	number = splitNum.join(decimalSeparator);

	return number;
}

/**
 * Makes the first letter of a string uppercase.
 * @return {string}
 */
String.prototype.ucfirst = function () {
	return this.charAt(0).toUpperCase() + this.slice(1);
};

String.prototype.removeAccent = function() {
	if (this.normalize) {
		// Use I18n API if avaiable to split characters and accents, then remove
		// the accents wholesale. Note that we use the original data as well as
		// the new to allow for searching of either form.
		return this.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
	}
	return this
		.replace(/έ/g, 'ε')
		.replace(/[ύϋΰ]/g, 'υ')
		.replace(/ό/g, 'ο')
		.replace(/ώ/g, 'ω')
		.replace(/ά/g, 'α')
		.replace(/[ίϊΐ]/g, 'ι')
		.replace(/ή/g, 'η')
		.replace(/\n/g, ' ')
		.replace(/á/g, 'a')
		.replace(/é/g, 'e')
		.replace(/í/g, 'i')
		.replace(/ó/g, 'o')
		.replace(/ú/g, 'u')
		.replace(/ê/g, 'e')
		.replace(/î/g, 'i')
		.replace(/ô/g, 'o')
		.replace(/è/g, 'e')
		.replace(/ï/g, 'i')
		.replace(/ü/g, 'u')
		.replace(/ã/g, 'a')
		.replace(/õ/g, 'o')
		.replace(/ç/g, 'c')
		.replace(/ì/g, 'i');
}

/**
 *
 * @return {[]}
 */
Array.prototype.getUnique = function () {
	var u = {}, a = [];
	for (var i = 0, l = this.length; i < l; ++i) {
		if (u.hasOwnProperty(this[i])) {
			continue;
		}
		a.push(this[i]);
		u[this[i]] = 1;
	}
	return a;
};


if (!Element.prototype.matches) {
	Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}
if (!Element.prototype.closest) {
	Element.prototype.closest = function (s) {
		var el = this;
		if (!document.documentElement.contains(el)) return null;
		do {
			if (el.matches(s)) return el;
			el = el.parentElement || el.parentNode;
		}
		while (el !== null && el.nodeType === 1);
		return null;
	}
}


$.fn.exists = function () {
	return this.length !== 0;
};
$.fn.existsOnce = function () {
	return this.length === 1;
};
$.fn.hasAttr = function(name) {
	return this.attr(name) !== undefined;
};

/**  ---------------------------------------------------------------------------------------
 *   GLOBALVISIO HOLDER : G
 *   -------------------------------------------------------------------------------------*/

var G;
if (!isdefined(G)) {
	G = {};
}



if (!isdefined(G.CmdStack)) {
	G.CmdStack = function (uiid, endCallback) {
		this._uiid = uiid;
		this._endCallback = endCallback;
		this._index = 0;
		this._stack = [];

		this.enqueue = function (func, args) {
			this._stack.push({
				func: func,
				args: args,
			});
		};
		this._next = function () {
			var cmd;

			if (this._stack.length === 0) {
				if (this._endCallback)
					this._endCallback();
			}
			else {
				cmd = this._stack.shift();
				cmd.func.apply(null, cmd.args);
			}
		};
		this.next = this._next.bind(this);
	}
}


// ############################ GLOBAL CONFIGURATION
// may be merged with other properties defined in model-config.js

if (!isdefined(G.i18n)) {
	G.i18n = {};
}

G.i18n.printNum = function (v, precision, doLog, forceEn) {
	var
		str,
		options = {},
		regex = /^[+\-]?[0-9,.]*$/
		;

	if (!regex.test(v))
		return v;

	if (precision === null || isNaN(precision)) {
		options.minimumFractionDigits = precision;
	}

	str = (v === null || isNaN(v)) ? '' : v.toLocaleString((forceEn === true) ? 'en' : G.i18n.lang, options);
	if (doLog !== false) {
	}
	return str;
};

G.i18n.printVal = function (v, precision, unit, comment) {
	var str = G.i18n.printNum(v, precision, false);

	if (isfilled(unit))
		str += '<small>' + unit + '</small>';

	if (isfilled(comment))
		str += comment;

	if(v === null)
		str = '-';
	return str;
};

G.i18n.lang = 'fr';

G.i18n.langs = [
	{ nick: 'fr', label: 'Français' },
	{ nick: 'de', label: 'Deutsch' },
	{ nick: 'en', label: 'English' }
];


// ############################ GLOBAL COLORS

if (!isdefined(G.clr)) {
	G.clr = {};

	/**
	 * enumeration for status colors
	 * @type {Readonly<{orange: string, red: string, green: string, blue: string, greyDefault: string}>}
	 */
	G.clr.STATUS_ENUM = Object.freeze({
		greyLight: rgbToHex(220, 220, 220, 124),
		greyDefault: rgbToHex(160, 160, 160),
		green: rgbToHex(150, 191, 85),
		blue: rgbToHex(91, 165, 186),
		orange: rgbToHex(219, 185, 40),
		red: rgbToHex(195, 88, 83)
	});

	/**
	 * @type {Object.<string, number>}
	 */
	G.clr.STATUS_2_COLORS = Object.freeze({
		// green
		ok: G.clr.STATUS_ENUM.green,
		success: G.clr.STATUS_ENUM.green,

		// blue
		info: G.clr.STATUS_ENUM.blue,

		// orange
		warning: G.clr.STATUS_ENUM.orange,

		// red
		ko: G.clr.STATUS_ENUM.red,
		fatal: G.clr.STATUS_ENUM.red,
		error: G.clr.STATUS_ENUM.red,

		// grey
		default: G.clr.STATUS_ENUM.greyDefault,
	});


	// #############################################################################################
	//		COLORS
	// #############################################################################################

	/**
	 * enumeration for odysecure colors
	 * @type {{alarmSystem: (string|*), gold: string, green: string, blue: string, greend: string, alarmOk: (string|*), chartMedian: string, alarmError: (string|*), alarmWarning: (string|*), chartLine: string, grey: string}}
	 */
	G.clr.ODY_ENUM = Object.freeze({
		alarmOk: G.clr.STATUS_ENUM.green,
		alarmSystem: G.clr.STATUS_ENUM.blue,
		alarmWarning: G.clr.STATUS_ENUM.orange,
		alarmError: G.clr.STATUS_ENUM.red,
		chartMedian: '#009ee0',
		chartLine: '#3c4e57',
		green: '#79B729',
		greend: '#11A825',
		blue: '#009FC3',
		gold: '#F29100',
		grey: '#808080'
	});

	G.clr.ODY_ARR = [
		G.clr.ODY_ENUM.alarmOk,
		G.clr.ODY_ENUM.alarmSystem,
		G.clr.ODY_ENUM.alarmWarning,
		G.clr.ODY_ENUM.alarmError,
		G.clr.ODY_ENUM.chartMedian,
		G.clr.ODY_ENUM.chartLine,
		G.clr.ODY_ENUM.green,
		G.clr.ODY_ENUM.greend,
		G.clr.ODY_ENUM.blue,
		G.clr.ODY_ENUM.gold,
		G.clr.ODY_ENUM.grey,
	];

	/**
	 * Enumeration for GlobalVisio colors
	 * @type {Readonly<{
	 *   ui_grey: string,
	 *   ui_green: string,
	 *   ui_blue: string,
	 *   ui_orange: string,
	 *   ui_red: string,
	 *   ui_transparent: string,
	 *   purple: string,
	 *   blue: string,
	 *   bluel: string,
	 *   green: string,
	 *   greenl: string,
	 *   yellow: string,
	 *   orange: string,
	 *   brown: string,
	 *   pink: string,
	 *   red: string,
	 *   dark: string,
	 *   pinkd: string,
	 *   purpled: string,
	 *   redl: string,
	 *   orangel: string
	 * }>}
	 */
	G.clr.GV_ENUM = Object.freeze({
		ui_grey: G.clr.STATUS_ENUM.greyDefault,
		ui_green: G.clr.STATUS_ENUM.green,
		ui_blue: G.clr.STATUS_ENUM.blue,
		ui_orange: G.clr.STATUS_ENUM.orange,
		ui_red: G.clr.STATUS_ENUM.red,
		ui_transparent: '#00000000',
		purple: '#9b57b4',
		blue: '#345a90',
		bluel: '#3d9fb8',
		green: '#599059',
		greenl: '#a0be64',
		yellow: '#d1b639',
		orange: '#cc693a',
		brown: '#836044',
		pink: '#e4798b',
		red: '#a13945',
		dark: '#4f4f4f',
		pinkd: '#b6616f',
		purpled: '#7c4690',
		redl: '#c35853',
		orangel: '#ff9c59'
	});

	G.clr.GV_ARR = [
		G.clr.GV_ENUM.ui_grey,
		G.clr.GV_ENUM.blue,//1
		G.clr.GV_ENUM.greenl,
		G.clr.GV_ENUM.brown,
		G.clr.GV_ENUM.yellow,
		G.clr.GV_ENUM.red,
		G.clr.GV_ENUM.bluel,//6
		G.clr.GV_ENUM.green,
		G.clr.GV_ENUM.purple,
		G.clr.GV_ENUM.orange,
		G.clr.GV_ENUM.pink,
		G.clr.GV_ENUM.dark,
		G.clr.GV_ENUM.pinkd,
		G.clr.GV_ENUM.purpled,
		G.clr.GV_ENUM.redl,
		G.clr.GV_ENUM.orangel,
		'#990099',
		'#0099c6',//17
		'#dd4477',
		'#3366cc',//19
		'#dc3912',
		'#ff9900',
		'#109618',
		'#b82e2e',
		'#3366cc',//24
		'#994499',
		'#22aa99',//26
		'#aaaa11',
		G.clr.GV_ENUM.ui_transparent,
		'#C8E6C9',
		'#A5D6A7',
		'#66BB6A',
		'#2E7D32',
		'#0f110f',
		'#BBDEFB',
		'#64B5F6',
		'#2196F3',
		'#1976D2',
		'#1565C0',
		'#0D47A1'
	];

	G.clr.HEATMAP_MODES = {
		hot: {
			minColor: '#fff4cc',   // jaune très clair (chaleur douce)
			maxColor: '#8b0000',   // rouge foncé profond (très chaud)
			colors: [
				'#fff4cc',  // jaune pâle
				'#ffd966',  // jaune chaud
				'#ff9933',  // orange vif
				'#e2583e',  // rouge chaud
				'#c1392b',  // rouge fort
				'#8b0000'   // rouge foncé profond
			]
		},
		cold: {
			minColor: '#e0f0ff',   // bleu très clair (presque blanc)
			maxColor: '#1d2d50',   // bleu très foncé
			colors: [
				'#e0f0ff',          // bleu clair / gris-bleu
				'#5aa6c2',          // bleu moyen
				'#345a90',          // bleu profond
				'#1d2d50'           // bleu nuit
			]
		},
		neutral: {
			minColor: '#f2f2f2',  // gris très clair
			maxColor: '#404040',  // gris foncé
			colors: [
				'#f2f2f2',  // gris très clair
				'#cccccc',  // gris clair
				'#a0a0a0',  // gris moyen (référence)
				'#707070',  // gris soutenu
				'#404040'   // gris foncé
			]
		}
	};
}

// ############################ GLOBAL INFERFACE FUNCTION
if (!isdefined(G.ui)) {
	G.ui = {};

	/**
	 * Whether client support seems to be a touch interface.
	 * @see  https://www.labnol.org/code/19616-detect-touch-screen-javascript
	 * @type {boolean}
	 */
	G.ui.isTouch = (('ontouchstart' in window) || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));

	document.addEventListener('DOMContentLoaded', function () {
		document.body.cleanClasses('touch--');
		document.body.classList.add(G.ui.isTouch ? 'touch--enabled' : 'touch--disabled');
	});


	G.ui.fatalError = function (message, context) {
		console.warn(message, context);
		$.ajax({
			url: "/frontend/ajax/logerror",
			type: 'POST',
			data: {
				'message': message,
				'context': JSON.stringify(context)
			},
			error: function (xhr, textStatus, errorThrown) {
				// G.ui.fatalError("ajax error: " + textStatus, {url: this.url, error: errorThrown});
			},
			success: function (data, textStatus, xhr) {

			}
		});
	};

	var tippedContainer = $('#o-wrapper');
	if (tippedContainer.length === 0)
		tippedContainer = null;

	G.ui.tippedClone = function (o) {
		return JSON.parse(JSON.stringify(o));
	};

	// @see http://www.tippedjs.com/documentation/options
	G.ui.tippedDefault = {
		behavior: 'hide',
		cache: true,
		container: tippedContainer,
		containment: true,
		close: false,
		fadeIn: 0,
		fadeOut: 0,
		hideAfter: 150,
		hideOn: 'click',
		hideOnClickOutside: false,
		hideOthers: true,
		inline: null,
		maxWidth: 200,
		offset: {
			x: 0,
			y: 0
		},
		padding: true,
		position: 'top',
		radius: true,
		shadow: false,
		showDelay: 75,
		showOn: 'mouseenter',
		size: 'medium', /* used as skin replacement */
		skin: 'dark',
		stem: true,
		spinner: false, /* disabled via css */
		target: 'element',
		title: null
	};
	G.ui.tippedPanel = deepmerge(G.ui.tippedClone(G.ui.tippedDefault), {
		offset: {
			x: 0,
			y: 0
		},
		stem: false,
		size: 'large' /* used as skin replacement */
	});

	/**
	 * Create a safe copy of elements title
	 *    - tippedjs remove title when initialized
	 *    - when added/removed to DOM there is no mean to re-init tipped as title attributes are removed
	 * @param where
	 */
	G.ui.tippedCreateSafeTitle = function (where) {
		var
			classSelector = '.gv-tip[title]',
			els;

		if (exists(where))
			els = where.is(classSelector) ? where : where.find(classSelector);
		else
			els = $(classSelector);

		els.each(function (index, el) {
			el = $(el);
			el.attr('data-safe-title', el.attr('title'));
		});
	};

	G.ui.tippedInit = function (where, searchForSafeTitle) {
		var
			classSelector = '.gv-tip',
			conf, style, position, els, el;

		var createContentFunction = function (el, conf) {
			return function () {
				var bcl = document.body.classList;
				if (bcl.contains('responsive--mobile') || bcl.contains('responsive--tablet'))
					return null;
				else {
					return conf.content;
				}
			}
		};

		G.ui.tippedCreateSafeTitle(where);

		if (exists(where)) {
			where = $(where);
			els = where.is(classSelector) ? where : where.find(classSelector);
		}
		else
			els = $(classSelector);

		els.each(function (index, rawEl) {
			el = $(rawEl);

			if (searchForSafeTitle)
				el.attr('title', el.attr('data-safe-title'));

			// ---  pick config according to "data-tippedstyle" attribute

			style = el.attr('data-tippedstyle');
			if (!!style)
				style = style.toLowerCase();

			switch (style) {
				case 'panel':
				case 'panel-locked':
					conf = G.ui.tippedClone(G.ui.tippedPanel);
					conf.content = function (element) {
						return $(element).next('.gv-tip__panel-content');
					};
					break;
				case 'default':
				case 'default-locked':
				default:
					conf = G.ui.tippedClone(G.ui.tippedDefault);
					break;
			}

			switch (style) {
				case 'panel-locked':
				case 'default-locked':
					conf.close = true;
					conf.hideOn = {
						element: 'click',
						tooltip: 'click'
					};
					conf.hideOnClickOutside = false;
					conf.hideAfter = null;
					break;
			}


			// ---  set title according to "data-tippedtitle" attribute

			if (!conf.content) {
				if (rawEl.hasAttribute('data-tippedtitle'))
					conf.content = rawEl.getAttribute('data-tippedtitle');
				else if (rawEl.hasAttribute('title'))
					conf.content = rawEl.getAttribute('title');
			}


			// ---  adjust position according to "data-tippedpos" attribute

			position = el.attr('data-tippedpos');
			if (!!position)
				position = position.toLowerCase();

			switch (position) {
				case 'bottom':
					conf.position = position;
					conf.offset = {
						y: 7
					};
					break;

				case 'right':
				case 'left':
					conf.position = position;
					break;

				case 'top':
				default:
					conf.position = 'top';
					break;
			}

			conf.cache = false;

			Tipped.create.apply(null, [el, createContentFunction(el, conf), conf]);
		});
	};

	// --- automatic conversion of select inputs in select2 instances
	G.ui.initSelect2 = function (where) {
		var selects, counter = 0;

		if (!!where) {
			if (!(where instanceof jQuery)) {
				where = $(where);
			}
			selects = where.is('select') ? where : where.find('select');
		}
		else {
			selects = $('select').not('.swal2-select');
		}

		selects.each(function (index, el) {
			var $el = $(el), options;


			if ($el.hasClass('no-select2')) {
			}
			else {
				++counter;
				options = {
					width: $el.hasClass('select2-full-width') ? '100%' : 'resolve'
				};

				if (el.hasAttribute('multiple')) {
					options.multiple = true;
					if (el.hasAttribute('data-clear')) {
						options.allowClear = true;
					}
				}

				if(el.hasAttribute('data-option-edit-url')) {
					options.templateResult = (state) => {
						if (!state.id ) return state.text;

						var $option = $(`<span>${state.text}</span>`);
						var $redirectLink = $(`
							<span class="text-flow">
								<a href="${$el.attr('data-option-edit-url').replace("{ID}", state.id)}" 
									target="_blank" style="float:right;cursor:pointer;text-decoration:none;border-bottom:none">
									<i class="fas fa-edit"></i>
								</a>
							</span>
						`);

						$redirectLink.on('mouseup', function (event) {
							// Select2 supprimera la liste déroulante lors du `mouseup`, ce qui empêchera tout événement `click` d'être déclenché.
							// On doit donc bloquer la propagation de l'événement `mouseup`
							event.stopPropagation();
						});

						$option.append($redirectLink);

						return $option;
					}
					options.templateSelection = (state) => {
						if (!state.id ) return state.text;

						var $option = $(`<span>${state.text}</span>`);
						var $redirectLink = $(`
							<span class="text-flow">
								<a href="${$el.attr('data-option-edit-url').replace("{ID}", state.id)}" 
									target="_blank" style="cursor:pointer;text-decoration:none;border-bottom:none">
									<i class="fas fa-edit"></i>
								</a>
							</span>
						`);

						$redirectLink.on('mouseup', function (event) {
							// Select2 supprimera la liste déroulante lors du `mouseup`, ce qui empêchera tout événement `click` d'être déclenché.
							// On doit donc bloquer la propagation de l'événement `mouseup`
							event.stopPropagation();
						});

						$option.prepend($redirectLink);

						return $option;
					}
				} else {
					options.templateResult = (option) => {
						if (option.element && $(option.element).data('hidden')) {
						return null; // option masquée dans la liste
						}
						return option.text;
					}
				}

				if (el.hasAttribute('placeholder'))
					options.placeholder = $el.attr('placeholder');

				if (el.hasAttribute('data-nosearch'))
					options.minimumResultsForSearch = -1;

				if (el.hasAttribute('data-tags'))
					options.tags = true;

				$el.select2(options);
			}
		});
		return counter;
	}

	// Ouverture fenêtre modale affichant une liste d'image en preview (nécessite la lib remodal)
	G.ui.showModalGalleryImage = function(listImgSrc, galleryTitle) {
		if (!Array.isArray(listImgSrc) || listImgSrc.length === 0) {
			return;
		}

		var cursorIndexPreviewPicture = 0;
		var galleryImageId = "swal-gallery-image";
		var galleryCounterId = "swal-gallery-counter";
		var imageAltLabel = G.config.LOCALE_RETRIEVE('trumbowyg.insertImage');
		var previewLabel = G.config.LOCALE_RETRIEVE('indicator.edition.preview');
		var previousLabel = G.config.LOCALE_RETRIEVE('indicator.edition.previous');
		var nextLabel = G.config.LOCALE_RETRIEVE('indicator.edition.next');

		var normalizedGalleryTitle = (galleryTitle || previewLabel).replace(/^\s*\d+\s*-\s*/, '');

		var updateGalleryImage = function () {
			var popup = Swal.getPopup();
			if (!popup) {
				return;
			}

			var currentSrc = listImgSrc[cursorIndexPreviewPicture];
			$(popup).find("#" + galleryImageId).attr("src", currentSrc);
			$(popup).find("#" + galleryCounterId).text((cursorIndexPreviewPicture + 1) + " / " + listImgSrc.length);

			var $denyButton = $(Swal.getDenyButton());
			var $cancelButton = $(Swal.getCancelButton());
			$denyButton.prop("disabled", listImgSrc.length <= 1 || cursorIndexPreviewPicture === 0);
			$cancelButton.prop("disabled", listImgSrc.length <= 1 || cursorIndexPreviewPicture >= (listImgSrc.length - 1));
		};

		Swal.fire({
			title: normalizedGalleryTitle,
			html: `
				<div class="uicomp__vflow mod--align-center" style="width: 100%; margin: 0 auto; overflow: hidden;">
					<div class="text-center" style="width: 100%;">
						<img id="${galleryImageId}" alt="${imageAltLabel}" style="display: block; width: 100%; max-width: 100%; max-height: 62vh; object-fit: contain; margin: 0 auto; border-radius: 8px;">
						<div id="${galleryCounterId}" class="mod--size-s" style="margin-top: 10px; text-align: center; color: #888;"></div>
					</div>
				</div>
			`,
			width: 'min(920px, 94vw)',
			showConfirmButton: false,
			showDenyButton: true,
			showCancelButton: true,
			showCloseButton: true,
			denyButtonText: '< ' + previousLabel,
			cancelButtonText: nextLabel + ' >',
			buttonsStyling: false,
			customClass: {
				popup: 'gv-swal-popup--gallery',
				closeButton: 'uicomp__button uicomp--transparent',
				actions: 'uicomp__hflow mod--align-center mod--nowrap',
				denyButton: 'uicomp__button uicomp--blue',
				cancelButton: 'uicomp__button uicomp--blue'
			},
			didOpen: function () {
				var popup = Swal.getPopup();
				$(popup).css("overflow", "hidden");
				$(popup).find(".swal2-title").css("margin-bottom", "14px");
				$(popup).find(".swal2-html-container").css({
					overflow: "hidden",
					margin: "0",
					padding: "0 0 8px 0"
				});
				$(Swal.getDenyButton()).html('<i class="fal fa-arrow-left"></i>&nbsp;' + previousLabel);
				$(Swal.getCancelButton()).html(nextLabel + '&nbsp;<i class="fal fa-arrow-right"></i>');
				updateGalleryImage();

				Swal.getDenyButton().addEventListener("click", function (e) {
					e.preventDefault();
					e.stopPropagation();
					e.stopImmediatePropagation();
					if (cursorIndexPreviewPicture === 0) {
						return false;
					}
					cursorIndexPreviewPicture = cursorIndexPreviewPicture - 1;
					updateGalleryImage();
					return false;
				}, true);

				Swal.getCancelButton().addEventListener("click", function (e) {
					e.preventDefault();
					e.stopPropagation();
					e.stopImmediatePropagation();
					if (cursorIndexPreviewPicture >= (listImgSrc.length - 1)) {
						return false;
					}
					cursorIndexPreviewPicture = cursorIndexPreviewPicture + 1;
					updateGalleryImage();
					return false;
				}, true);
			}
		});
	}
}

// ############################ GLOBAL MODE AVAILABLE IHM
if (!isdefined(G.state)) {
	G.state = {
		backend: 'backend',
		frontend: 'frontend'
	};

}

// ############################ VALUE OBJECTS
if (!isdefined(G.vo)) {
	G.vo = {};
}

/**
 * @param x {number}
 * @param y {number}
 * @constructor
 */
G.vo.Point = function (x, y) {
	this.x = 0;
	this.y = 0;
	this.reset = function (x, y) {
		this.x = isan(x) ? x : 0;
		this.y = isan(y) ? y : 0;
		return this;
	};
	this.plus = function (pt) {
		this.x += pt.x;
		this.y += pt.y;
		return this;
	};
	this.minus = function (pt) {
		this.x -= pt.x;
		this.y -= pt.y;
		return this;
	};
	this.toString = function () {
		return '{ ' + this.x.toFixed(2) + '; ' + this.y.toFixed(2) + ' }';
	};
	this.round = function (precision) {
		if (!isan(precision))
			precision = 1;
		this.x = Math.round(this.x / precision) * precision;
		this.y = Math.round(this.y / precision) * precision;
		return this;
	};
	this.divide = function (pt) {
		this.x /= pt.x;
		this.y /= pt.y;
		return this;
	};
	this.multiply = function (pt) {
		this.x *= pt.x;
		this.y *= pt.y;
		return this;
	};
	this.scale = function (coef) {
		this.x *= coef;
		this.y *= coef;
		return this;
	};
	this.clone = function () {
		return new G.vo.Point(this.x, this.y);
	};

	this.reset(x, y);
};

/**
 * @param id {string}
 * @param min {number}
 * @constructor
 */
G.vo.ResponsiveBreak = function (id, min) {
	/** @type {string} */
	this.id = id;
	/** @type {number} */
	this.min = min;
};

/**
 * @param vo {{id: number, label: string, url: string, site: ?G.vo.Site}}
 * @constructor
 */
G.vo.Fav = function (vo) {
	this.id = vo.id;
	this.label = vo.label;
	this.url = vo.url;
	/** @type {G.vo.Site|null} */
	this.site = exists(vo.site) ? new G.vo.Site(vo.site) : null;
};

/**
 * @param vo {{id: number, nom: string}}
 * @constructor
 */
G.vo.Role = function (vo) {
	this.id = vo.id;
	this.nom = vo.nom;
};

/**
 * @param vo {{id: number, nom: string, droit: number, kessel: number, admin: number}}
 * @constructor
 */
G.vo.Group = function (vo) {
	this.id = vo.id;
	this.nom = vo.nom;
	this.droit = vo.droit;
	this.kessel = vo.kessel;
	this.admin = vo.admin;
};

/**
 *
 * @param vo
 * @constructor
 */
G.vo.User = function (vo) {
	this.id = vo.id;
	this.username = vo.username;
	this.civilite = vo.civilite;
	this.nom = vo.nom;
	this.prenom = vo.prenom;
	this.droit = vo.droit;
	this.imgSquare = vo.imgSquare;
	this.imgDefault = vo.imgDefault;
	this.fonction = vo.fonction;
	this.email = vo.email;
	this.telephone = vo.telephone;
	this.entreprise_id = vo.entreprise_id;
	this.sessionExpiration = vo.sessionExpiration;

	/** @type G.vo.Fav[] */
	this.favs = [];
	/** @type G.vo.Role[] */
	this.roles = (vo?.roles ?? []).map(function(role) {
		return new G.vo.Role(role);
	});
	/** @type G.vo.Group */
	this.groupe = new G.vo.Group(vo.groupe);

	this.odysecure = vo.odysecure;
	this.hasFullAccess = vo.hasFullAccess;
	this.isDemo = vo.isDemo;
	this.isSuperAdmin = vo.isSuperAdmin;
	this.hasRoleIntervention = vo.hasRoleIntervention;

	/**
	 * Returns a string representation of the instance
	 */
	this.toString = function () {
		return '[User] ' + this.prenom + ' ' + this.nom + ' [id: ' + this.id + ']';
	};
};

/**
 *
 * @param vo
 * @constructor
 */
G.vo.DashboardPage = function (vo) {
	this.id = vo.id;
	this.titre = vo.titre;
	this.droit = vo.droit;
	this.position = vo.position;
	this.type = vo.type;
};

/**
 *
 * @param vo
 * @constructor
 */
G.vo.Synopsis = function (vo) {
	this.id = vo.id;
	this.nom = vo.nom;
	this.src = vo.image;
	this.width = vo.width;
	this.height = vo.height;
	this.color = vo.hasOwnProperty('color') ? vo.color : '#C0C0C0';
    this.siteId = vo.site_id;
};

/**
 *
 * @param vo
 * @constructor
 */
G.vo.Equipment = function (vo) {
	this.id = vo.id;
	this.nom = vo.nom;
	this.markName = vo?.marque?.nom ?? "";
};

/**
 *
 * @param vo
 * @constructor
 */
G.vo.Report = function (vo) {
	this.id = vo.id;
	this.nom = vo.nom;
	this.type = vo.type;
};

/**
 *
 * @param vo
 * @constructor
 */
G.vo.Site = function (vo) {
	// Applied default config in case when some config missing
	let voSiteDefault = {
		typeSite: null,
		entreprise: null,
		zones: [],
		dashboardPages: [],
		synoptiques: [],
		equipements: [],
		rapports: []
	};
	let voSite = Object.assign(voSiteDefault, vo);

	var i, len;

	this.type = 'site';
	this.id = voSite.id;
	this.nom = voSite.nom;
	this.adresse = voSite.adresse;
	this.adresse2 = voSite.adresse2;
	this.codePostal = voSite.codePostal;
	this.ville = voSite.ville;
	this.pays = voSite.pays;
	this.logo = voSite.logo;
	this.active = voSite.active;
	this.odysecure_id = voSite.odysecure_id;
	this.consommation = voSite.consommation;
	this.consoDetail = voSite.consoDetail;
	this.isEstateSite = voSite.isEstateSite;
	this.estateSiteId = voSite.estateSiteId;
	this.showMonitoringTable = voSite.showMonitoringTable;
	this.hideAlertSection = voSite.hideAlertSection;

	//  ---   belongs to
	this.typeSite = voSite.typeSite;
	this.entreprise = voSite.entreprise;


	//  ---   longitude/latitude
	this.latitude = voSite.latitude;
	this.longitude = voSite.longitude;

	//  ---   zones
	this.zones = [];
	for (i = 0, len = voSite.zones.length; i < len; ++i) {
		this.zones.push(new G.vo.Zone(vo.zones[i]));
	}

	//  ---   dashboardPages
	this.dashboardPages = [];
	if(exists(voSite.dashboardPages)){
		for (i = 0, len = voSite.dashboardPages.length; i < len; ++i)
			this.dashboardPages.push(new G.vo.DashboardPage(voSite.dashboardPages[i]));
	}

	//  ---   synopsis
	this.synoptiques = [];
	for (i = 0, len = voSite.synoptiques.length; i < len; ++i)
		this.synoptiques.push(new G.vo.Synopsis(voSite.synoptiques[i]));

	//  ---   equipments
	this.equipments = [];
	for (i = 0, len = voSite.equipements.length; i < len; ++i)
		this.equipments.push(new G.vo.Equipment(voSite.equipements[i]));

	//  ---   reports
	this.reports = [];
	for (i = 0, len = voSite.rapports.length; i < len; ++i)
		this.reports.push(new G.vo.Report(voSite.rapports[i]));

    //  ---   estateSiteChilds
    this.estateSiteChilds = [];
    if(this.isEstateSite == 1) {
		if(voSite.estateSiteChilds) {
			for (i = 0, len = voSite.estateSiteChilds.length; i < len; ++i)
				this.estateSiteChilds.push(new G.vo.Site(voSite.estateSiteChilds[i])); 
		}
    }

	// ---   alerts
	this.alertsColl = [];
	this.alertsCounter = [0, 0, 0, 0, 0];

	/**
	 * Resets alerts model
	 */
	this.alertsReset = function () {
		this.alertsColl = [];
		this.alertsCounter = [0, 0, 0, 0, 0];
	};

	/**
	 * Returns the index of highest priority alert
	 * @returns {number} priority index (1: priority0, 1: priority1, ... 4: priority4) or -1
	 */
	this.alertsHighestPriority = function () {
		for (var i = 1, ilen = this.alertsCounter.length; i < ilen; ++i) {
			if (this.alertsCounter[i] > 0)
				return i;
		}
		return 5;
	};

	/**
	 *
	 * @param p {[]} priorities
	 * @returns {boolean}
	 */
	this.allowFromPriorities = function (p) {

		if (this.alertsCounter[0] === 0)
			return p[0];

		for (var i = 1, ilen = p.length; i < ilen; i++) {
			if (p[i] && this.alertsCounter[i] > 0)
				return true;
		}

		return false;
	};

	this.hasEstateSite = function() {
		return exists(this.estateSiteId);
	}

	/**
	 * Returns a string representation of the instance
	 */
	this.toString = function () {
		return '[vo.Site] ' + this.nom + ' (#' + this.id + ', zones: ' + this.zones.length + ', synoptiques: ' + this.synoptiques.length + ')';
	};
};

/**
 *
 * @param vo
 * @constructor
 */
G.vo.Zone = function (vo) {
	this.id = vo.id;
	this.nom = vo.nom;

	/**
	 * Returns a string representation of the instance
	 */
	this.toString = function () {
		return '[vo.Zone] ' + this.nom + ' [id: ' + this.id + ']';
	};
};

/**
 *
 * @param vo
 * @constructor
 */
G.vo.TypeSite = function (vo) {
	this.id = vo.id;
	this.type = 'typeSite';
	this.nomUID = vo.nom;
	this.code = vo.code;

	/**
	 * Returns a string representation of the instance
	 */
	this.toString = function () {
		return '[vo.TypeSite] ' + this.nomUID + ' (#' + this.id + ')';
	};
};

/**
 *
 * @param vo
 * @constructor
 */
G.vo.Alert = function (vo) {

	this.guid = 'alert' + G.config.GET_GUID();
	this.siteId = vo.siteId;
	this.automateId = vo.automateId;
	this.icon = vo.icon;
	if (!isfilled(this.type)) this.type = 'sensor';
	this.pointId = vo.pointId;
	this.description = vo.description;
	this.type = vo.type;
	if (!isfilled(this.type)) this.type = 'default';
	this.pointLabelHumain = vo.pointLabelHumain;
	this.equipementLabelHumain = vo.equipementLabelHumain;
	if (!isfilled(this.pointLabelHumain)) this.pointLabelHumain = 'no-label';
	this.pointType = vo.pointType;
	this.pointUnite = vo.pointUnite;
	this.pointValeur = vo.pointValeur;

	switch (parseInt(vo.priorite)) {
		case 1:
		case 2:
		case 3:
			this.priorite = parseInt(vo.priorite);
			break;
		default:
			this.priorite = 4;
			break;
	}

	this.start = new Date(vo.start * 1000);

	if(exists(vo.end) && !isNaN(vo.end)) { vo.end = parseInt(vo.end); }
	this.end = isan(vo.end) ? new Date(vo.end * 1000) : null;

	/**
	 * Returns a string representation of the instance.
	 */
	this.toString = function () {
		return '[Alert] ' + this.pointId + ' "' + this.type + '" (from: ' + G.config.LOCALE_DATE(this.start) + (this.end ? ', to: ' + G.config.LOCALE_DATE(this.end) : '') + ')';
	};

};

/**
 * @param vo
 * @constructor
 */
G.vo.Section = function (vo) {
	this.id = vo.id;
	this.isAssets = vo.isAssets;
	this.convert = vo.convert || (this.isAssets ? 'dashboard' : 'dashboardAssets');
	/** @type {function} conditionAccessible */
	this.conditionAccessible = vo.conditionAccessible;
};

/**
 *
 * @constructor
 */
G.vo.Model = function () {
	// ---  site architecture
	/** @param {G.vo.Section[]} */
	this.sections = [];
	/** @param {G.vo.Section[]} */
	this.sectionsPrestations = [];
	this.sectionsMap = {};
	this.sectionsMapPrestations = {};

	/** @type {string} */
	this.lang = 'fr';

	/** @param lang {string} */
	this.setLang = function (lang) {
		this.lang = lang;
		G.i18n.lang = lang;

        document.documentElement.lang = lang;
        $('html').attr('lang', lang);

        // Déclenche ce hook avant chaque requête AJAX jQuery globale
        $(document).ajaxSend(function (event, jqXHR, settings) {
            // Construit une URL absolue à partir de l'URL de la requête.
            // Ça permet de gérer à la fois :
            // - les URLs relatives : /api/test
            // - les URLs absolues : https://monsite.com/api/test
            const requestUrl = new URL(settings.url, window.location.href);

            // Vérifie que la requête cible le même origin que la page courante.
            // origin = protocole + domaine + port
            // Exemples :
            // - https://monsite.com === https://monsite.com -> OK
            // - https://api.monsite.com !== https://monsite.com -> refusé
            // - http://monsite.com !== https://monsite.com -> refusé
            if (requestUrl.origin === window.location.origin) {
                // Ajoute le header HTTP Accept-Language avec la langue courante de la page.
                // Si aucune langue n'est définie dans <html lang="...">,
                // on utilise 'fr' par défaut.
                jqXHR.setRequestHeader(
                    'Accept-Language',
                    document.documentElement.lang || 'fr'
                );
            }
        });

        if (HCH)
			HCH.initHighcharts();
	};

	/** @type {string} */
	this.theme = 'globalvisio';

	/** @type {string[]} */
	this.icons = [
		'void', 'counter-default', 'counter-elec', 'counter-fire', 'counter-water', 'tank', 'measure-level', 'measure-from-top', 'measure-from-bottom', 'humidity-default', 'upload-to-cloud', 'warm-floor', 'circuit-temperature', 'circuit-plancher', 'certificate', 'shutterv2', '', '',
		'fan', 'elec', 'fire', 'water', 'solar', 'plug', 'pump', 'toolbox', 'wrench', 'humidity-green', 'elec-boxes', 'shower', 'circuit-radiateur', 'circuit-air', 'comfort', '', '','',
		'meter-default', 'meter-elec', 'meter-fire', 'meter-water', 'bathtub', 'radiator', 'wind', 'nuke', 'pen', 'humidity-orange', 'ventilation', 'water-temp', 'circuit-eau', 'circuit-gaz', 'elevator', '', '', '',
		'onoff-default', 'onoff-active', 'onoff-inactive', 'gps-default', 'gps-green', 'gps-orange', 'gps-red', 'favs', 'list', 'humidity-red', 'bactery-ko', 'thumb-up', 'circuit-solaire', 'pression', 'loop-v2', '', '', '',
		'suitcase-frost-protection', 'house-ecology', 'hand-ecology', 'boiler-cold', 'boiler-medium', 'boiler-hot', 'globalvisio-greyscale', 'globalvisio', 'kilogram', 'smoke-active', 'bactery-ok', 'thumb-down', 'star', 'pression-green', 'clock-v2', '', '', '',
		'house-cold', 'house-medium', 'house-hot', 'temp-cold', 'temp-medium', 'temp-hot', 'air-particles', 'counter-oil', 'counter-sun', 'smoke-inactive', 'brain', 'savings', 'compteur', 'pression-orange', 'chef', '', '', '',
		'file-zip', 'file-calc', 'file-doc', 'file-contract', 'data-graph', 'data-planning', 'data-calendar', 'data-calendar-alt', 'data-graph-alt', 'co2-default', 'pointer', 'alerts', 'chaudiere-blue', 'pression-red', 'water-meter-v2', '', '', '',
		'summer-winter-default', 'summer-winter-summer', 'summer-winter-winter', 'sun', 'snowflake', 'house', 'building', 'entreprise', 'trash', 'co2-green', 'blueprint', 'column', 'chaudiere-default', 'uptime', 'electric-car', '', '', '',
		'daynight-default', 'daynight-day', 'daynight-night', 'moon', 'man-default', 'man-worker', 'man-hotline', 'man-recipient', 'trash-opened', 'co2-orange', 'slideshow', 'temp-loop', 'chaudiere-red', 'echangeur', 'electric-plug', '', '', '',
		'network-ok', 'network-ko', 'automaton', 'header-ody-overview', 'lock-closed', 'lock-opened', 'refresh', 'log-in', 'log-out', 'co2-red', 'antenna', 'chrono', 'pinned', 'unpinned', 'charging-terminal', 'brand-grdf', '', '',
		'light-bulb-on', 'light-bulb-off', 'aim-red', 'aim-orange', 'aim-green', 'gear', 'search', 'overview', 'synopsis', 'shredder', 'duration', 'question-mark', 'temp-orange', 'radiateur', 'electric-car-v2', 'brand-enedis', '', '',
		'gauge-green', 'gauge-orange', 'gauge-red', 'gauge', 'bell-default', 'bell-ringing-default', 'bell-ringing-orange', 'bell-ringing-red', 'alarm-clock', 'data-minmax-average', 'data-dashboard', 'close', 'temp-alert-red', 'temp-alert-default', 'emergency', 'calendar-day', '', '',
		'alert-sign-red', 'alert-sign-orange', 'alert-sign-default', 'shield-default', 'shield-red', 'shield-green', 'check', 'wrong', 'time-ok', 'time-ko', 'check-default', 'simple-check', 'temp-alert-orange', 'temp-alert-blue', 'conso', 'header-conso', 'sousconso', 'surconso',
		'header-graph', 'header-overview', 'header-alerts', 'header-gear', 'header-synopsis', 'header-modules', 'header-user', 'header-data-dashboard', 'temp-minmax', 'data-average', 'brand-globalio', 'brand-kessel', 'brand-abiga', 'intervention', 'connection', 'disconnection', '', '',
		'header-file-calc', 'header-file-doc', 'header-file-contract', 'header-maintenance', 'header-real-time', 'header-historic', 'header-parc', 'shield-orange', 'minmax-average', 'data-delta', 'brand-lora', 'brand-siemens', 'door-closed', 'door-opened', 'header-add-location', 'header-data-import', 'header-data-export', 'data-error',
		'battery-level-5on5', 'battery-level-4on5', 'battery-level-3on5', 'battery-level-2on5', 'battery-level-1on5-orange', 'battery-level-1on5-red', 'battery-level-0on5', 'in-out-hot-cold', 'in-out-cold-hot', 'in-out-grey-grey', 'brand-sigfox', 'brand-trend', 'temp-interieur', 'factory', 'data', 'import-data', 'export-data', 'remove-data',
		'trend-down-green', 'trend-up-green', 'trend-down-red', 'trend-up-red', 'trend-steady-default', 'trend-down-default', 'trend-up-default', 'surface', 'volume', 'in-out-red-grey', 'brand-sauter', 'brand-sofrel', 'close-thin', 'dry', 'add-location', 'remove-location', 'add-user', 'remove-user',
		'threshold-down-green', 'threshold-up-green', 'threshold-down-default', 'threshold-up-default', 'threshold-down-red', 'threshold-up-red', 'timeline', 'phone', 'phone-sms', 'in-out-blue-grey', 'header-wizard', 'calculs-alt', 'fan-lvl1', 'fan-lvl2', 'email', 'opened-email', 'validation-email-success', 'validation-email',
		'trend-down-orange', 'trend-up-orange', 'threshold-down-orange', 'threshold-up-orange', 'el-ng', 'el-vl', 'el-ys', 'el-af', 'air-particles-orange', 'air-particles-red', 'header-mesures', 'calculs', 'fan-lvl3', 'fan-lvl4', 'send-email', 'opened-email-doc', 'validation-email-error', 'validation-email-error-alt',
		"ody-brome", "ody-compteur", "ody-turbidite", "ody-ozone", "ody-ph", "ody-sound", "ody-redox", "ody-chlore", "ody-niveau_bas", "ody-debit_eau", "ody-humidite", "ody-niveau", "ody-commande_produit", "ody-durete", "ody-consommation", "ody-niveau_haut", "ody-unknown1", "ody-icon", "ody-generic",
		"ody-temperature", "ody-shower", "ody-icon_orange", "ody-icon_turquoise", "ody-blue_dark", "ody-blue", "ody-purple", "ody-brown", "ody-seablue", "ody-green", "ody-red", "ody-concentration", "ody-tour",  "ody-tank1", "ody-heat", "ody-conductivity", "odyv2-amp","odyv2-rendement",
		"odyv2-alcalinite","odyv2-ozone", "odyv2-phosphate", "odyv2-brome", "odyv2-chlore", "odyv2-durete", "odyv2-amine_sulfite", "odyv2-base", "odyv2-collaborateur", "odyv2-temps-prod", "odyv2-legionnelose", "odyv2-innovation", "odyv2-target",  "odyv2-dysfunction", "odyv2-perf_high", "odyv2-perf_low", "odyv2-reduction-conso","",
		"odyv2-mes-voltage", "odyv2-mes-resistivite", "odyv2-mes-watt", "odyv2-mes-conductivite", "odyv2-mes-ozone", "odyv2-mes-bar", "odyv2-mes-ph", "odyv2-formation", "odyv2-circuit_froid", "odyv2-ecs", "odyv2-chauffage", "odyv2-circuitvapeur", "odyv2-service",  "odyv2-courant", "odyv2-corrosion", "odyv2-prevention", "odyv2-ecology","odyv2-desembouage"
	];

	/** @type {string{}} */
	this.indicatorDimensions = {
		"1:1" : "1:1",
		"1:2" : "1:2",
		"1:3" : "1:3",
		"2:1" : "2:1",
		"2:2" : "2:2",
		"2:3" : "2:3",
		"3:1" : "3:1",
		"3:2" : "3:2",
		"3:3" : "3:3",
		"4:1" : "4:1",
		"4:2" : "4:2",
		"4:3" : "4:3",
		"full_width" : "full_width"
	};

	// ---   session data holders
	/** @type {G.vo.User} */
	this.user = null;
	this.userApiKey = null;

	// ---   navigation & states
	this.initSectionId = null;
	/** @type {G.vo.Section} */
	this.sectionSelected = null;
	this.initSiteId = null;
	/** @type {G.vo.Site} */
	this.siteSelected = null;
	this.context = {};

	// ---   xhr
	this.xhr = null;

	// ---	 state
	this.state = G.state.frontend;

	this.parse = function ({lang, userApiKey, state = G.state.frontend}) {
		let logStr, instance, i, ilen;
		let self = this;

		logStr = '[G.vo.Model.parse]';

		// --- state
		this.state = state;

		// --- theme
		this.theme = document.body.getAttribute('data-theme');
		if (!this.theme)
			this.theme = 'globalvisio';
		logStr += '\n\t - theme: ' + this.theme;

		// --- user
		this.userApiKey = userApiKey;
		this.lang = lang;
		this.setLang(lang);
		$.ajax({
			url: `/apigv/profile/whoami`,
			type: "GET",
			headers: {
				"Content-Type": "application/json",
				"Authorization": "Bearer "+self.userApiKey
			},
			datatype: 'json',
			async: false,
			error: function (xhr, textStatus, errorThrown) {
				showError(G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
			},
			success: function (data) {
				if(data?.status === 'success') {
					self.user = new G.vo.User(data.response.user);
				}
			}
		});

		// --- initSiteId for backend mode
		if(this.state === G.state.backend && typeof this.initSiteId !== "undefined" && this.initSiteId !== null) {
			this.siteSelected = this.getSite(this.initSiteId);
		}

		this.sections = [
			new G.vo.Section({
				id: 'dashboardAssets',
				isAssets: true,
				conditionAccessible: function() {
					return true;
				}
			}),
			new G.vo.Section({
				id: 'reportAssets',
				isAssets: true,
				conditionAccessible: function() {
					return !self.user.isDemo;
				}
			}),
            new G.vo.Section({
                id: 'monitoringparkv2',
                isAssets: true,
                conditionAccessible: function() {
                    return true;
                }
            }),
			new G.vo.Section({
				id: 'dashboard',
				isAssets: false,
				conditionAccessible: function() {
					return true;
				}
			}),
			new G.vo.Section({
				id: 'dashboardPage',
				isAssets: false,
				conditionAccessible: function() {
					return self.siteSelected && self.siteSelected.dashboardPages && self.siteSelected.dashboardPages.length >= 1;
				}
			}),
			new G.vo.Section({
				id: 'alerts',
				isAssets: false,
				convert: 'alertsAssets',
				conditionAccessible: function() {
					return self.siteSelected && !self.siteSelected.hideAlertSection;
				}
			}),
			new G.vo.Section({
				id: 'exploitation',
				isAssets: false,
				conditionAccessible: function() {
					return self.siteSelected && self.siteSelected.synoptiques && self.siteSelected.synoptiques.length >= 1;
				}
			}),
			new G.vo.Section({
				id: 'data',
				isAssets: false,
				conditionAccessible: function() {
					return true;
				}
			}),
			new G.vo.Section({
				id: 'consumption',
				isAssets: false,
				conditionAccessible: function() {
					return self.siteSelected && !!self.siteSelected.consommation;
				}
			}),
			new G.vo.Section({
				id: 'consoDetail',
				isAssets: false,
				conditionAccessible: function() {
					return self.siteSelected && !!self.siteSelected.consoDetail;
				}
			}),
			new G.vo.Section({
				id: 'documents',
				isAssets: false,
				convert: 'documentsAssets',
				conditionAccessible: function() {
					return true;
				}
			}),
			new G.vo.Section({
				id: 'siteSettings',
				isAssets: false,
				conditionAccessible: function() {
					return true;
				}
			}),
			new G.vo.Section({
				id: 'showMonitoringTable',
				isAssets: false,
				conditionAccessible: function() {
					return self.siteSelected && !!self.siteSelected.showMonitoringTable;
				}
			})
		];
		this.sectionsPrestations = [
			new G.vo.Section({
				id: 'prestationAssets',
				isAssets: true,
				convert: 'prestation',
				conditionAccessible: function() {
					return true;
				}
			}),
			new G.vo.Section({
				id: 'historyPrestationAssets',
				isAssets: true,
				convert: 'historyPrestation',
				conditionAccessible: function() {
					return true;
				}
			}),
			new G.vo.Section({
				id: 'siteSettings',
				isAssets: false,
				conditionAccessible: function() {
					return true;
				}
			}),
			new G.vo.Section({
				id: 'prestation',
				isAssets: false,
				convert: 'prestationAssets',
				conditionAccessible: function() {
					return true;
				}
			}),
			new G.vo.Section({
				id: 'historyPrestation',
				isAssets: false,
				convert: 'historyPrestationAssets',
				conditionAccessible: function() {
					return true;
				}
			}),
			new G.vo.Section({
				id: 'interventionStatisticsAssets',
				isAssets: true,
				conditionAccessible: function() {
					return true;
				}
			})
		];

		if(this.user?.groupe?.nom == 'admin-prestation' || this.user?.groupe?.nom == 'prestation'){
			// --- sections
			for (i = 0, ilen = this.sectionsPrestations.length; i < ilen; ++i)
				this.sectionsMap[this.sectionsPrestations[i].id] = this.sectionsPrestations[i];

		} else {
			// --- sections
			for (i = 0, ilen = this.sections.length; i < ilen; ++i)
				this.sectionsMap[this.sections[i].id] = this.sections[i];

		}

		if(this.user?.groupe?.nom == 'admin-prestation' || this.user?.groupe?.nom == 'prestation'){
			this.initSectionId = 'prestationAssets';
			// --- initial state
			this.sectionSelected = (this.initSectionId != null) ? this.sectionsMap[this.initSectionId] : this.sectionsMap[0];

		} else {
			// --- initial state
			this.sectionSelected = (this.initSectionId != null) ? this.sectionsMap[this.initSectionId] : this.sections[0];

		}

		if (this.user != null) {
			logStr += '\n\t - user: ' + this.user.id + ' | sections: ' + this.sections.length;
			logStr += '\n\t - initial navigation settings | section: "' + this.initSectionId + '"';
			logStr += '\n\t - current navigation settings | section: "' + (this.sectionSelected ? this.sectionSelected.id : '-') + '"';
		}
		G.LOG(G.log.model, logStr);

		if(typeof $ === "function") $(document).trigger($.Event('modelReady'));
		else document.dispatchEvent(new Event('modelReady'));

		if(this.state === G.state.frontend) {
			this.initHash();
		}
	};

	this.getSection = function (id) {
		return this.sectionsMap.hasOwnProperty(id) ? this.sectionsMap[id] : this.sections[0];
	};
	this.getSite = function (id, silent) {
		if (!isdefined(id))
			return null;

		let site = null;
		$.ajax({
			url: `/apigv/sites/infos/${id}`,
			type: "GET",
			headers: {
				"Content-Type": "application/json",
				"Authorization": "Bearer "+G.model.userApiKey
			},
			datatype: 'json',
			async: false,
			error: function (xhr, textStatus, errorThrown) {
				if(!silent) showError(G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
				return null;
			},
			success: function (data) {
				if(data?.status === 'success') {
					site = new G.vo.Site(data.response.site);
				}
			}
		});

		return site;
	};
	this.handleChanges = function (newHash) {
		var hashTokens, siteId, s = this;
		// --- Isole la route du paramètre d'onglet ---
		// Le système d'onglets (section-tabs.js) stocke l'onglet actif dans le fragment
		// sous la forme "#route?tab=uuid". Ici, handleChanges ne doit router que sur la
		// route pure ("route") : on retire donc tout ce qui suit le premier "?".
		// Sans ça, newHash vaudrait "route?tab=uuid", que le routeur ne reconnaîtrait pas.
		// La partie "?tab=..." est gérée séparément par SectionTabs, pas par le routeur.
		var hashQueryIndex = newHash.indexOf('?');
		if (hashQueryIndex !== -1) {
			newHash = newHash.substring(0, hashQueryIndex);
		}

		if(newHash === "graphique-save"){
			return true;
		}
		if(newHash === "" && window.location.href.split('#').length > 1){
			return true;
		}
		if(this.state === G.state.backend) {
			return true;
		}


		// --- avoid hash evaluation for "external" pages
		if (window.location.pathname.lastIndexOf(G.config.REDIRECT_PATTERN) !== window.location.pathname.length - G.config.REDIRECT_PATTERN.length)
			return;

		// --- browse hash
		hashTokens = newHash.split('/');
		if(this.user?.groupe?.nom === 'admin-prestation' || this.user?.groupe?.nom === 'prestation'){
			this.initSectionId = hashTokens.shift() || 'prestationAssets';

		} else {
			this.initSectionId = hashTokens.shift() || 'dashboardAssets';
		}

		this.sectionSelected = this.getSection(this.initSectionId);

		this.context = {};
		for (var i = 0, ilen = hashTokens.length, subTokens, prop, value; i < ilen; ++i) {
			subTokens = hashTokens[i].split('-');
			prop = subTokens[0];
			value = subTokens.splice(1).join('-');
			if (prop == 'site') {
				siteId = value;
			}
			else if (prop != '')
				this.context[prop] = value;
		}

		if(typeof(siteId) === "undefined" || siteId == null) {
			this.siteSelected = null;
		}
		else if(this.siteSelected?.id != siteId) {
			this.siteSelected = this.getSite(siteId, true);
		}
		else {
			this.siteSelected = this.siteSelected;
		}

		if(!this.sectionSelected.conditionAccessible()) {
			let siteIdToRedirect = exists(this.siteSelected) ? this.siteSelected.id : null;

			let sectionIdToRedirect = ["admin-prestation", "prestation"].includes(this.user?.groupe?.nom)
				? (siteIdToRedirect ? "prestation" : "prestationAssets")
				: (siteIdToRedirect ? "dashboard" : "dashboardAssets");

			this.setLocation(sectionIdToRedirect, siteIdToRedirect);
			return;
		}

		$('#hiddenSiteId').val(this.siteSelected ? this.siteSelected.id : '');

		if(this.xhr) this.xhr.abort(); // si une requête frontend en cours alors on l'annule

		this.xhr = $.ajax({
			url: "/frontend/load/" + this.sectionSelected.id.toLowerCase(),
			type: 'POST',
			data: {
				'idSite': siteId,
				'context': this.context
			},
			error: function (xhr, textStatus, errorThrown) {
				G.ui.fatalError("ajax error: " + textStatus, { url: this.url, error: errorThrown });
			},
			beforeSend: function () {
				$('#o-wrapper').empty();
				$('#set-location-preloader').toggle(true);
			},
			error: function (e) {
				console.log('[SET_LOCATION]', e);
			},
			success: function (data) {
				$('#set-location-preloader').toggle(false);
				if (exists(data.error)) {
					if (siteId != null && siteId !== '') {
						window.location.href = G.config.SITE_PATH + 'backend/index/error403';
					}
					else {
						showError(data.error);
					}
					return false;
				}

				$('#o-wrapper').html(data);

				var title = [];
				if (s.sectionSelected)
					title.push(G.config.LOCALE_RETRIEVE('sections.' + s.sectionSelected.id));
				if (s.siteSelected)
					title.push(s.siteSelected.nom + ', ' + s.siteSelected.ville);
				else
					title.push(G.config.LOCALE_RETRIEVE('hud.allAssetsLabel'));
				if(G.model.theme == "odyssee"){
					title.push('Odysecure');
				} else {
					title.push('Globalvisio');
				}
				window.document.title = title.join(' | ');

				$(window).trigger('model.locationChanged');
			}
		});
	};
	this.getHash = function (sectionId, siteId, context, groupe) {
		var hash, s;

		if (siteId === undefined) {
			siteId = this.siteSelected ? this.siteSelected.id : null;
		}

		if (sectionId === undefined) {
			if ((this.siteSelected == null) === (siteId == null))
				sectionId = this.sectionSelected.id;
			else
				sectionId = this.sectionSelected.convert;
		}
		else{
			if( groupe == "admin-prestation" || groupe == "prestation" ){
				s = this.sectionsMapPrestations[sectionId];
			} else {
				s = this.sectionsMap[sectionId];

			}
			if(s && (siteId != null) === s.isAssets)
				sectionId = s.convert;
		}

		hash = sectionId;
		if (siteId)
			hash += '/site-' + siteId;
		if (context) {
			for (var prop in context)
				hash += '/' + prop + '-' + context[prop];
		}
		return hash;
	};
	this.setLocation = function (sectionId, siteId, context) {
		var hash, logStr;
		hash = this.getHash(sectionId, siteId, context, this.user.groupe);

		logStr = '';
		logStr += '#################################################################################';
		logStr += '\n\t\t setLocation';
		logStr += '\n#################################################################################';
		logStr += '\n\t - sectionId:' + sectionId;
		logStr += '\n\t - siteId:' + siteId;
		logStr += '\n\t - context:' + context;
		logStr += '\n\t - hash:' + hash;
		logStr += '\n#################################################################################';
		console.log(logStr);

		if (window.location.toString().indexOf(G.config.SECTION_BASE_URL) !== 0)
			window.location = G.config.SECTION_BASE_URL + '#' + hash;
		else
			hasher.setHash(hash);
	};
	this.setSection = function (sectionId) {
		this.setLocation(sectionId, this.siteSelected ? this.siteSelected.id : null);
	};
	this.setSite = function (siteId) {
		this.setLocation(this.sectionSelected.id, siteId);
	};

	this.initHash = function(){
		hasher.prependHash = '';
		hasher.changed.add(this.handleChanges.bind(this));
		hasher.initialized.add(this.handleChanges.bind(this));
		hasher.init();
	}
};


// ############################ SOCKET.IO
if (!isdefined(G.socket)) {
	G.vo.Socket = function () {
		this.connected = false;
		this.responses = {};
		this.socket = undefined;
	};
	G.vo.Socket.prototype.kill = function () {
		this.connected = false;
		if (this.socket) {
			for (var name in this.responses) {
				this.socket.off(name);
			}
			this.socket.off('connect');
			this.socket.off('connect_failed');
			this.socket.off('connect_error');
			this.socket.off('error');
			this.socket.off('disconnect');

			this.socket.disconnect();
			this.socket.close();
		}
	};
	G.vo.Socket.prototype.addResponse = function (name, callback) {
		if (this.connected) {
			if (this.responses[name]) {
				this.socket.off(name);
			}
			this.socket.on(name, callback);
		}
		this.responses[name] = callback;
	};
	G.vo.Socket.prototype.removeResponse = function (name) {
		if (this.responses[name] !== undefined) {
			if (this.connected)
				this.socket.off(name, this.responses[name]);
			delete this.responses[name];
		}
	};
	G.vo.Socket.prototype.connect = function () {
		var instance = this;

		if (this.socket && this.connected)
			return;

		this.socket = io.connect('https://v2.global-visio.com:24444', {
			'connect timeout': 5000,
			'reconnect': true,
			'reconnection delay': 2000,
			'max reconnection attempts': 3,
			'force new connection': true
		});

		for (var name in this.responses) {
			this.socket.on(name, this.responses[name]);
		}

		this.socket.on('connect', function () {
			instance.connected = true;
			instance.socket.emit('keepalive', 'true');
			for (var name in instance.responses)
				instance.socket.on(name, instance.responses[name]);
		});

		this.socket.on('connect_failed', function () {
			showError('Service indisponible', { log: 'socket.connect_failed' });
			instance.kill();
		});

		this.socket.on('connect_error', function () {
			showError('Service indisponible', { log: 'socket.connect_error' });
			instance.kill();
		});

		this.socket.on('error', function () {
			showError('Error', { log: 'socket.error' });
			instance.kill();
		});

		this.socket.on('disconnect', function () {
		});
	};
	G.socket = new G.vo.Socket();
}

if (!isdefined(G.socketDevio2)) {
	G.vo.SocketDevio2 = function () {
		this.connected = false;
		this.responses = {};
		this.socketdevio2 = undefined;
	};
	G.vo.SocketDevio2.prototype.kill = function () {
		this.connected = false;
		if (this.socketdevio2) {
			for (var name in this.responses) {
				this.socketdevio2.off(name);
			}
			this.socketdevio2.off('connect');
			this.socketdevio2.off('connect_failed');
			this.socketdevio2.off('connect_error');
			this.socketdevio2.off('error');
			this.socketdevio2.off('disconnect');

			this.socketdevio2.disconnect();
			this.socketdevio2.close();
		}
	};
	G.vo.SocketDevio2.prototype.addResponse = function (name, callback) {
		if (this.connected) {
			if (this.responses[name]) {
				this.socketdevio2.off(name);
			}
			this.socketdevio2.on(name, callback);
		}
		this.responses[name] = callback;
	};
	G.vo.SocketDevio2.prototype.removeResponse = function (name) {
		if (this.responses[name] !== undefined) {
			if (this.connected)
				this.socketdevio2.off(name, this.responses[name]);
			delete this.responses[name];
		}
	};
	G.vo.SocketDevio2.prototype.connect = function () {
		var instance = this;

		if (this.socketdevio2 && this.connected)
			return;

		this.socketdevio2 = io.connect('https://v2.global-visio.com:24442', {
			'connect timeout': 5000,
			'reconnect': true,
			'reconnection delay': 2000,
			'max reconnection attempts': 3,
			'force new connection': true
		});

		for (var name in this.responses) {
			this.socketdevio2.on(name, this.responses[name]);
		}

		this.socketdevio2.on('connect', function () {
			instance.connected = true;
			instance.socketdevio2.emit('keepalive', 'true');
			for (var name in instance.responses)
				instance.socketdevio2.on(name, instance.responses[name]);
		});

		this.socketdevio2.on('connect_failed', function () {
			showError('Service indisponible', { log: 'socketdevio2.connect_failed' });
			instance.kill();
		});

		this.socketdevio2.on('connect_error', function () {
			showError('Service indisponible', { log: 'socketdevio2.connect_error' });
			instance.kill();
		});

		this.socketdevio2.on('error', function () {
			showError('Error', { log: 'socketdevio2.error' });
			instance.kill();
		});

		this.socketdevio2.on('disconnect', function () {
		});
	};
	G.socketdevio2 = new G.vo.SocketDevio2();
}

if (!isdefined(G.socketDevio3)) {
	G.vo.SocketDevio3 = function () {
		this.connected = false;
		this.responses = {};
		this.socketdevio3 = undefined;
	};
	G.vo.SocketDevio3.prototype.kill = function () {
		this.connected = false;
		if (this.socketdevio3) {
			for (var name in this.responses) {
				this.socketdevio3.off(name);
			}
			this.socketdevio3.off('connect');
			this.socketdevio3.off('connect_failed');
			this.socketdevio3.off('connect_error');
			this.socketdevio3.off('error');
			this.socketdevio3.off('disconnect');

			this.socketdevio3.disconnect();
			this.socketdevio3.close();
		}
	};
	G.vo.SocketDevio3.prototype.addResponse = function (name, callback) {
		if (this.connected) {
			if (this.responses[name]) {
				this.socketdevio3.off(name);
			}
			this.socketdevio3.on(name, callback);
		}
		this.responses[name] = callback;
	};
	G.vo.SocketDevio3.prototype.removeResponse = function (name) {
		if (this.responses[name] !== undefined) {
			if (this.connected)
				this.socketdevio3.off(name, this.responses[name]);
			delete this.responses[name];
		}
	};
	G.vo.SocketDevio3.prototype.connect = function () {
		var instance = this;

		if (this.socketdevio3 && this.connected)
			return;

		this.socketdevio3 = io.connect('https://v2.global-visio.com:24443', {
			'connect timeout': 5000,
			'reconnect': true,
			'reconnection delay': 2000,
			'max reconnection attempts': 3,
			'force new connection': true
		});

		for (var name in this.responses) {
			this.socketdevio3.on(name, this.responses[name]);
		}

		this.socketdevio3.on('connect', function () {
			instance.connected = true;
			instance.socketdevio3.emit('keepalive', 'true');
			for (var name in instance.responses)
				instance.socketdevio3.on(name, instance.responses[name]);
		});

		this.socketdevio3.on('connect_failed', function () {
			showError('Service indisponible', { log: 'socketdevio3.connect_failed' });
			instance.kill();
		});

		this.socketdevio3.on('connect_error', function () {
			showError('Service indisponible', { log: 'socketdevio3.connect_error' });
			instance.kill();
		});

		this.socketdevio3.on('error', function () {
			showError('Error', { log: 'socketdevio3.error' });
			instance.kill();
		});

		this.socketdevio3.on('disconnect', function () {
		});
	};
	G.socketdevio3 = new G.vo.SocketDevio3();
}

if (!isdefined(G.socketgio)) {
	G.vo.SocketGio = function () {
		this.connected = false;
		this.responses = {};
		this.socketgio = undefined;
	};
	G.vo.SocketGio.prototype.kill = function () {
		this.connected = false;
		if (this.socketgio) {
			for (var name in this.responses) {
				this.socketgio.off(name);
			}
			this.socketgio.off('connect');
			this.socketgio.off('connect_failed');
			this.socketgio.off('connect_error');
			this.socketgio.off('error');
			this.socketgio.off('disconnect');

			this.socketgio.disconnect();
			this.socketgio.close();
		}
	};
	G.vo.SocketGio.prototype.addResponse = function (name, callback) {
		if (this.connected) {
			if (this.responses[name]) {
				this.socketgio.off(name);
			}
			this.socketgio.on(name, callback);
		}
		this.responses[name] = callback;
	};
	G.vo.SocketGio.prototype.removeResponse = function (name) {
		if (this.responses[name] !== undefined) {
			if (this.connected)
				this.socketgio.off(name, this.responses[name]);
			delete this.responses[name];
		}
	};
	G.vo.SocketGio.prototype.connect = function () {
		var name, instance = this;

		if (this.socketgio && this.connected)
			return;

		this.socketgio = io.connect('https://io-02.global-visio.com:22443', {
			'transports': ['websocket'],
			'connect timeout': 5000,
			'reconnect': true,
			'reconnection delay': 2000,
			'max reconnection attempts': 3,
			'force new connection': true
		});

		for (name in this.responses) {
			this.socketgio.on(name, this.responses[name]);
		}

		this.socketgio.on('connect', function () {
			var name;

			instance.connected = true;
			instance.socketgio.emit('keepalive', 'true');
			for (name in instance.responses)
				instance.socketgio.off(name, instance.responses[name]);
			for (name in instance.responses)
				instance.socketgio.on(name, instance.responses[name]);
		});

		this.socketgio.on('connect_failed', function () {
			showError('Service indisponible');
			instance.kill();
		});

		this.socketgio.on('connect_error', function () {
			showError('Service indisponible');
			instance.kill();
		});

		this.socketgio.on('error', function () {
			showError('Erreur');
			instance.kill();
		});

		this.socketgio.on('disconnect', function () {
			showInfo('Déconnecté');
		});
	};
	G.socketgio = new G.vo.SocketGio();
	G.lockConnection = false;
}


// ############################ MODEL
if (!isdefined(G.model)) {
	/** @type {G.vo.Model} */
	G.model = new G.vo.Model();
}

var HCH;

if (!exists(HCH)) {
	HCH = {};

	// #############################################################################################
	//		CONSTANTS
	// #############################################################################################

	HCH.CLASS_CONTAINER = 'hch-container';
	HCH.INDICATOR_CLASS_CONTAINER = 'hch-container-indicator';
	HCH.CLASS_PRELOADER = 'hch-preloader';
	HCH.CLASS_CHART = 'hch-graph';
	HCH.CLASS_CAPTION = 'hch-caption';
	HCH.CLASS_INLINE_CAPTION = 'status--inline-caption';

	HCH.CLASS_STYLEDCHART = 'highchart-styledmode';
	HCH.CLASS_DEFAULTCHART = 'hch-default-colors';
	HCH.CLASS_GVCHART = 'hch-system-colors';
	HCH.CLASS_ODYCHART = 'hch-ody-colors';

	HCH.VERBOSE = false;

	HCH.CHART_DATA_LOADED = 'CHART_DATA_LOADED';
	HCH.NOTE_TYPES = ['info', 'check', 'question', 'warning', 'error'];
	HCH.SERIES_TYPE_TOOLTIP_PRIORITY_ORDER  = [
		"column",
		"bar",
		"advanced_bar",
		"line",
		"advanced_line",
		"area",
		"advanced_area",
		"areaspline",
		"scatter",
		"spline",
		"advanced_spline",
		"arearange",
		"advanced_arearange",
		"areasplinerange",
		"pie",
		"gauge",
		"heatmap",
        "sankey"
	];

	for(var j = 0, c; j < 10; ++j){
		c = new Highcharts.Color(G.clr.ODY_ENUM.alarmSystem).brighten((j - 3) / 7).get();
		G.clr.ODY_ENUM['Water' + j] = c;
		G.clr.ODY_ARR.push(c);
	}

	HCH.NOTES_SHOW_CONTEXT = false;
	HCH.NOTES_SIZE = 28;

	// --- print highchart series specification for colors
	var
		arr, i, ilen,
		printColor = function(chartStyle, arr, i){
			return '.' + chartStyle + ' .highcharts-color-' + i + '{fill: ' + arr[i] + ' ; stroke: ' + arr[i] + ';}' + '\r\n'
				+ '.' + chartStyle + ' .highcharts-color-' + i + ' .highcharts-axis-line {stroke: ' + arr[i] + ';}' + '\r\n'
				+ '.' + chartStyle + ' .highcharts-color-' + i + ' .highcharts-axis-title {color: ' + arr[i] + ';}' + '\r\n'
				+ '.' + chartStyle + ' .highcharts-color-' + i + '.highcharts-yaxis-labels {fill: ' + arr[i] + ';}' + '\r\n'
				;
		},
		styleStr = '<style>';

	// default colors
	for (arr = G.clr.GV_ARR, i = 0, ilen = arr.length; i < ilen; ++i)
		styleStr += printColor(HCH.CLASS_DEFAULTCHART, arr, i);

	// odysecure colors
	for (arr = G.clr.ODY_ARR, i = 0, ilen = arr.length; i < ilen; ++i)
		styleStr += printColor(HCH.CLASS_ODYCHART, arr, i);

	styleStr += '</style>';
	$(styleStr).appendTo($('head'));



	// #############################################################################################
	//		CONFIGURATIONS
	// #############################################################################################


	HCH.initHighcharts = function(){
		var loc = G.config.LOCALE_RETRIEVE;

		Highcharts.setOptions({
			global: {
				useUTC: false
			},
			lang: loc('highchart')
		});

		Highcharts.seriesType('lowmedhigh', 'boxplot', {
			keys: ['date','low', 'median', 'high'],
			tooltip: {
					pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: ' +
						'Low <b>{point.low}</b> - Median <b>{point.median}</b> - High <b>{point.high}</b><br/>'
				}
			}, {
			// Change point shape to a line with three crossing lines for low/median/high
			// Stroke width is hardcoded to 1 for simplicity
			drawPoints: function () {
				var series = this;
				this.points.forEach(function (point) {
					var graphic = point.graphic,
						verb = graphic ? 'animate' : 'attr',
						shapeArgs = point.shapeArgs,
						width = shapeArgs.width,
						left = Math.floor(shapeArgs.x) + 0.5,
						right = left + width,
						crispX = left + Math.round(width / 2) + 0.5,
						highPlot = Math.floor(point.highPlot) + 0.5,
						medianPlot = Math.floor(point.medianPlot) + 0.5,
						// Sneakily draw low marker even if 0
						lowPlot = Math.floor(point.lowPlot) +
							0.5 - (point.low === 0 ? 1 : 0);
		
					if (point.isNull) {
						return;
					}
		
					if (!graphic) {
						point.graphic = graphic = series.chart.renderer.path('point').add(series.group);
					}
		
					graphic.attr({
						stroke: point.color || series.color,
						"stroke-width": 2
					});
		
					graphic[verb]({
						d: [
							'M', left, highPlot,
							'H', right,
							'M', left, medianPlot,
							'H', right,
							'M', left, lowPlot,
							'H', right,
							'M', crispX, highPlot,
							'V', lowPlot
						]
					});
				});
			}
		});

		/** basic configuration for all highcharts instances */
		HCH.ConfigCore = {
			chart: {
				animation: false,
				className: [HCH.CLASS_STYLEDCHART, HCH.CLASS_DEFAULTCHART].join(' '),
				colorCount: G.clr.GV_ARR.length,
				zoomType: 'x',
				zooming: {
					mouseWheel : {
						enabled: false
					}
				},
				accessibility:{ 'enabled': false},
				events: {
					selection: function() {
						this.reflow();
					}
				},
				resetZoomButton: {
					position: {
						x: -6,
						y: 6
					}
				},
				spacing: [20, 10, 10, 20],
				styledMode: true
			},
			accessibility:{ 'enabled': false},
			defs: {
				hatchRed: {
					tagName: 'pattern',
					id: 'hatch-red',
					patternUnits: 'userSpaceOnUse',
					width: 4,
					height: 4,
					children: [{
						tagName: 'path',
						d: 'M-1,1 l2,-2 M0,4 l4,-4 M3,5 l2,-2'
					}]
				},
				hatchOrange: {
					tagName: 'pattern',
					id: 'hatch-orange',
					patternUnits: 'userSpaceOnUse',
					width: 4,
					height: 4,
					children: [{
						tagName: 'path',
						d: 'M-1,1 l2,-2 M0,4 l4,-4 M3,5 l2,-2'
					}]
				}
			},
			exporting: {
				enabled: true,
				buttons: {
					contextButton: {
						menuItems: ['printChart', 'separator', 'downloadPNG', 'downloadSVG', 'downloadCSV', 'downloadXLS']
					}
				}
			},
			title: {
				text: '',
				align: 'left'
			},
			subtitle: {
				text: '',
				align: 'left'
			},
			legend: {
				enabled: true,
				title: '',
				align: 'left',
				layout: 'horizontal', // horizontal|vertical|proximate
				verticalAlign: 'bottom',
				labelFormatter: function () {
					return this.name;
				},
				useHTML: true
			},
			navigation: {
				buttonOptions: {
					verticalAlign: 'top',
					x: -6,
					y: -20
				}
			},
			plotOptions: {
				series: {
					animation: false
				},
				line: {
					turboThreshold: 0
				}
			},
			tooltip: {
				animation: false,
				shared: true,
				crosshairs: true,
				padding: 0,
				hideDelay: 150,
				formatter: function () {
					var
						nf = Highcharts.numberFormat,
						nfSmart = HCH.nfSmart,
						df = Highcharts.dateFormat,
						s = '';

					if(this.point && ['scatter', 'pie'].includes(this.series.type)){
						this.points = [this.point];
					}

					if(this.points && isarray(this.points)){
						var d = new Date(this.x);
						var total = 0;

						this.points.sort(function(a, b) {
							var serieTypeA = HCH.SERIES_TYPE_TOOLTIP_PRIORITY_ORDER.indexOf(a.series.type);
							var serieTypeB = HCH.SERIES_TYPE_TOOLTIP_PRIORITY_ORDER.indexOf(b.series.type);

							if (serieTypeA < serieTypeB) return -1;
							else if (serieTypeA > serieTypeB) return 1;
							else return 0;
						});

						//display month + year
						if(this.points[0].series.userOptions.type == "pie") {}
						else if(this.points[0].series.userOptions.type == "bar") {}
						else if(this.points[0].series.userOptions.tooltipPeriod == 'month'){
							s += '<div class="tooltip-title">' + df('%B %Y', new Date(this.x)) + '</div>';
						} else if(d.getFullYear() != 1970){
							//not display hour and minute if midnight
							if(df('%H:%M', new Date(this.x)) == '00:00' ){
								s += '<div class="tooltip-title">' + df('%A, %d/%m/%Y', new Date(this.x)) + '</div>';

							} else {
								s += '<div class="tooltip-title">' + df('%A, %d/%m/%Y %H:%M', new Date(this.x)) + '</div>';

							}

						} else {
							var d = new Date(this.points[0].point.options.date);
							if(d.getFullYear() != 1970){
								//not display hour and minute if midnight
								if(df('%H:%M', new Date(this.x)) == '00:00' ){
									s += '<div class="tooltip-title">' + df('%A, %d/%m/%Y', new Date(this.points[0].point.options.date)) + '</div>';

								} else {
									s += '<div class="tooltip-title">' + df('%A, %d/%m/%Y %H:%M', new Date(this.points[0].point.options.date)) + '</div>';

								}
							} else {
								// specific display for kessel
								var kRescale = parseInt(this.x);
								var position = parseInt(this.x * 3.4);
								s += '<div class="tooltip-title">' + kRescale + ' cm | #'+position+'</div>';

							}

						}
						s += '<div class="tooltip-rows">';
						this.points.forEach(function (el, elIndex) {
							var
								classname = el.series.userOptions.className,
								options = el.series.tooltipOptions,
								serieType = el.series.userOptions.type,
								serieColorIndex = serieType == "pie" ? el.colorIndex : el.series.colorIndex
							;

							if (!isfilled(classname) || classname.indexOf('hidden-dataset') < 0) {
								var serieName = el.series.options.name;
								if(el.series.options.display == "equipement"){
									serieName = el.series.options.equipement;
								} else if(serieType == "pie") {
									serieName = el.name;
								}

								s += '<div class="tooltip-row">'
									+ '<div class="tooltip-row__label"><span class="bullet" style="background-color:' + G.clr.GV_ARR[serieColorIndex] + '"></span>' + serieName + '</div>'
									+ '<div class="tooltip-row__value">';
								if (options.hasOwnProperty('valuePrefix'))
									s += options.valuePrefix;

								if(serieType === 'lowmedhigh'){
									s += nfSmart(el.point.low, el.series.options.valueDecimals) + options.valueSuffix + ' - ' + nfSmart(el.point.median, el.series.options.valueDecimals) + options.valueSuffix + ' - ' + nfSmart(el.point.high, el.series.options.valueDecimals);
								}
								else if(serieType === 'pie') {
									s += nfSmart(el.y, el.valueDecimals);
								}
								else if(serieType !== 'arearange'){
									s += nfSmart(el.y, el.series.options.valueDecimals);
									if((serieType == 'column' || serieType == 'column_stack') && el.series.options.valueDecimals != ''){
										total += el.point.y;
									}
								}
								else{
									s += nfSmart(el.point.low, el.series.options.valueDecimals) + options.valueSuffix + ' - ' + nfSmart(el.point.high, el.series.options.valueDecimals);
								}
								
								if (exists(el.point) && exists(el.point.series) && el.point.series.tooltipOptions.hasOwnProperty('valueSuffix'))
									s += ' '+el.point.series.tooltipOptions.valueSuffix;
								else if (options.hasOwnProperty('valueSuffix'))
									s += ' '+options.valueSuffix;
								
								if(exists(el.point) && exists(el.point.z) && typeof(el.point.z) != 'undefined' && el.point.z != null )
									s += ' ('+el.point.z+')';

								s += '</div></div>';

								//Objet EVENT: premier et dernier evenement de la journee
								if(el.series.options.tooltipMode == 'event' && exists(el.point) && el.point.options.dateDebut){
									var labels = el.series.options.tooltipLabels || {};
									s += '<div class="tooltip-row">'
										+ '<div class="tooltip-row__label">' + (labels.dateDebut || '') + '</div>'
										+ '<div class="tooltip-row__value">' + df('%H:%M:%S', new Date(el.point.options.dateDebut)) + '</div></div>';
									s += '<div class="tooltip-row">'
										+ '<div class="tooltip-row__label">' + (labels.dateFin || '') + '</div>'
										+ '<div class="tooltip-row__value">' + df('%H:%M:%S', new Date(el.point.options.dateFin)) + '</div></div>';
								}
							}
						});

						if(this.points[0].series.userOptions.type == 'column' && this.points.length > 1){
							var strTotal =  (typeof(this.points[0].total) != 'undefined') ? this.points[0].total : total;
							if(strTotal != 0){
								s += '<div class="tooltip-footer"><span>Total: </span>'+nfSmart(strTotal, this.points[0].series.options.valueDecimals)+' '+this.points[0].series.tooltipOptions.valueSuffix+'</div>';
							}
						}
						s += '</div>';
					}
					else if(this.point && this.point.series.userOptions.id === 'notes'){
						var
							p = this.point,
							str
						;

						if(p['dtstart'] && p['dtend']){
							str = loc('general.fromTo');
							str = str.replace('{DATE_FROM}', df('%d/%m/%Y %H:%M', new Date(p['dtstart'])));
							str = str.replace('{DATE_TO}', df('%d/%m/%Y %H:%M', new Date(p['dtend'])));
						}
						else if(p['dtstart']){
							str = df('%d/%m/%Y %H:%M', new Date(p['dtstart']));
						}

						s += '<div class="tooltip-notes"><div class="tooltip-title">' + p.name + '</div><p class="tooltip-content"><p>' + p.content + '</p>';
						if(str)
							s += '<p class="tooltip-content__range">' + str + '</p></div>';
						s += '</div>';
					}
					else{
						return '';
					}

					return s;
				},
				useHTML: true
			},
			scrollbar: {
				enabled: false
			},
			navigator: {
				enabled: false
			},
			rangeSelector: {
				enabled: false
			},
			xAxis: {
				type: 'datetime',
				ordinal:false,
				showEmpty: true,
				title: {
					text: loc('zone.thead_date')
				},
				tickPixelInterval: 100,
				minPadding: 0,
				maxPadding: 0
			},
			yAxis: [],
			series: [],
			notes: []
		};

		/** basic configuration for printed highcharts instances */
		HCH.ConfigCorePrinted = Highcharts.merge(HCH.ConfigCore, {
			legend: {
				enabled: false
			}
		});

		/** basic configuration for printed highcharts instances */
		HCH.ConfigCorePrintedShowLegend = Highcharts.merge(HCH.ConfigCore, {
			legend: {
				enabled: true
			}
		});

		/** basic configuration for odysecure highcharts instances */
		HCH.ConfigOdysecureCore = Highcharts.merge(HCH.ConfigCore, {
			chart: {
				className: [HCH.CLASS_STYLEDCHART, HCH.CLASS_ODYCHART].join(' '),
				zooming: {
					mouseWheel : {
						enabled : false
					}
				}
			},
			tooltip: {
				formatter: function () {
					var s = '';

					s += '<div class="tooltip-title">' + Highcharts.dateFormat('%d/%m/%Y %H:%m', new Date(this.x)) + '</div>';
					s += '<div class="tooltip-rows">';
					this.points.forEach(function (el) {
						var
							classname = el.series.userOptions.className,
							options = el.series.tooltipOptions;

						if (!isfilled(classname) || classname.indexOf('hidden-dataset') < 0) {
							s += '<div class="tooltip-row">'
								+ '<div class="tooltip-row__label"><span class="bullet" style="background-color:' + G.clr.ODY_ARR[el.series.colorIndex] + '"></span>' + el.series.name + '</div>'
								+ '<div class="tooltip-row__value">';
							if (options.hasOwnProperty('valuePrefix'))
								s += options.valuePrefix;
							s += Highcharts.numberFormat(el.y, el.series.options.valueDecimals);
							if (options.hasOwnProperty('valueSuffix'))
								s += options.valueSuffix;
							s += '</div></div>';
						}
					});
					s += '</div>';
					return s;
				}
			}
		});

		/** basic configuration for highcharts instances of piechart */
		HCH.ConfigPieChartCore = {
			chart: {
				type: "pie",
				zoomType: undefined,
				animation: false,
				colorCount: G.clr.GV_ARR.length,
				accessibility:{ 'enabled': false },
				events: {
					selection: function() {
						this.reflow();
					}
				},
				spacing: [20, 10, 10, 20],
				className: [HCH.CLASS_STYLEDCHART, HCH.CLASS_DEFAULTCHART].join(' '),
				styledMode: true
			},
			accessibility:{ 'enabled': false },
			exporting: {
				enabled: true,
				buttons: {
					contextButton: {
						menuItems: ['printChart', 'separator', 'downloadPNG', 'downloadSVG', 'downloadCSV', 'downloadXLS']
					}
				}
			},
			title: {
				text: '',
				align: 'left'
			},
			subtitle: {
				text: '',
				align: 'left'
			},
			credits: {
				enabled: false
			},
			legend: {
				enabled: true,
				title: '',
				align: 'center',
				layout: 'horizontal', // horizontal|vertical|proximate
				verticalAlign: 'bottom',
				labelFormatter: function () {
					return this.name;
				},
				useHTML: true
			},
			plotOptions: {
				series: {
					animation: false,
					allowPointSelect: false,
					cursor: 'pointer'
				}
			},
			tooltip: {
				animation: false,
				padding: 0,
				hideDelay: 150,
				// tooltip rendu hors du SVG (ajouté au <body>) pour ne pas être tronqué sur les petits camemberts
				outside: true,
				// styledMode : tooltip.style est ignoré, la mise en forme passe par cette classe (cf. _hch.scss)
				className: 'hch-tooltip--wrap',
				formatter: function () {
					var
						options = this.series.tooltipOptions,
						str = '';

					str += '<div class="tooltip-rows">';
					str += '<div class="tooltip-row" >'
						+ '<div class="tooltip-row__label"><span class="bullet" style="background-color:' + G.clr.GV_ARR[this.point.colorIndex] + '"></span>' + this.point.name + '</div>'
						+ '<div class="tooltip-row__value">';

					if (options.hasOwnProperty('valuePrefix'))
						str += options.valuePrefix;

					str += this.point.y;

					if (options.hasOwnProperty('valueSuffix'))
						str += options.valueSuffix;

					str += '</div></div>';

					return str;
				},
				useHTML: true
			},
			series: []
		};

		/** basic configuration for highcharts instances of heatmap */
		HCH.ConfigHeatMapChartCore = {
			chart: {
				type: "heatmap",
				zoomType: undefined,
				zooming: {
					type: null,
					mouseWheel: {
						enabled: false
					},
					pinchType: null
				},
				animation: false,
				colorCount: G.clr.GV_ARR.length,
				accessibility:{ 'enabled': false },
				spacing: [20, 10, 10, 20],
				className: [HCH.CLASS_STYLEDCHART, HCH.CLASS_DEFAULTCHART].join(' '),
				styledMode: true
			},
			accessibility:{ 'enabled': false },
			credits: {
				enabled: false
			},
			scrollbar: {
				enabled: false
			},
			navigator: {
				enabled: false
			},
			rangeSelector: {
				enabled: false
			},
			exporting: {
				enabled: true,
				buttons: {
					contextButton: {
						menuItems: ['printChart', 'separator', 'downloadPNG', 'downloadSVG', 'downloadCSV', 'downloadXLS']
					}
				}
			},
			title: {
				text: '',
				align: 'left'
			},
			subtitle: {
				text: '',
				align: 'left'
			},
			colorAxis: {},
			legend: {
				align: 'right',
				layout: 'vertical',
				margin: 0,
				verticalAlign: 'top',
				y: 50,
				symbolHeight: 300
			},
			tooltip: {
				animation: false,
				padding: 0,
				hideDelay: 150
			},
			series: []
		};

        /** basic configuration for highcharts instances of sankey */
        HCH.ConfigSankeyChartCore = {
            chart: {
                type: "sankey",
                zoomType: undefined,
                zooming: {
                    type: null,
                    mouseWheel: {
                        enabled: false
                    },
                    pinchType: null
                },
                animation: false,
                colorCount: G.clr.GV_ARR.length,
                accessibility:{ 'enabled': false },
                spacing: [20, 10, 10, 20],
                className: [HCH.CLASS_STYLEDCHART, HCH.CLASS_DEFAULTCHART].join(' '),
                styledMode: true
            },
            accessibility:{ 'enabled': false },
            credits: {
                enabled: false
            },
            scrollbar: {
                enabled: false
            },
            navigator: {
                enabled: false
            },
            rangeSelector: {
                enabled: false
            },
            exporting: {
                enabled: true,
                buttons: {
                    contextButton: {
                        menuItems: ['printChart', 'separator', 'downloadPNG', 'downloadSVG', 'downloadCSV', 'downloadXLS']
                    }
                }
            },
            title: {
                text: '',
                align: 'left'
            },
            subtitle: {
                text: '',
                align: 'left'
            },
            tooltip: {
                animation: false,
                padding: 0,
                hideDelay: 150
            },
            plotOptions: {
                sankey: {
                    nodeWidth: 20,
                    curveFactor: 0.5,
                    minLinkWidth: 3,
                    borderColor: '#aaa',
                    dataLabels: {
                        enabled: true,
                        style: {
                            fontSize: '13px',
                            fontWeight: 'normal'
                        }
                    }
                }
            },
            series: []
        };
	};
	HCH.initHighcharts();



	// #############################################################################################
	//		LOADING & PARSING
	// #############################################################################################

	HCH.nfSmart = function(value, decimals){
		if (value === null || value === undefined || isNaN(value)) {
			return '';
		}
		// Arrondit d'abord au nombre max de décimales de la série
		const rounded = Number(Number(value).toFixed(decimals ?? 2));
		// -1 = décimales "naturelles" de la valeur (50 -> 50, 2.7 -> 2,7, 1.22 -> 1,22)
		return Highcharts.numberFormat(rounded, -1);
	};

	/**
	 * Checks whether JSON response is a valid dataset.
	 * @private
	 */
	HCH._checkJSONError = function (data) {
		if (typeof data !== "object") {
			if (data.substr(0, 4) === "$ERR") {
				showError(data.substr(4));
				return true;
			}
		}
		else if (exists(data.error) && data.status === 'error') {
			showError(data.error);
			return true;
		}
		return false;
	};

	/**
	 *   Build a consistent chart axis ID.
	 * @private
	 */
	HCH._getYAxisId = function (data) {
		if(exists(data?.custom_serie_yaxis?.id)) {
			return `ID_${data.custom_serie_yaxis.id}`;
		}
		else if(exists(data.custom_serie_yaxis?.title)){
			var yAxisTitle = data.custom_serie_yaxis.title;
			yAxisTitle = yAxisTitle.replace(' (', '_');
			yAxisTitle = yAxisTitle.replace(')', '');
			return data.yAxis || yAxisTitle.toLowerCase();
		}
		else {
			var tmpYAxis = data.type.toLowerCase();
			if(exists(data.unite) && data.unite != ''){
				tmpYAxis += '_' + data.unite.toLowerCase();
			}
			return data.yAxis || tmpYAxis;
		}
	};

	/**
	 * Retrieve the y-axis corresponding to the passed-in dataset (or create if none is found).
	 * @private
	 */
	HCH._getYAxis = function (containerEl, data) {
		var
			chart = HCH._getChart(containerEl),
			axis, title,
			options = {},
			optionsChangedFlag = false,
			searchedId = HCH._getYAxisId(data);

		if(data.typeGraphique == 'bar'){
			var title = '';
			if(exists(data.custom_serie_yaxis?.title)){
				title += data.custom_serie_yaxis.title;
			} else {
				if(isfilled(data.type))
					title += data.type;
			}

			if(isfilled(data.unite) && data.unite != ''  && !exists(data.custom_serie_yaxis?.title))
				title += ' (' + data.unite + ')';

			optionsAxis = {
				id: searchedId,
				min: 0,
				opposite: true,
				tickPixelInterval: 150,
				title: {
					text: title
				}
			};
			if(exists(data.custom_serie_yaxis?.scale?.min)){
				optionsAxis.min = data.custom_serie_yaxis.scale.min;
			}
			if(exists(data.custom_serie_yaxis?.scale?.max)){
				optionsAxis.max = data.custom_serie_yaxis.scale.max;
			}
			if(exists(data.custom_serie_yaxis?.axisSide)){
				if(data.custom_serie_yaxis.axisSide === "right") optionsAxis.opposite = true;
				else if(data.custom_serie_yaxis.axisSide === "left") optionsAxis.opposite = false;
			}
			axis = chart.addAxis(optionsAxis, false, false);
			return axis;
		}

		// search if an axis is already registered with this ID
		for (var i = 0, ilen = chart.yAxis.length; i < ilen; ++i) {
			if (chart.yAxis[i].options.id === HCH._getYAxisId(data)) {
				axis = chart.yAxis[i];
				break;
			}
		}
		
		// ... or create one if required
		if (!axis) {
			title = '';
			if(exists(data.custom_serie_yaxis?.title)){
				title += data.custom_serie_yaxis.title;
			}

			else {
				if(isfilled(data.type))
					title += data.type;
			}
			if(isfilled(data.unite) && data.unite != ''  && !exists(data.custom_serie_yaxis?.title))
				title += ' (' + data.unite + ')';

			optionsAxis = {
				id: searchedId,
				endOnTick: true,
				title: {
					text: title
				},
				labels: {
					format: '{value} ' + data.unite,
					distance: 0
				}
			};

			if(exists(data.custom_serie_yaxis)) {
				if(exists(data.custom_serie_yaxis?.scale?.min)){
					optionsAxis.min = data.custom_serie_yaxis.scale.min;
				}
				if(exists(data.custom_serie_yaxis?.scale?.max)){
					optionsAxis.max = data.custom_serie_yaxis.scale.max;
				}
				if(exists(data.custom_serie_yaxis?.axisSide)){
					if(data.custom_serie_yaxis.axisSide === "right") optionsAxis.opposite = true;
					else if(data.custom_serie_yaxis.axisSide === "left") optionsAxis.opposite = false;
				}
			}
			else {
				if(exists(data.opposite)){
					optionsAxis.opposite = data.opposite;
				}
				if(exists(data.min)){
					optionsAxis.min = data.min;
				}
				if(exists(data.max)){
					optionsAxis.max = data.max;
				}
			}

			if(exists(data.tickInterval)){
				optionsAxis.tickInterval = data.tickInterval;
				optionsAxis.labels = {'label': data.tickInterval};
			}

			axis = chart.addAxis(optionsAxis, false, false);
		}

		// ---	assign min/max options if defined
		if(exists(data.custom_serie_yaxis)) {
			if (exists(data.custom_serie_yaxis?.scale?.min) && (!isan(axis.min) || data.custom_serie_yaxis.scale.min < axis.min)) {
				optionsChangedFlag = true;
				options.min = data.custom_serie_yaxis.scale.min;
			}
			if (exists(data.custom_serie_yaxis?.scale?.max) && (!isan(axis.max) || data.custom_serie_yaxis.scale.max < axis.max)) {
				optionsChangedFlag = true;
				options.max = data.custom_serie_yaxis.scale.max;
			}
		}
		else {
			if (exists(data.min) && (!isan(axis.min) || data.min < axis.min)) {
				optionsChangedFlag = true;
				options.min = data.min;
			}

			if (exists(data.max) && (!isan(axis.max) || data.max > axis.max)) {
				optionsChangedFlag = true;
				options.max = data.max;
			}
		}

		if (optionsChangedFlag){
			if(HCH.VERBOSE)
				console.log('\t[HCH._getYAxis] Assign min/max: [' + options.min + ';' + options.max + '] to: ' + axis.id, axis);
			axis.update(options, false);
		}

		return axis;
	};

	/**
	 * Displays and logs loading errors.
	 * @private
	 */
	HCH._loadError = function (methodName, xhr, textStatus, errorThrown) {
		console.warn('[AJAX ERROR: HCH.' + methodName + '] ' + textStatus, {
			xhr: xhr,
			errorThrown: errorThrown
		});
		showError(xhr?.responseJSON?.message ?? textStatus);
	};

	/**
	 * Initializes caption behaviours and interactions.
	 * @private
	 */
	HCH._initCaption = function (containerEl) {
		var
			lines,
			chart = HCH._getChart(containerEl),
			caption = HCH._getCaption(containerEl)
		;

		caption
			.off('change', 'input.graph-name')
			.on('change', 'input.graph-name', function () {
				HCH._chartState(containerEl, HCH._statesMap.pendingChanges);
			})

			.off('click', '.chartcaption__graph-save')
			.on('click', '.chartcaption__graph-save', function () {
				HCH.updateGraph(containerEl);
			})
		;


		lines = caption.find('tbody');
		lines.sortable({
			handle: 'td div.chartcaption_sort',
			helper: function (e, ui) {
				// fix width while drag process is running
				ui.children().each(function () {
					$(this).width($(this).width());
				});
				return ui;
			},
			start: function (e, ui) {
				// close tints picker while dragging
				ui.item.removeClass('state--tints-picker-active');
			},
			stop: function () {
				var
					captionOrder,
					chartOrder,
					trs = $(this).find('tr.chartcaption__row');

				// ---	retrieve caption display order
				captionOrder = [];
				trs.each(function (index, el) {
					captionOrder.push($(el).attr('data-graphique-point'));
				});

				chartOrder = [];
				chart.series.forEach(function (el) {
					chartOrder.push(el.options.pointId);
				});

				chartOrder.sort(function (a, b) {
					return captionOrder.indexOf(a) - captionOrder.indexOf(b);
				});
				chartOrder.reverse();

				for (var i = 0, ilen = chart.series.length, s; i < ilen; ++i) {
					s = chart.series[i];
					s.options.zIndex = chartOrder.indexOf(s.options.pointId);
					s.update(s.options);
				}
				chart.redraw();

				HCH._chartState(containerEl, HCH._statesMap.pendingChanges);
			}
		});
		lines.disableSelection();
	};

	/**
	 * Defines chart class according to passed-in state.
	 * @see HCH._statesMap
	 * @param containerEl
	 * @param state {string}
	 * @private
	 */
	HCH._chartState = function (containerEl, state) {
		containerEl
			.toggleClass(HCH._statesMap.data, state === HCH._statesMap.data)
			.toggleClass(HCH._statesMap.loading, state === HCH._statesMap.loading)
			.toggleClass(HCH._statesMap.nodata, state === HCH._statesMap.nodata)
			.toggleClass(HCH._statesMap.pendingChanges, state === HCH._statesMap.pendingChanges)
		;
	};

	/**
	 * Displays chart title.
	 * @private
	 */
	HCH._chartSetTitle = function(containerEl, data, from, to){
		var caption = HCH._getCaption(containerEl);

		if (caption)
			caption.find('input.graph-name').val(data.name);

		if(containerEl.is('.status--no-title')){
			HCH._getChart(containerEl).setTitle('', '', false);
		}
		else{
			HCH._getChart(containerEl).setTitle(
				{ text: data.name},
				{ text: G.config.LOCALE_RETRIEVE(from === to ? 'hch.subtitleFromToSingle' : 'hch.subtitleFromTo')
						.replace('{DATE_FROM}', from)
						.replace('{DATE_TO}', to) },
				false
			);
		}
	};

	/**
	 * Adds the series corresponding to the passed-in dataset to the chart instance.
	 * @private
	 */
	HCH._addSeries = function (containerEl, data, index, options) {
		var
			i, ilen, t,
			chart = HCH._getChart(containerEl),
			fromTstamp,
			toTstamp;

		if(HCH.VERBOSE)
			console.log('[HCH._addSeries] data', data);

		if (!data.couleur){
			data.couleur = index;
			if(HCH.VERBOSE) {
				console.log('---> add default color value', data.couleur, ' to index: ', index);
			}
		}

		//	---	core series options
		options = Highcharts.merge({
			data: data.data,
			colorIndex: data.couleur,
			equipement: data.equipement,
			display: data.display,
			name: data.name,
			turboThreshold: 0,
			id: 'id-' + data.pointId,
			marker: {
				symbol: 'circle'
			},
			tooltip: {
				valueSuffix: data.unite
			}
		}, options || {});

		// ---	register core options for all series

		if(data.typeGraphique != 'bar'){
			options.yAxis = HCH._getYAxisId(data);
			options.yAxisId = HCH._getYAxisId(data);
		}
		
		if(data.pointId){
			options.pointId = data.pointId;
			options.humanId = '[' + data.equipement + '] ' + data.name;
		}
		else
			options.humanId = data.name;

		if (exists(data.min))
			options.min = data.min;

		if (exists(data.max))
			options.max = data.max;

		if (exists(data.class))
			options.className = data.class;

		if (exists(data.zindex))
			options.zIndex = data.zindex;

		if (exists(data.legendIndex))
			options.legendIndex = data.legendIndex;

		if (exists(data.lineWidth))
			options.lineWidth = data.lineWidth;

		if (exists(data.opacity))
			options.opacity = data.opacity;

		if (exists(data.tooltipPeriod))
			options.tooltipPeriod = data.tooltipPeriod;

		if (exists(data.tooltipMode))
			options.tooltipMode = data.tooltipMode;

		if (exists(data.tooltipLabels))
			options.tooltipLabels = data.tooltipLabels;

		if (exists(data.valueDecimals))
			options.valueDecimals = data.valueDecimals;

		if (exists(data.data) && data.data.length > 1000)
			options.boostThreshold = 0;
		else 
			options.boostThreshold = 1;

		if (exists(data.pointPadding))
			options.pointPadding = data.pointPadding;

		//affichage graphique avec plusieurs points qui ont le même label --> on ajoute le nom de lequipement
		if (exists(data.display) && data.display == "equipement")
			options.name = '[' + data.equipement + '] ' + data.name;

		//data grouping
		if (exists(data.dataGrouping)){
			
			if(data.dataGrouping == 'month'){
				options.dataGrouping= {
					force:true,
					units: [
						['month', [1]]
					],
					type: 'column'
				};
			}
			
			if(data.dataGrouping == 'week'){
				options.dataGrouping= {
					force:true,
					units: [
						['week', [1]]
					],
					type: 'column'
				};
			}
		}

		if(exists(data['stack'])) {
			options.stack = data['stack'];
		}

		if(data.typeGraphique == 'column_custom' || exists(data.categories)){
			chart = HCH._getChart(containerEl);
			chart.xAxis[0].update({
				title:{
					text:data.xaxis_title
				},
				type: 'linear',
				categories: data.categories
			}, true);
		}
		else if(data.typeGraphique == 'bar') {
			chart = HCH._getChart(containerEl);
			chart.update({
				chart: {
					type: 'bar',
					inverted: true
				},
				xAxis: {
					type: 'category',
					title: { text: null }
				},
				legend: {
					enabled: false,
				},
				tooltip: {
					enabled: false
				},
				responsive: {
					rules: [{
						condition: {
							maxWidth: 550
						},
						chartOptions: {
							plotOptions: {
								series: {
									dataLabels: [{
										enabled: true,
										y: 8
									}, {
										enabled: true,
										format: '{point.name}',
										y: -8,
										style: {
											fontWeight: 'normal',
											opacity: 0.7
										}
									}]
								}
							}
						}
					}]
				}
			});
		}
		else {
			chart = HCH._getChart(containerEl);
			chart.xAxis[0].update({
				type: 'datetime',
				categories:null,
				ordinal:false,
				showEmpty: true,
				title: {
					text: 'Date'
				},
				tickPixelInterval: 100,
				minPadding: 0,
				maxPadding: 0
			}, true);
		}

		// ---	specific series types settings
		switch (data.typeGraphique) {

			case 'perf':
				HCH._addSeriesPerf(containerEl, data, options);
				return;
			case 'area':
				options.type = 'area';
				break;
			case 'column':
				options.type = 'column';
				break;
			case 'column_custom':
				options.type = 'column';
				options.categories = data.categories;
				options.custom_yaxis_title = data.custom_yaxis_title;
				options.data = data.data_categories;
				options.save_axis_title = data.xaxis_title;
				options.save_categories = data.categories;
				options.save_data_categories = data.data_categories;
				options.save_data = data.data;
				options.save_yaxis_title = data.save_yaxis_title;
				options.stacking = '';
				options.unite_series = data.unite_series;
				break;
			case 'column_stack':
				options.type = 'column';
				options.stack = HCH._getYAxisId(data);
				options.stacking = 'normal';
				break;
			case 'column_compare':
				options.type = 'column';
				options.stacking = '';
				if(exists(data['stack'])){
					options.stacking = 'normal';
				}
				break;
			case 'boolean':
				options.type = 'line';

				for(i = 0, ilen = data.data.length; i < ilen; ++i){
					t = data.data[i];
					chart.xAxis[0].addPlotBand({
						colorIndex: G.clr.GV_ARR.indexOf(G.clr.GV_ENUM.green),
						className: 'boolean-plotband',
						color: G.clr.GV_ENUM.green,
						from: t[0],
						to: t[1],
						title: {
							text: G.config.LOCALE_RETRIEVE('zone.thead_date')
						}
					});
				}
				options.colorIndex = G.clr.GV_ARR.indexOf(G.clr.GV_ENUM.ui_transparent);
				break;
			case 'arearange':
				options.type = "arearange";
				options.color = G.clr.GV_ARR.indexOf(G.clr.GV_ENUM.blue);
				options.zIndex = 0;
				options.className = 'arearange-area';
				break;
			case 'arearange_v2':
				var options_range = {
					data: data.data_range,
					colorIndex:G.clr.GV_ARR.indexOf(G.clr.GV_ENUM.blue),
					color:G.clr.GV_ARR.indexOf(G.clr.GV_ENUM.blue),
					type: 'arearange',
					// linkedTo: ':previous',
					className:'arearange_border',
					fillOpacity: 0.3,
					zIndex: 0,
					lineWidth: 0,
					marker: {
						enabled: false
					},
					tooltip: {
						valueSuffix: data.unite
					},
					name: data.name+' : '+G.config.LOCALE_RETRIEVE('highchart.range'),
					id: 'id-range_' + data.pointId,
					yAxis: HCH._getYAxisId(data),
					yAxisId: HCH._getYAxisId(data)
				};

				options.type = "line";
				options.className="arearange_line_avg";
				if (data.couleur){
					
					options.colorIndex= data.couleur;
					options.color = data.couleur;
				}else{
					options.colorIndex= G.clr.GV_ARR.indexOf(G.clr.GV_ENUM.blue);
					options.color = G.clr.GV_ARR.indexOf(G.clr.GV_ENUM.blue);

				}
				options.zIndex = 1;
				options.marker = {
					enabled: true,
					symbol: 'circle',
					states: {
						select: {},
						hover: {
							animation: false
						}
					},
					symbol: 'circle',
					fillColor: 'white',
					lineWidth: 2,
					lineColor: G.clr.GV_ARR.indexOf(G.clr.GV_ENUM.blue)
				}
				// options.className = 'arearange-area';
				break;
			// on n'affiche pas les défauts
			case 'defaut':
				return;
			case 'histogramme':
				//chart accessibility
				if(data.name == 'Débit perméat jour'){
					options.colorIndex= G.clr.GV_ARR.indexOf(G.clr.GV_ENUM.green);
					options.color = G.clr.GV_ARR.indexOf(G.clr.GV_ENUM.green);
					options.lineColor = G.clr.GV_ENUM.green;
					// options.className='highcharts-candlestick-series-green';
				}
				if(data.name == 'Débit concentrat moyen jour'){
					options.colorIndex= G.clr.GV_ARR.indexOf(G.clr.GV_ENUM.orange);
					options.color = G.clr.GV_ARR.indexOf(G.clr.GV_ENUM.orange);
					// options.className='highcharts-candlestick-series-orange';
				}
				// Define custom series type for displaying low/med/high values using boxplot as a base
				// options.type='candlestick';
				options.type='lowmedhigh';
				options.lineWidth=3;
				
				break;
			case 'threshold-line':
				options.type = 'line';
				options.colorIndex = G.clr.GV_ARR.indexOf(HCH._getColorConfigFromStyle(data.class).clr);
				options.showInLegend = false;
				options.className = 'hidden-dataset';
				break;
            case 'threshold-arearange':
                options.type = 'arearange';
                options.colorIndex = G.clr.GV_ARR.indexOf(HCH._getColorConfigFromStyle(data.class).clr);
                options.showInLegend = false;
                options.className = 'hidden-dataset threshold-arearange';
                break;
			case 'dash-line-visible':
				options.dashStyle = (exists(data.dashStyle)) ? data.dashStyle : 'dash';
				options.lineWidth = (exists(data.lineWidth)) ? data.lineWidth : 0.5;
				options.colorIndex = G.clr.GV_ARR.indexOf(HCH._getColorConfigFromStyle(data.class).clr);
				options.className = 'visible-dataset';

				options.type = 'line';
				break;
			case 'dash-line':
				options.dashStyle = (exists(data.dashStyle)) ? data.dashStyle : 'dash';
				options.lineWidth = (exists(data.lineWidth)) ? data.lineWidth : 0.5;
				options.colorIndex = G.clr.GV_ARR.indexOf(HCH._getColorConfigFromStyle(data.class).clr);
				options.className = 'hidden-dataset';

				options.type = 'line';
				break;
			case 'line':
			case 'state_change':
			case 'state_change_left':
				options.type = 'line';
				if(data.typeGraphique == 'state_change'){
					options.step = 'right';
				}
				if(data.typeGraphique == 'state_change_left'){
					options.step = 'left';
				}
				break;
			case 'areaspline':
			case 'spline':
				options.type = data.typeGraphique;
				options.marker.enabled = true;
				break;
			case 'spline_without_marker':
				options.type = 'spline';
				options.marker.enabled = false;
				
				break;
			case 'dot':
				options.type = 'scatter';
				break;
			case 'bar':
				options.type = 'bar';
				options.groupPadding = 0;
				options.colorByPoint = true;
				break;
			case 'advanced_bar':
			case 'advanced_column':
			case 'advanced_area':
			case 'advanced_columnrange':
			case 'advanced_line':
			case 'advanced_spline':
				options.type = data.typeGraphique
					.replace("advanced_", "");
				break;
			default:
				// options.type = 'line';
				options.type = 'spline';
				options.marker.enabled = false
				if (HCH.VERBOSE){
					console.log('[HCH._addSeries] Unhandled typeGraphique: "' + data.typeGraphique + '"');
				}
				break;
		}

		switch (data['soustype']) {
			case 'consigne':
				options.step = 'right';
				break;
		}

		if(exists(data['option_step'])){
			options.step = data['option_step'];
		}

		if(exists(data['index'])){
			options.index = data['index'];
			chart.update({
				yAxis: [{
					stackLabels: {
						enabled: true
					}
				}],
				plotOptions:{
					column: {
						stacking: 'normal',
						pointPadding: null,
						pointWidth: null,
						dataLabels: {
							enabled: true,
							style: {
								fontWeight: 'light'
							}
						}
					}
				}
			}, true);
		}
		else if(data.typeGraphique == 'column_compare') {
			chart.update({
				yAxis: {
					stackLabels: {
						enabled: false
					}
				},
				plotOptions:{
					column: {
						pointPadding: null,
						pointWidth: null,
						grouping: false,
						shadow: false,
						borderWidth: 0
					}
				}
			}, true);
		}
		else if(data.typeGraphique == 'column_custom') {
			chart.update({
				yAxis: {
					stackLabels: {
						enabled: false
					}
				},
				plotOptions:{
					column: {
						pointPadding: null,
						pointWidth: null,
						stacking: '',
						dataLabels: {
							enabled: false
						}
					}
				}
			}, true);
		}
		else if(data.typeGraphique == 'bar') {
			chart.update({
				chart: {
					type: 'bar',
					inverted: true
				},
				xAxis: {
					type: 'category',
					title: { text: null }
				},
				legend: {
					enabled: false,
				},
				tooltip: {
					enabled: false
				},
				legend: {
					enabled: false,
				},
				responsive: {
					rules: [{
						condition: {
							maxWidth: 550
						},
						chartOptions: {
							plotOptions: {
								series: {
									dataLabels: [{
										enabled: true,
										y: 8
									}, {
										enabled: true,
										format: '{point.name}',
										y: -8,
										style: {
											fontWeight: 'normal',
											opacity: 0.7
										}
									}]
								}
							}
						}
					}]
				}
			});
		}
		else if(data.typeGraphique == 'column') {
			chart.update({
				yAxis: {
					stackLabels: {
						enabled: false
					}
				},
				plotOptions:{
					column: {
						pointPadding: null,
						pointWidth: null,
						stacking: '',
						dataLabels: {
							enabled: false
						}
					}
				}
			}, true);
		}
		else if (["advanced_bar", "advanced_column", "advanced_area", "advanced_columnrange", "advanced_line", "advanced_spline"].includes(data.typeGraphique)) {
			if(exists(data['stack'])) {
				options.stacking = true;
			}
		}
		else {
			const chartResetOptions = {
				yAxis: {
					stackLabels: {
						enabled: false
					}
				},
				plotOptions:{
					column: {
						pointPadding: 0.2,
						pointWidth: 20,
						stacking: '',
						dataLabels: {
							enabled: false
						}
					}
				}
			};
			if(!exists(chartResetOptions["plotOptions"][options.type])) {
				chartResetOptions["plotOptions"][options.type] = {}
			}
			chartResetOptions["plotOptions"][options.type]["stacking"] = "";
			chart.update(chartResetOptions, true);
		}

		if(exists(data.markerSymbol)) {
			options.marker["enabled"] = true;
			options.marker["symbol"] = data.markerSymbol;
		}

		if (HCH.VERBOSE){
			console.log('[HCH._addSeries] "' + data.name + '", typeGraphique: "' + data.typeGraphique + '", options: ',options);
			console.log('\t\t - data: ', data);
		}

		// ######	ADD YAXIS
		HCH._getYAxis(containerEl, data);

		// ######	ADD SERIES
		try {
			if(chart.series  && isarray(chart.series) && (!data.typeGraphique || data.typeGraphique !== "threshold-line")) {
				chart.series.forEach(function(el) {
					if(el.userOptions.humanId === options.humanId)
						throw new Error('Serie "' + options.humanId + '" already displayed in graph');
				});
			}

			if(data.typeGraphique == 'arearange_v2'){
				var addSerReponse = chart.addSeries(options, true);
			} else {
				var addSerReponse = chart.addSeries(options);
			}
			
			if (HCH.VERBOSE){
				console.log('\t[HCH._addSeries] addSerReponse ; ', addSerReponse);
			}
			if (addSerReponse.toString().indexOf('Error: Highcharts error') === 0) {
				console.warn('\t[HCH._addSeries] Unable to add series ; ' + addSerReponse, options.data);
			}
		}
		catch (err) {
			if (err.toString().indexOf('Error: Highcharts error #14') === 0) {
				console.log('\t[HCH._addSeries] Capture "Highcharts error #14", attempt to correct', options.data);
				options.data = options.data.map(function (v) {
					return [v[0], parseFloat(v[1])];
				});
				try {
					var addSerReponse = chart.addSeries(options, false);
					if (addSerReponse.toString().indexOf('Error: Highcharts error') === 0) {
						console.warn('\t[HCH._addSeries] Unable to add series ; ' + addSerReponse, options.data);
					}
				}
				catch (err) {
					console.warn('\t[HCH._addSeries] Unable to add series ; ' + err, options.data);
					return;
				}
			}
			else{
				showInfo('Unable to add series ; ' + err);
				console.warn('\t[HCH._addSeries] Unable to add series ; ' + err, options);
				return;
			}
		}

		// ######	ADD LINKED THRESHOLD

		if (exists(data.ticks)) {
			if(typeof(data.data[0]['x']) == 'undefined'){
				fromTstamp = data.data[0][0];
			} else {
				fromTstamp = data.data[0]['x'];
			}
			if(typeof(data.data[data.data.length - 1]['x']) == 'undefined'){
				toTstamp = data.data[data.data.length - 1][0];
			} else {
				toTstamp = data.data[data.data.length - 1]['x'];
			}

			for (i = 0, ilen = data.ticks.length; i < ilen; ++i) {
				t = {
					fromY: parseFloat(data.ticks[i][0]),
					toY: parseFloat(data.ticks[i][1]),
					orientation: null,
					style: data.ticks[i][2]
				};

				if(t.style === 'status-ok')
					continue;

				t.orientation = (t.fromY > t.toY) ? 'min' : 'max'

				t = HCH._getColorConfigFromStyle(t.style, t);

				t.arearange = {
					id: 'tick' + i + '_arearange',
					yAxis: options.yAxis,
					type: 'arearange',
					className: 'hidden-dataset threshold-arearange hch--threshold-' + t.orientation + '-' + t.clrRef,
					// zIndex: 9,
					colorIndex: G.clr.GV_ARR.indexOf(t.clr),
					showInLegend: false,
					marker: {
						enabled: false,
						symbol: 'circle',
						fillColor: '#00000000',
						states: {
							hover: {
								animation: false
							}
						}
					},
					data: [
						[fromTstamp, t.fromY, t.toY],
						[toTstamp, t.fromY, t.toY]
					]
				};

				t.line = {
					id: 'tick' + i + '_line',
					yAxis: options.yAxis,
					type: 'line',
					className: 'hidden-dataset threshold-line hch--threshold-' + t.orientation + '-' + t.clrRef,
					colorIndex: G.clr.GV_ARR.indexOf(t.clr),
					showInLegend: false,
					marker: {
						enabled: false,
						symbol: 'circle',
						states: {
							select: {},
							hover: {
								animation: false
							}
						}
					},
					data: [
						[fromTstamp, t.fromY],
						[toTstamp, t.fromY]
					]
				};

				try{
					chart.addSeries(t.arearange, false);
					chart.addSeries(t.line, true);
				}
				catch(err){
					console.log('\t[HCH._addSeries] An error occurred while adding tick series', err, t);
				}
			}
		}

		if(data.typeGraphique == 'arearange_v2'){
			try{
				var addSerReponseRange = chart.addSeries(options_range, false);
				if (addSerReponseRange.toString().indexOf('Error: Highcharts error') === 0) {
					console.warn('\t[HCH._addSeries] Unable to add series ; ' + addSerReponseRange, options_range.data);
				}

			} catch (err){
				if (err.toString().indexOf('Error: Highcharts error #14') === 0) {
					console.log('\t[HCH._addSeries] Capture "Highcharts error #14", attempt to correct', options_range.data);
					options_range.data = options_range.data.map(function (v) {
						return [v[0], parseFloat(v[1])];
					});
					try {
						var addSerReponse = chart.addSeries(options_range, false);
						if (addSerReponse.toString().indexOf('Error: Highcharts error') === 0) {
							console.warn('\t[HCH._addSeries] Unable to add series ; ' + addSerReponse, options_range.data);
						}
					}
					catch (err) {
						console.warn('\t[HCH._addSeries] Unable to add series ; ' + err, options_range.data);
						return;
					}
				}
				else{
					showInfo('Unable to add series ; ' + err);
					console.warn('\t[HCH._addSeries] Unable to add series ; ' + err, options_range);
					return;
				}
			}
		}	

		HCH._addSeriesCaption(containerEl, data, options);
		HCH._initCaption(containerEl);

		// ######	ADD LINKED ANNOTATIONS
		HCH._notesInsert(containerEl,data);

		// bug largeur d'affichage
		chart.reflow();
	};

	/**
	 *
	 * @param style
	 * @param t
	 * @returns {*}
	 * @private
	 */
	HCH._getColorConfigFromStyle = function(style, t){

		if(!exists(t))
			t = {};

		if(/status-alert/i.test(style)){
			t.clrRef = 'red';
			t.clr = G.clr.GV_ENUM.redl;
		}
		else if(/status-warning/i.test(style)) {
			t.clrRef = 'orange';
			t.clr = G.clr.GV_ENUM.orangel;
		}
		else if(/status-ok/i.test(style))  {
			t.clrRef = 'green';
			t.clr = G.clr.GV_ENUM.greenl;
		}
		else if(/status-infos/i.test(style)) {
			t.clrRef = 'blue';
			t.clr = G.clr.GV_ENUM.bluel;
		}
		else{
			console.log('\t[HCH._addSeries] Unhandled tick style: "' + style + '", skip tick');
		}
		return t;
	};

	/**
	 * Adds a series of performance type ()
	 * @param containerEl
	 * @param data
	 * @param options
	 * @private
	 */
	HCH._addSeriesPerf = function (containerEl, data, options) {
		var
			chart = HCH._getChart(containerEl),
			percentYAxisId = 'percentYAxis',
			unitYAxisId = 'unitYAxis',
			// djuYAxisId = 'djuYAxis',
			adjusted = [],
			real = [],
			goal = [],
			djuRef = [],
			djuReal = [],
			percentages = [],
			percentMaxAbs = 0,
			sousconso = data.sousconso || false,
			// sousconsolight = data.sousconsolight || false,
			surconso = data.surconso || false,
			surconsolight = data.surconsolight || false,
			round = function (v) {
				return Math.round(v * 100) / 100;
			};

		$.each(data.data, function (index, value) {
			var iPercent, iPercentClr;

			if(typeof(value.ajuste) != 'undefined' && value.ajuste != '-'){
				adjusted.push([value.date, round(value.ajuste)]);
			}
			real.push([value.date, round(value.valeur)]);
			// real.push([value.date, round(value.valeur)]);
			goal.push([value.date, round(value.objectif)]);
			djuRef.push([value.date, round(value.dju_ref)]);
			djuReal.push([value.date, round(value.dju_reel)]);

			iPercent = round(value.pourcentage);
			if (Math.abs(iPercent) > percentMaxAbs)
				percentMaxAbs = iPercent;

			iPercentClr = G.clr.GV_ENUM.ui_grey;
			if (sousconso && iPercent < sousconso)
				iPercentClr = G.clr.GV_ENUM.orange;
			else if (surconso && iPercent > surconso)
				iPercentClr = G.clr.GV_ENUM.red;
			else if (surconsolight && iPercent > surconsolight)
				iPercentClr = G.clr.GV_ENUM.orange;
			else
				iPercentClr = G.clr.GV_ENUM.green;

			percentages.push({
				x: value.date,
				y: iPercent,
				className: 'perf-column',
				colorIndex: G.clr.GV_ARR.indexOf(iPercentClr)
			});
		});

		percentMaxAbs = parseInt(percentMaxAbs);
		if(percentMaxAbs < 0){
			percentMaxAbs -= 10;
		} else {
			percentMaxAbs += 10;
		}
		var percentMinAbs = (percentMaxAbs < 0) ? percentMaxAbs : -percentMaxAbs;
		var percentMaxAbs = (percentMaxAbs < 0) ? Math.abs(percentMaxAbs) : percentMaxAbs;

		chart.update(options);
		chart.xAxis[0].type = 'datetime';
		chart.xAxis[0].ordinal = false;

		// add yAxis
		chart.addAxis({
			id: unitYAxisId,
			title: {
				text: data.type + ' (' + data.unite + ')'
			}
		}, false, true, false);
		chart.addAxis({
			id: percentYAxisId,
			opposite: 1,
			min: percentMinAbs,
			max: percentMaxAbs,
			title: {
				text: G.config.LOCALE_RETRIEVE('indicator.performancePercentAxisTitle')
			}
		}, false, true, false);

		// primary yAxis: consommation
		chart.addSeries({
			name: G.config.LOCALE_RETRIEVE('indicator.performanceObjective'),
			data: goal,
			zIndex: 10,
			type: 'line',
			yAxis: unitYAxisId,
			colorIndex: G.clr.GV_ARR.indexOf(G.clr.GV_ENUM.ui_green),
			marker: {
				symbol: 'circle'
			},
			tooltip: {
				valueSuffix: data.unite
			}
		});

		chart.addSeries({
			name: G.config.LOCALE_RETRIEVE('indicator.performanceReal'),
			data: real,
			zIndex: 12,
			type: 'line',
			yAxis: unitYAxisId,
			colorIndex: G.clr.GV_ARR.indexOf(G.clr.GV_ENUM.brown),
			marker: {
				symbol: 'circle'
			},
			tooltip: {
				valueSuffix: data.unite
			}
		});

		chart.addSeries({
			name: G.config.LOCALE_RETRIEVE('indicator.performanceAdjusted'),
			data: adjusted,
			zIndex: 13,
			type: 'line',
			yAxis: unitYAxisId,
			colorIndex: G.clr.GV_ARR.indexOf(G.clr.GV_ENUM.blue),
			marker: {
				symbol: 'circle'
			},
			tooltip: {
				valueSuffix: data.unite
			}
		});

		// secondary yAxis: percentages
		chart.addSeries({
			name: G.config.LOCALE_RETRIEVE('indicator.performanceDelta'),
			type: 'column',
			data: percentages,
			yAxis: percentYAxisId,
			colorIndex: G.clr.GV_ARR.indexOf(G.clr.GV_ENUM.ui_grey),
			tooltip: {
				valueSuffix: '%'
			}
		});

		//Résumé
		if( $('#history-resume-perf-'+data.perf_id).length > 0 ){
			if(typeof(data.total) != 'undefined'){
				$('#array-perf-'+data.perf_id+'-dju_ref').html(data.total['dju_ref']);
				$('#array-perf-'+data.perf_id+'-objectif').html(data.total['objectif']);
				$('#array-perf-'+data.perf_id+'-dju_reel').html(data.total['dju_reel']);
				$('#array-perf-'+data.perf_id+'-reel').html(data.total['valeur']);
				//Ajusté
				$('#array-perf-'+data.perf_id+'-tint_reel').html(data.total['temp_avg']);
				$('#array-perf-'+data.perf_id+'-ajuste').html(data.total['ajuste']);
				$('#array-perf-'+data.perf_id+'-ratio').html(data.total['ajuste_percent']);
				if(parseFloat(data.total['ajuste_percent']) > 1.1){
					$('#array-perf-'+data.perf_id+'-ratio-class').removeClass('table-success, table-danger').addClass('table-danger');
				} else {
					$('#array-perf-'+data.perf_id+'-ratio-class').removeClass('table-success, table-danger').addClass('table-success');

				}
			}
		}
		if( $('#history-array-perf-'+data.perf_id).length > 0 ){
			var str = '';
			for(var i=0;i < data.data.length; i++){
				var d = data.data[i];
				if(data.commentaire == 'cchauffage' ){
					// var time = moment(d.date).format('DD/MM/YYYY');
					str += '<tr>'+
							'<td>'+moment(d.date).format('DD/MM/YYYY')+'</td>'+
							'<td>'+d.dju_ref+'</td>'+
							'<td>'+d.dju_reel+'</td>'+
							'<td>'+d.tint+'</td>'+
							'<td>'+d.objectif+'</td>'+
							'<td>'+d.valeur+'</td>'+
							'<td>'+d.ajuste+'</td>'+
						'</tr>';
				} else if(data.commentaire == 'cchauffage_sans_temp') {
					str += '<tr>'+
							'<td>'+moment(d.date).format('DD/MM/YYYY')+'</td>'+
							'<td>'+d.dju_ref+'</td>'+
							'<td>'+d.dju_reel+'</td>'+
							'<td>'+d.objectif+'</td>'+
							'<td>'+d.valeur+'</td>'+
							'<td>'+d.ajuste+'</td>'+
						'</tr>';
				} else if(data.commentaire == 'cecs') {
					var cecsTheorique = '-';
					var cecsMoinsBouclage = '-';
					if(typeof(d.cecs_energy_without_bouclage) != 'undefined' && d.cecs_energy_without_bouclage != '-'){
						cecsMoinsBouclage = Math.round(d.cecs_energy_without_bouclage / d.cecs_water);

					}
					if(typeof(data.total.vecs_objectif_day) != 'undefined'){
						switch(moment(d.date).format('MM')){
							case '01':
								if(typeof(data.total.nb_logements_01) != 'undefined'){
									var cecsTheorique = Math.round(((data.total.nb_logements_01 * data.total.vecs_objectif_day) / 1000)*10)/10;
								}
							break;
							case '02':
								if(typeof(data.total.nb_logements_02) != 'undefined'){
									var cecsTheorique = Math.round(((data.total.nb_logements_02 * data.total.vecs_objectif_day) / 1000)*10)/10;
								}
							break;
							case '03':
								if(typeof(data.total.nb_logements_03) != 'undefined'){
									var cecsTheorique = Math.round(((data.total.nb_logements_03 * data.total.vecs_objectif_day) / 1000)*10)/10;
								}
							break;
							case '04':
								if(typeof(data.total.nb_logements_04) != 'undefined'){
									var cecsTheorique = Math.round(((data.total.nb_logements_04 * data.total.vecs_objectif_day) / 1000)*10)/10;
								}
							break;
							case '05':
								if(typeof(data.total.nb_logements_05) != 'undefined'){
									var cecsTheorique = Math.round(((data.total.nb_logements_05 * data.total.vecs_objectif_day) / 1000)*10)/10;
								}
							break;
							case '06':
								if(typeof(data.total.nb_logements_06) != 'undefined'){
									var cecsTheorique = Math.round(((data.total.nb_logements_06 * data.total.vecs_objectif_day) / 1000)*10)/10;
								}
							break;
							case '07':
								if(typeof(data.total.nb_logements_07) != 'undefined'){
									var cecsTheorique = Math.round(((data.total.nb_logements_07 * data.total.vecs_objectif_day) / 1000)*10)/10;
								}
							break;
							case '08':
								if(typeof(data.total.nb_logements_08) != 'undefined'){
									var cecsTheorique = Math.round(((data.total.nb_logements_08 * data.total.vecs_objectif_day) / 1000)*10)/10;
								}
							break;
							case '09':
								if(typeof(data.total.nb_logements_09) != 'undefined'){
									var cecsTheorique = Math.round(((data.total.nb_logements_09 * data.total.vecs_objectif_day) / 1000)*10)/10;
								}
							break;
							case '10':
								if(typeof(data.total.nb_logements_10) != 'undefined'){
									var cecsTheorique = Math.round(((data.total.nb_logements_10 * data.total.vecs_objectif_day) / 1000)*10)/10;
								}
							break;
							case '11':
								if(typeof(data.total.nb_logements_11) != 'undefined'){
									var cecsTheorique = Math.round(((data.total.nb_logements_11 * data.total.vecs_objectif_day) / 1000)*10)/10;
								}
							break;
							case '12':
								if(typeof(data.total.nb_logements_12) != 'undefined'){
									var cecsTheorique = Math.round(((data.total.nb_logements_12 * data.total.vecs_objectif_day) / 1000)*10)/10;
								}
							break;
							default:
								if(typeof(data.nb_logements) != 'undefined'){
									var cecsTheorique = Math.round(((data.nb_logements * data.total.vecs_objectif_day) / 1000)*10)/10;
								}
						}
						if(cecsTheorique == '-' && typeof(data.nb_logements) != 'undefined'){
							var cecsTheorique = Math.round(((data.nb_logements * data.total.vecs_objectif_day) / 1000)*10)/10;
						}
					}
					str += '<tr>'+
							'<td>'+moment(d.date).format('DD/MM/YYYY')+'</td>'+
							'<td>'+d.objectif+'</td>'+
							'<td>'+d.valeur+'</td>'+
							'<td>'+d.cecs_energy+'</td>'+
							'<td>'+d.cecs_water+'</td>'+
							'<td>'+cecsTheorique+'</td>'+
							'<td>'+cecsMoinsBouclage+'</td>'+
						'</tr>';
				}
			}
			$('#history-array-perf-'+data.perf_id+' tbody').empty().append(str);
		}
	};


	HCH._addSeriesPiechart = function(containerEl, seriesPiechart, options = {}) {
		var chart = HCH._getChart(containerEl);

		chart.update(options);

		chart.addSeries({
			type: "pie",
			data: (seriesPiechart ?? []).map(function(seriePiechart) {
				var seriePiechartData = {
					name: seriePiechart.name,
					y: parseInt(seriePiechart.y),
					colorIndex: seriePiechart.color,
					yAxis: "piechartYAxisSeries"
				};

				if(exists(seriePiechart["valueDecimals"])) {
					seriePiechartData["valueDecimals"] = seriePiechart["valueDecimals"];
				}

				return seriePiechartData;
			})
		});
	};

	/**
	 * @param containerEl
	 * @private
	 */
	HCH._isInlineCaption = function(containerEl){
		return containerEl.is('.' + HCH.CLASS_INLINE_CAPTION);
	};

	/**
	 * Adds the series corresponding to the passed-in dataset in the chart caption.
	 * @private
	 */
	HCH._addSeriesCaption = function (containerEl, s) {
		var
			chart = HCH._getChart(containerEl),
			caption = HCH._getCaption(containerEl),
			index = chart.series.length - 1,
			loc = G.config.LOCALE_RETRIEVE,
			tr,
			str = '';

		if(HCH.VERBOSE)
			console.log('[HCH._addSeriesCaption] 1', s);

		if(s.showInLegend === false)
			return;

		if (!caption.exists())
			return;

		s.couleur = parseInt(s['couleur'], 10);

		if(HCH._isInlineCaption(containerEl)){
			str += '<div class="chartcaption__row" data-graphique-point="' + s.pointId + '" data-graphique-donnees="' + s['idGraphiqueDonnees'] + '">'
				+ '<div class="chartcaption__label">'
				+ '<span class="chartcaption__tints-picker-toggler link-no-decoration gv-tip" style="color: ' + G.clr.GV_ARR[s.couleur] + '" data-tippedpos="top" title="' + G.config.LOCALE_RETRIEVE('hch.seriesResetColor') + '">'
				+ '<i class="fa fa-square"></i>'
				+ '</span>'
				+ '<span class="chartcaption__label__equipment">' + s.equipement + ' › ' + '</span>'
				+ '<span class="chartcaption__label__name">' + s.name + '</span>'
				+ '</div>'
				+ '</div>';
			caption.find('.hch-caption-table').append($(str));

		}
		else{

			str += '<tr class="chartcaption__row" data-graphique-point="' + s.pointId + '" data-graphique-donnees="' + s['idGraphiqueDonnees'] + '">'

			// label
			str += '<td class="chartcaption__label">'
				+ '<span class="chartcaption__tints-picker-toggler link-no-decoration gv-tip" style="color: ' + G.clr.GV_ARR[s.couleur] + '" data-tippedpos="top" title="' + loc('hch.seriesResetColor') + '"><i class="fa fa-square"></i></span>'
				+ '<span class="chartcaption__label__equipment">' + s.equipement + ' › ' + '</span><span class="chartcaption__label__name">' + s.name + '</span>';

			// tints picker
			str += '<div class="chartcaption__tints-picker">›&nbsp;&nbsp;';
			for (var j = 0, jlen = G.clr.GV_ARR.length, color; j < jlen; ++j) {
				color = G.clr.GV_ARR[j];
				if(color === G.clr.GV_ENUM.ui_transparent)
					continue;
				str += '<div class="chartcaption__tint-option ' + (j === s.couleur ? ' state--selected' : '') + '" data-color-value="' + color + '" data-color-index="' + j + '" >'
					+ '<div class="bullet bullet--default" style="background-color:' + color + '"></div>'
					+ '<div class="bullet bullet--selected" style="background-color:' + color + '"></div>'
					+ '</div>';
			}
			str += '</div>';

			str += '</td>';

			// sort
			str += '<td class="col-icon sort-column">'
				+ '<div class="chartcaption_sort gv-tip" data-tippedpos="top" title="' + loc('hch.seriesSort') + '">'
				+ '<a href="#" onclick="return false;" class="link-no-decoration"><i class="fas fa-sort"></i></a>'
				+ '</div>'
				+ '</td>';

			// delete
			str += '<td class="col-icon">'
				+ '<div class="chartcaption__delete gv-tip" data-tippedpos="top" title="' + loc('hch.seriesDelete') + '">'
				+ '<a href="#" class="link-no-decoration"><i class="fa fa-trash"></i></a>'
				+ '</div>'
				+ '</td>';

			str += '</tr>';

			tr = $(str);
			caption.find('tbody').append(tr);
			tr
			//	---	toggle tints picker display state
				.on('click', '.chartcaption__tints-picker-toggler', function () {
					var
						el = $(this),
						tr = el.closest('tr.chartcaption__row'),
						wasActive = tr.hasClass('state--active');

					if (!wasActive)
						el.closest('tbody').find('tr.chartcaption__row').removeClass('state--active');
					tr.toggleClass('state--active', !wasActive);

					return false;
				})
				// --- set series color
				.on('click', '.chartcaption__tint-option', function () {
					var
						el = $(this),
						tr = el.closest('tr.chartcaption__row');

					// set tint options selected
					tr.find('.chartcaption__tint-option').removeClass('state--selected');
					el.addClass('state--selected');

					// reset prefix tint color
					tr.find('.chartcaption__tints-picker-toggler').css({
						color: el.attr('data-color-value')
					});
					tr.removeClass('state--active');

					HCH._chartState(containerEl, HCH._statesMap.pendingChanges);

					// reset chart series color
					chart.series[index].options.colorIndex = el.attr('data-color-index');
					chart.series[index].update(chart.series[index].options);

					return false;
				})
				// ---	toggle series display state
				.on('click', '.chartcaption__label__equipment, .chartcaption__label__name', function () {
					var
						ctn = $(this).closest('.chartcaption__row'),
						series = chart.get('id-' + ctn.attr('data-graphique-point'));

					series.visible ? series.hide() : series.show();
					ctn.toggleClass('state--series-hidden', !series.visible);


					setTimeout(function(){
						$(chart.tooltip.label.element).find('.highcharts-label').css('visibility', 'hidden');
					}, 150);


				})
				// ---	remove series
				.on('click', '.chartcaption__delete', function () {
					var
						state,
						ctn = $(this).closest('.chartcaption__row'),
						removedPointId = ctn.attr('data-graphique-point'),
						removedSeries = chart.get('id-' + removedPointId),
						removedYAxisId = removedSeries.options.yAxisId,
						yAxisCounter;

					if(HCH.VERBOSE){
						console.log('[HCH._addSeriesCaption] Delete series for id: ' + removedPointId);
						console.log('\t - removedSeries:', removedSeries);
						console.log('\t - old series configuration (' + chart.series.length + '):', chart.series);
					}


					// ---   remove y-axis if required
					// @see  https://api.highcharts.com/class-reference/Highcharts.Series#remove
					// @see  https://api.highcharts.com/class-reference/Highcharts.Axis#remove

					yAxisCounter = 0;
					for (var i = 0, ilen = chart.series.length; i < ilen; ++i) {
						if (chart.series[i].options.yAxisId === removedYAxisId)
							++yAxisCounter;
					}
					if(HCH.VERBOSE)
						console.log('\t - yAxis ' + (yAxisCounter === 1 ?  'removed' : 'maintained used by ' + yAxisCounter + ' series'));


					// --- remove axis, series and caption

					removedSeries.remove(true, false);
					if(yAxisCounter === 1)
						chart.get(removedYAxisId).remove(false);
					ctn.remove();
					if(HCH.VERBOSE)
						console.log('\t - new series (' + chart.series.length + '):', chart.series);


					// ---   update chart state

					state = chart.series.length === 0 ? HCH._statesMap.nodata : HCH._statesMap.pendingChanges;
					if(HCH.VERBOSE)
						console.log('\t - set chart state to : "' + state + '"');
					HCH._chartState(containerEl, state);

					// ---   redraw graph
					chart.redraw(false);
					chart.reflow();

					return false;
				});
		}
	};




	// #############################################################################################
	//		NOTES
	// #############################################################################################

	HCH._notesSeriesRequire = function(containerEl) {
		var chart = HCH._getChart(containerEl);

		if (!chart.get('notes')) {

			if(HCH.VERBOSE)
				console.log('[HCH._notesSeriesRequire] Create notes series and yAxis.')

			// ---   create y-axis
			chart.addAxis({
				id: 'notes-axis',
				visible: HCH.NOTES_SHOW_CONTEXT,
				gridLineWidth: 0,
				title: {
					text: ''
				},
				min: 0,
				max: 10
			}, false, false);

			// ---   create series
			chart.addSeries({
				type: 'bubble',
				name: 'notes',
				id: 'notes',
				yAxis: 'notes-axis',
				showInLegend: HCH.NOTES_SHOW_CONTEXT,
				findNearestPointBy: 'x',
				zIndex: 1000,
				lineWidth: 0,
				minSize: HCH.NOTES_SIZE,
				maxSize: HCH.NOTES_SIZE,
				data: []
			});
		}
	};

	HCH._notesGetTypeFile = function(type){
		if(type == 'alert')
			type = 'warning';
		return '/assets2/mm/hch-icons/' + G.model.theme + '-' + type + '.png';
	};

	HCH._notesDeleteReset = function(guid){
		var selectNote = $('#deletenote__form-inp__note-' + guid);

		selectNote.val(selectNote.find('option:eq(0)').val());
	};

	HCH._notesDeleteOpen = function(whereEl){
		var
			containerEl = HCH.getContainer(whereEl),
			guid = containerEl.find('.hch-container-chart').attr('data-guid'),
			notesOptions = '',
			chart = HCH._getChart(containerEl),
			formEl = $('#deletenote__form-' + guid),
			notes, note, i, ilen;  

		HCH._notesDeleteReset(guid);

		notes = chart.get('notes').points;
		for(i = 0, ilen = notes.length; i < ilen; ++i){
			note = notes[i];
			notesOptions += '<option value="' + note.id + '">' + note.name + ' [' + moment(note['dtstart']).format('DD/MM/YYYY');
			if(note['dtend'])
				notesOptions += ' - ' + moment(note['dtend']).format('DD/MM/YYYY');
			notesOptions += ']</option>';
		}

		$('#deletenote__form-inp__note-' + guid)
			.html(notesOptions)
			.select2({
				minimumResultsForSearch: -1
			});

		formEl.addClass('state--opened');
	};

	HCH._notesAddReset = function(guid){
		var
			selectPoint = $('#addnote__form-inp__point-' + guid),
			selectType = $('#addnote__form-inp__type-' + guid);

		selectPoint.val(selectPoint.find('option:eq(0)').val());
		$('#addnote__form-inp__from-' + guid).val('');
		$('#addnote__form-inp__to-' + guid).val('');
		selectType.val(selectType.find('option:eq(0)').val());
		$('#addnote__form-inp__title-' + guid).val('');
		$('#addnote__form-inp__desc-' + guid).val('');
	};

	HCH._notesAddOpen = function(whereEl){
		var
			containerEl = HCH.getContainer(whereEl),
			guid = containerEl.find('.hch-container-chart').attr('data-guid'),
			chart = HCH._getChart(containerEl),
			formEl = $('#addnote__form-' + guid),
			captionsOptions = '';

		HCH._notesAddReset(guid);

		chart.series.forEach(function(el){
			/** @type {Object.<{pointId: string, equipement: string, name: string}>} */
			var o = el.userOptions;
			if(o.pointId)
				captionsOptions += '<option value="' + o.pointId + '">' + o.equipement + ' › ' + o.name + '</option>';
		});

		$('#addnote__form-inp__point-' + guid)
			.html($(captionsOptions))
			.select2({
				minimumResultsForSearch: -1
			});

		formEl.addClass('state--opened');
	};

	HCH._notesSetDateFromMouse = function(e) {
		var
			activeElement,
			sourceEl = $(e.currentTarget),
			chart = HCH._getChart(HCH.getContainer(sourceEl)),
			date;

		if(sourceEl.is('input')){
			if(e.type === 'focus') {
				$(chart.renderTo)
					.on('mousemove', HCH._notesSetDateFromMouse)
					.on('click', HCH._notesSetDateFromMouse);
			}
			else if(e.type == 'blur') {
				$(chart.renderTo)
					.off('mousemove', HCH._notesSetDateFromMouse)
					.off('click', HCH._notesSetDateFromMouse);
			}
		}
		else{
			date = new Date(chart.xAxis[0].toValue(chart.pointer.normalize(e).chartX));
			if(e.type === 'mousemove') {
				activeElement = $(document.activeElement);
				if(activeElement.is('input')){
					activeElement.val(moment(date).format('DD/MM/YYYY HH:00'));
				}
			}
			else if(e.type === 'click') {
				activeElement = $(document.activeElement);
				if(activeElement.is('input')){
					activeElement.val(moment(date).format('DD/MM/YYYY HH:00'));
					activeElement.blur();
				}
			}
		}
	};

	HCH._notesInsert = function(containerEl, data){
		var
			notes,
			chart = HCH._getChart(containerEl);

		if(data.hasOwnProperty('annotations'))
			notes = data.annotations;
		if(data.hasOwnProperty('annotation'))
			notes = [data.annotation];

		if(!notes)			
			return;

		HCH._notesSeriesRequire(containerEl);

		if(HCH.VERBOSE)
			console.log('[HCH._notesInsert]', notes);

		for(var i = 0, ilen = notes.length, o; i < ilen; ++i){
			o = Object.assign(notes[i], {
				x: notes[i].dtstart,
				y: 1,
				z: 1,
				marker: {
					enabled: true,
					symbol: 'url(' + HCH._notesGetTypeFile(notes[i].type) + ')'
				},
				id: notes[i].id
			});

			if(HCH.VERBOSE)
				console.log('\t - #' + i, o);
				
			chart.get('notes').addPoint(o, false);
		}
		chart.redraw();
	};



	// #############################################################################################
	//		CORE
	// #############################################################################################

	HCH.chartDatesRangeUpdate = function (containerEl, completeCallback) {
		var
			caption = HCH._getCaption(containerEl),
			siteId = containerEl.attr(HCH._chartContextMap.siteId),
			graphId = containerEl.attr(HCH._chartContextMap.graphId),
			pointIds = [],
			seriesData = [];

		if(exists(graphId)
			&& isfilled(graphId)
			&& containerEl.is('.hch-container--pending-changes')
			&& !confirm(G.config.LOCALE_RETRIEVE('hch.overwritePendingChanges'))
		)
			return;

		if(isfilled(graphId)){
			HCH.loadGraph(containerEl, graphId, null, function (success) {
				var chart = HCH._getChart(containerEl);
				if(success && chart){
					chart.tooltip.hide(0);
					chart.pointer.reset(false, 0);
					chart.redraw(false);
				}
				if(completeCallback)
					completeCallback(success);
			});
		}
		else{
			caption.find('tr.chartcaption__row').each(function (index, el) {
				el = $(el);
				seriesData.push(el.attr('data-graphique-point') + ';' + el.find('.chartcaption__tint-option.state--selected').attr('data-color-index'));
				pointIds.push(el.attr('data-graphique-point'));
			});
			if (seriesData.length === 0) {
				console.log('[HCH.chartDatesRangeUpdate] No series to display');
				return;
			}

			HCH.chartReset(containerEl);
			HCH.loadSeries(containerEl, siteId, null, seriesData.join('|'), completeCallback);
		}
	};

	/**
	 * Saves graph settings
	 * @param containerEl
	 */
	HCH.updateGraph = function (containerEl) {
		var
			caption = HCH._getCaption(containerEl),
			pointData,
			graphNameInp = caption.find('input.graph-name'),
			graphName = graphNameInp.val();

		// check if name has been set
		if (!isfilled(graphName)) {
			graphNameInp
				.focus()
				.css({
					borderColor: G.clr.GV_ENUM.ui_red,
					borderWidth: '2px'
				});
			setTimeout(function () {
				graphNameInp.attr('style', null);
			}, 1200);
			return;
		}

		// retrieve series settings
		pointData = [];
		caption.find('tr.chartcaption__row').each(function (index, el) {
			el = $(el);
			pointData.push(el.attr('data-graphique-point') + '~' + el.find('.chartcaption__tint-option.state--selected').attr('data-color-index'));
		});
		pointData = pointData.join('|');

		const graphHasToBeCreated = containerEl.attr(HCH._chartContextMap.graphId) === "";
		const graphData = {
			nom: graphName,
			site_id: containerEl.attr(HCH._chartContextMap.siteId),
			type: "standard",
			points: pointData
		};
		if(!graphHasToBeCreated) { graphData["chart_id"] = containerEl.attr(HCH._chartContextMap.graphId); }

		$.ajax({
			url: G.config.SERVER + 'apigv/charts/save',
			type: graphHasToBeCreated ? 'POST' : 'PUT',
			headers: {
				"Content-Type": "application/json",
				"Authorization": "Bearer "+G.model.userApiKey
			},
			data: JSON.stringify(graphData),
			dataType: "json",
			error: function (xhr, textStatus, errorThrown) {
				HCH._loadError('[HCH._initCaption - save-graph] ', xhr, textStatus, errorThrown);
			},
			success: function (data) {
				if (data.status === 'error')
					showError(data.error);
				else if (data.status === "success"){
					showSuccess(G.config.LOCALE_RETRIEVE('general.saveSuccess'));
					if ($('#selGraphiques').find("option[value='"+data.chart_id+"']").length == 0) {
						var newOption = new Option(graphName, data.chart_id, true, true);
						$('#selGraphiques').append(newOption);
					}
				}
			}
		});
	};

	/**
	 * Initializes DOM and highcharts context
	 * @param containerSel        container selector
	 * @param hchConf             highcharts configuration
	 * @param usePreloader        whether to use a preloader
	 * @param useCaption          whether to use a caption table
	 * @param useNotes            whether to use notes
	 * @param lang                language forced definition
	 * @returns {Highcharts.Chart}
	 */
	HCH.init = function (containerSel, hchConf, usePreloader, useCaption, useNotes, lang, isStockChart = true) {
		var
			guid = G.config.GET_GUID(),
			str = '', typesOptions,
			chart,
			containerEl = $(containerSel)
		;
		containerEl.attr('data-guid', guid);
		containerEl.toggleClass('mod--use-preloader', usePreloader);
		containerEl.toggleClass('mod--use-caption', useCaption);
		containerEl.toggleClass('mod--use-notes', useNotes);

		if (usePreloader) {
			str += '<div class="' + HCH.CLASS_PRELOADER + ' hch-show-loading async-loader">'
				+ '<svg class="circular" viewBox="25 25 50 50"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"></circle></svg>'
				+ '</div>';
		}

		str += '<div class="' + HCH.CLASS_CHART + ' hch-show-hasdata"></div>';

		if (useCaption) {
			str += '<div class="' + HCH.CLASS_CAPTION + ' hch-show-hasdata">'
				+ '<div class="gvg-r">'
				+ '<div class="gvg-6on6">';
			if(HCH._isInlineCaption(containerEl)){
				str += '<div class="hch-caption-table"></div>';
			}
			else{
				str += '<table class="hch-caption-table gv-table gv-table--no-stripes"><tbody class="ui-sortable"></tbody></table>';
			}
			str += '</div>'
				+ '</div>'
				+ '<div class="gvg-r hch-show-pending-changes">'
				+ '<div class="gvg-3on6--narrow gvg-6on6">'
				+ '<input type="text" placeholder="' + G.config.LOCALE_RETRIEVE('hch.graphSetName') + '" title="' + G.config.LOCALE_RETRIEVE('hch.graphName') + '" class="shake-horizontal graph-name uicomp__input" />'
				+ '</div>'
				+ '<div class="gvg-3on6--narrow gvg-6on6 text-right">'
				+ '<div class="chartcaption__graph-save uicomp__button uicomp--brand btn--medium">'
				+ '<i class="fal fa-arrow-alt-to-bottom">&nbsp;</i>'
				+ '<span>' + G.config.LOCALE_RETRIEVE('hch.graphSave') + '</span></div>'
				+ '</div>'
				+ '</div>'
				+ '</div>';
		}
		containerEl.append($(str));

		if(useNotes){

			hchConf = Object.assign(hchConf, {
				exporting: {
					buttons: {
						contextButton: {
							menuItems: ['printChart', 'separator', 'addNote', 'removeNote', 'separator', 'downloadPNG', 'downloadSVG', 'downloadCSV', 'downloadXLS']
						}
					},
					menuItemDefinitions: {
						addNote: {
							onclick: function () {
								// Si le graphique possède une serie piechart et qu'elle est visible
								// Alors on n'affiche pas le formulaire d'annotation
								const isChartPieChart = this.series.findIndex(function(hchSerie) {
									if(hchSerie.options.type == "pie") {
										return hchSerie.visible;
									}

									return false;
								}) != -1;
								if(isChartPieChart) showError(G.config.LOCALE_RETRIEVE('hch.addNoteNotPossibleToPieChart'));
								else HCH._notesAddOpen(this);

							},
							text: G.config.LOCALE_RETRIEVE('highchart.addNote')
						},
						removeNote: {
							onclick: function () {
								HCH._notesDeleteOpen(this);
							},
							text: G.config.LOCALE_RETRIEVE('highchart.removeNote')
						}
					}
				}

			});

			// ---   INITIALIZE TYPES OPTIONS

			typesOptions = '';
			for(i = 0, ilen = HCH.NOTE_TYPES.length; i < ilen; ++i)
				typesOptions += '<option value="' + HCH.NOTE_TYPES[i] + '">'+HCH.NOTE_TYPES[i]+'</option>';


			// ---   BUILD DELETE NOTE FORM

			str = '<div id="deletenote__form-' + guid + '" class="note__form gv-header__data-filters">'
				+ '<div class="gvg-r">'
				+ '<div class="gvg-6on6 gvg-1on6--narrow"><label class="uicomp__label">##deleteNoteNoteSelectLabel##</label></div>'
				+ '<div class="gvg-6on6 gvg-5on6--narrow"><select id="deletenote__form-inp__note-' + guid + '" data-nosearch style="width:320px;"></select></div>'
				+ '</div>'

				+ '<div class="gvg-r">'
				+ '<button id="deletenote__form-submit-' + guid + '" class="uicomp__button uicomp--green">##deleteNoteSubmitLabel##</button>'
				+ '<button id="deletenote__form-close-' + guid + '" class="uicomp__button note__form-close">##addNoteCloseLabel##</button>'
				+ '</div>'

				+ '</div>';


			// ---   BUILD ADD NOTE FORM

			str += '<div id="addnote__form-' + guid + '" class="note__form gv-header__data-filters">'

				// ---   block #01: point
				+ '<div class="gvg-r">'
				+ '<div class="gvg-6on6 gvg-1on6--narrow"><label class="uicomp__label">##addNotePointSelectLabel##</label></div>'
				+ '<div class="gvg-6on6 gvg-5on6--narrow"><select id="addnote__form-inp__point-' + guid + '" data-nosearch style="width:320px;"></select></div>'
				+ '</div>'

				// ---   block #02: from, to
				+ '<div class="gvg-r">'
					+ '<div class="gvg-1on6"><label class="uicomp__label">##addNoteDateLabel## <i class="fas fa-info-circle gv-tip text-grey-medium" title="##addNoteDateInfo##"></i></label></div>'
					+ '<div class="gvg-6on6 gvg-5on6--narrow">'
						+ '<label class="uicomp__label uicomp--no-collapse">##addNoteDateFromLabel##</label>'
						+ '<div class="uicomp__input uicomp__input--timestamp">'
							+ '<input id="addnote__form-inp__from-' + guid + '" type="text" placeholder="##addNoteDateFromPlaceholder##" /><i class="far fa-clock"></i>'
						+ '</div>'
					+ '</div>'
				+ '</div>'
				+ '<div class="gvg-r">'
					+ '<div class="gvg-1on6"><label class="uicomp__label">&nbsp;</label></div>'
					+ '<div class="gvg-6on6 gvg-5on6--narrow">'
						+ '<label class="uicomp__label uicomp--no-collapse">##addNoteDateToLabel##</label>'
						+ '<div class="uicomp__input uicomp__input--timestamp">'
							+ '<input id="addnote__form-inp__to-' + guid + '" type="text" placeholder="##addNoteDateToPlaceholder##" /><i class="far fa-clock"></i>'
						+ '</div>'
					+ '</div>'
				+ '</div>'

				// ---   block #03: type, title, desc
				+ '<div class="gvg-r">'
				+ '<div class="gvg-6on6">'
				+ '<select id="addnote__form-inp__type-' + guid + '" data-nosearch class="note__form-inp__type">' + typesOptions + '</select>'
				+ '<input id="addnote__form-inp__title-' + guid + '" type="text" class="note__form-inp__title uicomp__input" placeholder="##addNoteTitlePlaceholder##" />'
				+ '<br />'
				+ '<textarea id="addnote__form-inp__desc-' + guid + '" class="uicomp__input" placeholder="##addNoteDescPlaceholder##"></textarea>'
				+ '</div>'
				+ '</div>'

				// ---   block #04: submit
				+ '<div class="gvg-r">'
					+ '<button id="addnote__form-submit-' + guid + '" class="uicomp__button uicomp--green">##addNoteSubmitLabel##</button>'
					+ '<button id="addnote__form-close-' + guid + '" class="uicomp__button note__form-close">##addNoteCloseLabel##</button>'
				+ '</div>'

				+ '</div>';

			// ---   I18N
			for(var i = 0, matches = str.match(/\##(.*?)\##/g), ilen = matches.length; i < ilen; ++i)
				str = str.replace(matches[i], G.config.LOCALE_RETRIEVE('hch.' + [matches[i].substr(2, matches[i].length - 4)]));

			containerEl.append($(str));


			// ---   INITIALIZE TYPE SELECT2

			var typesSelectFormatter = function(s) {
				return $('<img src="' + HCH._notesGetTypeFile(s.id) + '" alt="" />' + s.id);
			};
			$('#addnote__form-inp__type-' + guid).select2({
				minimumResultsForSearch: -1,
				templateResult: typesSelectFormatter,
				templateSelection: typesSelectFormatter
			});


			// ---   INITIALIZE DATE INPUT BEHAVIOUR

			$('#addnote__form-inp__from-' + guid + ', #addnote__form-inp__to-' + guid)
				.on('focus', HCH._notesSetDateFromMouse)
				.on('blur', HCH._notesSetDateFromMouse);


			$('.note__form-close').on('click', function(){
				containerEl.find('.note__form').removeClass('state--opened');
			});

			$('#addnote__form-submit-' + guid).on('click', function () {
				var
					fdate = function(v){
						return isfilled(v) ?
							moment(v,  'DD/MM/YYYY hh:mm').format('YYYY-MM-DD hh:mm') :
							null;
					},
					data = {
						start: $('#addnote__form-inp__from-' + guid).val(),
						end: $('#addnote__form-inp__to-' + guid).val(),
						pointId: $('#addnote__form-inp__point-' + guid).val(),
						type: $('#addnote__form-inp__type-' + guid).val(),
						title: $('#addnote__form-inp__title-' + guid).val(),
						content: $('#addnote__form-inp__desc-' + guid).val()
					};

				data.start = fdate(data.start);
				data.end = fdate(data.end);

				$.ajax({
					url: G.config.SERVER + 'apigv/charts/annotation',
					dataType: 'json',
					method: 'POST',
					headers: {
						"Content-Type": "application/json",
						"Authorization": "Bearer "+G.model.userApiKey
					},
					data: JSON.stringify(data),
					success: function(data){
						if(data.status === 'success') {
							showSuccess(data.response.txt);
							HCH._notesAddReset(guid);
							HCH._notesInsert(containerEl, data.response);
							containerEl.find('.note__form').removeClass('state--opened');
						}
						else if(data.error)
							showError(data.error);
					},
					error: function (xhr, textStatus, errorThrown) {
						HCH._loadError('loadSeries', xhr, textStatus, errorThrown);
					}
				})
			});

			$('#deletenote__form-submit-' + guid).on('click', function () {
				var params = {
					idAnnotation: $('#deletenote__form-inp__note-' + guid).val()
				};

				$.ajax({
					url: G.config.SERVER + 'apigv/charts/annotationDelete',
					dataType: 'json',
					type:'DELETE',
					headers: {
						"Content-Type": "application/json",
						"Authorization": "Bearer "+G.model.userApiKey
					},
					data: JSON.stringify(params),
					success: function(data){
						if(data.status === 'success') {
							showSuccess(data.response.txt);
							HCH._notesDeleteReset(guid);
							containerEl.find('.note__form').removeClass('state--opened');

							for(var i = 0, notes = chart.get('notes').points, ilen = notes.length; i < ilen; ++i){
								if(notes[i].id == params.idAnnotation){
									chart.get('notes').removePoint(i, true);
									break;
								}
							}
						}
						else if(data.error)
							showError(data.error);
					},
					error: function (xhr, textStatus, errorThrown) {
						HCH._loadError('loadSeries', xhr, textStatus, errorThrown);
					}
				})
			});
		}

		if(typeof(lang) !== 'undefined'){
			Highcharts.setOptions({
				lang: lang
			});
		}

		if(isStockChart) {
			chart = Highcharts.stockChart(containerEl.find('.' + HCH.CLASS_CHART)[0], hchConf);
		} else {
			chart = Highcharts.chart(containerEl.find('.' + HCH.CLASS_CHART)[0], hchConf);
		}

		if (useCaption)
			HCH._initCaption(containerEl);

		G.ui.tippedInit(containerEl);
		HCH._chartState(containerEl, HCH._statesMap.nodata);

		return chart;
	};
	
	HCH.loadDataSite = function (containerEl, siteId, mode, dataOptions, completeCallback) {
		var dataAjax = deepmerge({
			idSite: siteId,
			mode: mode,
			dateDebut: containerEl.attr(HCH._chartContextMap.from),
			// dateFin: containerEl.attr(HCH._chartContextMap.to)
		}, dataOptions || {});
		console.log('dataOptions',dataOptions);
		console.log('[HCH._chartContextMap]',HCH._chartContextMap,containerEl.attr(HCH._chartContextMap.to));
		
		$.ajax({
			url: '/apigv/indicators/datasite/'+siteId,
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer "+G.model.userApiKey
            },
			type: 'POST',
			dataType: 'json',
			data: JSON.stringify(dataAjax),
			beforeSend: function () {
				HCH._chartState(containerEl, HCH._statesMap.loading);
			},
			error: function (xhr, textStatus, errorThrown) {
				HCH._loadError('loadIndicator', xhr, textStatus, errorThrown);
				if(completeCallback)
					completeCallback(false);
			},
			success: function (data) {
				HCH.chartReset(containerEl);
				HCH._addGraph(containerEl, data.response);
				HCH._getChart(containerEl).reflow();
				if(completeCallback)
					completeCallback(true);
				var chart = HCH._getChart(containerEl);
				HCH._getChart(containerEl).reflow();
			}
		});
	};
	
	HCH.loadDataAggregated = function (containerEl, mode, dataOptions, completeCallback) {
		var dataAjax = deepmerge({
			mode: mode,
			dateDebut: containerEl.attr(HCH._chartContextMap.from),
			// dateFin: containerEl.attr(HCH._chartContextMap.to)
		}, dataOptions || {});
		console.log('dataOptions',dataOptions);
		console.log('[HCH._chartContextMap]',HCH._chartContextMap,containerEl.attr(HCH._chartContextMap.to));
		
		$.ajax({
			url: '/apigv/indicators/dataaggregated',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer "+G.model.userApiKey
            },
			type: 'POST',
			dataType: 'json',
			data: JSON.stringify(dataAjax),
			beforeSend: function () {
				HCH._chartState(containerEl, HCH._statesMap.loading);
			},
			error: function (xhr, textStatus, errorThrown) {
				HCH._loadError('loadIndicator', xhr, textStatus, errorThrown);
				if(completeCallback)
					completeCallback(false);
			},
			success: function (data) {
				HCH.chartReset(containerEl);
				HCH._addGraph(containerEl, data.response);
				HCH._getChart(containerEl).reflow();
				if(completeCallback)
					completeCallback(true);
				var chart = HCH._getChart(containerEl);
				HCH._getChart(containerEl).reflow();
			}
		});
	};

	HCH.applyDisabledPeriods = function (sectionId, periodsDisabled) {
		var $select = $("#indicators-panel-data-" + sectionId + " .period-select");
		if (!$select.length) return;

		// Sauvegarde unique d'une copie propre (sans cache Select2 ni état sélectionné)
		if (!$select.data("allOptions")) {
			$select.data("allOptions",
			$select.find("option").clone()
				.removeAttr("data-select2-id")
				.removeAttr("selected")
				.prop("selected", false)
			);
		}

		var disabled = (periodsDisabled || []).map(String);
		var current  = String($select.val());

		$select.empty().append(
			$select.data("allOptions").clone().filter(function () {
			return disabled.indexOf(String(this.value)) === -1;
			})
		);

		if (disabled.indexOf(current) !== -1 || !$select.find('option[value="' + current + '"]').length) {
			current = $select.find("option:first").val();
		}
		$select.val(current).trigger("change.select2");
	};

	HCH.loadIndicator = function (containerEl, indicatorId, dataOptions, completeCallback) {
		containerEl.find('.note__form').removeClass('state--opened');
		var dataAjax = deepmerge({
			idIndicateur: indicatorId,
			dateDebut: containerEl.attr(HCH._chartContextMap.from),
			dateFin: containerEl.attr(HCH._chartContextMap.to)
		}, dataOptions || {});
		if(exists(dataAjax.sectionId) && !$('#analyse-scale_auto_'+dataAjax.sectionId).is(':checked') ){
			if($('#analyse-chart_min_'+dataAjax.sectionId).val() != '' && $('#indicator-'+indicatorId).hasClass('indicator--analyse') ){
				dataAjax.min = $('#analyse-chart_min_'+dataAjax.sectionId).val();
				dataAjax.max = $('#analyse-chart_max_'+dataAjax.sectionId).val();
			}
		}

		$.ajax({
			url: G.config.SERVER + 'frontend/histo/loadChartIndicateur',
			type: 'POST',
			dataType: 'json',
			data: dataAjax,
			beforeSend: function () {
				HCH._chartState(containerEl, HCH._statesMap.loading);
			},
			error: function (xhr, textStatus, errorThrown) {
				HCH._loadError('loadIndicator', xhr, textStatus, errorThrown);
				if(completeCallback)
					completeCallback(false);
			},
			success: function (data) {
				HCH.chartReset(containerEl);
				// Contexte du container : indicateur courant + dates réellement utilisées par le backend
				// (période éventuellement forcée/décalée) pour que les rechargements lisant directement
				// data-date-from/to (switchColumn, loadDataAggregated, loadGraph) repartent de la bonne fenêtre.
				var chartCtx = { indicateurId: indicatorId };
				if (exists(data.dateDebut) && exists(data.dateFin)) {
					chartCtx.from = data.dateDebut;
					chartCtx.to = data.dateFin;
				}
				HCH.chartContext(containerEl, chartCtx);
				if (exists(data.dateFin)) {
					$('#indicators-panel-data-' + data.section_id)
						.find('[id^="indicateurPanelDate__"]')
						.trigger({ type: 'syncdate', date: data.dateFin });
				}
				HCH._addGraph(containerEl, data);
				HCH._getChart(containerEl).reflow();
				if(completeCallback)
					completeCallback(true);
				HCH.applyDisabledPeriods(
					data.section_id || containerEl.closest("[data-sectionid]").attr("data-sectionid"),
					data.periods_disabled
				);

				var chart = HCH._getChart(containerEl);
				var chartSeries = chart.series.filter(function(serie) {
					return serie.userOptions.type !== "bubble";
				});

				if(exists(data.analyse) && data.analyse){
					$('#indicators-panel-data-'+data.section_id).find('div.toggle-chart').show();
					$('#panel-data-content-'+data.section_id+' .hch-analyse-content').show();
					$('#panel-data-content-'+data.section_id+' .hch-container-chart')
						.removeClass('gvg-6on6')
						.addClass('gvg-4on6');
					G.ui.initSelect2($('#analyse-frequency_'+data.section_id));
					G.ui.initSelect2($('#analyse-filter_'+data.section_id));

					if(chart.yAxis[0] && chart.yAxis[0].min !== undefined) $('#analyse-chart_min_'+data.section_id).val(chart.yAxis[0].min);
					if(chart.yAxis[0] && chart.yAxis[0].max !== undefined) $('#analyse-chart_max_'+data.section_id).val(chart.yAxis[0].max);

					if(exists(data.period)){
						$('#panel-data-content-'+data.section_id+' .hch-analyse-content h5.filter-period').html(data.period);
					}
				} else {
					$('#indicators-panel-data-'+data.section_id).find('div.toggle-chart').hide();
					$('#panel-data-content-'+data.section_id+' .hch-analyse-content').hide();
					$('#panel-data-content-'+data.section_id+' .hch-container-chart')
						.removeClass('gvg-4on6')
						.addClass('gvg-6on6');
				}

				$('#indicators-panel-data-'+data.section_id).find('div.switch-chart-pie').toggle(exists(data["seriesPiechart"]));

				$('#panel-data-content-'+ data.section_id).find('.analyse-target-cop, .analyse-target-compteur, .analyse-target-qualite_air, .analyse-target-temperature, .analyse-target-humidite, .analyse-target-piechart').hide();
				if(exists(data.analyse_type)){
					$('#panel-data-content-'+ data.section_id).find('.analyse-target-'+data.analyse_type).show();
					$('#hid-analyse_type_'+data.section_id).val(data.analyse_type);
					$('#hid-date_debut_'+data.section_id).val(data.dateDebut);
					$('#hid-date_fin_'+data.section_id).val(data.dateFin);
					
					if(exists(data.display_occupation) && exists(data.periode_occupation) && data.display_occupation == 1){
						$('#gvfeedback_'+data.section_id+' .gvfeedback .__content').html(data.periode_occupation);
						$('#gvfeedback_'+data.section_id).show();
					} else {
						$('#gvfeedback_'+data.section_id).hide();
					}

					switch(data.analyse_type){
						case 'cop':
							if(exists(data.min_value)){
								$('#hid-min_value_'+data.section_id).val(data.min_value);
							}
							if(exists(data.min_value_date)){
								$('#hid-min_value_date_'+data.section_id).val(data.min_value_date * 1000);
							}
							if(exists(data.max_value_date)){
								$('#hid-max_value_date_'+data.section_id).val(data.max_value_date * 1000);
							}
							if(exists(data.max_value)){
								$('#hid-max_value_'+data.section_id).val(data.max_value);
							}
							var strDetails = '';
							for(var i=0; i<data.series.length; i++){
								var s=data.series[i];
								var name = (exists(s.name)) ? s.name : '';
								var minValue = (exists(s.analyse_min.value)) ? s.analyse_min.value : '-';
								var maxValue = (exists(s.analyse_max.value)) ? s.analyse_max.value : '-';
								strDetails +=
									'<tr class="chartcaption__row analyse-analog-point-'+s.pointId+'">' +
										'<td class="chartcaption__label">' +
											'<span class="chartcaption__tints-picker-toggler link-no-decoration" style="color:'+G.clr.GV_ARR[chartSeries[i].colorIndex]+';"><i class="fa fa-square"></i></span>' +
											'<span class="chartcaption__label__name">'+ name +'</span>' +
										'</td>' +
										'<td><span class="conso-total">' + numberFormat(parseFloat(s.avgValue), parseInt(s.valueDecimals ?? 1), ".", " ") + '</span></td>' +
										'<td><span class="conso-total">' + numberFormat(parseFloat(s.minValue), parseInt(s.valueDecimals ?? 1), ".", " ") + '</span></td>' +
										'<td><span class="conso-total">' + numberFormat(parseFloat(s.maxValue), parseInt(s.valueDecimals ?? 1), ".", " ") + '</span></td>' +
									'</tr>';
							}
							$('#panel-data-content-'+ data.section_id +' .analyse-target-cop .table-cop-details tbody')
								.empty()
								.append(strDetails);
							break;
						case 'humidite':
						case 'temperature':
							//display values for each series
							var strDetails = '';
							var chart = HCH._getChart(containerEl);
							var nbElements = 0;
							var totalHours = 0;
							for(var i=0; i<data.series.length; i++){
								var s=data.series[i];
								var name = (exists(s.name)) ? s.name : '-';
								var avgValue = (exists(s.avgValue)) ? s.avgValue : '-';
								var minValue = (exists(s.analyse_min.value)) ? s.analyse_min.value : '-';
								var maxValue = (exists(s.analyse_max.value)) ? s.analyse_max.value : '-';
								var unite = (exists(s.unite_series)) ? s.unite_series : s.unite;
								var nbHours = (exists(s.nb_hours_over_threshold)) ? s.nb_hours_over_threshold : '-';
								strDetails += 
									'<tr class="chartcaption__row analyse-analog-point-'+s.pointId+'">' +
										'<td class="chartcaption__label">' +
											'<span class="chartcaption__tints-picker-toggler link-no-decoration" style="color:'+G.clr.GV_ARR[chartSeries[i].colorIndex]+';"><i class="fa fa-square"></i></span>' +
											'<span class="chartcaption__label__name">'+ name +'</span>' +
										'</td>' +
										'<td><span class="conso-total">' + avgValue + '</span>'+ unite +'</td>' +
										'<td><span class="conso-total">' + minValue + '</span>'+ unite +'</td>' +
										'<td><span class="conso-total">' + maxValue + '</span>'+ unite +'</td>' +
										'<td><span class="conso-total">' + nbHours + '</span>h</td>' +
									'</tr>';

								if(!isNaN(parseFloat(nbHours))){
									totalHours += parseFloat(nbHours);
									nbElements++;
								}
							}
							if(nbElements > 0){
								var resultInfo = parseFloat(totalHours / nbElements).toFixed(0);
								$('#analyse-resultat_'+data.section_id).val(numberFormat(resultInfo, 1, ".", " "));
								if(exists(data.suffix)){
									$('#analyse-resultat-unit_'+data.section_id).html(data.suffix);
								} else {
									$('#analyse-resultat-unit_'+data.section_id).html('');
								}
							}
							$('#panel-data-content-'+ data.section_id +' .analyse-target-'+data.analyse_type+' .table-'+data.analyse_type+'-details tbody')
								.empty()
								.append(strDetails);
							break;
						
						case 'compteur':
							if(exists(data.dju_reel) && data.dju_reel != ''){
								$('#analyse-dju_'+data.section_id).val(data.dju_reel);
							}
							if(exists(data.total)){
								$('#hid-total_value_'+data.section_id).val(data.total);
								$('#analyse-resultat_'+data.section_id).val(numberFormat(data.total, 1, ".", " "));
							}
							if(exists(data.unit)){
								$('#hid-unit_value_'+data.section_id).val(data.unit);
							}
							if(exists(data.nb_days)){
								$('#hid-nb_days_'+data.section_id).val(data.nb_days);
							}
							if(exists(data.min_value)){
								$('#hid-min_value_'+data.section_id).val(data.min_value);
							}
							if(exists(data.max_value)){
								$('#hid-max_value_'+data.section_id).val(data.max_value);
							}
							if(exists(data.unit)){
								$('#analyse-resultat-unit_'+ data.section_id ).html(data.unit);
							} else {
								$('#analyse-resultat-unit_'+ data.section_id ).html('');
							}

							//display values for each series
							var strDetails = '';
							const consoTotalForAllSeriesConso = data.series.reduce((a, b) => a + (b["total"] || 0), 0);

							for(var i=0; i<data.series.length; i++){
								var s = data.series[i];
								var sTotal = s.total ?? 0;
								var sUnit = s.unite;
								var sValueDecimals = s?.valueDecimals ?? 1;
								var sRepartition = consoTotalForAllSeriesConso !== 0
									? (sTotal * 100) / consoTotalForAllSeriesConso
									: 0;

								strDetails +=
									'<tr class="chartcaption__row analyse-conso-point analyse-conso-point-'+s.pointId+'">' +
										'<td class="chartcaption__label">' +
											'<span class="chartcaption__tints-picker-toggler link-no-decoration" style="color:'+G.clr.GV_ARR[chartSeries[i].colorIndex]+';"><i class="fa fa-square"></i></span>' +
											'<span class="chartcaption__label__name">'+ s.name +'</span>' +
										'</td>' +
										'<td><span class="conso-total">' + numberFormat(sTotal, parseInt(sValueDecimals), ".", " ") + '</span> ' + sUnit +'</td>' +
										'<td><span class="conso-repartion">' + numberFormat(sRepartition, 1, ".", " ") + '</span> %</td>' +
									'</tr>';
							}
							$('#panel-data-content-'+ data.section_id +' .analyse-target-compteur .table-conso-details tbody')
								.empty()
								.append(strDetails);
							break;
						case 'qualite_air':
							if(exists(data.min_value)){
								$('#hid-min_value_'+data.section_id).val(data.min_value);
							}
							if(exists(data.min_value_date)){
								$('#hid-min_value_date_'+data.section_id).val(data.min_value_date * 1000);
							}
							if(exists(data.max_value_date)){
								$('#hid-max_value_date_'+data.section_id).val(data.max_value_date * 1000);
							}
							if(exists(data.max_value)){
								$('#hid-max_value_'+data.section_id).val(data.max_value);
							}
							if(exists(data.series[0].co2_indice_text)){
								$('#analyse-indice_co2_'+data.section_id).val(data.series[0].co2_indice_text + ' (' +data.series[0].co2_indice+')');
							}

							var strDetails = avgCO2 = '';
							var nbCO2 = totalCO2 = 0;
							var chart = HCH._getChart(containerEl);
							for(var i=0; i<data.series.length; i++){
								var s=data.series[i];
								var name = (exists(s.name)) ? s.name : '';
								var co2indice = (exists(s.co2_indice)) ? s.co2_indice : '-';
								var maxValue = (exists(s.analyse_max.value)) ? s.analyse_max.value : '-';
								var unite = (exists(s.unite_series)) ? s.unite_series : s.unite;
								strDetails +=
									'<tr class="chartcaption__row analyse-analog-point-'+s.pointId+'">' +
										'<td class="chartcaption__label">' +
											'<span class="chartcaption__tints-picker-toggler link-no-decoration" style="color:'+G.clr.GV_ARR[chartSeries[i].colorIndex]+';"><i class="fa fa-square"></i></span>' +
											'<span class="chartcaption__label__name">'+ name +'</span>' +
										'</td>' +
										'<td><span class="conso-total">' + numberFormat(co2indice, 1, ".", " ") + '</span></td>' +
										'<td><span class="conso-total">' + numberFormat(maxValue, 1, ".", " ") + '</span> ' + unite +'</td>' +
									'</tr>';
								if(!isNaN(parseFloat(s.co2_indice))){
									totalCO2 += parseFloat(s.co2_indice);
									nbCO2++;
								}
							}

							if(nbCO2 > 0){
								avgCO2 = parseFloat(totalCO2 / nbCO2);
							}
							$('#analyse-resultat_'+data.section_id).val(numberFormat(avgCO2, 0, ".", " "));

							$('#panel-data-content-'+ data.section_id +' .analyse-target-qualite_air .table-qualite_air-details tbody')
								.empty()
								.append(strDetails);
							break;
						case 'piechart':
							var tablePiechartAnalysisDetail$ = $('#panel-data-content-'+ data.section_id +' .analyse-target-piechart .table-piechart-details tbody');
							tablePiechartAnalysisDetail$.empty();
							var chartSeriesPiechart = chartSeries.find(function(series) {
								return series.options.type == "pie";
							});

							for(var i = 0; i < data.seriesPiechart.length; i++) {
								var dataSeriePiechart = data.seriesPiechart[i];
								tablePiechartAnalysisDetail$.append(`
									<tr class="analyse-conso-point analyse-conso-point-${dataSeriePiechart.pointId}">
										<td>
											<span style="color: ${ G.clr.GV_ARR[chartSeriesPiechart.points[i].colorIndex ?? 0] }"><i class="fa fa-square"></i></span>	
											<span>${(exists(dataSeriePiechart.name)) ? dataSeriePiechart.name : ''}</span>																	
										</td>
										<td>${ numberFormat(parseFloat(dataSeriePiechart["y"]), dataSeriePiechart["valueDecimals"] ?? 1, ".", " ")} ${data["unit"]}</td>
										<td>${ numberFormat( ((dataSeriePiechart["y"] / data["total"]) * 100) , 1, ".", " ")} %</td>
									</tr>
								`);
							}
							break;
					}

					if(exists(data.analyse_avance)){
						console.log('analyse_avance', data.analyse_avance);
						if(data.analyse_avance){
							console.log('analyse_avance show');
							$('#panel-data-content-'+data.section_id+' .analyse-avance').show();
						} else {
							console.log('analyse_avance hide');
							$('#panel-data-content-'+data.section_id+' .analyse-avance').hide();
						}
					}
				}
				HCH._getChart(containerEl).reflow();
			}
		});
	};

	HCH.loadSeries = function (containerEl, siteId, pointId, pointIds, completeCallback) {
		var
			chart = HCH._getChart(containerEl),
			data = {
				pointId: pointId,
				pointIds: pointIds,
				siteId: siteId,
				typeColumn: containerEl.attr(HCH._chartContextMap.typeColumn),
				mode: containerEl.attr(HCH._chartContextMap.mode),
				consumptionPeriod: containerEl.attr(HCH._chartContextMap.consumptionPeriod),
				dateDebut: containerEl.attr(HCH._chartContextMap.from),
				dateFin: containerEl.attr(HCH._chartContextMap.to)
			};

		if(HCH.VERBOSE)
			console.log('[HCH.loadSeries] Settings:', data);

		containerEl.find('.note__form').removeClass('state--opened');

		$.ajax({
			url: G.config.SERVER + 'frontend/histo/historique',
			type: 'POST',
			data: data,
			datatype: 'json',
			error: function (xhr, textStatus, errorThrown) {
				console.log('[HCH.loadSeries] error', data);
				HCH._loadError('HCH.loadSeries', xhr, textStatus, errorThrown);
				if(completeCallback)
					completeCallback(false);
			},
			beforeSend: function () {
				HCH._chartState(containerEl, HCH._statesMap.loading);
			},
			success: function (data) {
				HCH._chartState(containerEl, HCH._statesMap.data);

				if(HCH.VERBOSE)
					console.log('[HCH.loadSeries] Loaded data: ', data);
					
				if (HCH._checkJSONError(data))
					return;

				HCH._chartState(containerEl, HCH._statesMap.pendingChanges);

				for(var i = 0, ilen = data.series.length; i < ilen; ++i){
					var sousTypeId = data.series[i]['sousTypeId'];
					if( $('#history-array-'+sousTypeId).length > 0 ){
						if(typeof(data.repartition) != 'undefined'){
							$('#totaux-'+sousTypeId).val(JSON.stringify(data.repartition));
						}
						var str = '';
						var total = 0;
						for( var p1 in data['conso'][ sousTypeId ]){
							str +=  '<tr>' +
									'<td>'+moment(p1, 'x').format("DD/MM/YYYY")+'</td>'+
									'<td>'+new Intl.NumberFormat().format(data['conso'][ sousTypeId ][p1])+' '+data.series[i].unite+'</td>'+
									'</tr>';
							total += data['conso'][ sousTypeId ][p1];
						}
						var tfoot = '<tr>' +
										'<td><Total/td>' +
										'<td><strong>'+new Intl.NumberFormat().format(total)+'</strong> '+data.series[i].unite+'</td>' +
									'</tr>';
						$('#history-array-'+sousTypeId+' tbody').empty().append(str);
						$('#history-array-'+sousTypeId+' tfoot').empty().append(tfoot);
					}

					HCH._getYAxis(containerEl, data.series[i]);
					HCH._addSeries(containerEl, data.series[i], chart.series.length, {
						zIndex: chart.series.length
					});
				}
				HCH._chartReflow(containerEl, false);

				// réinitialise le tooltip (références aux séries supprimées par chartReset) puis redessine
				chart.tooltip.hide(0);
				chart.pointer.reset(false, 0);
				chart.redraw(false);

				if(completeCallback)
					completeCallback(true);
			}
		})
	};

	HCH.loadPieData = function (containerEl, data, completeCallback) {
		var
			chart = HCH._getChart(containerEl),
			data = {
				data: data
			};

		if(exists(chart.series[0])){
			chart.series[0].remove(false);
		}
		if(exists(chart.yAxis[0])){
			chart.yAxis[0].remove(false);
		}

		var options = Highcharts.merge({
			type: 'pie',
			data: data.data
		});

		chart.addSeries(options);
		chart.update({ plotOptions: { pie: { allowPointSelect: true, cursor: 'pointer', dataLabels: { enabled: true, format: '<b>{point.name}</b>: {point.percentage:.1f} %' } } }});
	};

	HCH.loadDataStandard = function (containerEl, data, ticks, completeCallback) {
		var
			chart = HCH._getChart(containerEl);
			
		if (!data.couleur){
			data.couleur = 0;
			if(HCH.VERBOSE) 
				console.log('---> add default color value', data.couleur, ' to index: ', 0);
		}

		var options = Highcharts.merge({
			type: data.typeGraphique,
			data: data.data,
			colorIndex: data.couleur,
			name: data.name,
			id: 'id-' + data.pointId,
			marker: {
				symbol: 'circle'
			},
			tooltip: {
				valueSuffix: data.unite
			},
			yAxis: HCH._getYAxisId(data),
			yAxisId: HCH._getYAxisId(data)
		}, options || {});

		HCH._getYAxis(containerEl, data);
		chart.addSeries(options);

		if (exists(ticks) && ticks.length > 0) {
			if(typeof(data.data[0]['x']) == 'undefined'){
				fromTstamp = data.data[0][0];
			} else {
				fromTstamp = data.data[0]['x'];
			}
			if(typeof(data.data[data.data.length - 1]['x']) == 'undefined'){
				toTstamp = data.data[data.data.length - 1][0];
			} else {
				toTstamp = data.data[data.data.length - 1]['x'];
			}

			for (i = 0, ilen = ticks.length; i < ilen; ++i) {
				t = {
					fromY: parseFloat(ticks[i][0]),
					toY: parseFloat(ticks[i][1]),
					orientation: null,
					style: ticks[i][2]
				};

				if(t.style === 'status-ok')
					continue;

				t.orientation = (t.fromY > t.toY) ? 'min' : 'max'

				t = HCH._getColorConfigFromStyle(t.style, t);

				t.arearange = {
					id: 'tick' + i + '_arearange',
					yAxis: options.yAxis,
					type: 'arearange',
					className: 'hidden-dataset threshold-arearange hch--threshold-' + t.orientation + '-' + t.clrRef,
					// zIndex: 9,
					colorIndex: G.clr.GV_ARR.indexOf(t.clr),
					showInLegend: false,
					marker: {
						enabled: false,
						symbol: 'circle',
						fillColor: '#00000000',
						states: {
							hover: {
								animation: false
							}
						}
					},
					data: [
						[fromTstamp, t.fromY, t.toY],
						[toTstamp, t.fromY, t.toY]
					]
				};

				t.line = {
					id: 'tick' + i + '_line',
					yAxis: options.yAxis,
					type: 'line',
					className: 'hidden-dataset threshold-line hch--threshold-' + t.orientation + '-' + t.clrRef,
					colorIndex: G.clr.GV_ARR.indexOf(t.clr),
					showInLegend: false,
					marker: {
						enabled: false,
						symbol: 'circle',
						states: {
							select: {},
							hover: {
								animation: false
							}
						}
					},
					data: [
						[fromTstamp, t.fromY],
						[toTstamp, t.fromY]
					]
				};

				try{
					chart.addSeries(t.arearange, false);
					chart.addSeries(t.line, true);
				}
				catch(err){
					console.log('\t[HCH._addSeries] An error occurred while adding tick series', err, t);
				}
			}
		}

		
	};

	HCH.loadData = function (containerEl, dataRaw, completeCallback) {
		var
			chart = HCH._getChart(containerEl),
			data = {
				dataRaw: dataRaw
			};

		if(exists(chart.series[0])){
			chart.series[0].remove(false);
		}
		
		var options = Highcharts.merge({
			data: data.dataRaw,
			name: 'Sender Finger',
			id: 1,
			zIndex: 1,
			marker: {
				symbol: 'circle'
			},
			type: 'line',
			yAxis: 'scan'
		});
		chart.addSeries(options);
	};

	/**
	 *
	 * @param containerEl         container pointer
	 * @param graphId             dataset ID
	 * @param dataOptions         chartOptions merged to chart configuration
	 * @param completeCallback
	 */
	HCH.loadGraph = function (containerEl, graphId, dataOptions, completeCallback) {
		if (graphId === '-1' || graphId === '')
			return;

		var from, to, data, source;

		from = containerEl.attr(HCH._chartContextMap.from);
		to = containerEl.attr(HCH._chartContextMap.to);

		source = {
			graphiqueId: graphId
		};

		if(isobj(dataOptions) && (dataOptions.hasOwnProperty('dateDebut') && dataOptions.dateDebut !== null) ){
			source.dateDebut = dataOptions.dateDebut;
		} else {
			if(!!from || isobj(dataOptions) || (typeof(dataOptions) == 'object' && !dataOptions.hasOwnProperty('dateDebut'))){
				source.dateDebut = from;
			}
		}
		if(isobj(dataOptions) && (dataOptions.hasOwnProperty('dateFin') && dataOptions.dateFin !== null ) ){
			source.dateFin = dataOptions.dateFin;
		} else {
			if(!!from || isobj(dataOptions) || isobj(dataOptions) && !dataOptions.hasOwnProperty('dateDebut')){
				source.dateFin = to;
			}
		}
		
		data = deepmerge(dataOptions || {}, source);

		if(HCH.VERBOSE)
			console.log('[HCH.loadGraph] Settings:', data);

		containerEl.find('.note__form').removeClass('state--opened');

		$.ajax({
			url: G.config.SERVER + 'frontend/histo/historique',
			type: 'POST',
			data: data,
			beforeSend: function () {
				HCH._chartState(containerEl, HCH._statesMap.loading);
			},
			error: function (xhr, textStatus, errorThrown) {
				HCH.chartReset(containerEl);
				HCH._chartState(containerEl, HCH._statesMap.nodata);
				HCH._loadError('HCH.loadGraph', xhr, textStatus, errorThrown);
				if(completeCallback)
					completeCallback(false);
			},
			success: function (data) {
				HCH.chartContext(containerEl, {
					graphId: graphId
				});
				HCH._addGraph(containerEl, data);
				var chart = HCH._getChart(containerEl);
				var chartSeries = chart.series.filter(function(serie) {
					return serie.userOptions.type !== "bubble";
				});
				if(exists(data.analyse) && data.analyse){
					$('#indicators-panel-data-'+data.section_id).find('div.toggle-chart').show();
					$('#panel-data-content-'+data.section_id+' .hch-analyse-content').show();
					$('#panel-data-content-'+data.section_id+' .hch-container-chart')
						.removeClass('gvg-6on6')
						.addClass('gvg-4on6');
					G.ui.initSelect2($('#analyse-frequency_'+data.section_id));
					G.ui.initSelect2($('#analyse-filter_'+data.section_id));
				} else {
					$('#indicators-panel-data-'+data.section_id).find('div.toggle-chart').hide();
					$('#panel-data-content-'+data.section_id+' .hch-analyse-content').hide();
					$('#panel-data-content-'+data.section_id+' .hch-container-chart')
						.removeClass('gvg-4on6')
						.addClass('gvg-6on6');
				}

				$('#indicators-panel-data-'+data.section_id).find('div.switch-chart-pie').toggle(exists(data["seriesPiechart"]));

				if(exists(data.analyse_type)){
					$('#panel-data-content-'+ data.section_id).find('.analyse-target-cop, .analyse-target-compteur, .analyse-target-qualite_air, .analyse-target-temperature, .analyse-target-piechart').hide();
					$('.analyse-target-'+data.analyse_type).show();
					$('#hid-analyse_type_'+data.section_id).val(data.analyse_type);
					$('#hid-date_debut_'+data.section_id).val(data.dateDebut);
					$('#hid-date_fin_'+data.section_id).val(data.dateFin);
					
					if(exists(data.display_occupation) && exists(data.periode_occupation) && data.display_occupation == 1){
						$('#gvfeedback_'+data.section_id+' .gvfeedback .__content').html(data.periode_occupation);
						$('#gvfeedback_'+data.section_id).show();
					} else {
						$('#gvfeedback_'+data.section_id).hide();
					}

					switch(data.analyse_type){
						case 'compteur':
							if(exists(data.dju_reel) && data.dju_reel != ''){
								$('#analyse-dju_'+data.section_id).val(data.dju_reel);
							}
							if(exists(data.total)){
								$('#hid-total_value_'+data.section_id).val(data.total);
								$('#analyse-resultat_'+data.section_id).val(numberFormat(data.total, 1, ".", " "));
							}
							if(exists(data.unit)){
								$('#hid-unit_value_'+data.section_id).val(data.unit);
							}
							if(exists(data.nb_days)){
								$('#hid-nb_days_'+data.section_id).val(data.nb_days);
							}
							if(exists(data.min_value)){
								$('#hid-min_value_'+data.section_id).val(data.min_value);
							}
							if(exists(data.max_value)){
								$('#hid-max_value_'+data.section_id).val(data.max_value);
							}
							if(exists(data.unit)){
								$('#analyse-resultat-unit_'+ data.section_id ).html(data.unit);
							} else {
								$('#analyse-resultat-unit_'+ data.section_id ).html('');
							}

							//display values for each series
							var strDetails = '';
							for(var i=0; i<data.series.length; i++){
								var s=data.series[i];

								strDetails +=
									'<tr class="chartcaption__row analyse-conso-point analyse-conso-point-'+s.pointId+'">' +
										'<td class="chartcaption__label">' +
											'<span class="chartcaption__tints-picker-toggler link-no-decoration" style="color:'+G.clr.GV_ARR[chartSeries[i].colorIndex]+';"><i class="fa fa-square"></i></span>' +
											'<span class="chartcaption__label__name">'+ s.name +'</span>' +
										'</td>' +
										'<td><span class="conso-total">' + numberFormat(s.total, parseInt(s.valueDecimals ?? 1), ".", " ") + '</span> ' + s.unite +'</td>' +
									'</tr>';
							}
							$('#panel-data-content-'+ data.section_id +' .analyse-target-compteur .table-conso-details tbody')
								.empty()
								.append(strDetails);
							break;
					}
				}

				if(exists(data.analyse_avance)){
					if(data.analyse_avance){
						$('#panel-data-content-'+data.section_id+' .analyse-avance').show();
					} else {
						$('#panel-data-content-'+data.section_id+' .analyse-avance').hide();
					}
				}
				if(completeCallback)
					completeCallback(true);
			}
		});
	};

	HCH._addGraph = function (containerEl, data) {
		var
			i,
			ilen
			graphIsPieChart = (data.type == "piechart");

		if(HCH.VERBOSE)
			console.log('[HCH._addGraph]', data);

		HCH.chartReset(containerEl);

		if (HCH._checkJSONError(data))
			return;

		HCH._chartSetTitle(containerEl, data, data.dateDebut, data.dateFin);
		HCH._chartState(containerEl, HCH._statesMap.data);

		if(exists(data.series)){
			for (i = 0, ilen = data.series.length; i < ilen; ++i) {
				if(HCH.VERBOSE)
					console.log('[HCH._addGraph] addSeries', data.series[i]);
	
				HCH._addSeries(containerEl, data.series[i], i, {
					zIndex: ilen - i
				});
			}
		}

		if(graphIsPieChart) {
			HCH._getChart(containerEl).series.forEach(function(serie) {
				serie.setVisible(false, false);
			});
			HCH._getChart(containerEl).yAxis.forEach(function(yAxis) {
				yAxis.update({ visible: false }, false);
			});
			HCH._getChart(containerEl).xAxis.forEach(function(xAxis) {
				xAxis.update({ visible: false }, false);
			});

			HCH._addSeriesPiechart(containerEl, data.seriesPiechart, {
                plotOptions: {
                    pie: {
                        dataLabels: {
                            enabled: true,
                            useHTML: true,
                            formatter: function () {
                                const maxY = Math.max(...this.series.data.map(p => p.y));
                                const isMax = this.point.y === maxY;
                                return `
                                  <i class="fas fa-square" style="color:${G.clr.GV_ARR[this.point.colorIndex]}"></i>
                                  <b>${this.point.name} : </b>
                                  ${isMax ? `
                                    <i class="fas fa-bolt"
                                    style="
                                      color:#ffcc00;
                                      margin-left:6px;
                                    "></i>
                                  ` : ''}
                                  <span style="opacity:0.8">${Highcharts.numberFormat(this.percentage, 1)}%</span>
                                `;
                            },
                            distance: 25,
                            alignTo: 'connectors',
                            connectorPadding: 0,
                            softConnector: false,
                            filter: { property: 'percentage', operator: '>', value: 5 },
                            style: { fontWeight: 'bold', color: 'white', textOutline: 'none' }
                        },
                        showInLegend: true
                    }
                },
				tooltip: {
					useHTML: true,
					valueSuffix: data.unit
				}
			});
		}

		HCH._getChart(containerEl).update({
			legend: {
				enabled: !graphIsPieChart,
			},
			seriesPiechart: exists(data.seriesPiechart) ? data.seriesPiechart : null,
			piechartViewActivated: graphIsPieChart,
			piechartUnit: data.unit
		});

		HCH._chartReflow(containerEl, true);
	};

	HCH._chartReflow = function(containerEl, doRedraw){
		var chart = HCH._getChart(containerEl);

		if(!isbool(doRedraw))
			doRedraw = false;

		if(containerEl.closest('.indicateurs-panel-data').is('.panel-data--active')){
			chart.setSize(containerEl.width(), containerEl.height());
			chart.reflow();
			if(doRedraw)
				chart.redraw(false);
		}
	};

	HCH._chartContextMap = Object.freeze({
		from: 'data-date-from',
		to: 'data-date-to',
		siteId: 'data-site-id',
		graphId: 'data-graph-id',
		typeColumn: 'data-column-type', //stacked or column standard
		mode: 'data-mode', //conso or not
		consumptionPeriod: 'data-consumption-period', // day, month
		indicateurId: 'data-indicateur-id'
	});

	HCH._statesMap = Object.freeze({
		nodata: 'hch-container--nodata',
		data: '',
		loading: 'hch-container--loading',
		pendingChanges: 'hch-container--pending-changes'
	});

	/**
	 * Empties chart content
	 * @param containerEl      jQuery pointer to container element
	 */
	HCH.chartReset = function (containerEl) {
		var
			chart = HCH._getChart(containerEl),
			caption = HCH._getCaption(containerEl);
		if(chart !== undefined ){
			while (chart.series && chart.series.length > 0){
				chart.series[0].remove(false);
			}
			while (chart.yAxis && chart.yAxis.length > 0){
				chart.yAxis[0].remove(false);
			}
			chart.xAxis.forEach(function(xAxis) {
				xAxis.update({ visible: true }, false);
			});
			chart.xAxis[0].setExtremes();
			chart.zoomOut();
			chart.setTitle({text: ''}, {text: ''}, true);
		}

		if (caption)
			caption.find('tbody').html('');

		HCH._chartState(containerEl, HCH._statesMap.nodata);
	};

	/**
	 *
	 * @param containerEl      jQuery pointer to container element
	 * @param context         object      { from, to, siteId, graphId }
	 * @param autofill      boolean      whether to create all contexts parameters even if empty
	 */
	HCH.chartContext = function (containerEl, context, autofill) {
		if(HCH.VERBOSE)
			console.log('[HCH.chartContext] ' + JSON.stringify(context) + ' on: ', containerEl);

		var
			prop,
			map = HCH._chartContextMap
		;

		if (isbool(autofill)) {
			if (!context)
				context = {};
			for (prop in map) {
				if (map.hasOwnProperty(prop))
					containerEl.attr(map[prop], context.hasOwnProperty(prop) ? context[prop] : '');
			}
		}
		else if (context) {
			for (prop in context) {
				if (context.hasOwnProperty(prop))
					containerEl.attr(map[prop], context[prop]);
			}

			// exclusions
			if (context.hasOwnProperty(map.graphId)) {
				containerEl.attr(map.indicateurId, null);
			}
			else if (context.hasOwnProperty(map.indicateurId)) {
				containerEl.attr(map.indicateurId, null);
			}
		}
	};

	/**
	 * Returns HCH container jQueryObject
	 * @param p  lazy pointer  (Highcharts.Chart, HTMLElement, jQueryObj or selector string)
	 * @param blacklistClass classe DOM à ne pas prendre en compte, par défault on ne prend pas en compte les container hch des indicateurs graphiqiues intégrés
	 * @returns {jQuery}   jQuery pointer to container element
	 */
	HCH.getContainer = function (p, blacklistClass = undefined) {
		var
			container,
			steps = [
				[p, typeof p, 'init']
			];

		var recursiveSearch = function (p, blacklistClass) {
			var downwards, upwards;
			if (typeof p === 'string' || p instanceof HTMLElement) {
				steps.push([p, typeof p, 'convert to $']);
				return recursiveSearch($(p));
			}
			else if (p instanceof Highcharts.Chart) {
				steps.push([p, typeof p, 'convert Highcharts.Chart']);
				return recursiveSearch($(p.renderTo).parent());
			}
			else if (p instanceof $) {
				if(exists(blacklistClass) && p.is('.' + blacklistClass)) {
					steps.push([p, typeof p, 'error : blacklist class']);
					return null;
				}
				else if (p.is('.' + HCH.CLASS_CONTAINER)) {
					steps.push([p[0], typeof p, '$ -> right level']);
					return p;
				}
				else {
					downwards = p.find('.' + HCH.CLASS_CONTAINER);
					if(exists(blacklistClass)) downwards = downwards.not('.' + blacklistClass);

					if (downwards.existsOnce()) {
						steps.push([p[0], typeof p, '$ -> downwards']);
						return recursiveSearch(downwards, blacklistClass);
					}
					else {
						upwards = p.closest('.' + HCH.CLASS_CONTAINER);
						if(exists(blacklistClass)) downwards = downwards.not('.' + blacklistClass);

						if (upwards.exists()) {
							steps.push([p[0], typeof p, '$ -> upwards']);
							return recursiveSearch(upwards, blacklistClass);
						}
						else {
							steps.push([p, typeof p, 'error : out of a .' + HCH.CLASS_CONTAINER + ' display list']);
							return null;
						}
					}
				}
			}
			else {
				steps.push([p, typeof p, 'error : unhandled type']);
				return null;
			}
		};


		container = recursiveSearch(p, blacklistClass);
		if (!container)
			console.warn('[HCH.getContainer] Unreachable element', steps);
		return container;
	};

	/**
	 * Returns Highcharts chart instance
	 * @param containerEl   jQuery pointer to container element
	 * @returns   {Highcharts.Chart}
	 */
	HCH._getChart = function (containerEl) {
		return containerEl.is('.' + HCH.CLASS_CHART) ? containerEl.highcharts() : containerEl.find('.' + HCH.CLASS_CHART).highcharts();
	};

	/**
	 * Returns Highcharts chart instance
	 * @param   containerEl   jQuery pointer to container element
	 * @returns jQueryObject
	 */
	HCH._getCaption = function (containerEl) {
		return containerEl.find('.' + HCH.CLASS_CAPTION);
	};
}

(function (H) {
	/** @see https://github.com/highcharts/highcharts/issues/3542 */
	H.wrap(H.SVGElement.prototype, 'show', function (p, inherit) {
		if (this.div)
			$(this.div).css({opacity: 1});
		return p.call(this, inherit);
	});

	H.wrap(H.SVGElement.prototype, 'fadeOut', function (p, duration) {
		this.hide();
		if (this.div)
			$(this.div).css({opacity: 0});
	});
})(Highcharts);
var G, p;

if(!exists(G))
	G = {};

if(!exists(G.ui))
	G.ui = {};

if(!exists(G.ui.GVGauge)){
	G.ui.GVGauge = function(qSelector, model){
		var self = this;

		this.m = {
			range: {
				valueStart: 0,
				valueEnd: 100,
				color: '#999999',
				thickness: 3,
				marginX: 25,
				marginY: 25,
			},
			tilts: {
				length: 11,
				lblOffset: 30,
				color: '#999999',
				font: "normal normal 400 16px 'Barlow Semi Condensed'",
				thickness: 2,
				offsetY: 5,
				data: [
					// value: 10, style: 'status-ok'
				]
			},
			format: {
				unit: '%',
				precision: 1,
			},
			units: {
				enabled: true,
				color: '#999999',
				lblOffset: -20,
				font: "normal normal 400 11px 'Barlow Semi Condensed'",
				thickness: 2,
				length: -6,
				every: 5,
				lblEvery: 25,
				offsetY: 4,
				format: {
					unit: '%',
					precision: 0,
				}
			},
			ticks: {
				data: [
					// valueStart: 0, valueEnd: 100, style: 'status-alert'
				],
				thicknessDefault: 0,
				thicknessActive: 8
			},
			value: {
				data: Number.NaN,
				font: "normal normal 300 50px 'Barlow Semi Condensed'",
				offsetY: -20
			}
		};
		this.m = deepmerge(this.m, model || {});
		this.el = document.querySelector(qSelector);
		$.data(this.el, 'GVGauge', this);

		this.cnv = document.createElement('canvas');
		this.ctx = this.cnv.getContext('2d');
		this.el.appendChild(this.cnv);

		this.model = model;

		window.addEventListener('resize', function(){
			self.render();
		});

		this.render();
	};
	p = G.ui.GVGauge.prototype;

	p.setValue = function(v){
		this.m.value.data = v;
		this.render();
	};
	p.render = function(){
		var
			self = this,
			cnv = this.cnv,
			ctx = this.ctx,
			mvtuc = function(t, r){
				ctx.moveTo.apply(ctx, self._tuc(c, t, r));
			},
			lntuc = function(t, r){
				ctx.lineTo.apply(ctx, self._tuc(c, t, r));
			},
			p, pt, w, h, c, r, t, ir, or, i, ilen, color, seltick, lblr,
			m = this.m;

		// ---	compute size and center

		w = this.el.offsetWidth;
		h = this.el.offsetHeight - 3;
		
		r = Math.min(
			(.5 * w) - m.range.marginX - m.tilts.lblOffset,
			h - m.range.marginY - m.tilts.lblOffset
		);
		c = {
			x: (.5 * w),
			y: (.5 * (h - r)) + r + (.25 * m.range.marginY)
		};


		if(w <= 0 || h <= 0 || isNaN(w) || isNaN(h)){
			// console.info('[GVGauge.render] Invalid size, cancel rendering process', { w: w, h: h });
			return;
		}
		else if(r <= 0){
			// console.info('[GVGauge.render] Invalid radius, cancel rendering process', { r: r });
			return;
		}


		// ---	clear

		cnv.width = w;
		cnv.height = h;
		ctx.clearRect(0, 0, w, h);


		// --- draw full range
		ctx.beginPath();
		ctx.arc(c.x, c.y, r + (.5 * m.range.thickness), -Math.PI, 0, false);
		ctx.strokeStyle = m.range.color;
		ctx.lineWidth = m.range.thickness;
		ctx.stroke();

		// ---	draw units
		if(m.units.enabled){
			ir = r + m.range.thickness;
			or = ir + m.units.length;
			lblr = r + m.units.lblOffset;

			p = Math.ceil(m.range.valueStart / m.units.every) * m.units.every;
			while(p <= m.range.valueEnd){
				t = this._value2Theta(p);

				// add tick
				ctx.beginPath();
				mvtuc(t, ir);
				lntuc(t, or);
				ctx.strokeStyle = m.units.color;
				ctx.lineWidth = m.units.thickness;
				ctx.stroke();

				// add label
				if(p % m.units.lblEvery === 0){
					pt = this._tuc(c, t, lblr);
					ctx.font = m.units.font;
					ctx.fillStyle = m.units.color;
					ctx.textAlign = "center";
					ctx.fillText(this._vFormat(p, m.units.format || m.format), pt[0], pt[1] + m.units.offsetY);
				}
				p += m.units.every;
			}
		}


		// --- current value

		color = m.range.color;
		seltick = -1;
		if(exists(m.value.data) && !isNaN(m.value.data)){
			tick_loop: for(i = 0, ilen = m.ticks.data.length; i < ilen; ++i){
				p = m.ticks.data[i];
				if(m.value.data >= p.valueStart && m.value.data < p.valueEnd){
					seltick = i;
					color = this._style2clr(p.style);
					break tick_loop;
				}
			}

			ctx.fillStyle = color;
			ctx.font = m.value.font;
			ctx.textAlign = "center";
			ctx.fillText(this._vFormat(m.value.data, m.value.format || m.format), c.x, c.y + m.value.offsetY);
		}

		//	---	ticks

		for(i = 0, ilen = m.ticks.data.length; i < ilen; ++i){
			p = m.ticks.data[i];
			t = (i == seltick) ? m.ticks.thicknessActive : m.ticks.thicknessDefault;
			if(t === 0)
				continue;
			ctx.beginPath();
			ctx.strokeStyle = this._style2clr(p.style);
			ctx.lineWidth = t;
			ctx.arc(c.x, c.y, r + (.5 * t), this._value2Theta(p.valueStart), this._value2Theta(p.valueEnd), false);
			ctx.stroke();
		}


		// --- tilts

		ir = r;
		or = ir + m.tilts.length;
		lblr = r + m.tilts.lblOffset;

		for(i = 0, ilen = m.tilts.data.length; i < ilen; ++i){
			p = m.tilts.data[i];
			t = this._value2Theta(p.value);
			color = this._style2clr(p.style);

			// add line
			ctx.beginPath();
			mvtuc(t, ir);
			lntuc(t, or);
			ctx.strokeStyle = color;
			ctx.lineWidth = m.tilts.thickness;
			ctx.stroke();

			// add label
			pt = this._tuc(c, t, lblr);
			ctx.font = m.tilts.font;
			ctx.fillStyle = color;
			ctx.textAlign = "center";
			ctx.fillText(this._vFormat(p.value, m.tilts.format || m.format), pt[0], pt[1] + m.tilts.offsetY);
		}

		//	---	draw arrow
		if(!isNaN(m.value.data)){
			or = (r - 8);
			ir = or - Math.min(.12 * or, 16);
			t = this._value2Theta(m.value.data);

			ctx.fillStyle = this._style2clr(m.ticks.data[seltick].style);
			ctx.beginPath();
			mvtuc(t, or);
			lntuc(t - this._deg2rad(5), ir);
			lntuc(t + this._deg2rad(5), ir);
			lntuc(t, or);
			ctx.fill();
		}
	};

	p._deg2rad = function(v){
		return v * Math.PI / 180;
	};
	p._style2clr = function(v){
		switch(v){
			case 'status-ok':
				return '#83C457';
			case 'status-alert':
				return '#CD402F';
			case 'status-warning':
				return '#e7a032';
			default:
				return '#999999';
		}
	};
	/** theta unit circle */
	p._tuc = function(c, t, r){
		return [
			c.x + (Math.cos(t) * r),
			c.y + (Math.sin(t) * r)
		];
	};
	p._vFormat = function(v, o){
		return G.i18n.printVal(parseFloat(v), o.precision, o.unit);
	};
	p._value2Theta = function(v){
		v = Math.max(this.m.range.valueStart, Math.min(this.m.range.valueEnd, v));
		v = (v - this.m.range.valueStart) / (this.m.range.valueEnd - this.m.range.valueStart);
		return (v * Math.PI) + Math.PI;
	};
}
(function ($, window, document) {

    const ALERT_DISPLAY_MODE = Object.freeze({
        MULTISITES: 'multisites',
        ESTATE_SITE: 'estatesite',
        SINGLE: 'single'
    });

	$.widget('globalvisio.AlertsBridge', {

		prioritiesStatuses: [true, true, true, true, true],

		_map: null,
		_list: null,
		_caption: null,
		_listeners: [],
		_preloader: null,
		_focusedSite: null,
		// isMultisitesMode: true,
        displayMode: ALERT_DISPLAY_MODE.MULTISITES,
        _searchOptions: {},
		_callbacks: null,
		_alertsColl: [],
		_alertsCounter: [0, 0, 0, 0, 0],
		_sites: [],

		options: {
			prioritiesStatus: [null, true, true, true, true],
			preloader: null,
			searchOptions: {
				onlyActive: true
			},
			map: null,
			mapOptions: {
				container: null,
				isOdyssee: false
			},
			// numbers of sites under which default mode will always be applied
			noAlertsActionThreshold: 10,
			isOdyssee: false,
			list: null,
			listOptions: {
				container: null,
				// action on sites/zones for whom not alerts are running, available values are 'hide', 'enqueue', 'default'
				noAlertsAction: 'enqueue',
				// behaviour for list folding, available values are 'free', 'single'
				folderExpandMode: 'single'
			},
			caption: null,
			captionOptions: {}
		},

		_miscUpdateFilters: function (e, data) {
			var checkboxes = $('.filters-alerts-priorities').find('input');
			for (var i = 0, ilen = data.prioritiesStatuses.length; i < ilen; ++i) {
				checkboxes.filter('[value="priority' + i + '"]').prop('checked', data.prioritiesStatuses[i]);
			}
		},

		_create: function () {
			var
				widget = this,
				alertsFilters = $('.filters-alerts-priorities'),
				inp, i, len;

			this._searchOptions = this.options.searchOptions ?? {};

			this.widgetEventPrefix = '';

			this._callbacks = {
				modelReady: this._modelAlertsLoad.bind(this),
				miscUpdateFilters: this._miscUpdateFilters.bind(this)
			};

			if (alertsFilters.length > 0) {
				alertsFilters.on('click', '.uicomp__checkbox', function (e) {
					inp = $(this).find('input');
					widget.setPriorityStatus(inp.val(), inp.prop('checked'));
				});
				this.element.on('alertsbridgeprioritiesstatuseschanged', this._callbacks.miscUpdateFilters);
			}

			this._listeners = [];
			this._sites = [];

			// ---   initialize map
			if (isfilled(this.options.map)) {
				this._map = $(this.options.map).AlertsMap(this.options.mapOptions).data('globalvisio-AlertsMap');
				if (!!this._map) {
					this._map._bridge = this;
					this._map.element.on('alertsmapfocuscaught', function (e, data) {
						widget.setFocus(data.site);
					});
					this._listeners.push(this._map);
				}
			}

			// ---   initialize preloader
			if (isfilled(this.options.preloader)) {
				this._preloader = $(this.options.preloader);
			}

			// ---   initialize caption
			if (isfilled(this.options.caption)) {
				this._caption = $(this.options.caption).AlertsCaption(this.options.captionOptions).data('globalvisio-AlertsCaption');
				if (!!this._caption) {
					this._caption._bridge = this;
					this._listeners.push(this._caption);
				}
			}

			// ---   initialize list
			if (isfilled(this.options.list)) {
				this._list = $(this.options.list).AlertsList(this.options.listOptions).data('globalvisio-AlertsList');
				this._list._bridge = this;
				this._list.element.on('alertslistfocuscaught', function (e, data) {
					widget.setFocus(data.site)
				});
				this._listeners.push(this._list);
			}

			// ---   bind listeners
			(
				/** @param b bridge */
				function (b) {
				b._listeners.forEach(function (listener) {
					b.element.on('alertsbridgefocuschanged', listener._callbacks.focuschanged);
					b.element.on('alertsbridgemodelchanged', listener._callbacks.modelchanged);
					b.element.on('alertsbridgeprioritiesstatuseschanged', listener._callbacks.prioritiesstatuseschanged);
				});
				$(document).on('responsiveBreak', (function (e) {
					b.onResponsiveBreak(e);
				}));
			}
			)(this);


			// ---   initializes states
			if (isarray(this.options.prioritiesStatuses)) {
				this.resetPrioritiesStatuses(this.options.prioritiesStatuses);
			}

			// ---   load alerts model
			this._displayPreloader(true);

			G.model.user != null ? this._callbacks.modelReady() : $(document).on('modelReady', this._callbacks.modelReady);
		},

		_destroy: function () {
			$(document).off('modelReady', this._callbacks.modelReady);
			this._callbacks.modelReady = null;

			(function (bridge) {
				bridge._listeners.map(function (listener) {
					bridge.element.off('alertsbridgefocuschanged', listener._callbacks.focusChanged);
					bridge.element.off('alertsbridgemodelchanged', listener._callbacks.modelChanged);
					bridge.element.off('alertsbridgeprioritiesstatuseschanged', listener._callbacks.prioritiesStatusesChanged);
				});
				$(document).on('responsiveBreak', (function (e) {
					bridge.onResponsiveBreak(e);
				}));
			})(this);
		},

		_triggerPriorities: function () {
			this._trigger('alertsbridgeprioritiesstatuseschanged', $.Event('alertsbridgeprioritiesstatuseschanged'), {prioritiesStatuses: this.prioritiesStatuses});
		},

		/**
		 * Resets all priority statuses with an array specifying each value.
		 * @param sArr   array containing boolean values for each priority status - ie: [null, true, true, true, true]
		 */
		resetPrioritiesStatuses: function (sArr) {
			this.prioritiesStatus = [sArr[0] === true, sArr[1] === true, sArr[2] === true, sArr[3] === true, sArr[4] === true];
			this._triggerPriorities();
		},

		/**
		 * Resets all priority statuses to a single boolean value.
		 * @param status  boolean value to be applied to each priority status
		 */
		setPrioritiesStatuses: function (status) {
			this.prioritiesStatuses = [status, status, status, status, status];
			this._triggerPriorities();
		},
		/**
		 * Defines status for a single priority level.
		 * @param l      priority level defined by an integer [1, 4] or a string [priority0, priority1, ..., priority4]
		 * @param s     boolean value applied to the priority status
		 */
		setPriorityStatus: function (l, s) {
			l = parseInt(keepNumeric(l + ''));

			if (isan(l) && l >= 0 && l <= 4) {
				this.prioritiesStatuses[l] = s;
				this._triggerPriorities();
			}
			else
				console.log('[AlertsBridge.setPriorityStatus] Invalid level value: "' + l + '"')
		},
		/**
		 * Toggle status from single priority level.
		 * @param l      priority level defined by an integer [1, 4] or a string [priority0, priority1, ..., priority4]
		 */
		togglePriorityStatus: function (l) {
			l = parseInt(keepNumeric(l + ''));
			if (isan(l) && l >= 0 && l <= 4) {
				this.prioritiesStatuses[l] = !this.prioritiesStatuses[l];
				this._triggerPriorities();
			}
			else
				console.log('[AlertsBridge.togglePriorityStatus] Invalid level value: "' + l + '"')
		},
		/**
		 * Saves focus model and apply it on display.
		 * @param site    focused site (or null)
		 */
		setFocus: function (site) {
			var formerFocusedSite = this._focusedSite;
			this._focusedSite = site;

			(function (widget, focusedSite, formerFocusedSite) {
				widget._listeners.map(function (listener) {
					listener._displayFocus(focusedSite, formerFocusedSite);
				});
			})(this, this._focusedSite, formerFocusedSite);
		},
		onResponsiveBreak: function (e) {
			if (!!this._map)
				this._map._toggleDisplay();
			if (!!this._caption)
				this._caption._toggleDisplay();
		},
		_modelAlertsLoad: function () {
			let url;
			let widget = this;
			let alertsData = [];
			let sitesLoaded = false;
			let alertsLoaded = false;
			let isRendered = false;
			let tryRender = function () {
				if (isRendered) return;
				if (widget.displayMode === ALERT_DISPLAY_MODE.MULTISITES && !widget.options.isOdyssee) {
					if (!sitesLoaded || !alertsLoaded) return;
				} else if (!alertsLoaded) {
					return;
				}
				isRendered = true;
				widget._modelAlertsLoaded(alertsData);
			};
			let loadAlerts = function () {
				if (widget.options.isOdyssee) {
					// ---   define API call
					url = G.config.API + 'getAlarmesActives';
					G.LOG(G.log.alerts, '{AlertsBridge.loadAlerts Odyssee} ajax call on: ' + url);
					G.LOG('{AlertsBridge.loadAlerts Odyssee} ajax call on: ');

					var odySites = widget._getFilteredSites(true);
					// console.log('odySites', odySites);
					odySites.forEach(function (el, index) {
						odySites[index] = el.odysecure_id + '##' + el.id;
					});
					$.ajax({
						dataType: 'json',
						data: {
							matchedSiteIds: odySites
						},
						// contentType: 'text/plain; charset=UTF-8',
						url: url,
						type: 'POST',
						error: function (xhr, textStatus) {
							if(textStatus === 'abort' || xhr?.status === 0) return;
							showError(G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
						},
						success: function (response) {
							alertsData = Array.isArray(response) ? response : [];
						},
						complete: function () {
							alertsLoaded = true;
							tryRender();
						}
					});
				} else {
					// ---   define API call
					url = G.config.APIGVALERTS + 'listAlarms';
					let queryParams = Object.assign({}, widget._searchOptions);
					if(widget.displayMode !== ALERT_DISPLAY_MODE.MULTISITES) queryParams["siteId"] = G.model.siteSelected.id;
					let queryString = new URLSearchParams(queryParams).toString();
					if(!isStrEmpty(queryString)) url += `?${queryString}`;

					G.LOG(G.log.alerts, '{AlertsBridge.loadAlerts} ajax call on: ' + url);

					$.ajax({
						url: url,
						headers: {
							"Content-Type": "application/json",
							"Authorization": "Bearer "+G.model.userApiKey
						},
						type: 'GET',
						dataType: 'json',
						error: function (xhr, textStatus) {
							if(textStatus === 'abort' || xhr?.status === 0) return;
							showError(G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
						},
						success: function(response) {
							if(response?.status === "success") alertsData = response["response"]["alerts"] || [];
						},
						complete: function () {
							alertsLoaded = true;
							tryRender();
						}
					});
				}
			};

			if($('#model_loaded').val() == '1'){
				return false;
			}
			$('#model_loaded').val('1');
			// once call
			$(document).off('modelReady', arguments.callee);
            if(G.model.siteSelected == null) this.displayMode = ALERT_DISPLAY_MODE.MULTISITES;
            else if(G.model.siteSelected.isEstateSite == 1) this.displayMode = ALERT_DISPLAY_MODE.ESTATE_SITE;
            else this.displayMode = ALERT_DISPLAY_MODE.SINGLE;
			//this.isMultisitesMode = (G.model.siteSelected == null);

			if(this.displayMode === ALERT_DISPLAY_MODE.MULTISITES) {
				$.ajax({
					url: `/apigv/sites/list`,
					type: "GET",
					headers: {
						"Content-Type": "application/json",
						"Authorization": "Bearer "+G.model.userApiKey
					},
					data: {
						withEnterprise: 1,
                        withEstateSiteChilds: 1
					},
					datatype: 'json',
					error: function (xhr, textStatus, errorThrown) {
						if(textStatus === 'abort' || xhr?.status === 0) return;
						showError(G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
					},
					success: function (data) {
						if(data?.status === 'success') {
							for (i = 0, len = data.response.sites.length; i < len; ++i) {
								widget._sites.push(new G.vo.Site(data.response.sites[i]));
							}
						}
					},
					complete: function() {
						sitesLoaded = true;
						if(widget.options.isOdyssee) loadAlerts();
						else tryRender();
					}
				});
				if(!this.options.isOdyssee) loadAlerts();
			} else {
				widget._sites = [G.model.siteSelected];
				sitesLoaded = true;
				loadAlerts();
			}
			
		},
		_modelAlertsLoaded: function (data) {
			var hasTwoColumn;

			hasTwoColumn = this.displayMode === ALERT_DISPLAY_MODE.MULTISITES && (this._map != null);

			G.LOG(G.log.alerts,
				'{AlertsBridge._modelAlertsLoaded} ',
				'DisplayMode: ' + this.displayMode,
				'hasTwoColumn: ' + hasTwoColumn
			);

			// ---   reset model
			this._alertsReset(data, this.displayMode);

			// ---   reset display
			this._listeners.map(function (listener) {
				listener._resetModel();
			});
			this._displayPreloader(false);

			this.setFocus(null);
			this._trigger('alertsbridgeprioritiesstatuseschanged', $.Event('alertsbridgeprioritiesstatuseschanged'), {prioritiesStatuses: this.prioritiesStatuses});
			if ($('.img-responsive').length > 0) {
				$('.img-responsive').css('height', $('#alerts-list').css('height'));
			}
			$('#model_loaded').val('0');
		},
		_displayPreloader: function (status) {
			if(this._preloader) {
				this._preloader.toggle(status);
				this._listeners.map(function (listener) {
					listener._toggleDisplay(!status);
				});
			}
		},
		_alertsReset: function(vo, displayMode) {
			var i, len, alert, site;

			// clear previous settings
			this._alertsColl = [];
			this._alertsCounter = [0, 0, 0, 0, 0];

			if (!isdefined(vo)) {
				return;
			}

			for (const siteAlarmToReset of this._sites) {
				siteAlarmToReset.alertsReset();
			}

			// implement alerts collection
			for (i = 0, len = vo.length; i < len; ++i) {
				alert = new G.vo.Alert(vo[i]);
				site = this._getSiteInfo(alert.siteId);

				if (site == null && displayMode === ALERT_DISPLAY_MODE.ESTATE_SITE) {
                    site = G.model.siteSelected.estateSiteChilds.find(s => s.id == alert.siteId) ?? null;
				}

                if(site == null) {
                    continue;
                }

				this._alertsColl.push(alert);
				site.alertsColl.push(alert);

				// increment site counter
				site.alertsCounter[0]++;
				site.alertsCounter[alert.priorite]++;


				// Affiche les alarmes des sites enfants sur une vue qui n'est pas multisite (pour éviter les duplications)
				if(displayMode !== ALERT_DISPLAY_MODE.MULTISITES && site.hasEstateSite()) {
                    let siteEstate = this._getSiteInfo(site.estateSiteId);
                    if(siteEstate) {
                        siteEstate.alertsColl.push(alert);
                        siteEstate.alertsCounter[0]++;
                        siteEstate.alertsCounter[alert.priorite]++;
                    }
                }

				// increment all assets global counter
				this._alertsCounter[0]++;
				this._alertsCounter[alert.priorite]++;
			}

			if (this._alertsCounter[0] == 0 && displayMode === ALERT_DISPLAY_MODE.MULTISITES) {
				$('.badge.priority1').text('0');
				$('.badge.priority2').text('0');
				$('.badge.priority3').text('0');
				$('.badge.priority4').text('0');
			}

			$(document).trigger($.Event('alertModelReady'));
		},
		_getSiteInfo: function(siteId) {
			if (!isdefined(siteId)) return null;

			for (var i = 0, ilen = this._sites.length; i < ilen; ++i) {
				if (this._sites[i].id == siteId) return this._sites[i];
			}

			return null;
		},
		_getFilteredSites: function(isOdysecure) {
			var out = [];
			isOdysecure = !!isOdysecure;

			this._sites.forEach(function (el) {
				if ((el.odysecure_id != null) == isOdysecure)
					out.push(el);
			});

			return out;
		}
	});
	$.widget('globalvisio.AlertsBridgeListener', {
		_create: function () {
			this._callbacks = {
				focuschanged: this._focusChanged.bind(this),
				modelchanged: this._modelChanged.bind(this),
				prioritiesstatuseschanged: this._prioritiesStatusesChanged.bind(this),
			};
		},

		_displayFocus: function (site, formerSite) {
		},
		_resetModel: function () {
			console.log('\t {AlertsBridgeListener._resetModel} on:' + this.widgetName);
		},
		_toggleDisplay: function (status) {
			this.element.toggle(status);
		},
		_updatePrioritiesStatuses: function (ps) {},

		_modelChanged: function (e, data) {
			this._resetModel(data.focus, data.formerFocus);
		},
		_prioritiesStatusesChanged: function (e, data) {
			this._updatePrioritiesStatuses(data.prioritiesStatuses);
		},
		_focusChanged: function (e, data) {
			this._displayFocus(data.focus, data.formerFocus);
		}
	});
	$.widget('globalvisio.AlertsCaption', $.globalvisio.AlertsBridgeListener, {
		_currentDisplayStatus: false,

		_create: function () {
			this._super();
		},
		_displayFocus: function (site, formerSite) {
			var content, linksPointer, html;

			content = {
				nom: G.config.LOCALE_RETRIEVE('hud.allAssetsLabel'),
				ville: '',
				alertsCounter: this._bridge._alertsCounter,
				notificationsCounter: [0, 0, 0, 0, 0],
				siteId: null
			};
			if (site) {
				content.nom = site.nom;
				content.ville = site.ville;
				content.alertsCounter = site.alertsCounter;
				content.siteId = site.id;
			}

			html = content.nom;
			if (isfilled(content.ville))
				html += ' <small>(' + content.ville + ')</small>';
			this.element.find('.maps-selected-site-name').html(html);

			this._printBadge(this.element.find('.priority1'), 1, content);
			this._printBadge(this.element.find('.priority2'), 2, content);
			this._printBadge(this.element.find('.priority3'), 3, content);
			this._printBadge(this.element.find('.priority4'), 4, content);

			linksPointer = this.element.find('a');
			linksPointer.toggle(content.siteId != null);
			if (content.siteId) {
				linksPointer.filter('.alerts').off('click');
				linksPointer.filter('.alerts').on('click', function () {
					G.model.setLocation('alerts', content.siteId);
					return false;
				});
				linksPointer.filter('.dashboard').off('click');
				linksPointer.filter('.dashboard').on('click', function () {
					G.model.setLocation('dashboard', content.siteId);
					return false;
				});
			}
		},
		_resetModel: function () {
		},
		_updatePrioritiesStatuses: function (ps) {
			var o = this.document.find('.alerts-counter-overview');

			o.find('.priority1').toggleClass('priority--off', !ps[1]);
			o.find('.priority2').toggleClass('priority--off', !ps[2]);
			o.find('.priority3').toggleClass('priority--off', !ps[3]);
			o.find('.priority4').toggleClass('priority--off', !ps[4]);
		},
		/**
		 *
		 * @param b    badge
		 * @param i    index
		 * @param c    content
		 * @private
		 */
		_printBadge: function (b, i, c) {
			b.html(c.alertsCounter[i])
				.attr('data-sub-value', c.notificationsCounter[i])
				.toggleClass('sub-badge', c.notificationsCounter[i] > 0);
		},
		_toggleDisplay: function (status) {
			if (isbool(status))
				this._currentDisplayStatus = status;
			else
				status = this._currentDisplayStatus;
			this.element.toggle(status && this._bridge.displayMode === ALERT_DISPLAY_MODE.MULTISITES && (G.Responsive.responsiveBreak.id !== 'mobile'));
		}
	});
	$.widget('globalvisio.AlertsList', $.globalvisio.AlertsBridgeListener, {
		_container: null,
		_tplMultisitesOverview: null,
		_tplMultisitesAlertsList: null,
		_tplMultisitesAlertRow: null,
		_tplMultisitesNoAlertRow: null,
		_tplMonositeAlertsList: null,
		_tplMonositeAlertRow: null,
		_tplMonositeNoAlertRow: null,
		_alertRowClass: null,
		_alertsListClass: null,
		_overviewClass: null,

		options: {
			container: null,
			// 'hide', 'enqueue', 'default'
			noAlertsAction: 'enqueue',
			// 'default', 'single'
			folderExpandMode: 'single'
		},

		_create: function () {
			this._super();
			this._container = $(this.options.container);

			// --- store list snippets, then remove them from DOM display

			this._tplMultisitesAlertRow = this.element.find('tr.multisites-alert-row').eq(0);
			this._tplMultisitesAlertRow.remove();
			this._tplMultisitesNoAlertRow = this.element.find('tr.multisites-noalert').eq(0);
			this._tplMultisitesNoAlertRow.remove();
			this._tplMultisitesAlertsList = this.element.find('tr.multisites-alerts-list').eq(0);
			this._tplMultisitesAlertsList.remove();
			this._tplMultisitesOverview = this.element.find('tr.multisites-overview').eq(0);
			this._tplMultisitesOverview.remove();

			this._tplMonositeAlertRow = this.element.find('tr.monosite-alert-row').eq(0);
			this._tplMonositeAlertRow.remove();
			this._tplMonositeNoAlertRow = this.element.find('tr.monosite-noalert').eq(0);
			this._tplMonositeNoAlertRow.remove();
			this._tplMonositeAlertsList = this.element.find('tr.monosite-alerts-list').eq(0);
			this._tplMonositeAlertsList.remove();
		},
		_destroy: function () {
			this._super();
		},

		// ######################### ALERTS-BRIDGE-LISTENER METHODS

		_displayFocus: function (site, formerSite) {
			var p, outer;

			if (formerSite) {
				$('tr.' + this._overviewClass + '[data-site-id=' + formerSite.id + ']').removeClass('opened');
				if (this.options.folderExpandMode == 'single')
					$('tr.' + this._alertsListClass + '[data-site-id=' + formerSite.id + ']').toggle(false);
			}
			if (site) {
				p = $('tr.' + this._overviewClass + '[data-site-id=' + site.id + ']');
				if (p.length > 0) {
					p.addClass('opened');
					this._container.animate({ scrollTop: p.first().position().top - 40 }, 500);	// scroll into alert in alert list

					// scroll position
					outer = $('div.outer');
					outer.scrollTop(p.position().top - 1);

					p = $('tr.' + this._alertsListClass + '[data-site-id=' + site.id + ']');
					p.toggle(true);
					this._clearAlertSiblings(p.find('.' + this._alertRowClass)); // clear previously loaded alert siblings
				}
			}
			this.element.parent('.inner').toggleClass('has-focus', site != null);
		},
		_resetModel: function () {
			var sites, site, alert, pointValue, str;
			var mainListPointer, alertsListPointer, pointer, tplSite, tplAlertsList, tplAlertRow;
			var counter = 0, isOddCounter, i, ilen, j, jlen;

			if (this._bridge.displayMode === ALERT_DISPLAY_MODE.MULTISITES) {
				this._alertRowClass = 'multisites-alert-row';
				this._alertsListClass = 'multisites-alerts-list';
				this._overviewClass = 'multisites-overview';
			} else {
				this._alertRowClass = 'monosite-alert-row';
				this._alertsListClass = 'monosite-alerts-list';
				this._overviewClass = null;
			}

			// ---   display single sites alert overview
			if (this._bridge.displayMode !== ALERT_DISPLAY_MODE.MULTISITES) {

				site = G.model.siteSelected;
				ilen = site.alertsColl.length;

				this._displayGlobalOverview(site.nom, site.alertsCounter);

				G.LOG(G.log.alerts, '{AlertsList._resetModel} Single site mode, display ' + ilen + ' alerts');

				mainListPointer = this.element.find('tbody');

				tplAlertsList = this._tplMonositeAlertsList.clone()
					.attr('data-site-id', site.id)
					.appendTo(mainListPointer);

				// ---   display alerts rows
				alertsListPointer = tplAlertsList.find('table.alerts-list').find('tbody');

				if (ilen === 0) {
					tplAlertRow = this._tplMonositeNoAlertRow.clone()
						.toggleClass('odd', true);
					tplAlertRow.find('td').eq(1).html(G.config.LOCALE_RETRIEVE('listSites.monositeNoAlerts'));
					tplAlertRow.appendTo(alertsListPointer);
				}

				for (i = 0; i < ilen; ++i) {
					alert = site.alertsColl[i];

					// ---   define whether row is odd or not
					isOddCounter = (counter % 2 === 0);
					++counter;

					tplAlertRow = this._tplMonositeAlertRow.clone()
						.toggleClass('odd', isOddCounter)
						.addClass('priority' + alert.priorite)
						.attr('data-alert-point-id', '' + (alert.pointId === 0 ? alert.type : alert.pointId))
						.attr('data-alert-guid', alert.guid)
						.attr('data-alert-priority', 'priority' + alert.priorite);

					if (alert.pointType === 'ody')
						tplAlertRow.eq(0).addClass('alert-odysecure');

					// inject content
					pointer = tplAlertRow.find('td');

					pointValue = G.i18n.printVal(alert.pointValeur,1);
					if (alert.pointValeur == true) {
						pointValue = '';
					}
					if(pointValue != '' && exists(alert.pointUnite)){
						pointValue += ' '+alert.pointUnite;
					}

					alertClass = 'xs-';
					alertClass += (alert.icon == '') ? 'sensor' : alert.icon;

					pointer.filter('.td-alert__type').find('span')
						.addClass('alert-type-' + alert.type)
						.html('<div class="gv-icon__xs xs-clr-white ' + alertClass + '"></div>');

					str = '';
					if (!!alert.equipementLabelHumain && isfilled(alert.equipementLabelHumain))
						str += '<span class="info-equipement">' + alert.equipementLabelHumain + '</span>';
					// if(exists(alert.description) && alert.description != ''){
					if(exists(alert.description) && alert.description != ''){
						str += '<span class="info-point">' + alert.description + '</span>';
					} else {
						str += '<span class="info-point">' + alert.pointLabelHumain + '</span>';
					}

					pointer.filter('.td-alert__desc')
						.find('span')
						.html(str);
					pointer.filter('.td-alert__value').find('span').html(pointValue);
					pointer.filter('.td-alert__start').html(G.config.LOCALE_DATE(alert.start));
					pointer.filter('.td-alert__end').html(alert.end ? G.config.LOCALE_DATE(alert.end) : '');

					tplAlertRow.find('.async-loader').hide();
					tplAlertRow.find('.alert-siblings').hide();
					tplAlertRow.appendTo(alertsListPointer);

					(function (list, site, alert) {
						tplAlertRow.on('click', function () {
							list._modelLoadAlertSiblings(site, alert);
						});
					})(this, site, alert);
				}
			}

			// ---   display all sites alert overview
			else {
				sites = this._sortSites();
				ilen = sites.length;

				G.LOG(G.log.alerts, '{AlertsList._resetModel} display ' + ilen + ' sites');

				this._displayGlobalOverview(G.config.LOCALE_RETRIEVE('hud.allAssetsLabel'), this._bridge._alertsCounter);

				mainListPointer = this.element.find('tbody');

				if (ilen === 0) {
					tplAlertRow = this._tplMultisitesNoAlertRow.clone()
						.toggleClass('odd', true);
					tplAlertRow.find('td').eq(0).html(G.config.LOCALE_RETRIEVE('listSites.multisiteNoAlerts'));
					tplAlertRow.appendTo(mainListPointer);
				}

				for (i = 0; i < ilen; ++i) {
					site = sites[i];

					// ---   define whether row is odd or not
					isOddCounter = (counter % 2 === 0);
					++counter;

					// ---   display site overview
					tplSite = this._tplMultisitesOverview.clone();
					tplSite.attr('data-site-id', site.id)
						.attr('data-priority1', site.alertsCounter[1])
						.attr('data-priority2', site.alertsCounter[2])
						.attr('data-priority3', site.alertsCounter[3])
						.attr('data-priority4', site.alertsCounter[4])
						.toggleClass('odd', isOddCounter)
						.appendTo(mainListPointer);

					// inject content
					pointer = tplSite.find('td').eq(0);
					pointer.html(site.nom + '&nbsp;<small>' + site.ville + ' - ' + site?.entreprise?.nom ?? "" + '</small>');
					(function (list, site) {
						pointer.css('cursor', 'pointer');
						pointer.on('click', function (e) {
							list._catchInnerFocus(site);
						});
					})(this, site);
					tplSite.find('.priority1').html(this._formatAlertsCount(site.alertsCounter[1]));
					tplSite.find('.priority2').html(this._formatAlertsCount(site.alertsCounter[2]));
					tplSite.find('.priority3').html(this._formatAlertsCount(site.alertsCounter[3]));
					tplSite.find('.priority4').html(this._formatAlertsCount(site.alertsCounter[4]));


					// ---   display site alerts list
					if (site.alertsCounter[0] <= 0)
						continue;

					tplAlertsList = this._tplMultisitesAlertsList.clone()
						.attr('data-site-id', site.id)
						.toggleClass('odd', isOddCounter)
						.hide();

					// ---   display alerts rows
					alertsListPointer = tplAlertsList.find('table.alerts-list').find('tbody');

					jlen = site.alertsColl.length;
					for (j = 0; j < jlen; ++j) {
						alert = site.alertsColl[j];

						tplAlertRow = this._tplMultisitesAlertRow.clone()
							.addClass('priority' + alert.priorite)
							.attr('data-alert-point-id', '' + (alert.pointId === 0 ? alert.type : alert.pointId))
							.attr('data-alert-guid', alert.guid)
							.attr('data-alert-priority', 'priority' + alert.priorite);
						if (alert.pointType == 'ody')
							tplAlertRow.addClass('alert-odysecure')

						// inject content
						pointer = tplAlertRow.find('td');

						alertClass = 'xs-';
						alertClass += (alert.icon == '') ? 'sensor' : alert.icon;
						var str = '';

						if (!!alert.equipementLabelHumain && isfilled(alert.equipementLabelHumain))
							str += '<span class="info-equipement">' + alert.equipementLabelHumain + '</span>';
						// if(exists(alert.description) && alert.description != ''){
						if(alert.description != '' && alert.description !== null){
							str += '<span class="info-point">' + alert.description + '</span>';
						} else {
							str += '<span class="info-point">' + alert.pointLabelHumain + '</span>';
						}
						// str += '<span class="info-point">' + alert.pointLabelHumain + '</span>';
						pointer.filter('.td-alert__type').find('span').html('<div class="gv-icon__xs xs-clr-white ' + alertClass + '"></div>');
						pointer.filter('.td-alert__desc').find('span').html(str);
						pointer.filter('.td-alert__start').html(G.config.LOCALE_DATE(alert.start));
						pointer.filter('.td-alert__end').html(alert.end ? G.config.LOCALE_DATE(alert.end) : '');
						tplAlertRow.find('.async-loader').hide();
						tplAlertRow.find('.alert-siblings').hide();
						tplAlertRow.appendTo(alertsListPointer);
						(function (list, site, alert) {
							tplAlertRow.on('click', function (e) {
								list._modelLoadAlertSiblings(site, alert);
							});
						})(this, site, alert);
					}
					tplAlertsList.appendTo(mainListPointer);
				}
			}
		},
		/**
		 * @param ps   {[]}  priority statuses
		 * @private
		 */
		_updatePrioritiesStatuses: function (ps) {
			var rows, row, subRows, i, ilen, site, status;

			// --- focus out alerts count for disabled priorities
			rows = this.element.find('.' + this._alertRowClass);
			for (i = 0, ilen = ps.length; i < ilen; ++i) {
				rows.filter('.priority' + i).toggleClass('hidden', !ps[i]);
			}

			// --- remove alert lines whose priority is not active
			rows = this.element.find('.site-alerts-list');
			for (i = 0, ilen = rows.length; i < ilen; ++i) {
				subRows = rows.eq(i).find('.' + this._alertRowClass);
				rows.eq(i).toggleClass('hidden', subRows.not('.hidden').length == 0);
			}

			// --- remove sites which do not hold any alert whose priorities are active
			rows = this.element.find('.multisites-overview');
			for (i = 0, ilen = rows.length; i < ilen; ++i) {
				row = rows.eq(i);
				site = this._bridge._getSiteInfo(row.attr('data-site-id'));
				status = !!site && site.allowFromPriorities(ps);
				row.toggleClass('hidden', !status);
				row.next('.multisites-alerts-list').toggleClass('hidden', !status);
			}
		},

		// ######################### PRIVATE UTILITIES

		_clearAlertSiblings: function (alertPointer) {
			if (!alertPointer)
				return;
			alertPointer.find('.open-link').removeClass('opened');
			alertPointer.find('.alert-siblings').hide();
			alertPointer.find('.async-loader').hide();
		},
		/**
		 * Catches inner focus changes for event dispatch
		 * @param site
		 * @private
		 */
		_catchInnerFocus: function (site) {
			// toggle focus if list item is already opened
			if ($('tr.multisites-overview[data-site-id=' + site.id + ']').hasClass('opened'))
				site = null;

			G.LOG(G.log.alerts, '{AlertsList._catchInnerFocus} Focus caught on: ' + (site ? site.nom + ', ' + site.ville : '-'));
			this._trigger('focuscaught', $.Event('focuscaught'), {site: site});
		},
		/**
		 * Loads previous identical alerts from a source alert
		 * @param site    site from which alert is generated
		 * @param alert   source alert
		 * @private
		 */
		_modelLoadAlertSiblings: function (site, alert) {
			var url, alertPointer, siblingsPointer, loaderPointer, alertOpenLinkPointer, pointId;

			pointId = (alert.pointId == 0 || alert.pointId == '') ? alert.type + 'PP' + alert.automateId : alert.pointId;

			alertPointer = $('tr.' + this._alertRowClass + '[data-alert-guid=' + alert.guid + ']');
			alertOpenLinkPointer = alertPointer.find('.open-link');
			siblingsPointer = alertPointer.find('.alert-siblings');
			loaderPointer = alertPointer.find('.async-loader');


			// close sibling alerts if already opened
			if (alertOpenLinkPointer.hasClass('opened')) {
				this._clearAlertSiblings(alertPointer);
				return;
			}

			// else display preloader and launch ajax call
			alertOpenLinkPointer.addClass('opened');
			siblingsPointer.hide();
			loaderPointer.show();

			url = G.config.APIGVALERTS + 'listAlarms?'
				+ 'pointSearch=' + pointId
				+ '&limit=' + G.config.ALERTS_NUM_SIBLINGS;

			G.LOG(G.log.alerts,
				'{AlertsList._modelLoadAlertSiblings} ',
				'site: ' + site.toString(),
				'alert: ' + alert.toString(),
				'url: ' + url
			);

			$.ajax({
				url: url,
				headers: {
					"Content-Type": "application/json",
					"Authorization": "Bearer "+G.model.userApiKey
				},
				type: 'GET',
				dataType: 'json'
			}).done(function (data) {
				var siblings, html, i, ilen, isCut;

				// ---   handle model
				ilen = (data["response"]["alerts"] ?? []).length;

				siblings = [];
				for (i = 0; i < ilen; ++i) {
					siblings.push(new G.vo.Alert(data["response"]["alerts"][i]));
				}
				console.log('{AlertsList._modelLoadAlertSiblings} Loaded ' + ilen + ' siblings alerts');

				// ---   build & display html content
				siblingsPointer.find('.info-count-alerts').html(
					G.config.LOCALE_RETRIEVE('listSites.' + (ilen > 1 ? 'siblingAlertsCount' : 'siblingAlertCount')).replace('{num}', ilen)
				);

				for (i = 0, html = ''; i < ilen; ++i) {
					html += '<li>';
					html += G.config.LOCALE_RETRIEVE('listSites.siblingAlertDetailFrom' + (siblings[i].end ? 'To' : ''))
						.replace('{from}', G.config.LOCALE_DATE(siblings[i].start))
						.replace('{to}', G.config.LOCALE_DATE(siblings[i].end));
					if (typeof pointId == "string" && pointId.substr(0, 4) == 'ody-') {
						html += ' | ' + siblings[i].pointLabelHumain;
						if (siblings[i].pointValeur !== '' && siblings[i].pointValeur.substr(0, 4) !== '0.00') {
							html += ' = ' + siblings[i].pointValeur;
						}
					}
					html += '</li>';
				}
				siblingsPointer.find('ul').html(html);
				// console.log(html);

				siblingsPointer.find('.see-next-alerts')
					.html(G.config.LOCALE_RETRIEVE('listSites.siblingShowInSite'))
					.on('click', function () {
						G.model.setLocation('alerts', site.id, {
							automateId: alert.automateId,
							pointId: alert.pointId
						});
						return false;
					});

				// ---   toggle views
				siblingsPointer.show();
				loaderPointer.hide();
			});
		},
		/**
		 * Sorts model sites according to instance settings
		 * @see <code>options.noAlertsAction</code>
		 * @returns {*}   array of sorted sites
		 * @private
		 */
		_sortSites: function () {
			var sites,
				noAlertsAction = this.options.noAlertsAction;

			if ((this._bridge._sites.length <= this._bridge.options.noAlertsActionThreshold) || this._bridge._alertsCounter[0] === 0) {
				noAlertsAction = 'hide';
			}

			switch (noAlertsAction) {
				case 'hide':
					sites = [];
					for (i = 0, ilen = this._bridge._sites.length; i < ilen; ++i) {
						site = this._bridge._sites[i];
						if (site.alertsCounter[0] > 0) {
							sites.push(site);
						}
					}
					break;
				case 'enqueue':
					var compare = function (a, b) {
						var aHasAlert = a.alertsCounter[0] > 0;
						var bHasAlert = b.alertsCounter[0] > 0;

						if (aHasAlert == bHasAlert) {
							if (a.nom == b.nom)
								return 0;
							else
								return a.nom > b.nom ? 1 : -1;
						} else if (aHasAlert)
							return -1;

						// bHasAlert == true
						else
							return 1;
					};

					sites = this._bridge._sites.concat().sort(compare);
					break;
				case 'default':
				default:
					sites = this._bridge._sites.concat();
					break;
			}

			console.log('{AlertsList._sortSites} Sort and filter sites with noAlertsAction: "' + this.options.noAlertsAction + '", ' + sites.length + ' sites');
			return sites;
		},
		/**
		 * Formats alerts count value
		 * @param v alert count as an interger
		 * @returns {string} formated string
		 * @private
		 */
		_formatAlertsCount: function (v) {
			return v == 0 ? '-' : v;
		},
		/**
		 * Displays bootstrap for all assets alerts counter overview
		 * @private
		 */
		_displayGlobalOverview: function (title, alertsCounter) {
			var pointer;

			// set title
			this.element
				.find('.global-overview')
				.find('th.table-caption')
				.html(title);

			pointer = this.element.find('.alerts-counter-overview');
			for (var i = 1, len = 4, badge; i <= len; ++i) {
				badge = pointer.find('span.priority' + i);
				badge.html(this._formatAlertsCount(alertsCounter[i]));
				(function (widget, index) {
					badge.on('click', function () {
						widget._bridge.togglePriorityStatus(index);
						return false;
					});
				})(this, i);
			}
		}
	});
	$.widget('globalvisio.AlertsMap', $.globalvisio.AlertsBridgeListener, {

		_gmap: null,
		_currentFocusedSite: null,
		_defaultBoundsNoSite: null,
		_defaultBounds: null,
		_sites: [],
		_markers: [],
		_container: null,
		_currentDisplayStatus: false,

		options: {
			// set to false will require a click on map before using the scrollwheel behaviour
			defaultScrollwheelBehaviour: false,
			// container DOM element defined as fullscreen element
			container: null,
			// do not display sites without running alerts
			hideSiteWithoutAlert: false,
			// numbers of sites under which the map is not displayed (or -1 to show it anyway)
			mapDisplayLimit: 1,
			mapMaxZoom: 18,
			mapMinZoom: 4,
			mapId: null
		},

		_create: function () {
			this._super();
			this._container = $(this.options.container);

			// bound europe focused on france
			this._defaultBoundsNoSite = new google.maps.LatLngBounds();
			this._defaultBoundsNoSite.extend(new google.maps.LatLng(59.45535272294042, 31.275841875000005));
			this._defaultBoundsNoSite.extend(new google.maps.LatLng(40.99516127840817, -21.282751874999995));

			(function (widget) {
				$(document).find('.map-functions')
					.on('click', 'div.function-zoom-in', function () {
						widget._zoom(1);
					})
					.on('click', 'div.function-zoom-out', function () {
						widget._zoom(-1);
					})
					.on('click', 'div.function-bounds', function () {
						widget.fitDefaultBounds();
					})
					.on('click', 'div.function-fullscreen', function () {
						$('#alerts-map-container').toggleClass('is-fullscreen');
						google.maps.event.trigger(widget.gmap, 'resize');
						widget._delay(widget.fitDefaultBounds, 300);
					});
			})(this);
		},

		_destroy: function () {
			this._super();
		},

		_toggleDisplay: function (status) {
			if (isbool(status))
				this._currentDisplayStatus = status;
			else
				status = this._currentDisplayStatus;
			status = status && this._bridge.displayMode === ALERT_DISPLAY_MODE.MULTISITES && (G.Responsive.responsiveBreak.id !== 'mobile');
			this._container.toggle(status);
		},

		/*Adapter de compatibilite Marker -> AdvancedMarkerElement.
		Pourquoi il existe:
		- le widget historique manipule des marqueurs via une API "Marker-like"
		  (getIcon/setIcon/setVisible/addListener('click')).
		- AdvancedMarkerElement n'expose pas ce meme contrat (notamment icon/origin/anchor).
		- ce pont permet de migrer vers l'API recommandee sans casser le rendu sprite ni
		  les comportements de selection/focus deja en place.*/

		//Cree le contenu DOM du marqueur a partir de la sprite sheet existante.
		//On conserve ainsi exactement le rendu visuel actuel.
		_createMarkerContent: function (icon) {
			var content = document.createElement('div');
			content.style.position = 'absolute';
			content.style.width = icon.size.width + 'px';
			content.style.height = icon.size.height + 'px';
			content.style.backgroundImage = 'url("' + icon.url + '")';
			content.style.backgroundRepeat = 'no-repeat';
			content.style.backgroundSize = '34px 100px';
			content.style.cursor = 'pointer';
			content.style.pointerEvents = 'auto';
			return content;
		},
		// Reproduit l'ancien comportement icon.origin/icon.anchor via CSS.
		_applyMarkerContentIcon: function (content, icon) {
			var originX = (icon.origin && isan(icon.origin.x)) ? icon.origin.x : 0;
			var originY = (icon.origin && isan(icon.origin.y)) ? icon.origin.y : 0;
			content.style.backgroundPosition = '-' + originX + 'px -' + originY + 'px';
			if (icon.anchor && isan(icon.anchor.x) && isan(icon.anchor.y)) {
				content.style.transform = 'translate(' + (-icon.anchor.x) + 'px, ' + (-icon.anchor.y) + 'px)';
			} else {
				content.style.transform = '';
			}
		},
		// Fabrique un marqueur compatible avec l'ancien code:
		// on encapsule AdvancedMarkerElement dans un adapter avec les methodes attendues.
		_createMapMarker: function (markerOptions) {
			var widget = this;
			var markerContent = this._createMarkerContent(markerOptions.icon);

			var advancedMarker = new google.maps.marker.AdvancedMarkerElement({
				map: markerOptions.map || null,
				position: markerOptions.position,
				title: markerOptions.title,
				content: markerContent,
				gmpClickable: true
			});
			advancedMarker.site = markerOptions.site;

			this._applyMarkerContentIcon(markerContent, markerOptions.icon);

			// Facade de compatibilite:
			// - setMap / setVisible: affichage
			// - getIcon / setIcon: gestion sprite et etat selectionne/non-selectionne
			// - addListener('click'): translation vers l'evenement gmp-click
			return {
				site: markerOptions.site,
				isSelected: false,
				_icon: markerOptions.icon,
				_content: markerContent,
				_advancedMarker: advancedMarker,
				setMap: function (map) {
					this._advancedMarker.map = map || null;
				},
				setVisible: function (visible) {
					this._content.style.display = visible ? '' : 'none';
				},
				getIcon: function () {
					return this._icon;
				},
				setIcon: function (icon) {
					this._icon = icon;
					widget._applyMarkerContentIcon(this._content, icon);
				},
				addListener: function (eventName, callback) {
					if (eventName === 'click' && typeof this._advancedMarker.addEventListener === 'function') {
						this._advancedMarker.addEventListener('gmp-click', callback);
						return {
							remove: function () {
								advancedMarker.removeEventListener('gmp-click', callback);
							}
						};
					}
					if (typeof this._advancedMarker.addListener === 'function') {
						return this._advancedMarker.addListener(eventName, callback);
					}
					return null;
				}
			};
		},

		_getClusterDistribution: function(clusterMarkers) {
			var counts = { red: 0, yellow: 0, blue: 0, green: 0, grey: 0 };
			var ps = this._bridge ? this._bridge.prioritiesStatuses : null;
			clusterMarkers.forEach(function(m) {
				var site = m.site || (m._advancedMarker && m._advancedMarker.site);
				var priority = 5;

				if(site && site.alertsCounter) {
					for(var i = 1; i <= 4; i++) {
						if((!ps || ps[i]) && site.alertsCounter[i] > 0) {
							priority = i;
							break;
						}
					}
				}

				if(priority === 1) counts.red++;
				else if(priority === 2) counts.yellow++;
				else if(priority === 3) counts.blue++;
				else if(priority === 4) counts.grey++;
				else counts.green++;
			});
			return counts;
		},

		_clusterHalo: function(hex) {
			var v = hex.replace('#', '');
			var n = parseInt(v, 16);
			return 'rgba(' + ((n >> 16) & 255) + ',' + ((n >> 8) & 255) + ',' + (n & 255) + ',0.22)';
		},

		_createPieChartClusterElement: function(count, distribution) {
			var NIVEAUX = [
				{ cle: 'red',    couleur: '#C94A45', n: distribution.red },
				{ cle: 'yellow', couleur: '#E8B62C', n: distribution.yellow },
				{ cle: 'blue',   couleur: '#4AA3DF', n: distribution.blue },
				{ cle: 'green',  couleur: '#7CB342', n: distribution.green },
				{ cle: 'grey',   couleur: '#ADADAD', n: distribution.grey }
			];

			var EPAISSEUR = 6;
			var dominante = NIVEAUX.reduce(function(a, b) { return b.n > a.n ? b : a; }, NIVEAUX[0]).couleur;
			var taille = count < 10 ? 34 : count < 50 ? 42 : count < 200 ? 52 : 62;
			var r = (taille - EPAISSEUR) / 2;
			var circ = 2 * Math.PI * r;

			var offset = 0;
			var segments = NIVEAUX.filter(function(p) { return p.n > 0; }).map(function(p) {
				var longueur = (p.n / count) * circ;
				var s = '<circle cx="' + (taille / 2) + '" cy="' + (taille / 2) + '" r="' + r + '" fill="none"' +
					' stroke="' + p.couleur + '" stroke-width="' + EPAISSEUR + '"' +
					' stroke-dasharray="' + longueur + ' ' + (circ - longueur) + '"' +
					' stroke-dashoffset="' + (-offset) + '" />';
				offset += longueur;
				return s;
			}).join('');

			var el = document.createElement('div');
			el.className = 'badge-cluster';
			el.style.cssText = 'position:relative;width:' + taille + 'px;height:' + taille + 'px;border-radius:50%;' +
				'box-shadow:0 0 0 ' + Math.round(taille * 0.14) + 'px ' + this._clusterHalo(dominante) + ';cursor:pointer;';
			el.innerHTML =
				'<svg width="' + taille + '" height="' + taille + '" viewBox="0 0 ' + taille + ' ' + taille + '"' +
				' style="position:absolute;inset:0;transform:rotate(-90deg)">' +
					'<circle cx="' + (taille / 2) + '" cy="' + (taille / 2) + '" r="' + r + '" fill="#fff"' +
					' stroke="rgba(0,0,0,0.06)" stroke-width="' + EPAISSEUR + '" />' +
					segments +
				'</svg>' +
				'<div style="position:absolute;inset:' + EPAISSEUR + 'px;display:flex;align-items:center;justify-content:center;' +
					'background:#fff;border-radius:50%;box-shadow:0 1px 3px rgba(0,0,0,0.18);' +
					'font-family:\'Archivo\',system-ui,-apple-system,sans-serif;font-weight:600;color:#333;' +
					'font-size:' + (count > 999 ? 11 : count > 99 ? 12 : 13) + 'px;line-height:1">' + count + '</div>';

			return el;
		},


		// ######################### ALERTS-BRIDGE-LISTENER METHODS

		_resetModel: function () {
			let i, len, s, marker = invalidSites = [];

			this._sites = [];
			for (i = 0, len = this._bridge._sites.length; i < len; ++i) {
				s = this._bridge._sites[i];
				if (s.alertsColl.length === 0 && this.options.hideSiteWithoutAlert) {
					continue;
				}
				if(this.options.isOdyssee && !isan(s.odysecure_id)){
					continue;
				}
				this._sites.push(s);
			}

			// ---   create _markers
			this._markers = [];
			for (i = 0, len = this._sites.length; i < len; ++i) {
				s = this._sites[i];

				//	remove invalid coordinates
				if (!isan(s.latitude) || !isan(s.longitude)) {
					invalidSites.push(s);
					continue;
				}

				// create marker
				// warning : https://stackoverflow.com/questions/59898381/google-maps-api-custom-marker-svg-size-and-position
				marker = this._createMapMarker({
					site: s,
					position: new google.maps.LatLng(s.latitude, s.longitude),
					title: s.nom,
					optimized: false,
					icon: {
						url: G.config.MM_PATH + 'assets2/mm/spritesheets/' + G.model.theme + '-gmap.png',
						size: new google.maps.Size(20, 20),
						origin: new google.maps.Point(0, 20 * (s.alertsHighestPriority() - 1)),
						anchor: new google.maps.Point(10, 10)
					}
				});
				if (!marker) {
					continue;
				}

				(function (widget, marker) {
					marker.addListener('click', function () {
						widget._markerClick(marker);
					});
				})(this, marker);
				this._markers.push(marker);
			}


			if (invalidSites.length > 0) {
				console.warn('[G.map.mapInit] ' + invalidSites.length + ' site positions are invalid', invalidSites);
			}

			// ---   init google map instance
			var mapOptions = {
				mapTypeControl: false,
				scrollwheel: this.options.defaultScrollwheelBehaviour,
				streetViewControl: false,
				disableDefaultUI: true,
				zoomControlOptions: {
					position: google.maps.ControlPosition.LEFT_BOTTOM
				},
				maxZoom: this.options.mapMaxZoom,
				minZoom: this.options.mapMinZoom
			};
			var tacMapId = '';
			if (typeof tarteaucitron !== 'undefined' && tarteaucitron.user && typeof tarteaucitron.user.googlemapsMapId === 'string') {
				tacMapId = tarteaucitron.user.googlemapsMapId.trim();
			}
			var resolvedMapId = tacMapId || this.options.mapId;
			mapOptions.mapId = resolvedMapId;
			this._gmap = new google.maps.Map(this.element.get(0), mapOptions);

			// ---   set map bounds
			this.defaultBounds = new google.maps.LatLngBounds();

			if (this._markers.length >= this.options.mapDisplayLimit) {

				// ---   add _markers to map

				var widget = this;

				var advancedMarker = this._markers.map(function(m) {
					return m._advancedMarker || m;
				});

				if(this._markerCluster) {
					this._markerCluster.clearMarkers();
				}

				var ClustererClass = (typeof markerClusterer !== 'undefined' && markerClusterer.MarkerClusterer) 
					|| (typeof window.markerClusterer !== 'undefined' && window.markerClusterer.MarkerClusterer) 
					|| window.MarkerClusterer;

				if (typeof ClustererClass === 'function') {
					var pieRenderer = {
						render: function(cluster, stats, map) {
							var distribution = widget._getClusterDistribution(cluster.markers);
							var element = widget._createPieChartClusterElement(cluster.count, distribution);

							return new google.maps.marker.AdvancedMarkerElement({
								position: cluster.position,
								content: element,
								gmpClickable: true,
								zIndex: 1000 + cluster.count
							});
						}
					};

					this._markerCluster = new ClustererClass({
						map: this._gmap,
						markers: advancedMarker,
						renderer: pieRenderer
					});
				} else {
					console.error('[AlertsMap] MarkerClusterer library is not available in window');
				}


				for (i = 0, len = this._sites.length; i < len; ++i) {
					s = this._sites[i];
					if (isan(s.latitude) && isan(s.longitude))
						this.defaultBounds.extend(new google.maps.LatLng(s.latitude, s.longitude));
				}
				this.fitDefaultBounds();


				// ---   scrollwheel behaviour
				// @see  http://bdadam.com/blog/simple-usability-trick-for-google-maps.html
				if (!this.options.defaultScrollwheelBehaviour) {
					(function (widget) {
						$('body').on('mousedown', function (event) {
							widget._enableMouseWheelScrolling($(event.target).parents('#' + widget.element.attr('id')).length > 0);
						});
						$(window).on('scroll', function () {
							widget._enableMouseWheelScrolling(false);
						});
					})(this);
				}
			} else {
				this.defaultBounds = Object.freeze(this._defaultBoundsNoSite);
				this.fitDefaultBounds();
			}
		},

		_displayFocus: function (site, formerSite) {
			console.log('{AlertsMap._displayFocus} Display focus for: ' + (site ? site.nom + ', ' + site.ville : '-'));

			for (var i = 0, len = this._markers.length, marker; i < len; ++i) {
				marker = this._markers[i];
				marker.isSelected = (site && marker.site === site);

				icon = marker.getIcon();
				icon.origin = new google.maps.Point((marker.isSelected ? 0 : 20), icon.origin.y);
				marker.setIcon(icon);
			}

			if (site != null && formerSite != null && site["id"] == formerSite["id"]) {
				return;
			}

			site ? this.panToSite(site) : this.fitDefaultBounds();
		},
		/**
		 *
		 * @param {[]} psts     priorities statuses
		 * @private
		 */
		_updatePrioritiesStatuses: function (psts) {

			this.defaultBounds = new google.maps.LatLngBounds();

			if(this._markers.length === 0) {
				this.defaultBounds = Object.freeze(this._defaultBoundsNoSite);
			} else {
				var activeAdvancedMarkers = [];
    
				for (var i = 0, ilen = this._markers.length, s, ssts, m; i < ilen; ++i) {
					m = this._markers[i];
					s = m.site;
					ssts = s.allowFromPriorities(psts);

					m.setVisible(ssts);
					if (ssts) {
						activeAdvancedMarkers.push(m._advancedMarker || m);
						if (isan(s.latitude) && isan(s.longitude)) {
							this.defaultBounds.extend(new google.maps.LatLng(s.latitude, s.longitude));
						}
					}
				}

				if (this._markerCluster) {
					this._markerCluster.clearMarkers();
					this._markerCluster.addMarkers(activeAdvancedMarkers);
				}

			}

			if (this._gmap) {
				this.fitDefaultBounds();
			}
		},


		// ######################### PUBLIC METHODS

		fitDefaultBounds: function () {
			this._gmap.fitBounds(this.defaultBounds);
		},

		panToSite: function (site) {
			this._gmap.setZoom(this.options.mapMaxZoom);
			this._gmap.panTo(new google.maps.LatLng(site.latitude, site.longitude));
		},


		// ######################### PRIVATE UTILITIES

		/**
		 * Catches inner focus changes for event dispatch
		 * @param site
		 * @private
		 */
		_catchInnerFocus: function (site) {
			console.log('{AlertsMap._catchInnerFocus} Focus caught on: ' + (site ? site.nom + ', ' + site.ville : '-'));
			this._trigger('focuscaught', $.Event('focuscaught'), {site: site});
		},
		_markerClick: function (markerClicked) {
			for (var i = 0, len = this._markers.length, m; i < len; ++i) {
				m = this._markers[i];
				if (m === markerClicked) {
					return this._catchInnerFocus(m.isSelected ? null : m.site);
				}
			}
		},
		_findMarker: function (site) {
			for (var i = 0, len = this._markers.length, m; i < len; ++i) {
				m = this._markers[i];
				if (m.site === site)
					return m;
			}
			return null;
		},
		_enableMouseWheelScrolling: function (enabled) {
			this._gmap.setOptions({
				scrollwheel: enabled
			});
		},
		_zoom: function (increment) {
			var oldVal, newVal;

			oldVal = this._gmap.getZoom();
			newVal = oldVal + (increment * 3);
			if (newVal < this.options.mapMinZoom) {
				newVal = this.options.mapMinZoom;
			} else if (newVal > this.options.mapMaxZoom) {
				newVal = this.options.mapMaxZoom;
			}
			console.log('{AlertsMap._zoom} zoom:' + newVal);
			this._gmap.setZoom(newVal);
			google.maps.event.trigger(this._gmap, 'resize');
		}
	});


})(jQuery, window, document);

var G, p;


if (!G)
	G = {};

if (!G.ui)
	G.ui = {};

if (!G.ui.GVLogger) {

	G.ui.GVLogger = function () {
		this._init();
	}

	/** @private */
	G.ui.GVLogger._Instance = null;

	/**
	 * Returns singleton instance.
	 */
	G.ui.GVLogger.GetInstance = function () {
		if (G.ui.GVLogger._Instance === null) {
			G.ui.GVLogger._Instance = new G.ui.GVLogger();
		}
		return G.ui.GVLogger._Instance;
	}


	var p = G.ui.GVLogger.prototype;

	p.setOptions = function (options) {
		this._o = deepmerge({
			height: '200px',
			globalChannel: "[Général]",
			timeFormat: 'HH:mm:ss',
			onTop: true,
			autoOpen: false,
		}, options || {});

		this._console.find('section').css({
			height: this._o.height
		});
	}

	/** @private */
	p._init = function () {
		var self = this;

		this._console = $('#page-console');
		if (this._console.length === 0) {
			console.warn('Unable to find Logger target (searching for "#page-console")');
			return;
		}

		this._console
			.addClass('uicomp__logger')
			.append($('<header>'
				+ '<div class="mod--opened" data-action="clear">'
				+ '<i class="fal fa-broom"></i>'
				+ '<span class="__count">000</span>'
				+ '</div>'
				+ '<div data-action="toggle-expand">'
				+ '<i class="fal fa-chevron-up mod--closed"></i>'
				+ '<i class="fal fa-chevron-down mod--opened"></i>'
				+ '</div>'
				+ '</header>'
				+ '<section><table></table></section>'
			));

		this._console
			.on('click', '[data-action="toggle-expand"]', function (e) {
				self.open();
			})
			.on('click', '[data-action="clear"]', function (e) {
				self.clear();
			});

		this.setOptions();

		this._container = this._console.find('table');
		this._counter = 0;
	}
	
	/** @private */
	p._isOpened = function () {
		return this._console.hasClass('mod--opened');
	}

	/** @private */
	p._updateLogsCount = function () {
		this._console.find('.__count').text(this._container.find('tr').length);
	}

	/**
	 * Updates logger opened state 
	 * 
	 * @param {?bool} status 				required opened state (omitted value or null will toggle current state)
	 */
	p.open = function (status) {
		if (status === undefined || status === null) {
			status = !this._isOpened();
		}
		this._console.toggleClass('mod--opened', status);
	}

	/**
	 * Clears logger stack.
	 */
	p.clear = function () {
		this._container.children('tr').remove();
		this._updateLogsCount();
	}

	/**
	 * Prepends a log in the logger stack.
	 * 
	 * @param {?string} level 					status (allowed value: 'error', 'warning', 'info', 'success', null)
	 * @param {string} channel 				unique reference for the channel	
	 * @param {string} message 				log content
	 * @param {string|object} data 			optional data to be exposed (allowed types: JSON string, string, object)
	 */
	p.add = function (level, channel, message, data) {
		if (this._autoOpen)
			this._open(true);

		++this._counter;

		var classList = [];
		if (['error', 'warning', 'info', 'success'].indexOf(level) >= 0) {
			classList.push('level--' + level);
		}
		if (this._counter % 2 === 0) {
			classList.push('mod--odd');
		}

		var line =
			'<tr class="' + classList.join(' ') + '">'
			+ '<td class="__index">' + this._counter + '</td>'
			+ '<td class="__timestamp">' + moment().format(this._o.timeFormat) + '</td>'
			+ '<td class="__channel">' + (channel || this._o.globalChannel) + '</td>'
			+ '<td>' + message;
		if (data) {
			if (isstring(data)) {
				try {
					var o = JSON.parse(data);
					data = JSON.stringify(o, undefined, 2);
				}
				catch (err) {
					data = data;
				}
			}
			else if (isobj(data)) {
				data = JSON.stringify(data, undefined, 2);
			}
			else {
				data = String(data);
			}
			line += '<pre><code>' + data + '</code></pre>';
		}
		line += '</td></tr>';
		this._o.onTop
			? this._container.prepend($(line))
			: this._container.append($(line));
		if (!this._isOpened() && this._o.autoOpen) {
			this.open(true);
		}
		this._updateLogsCount();
	}
}
if(!exists(G))
	G = {};

if(!exists(G.vo))
	G.vo = {};

if(!exists(G.vo.utilsFormatLabel)){
	G.vo.utilsFormatLabel = function (l) {
		if (l == undefined)
			return undefined;

		// avoid empty strings
		l = l.trim();
		if (l == '')
			return '';

		// replace br tags
		l = l.replace('<br/>', '<br />');
		l = l.replace('<br>', '<br />');
		l = l.replace('<br />', '<br /> ');

		return l;
	};
}


// ----------------------------------------------------------------------
// COMPONENT STYLE
// ----------------------------------------------------------------------

if(!exists(G.vo.CompStyle)) {
	G.vo.CompStyle = function (d) {
		this.uid = 'style' + G.config.GET_GUID();
		this.label = undefined;
		this.template = undefined;
		this.errorLabel = undefined;
		this.status = undefined;
		this.showValue = undefined;
		this.valueMap = undefined;

		this.parse(d || {});
	};
	G.vo.CompStyle.prototype.clone = function () {
		var s = new G.vo.CompStyle();
		s.comp = this.comp;
		s.label = this.label;
		s.template = this.template;
		s.status = this.status;
		s.showValue = this.showValue;
		s.errorLabel = this.errorLabel;
		s.valueMap = this.valueMap;
		return s;
	};
	G.vo.CompStyle.prototype.compose = function (s) {
		if (s == null)
			return;

		if (s.label !== undefined)
			this.label = s.label;
		if (s.template !== undefined)
			this.template = s.template;
		if (s.status !== undefined)
			this.status = s.status;
		if (s.showValue !== undefined)
			this.showValue = s.showValue;
		if (s.errorLabel !== undefined)
			this.errorLabel = s.errorLabel;
		if (s.valueMap !== undefined)
			this.valueMap = s.valueMap;
	};
	G.vo.CompStyle.prototype.parse = function (d) {
		if (d.hasOwnProperty('label'))
			this.label = G.vo.utilsFormatLabel(d.label);

		if (d.hasOwnProperty('template'))
			this.template = d.template;

		if (d.hasOwnProperty('errorLabel'))
			this.errorLabel = G.vo.utilsFormatLabel(d.errorLabel);

		if (d.hasOwnProperty('status')) {
			switch (d.status) {
				case 'error':
				case 'warning':
					this.status = d.status;
					break;
				default:
					this.status = null;
					break;
			}
		}

		if (d.hasOwnProperty('showValue'))
			this.showValue = d.showValue;

		if (d.hasOwnProperty('valueMap'))
			this.valueMap = d.valueMap;
	};
	G.vo.CompStyle.prototype.error = function (instance, message) {
		console.error('[ComponentStyle] Configuration error on: ' + instance.toString() + '\n\t' + message);
	};
	G.vo.CompStyle.prototype.toString = function () {
		return '[CompStyle]' + this.printStyleChanges();
	};
	G.vo.CompStyle.prototype.printStyleChanges = function () {
		var str = '';
		if (this.label !== undefined)
			str += '\n\t - label: ' + this.label;
		if (this.template !== undefined)
			str += '\n\t - template: ' + this.template;
		if (this.status !== undefined)
			str += '\n\t - status: ' + this.status;
		if (this.valueMap !== undefined)
			str += '\n\t - valueMap: ' + this.valueMap;
		if (this.errorLabel !== undefined)
			str += '\n\t - errorLabel: ' + this.errorLabel;
		if (this.showValue !== undefined)
			str += '\n\t - showValue: ' + this.showValue;
		return str;
	};
	G.vo.CompStyle.prototype.getStyleChanges = function () {
		var s = [];
		if (this.label !== undefined)
			s.push(this.label);
		if (this.template !== undefined)
			s.push(this.template);
		if (this.valueMap !== undefined)
			s.push(this.valueMap);
		if (this.status !== undefined)
			s.push(this.status);
		if (this.errorLabel !== undefined)
			s.push(this.errorLabel);
		if (this.showValue !== undefined)
			s.push(this.showValue);
		return s;
	};
	G.vo.CompStyle.prototype.isValid = function () {
		return this.getStyleChanges().length > 0;
	};
	G.vo.CompStyle.prototype.toJSONObject = function () {
		return {
			label: this.label,
			template: this.template,
			errorLabel: this.errorLabel,
			status: this.status,
			valueMap: this.valueMap,
			showValue: this.showValue
		};
	};
}


// ----------------------------------------------------------------------
// COMPONENT RULE
// ----------------------------------------------------------------------

if(!exists(G.vo.CompRule)) {
	G.vo.CompRule = function (d) {
		this.comparison = null;
		this.threshold = null;
		G.vo.CompStyle.call(this, d);
	};
	G.vo.CompRule.prototype = Object.create(G.vo.CompStyle.prototype);
	G.vo.CompRule.prototype.parse = function (d) {
		G.vo.CompStyle.prototype.parse.call(this, d);

		if (d.hasOwnProperty('threshold'))
			this.threshold = d.threshold;

		switch (d.comparison) {
			// check whether value is numeric or boolean
			case 'equals':
			case 'different':
				this.comparison = d.comparison;
				break;

			// check if value is numeric
			case 'superior':
			case 'inferior':
				if (isNaN(this.threshold)) {
					this.comparison = 'any';
					this.error(this, 'Comparison "' + d.comparison + '" defined with a non-numeric value: ' + this.threshold);
				}
				this.comparison = d.comparison;
				break;

			// no comparison appliable == any value
			default:
				this.comparison = 'any';
				break;
		}
	};
	G.vo.CompRule.prototype.test = function (valuesMap, id, synopsisComp) {
		var value, r = true, t;

		if (valuesMap.hasOwnProperty(id))
			value = valuesMap[id].value;
		else
			return false;

		t = this.threshold;
		if (synopsisComp.datatype == 'boolean' && !isbool(t)) {
			t = (t == (isan(t) ? 1 : 'true'));
		}

		switch (this.comparison) {
			case 'equals':
				r = (value == t);
				break;
			case 'different':
				r = (value != t);
				break;
			case 'superior':
				r = (value > t);
				break;
			case 'inferior':
				r = (value < t);
				break;
		}
		return r;
	};
	G.vo.CompRule.prototype.toString = function () {
		var str = '[ComponentRule]';
		if (this.comparison != null)
			str += ' ' + this.comparison + ' ' + this.threshold;
		// str += this.printStyleChanges();
		return str;
	};
	G.vo.CompRule.prototype.toJSONObject = function () {
		var o = G.vo.CompStyle.prototype.toJSONObject.call(this);
		o.comparison = this.comparison;
		o.threshold = this.threshold;

		// remove undefined properties
		for (var prop in o) {
			if (o[prop] === undefined)
				delete o.prop;
		}

		return o;
	};
	G.vo.CompRule.prototype.isValid = function () {
		return G.vo.CompStyle.prototype.isValid.call(this)
			&& (this.threshold != undefined || this.comparison == 'any');
	};
}


// ----------------------------------------------------------------------
// COMPONENT DEFECT
// ----------------------------------------------------------------------

if(!exists(G.vo.CompDefect)) {
	G.vo.CompDefect = function (d) {
		this.pointId = undefined;
		this.pointValue = undefined;

		G.vo.CompStyle.call(this, d);
	};
	G.vo.CompDefect.prototype = Object.create(G.vo.CompStyle.prototype);
	G.vo.CompDefect.prototype.parse = function (d) {
		G.vo.CompStyle.prototype.parse.call(this, d);

		if (d.hasOwnProperty('pointId'))
			this.pointId = d.pointId;
		if (d.hasOwnProperty('pointValue'))
			this.pointValue = d.pointValue;
	};
	G.vo.CompDefect.prototype.test = function (valuesMap, synopsisComp) {
		var pv = this.pointValue;
		if (synopsisComp.datatype == 'boolean' && !isbool(this.pointValue)) {
			pv = (pv == (isan(pv) ? 1 : 'true'));
		}
		return valuesMap.hasOwnProperty(this.pointId) && valuesMap[this.pointId].value == pv;
	};
	G.vo.CompDefect.prototype.toString = function () {
		return '[CompDefect] Check if ' + this.pointId + ' equals ' + this.pointValue + this.printStyleChanges();
	};
	G.vo.CompDefect.prototype.toJSONObject = function () {
		var o = G.vo.CompStyle.prototype.toJSONObject.call(this);
		o.pointId = this.pointId;
		o.pointValue = this.pointValue;

		// remove undefined properties
		for (var prop in o) {
			if (o[prop] == undefined)
				delete o.prop;
		}

		return o;
	};
	G.vo.CompDefect.prototype.isValid = function () {
		return G.vo.CompStyle.prototype.isValid.call(this)
			&& this.pointId != undefined
			&& this.pointValue != undefined;
	};
}


// ----------------------------------------------------------------------
// COMPONENT GROUP
// ----------------------------------------------------------------------

if(!exists(G.vo.SynopsisGroup)) {
	G.vo.SynopsisGroup = function (synopsis, d) {
		this.synopsis = synopsis;

		this.id = parseInt(d.id);
		this.label = d.label;
		this.source = d.source;
		this.selection = d.selection;
		this.planning_id = parseInt(d.planning_id);
		this.planning_right = exists(d.planning_right) ? d.planning_right : null;
		this.planning_exists = !isNaN(this.planning_id) && exists(this.planning_right) && G.model.user.droit >= this.planning_right;
		this.planning_name = this.planning_exists ? d.planning_name : null;
		this.graphic_id = parseInt(d.graphique_id);
		this.heating_curve_id = d.heating_curve_id;
		this.heating_curve_exists = exists(this.heating_curve_id);

		console.log("SynopsisGroup", synopsis, d, this.heating_curve_id, this.heating_curve_exists);

		// ---   component UI
		this.uiPositionContext = null;
		if (d.ui)
			this.uiPositionContext = new G.vo.Point(d.ui.x, d.ui.y);

		this.ui = $('<div class="synopsis-ui-group no-select"></div>');
		this.ui.on('click', this.synopsis.focusSet.bind(this.synopsis, this));
		this.synopsis.structureAddComponent(this.ui, this.uiPositionContext);

		// ---   panel UI
		this.panel = $('<div class="summary panel-comp-list"></div>');
		this.panelPositionContext = null;
		if (d.panel) {
			if (isan(d.panel.x) && isan(d.panel.y))
				this.panelPositionContext = new G.vo.Point(d.panel.x, d.panel.y);
			else if (d.panel.hasOwnProperty('alignement'))
				this.panelPositionContext = d.panel.alignement;
		}
		this.synopsis.structureAddComponent(this.panel, this.panelPositionContext);

		// ---   components list
		this.components = [];
		for (var i = 0, ilen = d.components.length; i < ilen; ++i) {
			this.components.push(new G.vo.SynopsisComponent(this, d.components[i]));
		}

		this.uiRender();
		this.panelRender(false);

	};
	G.vo.SynopsisGroup.prototype.requiredPoints = function () {
		var r = [];
		for (var i = 0, ilen = this.components.length; i < ilen; ++i) {
			r = r.concat(this.components[i].requiredPoints());
		}
		return r;
	};
	G.vo.SynopsisGroup.prototype.toJSONObject = function () {
		var o;

		o = {};
		o.id = this.id;
		o.label = this.label;
		o.source = this.source;
		o.selection = this.selection;
		o.planning_id = this.planning_id;
		if (this.planning_name)
			o.planning_name = this.planning_name;
		if(this.planning_right)
			o.planning_right = this.planning_right;
		o.heating_curve_id = this.heating_curve_id;

		if (this.uiPositionContext instanceof G.vo.Point)
			o.ui = {x: this.uiPositionContext.x, y: this.uiPositionContext.y};

		if (this.panelPositionContext instanceof G.vo.Point)
			o.panel = {x: this.panelPositionContext.x, y: this.panelPositionContext.y};
		else if (this.panelPositionContext)
			o.panel = {alignement: this.panelPositionContext};
		else
			o.panel = null;

		o.components = [];
		for (var i = 0, ilen = this.components.length; i < ilen; ++i)
			o.components[i] = this.components[i].toJSONObject();
		return o;
	};
	G.vo.SynopsisGroup.prototype.uiRender = function () {
		this.ui.css('visibility', this.uiPositionContext ? 'visible' : 'collapse');
		this.ui.html(this.label);
	};
	G.vo.SynopsisGroup.prototype.panelRender = function (renderContent) {
		this.panel.css('visibility', this.panelPositionContext ? 'visible' : 'collapse');
		if (renderContent !== false && this.panelPositionContext)
			this.synopsis.groupFillComponents(this, false);
	};
	G.vo.SynopsisGroup.prototype.toString = function () {
		return '[SynopsisGroup] "' + this.id + '" (' + this.components.length + ' components)';
	};
}


// ----------------------------------------------------------------------
// SYNOPSIS COMPONENT
// ----------------------------------------------------------------------

if(!exists(G.vo.SynopsisComponent)) {
	G.vo.SynopsisComponent = function (group, d) {
		var i, ilen, html;

		this.group = group;
		this.synopsis = this.group.synopsis;

		this.id = d.id || 'comp' + G.config.GET_GUID();
		this.synopsisId = d.synopsisId;

		this.label_automate = d.label_automate;
		this.equipement_d = d.equipement_d;
		this.equipement_mnemonique = d.equipement_mnemonique;

		this.label = this.errorLabel = G.vo.utilsFormatLabel(d.label);
		switch (d.type) {
			case 'synopsis-link':
			case 'synopsis-title':
			case 'orientation':
				this.type = d.type;
				this.display = 'scene';
				break;
			case 'title':
			case 'separator':
				this.type = d.type;
				this.display = 'panel';
				break;
			case 'input':
			case 'point':
				this.type = d.type;
				this.display = d.display || 'both';
				break;
			default:
				console.log('#################### ERROR Unknown type: "' + d.type + '"');
				return;
		}

		this.unit = d.unit;
		switch (d.datatype) {
			case 'boolean':
			case 'analogic':
			case 'analogic-select':
				this.datatype = d.datatype;
				break;
			default:
				if (isfilled(d.datatype))
					console.log('[SynopsisComponent] Unknown datatype: "' + d.datatype + '"', d);
				this.datatype = 'analogic';
				break;
		}
		this.showData = d.showData === true;

		this.rules = [];
		for (i = 0, ilen = isarray(d.rules) ? d.rules.length : 0; i < ilen; ++i) {
			this.rules.push(new G.vo.CompRule(d.rules[i]));
		}

		this.defects = [];
		for (i = 0, ilen = isarray(d.defects) ? d.defects.length : 0; i < ilen; ++i) {
			this.defects.push(new G.vo.CompDefect(d.defects[i]));
		}

		this.required = [];
		var requiredIds = [];
		var retrieveRequiredIds = function (str) {
			if (!str)
				return;
			str.replace(/#_(.*?)_#/g, (function () {
				if (arguments[1])
					requiredIds.push(arguments[1]);
			}));
		};
		retrieveRequiredIds(this.label);
		for (i = 0, ilen = this.rules.length; i < ilen; ++i)
			retrieveRequiredIds(this.rules[i].label);
		for (i = 0, ilen = this.defects.length; i < ilen; ++i)
			retrieveRequiredIds(this.defects[i].label);
		this.required = requiredIds;

		this.uiPosition = new G.vo.Point(d.x || 0, d.y || 0);

		html = '';
		switch (this.type) {
			case 'synopsis-link':
				html += '<div class="synopsis-ui-group no-select ' + (this.getDefaultStyle().template || '') + '" data-template="synopsis-link" data-synopsis-id="' + this.synopsisId + '"></div>';
				break;
			case 'synopsis-title':
				html += '<div class="synopsis-ui-group no-select ' + (this.getDefaultStyle().template || '') + '" data-template="synopsis-link">' + this.label + '</div>';
				break;
			case 'orientation':
				html += '<div class="synopsis-ui-comp no-select ' + (this.getDefaultStyle().template || '') + '" data-template="orientation">';
				html += '<div class="orientation-head"></div>';
				html += '<div class="orientation-tail"></div>';
				html += '</div>';
				break;
			default:
				html += '<div class="synopsis-ui-comp no-select">';
				html += '<div class="icon"></div>';
				html += '<div class="caption-blocks">';
				html += '<div class="value"></div>';
				html += '<div class="label"></div>';
				html += '<div class="error"></div>';
				html += '</div>';
				html += '</div>';
				break;
		}
		this.ui = $(html);

		this.ui.on('click', this.synopsis.focusSet.bind(this.synopsis, this));

		this.synopsis.structureAddComponent(this.ui, this.uiPosition);

		this.synopsis.on('valuesUpdate', this.uiRender.bind(this));
		this.uiRender();
	};
	G.vo.SynopsisComponent.prototype.testRules = function () {
		for (var i = 1, ilen = this.rules.length; i < ilen; ++i) {
			if (this.rules[i].test(this.synopsis.values.map, this.id, this))
				return this.rules[i];
		}
		return null;
	};
	G.vo.SynopsisComponent.prototype.testDefects = function () {
		for (var i = 0, ilen = this.defects.length; i < ilen; ++i) {
			if (this.defects[i].test(this.synopsis.values.map, this))
				return this.defects[i];
		}
		return null;
	};
	G.vo.SynopsisComponent.prototype.toString = function () {
		return '[SynopsisComponent] type: ' + this.type + ', label: "' + this.label + '"';
	};
	G.vo.SynopsisComponent.prototype.requiredPoints = function () {
		if (this.id == null || this.type == 'synopsis-link' || this.type == 'synopsis-title' || this.type == 'orientation')
			return [];

		var r = [this.id].concat(this.required);
		if (typeof (this.defects) != "undefined") {
			for (var i = 0, ilen = this.defects.length; i < ilen; ++i)
				r.push(this.defects[i].pointId);
		}
		return r;
	};
	G.vo.SynopsisComponent.prototype.getDefaultStyle = function () {
		return (this.rules.length > 0) ? this.rules[0] : new G.vo.CompRule({});
	};
	G.vo.SynopsisComponent.prototype.composeStyle = function () {
		var s, str, sDefault, sDefect, sRules;
		var logComposer = false;

		// ---   compose applied style
		sDefault = this.getDefaultStyle();
		sRules = this.testRules();
		sDefect = this.testDefects();

		s = sDefault.clone();
		s.compose(sRules);
		s.compose(sDefect);

		if (logComposer) {
			str = '#' + this.id;
			str += '\n### default: \n' + '' + sDefault;
			if (sRules)
				str += '\n###  testRules\n' + sRules.toString();
			if (sDefect)
				str += '\n###  testDefects\n' + sDefect.toString();
			str += '\n\t ------------ ';
			str += '\n###  apply: ' + s.toString();
			console.log(this.id + str);
		}
		return s;
	};
	G.vo.SynopsisComponent.prototype.uiRender = function () {
		var s, str, p, label, isToggler;

		// do not apply to oriented components
		if (this.ui == null || this.type == 'synopsis-link' || this.type == 'synopsis-title' || this.type == 'orientation')
			return;

		// hide components displayed only in panel
		this.ui.css('visibility', this.display == 'panel' ? 'collapse' : 'visible');

		// compose applied style
		s = this.composeStyle();

		// ---   apply style

		// display template and statuses
		this.ui.attr('data-template', (s.template != undefined) ? s.template : null);

		this.ui.attr('data-status', (s.status != undefined) ? s.status : null);

		// display label
		p = this.ui.find('.label');
		label = (s.label !== undefined) ? s.label : this.label;
		if (label !== undefined) {
			p.html(this.formatText(label));
			p.toggle(isfilled(label));
		}

		// display error label
		p = this.ui.find('.error');
		if (s.errorLabel !== undefined) {
			p.html(this.formatText(s.errorLabel));
		}
		p.toggle(isfilled(s.errorLabel));

		// show/hide abd format value
		p = this.ui.find('.value');
		p.css('display', s.showValue !== false ? 'block' : 'none');

		str = '';
		isToggler = (s.template && s.template.indexOf('toggler') == 0);

		if (isToggler ? (s.showValue === true || s.valueMap !== undefined) : s.showValue !== false) {
			if (s.valueMap) {
				str = this.formatText(s.valueMap);
			} else {
				str = this.formatValue(this.id);
				var tmpUnit = this.formatUnit(this.id);
				if(tmpUnit != '' ){
					str += ' ' + tmpUnit;
				} else if (this.unit != null && this.unit != 'null'){
					str += ' ' + this.unit;
				}
			}
		}
		p.html(str);
		if (isToggler)
			p.toggle(str != '');

		// hide caption-blocks if value = label = error = ''
		var isEmpty = this.ui.find('.value').html() == '';
		isEmpty = isEmpty && this.ui.find('.label').html() == '';
		isEmpty = isEmpty && this.ui.find('.error').html() == '';
		this.ui.find('.caption-blocks').toggle(!isEmpty);
	};
	G.vo.SynopsisComponent.prototype.formatValue = function (id) {
		var v = this.synopsis.values.map[id];
		if (v == null){
			return '';
		}
		if (isan(v.value)){
			var tmpValue = v.value.toFixed(v.precision);
			if(tmpValue.substr(-2) == '.0'){
				tmpValue = tmpValue.substr(0, tmpValue.length -2);
			}
			return tmpValue;
		}
		else{
			v.value = v.value + '';
		}
		return v.value;
	};
	G.vo.SynopsisComponent.prototype.formatUnit = function (id) {
		var v = this.synopsis.values.map[id];
		if (v == null){
			return '';
		}
		if (typeof(v.unit) != 'undefined' && v.unit != '' && v.unit !== null){
			return v.unit;
		}
		return '';
	};
	G.vo.SynopsisComponent.prototype.formatText = function (str) {
		if (str == null || !str)
			str = '';
		str = str.toString();
		str = str.replace(/#_(.*?)_#/g, (function () {
			return this.formatValue(arguments[1]);
		}).bind(this));
		return str;
	};
	G.vo.SynopsisComponent.prototype.toJSONObject = function () {
		var o, i, ilen;

		o = {};
		o.id = this.id;
		o.synopsisId = this.synopsisId;
		o.label_automate = this.label_automate;
		o.equipement_d = this.equipement_d;
		o.equipement_mnemonique = this.equipement_mnemonique;
		o.label = this.label;
		o.type = this.type;
		o.showData = this.showData;
		o.display = this.display;
		if (this.display != 'panel') {
			o.x = this.uiPosition.x;
			o.y = this.uiPosition.y;
		}

		if (this.type == 'point' || this.type == 'input') {
			o.datatype = this.datatype;
			o.unit = this.unit;
		}

		// add rules if required
		if (this.rules.length > 0) {
			o.rules = [];
			for (i = 0, ilen = this.rules.length; i < ilen; ++i)
				o.rules[i] = this.rules[i].toJSONObject();
		}

		// add defects if required
		if (this.type != 'orientation' && this.type != 'synopsis-link' && this.type != 'synopsis-title' && this.defects.length > 0) {
			o.defects = [];
			for (i = 0, ilen = this.defects.length; i < ilen; ++i)
				o.defects[i] = this.defects[i].toJSONObject();
		}

		// remove undefined properties
		for (var prop in o) {
			if (o[prop] === undefined)
				delete o.prop;
		}

		return o;
	};
}
var io;

(function ($, window, document) {

	$.widget('globalvisio.Synopsis', {
		pathes: {
			bg: G.config.SERVER + 'img/synoptiques/',
			bgError: G.config.SERVER + 'img/synopt_site_error.png',
			minimap: G.config.SERVER + 'img/synoptiques/',
			structure: G.config.API + 'synoptique/',
			values: G.config.API + 'synoptiquevalues/'
		},
		bg: {
			jqo: null,
			scale: -1,
			margin: new G.vo.Point(15, 15),
			size: new G.vo.Point(0, 0),
			offset: new G.vo.Point(0, 0)
		},
		scale: {
			timeoutDelay: 50,
			timeoutId: Number.NaN,
			timeoutCallback: null
		},
		values: {
			map: {},
			keys: [],
			feedback: null,
			date: null
		},
		container: null,
		preloader: null,
		focusedItem: null,
		editor: null,
		templates: {},
		state: {
			synopsis: null,
			group: null,
			utility: null
		},
		p: {},
		histoChart: null,
		histoChartContainerEl: null,
		updateCache: {},
		components: [],
		groups: [],
		options: {
			isStatic: false,
			synopsisId: undefined,
			panelClickable: false,
			editionMode: false,
			positionRounding: 5,
			maxHeaderTab: 4,
			synopHistoDateRangeUUID: null
		},
		callbacks: {},


		// UTILITIES
		// ----------------------------------------------------------------------

		isInteger: function (o) {
			return (Object.prototype.toString.call(o)) === '[object Number]'
				&& (o % 1 === 0 && !(o === 0) && (Number.NEGATIVE_INFINITY === 1 / o));
		},


		// CORE
		// ----------------------------------------------------------------------

		_create: function () {
			var classname;
			var self = this;

			this.callbacks.scaleWindowResized = this.scaleWindowResized.bind(this);
			this.callbacks.synopsisInitAll = this.synopsisInitAll.bind(this);
			this.callbacks.chartLoadGraph = this.chartLoadGraph.bind(this);
			this.callbacks.chartDatesRangeUpdate = this.chartDatesRangeUpdate.bind(this);

			// ---   retrieve templates
			classname = 'template-synopsis';
			this.templates.synopsisTab = this.element.find('.' + classname);
			this.templates.synopsisTab
				.removeClass(classname)
				.remove();

			classname = 'template-group';
			this.templates.groupPanel = this.templates.synopsisTab.find('.' + classname);
			this.templates.groupPanel
				.removeClass(classname)
				.remove();

			classname = 'template-infogroup';
			this.templates.infogroupPanel = this.templates.synopsisTab.find('.' + classname);
			this.templates.infogroupPanel
				.removeClass(classname)
				.remove();

			this.templates.planning = $('#planning-content').remove();
			this.templates.curves = $('#courb-content').remove();
			this.templates.data = $('#history-content');
			this.chartInit();
			this.templates.data.remove();


			// ---   watch window events
			this.scale.timeoutCallback = this.scaleApply.bind(this);
			this.window.on('resize', this.callbacks.scaleWindowResized);

			G.ui.initSelect2(this.element.find(".tabs-menu").find('select'));

			// ---   launch initialization
			$(document).on('modelReady', this.callbacks.synopsisInitAll);
			if (exists(G.model.siteSelected)) {
				this.synopsisInitAll();
			}


			// ---   socket initialization
			if (io) {
				//Socket GlobalIO
				G.socketgio.connect();
				// traitement des résultats
				G.socketgio.addResponse('return', function (data) {
					var txt = JSON.parse(data);
					$.ajax({
						url: G.config.SERVER + 'apigv/globalio/response',
						headers: {
							"Content-Type": "application/json",
							"Authorization": "Bearer "+G.model.userApiKey
						},
						type: 'POST',
						dataType: 'json',
						data: JSON.stringify({
							response: txt,
							equipementId: $('#tmp-synoptique-equipement-id').val()
						}),
						/*url: G.config.SERVER + 'frontend/ajax/globalioresponse',
						type: 'POST',
						dataType: 'json', // selon le retour attendu
						data: {
							response: JSON.stringify(txt),
							equipementId: $('#tmp-synoptique-equipement-id').val()
						},*/
						success: function (response) {
							
							// La réponse du serveur
							if (response.status === "error") {
								showError(response.message);
								G.socketgio.socketgio.disconnect();
								// G.socketgio.socketgio.close();
								self.updateCacheReset();
							}
							//Mise à jour des points suite à lecture table de réponses modbus
							if (response.response.status === "updateok") {
								self.onlyValuesUpdate();
								showInfo(response.response.info);
								G.socketgio.socketgio.disconnect();
							}
							if (response.response.status === "writeok") {
								showSuccess(response.response.info);
								G.socketgio.socketgio.disconnect();
								//AJAX
								$.ajax({
									url: G.config.SERVER + 'frontend/ajax/synoptiquenextcommand',
									type: "POST",
									data: {
										data: '1'
									},
									datatype: 'json',
									error: function (xhr, textStatus, errorThrown) {
										G.ui.fatalError("ajax error: " + textStatus, { url: this.url, error: errorThrown });
									},
									beforeSend: function (xhr) {
									},
									success: function (dataJson) {
										if (typeof (dataJson.end) != 'undefined' && dataJson.end != '') {
											// G.socketgio.socketgio.close();
											self.updateCacheDone();
										}
										if (typeof (dataJson.status) != 'undefined' && dataJson.status == 'error') {
											// G.socketgio.socketgio.disconnect();
											self.updateCacheReset();
										}
										if (typeof (dataJson.frame) != 'undefined' && dataJson.frame != '') {
											G.socketgio.socketgio.connect();

											var voieModbus = 'modbus';
											if (typeof (dataJson.voie) != 'undefined' && dataJson.voie == 2) {
												var voieModbus = 'modbus2';
											}

											var json = { "ip": dataJson.adresseIp, "cmd": dataJson.frame };
											G.socketgio.socketgio.emit(voieModbus, JSON.stringify(json));
											showInfo('Envoi des commandes');
										}
									}
								});
							}
							if (response.status === "success") {
								showInfo(response.response.info);
							}
						}
					});
				});

				G.socketgio.addResponse('return_ozw', function (data) {
					var txt = JSON.parse(data);
					$.ajax({
						url: G.config.SERVER + 'frontend/ajax/siemensresponse',
						type: 'POST',
						dataType: 'json', // selon le retour attendu
						data: {
							response: JSON.stringify(txt),
							equipementId: $('#tmp-synoptique-equipement-id').val(),
							addressIp: $('#tmp-synoptique-address-ip').val(),
							mode: $('#tmp-command-mode').val()
						},
						success: function (response) {
							
							// La réponse du serveur
							if (response.status === "error") {
								showError(response.error);
								G.socketgio.socketgio.disconnect();
								// G.socketgio.socketgio.close();
								self.updateCacheReset();
							}
							//Mise à jour des points suite à lecture table de réponses modbus
							if (response.status === "updateok") {
								self.onlyValuesUpdate();
								showInfo(response.info);
								G.socketgio.socketgio.disconnect();
							}
							if (response.status === "writeok") {
								showSuccess(response.info);
								G.socketgio.socketgio.disconnect();
								//AJAX
								$.ajax({
									url: G.config.SERVER + 'frontend/ajax/synoptiquenextcommand',
									type: "POST",
									data: {
										data: '1'
									},
									datatype: 'json',
									error: function (xhr, textStatus, errorThrown) {
										G.ui.fatalError("ajax error: " + textStatus, { url: this.url, error: errorThrown });
									},
									beforeSend: function (xhr) {
									},
									success: function (dataJson) {
										if (typeof (dataJson.end) != 'undefined' && dataJson.end != '') {
											self.updateCacheDone();										}
										if (typeof (dataJson.status) != 'undefined' && dataJson.status == 'error') {
											self.updateCacheReset();
										}
										if (typeof (dataJson.frame) != 'undefined' && dataJson.frame != '') {
											G.socketgio.connect();
											var voieModbus = 'modbus';
											if (typeof (dataJson.voie) != 'undefined' && dataJson.voie == 2) {
												var voieModbus = 'modbus2';
											}

											var json = { "ip": dataJson.adresseIp, "cmd": dataJson.frame };
											G.socketgio.socketgio.emit(voieModbus, JSON.stringify(json));
											showInfo('Envoi des commandes');

										}
									}
								});
							}
							if (response.status === "success") {
								showInfo(response.info);
							}
							//Affichage static d'informations complementaires (exemple: récupération des valeurs en cours)
							if (exists(response.info_complementary)) {
								showInfoStatic(response.info_complementary);
							}
							if (response.cmd === "dcnx") {
								notificationsClearAll(5000);
							}
						}
					});
				});

				G.socket.connect();
				G.socket.addResponse('responseDevio', function (data) {
					if(!exists(data.msg) || data.msg == ''){
						return true;
					}
					$.ajax({
						url: G.config.SERVER + 'backend/devio/response',
						type: "POST",
						dataType: "json",
						data: {
							host: 'devio05',
							response: data.msg
						},
						// dataType: "json",
						error: function (xhr, textStatus, errorThrown) {
							showError(textStatus, { url: this.url, error: errorThrown });
						},
						success: function (data) {
							var method = 'write';

							//Affichage info bloquée (recuperation en cours)
							if (typeof (data.info_static) !== 'undefined') {
								showInfoStatic(data.info_static);
							}

							//Affichage info temporaire (connexion, connecté...)
							if (typeof (data.info) !== 'undefined') {
								showInfo(data.info);
							}

							//Affichage succes (ecriture avec succes)
							if (typeof (data.info_success) !== 'undefined') {
								showSuccess(data.info_success);
							}

							if (typeof (data.writeok) !== 'undefined') {
								if (typeof (data.automateId) !== 'undefined') {
									$.ajax({
										url: G.config.SERVER + 'backend/devio/request',
										type: "POST",
										dataType: "json",
										data: {
											method: "cnx",
											finalMethod: "write",
											host: "devio05",
											automateId: data.automateId,
											automate: data.automate
										},
										error: function (xhr, textStatus, errorThrown) {
											showError("ajax error: " + textStatus, { url: this.url, error: errorThrown });
										},
										success: function (data) {
											G.socket.socket.emit('dvio', data.result);
										}
									});
									return true;
								}
							} else if (typeof (data.writeinprogress) != 'undefined') {
								// showInfo(data.writeinprogress);
							} else if (typeof (data.checkresult) !== 'undefined') {
								if (typeof (data.info) !== 'undefined') {
									showInfoStatic(data.info);
								}
								self.synopsisCheckResult("devio05");
								return true;
							} else if (typeof (data.sleep) !== 'undefined') {
								// showInfo('En attente de connexion');
								G.socket.socket.emit('dvio', data.command);
								return true;
							} else if (typeof (data.error) !== "undefined") {
								showError(data.error);
								notificationsClearAll(5000);
								self.updateCacheReset();
								if (typeof (data.result) !== 'undefined' && data.result !== '') {
									G.socket.socket.emit('dvio', data.result);
									showInfo('Déconnexion en cours');
								}
								return false;
							} else if (typeof (data.end) !== "undefined" || data.result === '') {
								self.updateCacheDone();
								// showInfo('Déconnecté');
								return false;
							} else if (method === 'dcnx') {
								return false;
							}
							G.socket.socket.emit('dvio', data.result);
						}
					});
				});

				G.socketdevio2.connect();
				G.socketdevio2.addResponse('responseDevio2', function (data) {
					if(!exists(data.msg) || data.msg == ''){
						console.log('synopsis-widget error no data');
						return true;
					}
					$.ajax({
						url: G.config.SERVER + 'backend/devio/response',
						type: "POST",
						dataType: "json",
						data: {
							host: 'devio06',
							response: data.msg
						},
						// dataType: "json",
						error: function (xhr, textStatus, errorThrown) {
							showError(textStatus, { url: this.url, error: errorThrown });
						},
						success: function (data) {
							var method = 'write';
							console.log('responseOk', data);

							//Affichage info bloquée (recuperation en cours)
							if (typeof (data.info_static) !== 'undefined') {
								showInfoStatic(data.info_static);
							}

							//Affichage info temporaire (connexion, connecté...)
							if (typeof (data.info) !== 'undefined') {
								showInfo(data.info);
							}

							//Affichage succes (ecriture avec succes)
							if (typeof (data.info_success) !== 'undefined') {
								showSuccess(data.info_success);
							}

							if (typeof (data.writeok) !== 'undefined') {
								if (typeof (data.automateId) !== 'undefined') {
									$.ajax({
										url: G.config.SERVER + 'backend/devio/request',
										type: "POST",
										dataType: "json",
										data: {
											method: "cnx",
											finalMethod: "write",
											host: "devio06",
											automateId: data.automateId,
											automate: data.automate
										},
										error: function (xhr, textStatus, errorThrown) {
											showError("ajax error: " + textStatus, { url: this.url, error: errorThrown });
										},
										success: function (data) {
											G.socketdevio2.socketdevio2.emit('dvio', data.result);
										}
									});
									return true;
								}
							} else if (typeof (data.writeinprogress) != 'undefined') {
								// showInfo(data.writeinprogress);
							} else if (typeof (data.checkresult) !== 'undefined') {
								if (typeof (data.info) !== 'undefined') {
									showInfoStatic(data.info);
								}
								self.synopsisCheckResult("devio06");
								return true;
							} else if (typeof (data.sleep) !== 'undefined') {
								// showInfo('En attente de connexion');
								G.socketdevio2.socketdevio2.emit('dvio', data.command);
								return true;
							} else if (typeof (data.error) !== "undefined") {
								showError(data.error);
								notificationsClearAll(5000);
								self.updateCacheReset();
								if (typeof (data.result) !== 'undefined' && data.result !== '') {
									G.socketdevio2.socketdevio2.emit('dvio', data.result);
									showInfo('Déconnexion en cours');
								}
								return false;
							} else if (typeof (data.end) !== "undefined" || data.result === '') {
								self.updateCacheDone();
								self.onlyValuesUpdate(data.host);
								// showInfo('Déconnecté');
								return false;
							} else if (method === 'dcnx') {
								return false;
							}
							G.socketdevio2.socketdevio2.emit('dvio', data.result);
						}
					});
				});

				G.socketdevio3.connect();
				G.socketdevio3.addResponse('responseDevio3', function (data) {
					if(!exists(data.msg) || data.msg == ''){
						console.log('synopsis-widget error no data');
						return true;
					}
					$.ajax({
						url: G.config.SERVER + 'backend/devio/response',
						type: "POST",
						dataType: "json",
						data: {
							host: 'devio07',
							response: data.msg
						},
						// dataType: "json",
						error: function (xhr, textStatus, errorThrown) {
							showError(textStatus, { url: this.url, error: errorThrown });
						},
						success: function (data) {
							var method = 'write';
							
							//Affichage info bloquée (recuperation en cours)
							if (typeof (data.info_static) !== 'undefined') {
								showInfoStatic(data.info_static);
							}

							//Affichage info temporaire (connexion, connecté...)
							if (typeof (data.info) !== 'undefined') {
								showInfo(data.info);
							}

							//Affichage succes (ecriture avec succes)
							if (typeof (data.info_success) !== 'undefined') {
								showSuccess(data.info_success);
							}

							if (typeof (data.writeok) !== 'undefined') {
								if (typeof (data.automateId) !== 'undefined') {
									$.ajax({
										url: G.config.SERVER + 'backend/devio/request',
										type: "POST",
										dataType: "json",
										data: {
											method: "cnx",
											finalMethod: "write",
											host: "devio07",
											automateId: data.automateId,
											automate: data.automate
										},
										error: function (xhr, textStatus, errorThrown) {
											showError("ajax error: " + textStatus, { url: this.url, error: errorThrown });
										},
										success: function (data) {
											G.socketdevio3.socketdevio3.emit('dvio', data.result);
										}
									});
									return true;
								}
							} else if (typeof (data.writeinprogress) != 'undefined') {
								// showInfo(data.writeinprogress);
							} else if (typeof (data.checkresult) !== 'undefined') {
								if (typeof (data.info) !== 'undefined') {
									showInfoStatic(data.info);
								}
								self.synopsisCheckResult("devio07");
								return true;
							} else if (typeof (data.sleep) !== 'undefined') {
								// showInfo('En attente de connexion');
								G.socketdevio3.socketdevio3.emit('dvio', data.command);
								return true;
							} else if (typeof (data.error) !== "undefined") {
								console.log('synopsis-widget error', data.error);
								showError(data.error);
								notificationsClearAll(5000);
								self.updateCacheReset();
								if (typeof (data.result) !== 'undefined' && data.result !== '') {
									G.socketdevio3.socketdevio3.emit('dvio', data.result);
									showInfo('Déconnexion en cours');
								}
								return false;
							} else if (typeof (data.end) !== "undefined" || data.result === '') {
								console.log('resposeDevio3', data.end);
								self.updateCacheDone();
								self.onlyValuesUpdate(data.host);
								// showInfo('Déconnecté');
								return false;
							} else if (method === 'dcnx') {
								console.log('resposeDevio3 DCNX', data.end);
								return false;
							}
							G.socketdevio3.socketdevio3.emit('dvio', data.result);
						}
					});
				});
			}
		},
		_destroy: function () {
			this.window.off('resize', this.callbacks.scaleWindowResized);
			$(document).off('modelReady', this.callbacks.synopsisInitAll);
			G.socket.removeResponse('responseDevio');
			G.socketdevio3.removeResponse('responseDevio3');
		},

		// UTILITIES
		// ----------------------------------------------------------------------

		on: function (eventName, fn) {
			this.element.on((this.widgetEventPrefix + eventName).toLowerCase(), fn);
		},
		off: function (eventName, fn) {
			this.element.off((this.widgetEventPrefix + eventName).toLowerCase(), fn);
		},


		// RESIZE
		// ----------------------------------------------------------------------

		scaleWindowResized: function () {
			if (this.scale.timeoutId != null)
				clearTimeout(this.scale.timeoutId);
			this.scale.timeoutId = setTimeout(this.scale.timeoutCallback, this.scale.timeoutDelay);
		},
		scaleApply: function () {
			var ratio, currentSize;

			// clear delayed call
			if (!isNaN(this.scale.timeoutId))
				clearTimeout(this.scale.timeoutId);
			this.scale.timeoutId = Number.NaN;

			// retrieve applied scale
			currentSize = new G.vo.Point(this.bg.jqo.width(), this.bg.jqo.height());
			ratio = currentSize.clone();
			ratio.divide(this.bg.size);
			this.bg.scale = Math.min(ratio.x, ratio.y);

			// compute offset

			this.bg.offset.reset(this.container.width(), this.container.height());
			this.bg.offset.minus(currentSize);
			this.bg.offset.scale(.5);
			this.bg.offset.round();

			// apply on display
			this.bg.jqo.css('left', this.bg.offset.x + 'px');
			this.bg.jqo.css('top', this.bg.offset.y + 'px');

			this._trigger('resize', $.Event('resize'));
		},
		transformPosition: function (component, context) {
			var pos, props = {};


			// transform relative coordinates
			if (context instanceof G.vo.Point) {

				pos = context.clone();
				pos.scale(this.bg.scale);
				pos.plus(this.bg.offset);
				pos.round();

				component.css('left', pos.x + 'px');
				component.css('top', pos.y + 'px');
			}

			// transform relative corner alignement (LT, LB, RT, RB - default LT)
			else if (typeof context == 'string' && context.length == 2) {
				context = context.toLowerCase();
				component.css((context.charAt(0) == 'r') ?
					{ left: 'auto', right: this.bg.margin.x + 'px' } :
					{ left: this.bg.margin.x + 'px', right: 'auto' }
				);
				component.css((context.charAt(1) == 'b') ?
					{ top: 'auto', bottom: this.bg.margin.x + 'px' } :
					{ top: this.bg.margin.x + 'px', bottom: 'auto' }
				);
			}

			return props;
		},


		// DISPLAY
		// ----------------------------------------------------------------------

		displayError: function (message, xhr, textStatus, errorThrown) {
			console.log('[Synopsis.displayError] message: "' + message + '"\n\t - textStatus: ' + textStatus + '\n\t - errorThrown: ' + errorThrown);
		},
		displayAsyncStatus: function (status) {
			status = (status == true);

			this.preloader.toggle(status);
			this.bg.jqo.toggle(!status);
		},


		// FOCUS
		// ----------------------------------------------------------------------

		/** Displays focused element status */
		focusSet: function (el) {
			if (this.options.editionMode) {
				this.editor.compSelected(el);
			} else {
				if (el instanceof G.vo.SynopsisGroup) {
					this.groupMenuDisplay(true, el.id);
				} else {
					switch (el.type) {
						case 'synopsis-link':
							this.synopsis.synopsisReset(el.synopsisId);
							break;
						case 'synopsis-title':
							break;
						case 'flux':
							break;
						default:
							var focusout;
							if (this.focused != null && el != null && el.id == this.focused.id)
								return;

							focusout = this.focused;
							this.focused = el;

							if (el && el.group) {
								this.groupMenuDisplay(true, el.group.id);
							}

							this._trigger('focusChange', $.Event('focusChange'), {
								focusin: this.focused,
								focusout: focusout
							});
					}
				}
			}
		},


		// INITIALIZATION AND STRUCTURE
		// async processes flow : synopsisReset > synopsisStructureLoad >  synopsisStructureLoaded > valuesUpdate > valuesUpdated
		// ----------------------------------------------------------------------

		componentsRetrieveId: function (id) {
			for (var i = 0, ilen = this.components.length; i < ilen; ++i) {
				if (this.components[i].id == id)
					return this.components[i];
			}
			return null;
		},
		componentsPanelFactory: function (component, asSystemPanel) {
			var s, v, inputId, html, i, ilen, r, isMajor;

			switch (component.type) {
				case 'synopsis-link':
					return '';
				case 'synopsis-title':
					return '';
				case 'separator':
					return '\n<div class="separator"></div>';
				case 'title':
					return '\n<div class="data-group-title">' + component.label + '</div>';
				case 'point':
				case 'input':
					break;
				default:
					console.log('\t - ERROR: unhandled component type: "' + component.type + '"');
					return '';
			}

			v = this.values.map[component.id];
			s = component.composeStyle();
			inputId = 'panel-input-' + component.id + G.config.GET_GUID();
			isMajor = s.template && (s.template.indexOf('major-') === 0);

			if (v == null) {
				console.log('\t - ERROR unable to retrieve value of id: "' + component.id + '"');
				return '';
			}

			html = '\n';

			var classes = [];
			classes.push('panel-comp-list-item');
			classes.push('comp-display-' + component.display);
			if (isMajor)
				classes.push('panel-comp-list-item--major');
			html += '<div data-comp-id="' + component.id + '" class="' + classes.join(' ') + '"';
			if (s.template != null)
				html += 'data-template="' + s.template + '"'
			html += '>';

			if (!isMajor)
				html += '<div class="comp-left-column">';
			html += '<div class="comp-label">' + component.formatText(component.label) + '</div>';
			if (!isMajor)
				html += '</div>'; // end .comp-left-column

			// -------------------------------
			//    BOOLEAN
			// -------------------------------

			if (component.datatype === 'boolean') {
				if (!isMajor) {
					var cursor = (component.type === 'point') ? ' style="cursor:default;"' : '';
					html +=
						'<div class="comp-right-column">'
						+ '<div class="gv-ui-toggler" ' + cursor + '>';
					html +=
						'<input id="' + inputId + '" type="checkbox" class="automaton-data uicomp__input" ' + (component.type == 'point' ? 'disabled' : 'checked') + '/>'
						+ '<label for="' + inputId + '"  ' + cursor + '></label>'
						+ '</div>';
				}

				var valuesMap = {
					vTrue: null,
					vFalse: null,
					vAny: null
				};

				ilen = component.rules.length;
				for (i = 0; i < ilen; ++i) {
					r = component.rules[i];
					if (r.comparison === 'any')
						valuesMap.vAny = r;
					else if (r.threshold)
						valuesMap.vTrue = r;
					else
						valuesMap.vFalse = r;
				}

				if (isMajor)
					html += '<div class="comp-value">';
				if (valuesMap.vTrue && valuesMap.vFalse) {
					html += '<span class="value-map" data-value-map="istrue">' + valuesMap.vTrue.valueMap + '</span>';
					html += '<span class="value-map" data-value-map="isfalse">' + valuesMap.vFalse.valueMap + '</span>';
				} else if ((valuesMap.vTrue || valuesMap.vFalse) && valuesMap.vAny) {
					r = valuesMap.vTrue || valuesMap.vFalse;
					html += '<span class="value-map" data-value-map="' + (r.threshold ? 'istrue' : 'isfalse') + '">' + r.valueMap + '</span>';
					html += '<span class="value-map" data-value-map="' + (!r.threshold ? 'istrue' : 'isfalse') + '">' + valuesMap.vAny.valueMap + '</span>';
				}
				if (isMajor)
					html += '</div>'; // end .comp-value

				if (!isMajor)
					html += '</div>'; // end .text-left

				if (component.showData && !asSystemPanel)
					html += '<div class="comp-add-data"></div>';
			}


			// -------------------------------
			//    ANALOGIC SELECT
			// -------------------------------

			else if (component.datatype === 'analogic-select') {
				html += '<div class="comp-right-column">';

				html += '<div class="comp-full-value">';
				if (isMajor) {
					for (i = 0, ilen = component.rules.length; i < ilen; ++i) {
						r = component.rules[i];
						html += '<span class="value-map" data-value-map="' + (r.comparison === 'any' ? 'analogic-select-default' : r.threshold) + '">' + r.valueMap + '</span>';
					}
				} else {
					html += '<div ' + (component.type === 'point' ? ' no-use' : '') + '">';
					html += '<select id="' + inputId + '" '
						+ 'data-nosearch class="automaton-data uicomp--full-width" '
						+ (component.type === 'point' ? ' disabled ' : '')
						+ 'style="width: 100%;" '
						+ '>';
					for (i = 0, ilen = component.rules.length; i < ilen; ++i) {
						r = component.rules[i];
						html += '<option value="' + (r.comparison === 'any' ? 'analogic-select-default' : r.threshold) + '">' + r.valueMap + '</option>';
					}
					html += '</select>';
					html += '</div>';
				}
				html += '</div>'; // end .comp-value
				html += '</div>';
				if (component.showData && !asSystemPanel)
					html += '<div class="comp-add-data"></div>';
			}


			// -------------------------------
			//    ANALOGIC
			// -------------------------------

			else if (component.datatype === 'analogic') {
				var tmpValue = v.value;
				if (tmpValue == null) {
					tmpValue = '';
				}
				if (isan(tmpValue)) {
					var tmpOldval = tmpValue.toFixed(1);
					if (tmpOldval.substr(-2) == '.0') {
						tmpOldval = tmpOldval.substr(0, tmpOldval.length - 2);
					}
					tmpValue = tmpOldval;
				}
				else {
					tmpValue = tmpValue + '';
				}
				// value + unit
				if (isMajor) {
					html += '<span class="comp-value">' + tmpValue;
					if (typeof(v.unit) != 'undefined' && v.unit != ''){
						html += '&nbsp;<small>' + v.unit + '</small>';
					} else if (!!component.unit) {
						html += '&nbsp;<small>' + component.unit + '</small>';
					}
					html += '</span>';
				} else {
					html += '<div class="comp-right-column">';
					html += '<div class="comp-value">' +
						'<input type="text" id="' + inputId + '" '
						+ 'value="' + tmpValue + '"  '
						+ 'class="automaton-data uicomp__input text-right" '
						+ (component.type == 'point' ? ' disabled' : '') + '/>' +
						'</div>';
					if (typeof(v.unit) != 'undefined' && v.unit != ''){
						html += '<div class="uicomp-unit">&nbsp;' + v.unit + '</div>';
					} else if (!!component.unit) {
						html += '<div class="uicomp-unit">&nbsp;' + component.unit + '</div>';
					}
				}

				// value map
				if (s.valueMap)
					html += '<span class="value-map">' + component.formatText(s.valueMap) + '</span>';

				if (!isMajor)
					html += '</div>';

				if (component.showData && !asSystemPanel)
					html += '<div class="comp-add-data"></div>';
			} else {
				console.log('\t - ERROR: unhandled component datatype: "' + component.datatype + '"');
				return '';
			}


			// -------------------------------
			//    ERRORS
			// -------------------------------

			html += '</div>'; // end .panel-comp-list-item

			return html;
		},

		synopsisInitAll: function () {
			var
				logStr = '[Synopsis.initAllsynopses]',
				headerPointer = this.element.find('div.tabs-menu'),
				headerStr = '',
				selectPointer = this.element.find('.tabs-select').find('select'),
				selectStr = '',
				widget = this,
				i, ilen, s, optionStr,
				headerTabMode;

			ilen = G.model.siteSelected.synoptiques.length;
			headerTabMode = ilen <= this.options.maxHeaderTab;

			//	--- build list strings and DOM objects
			headerStr += headerTabMode ? '<ul>' : '<select data-nosearch>';
			for (i = 0; i < ilen; ++i) {
				s = G.model.siteSelected.synoptiques[i];

                // Site patrimoine : préfixer avec le nom du site enfant
                var synopticDisplayName = s.nom;
                if (G.model.siteSelected.isEstateSite == 1) {
                    var synopticSite = G.model.siteSelected.estateSiteChilds.find(function(child) {
                        return child.id == s.siteId;
                    }) ?? null;
                    if (exists(synopticSite)) {
                        synopticDisplayName = synopticSite.nom + ' / ' + s.nom;
                    }
                }

                logStr += '\n\t - add synopsis: ' + synopticDisplayName + ' [' + s.id + ']';
                optionStr = '<option value="' + s.id + '">' + synopticDisplayName + '</option>';
                selectStr += optionStr;
                headerStr += headerTabMode ?
                    '<li data-synopsis-id="' + s.id + '"><a href="#' + G.model.getHash(undefined, undefined, { synopsis: s.id }) + '">' + synopticDisplayName + '</a></li>' :
                    optionStr;
			}

			headerStr += headerTabMode ? '</ul>' : '</select>';
			$(headerStr).appendTo(headerPointer);
			$(selectStr).appendTo(selectPointer);

			G.ui.initSelect2(headerPointer);
			G.ui.initSelect2(selectPointer);

			// --- listen to select changes
			if (!headerTabMode) {
				headerPointer.on('change', 'select', function () {
					widget.synopsisReset($(this).val());
				});
			}
			selectPointer.on('change', function () {
				widget.synopsisReset($(this).val());
			});

			this.synopsisReset(this.options.synopsisId);
		},
		synopsisCheckResult: function (host) {
			var self = this;
			$.ajax({
				url: G.config.SERVER + 'backend/devio/checkresult',
				type: "POST",
				dataType: "json",
				data: {
					host: host,
					none: 'none',
					target: 'synoptique'
				},
				error: function (xhr, textStatus, errorThrown) {
					console.error("ajax error: " + textStatus);
				},
				success: function (data) {

					//Affichage info bloquée (recuperation en cours)
					if (typeof (data.info_static) !== 'undefined') {
						showInfoStatic(data.info_static);
					}

					//Affichage info temporaire (connexion, connecté...)
					if (typeof (data.info) !== 'undefined') {
						showInfo(data.info);
					}

					//Affichage succes (ecriture avec succes)
					if (typeof (data.info_success) !== 'undefined') {
						showSuccess(data.info_success);
					}

					//Affichage error
					if (typeof (data.error) !== 'undefined') {
						showError(data.error);
					}

					if (typeof (data.working) !== "undefined") {
						$('.info-log').append('<p>No result yet ' + data.responseText + '</p>');
						setTimeout(function () {
							self.synopsisCheckResult(host);
						}, 5000);
					} else {
						if (typeof (data.result) !== "undefined") {
							switch(host){
								case 'devio5':
								case 'devio05':
									G.socket.socket.emit('dvio', data.result);
									break;
								case 'devio6':
								case 'devio06':
									G.socketdevio2.socketdevio2.emit('dvio', data.result);
									break;
								case 'devio7':
								case 'devio07':
									G.socketdevio3.socketdevio3.emit('dvio', data.result);
									break;
								default:
									G.socket.socket.emit('dvio', data.result);
							}
							

							if (typeof (data.valuesUpdate) !== "undefined") {
								self.onlyValuesUpdate(data.host);
							}
							if (typeof (data.next) !== "undefined") {
								showInfo('Récupération des informations de l\'automate suivant');
								setTimeout(function () {
									console.log('Récupération des informations de l\'automate suivant');
									switch(host){
										case 'devio5':
										case 'devio05':
											G.socket.socket.emit('dvio', data.next);
											break;
										case 'devio6':
										case 'devio06':
											G.socketdevio2.socketdevio2.emit('dvio', data.next);
											break;
										case 'devio7':
										case 'devio07':
											G.socketdevio3.socketdevio3.emit('dvio', data.next);
											break;
										default:
											G.socket.socket.emit('dvio', data.next);
									}
								}, 5000);
							}
						} else {
							showError('Une erreur est survenue');
						}
					}

				}
			});

		},
		synopsisReset: function (synopsisId) {
			var
				widget = this,
				pointer,
				synopsis;

			// ---   model
			if (synopsisId) {
				G.model.siteSelected.synoptiques.forEach(function (el, index) {
					if (el.id == synopsisId) {
						synopsis = el;
						return false;
					}
					return true;
				});
			}

			if (!synopsis) {
				synopsis = G.model.siteSelected.synoptiques[0];
			}
			this.state.synopsis = synopsis;

			// ---   display selected tab

			this.element.find('.tabs-menu').find('li').each(function (index, el) {
				el = $(el);
				el.toggleClass('current', el.attr('data-synopsis-id') == widget.state.synopsis.id);
			});

			this.element.find(".tabs-menu").find('select')
				.val(this.state.synopsis.id)
				.trigger('change.select2');
			this.element.find(".tabs-select").find('select')
				.val(this.state.synopsis.id)
				.trigger('change.select2');


			// ---   re-build synopsis tab

			// clear former tab
			pointer = this.element.find('.tab');
			pointer.children().remove();


			// rebuild new tab
			this.p.tab = this.templates.synopsisTab.clone();
			this.p.tab.appendTo(pointer);

			// components form behaviour
			this.p.tab
				// .on('click', '.data-update-at-label', this.pingValuesUpdate.bind(this))
				.on('click', '.update-refresh', this.pingValuesUpdate.bind(this))
				.on('click', '.update-cache-validate', this.updateCacheValidate.bind(this))
				.on('click', '.update-cache-reset', this.updateCacheReset.bind(this));

			$('#synopsis-scene')
				.css({
					'background-color': synopsis.color
				})
				.on('click', '.panel-opener', this.groupMenuDisplay.bind(this, true, null))
				.on('click', '.panel-closer', this.groupMenuHide.bind(this, true, null))
				.on('change', 'select.automaton-data, input[type="checkbox"].automaton-data', this.updateCacheAdd.bind(this))
				.on('focusout', 'input[type="text"].automaton-data', this.updateCacheAdd.bind(this));
			$('.exp-datas-container')
				.on('change', 'select.automaton-data, input[type="checkbox"].automaton-data', this.updateCacheAdd.bind(this))
				.on('focusout', 'input[type="text"].automaton-data', this.updateCacheAdd.bind(this));


			// init widget elements
			this.container = $('<div class="synopsis-container"></div>');
			this.container.prependTo(pointer.find('#synopsis-scene'));
			this.container.on('dragstart', function (e) {
				e.preventDefault();
			});

			// --- edition mode

			pointer = this.p.tab.find('.synopsis-editor');
			if (this.options.editionMode) {
				this.editor = new G.ui.SynopsisEditor(pointer.get(0), this);
			} else {
				this.editor = null;
				pointer.remove();
			}

			this.bg.jqo = $('<img class="synopsis-background no-select" alt="" />');
			this.bg.jqo
				.on('dragstart', function (e) {
					e.preventDefault();
				})
				.appendTo(this.container);

			this.preloader = $('<div class="async-loader">' +
				'<svg class="circular" viewBox="25 25 50 50">' +
				'<circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>' +
				'</svg>' +
				'</div>');
			this.preloader.prependTo(this.container);

			// ---   load background scene
			this.bg.size.reset(this.state.synopsis.width, this.state.synopsis.height);

			this.bg.jqo
				.css({
					'max-width': '100%',
					'max-height': '100%'
				})
				.attr('src', this.pathes.bg + this.state.synopsis.src)
				.on('load', function () {
					widget.bg.size.reset(this.width, this.height);
					widget.scaleApply();
					widget.structureLoad();
				})
				.on('error', function () {
					$(this).attr('src', widget.pathes.bgError);
				});

			this.displayAsyncStatus(true);
		},
		synopsisBuildPanel: function () {
			var widget = this;
			var i, ilen, panel, str;

			// ---   group select

			this.p.tab.find('.exp-back-diagram').on('click', this.groupMenuDisplay.bind(this, false, null));

			this.p.groupSelect = this.p.tab.find('.synopsis-groups-select');

			// add group options
			str = '';
			for (i = 0, ilen = this.groups.length; i < ilen; ++i)
				str += '<option value="' + this.groups[i].id + '">' + this.groups[i].label + '</option>';
			$(str).appendTo(this.p.groupSelect);
			this.p.groupSelect.select2({
				width: 'resolve',
				minimumResultsForSearch: -1
			});
			this.p.groupSelect.on('change', function () {
				widget.groupReset($(this).val());
			});


			// add groups blocks
			for (i = 0, ilen = this.groups.length; i < ilen; ++i) {
				panel = (this.groups[i].id === 'system' ? this.templates.infogroupPanel : this.templates.groupPanel).clone()
					.attr('id', 'group-' + this.groups[i].id)
					.appendTo(this.p.tab.find('.exp-datas-container'));
			}

			this.p.tab
				// group select previous/next buttons
				.on('click', '.prev_datas', this.groupBrowse.bind(this, -1))
				.on('click', '.next_datas', this.groupBrowse.bind(this, 1))
				// add series to graph
				.on('click', '.comp-add-data', function () {
					widget.chartLoad('series', $(this).closest('[data-comp-id]').attr('data-comp-id'));
				});


			// ---   utilities menu

			this.element.find('.express-access')
				.on('click', 'li', function () {
					var liEl, utilityId;

					liEl = $(this);
					utilityId = $(this).data('utility-id');


					if (utilityId === 'ico-courb') {
						widget.utilitiesPanelDisplay(!liEl.hasClass('active'), utilityId);

						$('#chart-temp').empty();
						widget.utilitiesInitCourbe();
					}

					else if (utilityId === 'ico-planning') {
						var group, groupId, gvp;

						groupId = liEl.closest('.exp-datas').attr('id').split('-')[1];
						group = widget.groupFind(groupId);
						gvp = G.ui.GVPlanning.GetInstance(widget.templates.planning.find('.gvp'));


						widget.utilitiesPanelDisplay(!liEl.hasClass('active'), utilityId);

						gvp.model_load(group.planning_id, true);
						gvp.events_init(true);
					}
					else if (utilityId === 'ico-history') {
						widget.historyInit(null, true);
					}
				});
		},

		historyInit: function (openStatus, loadDefaultGraph) {
			var
				linkedGraph,
				panelEl = $('.exp-datas').filter('.datas-open'),
				subpanelNavEl = panelEl.find('ul.express-access'),
				historyLiEl = subpanelNavEl.find('li[data-utility-id="ico-history"]')
				;

			if (!isbool(openStatus))
				openStatus = !historyLiEl.hasClass(('active'));

			// --- reset chart
			/*
			Update: avoid graph reset on serie addition >>> africker 14/11/2019
			if(openStatus){
				HCH.chartReset(this.histoChartContainerEl);
				this.histoChart.reflow(true);
			}
			*/
			historyLiEl.toggleClass('active', openStatus);
			this.utilitiesPanelDisplay(openStatus, 'ico-history');

			if (!openStatus)
				return;

			if (isbool(loadDefaultGraph) && loadDefaultGraph) {

				// ---   reset
				HCH.chartReset(this.histoChartContainerEl);
				this.histoChart.reflow(true);

				linkedGraph = this.groupFind(this.p.groupSelect.val()).graphic_id;
				if (!isNaN(linkedGraph)) {
					$('#select-graph')
						.val(linkedGraph)
						.trigger('change.select2');
					HCH.loadGraph(this.histoChartContainerEl, linkedGraph, null, function () {
						HCH._getChart($('.hch-container')).reflow();
					});
				}
				else {
					$('#select-graph')
						.val('')
						.trigger('change.select2');
				}
			}
		},

		chartInit: function () {
			var
				widget = this,
				dateRangePicker = $('#date-range-picker__' + this.options.synopHistoDateRangeUUID)
				;

			this.histoChartContainerEl = $('#exp-histo-chart');

			this.histoChart = HCH.init(this.histoChartContainerEl, Highcharts.merge(HCH.ConfigCore, {
				legend: {
					enabled: false
				}
			}), true, true, true);
			dateRangePicker.on('datechanged', function (e) {
				HCH.chartContext(widget.histoChartContainerEl, {
					siteId: G.model.siteSelected.id,
					from: moment(e.startRange).format('DD/MM/YYYY'),
					to: moment(e.endRange).format('DD/MM/YYYY')
				});
			});
			if (G.model.siteSelected)
				dateRangePicker.trigger('refresh');
		},
		chartPanelReset: function () {
			var selectGraph = $('#select-graph');

			if (selectGraph.data('select2'))
				selectGraph.select2('destroy');

			selectGraph
				.select2({
					width: 'resolve',
					minimumResultsForSearch: -1
				})
				.off('select2:select', this.callbacks.chartLoadGraph)
				.on('select2:select', this.callbacks.chartLoadGraph);

			$('#range-start__' + this.options.synopHistoDateRangeUUID)
				.off('change', this.callbacks.chartDatesRangeUpdate)
				.on('change', this.callbacks.chartDatesRangeUpdate);

			$('#range-end__' + this.options.synopHistoDateRangeUUID)
				.off('change', this.callbacks.chartDatesRangeUpdate)
				.on('change', this.callbacks.chartDatesRangeUpdate);
		},
		chartDatesRangeUpdate: function () {
			var d = $('#date-range-picker__' + this.options.synopHistoDateRangeUUID).data();
			HCH.chartContext(this.histoChartContainerEl, {
				from: $('#range-start__' + this.options.synopHistoDateRangeUUID).val(),
				to: $('#range-end__' + this.options.synopHistoDateRangeUUID).val()
			});
			HCH.chartDatesRangeUpdate(this.histoChartContainerEl);
		},
		chartLoadGraph: function () {

			this.chartLoad('chart', $('#select-graph').val(), {
				dateDebut: $('#range-start__' + $('#select-graph').data('filteruuid')).val(),
				dateFin: $('#range-end__' + $('#select-graph').data('filteruuid')).val()
			});
		},
		chartLoad: function (mode, id, data) {
			var widget = this;

			this.historyInit(true, false);
			if (mode === 'series') {
				console.log('[Synopsis.chartLoad] Load series', {
					siteId: G.model.siteSelected.id,
					pointId: id
				});
				HCH.loadSeries(this.histoChartContainerEl, G.model.siteSelected.id, id, null, function () {
					HCH._initCaption(widget.histoChartContainerEl);
				});
			}
			else {
				console.log('[Synopsis.chartLoad] Load graph', {
					graphId: id,
					data: data
				});
				HCH.loadGraph(this.histoChartContainerEl, id, data, function () {
					HCH._getChart($('.hch-container')).reflow();
				});
			}
		},

		groupFind: function (groupId) {
			groupId = parseInt(groupId);
			for (var i = 0, ilen = this.groups.length; i < ilen; ++i) {
				if (this.groups[i].id === groupId)
					return this.groups[i];
			}
			return null;
		},
		groupMenuHide: function (status, groupId) {
			var infosCtn = this.element.find('.exp-content').find('.panel-comp-list');
			infosCtn[0].remove();
		},
		groupMenuDisplay: function (status, groupId) {

			var infosCtn = this.element.find('.exp-content').find('.exp-infos-container');

			infosCtn.toggleClass('is-open', status);

			if (!status)
				this.focused = null;

			infosCtn.find('.exp-overlay')
				.fadeTo(600, status ? 1 : 0, function () {
					if (!status)
						$(this).hide();
				})
				.toggleClass('in', status);
			infosCtn.find('.exp-back-diagram')
				.fadeTo(600, status ? 1 : 0, function () {
					if (!status)
						$(this).hide();
				})
				.toggleClass('in', status);

			this.groupReset(groupId ? groupId : this.groups[0].id);
		},
		groupReset: function (groupId) {
			var pGroups, pGroup, p, group, pMenu;

			this.state.group = groupId;
			group = this.groupFind(groupId);

			// display group block
			pGroups = $('.exp-datas').removeClass('datas-open');
			pGroup = pGroups.find('#group-' + groupId);
			pGroup.addClass('datas-open');

			// move secondary panel content
			p = pGroup.find('.li-contents');
			this.templates.planning.appendTo(p.find('div[data-utility-id="ico-planning"]'));
			this.templates.curves.appendTo(p.find('div[data-utility-id="ico-courb"]'));
			this.templates.data.appendTo(p.find('div[data-utility-id="ico-history"]'));

			pMenu = $('ul.express-access');
			pMenu.find('li[data-utility-id="ico-planning"]').toggle(group.planning_exists);
			pMenu.find('li[data-utility-id="ico-courb"]').toggle(group.heating_curve_exists);
			HCH.chartReset(this.histoChartContainerEl);

			// update group select
			p = this.p.groupSelect.get(0);
			this.p.groupSelect
				.val(groupId)
				.trigger('change.select2');
			this.p.tab.find('.prev_datas').toggleClass('disabled', p.selectedIndex == 0);
			this.p.tab.find('.next_datas').toggleClass('disabled', p.selectedIndex == p.options.length - 1);

			// display minimap
			p = pGroup.find('.mini-schema-b').get(0);
			if (p && !p.highlight) {
				p.highlight = new G.ui.Highlight(p, {
					selection: group.selection,
					source: this.pathes.minimap + group.source
				});
			}

			// close utilities panel
			this.utilitiesPanelDisplay(false, 'void');
		},
		groupBrowse: function (increment) {
			var optionIndex, select;

			select = this.p.groupSelect.get(0);
			optionIndex = Math.max(0, Math.min(select.options.length - 1, select.selectedIndex + increment));

			if (optionIndex != select.selectedIndex) {
				select.selectedIndex = optionIndex;

				var e;
				if (typeof (Event) === 'function') {
					e = new Event('change');
				} else {
					e = document.createEvent('Event');
					e.initEvent('change', true, true);
				}
				select.dispatchEvent(e);
			}
		},
		groupFillComponents: function (group, asScenePanel) {
			var widget = this, domTarget;
			var completeBuild = function (widget, asSystemPanel) {
				var html = '';
				html += '<form>';
				if (asSystemPanel && !!group.panelPositionContext) {
					html += '<div class="panel-comp-list-item text-right">'
						+ '<div class="panel-closer btn btn--small color-grey">'
						+ '<span class="fal fa-window-close"></span>'
						+ '</div>'
						+ '<div class="panel-opener btn btn--small color-grey">'
						+ G.config.LOCALE_RETRIEVE('synopsis.panelOpener')
						+ '</div>'
						+ '</div>';
				}
				for (var i = 0, ilen = group.components.length; i < ilen; ++i) {
					html += widget.componentsPanelFactory(group.components[i], asSystemPanel);
				}
				html += '</form>';
				return html;
			};

			if (group.panel) {
				group.panel.html(completeBuild(this, true));
				G.ui.initSelect2(group.panel);
			}

			domTarget = $('#group-' + group.id).find('.panel-comp-list');
			domTarget.html(completeBuild(this, false));
			G.ui.initSelect2(domTarget);

			$('#synopsis-scene').find('select.automaton-data, input[type="checkbox"].automaton-data').each(function (index, el) {
				widget.updateCacheAdd($(el), true);
			});
		},

		updateCacheAdd: function (e, isInit) {
			var newval, component, componentId, oldval, input, inputTagName, inputTagType, isCheckbox, changedStatus,
				self = this;

			isInit = isbool(isInit) && isInit;
			input = e instanceof jQuery ? e : $(e.target);
			componentId = input.closest('[data-comp-id]').attr('data-comp-id');
			component = this.componentsRetrieveId(componentId);


			// avoid system and browsing
			if (component == null) {
				console.log('[Synopsis.updateCacheAdd] Unable to retrieve component for id: "' + componentId + '"', input);
				return;
			} else if (this.values.map[component.id] == undefined) {
				console.log('[Synopsis.updateCacheAdd] Unable to retrieve component value for id: "' + component.id + '"');
				return;
			}


			// input context
			inputTagName = input.prop('tagName').toLowerCase();
			inputTagType = input.attr('type');

			if (inputTagType)
				inputTagType = inputTagType.toLowerCase();
			isCheckbox = (inputTagName == 'input') && (inputTagType == 'checkbox');

			// value context
			oldval = this.values.map[component.id].value;
			if (isCheckbox) {
				newval = isInit ? oldval : input.is(':checked');
			} else if (inputTagName == 'div') {
				newval = this.values.map[component.id].value;
				oldval = null;
			} else {
				newval = input.val();
			}
			changedStatus = oldval != newval;

			// retrieve all similar blocks and display update status on component displays
			this.p.tab.find('[data-comp-id="' + component.id + '"]').each(function (blockIndex, blockEl) {
				var valueMapStatus;
				blockEl = $(blockEl);

				blockEl.toggleClass('pending-change', changedStatus);

				// apply new value
				if (isCheckbox) {
					blockEl.find(inputTagName).prop('checked', newval);

					// retrieve value map blocks
					blockEl.find('[data-value-map]').each(function (valueIndex, el) {
						el = $(el);
						valueMapStatus = el.attr('data-value-map') == (newval ? 'istrue' : 'isfalse');
						el.css({
							display: valueMapStatus ? 'inline-block' : 'none'
						});
					});
				}
				else if (inputTagName === 'div') {
					blockEl.find('[data-value-map]').each(function (index, el) {
						el = $(el);
						valueMapStatus = el.attr('data-value-map') == (isbool(newval) ?
							newval ? 'istrue' : 'isfalse' :
							newval.toString()
						);
						el.css({
							display: valueMapStatus ? 'inline-block' : 'none'
						});
					});
				}
				else {
					blockEl.find(inputTagName)
						.val(newval)
						.trigger('change.select2');
				}
			});

			// --- UPDATE MODEL

			// store value (if value does not comeback to original value)
			if (changedStatus)
				this.updateCache[component.id] = newval;
			else
				delete this.updateCache[component.id];
			this.updateCacheDisplay();
		},
		updateCacheDisplay: function () {
			var counter = 0;
			for (var p in this.updateCache) {
				++counter;
			}

			// enable/disable submit and cancel
			$('.update-refresh')
				.html(G.config.LOCALE_RETRIEVE('synopsis.refresh'))
				.css('display', 'inline-block');
			$('.update-cache-validate')
				.toggleClass('disabled', counter == 0)
				.html(G.config.LOCALE_RETRIEVE('synopsis.applyChanges') + (counter > 0 ? ' (' + counter + ')' : ''))
				.css('display', 'inline-block');
			$('.update-cache-reset')
				.toggleClass('disabled', counter == 0)
				.html(G.config.LOCALE_RETRIEVE('synopsis.reset'))
				.css('display', 'inline-block');
		},
		updateCacheReset: function () {
			var pBlock, oldval;

			console.log('[Synopsis.updateCacheReset]', this.updateCache);

			// resets original value on component displays
			for (var componentId in this.updateCache) {
				if (exists(this.values.map[componentId])) {
					oldval = this.values.map[componentId].value;

					if (oldval == null) {
						oldval = '';
					}
					if (isan(oldval)) {
						var tmpOldval = oldval.toFixed(1);
						if (tmpOldval.substr(-2) == '.0') {
							tmpOldval = tmpOldval.substr(0, tmpOldval.length - 2);
						}
						oldval = tmpOldval;
					}
					else {
						oldval = oldval + '';
					}

					pBlock = this.p.tab.find('[data-comp-id="' + componentId + '"]');

					pBlock.toggleClass('pending-change', false);

					pBlock.find('select')
						.val(oldval)
						.trigger('change.select2');
					pBlock.find('input[type="text"]').val(oldval);
					pBlock.find('input[type="checkbox"]').prop("checked", oldval);
				}
				delete this.updateCache[componentId];
			}

			this.updateCacheDisplay();
		},
		updateCacheDone: function () {
			console.log('[updateCacheDone]', this.values.map);
			for (var componentId in this.updateCache) {
				this.values.map[componentId].value = this.updateCache[componentId];
				this.p.tab.find('[data-comp-id="' + componentId + '"]')
					.toggleClass('pending-change', false);
				delete this.updateCache[componentId];
			}
			this.updateCacheDisplay();
		},
		updateCacheValidate: function () {
			var
				self = this,
				commands = [],
				counter = 0;

			$.each(this.updateCache, function (key, value) {
				var comp = self.componentsRetrieveId(key);
				commands.push({
					pointId: key,
					value: value,
					label_automate: comp.label_automate,
					equipement_d: comp.equipement_d,
					equipement_mnemonique: comp.equipement_mnemonique
				});
				counter++;
			});

			showInfo('Demande d\'écriture en cours');
			$.ajax({
				url: G.config.SERVER + 'frontend/ajax/synoptiquestorecommands',
				type: 'POST',
				data: {
					commands: JSON.stringify(commands)
				},
				datatype: 'json',
				error: function (xhr, textStatus, errorThrown) {
					showError("ajax error: " + textStatus, { url: this.url, textStatus: textStatus, error: errorThrown });
				},
				beforeSend: function () {
					$('#data-chart-preloader').toggle(true);
				},
				success: function (dataJson) {
					if (dataJson.status == 'error') {
						showError(dataJson.error);
						return true;
					}

					$.ajax({
						url: G.config.SERVER + 'frontend/ajax/synoptiquecommand',
						type: "POST",
						data: {
							pointId: commands[0].pointId,
							context: 'synoptique',
							value: commands[0].value,
							label_automate: commands[0].label_automate,
							equipement_d: commands[0].equipement_d,
							equipement_mnemonique: commands[0].equipement_mnemonique
						},
						datatype: 'json',
						error: function (xhr, textStatus, errorThrown) {
							showError("ajax error: " + textStatus, { url: this.url, error: errorThrown });
						},
						beforeSend: function (xhr) {
							$('#data-chart-preloader').toggle(true);
						},
						success: function (dataJson, textStatus, xhr) {
							console.log('\t [Synopsis.updateCacheValidate]', dataJson);

							if (dataJson.status === "error") {
								showError(dataJson.error);
								return true;
							}

							if (dataJson.mode === "globalio") {
								G.socketgio.socketgio.connect();

								var voieModbus = 'modbus';
								if (typeof (dataJson.voie) != 'undefined' && dataJson.voie == 2) {
									var voieModbus = 'modbus2';
								}

								var json = { "ip": dataJson.adresseIp, "cmd": dataJson.frame };
								G.socketgio.socketgio.emit(voieModbus, JSON.stringify(json));
								console.log('emit', json);
								showInfo('Envoi des commandes');
							} else if (dataJson.mode == "ozw") {
								$('#tmp-command-mode').val('write');
								$('#tmp-synoptique-equipement-id').val(dataJson.equipement_id);
								$('#tmp-synoptique-address-ip').val(dataJson.adresseIp);
								var typeValue = 'Numeric';
								if (exists(dataJson.typepoint)) {
									var typeValue = dataJson.typepoint;
								}

								G.socketgio.socketgio.connect();
								G.socketgio.socketgio.emit('ozw', JSON.stringify({
									ip: dataJson.adresseIp,
									cmd: 'writepoint#' + dataJson.label + '#' + typeValue + '#' + dataJson.value
								}));
								console.log('\t [Synopsis.updateCacheValidate].OZW Mode', 'writepoint#' + dataJson.label + '#' + typeValue + '#' + dataJson.value);
								showInfo('Envoi des commandes');
							} else {
								if (G.socket.connected || G.socketdevio2.connected || G.socketdevio3.connected) {
									var host = dataJson.dv_host;
									$.ajax({
										url: G.config.SERVER + 'backend/devio/request',
										type: "POST",
										dataType: "json",
										data: {
											method: "cnx",
											finalMethod: "write",
											context: "synoptique",
											host: host,
											automateId: dataJson.equipement_id,
											automate: dataJson.mnemonique_automate
										},
										error: function (xhr, textStatus, errorThrown) {
											showError("ajax error: " + textStatus, { url: this.url, error: errorThrown });
										},
										success: function (data) {
											switch(host){
												case 'devio5':
												case 'devio05':
													G.socket.socket.emit('dvio', data.result);
													break;
												case 'devio6':
												case 'devio06':
													G.socketdevio2.socketdevio2.emit('dvio', data.result);
													break;
												case 'devio7':
												case 'devio07':
													G.socketdevio3.socketdevio3.emit('dvio', data.result);
													break;
												default:
													G.socketdevio2.socketdevio2.emit('dvio', data.result);
											}
										}
									});
								}
							}
						}
					});

				}
			});
		},

		utilitiesPanelDisplay: function (status, id) {
			var classname;

			console.log('[Synopsis.utilitiesPanelDisplay] status: ' + status + ', id: "' + id + '"');

			// toggle back button styles
			$('.exp-back-diagram').toggleClass('on-top', status);

			classname = 'active';
			this.element.find('.express-access, li')
				.removeClass(classname)
				.filter('[data-utility-id="' + id + '"]').toggleClass(classname, status);

			classname = 'is-open';
			this.element.find('.li-contents div')
				.removeClass(classname)
				.filter('[data-utility-id="' + id + '"]')
				.toggleClass(classname, status);

			if (status && id === 'ico-history')
				this.chartPanelReset();
		},
		utilitiesInitCourbe: function () {
			var ccPointer, url, collSafe, self = this;

			ccPointer = $('#chart-temp');
			console.log('[Synopsis.initStructureLoad] init');
			ccPointer.addClass('characteristic-curve');

			console.debug(this.state.group);
			//var groupId = $(this).parents().parents().parents().parents().attr('id').split('-')[1];
			// @todo (search here for data: this.state)

			var groupId = this.state.group;
			$.ajax({
				url: G.config.SERVER + 'frontend/ajax/synoptiquecourbechauffe',
				type: 'POST',
				dataType: "json",
				data: {
					groupId: this.state.group
				},
				error: function (xhr, textStatus, thrownError) {
					console.error('[Synopsis.utilitiesInitCourbe] "' + url + '", ajax error: ' + textStatus, thrownError);
				},
				beforeSend: function () {
					$('#data-courbe-de-chauffe-preloader').toggle(true);
					$("#table-chart-temp").hide();
					$("#graph-status-message").empty();
					$("#graph-status-message").hide();
				},
				success: function (data) {
					$('#data-courbe-de-chauffe-preloader').toggle(false);

					if (exists(data.error)) {
						showError(data.error);
						return true;
					}

					if (data.mode == "default") {
						if (typeof (data.dotsNumMini) == "undefined") {
							$('#chart-temp').html('<p>Il n\'y a pas de courbe de chauffe configurée pour ce groupe</p>');
							return true;
						}
					}

					if(exists(self.p.cc)) {
						self.p.cc.jqoTarget.off('modelUpdated');
						self.p.cc.jqoTarget.off('modelExported');
						self.p.cc.destroy();
						self.p.cc = null;
					}

					self.p.cc = new G.ui.CharacteristicCurveGraph(ccPointer, data);
					self.p.cc.jqoTarget.on('modelUpdated', function (e, settings) {
						if(exists(settings.linearMaxTemp)) $('#txt-temperature_max').val(settings.linearMaxTemp);
						if(exists(settings.linearSlope)) $('#txt-pente_pente').val(parseFloat(settings.linearSlope).toFixed(1));
						if(exists(settings.coll) && isarray(settings.coll)) {
							$("#table-chart-temp tbody").empty();
							if(settings.coll.length == 0) {
								$("#table-chart-temp tbody").append(`
									<tr>
										<td colspan="3">${G.config.LOCALE_RETRIEVE('datatable.emptyTable')}</td>
									</tr>
								`);
							} else {
								for (const [index, dotColl] of self.p.cc.o.dotsColl.entries()) {
									$("#table-chart-temp tbody").append(`
										<tr>
											<td>${index + 1}</td>
											<td class="text-center"><input type="number" class="uicomp__input courb_point_axis_field" data-point-id="${dotColl.uid}" data-point-axis="x" value="${dotColl["x"]}" ${dotColl["x_type"] == "const" ? "disabled" : ""}/></td>
											<td class="text-center"><input type="number" class="uicomp__input courb_point_axis_field" data-point-id="${dotColl.uid}" data-point-axis="y" value="${dotColl["y"]}" ${dotColl["y_type"] == "const" ? "disabled" : ""}/></td>
										</tr>
									`);
								}
							}

							$("#table-chart-temp").show();
						}
					});

					$("#graph-status-message").toggle(data.meta.writeInProgess);
					if(data.meta.writeInProgess && data.meta.lastRequest) {
						$("#graph-status-message").text(
							G.config.LOCALE_RETRIEVE('general.writingRequestSinceTo').replace(
								"{DATE}",
								new Date(data.meta.lastRequest).toLocaleString()
							)
						);
					}

					collSafe = { ...data };
					/* "ça on touche pas" © Nicolas Gyss - 27/03/2019 */
					if (data.mode == "default") {
						// @see https://stackoverflow.com/a/9886013
						collSafe = JSON.parse(JSON.stringify(data.dotsColl));
					}

					$('.courb-pente').show();
					if (data.mode == 'default') {
						$('.courb-pente').hide();
					}
					if (exists(data.linearMaxTemp)) {
						$('#txt-temperature_max').val(data.linearMaxTemp);
					}
					if (exists(data.linearSlope)) {
						$('#txt-pente_pente').val(data.linearSlope);
					}

					$('#isbaelz').val(0);
					if (data.baelz) {
						$('#isbaelz').val(data.baelz);
					}

					function graphModelExported(e, coll) {
						console.log(e, coll)
						var collSaved = coll;
						url = G.config.SERVER + 'frontend/ajax/synoptiquecourbechauffe';
						console.log('url = ' + url);
						console.log('before coll = ');
						console.log(collSaved);

						$.ajax({
							url: url,
							dataType: "json",
							data: {
								groupId: groupId,
								coll: collSaved
							},
							type: 'POST',
							error: function (xhr, textStatus, thrownError) {
								console.error('[Synopsis.graphModelExported] "' + url + '", ajax error: ' + textStatus, thrownError);
							},
							beforeSend: function () {
								showInfo('Demande d\'écriture en cours, veuillez ne pas fermer la page');
							},
							success: function (data) {
								console.log(data, data.coll, data.coll.length);
								// console.log('size = ' + data.coll.coll.length);
								console.log('dotsColl' + data.dotsColl);
								console.log('write', data.write.length);

								var mode = "";
								var baelzcommand = "";
								for (var cc = 0; cc < data.write.length; cc++) {
									var d = data.write[cc];
									if (baelzcommand !== "") {
										baelzcommand += "###";
									}
									baelzcommand += d.pointId + ";" + d.value + ";" + d.mnemonique;
								}
								if (exists(data.coll.coll)) {
									for (var cc = 0; cc < data.coll.coll.length; cc++) {
										console.log('coll[cc]: ', data.coll.coll[cc], 'dotsColl[cc]: ', data.dotsColl[cc]);

										if ($('#isbaelz').val() == 1 || $('#isbaelz').val() == "true") {
											if (baelzcommand != "") {
												baelzcommand += "###";
											}
											baelzcommand += data.dotsColl[cc].x_pointId + ";" + parseInt(data.coll.coll[cc].x) + ";" + data.dotsColl[cc].x_label_automate + "###";
											baelzcommand += data.dotsColl[cc].y_pointId + ";" + parseInt(data.coll.coll[cc].y) + ";" + data.dotsColl[cc].y_label_automate;

										} else {

											if (data.dotsColl[cc].x_type === 'dynamic') {
												if (baelzcommand != "") {
													baelzcommand += "###";
												}
												baelzcommand += data.dotsColl[cc].x_pointId + ";" + parseInt(data.coll.coll[cc].x) + ";" + data.dotsColl[cc].x_label_automate;
											}
											if (data.dotsColl[cc].y_type === 'dynamic') {
												if (baelzcommand !== "") {
													baelzcommand += "###";
												}
												baelzcommand += data.dotsColl[cc].y_pointId + ";" + parseInt(data.coll.coll[cc].y) + ";" + data.dotsColl[cc].y_label_automate;
											}
										}
									}

								}
								console.log('baelzcommand', baelzcommand);
								if (baelzcommand != "") {
									console.log('run command', baelzcommand);
									$.ajax({
										url: G.config.SERVER + 'frontend/ajax/synoptiquemulticommands',
										type: "POST",
										data: {
											groupId: groupId,
											data: baelzcommand,
											baelz: $('#isbaelz').val()
										},
										datatype: 'json',
										error: function (xhr, textStatus) {
											console.error('[Synopsis.graphModelExported] "synoptiquemulticommands", ajax error: ' + textStatus, thrownError);
										},
										success: function (dataJson) {
											console.log(dataJson);
											showInfo("L'écriture des paramètres a été programmée. <br />Vous serez notifié du résultat de l'opération par mail.", 10000);
										}
									});
								}

							}
						});

						// @todo : should be sent to database
						// console.warn('[Synopsis] function "graphModelExported" is not implemented', coll, dotsMini, dotsMaxi);
					}

					function graphModelUpdated(e, coll, dotsMini, dotsMaxi) {
						if (dotsMaxi == dotsMini) {
							$('#courb-add-point').css('visibility', 'hidden');
							$('#courb-remove-point').css('visibility', 'hidden');
						} else {
							$('#courb-add-point')
								.prop('disabled', coll.length >= dotsMaxi)
								.css('visibility', 'visible');
							$('#courb-remove-point')
								.prop('disabled', coll.length <= dotsMini)
								.css('visibility', 'visible');
						}
					}

					/* <------------ end :::: "ça on touche pas" © Nicolas Gyss - 27/03/2019 */

					self.p.cc.jqoTarget.on('modelUpdated', graphModelUpdated);
					self.p.cc.jqoTarget.on('modelExported', graphModelExported);
					self.p.cc.modelUpdate();

					$('#courb-save').off('click');
					$('#courb-add-point').off('click');
					$('#courb-remove-point').off('click');
					$('#txt-pente_pente').off('change');
					$(document).off('change', '.courb_point_axis_field');

					$('#courb-save').on('click', function () {
						self.p.cc.modelExport();
					});
					$('#courb-reset').on('click', function () {
						self.p.cc.modelImport(collSafe);
					});

					$('#courb-add-point').on('click', function () {
						$(this).prop('disabled', true);
						self.p.cc.collEditPointAdd();
					});

					$('#courb-remove-point').on('click', function () {
						$(this).prop('disabled', true);
						self.p.cc.collEditPointRemove();
					});
					$('#txt-pente_pente').on('change', function(event) {
						let slopeInput$ = $(event.currentTarget);
						self.p.cc.plugin.updateSlope(
							slopeInput$.val()
						);
					});
					$(document).on('change', '.courb_point_axis_field', function(event) {
						let courbPointAxisField$ = $(event.currentTarget);
						self.p.cc.plugin.updateAxisByUid(
							courbPointAxisField$.data("point-id"),
							courbPointAxisField$.data("point-axis"),
							courbPointAxisField$.val()
						);
					});
				}
			});
			//}
		},

		structureLoad: function () {
			var url;

			url = this.pathes.structure + this.state.synopsis.id;
			$.ajax({
				url: url,
				dataType: 'json',
				type: 'POST',
				data: null,
				error: this.displayError.bind(this, 'Unable to load: ' + url),
				success: this.structureLoaded.bind(this)
			});
		},
		structureLoaded: function (data) {
			var i, ilen, comp, logStr;

			this.displayAsyncStatus(false);

			this.groups = [];
			for (i = 0, ilen = data.groups.length; i < ilen; ++i) {
				comp = new G.vo.SynopsisGroup(this, data.groups[i]);
				this.groups.push(comp);
				this.components = this.components.concat(comp.components);
			}

			logStr = '[Synopsis.initStructureLoaded]';
			logStr += '\n\t groups: ' + this.groups.length;
			for (i = 0, ilen = this.groups.length; i < ilen; ++i)
				logStr += '\n\t\t ' + this.groups[i].toString();
			logStr += '\n\t components: ' + this.components.length;

			this.synopsisBuildPanel();

            this.container.find('[data-synopsis-id]').each(function (index, el) {
                el = $(el);
                for (var i = 0, ilen = G.model.siteSelected.synoptiques.length, s; i < ilen; ++i) {
                    s = G.model.siteSelected.synoptiques[i];
                    if (s.id == el.attr('data-synopsis-id')) {

                        var synopticDisplayName = s.nom;
                        if (G.model.siteSelected.isEstateSite == 1) {
                            var synopticSite = G.model.siteSelected.estateSiteChilds.find(function(child) {
                                return child.id == s.siteId;
                            }) ?? null;
                            if (exists(synopticSite)) {
                                synopticDisplayName = synopticSite.nom + ' / ' + s.nom;
                            }
                        }

                        el.html(synopticDisplayName);
                        break;
                    }
                }
            });

			this._trigger('structureUpdate', $.Event('structureUpdate'));

			this.registeredValuesUpdate(true, 'registered');
		},
		structureToJSONObject: function () {
			var o;

			o = {};
			o.groups = [];
			for (var i = 0, ilen = this.groups.length; i < ilen; ++i) {
				o.groups[i] = this.groups[i].toJSONObject();
			}
			return o;
		},
		structureAddComponent: function (componentJqo, componentPositionContext) {
			componentJqo.appendTo(this.container);
			this.on('resize', this.transformPosition.bind(this, componentJqo, componentPositionContext));
			this.transformPosition(componentJqo, componentPositionContext);
		},


		// VALUES
		// ----------------------------------------------------------------------

		requiredPointsKeys: function () {
			var r = [];
			for (var i = 0, ilen = this.groups.length; i < ilen; ++i) {
				r = r.concat(this.groups[i].requiredPoints())
			}
			r = r.getUnique();
			return r;
		},
		onlyValuesUpdate: function (host) {
			var keys, self;

			keys = this.requiredPointsKeys();
			self = this;
			var url = this.pathes.values + this.state.synopsis.id;
			$.ajax({
				url: url,
				dataType: 'json',
				type: 'POST',
				data: {
					target: host,
					keys: keys,
					type: 'valuesupdate'
				},
				error: function (dataError) {
					showError('Unable to load: ' + url);
				},
				success: function (data) {
					self.valuesUpdatedAutomate(data);
				}
			});
		},
		registeredValuesUpdate: function (isFirst, type) {
			if(type === 'ping'){
				// console.log('disabled update refresh', "$('.update-refresh').addClass('disabled')", $('.update-refresh'));
				$('.update-refresh').addClass('disabled');
			}
			var url, keys, self;

			keys = this.requiredPointsKeys();
			self = this;
			// console.log('[Synopsis.registeredValuesUpdate]', keys, type);
			url = this.pathes.values + this.state.synopsis.id;

			$.ajax({
				url: url,
				dataType: 'json',
				type: 'POST',
				data: {
					isFirst: isFirst,
					type: type,
					keys: keys
				},
				beforeSend: function () {
					$('#data-synoptique-preloader').toggle(true);
					self.p.groupSelect.prop('disabled', 'disabled');
				},
				error: function () {
					showError('Unable to load: ' + url);
				},
				success: function (data) {
					if( exists(data.error) ){
						showError(data.error);
						return false;
					}

					if (data.dv_refresh == 1) {
						var host = data.dv_host;

						if ((G.socket.connected || G.socketdevio2.connected || G.socketdevio3.connected) && !self.options.editionMode) {
							if (typeof (data.dv_equipements[0]) != 'undefined' && data.dv_equipements[0].ping == 1) {
								$.ajax({
									url: G.config.SERVER + 'frontend/ajax/isAvailable',
									type: "POST",
									data: {
										equipementId: data.dv_equipements[0].id
									},
									datatype: "json",
									error: function (xhr, textStatus, errorThrown) {
										showError("ajax error: " + textStatus, { url: this.url, error: errorThrown });
									},
									beforeSend: function (xhr) {
										showInfo('Vérification de la communication');
									},
									success: function (dataAvailable, textStatus, xhr) {
										var url = G.config.SERVER + 'backend/devio/request';

										if (dataAvailable.status === "error") {
											showError(dataAvailable.error);
											return false;
										}

										$.ajax({
											url: url,
											type: "POST",
											dataType: "json",
											data: {
												method: "cnx",
												finalMethod: "tempsreel",
												host: host,
												automateId: data.dv_equipements[0].id,
												automate: data.dv_equipements[0].mnemonique
											},
											beforeSend: function () {
												showInfo('Connexion à l\'automate');
											},
											error: function (xhr, textStatus, errorThrown) {
												showError("ajax error: " + textStatus, { url: this.url, error: errorThrown });
											},
											success: function (data) {
												switch(host){
													case 'devio5':
													case 'devio05':
														G.socket.socket.emit('dvio', data.result);
														break;
													case 'devio6':
													case 'devio06':
														G.socketdevio2.socketdevio2.emit('dvio', data.result);
														break;
													case 'devio7':
													case 'devio07':
														G.socketdevio3.socketdevio3.emit('dvio', data.result);
														break;
													default:
														G.socketdevio2.socketdevio2.emit('dvio', data.result);
												}
											}
										});
									}
								});
							} else if(typeof(data.dv_equipements[0]) != 'undefined' ) {
								$.ajax({
									url: G.config.SERVER + 'backend/devio/request',
									type: "POST",
									dataType: "json",
									data: {
										method: "cnx",
										finalMethod: "tempsreel",
										host: host,
										automateId: data.dv_equipements[0].id,
										automate: data.dv_equipements[0].mnemonique
									},
									beforeSend: function () {
										showInfo('Connexion à l\'automate');
									},
									error: function (xhr, textStatus, errorThrown) {
										G.ui.fatalError("ajax error: " + textStatus, { url: this.url, error: errorThrown });
									},
									success: function (data) {
										switch(host){
											case 'devio5':
											case 'devio05':
												G.socket.socket.emit('dvio', data.result);
												break;
											case 'devio6':
											case 'devio06':
												G.socketdevio2.socketdevio2.emit('dvio', data.result);
												break;
											case 'devio7':
											case 'devio07':
												G.socketdevio3.socketdevio3.emit('dvio', data.result);
												break;
											default:
												G.socketdevio2.socketdevio2.emit('dvio', data.result);
										}
									}
								});
							}
						}
					}

					if (data.globalio == 1 && data.globalio_refresh == 1) {
						$('#tmp-synoptique-equipement-id').val(data.globalio_equipement_id);
						$('#tmp-synoptique-address-ip').val(data.adresseIp);
						showInfo('Interrogation de la passerelle');

						G.socketgio.socketgio.connect();
						G.socketgio.socketgio.emit('read', JSON.stringify({
							ip: data.adresseIp,
							serial: data.mnemonique,
							cmd: "tableRepModbus"
						}));
					} else if (data.siemens == 1 && data.siemens_refresh == 1) {
						$('#tmp-synoptique-equipement-id').val(data.equipement_id);
						$('#tmp-synoptique-address-ip').val(data.adresseIp);
						$('#tmp-command-mode').val('synoptique_real_time');
						showInfo('Interrogation de la passerelle');
						G.socketgio.socketgio.connect();
						G.socketgio.socketgio.emit('ozw', JSON.stringify({
							ip: data.adresseIp,
							cmd: 'readpointsbyid#' + data.siemensIds
						}));
					}

					self.valuesUpdated(data);
				},
				complete: function() {
					self.p.groupSelect.removeAttr('disabled');
				}
			});
		},
		pingValuesUpdate: function () {
			$('.update-refresh').addClass('disabled');

			this.registeredValuesUpdate(false, 'ping');
		},

		valuesUpdated: function (data) {
			console.log('[valuesUpdated]', data);
			var i, ilen, j, jlen, found, r, p, component, self = this;
			
			this.values.type = data.type;
			this.values.feedback = data.feedback;
			this.values.date = '';

			if (data.date != '') {

				if (!Number.isInteger(data.date)) {
					var d = data.date;
					var s = d.split('T');
					var e = s[0] + " " + s[1];
					var t = e.split(/[- :]/);
					var tmpdate = new Date(t[0], t[1] - 1, t[2], t[3], t[4]);
					
					this.values.date = tmpdate;
				} else {
					this.values.date = new Date(data.date);
				}
			}

			// values map
			this.values.map = {};
			for (i = 0, ilen = data.points_values.length, p; i < ilen; ++i) {
				p = data.points_values[i];
				component = this.componentsRetrieveId(p.id);
				if (component === null) {
					console.log('[valuesUpdated] component not found', p.id);
					continue;
				}
				if (component && (component.hasOwnProperty('datatype') && component.datatype == 'boolean') && !isbool(p.value)) {
					p.value = (p.value_raw == (isan(p.value_raw) ? 1 : 'true'));
				} else if (component && (component.hasOwnProperty('datatype') && component.datatype == 'analogic-select')) {
					found = false;
					rulesLoop: for (j = 0, jlen = component.rules.length; j < jlen; ++j) {
						r = component.rules[j];
						if (r.comparison != 'any' && r.threshold == p.value)
							found = true;
					}
					if (!found)
						p.value = 'analogic-select-default';
				}
				var finalValue = p.value;
				if (exists(component.datatype)) {
					if (component.datatype == 'analogic-select' && exists(p.value_raw)) {
						var finalValue = p.value_raw;
					}
					if (component.datatype == 'boolean' && exists(p.value_raw)) {
						var finalValue = (p.value_raw == 1) ? true : false;
					}
				}
				this.values.map[p.id] = {
					value: finalValue,
					unit: p.unit,
					precision: p.precision || 0
				};
			}

			// display update date
			this.element.find('.data-update-at-label')
				.find('span')
				.html(G.config.LOCALE_DATE(this.values.date));

			// display groups panels content
			for (i = 0, ilen = this.groups.length; i < ilen; ++i) {
				this.groupFillComponents(this.groups[i], true);
			}


			// apply default on analogic select
			$('.exp-datas-container').find('.panel-comp-list-item--major').each(function (index, el) {
				el = $(el);
				if (el.find('.value-map'))
					self.updateCacheAdd(el, true);
			});


			this.groupReset(this.groups[0].id);

			if (this.options.editionMode) {
				this.editor.modelInit(this.state.synopsis, this.groups);
			}

			this._trigger('valuesUpdate', $.Event('valuesUpdate'));

			this.updateCacheReset();
			$('#data-synoptique-preloader').toggle(false);
		},

		valuesUpdatedAutomate: function (data) {
			var i, ilen, j, jlen, found, r, p, component, self = this;

			showInfo('Mise à jour des valeurs');

			// data context
			this.values.type = data.type;
			this.values.feedback = data.feedback;
			this.values.date = '';
			if (data.date != '') {
				if (!Number.isInteger(data.date)) {
					var d = data.date;
					var s = d.split('T');
					var e = s[0] + " " + s[1];
					var t = e.split(/[- :]/);
					var tmpdate = new Date(parseInt(t[0]), parseInt(t[1]) - 1, parseInt(t[2]), parseInt(t[3]), parseInt(t[4]));
					this.values.date = tmpdate;
				}
				else {
					this.values.date = new Date(data.date);
				}
			}

			// values map
			this.values.map = {};
			for (i = 0, ilen = data.points_values.length, p; i < ilen; ++i) {
				p = data.points_values[i];
				component = this.componentsRetrieveId(p.id);
				if (component === null) {
					continue;
				}
				if (component && (component.hasOwnProperty('datatype') && component.datatype == 'boolean') && !isbool(p.value)) {
					p.value = (p.value_raw == (isan(p.value_raw) ? 1 : 'true'));
				} else if (component && (component.hasOwnProperty('datatype') && component.datatype == 'analogic-select')) {
					found = false;
					for (j = 0, jlen = component.rules.length; j < jlen; ++j) {
						r = component.rules[j];
						if (r.comparison != 'any' && r.threshold == p.value)
							found = true;
					}
					if (!found)
						p.value = 'analogic-select-default';
				}
				var finalValue = p.value;
				if (exists(component.datatype)) {
					if (component.datatype == 'analogic-select' && exists(p.value_raw)) {
						var finalValue = p.value_raw;
					}
					if (component.datatype == 'boolean' && exists(p.value_raw)) {
						var finalValue = (p.value_raw == 1) ? true : false;
					}
				}
				this.values.map[p.id] = {
					value: finalValue,
					unit: p.unit || '',
					// value: p.value,
					precision: p.precision || 0
				};
			}

			// display update date
			this.element.find('.data-update-at-label')
				.find('span')
				.html(G.config.LOCALE_DATE(this.values.date));

			// display groups panels content
			for (i = 0, ilen = this.groups.length; i < ilen; ++i) {
				this.groupFillComponents(this.groups[i], true);
			}


			// apply default on analogic select
			$('.exp-datas-container').find('.panel-comp-list-item--major').each(function (index, el) {
				el = $(el);
				if (el.find('.value-map'))
					self.updateCacheAdd(el, true);
			});

			this.groupReset(this.groups[0].id);

			if (this.options.editionMode) {
				this.editor.modelInit(this.state.synopsis, this.groups);
			}

			this._trigger('valuesUpdate', $.Event('valuesUpdate'));

			this.updateCacheReset();
			showInfo('Valeurs rafraîchies');
			$('.update-refresh').removeClass('disabled');
			notificationsClearAll(5000);
		}
	});

})(jQuery, window, document);
var G;
var proto; 

if (!G)
	G = {};
if (!G.ui)
	G.ui = {};

// -------------------------------------------------------------------------
// PUBLIC METHODS
// -------------------------------------------------------------------------

G.ui.Highlight = function (target, options) {
	this.target = target;
	
	this.options = {
		editable: false,
		source: null,
		selection: null,
		overlayColor: '#000000',
		overlayOpacity: .5,
		precision: 2
	};
	this.options = deepmerge(this.options, options);
	
	if(this.options.editable){
		$(this.target).css('cursor', 'crosshair');
	}
	
	this._callbacks = {
		resize: this._resize.bind(this),
		dragStart: this._dragStart.bind(this),
		dragMove: this._dragMove.bind(this),
		dragStop: this._dragStop.bind(this)
	};
	
	this._stt = { 
		id: target.id,
		dragged: false,
		startPos: {x: 0, y: 0},
		cnvSize: {x: 0, y: 0},
		srcSize: {x: 0, y: 0},
		imgSize: {x: 0, y: 0},
		scale: 1,
		selImg: {top: 0, left: 0, right: 0, bottom: 0},
		selSrc: {top: 0, left: 0, right: 0, bottom: 0}
	};
	
	this._cnv = document.createElement('canvas');
	target.appendChild(this._cnv);
	
	this._ctx = this._cnv.getContext('2d');
	
	this._img = new Image();
	this._img.onload = this._callbacks.resize;
	
	window.addEventListener('resize', this._callbacks.resize);
	if (this.options.editable)
		this._cnv.addEventListener('mousedown', this._callbacks.dragStart, false);
	
	this.reset(this.options.source, this.options.selection);
};
proto = G.ui.Highlight.prototype;
 
proto.reset = function(source, selection){
	this.options.source = source;
	this.options.selection = this._fixSelection(selection);
	this._img.src = this.options.source;
};
proto.getSelection = function(){
	var p = Math.pow(10, this.options.precision);
	var s = this.options.selection;
	for(var prop in s){
		if(s.hasOwnProperty(prop))
			s[prop] = Math.round(s[prop] * p) / p;
	}
	return s;
};
proto.setSelection = function(selection){
	this.options.selection =  this._fixSelection(selection);
	this._updateSelection();
};
proto.destroy = function () {
	window.removeEventListener('resize', this._callbacks.resize);
	this._cnv.removeEventListener('mousedown', this._callbacks.dragStart);
	document.removeEventListener('mousemove', this._callbacks.dragMove);
	document.removeEventListener('mouseup', this._callbacks.dragStop);
};
 

// -------------------------------------------------------------------------
// PRIVATE METHODS
// -------------------------------------------------------------------------

proto._dragStart = function (e) {
	this._cnv.removeEventListener('mousedown', this._callbacks.dragStart);
	document.addEventListener('mousemove', this._callbacks.dragMove, false);
	document.addEventListener('mouseup', this._callbacks.dragStop, false);
	
	this._stt.dragged = true;
	this._stt.startPos = this._getCoords(e);
	this.options.selection = {};
	
	this._dragMove(e);
};
proto._dragMove = function (e) {
	var coords = this._getCoords(e);
	var s = this._stt;
	 
	this.setSelection({
		left: s.startPos.x / s.imgSize.x,
		right: coords.x / s.imgSize.x,
		top: s.startPos.y / s.imgSize.y,
		bottom: coords.y / s.imgSize.y
	});
};
proto._dragStop = function () {
	this._cnv.addEventListener('mousedown', this._callbacks.dragStart, false);
	document.removeEventListener('mousemove', this._callbacks.dragMove);
	document.removeEventListener('mouseup', this._callbacks.dragStop);
	
	this._stt.dragged = false;
	this.setSelection(this.options.selection);
};
proto._isHor = function (p) {
	return p == 'left' || p == 'right' || p == 'width';
};
proto._updateSelection = function () {
	var p;
	var s = this._stt;
	var sel = this.options.selection;
	
	if (sel != null) {
		s.selSrc = deepmerge({}, sel);
		for (p in s.selSrc) {
			if (s.selSrc.hasOwnProperty(p))
				s.selSrc[p] = s.selSrc[p] * (this._isHor(p) ? s.srcSize.x : s.srcSize.y);
		}
		
		s.selImg = deepmerge({}, s.selSrc);
		for (p in s.selImg) {
			if (s.selImg.hasOwnProperty(p))
				s.selImg[p] = s.selImg[p] * s.scale;
		}
	}
	this._redraw();
};
proto._contrains = function (v, mini, maxi) {
	if (v < mini)
		return mini;
	else if (v > maxi)
		return maxi;
	return v;
};
proto._getCoords = function (e) {
	var o = $(this.target).offset();
	return {
		x: this._contrains(e.pageX - o.left, 0, this._stt.imgSize.x),
		y: this._contrains(e.pageY - o.top, 0, this._stt.imgSize.y)
	};
};
proto._resize = function () {
	var cnv = this._cnv;
	var img = this._img;
	var s = this._stt;
	
	cnv.width = this.target.offsetWidth;
	cnv.height = this.target.offsetHeight;
	
	s.cnvSize = {x: cnv.width, y: cnv.height};
	s.srcSize = {x: img.width, y: img.height};
	s.scale = Math.min(s.cnvSize.x / s.srcSize.x, s.cnvSize.y / s.srcSize.y);
	s.imgSize = {x: Math.round(s.srcSize.x * s.scale), y: Math.round(s.srcSize.y * s.scale)};
	
	this._updateSelection();
	this._redraw();
};
proto._redraw = function(){
	var ctx = this._ctx;
	var s = this._stt;
	 
	// --- source image
	ctx.drawImage(this._img,
		0, 0, s.srcSize.x, s.srcSize.y,
		0, 0, s.imgSize.x, s.imgSize.y
	);
	
	// --- if selection is empty do not display overlay
	if(this.options.selection == null)
		return;
	
	// --- overlay
	ctx.save();
	ctx.globalAlpha = this.options.overlayOpacity;
	ctx.fillStyle = this.options.overlayColor;
	ctx.fillRect(0, 0, s.imgSize.x, s.imgSize.y);
	ctx.restore();
	
	
	// --- selection
	if(s.selImg.width > 0 && s.selImg.height > 0 ){
		ctx.save();
		ctx.beginPath();
		ctx.clearRect(s.selImg.left, s.selImg.top, s.selImg.width, s.selImg.height);
		ctx.rect(s.selImg.left, s.selImg.top, s.selImg.width, s.selImg.height);
		ctx.clip();
		ctx.drawImage(this._img,
			s.selSrc.left, s.selSrc.top, s.selSrc.width, s.selSrc.height,
			s.selImg.left, s.selImg.top, s.selImg.width, s.selImg.height
		);
		ctx.restore();
	}
};
proto._fixSelection = function(s){
	var temp;
	
	if(!s)
		return null;
	
	switch(false){
		case s.hasOwnProperty('left'):
		case s.hasOwnProperty('right'):
		case s.hasOwnProperty('top'):
		case s.hasOwnProperty('bottom'):
			return null;
	}
	
	// correct invalid values
	if(s.left > s.right){
		temp = s.left;
		s.left = s.right;
		s.right = temp;
	}
	if(s.top > s.bottom){
		temp = s.top;
		s.top = s.bottom;
		s.bottom = temp;
	}
	s.width = s.right - s.left;
	s.height = s.bottom - s.top;
	
	if(!this._stt.dragged && (s.width == 0 || s.height == 0))
		return null;
	
	return s;
};

var G;
var proto;

if (!G)
	G = {};
if (!G.ui)
	G.ui = {};

//    ###########################################################################################
//       CharacteristicCurveGraph
//    ###########################################################################################
if(!G.ui.CharacteristicCurveGraph){
	
	G.ui.CharacteristicCurveGraph = function (target, o) {
		console.log('[CharacteristicCurveGraph] on "#' + target.attr('id') + '"');
		
		// ---   options data consolidation
		this.o = {
			
			// widget display
			width: '100%',
			height: '100%',
			margin: {
				top: 10,
				left:70,
				bottom: 60,
				right: 15
			},
			
			mode: 'linear',
			linearSlope: .8,
			linearStep:  20,
			linearMaxTemp: 80,
			
			// drag
			dragXLimitsMode: 'reorder', /* reorder, block */
			dragShowLabel: true,
			dragShowAxis: true,
			dragRoundVal: true,
			
			// mouseover
			mouseoverShowLabel: false,
			mouseoverShowAxis: false,
			
			// style
			styleAxisThickness: 1,
			styleAxisColor: '#666666',
			styleAxisDivisionLength: 7,
			styleAxisDivisionShowValue: true,
			styleAxisDivisionOffset: 10,
			
			styleDefaultColor: '#333530',
			styleDefaultThickness: 2,
			styleDefaultDashLength: 0,
			styleDefaultDashGap: 0,
			
			styleEcoColor: '#92928F',
			styleEcoThickness: 2,
			styleEcoDashLength: 3,
			styleEcoDashGap: 4,
			
			styleIdleColor: '#DCDCDC',
			styleIdleThickness: 2,
			styleIdleDashLength: 3,
			styleIdleDashGap: 4,
			
			deltaEco: 0,
			deltaIdle: 0,
			
			// xAxis
			xAxisLabel: 'Température Extérieure (°C)',
			xAxisUnit: "°C",
			xAxisRounding: 1,
			xAxisDivision: 10,
			xAxisPrecision: 0,
			xAxisMini: -20,
			xAxisMaxi: 30,
			
			// yAxis
			yAxisLabel: 'Température Départ Réseau (°C)',
			yAxisUnit: "°C",
			yAxisRounding: 1,
			yAxisDivision: 10,
			yAxisPrecision: 0,
			yAxisMini: 0,
			yAxisMaxi: 100,
			
			// dots
			dotsXLockDefault: false,
			dotsYLockDefault: false,
			dotsNumMini: 2,
			dotsNumMaxi: 10,
			dotsColl: []
		};
		
		this.o = deepmerge(this.o, o);
		o = this.o;
		
		// ---   options data consolidation
		
		// margin utilities
		this.o.margin.width = this.o.margin.left + this.o.margin.right;
		this.o.margin.height = this.o.margin.top + this.o.margin.bottom;
		
		// stored callbacks
		this.callbacks = {
			resize: this.resize.bind(this)
		};
		
		// working variables
		this.dotsCounter = 0;
		this.vw = {
			x: 0,
			y: 0
		};
		
		
		// sub-elements
		this.jqoTarget = target;
		
		this.jqoDots = $('<div class="dots"></div>');
		this.jqoDots.appendTo(this.jqoTarget);
		
		this.jqoGraph = $('<div class="graph"></div>');
		this.jqoGraph.appendTo(this.jqoTarget);
		
		this.jqoCnvGraph = $('<canvas class="graph"></canvas>');
		this.jqoCnvGraph.appendTo(this.jqoTarget);
		this.cnvGraph = this.jqoCnvGraph.get(0);
		this.ctxGraph = this.cnvGraph.getContext('2d');
		
		this.jqoCnvCurve = $('<canvas class="curve"></canvas>');
		this.jqoCnvCurve.appendTo(this.jqoTarget);
		this.cnvCurve = this.jqoCnvCurve.get(0);
		this.ctxCurve = this.cnvCurve.getContext('2d');
		
		this.jqoDotsLabel = $('<div class="dots-label"></div>');
		this.jqoDotsLabel.appendTo(this.jqoTarget);
		
		
		// --- apply options style
		
		this.jqoTarget.css({
			width: this.o.width,
			height: this.o.height
		});
		this.jqoTarget.addClass('no-select');
		this.jqoTarget.children().addClass('no-select');
		
		
		// --- resize handler
		
		$(window).on('resize', this.callbacks.resize);
		
		
		// --- launch
		this.plugin = (o.mode == 'linear') ? new G.ui.CCGLinearPlugin(this) : new G.ui.CCGDefaultPlugin(this);
		this.modelImport(this.o.dotsColl);
		this.updateSettings(o);
		this.resize();
	};
	proto = G.ui.CharacteristicCurveGraph.prototype;
	
	proto.destroy = function(){
		$(document)
			.off('mousemove', this.callbacks.dragMove)
			.off('mouseup', this.callbacks.dragStop);
		$(window)
			.off('resize', this.callbacks.resize);
		this.callbacks = null;
		this.jqoTarget.empty();
	};
	proto.resize = function(){
		this.vw.x = this.jqoTarget.width();
		this.vw.y = this.jqoTarget.height();
		
		this.cnvGraph.width = this.vw.x;
		this.cnvGraph.height = this.vw.y;
		
		this.cnvCurve.width = this.vw.x;
		this.cnvCurve.height = this.vw.y;
		
		this.renderGraph();
		this.plugin.renderCurve();
	};
	proto.validateDots = function(coll){
		
		this.dotsCounter = 0;
		this.jqoDots.empty();
		for(var i = 0, dot, ilen = coll.length; i < ilen; ++i){
			dot = coll[i];
			
			// consolidate model
			dot.uid = this.dotsCounter;
			dot.x = Math.max(Math.min(dot.x || this.o.xAxisMini, this.o.xAxisMaxi), this.o.xAxisMini);
			dot.x = this.roundTo(dot.x, this.o.xAxisRounding);
			dot.y = Math.max(Math.min(dot.y || this.o.yAxisMini, this.o.yAxisMaxi), this.o.yAxisMini);
			dot.y = this.roundTo(dot.y, this.o.yAxisRounding);
			dot.xLock = (dot.xLock !== undefined) ? dot.xLock  : this.o.dotsXLockDefault;
			dot.yLock = (dot.yLock !== undefined) ? dot.yLock  : this.o.dotsYLockDefault;
			dot.canRemove = (dot.canRemove !== undefined) ? dot.canRemove  : true;
			
			// create ui
			dot.ui = $('<div class="dot"></div>');
			dot.ui.attr('data-point-id', 'uid-' + dot.uid);
			dot.ui.addClass(dot.xLock ? (dot.yLock ? 'xy-lock' : 'x-lock') : (dot.yLock ? 'y-lock' : 'no-lock'));
			dot.ui.appendTo(this.jqoDots);
			
			this.dotsCounter++;
		}
		
		this.o.dotsColl = coll;
	};
	
	proto.modelImport = function(data){
		if(this.plugin instanceof G.ui.CCGDefaultPlugin){
			var coll;
			if(this.isArray(data))
				coll = data;
			else if(data.hasOwnProperty('coll'))
				coll = data.coll;
			else
				console.log('[CharacteristicCurveGraph.modelImport] configuration error');
			this.plugin.modelImport(coll);
		}
		else if(this.plugin instanceof G.ui.CCGLinearPlugin){
			this.plugin.modelImport(data);
		}
		
	};
	proto.modelUpdate = function(){
		return this.plugin.modelUpdate();
	};
	proto.modelExport = function(){
		this.jqoTarget.trigger('modelExported', this.modelUpdate());
	};
	proto.updateSettings = function(settings){
		// both modes
		if(settings.hasOwnProperty('deltaEco') && settings.hasOwnProperty('deltaIdle')){
			this.o.deltaEco = settings.deltaEco;
			this.o.deltaIdle = settings.deltaIdle;
		}
		
		if(this.plugin instanceof G.ui.CCGDefaultPlugin){
			this.plugin.updateSettings();
		}
		else if(this.plugin instanceof G.ui.CCGLinearPlugin){
			if(settings.hasOwnProperty('deltaEco') && settings.hasOwnProperty('deltaIdle')){
				this.plugin.updateSettings(settings.linearStep, settings.linearSlope, settings.linearMaxTemp);
			}
			else{
				console.warn('[CharacteristicCurveGraph.updateSettings] Method is not implemented on "linear" mode.');
			}
		}
	};
	proto.customAction = function(action){
		if(this.plugin instanceof G.ui.CCGDefaultPlugin){
			switch(action){
				case 'collEditPointAdd':
					this.plugin.collEditPointAdd();
					break;
				case 'collEditPointRemove':
					this.plugin.collEditPointRemove();
					break;
				default:
					console.warn('[CharacteristicCurveGraph.customAction] Method does not handle "' + action + '" for "default" mode.');
					break;
			}
		}
		else if(this.plugin instanceof G.ui.CCGLinearPlugin){
			switch(action){
				default:
					console.warn('[CharacteristicCurveGraph.customAction] Method does not handle "' + action + '" for "linear" mode.');
					break;
			}
		}
	};
	proto.renderGraph = function(){
		var i, maxi, pos, ctx;
		
		ctx = this.ctxGraph;
		
		// reset previous content
		ctx.clearRect(0, 0, this.vw.x, this.vw.y);
		this.jqoGraph.empty();
		
		
		// draw both axis
		ctx.beginPath();
		ctx.moveTo(this.o.margin.left, this.vw.y - this.o.margin.bottom);
		ctx.lineTo(this.vw.x - this.o.margin.right, this.vw.y - this.o.margin.bottom);
		ctx.moveTo(this.o.margin.left, this.vw.y - this.o.margin.bottom);
		ctx.lineTo(this.o.margin.left, this.o.margin.top);
		ctx.lineWidth = this.o.styleAxisThickness;
		ctx.strokeStyle = this.o.styleAxisColor;
		ctx.stroke();
		
		// draw x-axis divisions and linked values
		ctx.beginPath();
		maxi = this.floorTo(this.o.xAxisMaxi, this.o.xAxisRounding);
		for(i = this.ceilTo(this.o.xAxisMini, this.o.xAxisRounding); i <= maxi; i += this.o.xAxisDivision){
			pos = this.rel2pos(this.val2rel({ x: i, y: this.o.yAxisMini }));
			ctx.moveTo(pos.x, pos.y);
			ctx.lineTo(pos.x, pos.y + this.o.styleAxisDivisionLength);
			
			if(this.o.styleAxisDivisionShowValue){
				$('<div class="x-axis division no-select">' + i + '</div>')
					.css({ left: pos.x, top: pos.y + this.o.styleAxisDivisionOffset })
					.appendTo(this.jqoGraph);
			}
		}
		ctx.lineWidth = this.o.styleAxisThickness;
		ctx.strokeStyle = this.o.styleAxisColor;
		ctx.stroke();
		
		// draw y-axis divisions and linked values
		ctx.beginPath();
		maxi = this.floorTo(this.o.yAxisMaxi, this.o.yAxisRounding);
		for(i = this.ceilTo(this.o.yAxisMini, this.o.yAxisRounding); i <= maxi; i += this.o.yAxisDivision){
			pos = this.rel2pos(this.val2rel({ x: this.o.mode === 'linear' ? this.o.xAxisMaxi : this.o.xAxisMini, y: i }));
			ctx.moveTo(pos.x, pos.y);
			ctx.lineTo(pos.x - this.o.styleAxisDivisionLength, pos.y);
			
			if(this.o.styleAxisDivisionShowValue) {
				$('<div class="y-axis division no-select">' + i + '</div>')
					.css({left: pos.x - this.o.styleAxisDivisionOffset, top: pos.y})
					.appendTo(this.jqoGraph);
			}
		}
		ctx.lineWidth = this.o.styleAxisThickness;
		ctx.strokeStyle = this.o.styleAxisColor;
		ctx.stroke();


		if(!!this.o.xAxisLabel){
			$('<div class="x-axis caption no-select">' + this.o.xAxisLabel + '</div>')
				.appendTo(this.jqoGraph);
		}

		if(!!this.o.yAxisLabel){
			$('<div class="y-axis caption no-select">' + this.o.yAxisLabel + '</div>')
				.appendTo(this.jqoGraph);
		}
	};
	proto.renderLabel = function(dot){
		var lbl = '', val, pos;
		
		val = {
			x: dot.x,
			y: dot.y
		};
		rel = this.val2rel(val);
		pos = this.rel2pos(rel);
		
		// label display
		this.jqoDotsLabel
			.css({
				left: pos.x,
				top: pos.y
			})
			.toggleClass('align-right', (this.o.mode != 'linear') == (rel.x > .5))
			.toggleClass('align-bottom', rel.y < .5);
		 
		// xAxis value
		lbl += '<p>';
		if(this.isFilled(this.o.xAxisLabel))
			lbl += this.o.xAxisLabel + ' : ';
		lbl += val.x.toFixed(this.o.xAxisPrecision) + this.o.xAxisUnit;
		lbl += '</p>';
		
		// yAxis value
		lbl += '<p>';
		if(this.isFilled(this.o.yAxisLabel))
			lbl += this.o.yAxisLabel + ' : ';
		lbl += val.y.toFixed(this.o.yAxisPrecision) + this.o.yAxisUnit;
		lbl += '</p>';
		
		this.jqoDotsLabel.html(lbl);
	};
	
	proto.val2rel = function(val){
		var rel = {
			x: (val.x - this.o.xAxisMini) / (this.o.xAxisMaxi - this.o.xAxisMini),
			y: (val.y - this.o.yAxisMini) / (this.o.yAxisMaxi - this.o.yAxisMini)
		};
		rel = this.relConstrain(rel);
		return rel;
	};
	proto.rel2val = function(rel){
		return {
			x: this.o.xAxisMini + (rel.x * (this.o.xAxisMaxi - this.o.xAxisMini)),
			y: this.o.yAxisMini + (rel.y * (this.o.yAxisMaxi - this.o.yAxisMini))
		};
	};
	
	proto.rel2pos = function(rel){
		return {
			x: this.o.mode == 'linear' ?
				this.o.margin.left + ((1 - rel.x) * (this.jqoTarget.width() - this.o.margin.width)) :
				this.o.margin.left + (rel.x * (this.jqoTarget.width() - this.o.margin.width)),
			y: this.o.margin.top + ((1 - rel.y) * (this.jqoTarget.height() - this.o.margin.height))
		};
	};
	proto.pos2rel = function(pos){
		var rel = {
			x: this.o.mode == 'linear' ?
				1 - (pos.x - this.o.margin.left) / (this.jqoTarget.width() - this.o.margin.width) :
				(pos.x - this.o.margin.left) / (this.jqoTarget.width() - this.o.margin.width),
			y: 1 - (pos.y - this.o.margin.top) / (this.jqoTarget.height() - this.o.margin.height)
		};
		rel = this.relConstrain(rel);
		return rel;
	};
	
	proto.isFilled = function(v){
		return v && v.length > 0;
	};
	proto.isArray = function (arg) {
		if (Array.isArray)
			return Array.isArray(arg);
		return objectToString(arg) === '[object Array]';
	};
	proto.relConstrain = function(d){
		d.x = Math.min(1, Math.max(0, d.x));
		d.y = Math.min(1, Math.max(0, d.y));
		return d;
	};
	proto.keepNumeric = function (v) {
		return v.match(/\d/g).join("");
	};
	proto.roundTo = function(val, rounding){
		return Math.round(val / rounding) * rounding;
	};
	proto.ceilTo = function(val, rounding){
		return Math.ceil(val / rounding) * rounding;
	};
	proto.floorTo = function(val, rounding){
		return Math.floor(val / rounding) * rounding;
	};
}


//    ###########################################################################################
//       CCGDefaultPlugin
//    ###########################################################################################
if(!G.ui.CCGDefaultPlugin){
	
	G.ui.CCGDefaultPlugin = function (ccg) {
		this.ccg = ccg;
		this.o = this.ccg.o;
		
		// ---   options data consolidation : dots mini/maxi number
		ilen = this.o.dotsColl.length;
		if(isNaN(this.o.dotsNumMini) || this.o.dotsNumMini < 0)
			o.dotsNumMini = ilen;
		else if(isNaN(this.o.dotsNumMaxi) || this.o.dotsNumMaxi < 0)
			o.dotsNumMaxi = ilen;
		
		// ---   working variables
		this.dotCurrent = null;
		this.dotCurrentLock = null;
		
		// ---    callbacks
		this.callbacks = {
			dragStart: this.dragStart.bind(this),
			dragMove: this.dragMove.bind(this),
			dragStop: this.dragStop.bind(this),
			collEditPointAdded: this.collEditPointAdded.bind(this)
		};
	};
	proto = G.ui.CCGDefaultPlugin.prototype;
	
	proto.destroy = function(){
		this.setProcess('destroy');
		this.ccg = null;
		this.callbacks = null;
	};
	proto.updateSettings = function(){
		this.renderCurve();
	};
	proto.modelImport = function(coll){
		// check configuration
		var ilen = coll.length;
		if(ilen < this.o.dotsNumMini || ilen > this.o.dotsNumMaxi){
			console.error('\t - configuration error, passed-in dots collection length do no match specifications', {
				mini: this.o.dotsNumMini,
				maxi: this.o.dotsNumMaxi,
				num: ilen
			});
			return;
		}
		
		// dots configuration
		this.ccg.validateDots(coll);
		this.dotsSortedX();
		
		this.renderCurve();
		this.setProcess();
		this.modelUpdate();
	};
	proto.modelUpdate = function(){
		var settings = {
			mode: 'default',
			coll: [],
			dotsMini: this.o.dotsNumMini,
			dotsMaxi: this.o.dotsNumMaxi
		};
		
		// clean data for export
		for(var i = 0, ilen = this.o.dotsColl.length, dot; i < ilen; ++i){
			dot = this.o.dotsColl[i];
			settings.coll.push({
				x: dot.x,
				y: dot.y,
				xLock: dot.xLock,
				yLock: dot.yLock,
				canRemove: dot.canRemove
			});
		}
		this.ccg.jqoTarget.trigger('modelUpdated', settings);
		return settings;
	};
	proto.renderCurve = function(){
		var i, ilen, dot, ctx;
		
		ctx = this.ccg.ctxCurve;
		ctx.clearRect(0, 0, this.ccg.vw.x, this.ccg.vw.y);
		
		ilen = this.o.dotsColl.length;
		
		
		// ---   default curve
		ctx.beginPath();
		for(i = 0; i < ilen; ++i){
			dot = this.o.dotsColl[i];
			pos = this.ccg.rel2pos(this.ccg.val2rel(dot));
			dot.ui.css({
				left: pos.x,
				top: pos.y
			});
			i == 0 ? ctx.moveTo(pos.x, pos.y) : ctx.lineTo(pos.x, pos.y);
		}
		ctx.lineWidth = this.o.styleDefaultThickness;
		ctx.strokeStyle = this.o.styleDefaultColor;
		ctx.setLineDash((this.o.styleDefaultDashLength > 0 && this.o.styleDefaultDashGap > 0) ? [this.o.styleDefaultDashLength, this.o.styleDefaultDashGap]: []);
		ctx.stroke();
		
		// ---   eco curve
		ctx.beginPath();
		if(this.o.deltaEco > 0){
			for(i = 0; i < ilen; ++i){
				dot = this.o.dotsColl[i];
				pos = this.ccg.rel2pos(this.ccg.val2rel({
					x: dot.x,
					y: dot.y - this.o.deltaEco
				}));
				i == 0 ? ctx.moveTo(pos.x, pos.y) : ctx.lineTo(pos.x, pos.y);
			}
			ctx.lineWidth = this.o.styleEcoThickness;
			ctx.strokeStyle = this.o.styleEcoColor;
			ctx.setLineDash((this.o.styleEcoDashLength > 0 && this.o.styleEcoDashGap > 0) ? [this.o.styleEcoDashLength, this.o.styleEcoDashGap] : []);
			ctx.stroke();
		}
		
		// ---   idle curve
		if(this.o.deltaIdle > 0) {
			ctx.beginPath();
			for (i = 0; i < ilen; ++i) {
				dot = this.o.dotsColl[i];
				pos = this.ccg.rel2pos(this.ccg.val2rel({
					x: dot.x,
					y: dot.y - this.o.deltaIdle
				}));
				i == 0 ? ctx.moveTo(pos.x, pos.y) : ctx.lineTo(pos.x, pos.y);
			}
			ctx.lineWidth = this.o.styleIdleThickness;
			ctx.strokeStyle = this.o.styleIdleColor;
			ctx.setLineDash((this.o.styleIdleDashLength > 0 && this.o.styleIdleDashGap > 0) ? [this.o.styleIdleDashLength, this.o.styleIdleDashGap] : []);
			ctx.stroke();
		}
	};
	
	proto.collEditPointAdd = function(){
		console.log('[CharacteristicCurveGraph.collEditPointAdd]');
		
		this.setProcess('add');
	};
	proto.collEditPointAdded = function(e){
		var targetPos;
		
		console.log('[CharacteristicCurveGraph.collEditPointAdded]');
		
		targetPos = this.ccg.jqoTarget.offset();
		this.o.dotsColl.push(this.ccg.rel2val(this.ccg.pos2rel({
			x: e.pageX - targetPos.left,
			y: e.pageY - targetPos.top
		})));
		
		this.modelImport(this.o.dotsColl);
		this.setProcess(null);
	};
	proto.collEditPointRemove = function(){
		console.log('[CharacteristicCurveGraph.collEditPointRemove]');
		this.setProcess('remove');
	};
	proto.collEditPointRemoved = function(dot, index){
		console.log('[CharacteristicCurveGraph.collEditPointRemoved] dot: ' + dot.uid + ', index: ' + index);
		
		dot.ui.remove();
		this.o.dotsColl.splice(index, 1);
		
		this.setProcess(null);
		
		this.renderCurve();
		
		this.modelUpdate();
	};
	proto.dragStart = function(e, dot){
		var dotIndex, dotMaxIndex;
		
		this.dotCurrent = dot;
		this.dotCurrent.ui.addClass('current');
		
		// drag context
		switch(this.o.dragXLimitsMode){
			
			case 'reorder':
				this.dotCurrentLock = null;
				break;
			
			case 'block':
			default:
				dotIndex = this.o.dotsColl.indexOf(this.dotCurrent);
				dotMaxIndex = this.o.dotsColl.length - 1;
				this.dotCurrentLock = {
					mini: this.o.dotsColl[dotIndex > 0 ? dotIndex - 1 : 0].x,
					maxi: this.o.dotsColl[dotIndex < dotMaxIndex ? dotIndex + 1 : dotMaxIndex].x
				};
				break;
		}
		
		// display label
		this.ccg.jqoDotsLabel.css({
			left: this.dotCurrent.ui.css('left'),
			top: this.dotCurrent.ui.css('top')
		});
		
		this.dragMove(e);
		
		this.setProcess('drag');
	};
	proto.dragMove = function(e){
		var rel, pos, val, targetPos;
		
		targetPos = this.ccg.jqoTarget.offset();
		
		pos = {
			x: e.pageX - targetPos.left,
			y: e.pageY - targetPos.top
		};
		rel = this.ccg.pos2rel(pos);
		val = this.ccg.rel2val(rel);
		
		// constrain drag x value
		if(this.dotCurrentLock){
			if(val.x < this.dotCurrentLock.mini)
				val.x = this.dotCurrentLock.mini;
			else if(val.x > this.dotCurrentLock.maxi)
				val.x = this.dotCurrentLock.maxi;
		}
		
		// round value
		if(this.o.dragRoundVal){
			val.x = this.ccg.roundTo(val.x, this.o.xAxisRounding);
			val.y = this.ccg.roundTo(val.y, this.o.yAxisRounding);
		}
		
		// reorder dots
		if(!this.dotCurrentLock){
			this.dotsSortedX();
		}
		
		if(!this.dotCurrent.xLock)
			this.dotCurrent.x = val.x;
		if(!this.dotCurrent.yLock)
			this.dotCurrent.y = val.y;
		
		this.ccg.renderLabel(this.dotCurrent);
		
		this.renderCurve();
	};
	proto.dragStop = function(){
		var pos, css;
		
		this.dotCurrent.x = this.ccg.roundTo(this.dotCurrent.x, this.o.xAxisRounding);
		this.dotCurrent.y = this.ccg.roundTo(this.dotCurrent.y, this.o.yAxisRounding);
		pos = this.ccg.rel2pos(this.ccg.val2rel(this.dotCurrent));
		css = {
			left: pos.x,
			top: pos.y
		};
		
		// clear dot current
		this.dotCurrent.ui.removeClass('current');
		this.dotCurrent = null;
		
		// hide label
		this.ccg.jqoDotsLabel.css(css);
		this.ccg.jqoDotsLabel.toggle(false);

		this.modelUpdate();
		this.renderCurve();
		this.setProcess(null);
	};
	proto.dotsSortedX = function(){
		this.o.dotsColl = this.o.dotsColl.sort(function(v1, v2){
			if(v1.x < v2.x)
				return -1;
			else if(v1.x > v2.x)
				return 1;
			return 0;
		});
	};
	proto.setProcess = function(process){
		var self = this;
		
		this.o.dotsColl.forEach(function(dot){
			dot.ui
				.removeClass('removable')
				.off('mousedown')
				.off('mouseover')
				.off('mouseout')
				.off('click')
				.on('mouseover', function () {
					self.ccg.renderLabel(dot);
					self.ccg.jqoDotsLabel.toggle(true);
				})
				.on('mouseout', function() {
					if(!self.dotCurrent)
						self.ccg.jqoDotsLabel.toggle(false);
				});
		});
		
		this.ccg.jqoTarget.off('click', self.callbacks.collEditPointAdded);
		
		$(document)
			.off('mousemove', this.callbacks.dragMove)
			.off('mouseup', this.callbacks.dragStop);
		
		switch(process){
			case 'drag':
				$(document)
					.on('mousemove', this.callbacks.dragMove)
					.on('mouseup', this.callbacks.dragStop);
				break;
			
			case 'remove':
				this.o.dotsColl.forEach(function(dot, index){
					if(dot.canRemove){
						dot.ui
							.addClass('removable')
							.on('click', function(){
								self.collEditPointRemoved(dot, index);
							});
					}
				});
				break;
			
			case 'add':
				this.ccg.jqoTarget.on('click', self.callbacks.collEditPointAdded);
				break;
			
			case 'destroy':
				break;
			
			default:
				this.o.dotsColl.forEach(function(dot) {
					(function (dot) {
						if (!dot.xLock || !dot.yLock) {
							dot.ui
								.on('mousedown', function (e) {
									self.dragStart(e, dot);
								});
						}
					})(dot);
				});
				break;
		}
	};
	proto.updateAxisByUid = function(dotUid, axis, value) {
		var dotsCollIndexToSelect = this.o.dotsColl.findIndex((dotColl) => {
			return dotColl.uid == dotUid;
		});
		if(dotsCollIndexToSelect != -1) {
			this.o.dotsColl[dotsCollIndexToSelect][axis] = this.ccg.roundTo(value, axis == "x" ? this.o.xAxisRounding : this.o.yAxisRounding);
		}
		this.modelUpdate();
		this.renderCurve();
	};
}


//    ###########################################################################################
//       CCGLinearPlugin
//    ###########################################################################################
if(!G.ui.CCGLinearPlugin){
	
	G.ui.CCGLinearPlugin = function (ccg) {
		this.ccg = ccg;
		this.o = this.ccg.o;
		
		if(isNaN(this.o.linearStep < this.o.yAxisMini) || this.o.linearStep > this.o.yAxisMaxi){
			console.warn('[CCGLinearPlugin] linearStep value is out of bounds [' + this.o.yAxisMini + ';' + this.o.yAxisMaxi + ']');
			this.o.linearStep = Math.max(this.o.yAxisMini, Math.min(this.o.yAxisMaxi, this.o.linearStep));
		}
		
		this.o.dotsNumMaxi = 2;
		this.o.dotsNumMini = 2;
		this.o.dotsYLockDefault = true;
		
		// ---    callbacks
		this.callbacks = {
			dragStart: this.dragStart.bind(this),
			dragMove: this.dragMove.bind(this),
			dragStop: this.dragStop.bind(this)
		};
		
		this.modelImport();
	};
	proto = G.ui.CCGLinearPlugin.prototype;
	
	proto.destroy = function(){
		
	};
	
	proto.modelImport = function(settings){
		var coll;
		
		if(settings && !isNaN(settings.linearStep))
			this.o.linearStep = settings.linearStep;
		if(settings && !isNaN(settings.linearMaxTemp))
			this.o.linearMaxTemp = Math.max(this.o.yAxisMini, Math.min(this.o.yAxisMaxi, settings.linearMaxTemp));
		if(settings && !isNaN(settings.linearSlope))
			this.o.linearSlope = settings.linearSlope;
		
		coll = [
			{
				x: this.o.xAxisMaxi,
				y: this.o.linearStep,
				xLock: true,
				canRemove: false
			},
			{
				x: this.o.xAxisMaxi - ((this.o.linearMaxTemp - this.o.linearStep) / this.o.linearSlope),
				y: this.o.linearMaxTemp,
				canRemove: false
			}
		];
		
		console.log('[CharacteristicCurveGraph.modelImport] coll: ', coll, this.o);
		// dots configuration
		this.ccg.validateDots(coll);
		
		this.renderCurve();
		this.setProcess();
		this.modelUpdate();
	};
	proto.modelUpdate = function(){
		var settings = {
			mode: 'linear',
			linearStep: this.o.linearStep,
			linearSlope: this.o.linearSlope,
			linearMaxTemp: this.o.linearMaxTemp,
			dotsMini: this.o.dotsNumMini,
			dotsMaxi: this.o.dotsNumMaxi
		};
		
		this.ccg.jqoTarget.trigger('modelUpdated', settings);
		return settings;
	};
	proto.renderCurve = function(){
		var i, ilen, dot, ctx;
		
		ctx = this.ccg.ctxCurve;
		ctx.clearRect(0, 0, this.ccg.vw.x, this.ccg.vw.y);
		
		ilen = this.o.dotsColl.length;
		
		// ---   default curve
		ctx.beginPath();
		for(i = 0; i < ilen; ++i){
			dot = this.o.dotsColl[i];
			pos = this.ccg.rel2pos(this.ccg.val2rel(dot));
			dot.ui.css({
				left: pos.x,
				top: pos.y
			});
			i == 0 ? ctx.moveTo(pos.x, pos.y) : ctx.lineTo(pos.x, pos.y);
		}
		pos = this.ccg.rel2pos(this.ccg.val2rel({
			x: this.o.xAxisMini,
			y: dot.y
		}));
		ctx.lineTo(pos.x, pos.y);
		
		ctx.lineWidth = this.o.styleDefaultThickness;
		ctx.strokeStyle = this.o.styleDefaultColor;
		ctx.setLineDash((this.o.styleDefaultDashLength > 0 && this.o.styleDefaultDashGap > 0) ? [this.o.styleDefaultDashLength, this.o.styleDefaultDashGap]: []);
		ctx.stroke();
		
		// ---   eco curve
		ctx.beginPath();
		if(this.o.deltaEco > 0){
			for(i = 0; i < ilen; ++i){
				dot = this.o.dotsColl[i];
				pos = this.ccg.rel2pos(this.ccg.val2rel({
					x: dot.x,
					y: dot.y - this.o.deltaEco
				}));
				i == 0 ? ctx.lineTo(pos.x, pos.y) : ctx.lineTo(pos.x, pos.y);
			}
			pos = this.ccg.rel2pos(this.ccg.val2rel({
				x: this.o.xAxisMini,
				y: dot.y - this.o.deltaEco
			}));
			ctx.lineTo(pos.x, pos.y);
			
			ctx.lineWidth = this.o.styleEcoThickness;
			ctx.strokeStyle = this.o.styleEcoColor;
			ctx.setLineDash((this.o.styleEcoDashLength > 0 && this.o.styleEcoDashGap > 0) ? [this.o.styleEcoDashLength, this.o.styleEcoDashGap] : []);
			ctx.stroke();
		}
		
		// ---   idle curve
		if(this.o.deltaIdle > 0) {
			ctx.beginPath();
			for (i = 0; i < ilen; ++i) {
				dot = this.o.dotsColl[i];
				pos = this.ccg.rel2pos(this.ccg.val2rel({
					x: dot.x,
					y: dot.y - this.o.deltaIdle
				}));
				i == 0 ? ctx.moveTo(pos.x, pos.y) : ctx.lineTo(pos.x, pos.y);
			}
			pos = this.ccg.rel2pos(this.ccg.val2rel({
				x: this.o.xAxisMini,
				y: dot.y - this.o.deltaIdle
			}));
			ctx.lineTo(pos.x, pos.y);
			
			ctx.lineWidth = this.o.styleIdleThickness;
			ctx.strokeStyle = this.o.styleIdleColor;
			ctx.setLineDash((this.o.styleIdleDashLength > 0 && this.o.styleIdleDashGap > 0) ? [this.o.styleIdleDashLength, this.o.styleIdleDashGap] : []);
			ctx.stroke();
		}
	};
	proto.updateSettings = function(linearStep, linearSlope, linearMaxTemp){
		this.modelImport({
			linearStep: linearStep,
			linearSlope: linearSlope,
			linearMaxTemp: linearMaxTemp
		});
	};
	
	proto.dragStart = function(e, dot){
		var dotIndex, dotMaxIndex;
		
		this.dotCurrent = dot;
		this.dotCurrent.ui.addClass('current');
		
		// drag context
		switch(this.o.dragXLimitsMode){
			
			case 'reorder':
				this.dotCurrentLock = null;
				break;
			
			case 'block':
			default:
				dotIndex = this.o.dotsColl.indexOf(this.dotCurrent);
				dotMaxIndex = this.o.dotsColl.length - 1;
				this.dotCurrentLock = {
					mini: this.o.dotsColl[dotIndex > 0 ? dotIndex - 1 : 0].x,
					maxi: this.o.dotsColl[dotIndex < dotMaxIndex ? dotIndex + 1 : dotMaxIndex].x
				};
				break;
		}
		
		// display label
		this.ccg.jqoDotsLabel.css({
			left: this.dotCurrent.ui.css('left'),
			top: this.dotCurrent.ui.css('top')
		});
		
		this.dragMove(e);
		
		this.setProcess('drag');
	};
	proto.dragMove = function(e){
		var rel, pos, val, targetPos;
		
		targetPos = this.ccg.jqoTarget.offset();
		
		pos = {
			x: e.pageX - targetPos.left,
			y: e.pageY - targetPos.top
		};
		rel = this.ccg.pos2rel(pos);
		val = this.ccg.rel2val(rel);
		
		// constrain drag x value
		if(this.dotCurrentLock){
			if(val.x < this.dotCurrentLock.mini)
				val.x = this.dotCurrentLock.mini;
			else if(val.x > this.dotCurrentLock.maxi)
				val.x = this.dotCurrentLock.maxi;
		}
		
		// round value
		if(this.o.dragRoundVal){
			val.x = this.ccg.roundTo(val.x, this.o.xAxisRounding);
			val.y = this.ccg.roundTo(val.y, this.o.yAxisRounding);
		}
		
		if(!this.dotCurrent.xLock)
			this.dotCurrent.x = val.x;
		if(!this.dotCurrent.yLock)
			this.dotCurrent.y = val.y;
		
		this.ccg.renderLabel(this.dotCurrent);
		
		this.renderCurve();
	};
	proto.dragStop = function(){
		var pos, css;
		
		this.dotCurrent.x = this.ccg.roundTo(this.dotCurrent.x, this.o.xAxisRounding);
		this.dotCurrent.y = this.ccg.roundTo(this.dotCurrent.y, this.o.yAxisRounding);
		pos = this.ccg.rel2pos(this.ccg.val2rel(this.dotCurrent));
		css = {
			left: pos.x,
			top: pos.y
		};
		
		// clear dot current
		this.dotCurrent.ui.removeClass('current');
		this.dotCurrent = null;
		
		// hide label
		this.ccg.jqoDotsLabel.css(css);
		this.ccg.jqoDotsLabel.toggle(false);
		
		
		// update model
		this.o.linearStep = this.o.dotsColl[0].y;
		this.o.linearMaxTemp = this.o.dotsColl[1].y;
		this.o.linearSlope = (this.o.linearMaxTemp - this.o.linearStep) / (this.o.dotsColl[0].x - this.o.dotsColl[1].x);
		
		this.modelUpdate();
		this.renderCurve();
		this.setProcess(null);
	};
	proto.setProcess = function(process){
		var self = this;
		
		this.o.dotsColl.forEach(function(dot){
			dot.ui
				.off('mousedown')
				.off('mouseover')
				.off('mouseout')
				.on('mouseover', function () {
					self.ccg.renderLabel(dot);
					self.ccg.jqoDotsLabel.toggle(true);
				})
				.on('mouseout', function() {
					if(!self.dotCurrent)
						self.ccg.jqoDotsLabel.toggle(false);
				});
		});
		
		this.ccg.jqoTarget.off('click', self.callbacks.collEditPointAdded);
		
		$(document)
			.off('mousemove', this.callbacks.dragMove)
			.off('mouseup', this.callbacks.dragStop);
		
		switch(process){
			case 'drag':
				$(document)
					.on('mousemove', this.callbacks.dragMove)
					.on('mouseup', this.callbacks.dragStop);
				break;
			
			case 'remove':
				this.o.dotsColl.forEach(function(dot, index){
					if(dot.canRemove){
						dot.ui
							.addClass('removable')
							.on('click', function(){
								self.collEditPointRemoved(dot, index);
							});
					}
				});
				break;
			
			case 'add':
				this.ccg.jqoTarget.on('click', self.callbacks.collEditPointAdded);
				break;
			
			case 'destroy':
				break;
			
			default:
				this.o.dotsColl.forEach(function(dot) {
					(function (dot) {
						if (!dot.xLock || !dot.yLock) {
							dot.ui
								.on('mousedown', function (e) {
									self.dragStart(e, dot);
								});
						}
					})(dot);
				});
				break;
		}
	};

	proto.updateSlope = function(value) {
		this.o.linearSlope = parseFloat(value);
		this.o.dotsColl[1].x = this.o.dotsColl[0].x - (this.o.linearMaxTemp - this.o.linearStep) / this.o.linearSlope;
		this.modelUpdate();
		this.renderCurve();
	};
}

var IO_POINTS = {};


IO_POINTS._verbose = true;
/**
 *
 * @type {{equipementUID: string, pointLabel: string, pointUID: string, checkping: string, mnemonique: string, ipAddress: string, indicateurUID: string}}
 * @private
 */
IO_POINTS._attr = {
	pointUID: 'data-point-id',
	pointLabel: 'data-point-label',
	equipementMarque: 'data-equipement-marque',
	equipementFrontal: 'data-equipement-frontal',
	equipementUID: 'data-equipement-id',
	equipementHost: 'data-equipement-host',
	checkping: 'data-equipement-checkping',
	mnemonique: 'data-equipement-mnemonique',
	ipAddress: 'data-equipement-ip',
	indicateurUID: 'data-indicateur-id',
	voie: 'data-voie',
};

/**
 * Retrieves indicator settings from user event source.
 * @param from
 * @returns {{equipementUID: (*|jQuery), pointLabel: (*|jQuery), pointUID: (*|jQuery), checkping: (*|jQuery), mnemonique: (*|jQuery), ipAddress: (*|jQuery), equipementMarque: (*|jQuery), indicateurUID: (*|jQuery)}}
 */
IO_POINTS.getSettings = function (from) {

	var
		s, pointDataHolder,
		ind = from.is('.indicator') || from[0].hasAttribute(IO_POINTS._attr.checkping) ? from : from.closest('.indicator'),
		attr = function (p, from) {
			return (exists(from) ? from : ind).attr(IO_POINTS._attr[p]);
		}
		;

	s = {
		indicateurUID: attr('indicateurUID')
	};

	pointDataHolder = from.closest('.ind-data-brick');

	if (pointDataHolder.exists()) {
		s.checkping = attr('checkping', pointDataHolder);
		s.equipementUID = attr('equipementUID', pointDataHolder);
		s.equipementMarque = attr('equipementMarque', pointDataHolder);
		s.equipementFrontal = attr('equipementFrontal', pointDataHolder);
		s.equipementHost = attr('equipementHost', pointDataHolder);
		s.pointLabel = attr('pointLabel', pointDataHolder);
		s.pointUID = attr('pointUID', pointDataHolder);
		s.ipAddress = attr('ipAddress', pointDataHolder);
		s.mnemonique = attr('mnemonique', pointDataHolder);
		s.voie = attr('voie', pointDataHolder);
	}
	else {
		s.checkping = attr('checkping');
		s.equipementUID = attr('equipementUID');
		s.equipementMarque = attr('equipementMarque');
		s.equipementFrontal = attr('equipementFrontal');
		s.equipementHost = attr('equipementHost');
		s.pointLabel = attr('pointLabel');
		s.pointUID = attr('pointUID');
		s.ipAddress = attr('ipAddress');
		s.mnemonique = attr('mnemonique');
		s.voie = attr('voie');
	}

	// consolidate data
	if (isstring(s.equipementMarque))
		s.equipementMarque = s.equipementMarque.toLowerCase();
	if (isstring(s.pointLabel))
		s.pointLabel = s.pointLabel.toLowerCase();


	return s;
};

IO_POINTS.readPoint = function (s) {

	if (IO_POINTS._verbose)
		console.log(
			'[IO_POINTS.readPoint]',
			'\n\t - settings:', s
		);

	if (['devio5','devio05','devio6','devio5','devio6','devio06','devio7','devio07'].indexOf(s.equipementHost) >= 0)
		IO_POINTS.readPoint_Devio(s);
	else if (s.equipementMarque == 'globalio' || s.equipementMarque == 'siemens')
		IO_POINTS.readPoint_Globalio_Siemens(s);
	else if (s.equipementMarque == 'kessel') {
		console.log('IO_POINTS.getHistory_Kessel', s);
		IO_POINTS.getHistory_Kessel(s);
	}
	else
		showError('[IO_POINTS.readPoint] Unknown hardware: "' + s.equipementMarque + '"');
};

IO_POINTS.indStatus = function (indicatorId, s) {
	if (IO_POINTS._verbose)
		console.log(
			'[IO_POINTS.indStatus]',
			'\n\t - settings:', indicatorId, s
		);
	$('#indicator-' + indicatorId).toggleClass('indicator--reloading', s);
};
IO_POINTS.indResetModified = function (s) {
	var ind = $('#indicator-' + indicatorId);

	ind.remove('indicator--modified');
};

IO_POINTS.readPoint_Devio = function (s) {
	IO_POINTS.indStatus(s.indicateurUID, true);

	if (IO_POINTS._verbose)
		console.log('[IO_POINTS.readPoint_Devio]');

	var port = '24442';
	switch(s.equipementHost){
		case 'devio7':
		case 'devio07':
			var port = '24443';
			break;
		case 'devio5':
		case 'devio05':
			var port = '24444';
			break;
		case 'devio6':
		case 'devio06':
			var port = '24442';
			break;		
		default:
			if (s.equipementMarque == 'sauter' || s.equipementMarque == 'saia' || s.equipementMarque == 'bacnet') {
				var port = '24444';
			} else if (s.equipementMarque == 'schneider') {
				var port = '24443';	
			}
	}	

	var socket = io.connect('https://v2.global-visio.com:' + port, {
		'connect timeout': 5000,
		'reconnect': true,
		'reconnection delay': 2000,
		'max reconnection attempts': 3,
		'force new connection': true
	});
	showInfo(G.config.LOCALE_RETRIEVE('general.connectionInProgress'));

	socket.on('connect_failed', function () {
		showError(G.config.LOCALE_RETRIEVE('general.serviceUnavailable'));
		socket.disconnect();
		IO_POINTS.indStatus(s.indicateurUID, false);
	});

	socket.on('connect_error', function () {
		showError(G.config.LOCALE_RETRIEVE('general.serviceUnavailable'));
		socket.disconnect();
		IO_POINTS.indStatus(s.indicateurUID, false);
	});

	socket.on('error', function () {
		showError(G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
		socket.disconnect();
		IO_POINTS.indStatus(s.indicateurUID, false);
	});

	socket.on('responseDevio2', function (data) {
		$.ajax({
			url: G.config.SERVER + 'backend/devio/response',
			type: "POST",
			dataType: "json",
			data: {
				response: data.msg,
				method: "read"
			},
			error: IO_POINTS.ajaxError,
			success: function (data) {
				var method = 'read';

				if (typeof (data.readinprogress) != 'undefined' && data.readinprogress != '1') {
					showInfo(data.readinprogress);
				}

				if (typeof (data.info) != 'undefined') {
					showInfo(data.info);
				}
				if (typeof (data.readok) != 'undefined') {
					// showInfo(data.readok);
					IO_POINTS.refreshValue(s, data.value, data.date);
				}
				if (typeof (data.checkresult) != 'undefined') {
					self.synopsisCheckResult();
					return true;
				}
				if (typeof (data.sleep) != 'undefined') {
					showInfo(G.config.LOCALE_RETRIEVE('general.waitingForConnection'));
					socket.emit('dvio', data.command);
					return true;
				}
				if (typeof (data.error) != "undefined") {
					console.log('point-io error', data.error);
					showError(data.error);
					notificationsClearAll(5000);
					socket.removeAllListeners('responseDevio2');
					socket.removeAllListeners('connect');
					socket = undefined;
					return false;
				}
				if (typeof (data.end) != "undefined") {
					showInfo(G.config.LOCALE_RETRIEVE('general.disconnected'));
					notificationsClearAll(5000);
					IO_POINTS.indStatus(s.indicateurUID, false);

					socket.removeAllListeners('responseDevio2');
					socket.removeAllListeners('connect');
					socket = undefined;
					return false;
				}
				if (method === 'dcnx') {
					socket.removeAllListeners('responseDevio2');
					socket.removeAllListeners('connect');
					socket = undefined;
					return false;
				}
				if (data.result == '') {
					showInfo(G.config.LOCALE_RETRIEVE('general.disconnected'));
					notificationsClearAll(5000);
					socket.removeAllListeners('responseDevio2');
					socket.removeAllListeners('connect');
					socket = undefined;
					//delete socket;
					IO_POINTS.indStatus(s.indicateurUID, false);
					return false;
				}
				socket.emit('dvio', data.result);
			}
		});
	});

	socket.on('responseDevio3', function (data) {
		$.ajax({
			url: G.config.SERVER + 'backend/devio/response',
			type: "POST",
			dataType: "json",
			data: {
				response: data.msg,
				method: "read"
			},
			error: IO_POINTS.ajaxError,
			success: function (data) {
				var method = 'read';

				if (typeof (data.readinprogress) != 'undefined' && data.readinprogress != '1') {
					showInfo(data.readinprogress);
				}

				if (typeof (data.info) != 'undefined') {
					showInfo(data.info);
				}
				if (typeof (data.readok) != 'undefined') {
					// showInfo(data.readok);
					IO_POINTS.refreshValue(s, data.value, data.date);
				}
				if (typeof (data.checkresult) != 'undefined') {
					self.synopsisCheckResult();
					return true;
				}
				if (typeof (data.sleep) != 'undefined') {
					showInfo(G.config.LOCALE_RETRIEVE('general.waitingForConnection'));
					socket.emit('dvio', data.command);
					return true;
				}
				if (typeof (data.error) != "undefined") {
					console.log('point-io error', data.error);
					showError(data.error);
					notificationsClearAll(5000);
					socket.removeAllListeners('responseDevio3');
					socket.removeAllListeners('connect');
					socket = undefined;
					return false;
				}
				if (typeof (data.end) != "undefined") {
					showInfo(G.config.LOCALE_RETRIEVE('general.disconnected'));
					notificationsClearAll(5000);
					IO_POINTS.indStatus(s.indicateurUID, false);

					socket.removeAllListeners('responseDevio3');
					socket.removeAllListeners('connect');
					socket = undefined;
					return false;
				}
				if (method === 'dcnx') {
					socket.removeAllListeners('responseDevio3');
					socket.removeAllListeners('connect');
					socket = undefined;
					return false;
				}
				if (data.result == '') {
					showInfo(G.config.LOCALE_RETRIEVE('general.disconnected'));
					notificationsClearAll(5000);
					socket.removeAllListeners('responseDevio3');
					socket.removeAllListeners('connect');
					socket = undefined;
					//delete socket;
					IO_POINTS.indStatus(s.indicateurUID, false);
					return false;
				}
				socket.emit('dvio', data.result);
			}
		});
	});

	socket.on('responseDevio', function (data) {
		$.ajax({
			url: G.config.SERVER + 'backend/devio/response',
			type: "POST",
			dataType: "json",
			data: {
				response: data.msg,
				method: "read"
			},
			error: IO_POINTS.ajaxError,
			success: function (data) {
				var method = 'read';

				if (typeof (data.readinprogress) != 'undefined' && data.readinprogress != '1') {
					showInfo(data.readinprogress);
				}

				if (typeof (data.info) != 'undefined') {
					showInfo(data.info);
				}
				if (typeof (data.readok) != 'undefined') {
					// showInfo(data.readok);
					IO_POINTS.refreshValue(s, data.value, data.date);
				}
				if (typeof (data.checkresult) != 'undefined') {
					self.synopsisCheckResult();
					return true;
				}
				if (typeof (data.sleep) != 'undefined') {
					showInfo(G.config.LOCALE_RETRIEVE('general.waitingForConnection'));
					socket.emit('dvio', data.command);
					return true;
				}
				if (typeof (data.error) != "undefined") {
					console.log('point-io error', data.error);
					showError(data.error);
					notificationsClearAll(5000);
					socket.removeAllListeners('responseDevio');
					socket.removeAllListeners('connect');
					socket = undefined;
					return false;
				}
				if (typeof (data.end) != "undefined") {
					showInfo(G.config.LOCALE_RETRIEVE('general.disconnected'));
					notificationsClearAll(5000);
					IO_POINTS.indStatus(s.indicateurUID, false);

					socket.removeAllListeners('responseDevio');
					socket.removeAllListeners('connect');

					socket = undefined;
					return false;
				}
				if (method === 'dcnx') {
					socket.removeAllListeners('responseDevio');
					socket.removeAllListeners('connect');
					socket = undefined;
					return false;
				}
				if (data.result == '') {
					showInfo(G.config.LOCALE_RETRIEVE('general.disconnected'));
					notificationsClearAll(5000);

					socket.removeAllListeners('responseDevio');
					socket.removeAllListeners('connect');
					socket = undefined;

					IO_POINTS.indStatus(s.indicateurUID, false);
					return false;
				}
				socket.emit('dvio', data.result);
			}
		});
	});

	socket.on('connect', function () {
		showInfo(G.config.LOCALE_RETRIEVE('general.connected'));
		console.log('[IO_POINTS.readPoint_Devio] connect --> backend/devio/request');
		$.ajax({
			url: G.config.SERVER + 'backend/devio/request',
			type: "POST",
			dataType: "json",
			data: {
				method: "cnx",
				finalMethod: "read",
				point: s.pointLabel,
				automateId: s.equipementUID,
				automate: s.mnemonique
			},
			error: IO_POINTS.ajaxError,
			success: function (data) {
				socket.emit('dvio', data.result);
			}
		});
	});
	socket.on('disconnect', function () {
		showInfo(G.config.LOCALE_RETRIEVE('general.disconnection'));
		IO_POINTS.indStatus(s.indicateurUID, false);
	});
};

IO_POINTS.refreshValue = function (s, value, date) {
	var
		ind = $('#indicator-' + s.indicateurUID),
		tgt = ind.find('.txt-value'),
		unit = tgt.find('small')
		;

	tgt.text(unit.exists() ? value + unit.html() : value);

	if (date) {
		ind.find('.ind__date-ts').text(date);
	}
};

IO_POINTS.getHistory_Kessel = function (s) {

	IO_POINTS.indStatus(s.indicateurUID, true);

	if (IO_POINTS._verbose)
		console.log('[IO_POINTS.getHistory_Kessel]'
			+ '\n\t - settings: ', s
		);

	$.ajax({
		url: G.config.SERVER + 'frontend/ajax/gethistory',
		type: 'GET',
		data: {
			key: 'AZE',
			limit: 10,
			offset: $('#raw-list-' + s.indicateurUID).attr('offset'),
			pointId: s.pointUID
		},
		datatype: 'json',
		beforeSend: function () {
		},
		error: function (xhr, textStatus, errorThrown) {
			G.ui.fatalError("ajax error: " + textStatus, {
				url: this.url,
				error: errorThrown
			});
		},
		success: function (data) {
			console.log(data, data.data.length);
			var str = '';
			for (var i = 0; i < data.data.length; ++i) {
				str += '<tr>';
				str += '<td>' + data.data[i].date + '</td>';
				str += '<td>' + data.data[i].value + '</td>';
				str += '</tr>';
			}
			$('#raw-list-' + s.indicateurUID + '  > tbody:last-child').append(str);
			$('#raw-list-' + s.indicateurUID).attr('offset', data.offset);
			IO_POINTS.indStatus(s.indicateurUID, false);
		}
	});
};


IO_POINTS.readPoint_Globalio_Siemens = function (s) {

	// IO_POINTS.indStatus(s.indicateurUID, true);

	if (IO_POINTS._verbose)
		console.log('[IO_POINTS.readPoint_Globalio_Siemens]'
			+ '\n\t - settings: ', s
		);

	var socketgio;

	socketgio = io.connect('https://' + s.equipementFrontal + ':22443', {
		transports: ['websocket'],
		secure: true
	});
	showInfo(G.config.LOCALE_RETRIEVE('general.connectionInProgress'));

	socketgio
		.on('connect_failed', function () {
			showError(G.config.LOCALE_RETRIEVE('general.serviceUnavailable'));
			socketgio.disconnect();
			IO_POINTS.indStatus(s.indicateurUID, false);
		})
		.on('connect_error', function () {
			showError(G.config.LOCALE_RETRIEVE('general.serviceUnavailable'));
			socketgio.disconnect();
			IO_POINTS.indStatus(s.indicateurUID, false);
		})
		.on('disconnect', function () {
			showInfo(G.config.LOCALE_RETRIEVE('general.disconnection'));
		})
		.on('error', function () {
			showError(G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
			socketgio.disconnect();
			IO_POINTS.indStatus(s.indicateurUID, false);
		});

	if (s.equipementMarque == 'globalio') {
		var prefix = s.pointLabel.substr(0, 2);
		if (prefix === 're') {
			socketgio
				.on('return', function (data) {
					$.ajax({
						url: G.config.SERVER + 'frontend/ajax/globalioresponserelay',
						type: 'POST',
						dataType: 'json',
						data: {
							equipementId: s.equipementUID,
							pointId: s.pointUID,
							labelAutomate: s.pointLabel,
							response: data
						},
						success: function (response) {
							if (response.status === "error") {
								showError(response.error);
								socketgio.disconnect();
								showInfo(G.config.LOCALE_RETRIEVE('general.disconnected'));
								IO_POINTS.indStatus(s.indicateurUID, false);
							}
							if (response.status === "success") {
								IO_POINTS.refreshValue(s, response.value, moment().format('D/M/Y H:m'));
								MONITORING.indicatorsUpdateValue_action(s.indicateurUID, s.pointUID, response.value);
								showInfo(response.info);
							}
							/*if (response.response !== "") {
							}*/
							if (response.cmd === "dcnx") {
								showInfo(G.config.LOCALE_RETRIEVE('general.disconnection'));
								socketgio.disconnect();
								IO_POINTS.indStatus(s.indicateurUID, false);
							}
						}
					});
				})
				.emit('read', JSON.stringify({
					ip: s.ipAddress,
					serial: s.equipementUID,
					cmd: 'stRelay'
				}));
		}
		else if (prefix === 'ai') {
			// @todo tout doux ng
			socketgio
				.on('return', function (data) {
					$.ajax({
						// url: G.config.SERVER + 'frontend/ajax/globalioresponse',
						url: G.config.SERVER + 'apigv/globalio/response',
						headers: {
							"Content-Type": "application/json",
							"Authorization": "Bearer "+G.model.userApiKey
						},
						type: 'POST',
						dataType: 'json',
						data: JSON.stringify({
							equipementId: s.equipementUID,
							pointId: s.pointUID,
							labelAutomate: s.pointLabel,
							response: JSON.parse(data),
							command: 'readpoint'
						}),
						success: function (response) {
							if (response.status === "error") {
								showError(response.message);
								socketgio.disconnect();
								showInfo(G.config.LOCALE_RETRIEVE('general.disconnected'));
								IO_POINTS.indStatus(s.indicateurUID, false);
							} else if (response.status === "success") {
								showInfo(response.response.info);
							}
							if (response.response.value !== "") {
								IO_POINTS.refreshValue(s, response.response.value, moment().format('D/M/Y H:m'))
							}
							if (response.response.cmd === "dcnx") {
								showInfo(G.config.LOCALE_RETRIEVE('general.disconnection'));
								socketgio.disconnect();
								IO_POINTS.indStatus(s.indicateurUID, false);
								MONITORING.indicatorsUpdateValue_action(s.indicateurUID, s.pointUID, response.response.value);
							}
						}
					});
				})
				.emit('read', JSON.stringify({
					ip: s.ipAddress,
					serial: s.equipementUID,
					cmd: 'stRecord'
				}));
		}
		else {
			socketgio.on('return', function (data) {
				$.ajax({
					url: G.config.SERVER + 'apigv/globalio/response',
					headers: {
						"Content-Type": "application/json",
						"Authorization": "Bearer "+G.model.userApiKey
					},
					type: 'POST',
					dataType: 'json',
					data: JSON.stringify({
						equipementId: s.equipementUID,
						pointId: s.pointUID,
						response: data
					}),
					success: function (response) {
						if (response.status == "error") {
							showError(response.error);
							socketgio.disconnect();
							showInfo(G.config.LOCALE_RETRIEVE('general.disconnected'));
							IO_POINTS.indStatus(s.indicateurUID, false);
						}
						if (response.status == "success") {
							showInfo(response.response.info);
						}
						if (typeof(response.response.value) != "undefined") {
							var tmpValue = response.response.value;
							if (typeof(response.response.modbus_read_trame_unit) != "undefined") {
								tmpValue += response.response.modbus_read_trame_unit;
							}

							IO_POINTS.refreshValue(s, tmpValue, moment().format('D/M/Y H:m'))
						}
						if (response.response.cmd == "dcnx") {
							showInfo(G.config.LOCALE_RETRIEVE('general.disconnection'));
							socketgio.disconnect();
							IO_POINTS.indStatus(s.indicateurUID, false);
						}
					}
				});
			});
			$.ajax({
				url: G.config.SERVER + 'apigv/globalio/modbusFrameRead/'+s.pointUID,
				headers: {
					"Content-Type": "application/json",
					"Authorization": "Bearer "+G.model.userApiKey
				},
				type: 'GET',
				dataType: 'json',
				success: function (response) {
					var voieModbus = 'modbus';
					if (typeof (response.response.voie) != 'undefined' && response.response.voie == 2) {
						var voieModbus = 'modbus2';
					}
					socketgio.emit(voieModbus, JSON.stringify({
						ip: response.response.ip,
						cmd: response.response.frame
					}));
				}
			});
		}

	} else {
		socketgio
			.on('return_ozw', function (data) {
				$.ajax({
					url: G.config.SERVER + 'frontend/ajax/siemensresponse',
					type: 'POST',
					dataType: 'json',
					data: {
						equipementId: s.equipementUID,
						pointId: s.pointUID,
						labelAutomate: s.pointLabel,
						response: data
					},
					success: function (response) {
						if (response.status === "error") {
							showError(response.error);
							socketgio.disconnect();
							// showInfo(G.config.LOCALE_RETRIEVE('general.disconnected'));
							IO_POINTS.indStatus(s.indicateurUID, false);
						}
						if (response.status === "success") {
							showInfo(response.info);
						}
						if (response.response !== "") {
							IO_POINTS.refreshValue(s, response.response, moment().format('D/M/Y H:m'));
							MONITORING.indicatorsUpdateValue_action(s.indicateurUID, s.pointUID, response.response);
						}
						if (response.cmd === "dcnx") {
							socketgio.disconnect();
							IO_POINTS.indStatus(s.indicateurUID, false);
						}
					}
				});
			})
			.on('connect', function () {
				socketgio.emit('ozw', JSON.stringify({
					ip: s.ipAddress,
					// cmd: 'getlivepoints'
					cmd: 'readpoint#' + s.pointLabel
				}));
			});
	}

};

IO_POINTS.writePoint_Globalio = function (s, frame, actionSettings) {
	var socketmodbus;

	IO_POINTS.indStatus(s.indicateurUID, true);

	if (IO_POINTS._verbose)
		console.log('[IO_POINTS.writePoint_Globalio]__',
			'\n\t - s: ' + s,
			'\n\t - actionSettings: ' + actionSettings,
			'\n\t - frame: ' + frame,
			actionSettings
		);

	socketmodbus = io.connect('https://' + s.equipementFrontal + ':22443', {
		transports: ['websocket'],
		secure: true
	});
	socketmodbus
		.on('connect', function () {
			showInfo(G.config.LOCALE_RETRIEVE('general.openedConnection'));
		})
		.on('connect_error', function () {
			showInfo(G.config.LOCALE_RETRIEVE('general.impossibleConnection'));
		})
		// traitement des résultats
		.on('return', function (data) {
			$.ajax({
				url: G.config.SERVER + 'apigv/globalio/response',
				headers: {
					"Content-Type": "application/json",
					"Authorization": "Bearer "+G.model.userApiKey
				},
				type: 'POST',
				dataType: 'json',
				data: JSON.stringify({
					response: data,
					labelAutomate: s.pointLabel,
					equipementId: s.equipementUID
				}),
				success: function (response) {
					if (response.status === "error")
						showError(response.error);
						IO_POINTS.indStatus(s.indicateurUID, false);
					if (response.response.status === "writeok") {
						showSuccess(response.response.info);
						IO_POINTS.refreshValue(s, actionSettings.inpValue, data.date);
						MONITORING.actionInputUpdate(s, actionSettings.inpValue);
					} else if (response.status === "success"){
						showInfo(response.response.info);
						IO_POINTS.indStatus(s.indicateurUID, false);
					}
				}
			});
		});
	var voieModbus = 'modbus';
	if (exists(s.voie) && s.voie == 2) {
		var voieModbus = 'modbus2';
	}
	socketmodbus.emit(voieModbus, JSON.stringify({
		ip: s.ipAddress,
		cmd: frame
	}));
	showInfo(G.config.LOCALE_RETRIEVE('general.commandsSent'));
};

/* DEVIO (Trend, Sauter, etc.) */
IO_POINTS.writePoint = function (s, value, additionalSettings) {
	IO_POINTS.indStatus(s.indicateurUID, true);

	var port = '24442';
	switch(s.equipementHost){
		case 'devio6':
		case 'devio06':
			var port = '24442';
			break;
		case 'devio7':
		case 'devio07':
			var port = '24443';
			break;
		case 'devio5':
		case 'devio05':
			var port = '24444';
			break;
		default:
			if (s.equipementMarque == 'sauter' || s.equipementMarque == 'saia' || s.equipementMarque == 'bacnet') {
				var port = '24444';
			} else if (s.equipementMarque == 'schneider') {
				var port = '24443';	
			}
	}

	value = (value === false) ? 0 : value;
	value = (value === true) ? 1 : value;

	if (IO_POINTS._verbose)
		console.log('[IO_POINTS.writePoint]', s, value);

	var socket = io.connect('https://v2.global-visio.com:' + port, {
		'connect timeout': 5000,
		'reconnect': true,
		'reconnection delay': 2000,
		'max reconnection attempts': 3,
		'force new connection': true
	});

	var data = Object.assign({
		value: value,
		point: s.pointLabel,
		pointId: s.pointUID,
		automateId: s.equipementUID,
		automate: s.mnemonique
	}, additionalSettings || {});

	showInfo(G.config.LOCALE_RETRIEVE('general.connectionInProgress'));

	socket
		.on('connect_failed', function () {
			showError(G.config.LOCALE_RETRIEVE('general.serviceUnavailable'));
			socket.disconnect();
			IO_POINTS.indStatus(s.indicateurUID, false);
		})
		.on('connect_error', function () {
			showError(G.config.LOCALE_RETRIEVE('general.serviceUnavailable'));
			socket.disconnect();
			IO_POINTS.indStatus(s.indicateurUID, false);
		})
		.on('error', function () {
			showError(G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
			socket.disconnect();
			IO_POINTS.indStatus(s.indicateurUID, false);
		})
		.on('connect', function () {
			showInfo(G.config.LOCALE_RETRIEVE('general.connected'));

			//Check if value is correct
			$.ajax({
				url: G.config.SERVER + 'apigv/points/checkwrite/'+s.pointUID,
				type: "POST",
				headers: {
					"Content-Type": "application/json",
					"Authorization": "Bearer "+G.model.userApiKey
				},
				dataType: "json",
				data: JSON.stringify(data),
				error: IO_POINTS.ajaxError,
				success: function (data) {
					if (data.status === "success") {
						$.ajax({
							url: G.config.SERVER + 'backend/devio/request',
							type: "POST",
							dataType: "json",
							data: {
								method: "cnx",
								finalMethod: "writepoint",
								context: "dashboard",
								value: value,
								point: s.pointLabel,
								pointId: s.pointUID,
								automateId: s.equipementUID,
								automate: s.mnemonique
							},
							error: IO_POINTS.ajaxError,
							success: function (data) {
								socket.emit('dvio', data.result);
							}
						});
					} else
						showError(G.config.LOCALE_RETRIEVE('general.invalidValue'));
				}
			});
		})
		.on('responseDevio', function (data) {
			$.ajax({
				url: G.config.SERVER + 'backend/devio/response',
				type: "POST",
				dataType: "json",
				data: {
					response: data.msg,
					method: "writepoint"
				},
				error: IO_POINTS.ajaxError,
				/**
				 *
				 * @param data {{ readinprogress, writeok, readok, checkresult, end, sleep, command, error, result }}
				 * @returns {boolean}
				 */
				success: function (data) {
					var method = 'writepoint';

					if (exists(data.readinprogress) && data.readinprogress != '1') {
						showInfo(data.readinprogress);
					}
					if (exists(data.info)) {
						showInfo(data.info);
					}
					if (exists(data.writeok_thenread)) {
						socket.emit('dvio', data.command);
					}
					if (exists(data.writeok)) {
						// showInfo(data.writeok);
						IO_POINTS.refreshValue(s, data.value, data.date);
						MONITORING.actionInputUpdate(s, data.value);
					}
					if (exists(data.readok)) {
						showInfo(data.readok);
						IO_POINTS.refreshValue(s, data.value, data.date);
						MONITORING.actionInputUpdate(s, data.value);
					}
					if (exists(data.checkresult)) {
						self.synopsisCheckResult();
						return true;
					}
					if (exists(data.sleep)) {
						showInfo(G.config.LOCALE_RETRIEVE('general.waitingForConnection'));
						socket.emit('dvio', data.command);
						return true;
					}
					if (exists(data.error)) {
						showError(data.error);
						notificationsClearAll(5000);
						socket.removeAllListeners('responseDevio');
						socket.removeAllListeners('connect');
						socket = null;
						return false;
					}
					if (exists(data.end)) {
						showInfo(G.config.LOCALE_RETRIEVE('general.disconnected'));
						notificationsClearAll(5000);
						socket.removeAllListeners('responseDevio');
						socket.removeAllListeners('connect');

						IO_POINTS.indStatus(s.indicateurUID, false);

						socket = null;
						return false;
					}
					if (method === 'dcnx') {
						socket.removeAllListeners('responseDevio');
						socket.removeAllListeners('connect');
						socket = null;
						return false;
					}
					if (data.result == '') {
						showInfo(G.config.LOCALE_RETRIEVE('general.disconnected'), { clearAll: 5000 });
						socket.removeAllListeners('responseDevio');
						socket.removeAllListeners('connect');
						socket = null;
						IO_POINTS.indStatus(s.indicateurUID, false);
						return false;
					}
					socket.emit('dvio', data.result);
				}
			});
		})
		.on('responseDevio2', function (data) {
			$.ajax({
				url: G.config.SERVER + 'backend/devio/response',
				type: "POST",
				dataType: "json",
				data: {
					response: data.msg,
					method: "writepoint"
				},
				error: IO_POINTS.ajaxError,
				// @param data {{ readinprogress, writeok, readok, checkresult, end, sleep, command, error, result }}
				// @returns {boolean}
				success: function (data) {
					var method = 'writepoint';

					if (exists(data.readinprogress) && data.readinprogress != '1') {
						showInfo(data.readinprogress);
					}
					if (exists(data.info)) {
						showInfo(data.info);
					}
					if (exists(data.writeok_thenread)) {
						socket.emit('dvio', data.command);
					}
					if (exists(data.writeok)) {
						// showInfo(data.writeok);
						IO_POINTS.refreshValue(s, data.value, data.date);
						MONITORING.actionInputUpdate(s, data.value);
					}
					if (exists(data.readok)) {
						showInfo(data.readok);
						IO_POINTS.refreshValue(s, data.value, data.date);
						MONITORING.actionInputUpdate(s, data.value);
					}
					if (exists(data.checkresult)) {
						self.synopsisCheckResult();
						return true;
					}
					if (exists(data.sleep)) {
						showInfo(G.config.LOCALE_RETRIEVE('general.waitingForConnection'));
						socket.emit('dvio', data.command);
						return true;
					}
					if (exists(data.error)) {
						showError(data.error);
						notificationsClearAll(5000);
						socket.removeAllListeners('responseDevio2');
						socket.removeAllListeners('connect');
						socket = null;
						return false;
					}
					if (exists(data.end)) {
						showInfo(G.config.LOCALE_RETRIEVE('general.disconnected'));
						notificationsClearAll(5000);
						socket.removeAllListeners('responseDevio2');
						socket.removeAllListeners('connect');

						IO_POINTS.indStatus(s.indicateurUID, false);

						socket = null;
						return false;
					}
					if (method === 'dcnx') {
						socket.removeAllListeners('responseDevio2');
						socket.removeAllListeners('connect');
						socket = null;
						return false;
					}
					if (data.result == '') {
						showInfo(G.config.LOCALE_RETRIEVE('general.disconnected'));
						notificationsClearAll(5000);
						socket.removeAllListeners('responseDevio2');
						socket.removeAllListeners('connect');
						socket = null;
						IO_POINTS.indStatus(s.indicateurUID, false);
						return false;
					}
					socket.emit('dvio', data.result);
				}
			});
		})
		.on('responseDevio3', function (data) {
			$.ajax({
				url: G.config.SERVER + 'backend/devio/response',
				type: "POST",
				dataType: "json",
				data: {
					response: data.msg,
					method: "writepoint"
				},
				error: IO_POINTS.ajaxError,
				/**
				 *
				 * @param data {{ readinprogress, writeok, readok, checkresult, end, sleep, command, error, result }}
				 * @returns {boolean}
				 */
				success: function (data) {
					var method = 'writepoint';

					if (exists(data.readinprogress) && data.readinprogress != '1') {
						showInfo(data.readinprogress);
					}
					if (exists(data.info)) {
						showInfo(data.info);
					}
					if (exists(data.writeok_thenread)) {
						socket.emit('dvio', data.command);
					}
					if (exists(data.writeok)) {
						// showInfo(data.writeok);
						IO_POINTS.refreshValue(s, data.value, data.date);
						MONITORING.actionInputUpdate(s, data.value);
					}
					if (exists(data.readok)) {
						showInfo(data.readok);
						IO_POINTS.refreshValue(s, data.value, data.date);
						MONITORING.actionInputUpdate(s, data.value);
					}
					if (exists(data.checkresult)) {
						self.synopsisCheckResult();
						return true;
					}
					if (exists(data.sleep)) {
						showInfo(G.config.LOCALE_RETRIEVE('general.waitingForConnection'));
						socket.emit('dvio', data.command);
						return true;
					}
					if (exists(data.error)) {
						showError(data.error);
						notificationsClearAll(5000);
						socket.removeAllListeners('responseDevio3');
						socket.removeAllListeners('connect');
						socket = null;
						return false;
					}
					if (exists(data.end)) {
						showInfo(G.config.LOCALE_RETRIEVE('general.disconnected'));
						notificationsClearAll(5000);
						socket.removeAllListeners('responseDevio3');
						socket.removeAllListeners('connect');

						IO_POINTS.indStatus(s.indicateurUID, false);

						socket = null;
						return false;
					}
					if (method === 'dcnx') {
						socket.removeAllListeners('responseDevio3');
						socket.removeAllListeners('connect');
						socket = null;
						return false;
					}
					if (data.result == '') {
						showInfo(G.config.LOCALE_RETRIEVE('general.disconnected'));
						notificationsClearAll(5000);
						socket.removeAllListeners('responseDevio3');
						socket.removeAllListeners('connect');
						socket = null;
						IO_POINTS.indStatus(s.indicateurUID, false);
						return false;
					}
					socket.emit('dvio', data.result);
				}
			});
		})

		//Report disconnection
		.on('disconnect', function () {
			showInfo(G.config.LOCALE_RETRIEVE('general.disconnection'));
			IO_POINTS.indStatus(s.indicateurUID, false);
		});
};

IO_POINTS.ajaxError = function (xhr, textStatus, errorThrown) {
	showError("ajax error: " + textStatus, {
		url: this.url,
		textStatus: textStatus,
		error: errorThrown,
		xhr: xhr
	});
};

IO_POINTS.writeSiemens = function (s, value, mode) {
	var socketsiemens;

	if (IO_POINTS._verbose)
		console.log(
			'[IO_POINTS.writeSiemens]',
			'\n\t - settings: ', s,
			'\n\t - value: ', value,
			'\n\t - socketio: ', 'https://' + s.equipementFrontal + ':22443'
		);

	IO_POINTS.indStatus(s.indicateurUID, true);

	socketsiemens = io.connect('https://' + s.equipementFrontal + ':22443', {
		transports: ['websocket'],
		secure: true
	});
	showInfo(G.config.LOCALE_RETRIEVE('general.connectionInProgress'));

	socketsiemens
		.on('connect_failed', function () {
			showError(G.config.LOCALE_RETRIEVE('general.serviceUnavailable'));
			socketsiemens.disconnect();
			IO_POINTS.indStatus(s.indicateurUID, false);
		})
		.on('connect_error', function () {
			showError(G.config.LOCALE_RETRIEVE('general.serviceUnavailable'));
			socketsiemens.disconnect();
			IO_POINTS.indStatus(s.indicateurUID, false);
		})
		.on('error', function () {
			showError(G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
			socketsiemens.disconnect();
			IO_POINTS.indStatus(s.indicateurUID, false);
		})
		.on('connect', function () {
			var type = 'Numeric';
			if (mode == 'select') {
				var type = 'Enumeration';
			}
			socketsiemens.emit('ozw', JSON.stringify({
				ip: s.ipAddress,
				cmd: 'writepoint#' + s.pointLabel + '#' + type + '#' + value
			}));
		})
		.on('return_ozw', function (data) {
			data = JSON.parse(data);
			console.log('[POINTS_IO.writeSiemens] Return: ', data);

			$.ajax({
				url: G.config.SERVER + 'frontend/ajax/siemensresponse',
				type: 'POST',
				dataType: 'json',
				data: {
					response: data,
					labelAutomate: s.pointLabel,
					equipementId: s.equipementUID
				},
				success: function (response) {
					if (response.status === "error") {
						showError(response.error);
						IO_POINTS.indStatus(s.indicateurUID, false);
					}
					if (response.response === "ok") {
						showSuccess(response.info);
						MONITORING.actionInputUpdate(s, value);
					} else if (response.status === "success")
						showInfo(response.info);
					if (response.cmd === "dcnx") {
						if (socketsiemens != null) {
							socketsiemens.disconnect();
							socketsiemens.removeAllListeners('return_ozw');
							socketsiemens.removeAllListeners('connect');
							socketsiemens = null;
							console.log('dcnx');
							showInfo(G.config.LOCALE_RETRIEVE('general.disconnection'));
						}
						return false;
					}
				}
			});
		});


};

IO_POINTS.writeRelais_Globalio = function (s, value) {
	var socketgio;

	if (IO_POINTS._verbose)
		console.log(
			'[IO_POINTS.writeRelais_Globalio]',
			'\n\t - settings: ', s,
			'\n\t - value: ', value
		);

	IO_POINTS.indStatus(s.indicateurUID, true);

	socketgio = io.connect('https://' + s.equipementFrontal + ':22443', {
		transports: ['websocket'],
		secure: true
	});
	showInfo(G.config.LOCALE_RETRIEVE('general.connectionInProgress'));

	socketgio
		.on('connect_failed', function () {
			showError(G.config.LOCALE_RETRIEVE('general.serviceUnavailable'));
			socketgio.disconnect();
			IO_POINTS.indStatus(s.indicateurUID, false);
		})
		.on('connect_error', function () {
			showError(G.config.LOCALE_RETRIEVE('general.serviceUnavailable'));
			socketgio.disconnect();
			IO_POINTS.indStatus(s.indicateurUID, false);
		})
		.on('error', function () {
			showError(G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
			socketgio.disconnect();
			IO_POINTS.indStatus(s.indicateurUID, false);
		})
		.on('return', function (data) {
			data = JSON.parse(data);
			console.log('[POINTS_IO.writeRelais_Globalio] Return: ', data);

			$.ajax({
				url: G.config.SERVER + 'apigv/globalio/response',
				headers: {
					"Content-Type": "application/json",
					"Authorization": "Bearer "+G.model.userApiKey
				},
				type: 'POST',
				dataType: 'json',
				data: JSON.stringify({
					response: data,
					labelAutomate: s.pointLabel,
					equipementId: s.equipementUID
				}),
				success: function (response) {
					if (response.status === "error")
						showError(response.error);
					if (response.status === "writeok") {
						showSuccess(response.response.info);
						MONITORING.actionInputUpdate(s, value);
					}
					if (response.status === "success")
						showInfo(response.response.info);
				}
			});

			if (data === null) {
				// showSuccess('Écriture réalisée avec succès');
			}
			else if (exists(data.code)) {
				data.code = parseInt(data.code);
				switch (data.code) {
					case 5:
						// showInfo('Connexion établie');
						break;
					case 6:
						// showInfo('Déconnexion en cours');
						break;
					case 7:
						// showInfo('Déconnexion complète');
						MONITORING.actionInputUpdate(s, value);
						break;
					case 18:
						// showError('Connexion impossible. Veuillez réessayer ultérieurement.');
						MONITORING.actionInputRestore(s);
						break;
					default:
						console.warn('[IO_POINTS.writeRelais_Globalio] Socket return handler ; unhandled data code:', data.code);
						break;
				}
			}
		});

	var cmd = 'relay';
	// cmd += (value) ? 'On_' : 'Off_';
	cmd += (value === '1') ? 'On_' : 'Off_';
	cmd += (s.pointLabel == 're2') ? '2' : '1';
	console.log(cmd);

	socketgio.emit('cmd', JSON.stringify({
		ip: s.ipAddress,
		cmd: cmd
	}));
};

IO_POINTS.checkPingToWritePoint = function (s) {

	var actionSettings = MONITORING.getActionContext(s);

	console.log(
		'[IO_POINTS.checkPingToWritePoint]',
		'\n\t - actionSettings:', actionSettings
	);

	if (confirm("Confirmez vous l'écriture du point?")) {
		if (exists(s.equipementUID)) {
			if (s.checkping) {
				$.ajax({
					url: G.config.SERVER + 'frontend/ajax/isAvailable',
					type: "POST",
					data: {
						equipementId: s.equipementUID
					},
					error: IO_POINTS.ajaxError,
					datatype: "json",
					beforeSend: function () {
						showInfo("Vérification de la communication");
					},
					success: function (data) {
						if (data.status === "error") {
							showError(data.error, data);
							return;
						}
						IO_POINTS.writePoint(s, actionSettings.inpValue);
					}
				});
			}
			else {
				IO_POINTS.writePoint(s, actionSettings.inpValue);
			}
		}
	}
};

IO_POINTS.getModbusFrameToWritePoint_Globalio = function (s) {
	var actionSettings;

	actionSettings = MONITORING.getActionContext(s);

	console.log(
		'[IO_POINTS.getModbusFrameToWritePoint_Globalio]',
		'\n\t - settings: ', s,
		'\n\t - actionSettings: ', actionSettings
	);

	//	---	RELAIS
	if (s.equipementMarque == 'siemens') {
		IO_POINTS.writeSiemens(s, actionSettings.inpValue);
	}
	else if (s.equipementMarque === 'guntamatic') {
		if (confirm('Confirmez vous l\'écriture du point?')) {
			$.ajax({
				url: G.config.SERVER + 'frontend/ajax/writeGuntamatic',
				type: "POST",
				data: {
					idEquipement: s.equipementUID,
					mnemonique: s.mnemonique,
					idPoint: s.pointUID,
					ipAddress: s.ipAddress,
					mode: 'single',
					value: actionSettings.inpIsToggler ? (actionSettings.inpValue ? 1 : 0) : actionSettings.inpValue
				},
				datatype: "json",
				error: IO_POINTS.ajaxError,
				success: function (data) {
					if (data.status === "success")
						showSuccess('ok');
					else
						showError(data.error);
				}
			});
		}
	}
	else if (s.pointLabel === 're1' || s.pointLabel === 're2') {
		IO_POINTS.writeRelais_Globalio(s, actionSettings.inpValue);
	}
	else {
		//	---	MODBUS
		if (confirm('Confirmez vous l\'écriture du point?')) {
			$.ajax({
				url: G.config.SERVER + 'apigv/globalio/modbusFrame/'+s.pointUID,
				type: 'POST',
				headers: {
					"Content-Type": "application/json",
					"Authorization": "Bearer "+G.model.userApiKey
				},
				// url: G.config.SERVER + 'frontend/ajax/getModbusFrame',
				// type: "POST",
				data: JSON.stringify({
					idPoint: s.pointUID,
					mode: 'writepoint',
					value: actionSettings.inpIsToggler ? (actionSettings.inpValue ? 1 : 0) : actionSettings.inpValue
				}),
				datatype: "json",
				error: IO_POINTS.ajaxError,
				beforeSend: function () {
					showInfo("Service indisponible");
				},
				success: function (data) {
					if (data.status === "success")
						IO_POINTS.writePoint_Globalio(s, data.response.frame, actionSettings);
					else
						showError(data.message);
				}
			});
		}
	}
};
var G;

/**
 * @typedef {?{uid: string, color: string, altColor: string}} _SliceState
 * @typedef {{s: string, start: string, end: string}} _Slice
 * @typedef {Object.<{ranges: _Slice[], days: Array.<_Slice[]>}>}  _GVPlanningSlicesConfig
 *
 * @typedef {{planningId: number, vorbose: boolean }} _GVPlanningOptions
 * @typedef {{feedbackCallback: ?function, mode: ?string, hourFrom: ?number, hourTo: ?number, planningId: ?number, hourParts: ?number, verbose: ?boolean}} _GVDaySlicesOptions
 *
 */

if (!exists(G))
	G = {};

if (!exists(G.ui))
	G.ui = {};

if (!exists(G.ui.VOException)) {
	'use strict';
	
	/**
	 * VOException is a "value object" or data container holding a calendar planning exception.
	 *
	 * @param d {string|{date: string, day: string, month: string, year: string, exceptions: _Slice[]}}
	 * @param slices _Slice[]
	 * @constructor
	 */
	G.ui.VOException = function (d, slices) {
		if(slices != undefined) {
			// console.log('[VOException] from: ', '\n\t - d: ', d, '\n\t - slices: ', slices);
			var dateTokens = d.split('/');
			
			this.date = d;
			this.day = parseInt(dateTokens[0]);
			this.month = parseInt(dateTokens[1]);
			this.year = parseInt(dateTokens[2]);
			this.slices = slices;
			return;
		}
		
		console.log('[VOException] from: ', '\n\t - d: ', d);
		
		/** @type {string} */
		this.date = d.date;
		/** @type {number} */
		this.day = parseInt(d.day);
		/** @type {number} */
		this.month = parseInt(d.month);
		/** @type {number} */
		this.year = parseInt(d.year);
		/** @type {_Slice[]} */
		this.slices = d.exceptions || [];
		
		// console.log(this);
	};
	
	/**
	 * Process a deep Comparison of two VOException instances.
	 * @param p {?VOException}
	 * @return {boolean}
	 */
	G.ui.VOException.prototype.equal = function(p){
		var i, ilen;
		/** */
		var sl, slp;
		
		if(p && p instanceof G.ui.VOException){
			ilen = this.slices.length;
			if(ilen != p.slices.length)
				return false;
			
			for(i = 0; i < ilen; ++i){
				sl = this.slices[i];
				slp = p.slices[i];
				if(slp && sl.s != slp.s || sl.start != slp.start || sl.end != slp.end)
					return false;
			}
			return true;
		}
		return false;
	};
	
	/** Returns a string representation of the instance */
	G.ui.VOException.prototype.toString = function(){
		return '[VOException] #' + this.slices.length + ' - ' + this.date;
	};
}

if (!exists(G.ui.GVExceptionsCalendar)) {
	'use strict';
	
	/**
	 * GVExceptionsCalendar is an user interface element component displaying planning exception within a perpetual calendar.
	 *
	 * @param planning {G.ui.GVPlanning}
	 * @param elJqo {jQuery}
	 * @param options {?{?verbose: boolean}}
	 * @constructor
	 */
	G.ui.GVExceptionsCalendar = function (planning, elJqo, options) {
		var
			self = this,
			str, i, ilen,
			datesRange, currentDate;

		// ---   initialize model
		/** @type {G.ui.GVPlanning} */
		this._planning = planning;
		/** @type {{verbose: boolean}} */
		this._o = deepmerge({
			verbose: false
		}, options || {});
		/** @type {boolean} */
		this._initialized = false;
		/** @type  {jQuery} */
		this._el = elJqo;
		/** @type {moment} */
		this._dateCalendar = moment().startOf('month');
		/** @type {moment} */
		this._dateCalendarMin = moment(this._dateCalendar)
			.startOf('year')
			.subtract(1, 'y');
		/** @type {moment} */
		this._dateCalendarMax = moment(this._dateCalendar)
			.endOf('year')
			.add(1, 'y');
		
		/** @type {VOException[]} */
		this._exceptions = [];
		/**
		 * Map keys conform to a DD/MM/YYYY format
		 * @type {Object.<string, VOException>}
		 */
		this._exceptionsMap = {};
		this._cbs = {
			model_dateCalendarFromBrowser: this.model_dateCalendarFromBrowser.bind(this),
			ux_excalEditorClose: this.ux_excalEditorClose.bind(this),
			model_exceptionDelete: this.model_exceptionDelete.bind(this),
			model_exceptionClipboardCopy: this.model_exceptionClipboardCopy.bind(this),
			model_exceptionClipboardPaste: this.model_exceptionClipboardPaste.bind(this),
			ux_dateSelDragStart: this.ux_dateSelDragStart.bind(this),
			ux_dateSelDragEnd: this.ux_dateSelDragEnd.bind(this),
			model_dateSelChange: this.model_dateSelChange.bind(this),
			model_exceptionRestore: this.model_exceptionRestore.bind(this),
			model_exceptionSave: this.model_exceptionSave.bind(this),
			ux_dateSelDragMove: this.ux_dateSelDragMove.bind(this),
			model_navStatesGet__fromEdited: function(e){
				var s = self._planning.model_navStatesGet();
				self._planning.model_navStateSet(e.status ? s.EXCAL_EDITED : s.EXCAL_EDIT);
			}
		};

		currentDate = parseInt(this._dateCalendar.format('Y'));
		datesRange = [currentDate - 1, currentDate + 2];
		
		this._p = {};
		/**
		 * Table element containing calendar
		 * @type {jQuery}
		 */
		this._p.calendar = this._el.find('table.excal-calendar');
		/** @type {jQuery} */
		this._p.editor = this._el.find('.excal-editor');
		/** @type {jQuery} */
		this._p.monthSelect = this._el.find('select.gv-cal-month');
		/** @type {jQuery} */
		this._p.yearSelect = this._el.find('select.gv-cal-year');
		/** @type {jQuery} */
		this._p.dateFrom = this._el.find('.excal-date-from').find('input');
		/** @type {Pikaday}  */
		this._p.dateFromPickaday = new Pikaday({
			field: this._p.dateFrom[0],
			trigger: this._p.dateFrom.parent()[0],
			format: "DD/MM/YYYY",
			yearRange: datesRange,
			onSelect: function(){
				self._cbs.model_dateSelChange(
					moment(self._p.dateFromPickaday.getDate()),
					null
				);
			}
		});
		/** @type {jQuery} */
		this._p.dateTo = this._el.find('.excal-date-to').find('input');
		/** @type {Pikaday} */
		this._p.dateToPickaday = new Pikaday({
			field: this._p.dateTo[0],
			trigger: this._p.dateTo.parent()[0],
			format: "DD/MM/YYYY",
			yearRange: datesRange,
			onSelect: function(){
				self._cbs.model_dateSelChange(
					null,
					moment(self._p.dateToPickaday.getDate())
				);
			} //this._o.field.parentNode.classList.add("state--focused");
		});
		/** @type {GVDaySlices} */
		this._p.dsl = new G.ui.GVDaySlices('excal', this._planning, this._el.find('.gvdsl'), {
			mode: 'day',
			verbose: this._o.verbose
		});
		
		/** @type {moment} */
		this._dateSelStart = null;
		/** @type {moment} */
		this._dateSelEnd = null;


		// ---   initialize interactions

		str = '';
		G.config.LOCALE_RETRIEVE('date.monthes').forEach(function(el, index){
			str += '<option value="' + (index + 1) + '">' + el + '</option>';
		});
		this._p.monthSelect.html(str);

		str = '';
		for(i = this._dateCalendar.format('Y') - 1, ilen = i + 3; i < ilen; ++i)
			str += '<option value="' + i + '">' + i + '</option>';
		this._p.yearSelect.html(str);


		// ---   launch

		this.model_exceptionClipboardSet();
		this.model_dateCalendarSet(moment());
		this.ui_showEditor(false);
	};
	
	
	G.ui.GVExceptionsCalendar.prototype.ux_dateSelDragStart = function(e){
		var
			tds = this._p.calendar.find('td'),
			td = $(e.currentTarget)
			;

		this._dateSelStart = moment(td.attr('data-date'), 'DD/MM/YYYY');
		this._dateSelEnd = null;

		tds.removeClass('item--selected');
		td.addClass('item--selected');

		this._p.calendar.on('mousemove', 'tbody td', this._cbs.ux_dateSelDragMove);
		$(document).on('mouseup', this._cbs.ux_dateSelDragEnd);
	};
	G.ui.GVExceptionsCalendar.prototype.ux_dateSelDragMove = function(e){
		var dMini, dMaxi;

		this._dateSelEnd = moment($(e.currentTarget).attr('data-date'), 'DD/MM/YYYY');

		dMini = this._dateSelStart;
		dMaxi = this._dateSelEnd;
		if(this._dateSelEnd.diff(this._dateSelStart) < 0){
			dMini = this._dateSelEnd;
			dMaxi = this._dateSelStart;
		}
		this.ui_calRenderMonthStatesDateSel(dMini, dMaxi);
	};
	G.ui.GVExceptionsCalendar.prototype.ux_dateSelDragEnd = function(){
		this._p.calendar.off('mousemove', 'tbody td', this._cbs.ux_dateSelDragMove);
		$(document).off('mouseup', this._cbs.ux_dateSelDragEnd);

		this.model_dateSelChange();
	};
	G.ui.GVExceptionsCalendar.prototype.ux_excalEditorClose = function(){
		console.log('[GVExceptionsCalendar.ux_excalEditorClose]');

		this._dateSelStart = null;
		this._dateSelEnd = null;

		this.ui_calRenderMonth();
		this._planning.model_navStateSet(this._planning.model_navStatesGet().EXCAL);
	};
	G.ui.GVExceptionsCalendar.prototype.ux_dslGet = function(){
		return this._p.dsl;
	};
	
	
	G.ui.GVExceptionsCalendar.prototype.events_init = function(status){
		this._p.dsl.events_init(status);

		if(this._initialized == status)
			return;
		
		this._initialized = status;

		if(this._initialized == false){
			this._el
				.off('click', '.gv-cal-previous', this._cbs.model_dateCalendarFromBrowser)
				.off('click', '.gv-cal-next', this._cbs.model_dateCalendarFromBrowser)
				.off('click', '.gvp-excal-close', this._cbs.ux_excalEditorClose)
				.off('click', '.gvp-excal-delete', this._cbs.model_exceptionDelete)
				.off('click', '.gvp-excal-copy', this._cbs.model_exceptionClipboardCopy)
				.off('click', '.gvp-excal-paste', this._cbs.model_exceptionClipboardPaste)
				.off('click', '.gvp-excal-save', this._cbs.model_exceptionSave)
				.off('click', '.gvp-excal-restore', this._cbs.model_exceptionRestore)
				.off('mousedown', 'table.excal-calendar tbody td', this._cbs.ux_dateSelDragStart)
				.off('GVDaySlices:edited', '.gvdsl', this._cbs.model_navStatesGet__fromEdited)
				.off('change', 'select.gv-cal-month', this._cbs.model_dateCalendarFromBrowser)
				.off('change', 'select.gv-cal-year', this._cbs.model_dateCalendarFromBrowser)
			;
		}
		else{
			this._el
				.on('click', '.gv-cal-previous', this._cbs.model_dateCalendarFromBrowser)
				.on('click', '.gv-cal-next', this._cbs.model_dateCalendarFromBrowser)
				.on('click', '.gvp-excal-close', this._cbs.ux_excalEditorClose)
				.on('click', '.gvp-excal-delete', this._cbs.model_exceptionDelete)
				.on('click', '.gvp-excal-copy', this._cbs.model_exceptionClipboardCopy)
				.on('click', '.gvp-excal-paste', this._cbs.model_exceptionClipboardPaste)
				.on('click', '.gvp-excal-save', this._cbs.model_exceptionSave)
				.on('click', '.gvp-excal-restore', this._cbs.model_exceptionRestore)
				.on('mousedown', 'table.excal-calendar tbody td', this._cbs.ux_dateSelDragStart)
				.on('GVDaySlices:edited', '.gvdsl', this._cbs.model_navStatesGet__fromEdited)
				.on('change', 'select.gv-cal-month', this._cbs.model_dateCalendarFromBrowser)
				.on('change', 'select.gv-cal-year', this._cbs.model_dateCalendarFromBrowser)
			;

			G.ui.initSelect2(this._el);
		}
	};
	
	// dateSel
	G.ui.GVExceptionsCalendar.prototype.model_dateSelChange = function(selDateStart, selDateEnd){
		var
			loc,
			p = this._planning
		;

		loc = G.config.LOCALE_RETRIEVE('gvplanning.excal__quit_no_save').toString();
		if(p._navStateCurrent == p._navStates.EXCAL_EDITED && !window.confirm(loc)){
			this.model_navStateRestoreSelect();
			return;
		}

		// ---   consolidate data

		// value update
		if(exists(selDateStart) && selDateStart){
			console.log('[GVExceptionsCalendar.model_dateSelChange] Update selDateStart with: ', selDateStart);
			this._dateSelStart = moment(selDateStart);
		}
		if(exists(selDateEnd) && selDateEnd){
			console.log('[GVExceptionsCalendar.model_dateSelChange] Update selDateEnd with: ', selDateEnd);
			this._dateSelEnd = moment(selDateEnd);
		}

		// complete dataset for simple click behaviour
		if(this._dateSelEnd == null)
			this._dateSelEnd = moment(this._dateSelStart);

		// order dataset if rewind selection
		if(this._dateSelEnd.diff(this._dateSelStart) < 0){
			d = moment(this._dateSelEnd);
			this._dateSelEnd = moment(this._dateSelStart);
			this._dateSelStart = d;
		}

		if(this._o.verbose){
			console.log(
				'[GVExceptionsCalendar.model_dateSelChange]',
				'\n\t - selDateStart: ' + (this._dateSelStart ? this._dateSelStart.format('DD/MM/YYYY') : '-'),
				'\n\t - selDateEnd: ' + (this._dateSelStart ? this._dateSelEnd.format('DD/MM/YYYY') : '-')
			);
		}

		// ---   display range

		// ...in calendar

		this.ui_calRenderMonthStatesDateSel(this._dateSelStart, this._dateSelEnd);


		// ...in date pickers

		// set values
		this._p.dateFromPickaday.setMoment(this._dateSelStart, true);
		this._p.dateToPickaday.setMoment(this._dateSelEnd, true);

		// update ranges
		this._p.dateFromPickaday.setStartRange(this._dateSelStart.toDate());
		this._p.dateFromPickaday.setEndRange(this._dateSelEnd.toDate());

		this._p.dateToPickaday.setStartRange(this._dateSelStart.toDate());
		this._p.dateToPickaday.setEndRange(this._dateSelEnd.toDate());
		this._p.dateToPickaday.setMinDate(this._dateSelStart.toDate());

		// --- adjust display

		// focus out range date end input
		this._el.find('.excal-date-to-block').css({
			opacity: this.model_dateSelIsRange() ? 1 : .6
		});

		var canDeleteStatus = false;
		if(this._dateSelStart && this._dateSelEnd){
			for(var d = moment(this._dateSelStart); d.diff(this._dateSelEnd) <= 0; d.add(1, 'd')){
				if(this._exceptionsMap.hasOwnProperty(d.format('DD/MM/YYYY'))){
					canDeleteStatus = true;
					break;
				}
			}
		}
		this._planning.ui_elGet().find('.gvp-excal-delete').toggleClass('uicomp--disabled', !canDeleteStatus);

		// ---   update slices

		this.ui_slicesFromExceptionsMap();
		this._planning.model_navStateSet(this._planning.model_navStatesGet().EXCAL_EDIT, true);
	};
	G.ui.GVExceptionsCalendar.prototype.model_dateSelDelete = function(){
		this._dateSelStart = null;
		this._dateSelEnd = null;
		this._p.calendar.find('tbody td').removeClass('item--selected');
	};
	G.ui.GVExceptionsCalendar.prototype.model_dateSelIsRange = function(){
		return this._dateSelEnd.diff(this._dateSelStart, 'days') > 0;
	};

	// dateCalendar
	G.ui.GVExceptionsCalendar.prototype.model_dateCalendarGet = function(){
		return this._dateCalendar;
	};
	G.ui.GVExceptionsCalendar.prototype.model_dateCalendarSet = function(d){
		var dDiff;

		d.startOf('month');
		dDiff = d.diff(this._dateCalendar);


		// clamp date within valid range
		if(dDiff > 0 && d.diff(this._dateCalendarMax) > 0){
			d = moment(this._dateCalendarMax)
				.startOf('month');
		}
		else if(dDiff < 0 && d.diff(this._dateCalendarMin) < 0){
			d = moment(this._dateCalendarMin);
		}

		// load year exception if required
		if(d.year() != this._dateCalendar.year()){
			this._planning.model_load(this._planning.model_getPlanningId(), false, d.year());
		}

		this._dateCalendar = d;
		//console.log('[GVExceptionsCalendar.model_dateCalendarFromBrowser]', this._dateCalendar.format('DD/MM/YYYY'));


		// define month next/previous buttons state
		this._el.find('.gv-cal-previous').toggleClass(
			'uicomp--disabled',
			moment(d).subtract(1, 'month').diff(this._dateCalendarMin) < 0
		);
		this._el.find('.gv-cal-next').toggleClass(
			'uicomp--disabled',
			moment(d).add(1, 'month').diff(this._dateCalendarMax) > 0
		);


		// show current date in select inputs
		if(this._p.monthSelect.val() != this._dateCalendar.format('M')){
			this._p.monthSelect
				.val(this._dateCalendar.format('M'))
				.trigger('change.select2');
		}
		if(this._p.yearSelect.val() != this._dateCalendar.format('Y')) {
			this._p.yearSelect
				.val(this._dateCalendar.format('Y'))
				.trigger('change.select2');
		}

		this.ui_calRenderMonth();
	};
	G.ui.GVExceptionsCalendar.prototype.model_dateCalendarFromBrowser = function (e) {
		var from;

		if(!exists(e)){
			console.log('[GVExceptionsCalendar.model_dateCalendarFromBrowser] Illegal call');
			return;
		}

		// ---   update date model
		from = $(e.currentTarget);
		if(from.is('.gv-cal-previous'))
			this.model_dateCalendarSet(moment(this._dateCalendar).subtract(1, 'M'));
		else if(from.is('.gv-cal-next'))
			this.model_dateCalendarSet(moment(this._dateCalendar).add(1, 'M'));
		else
			this.model_dateCalendarSet(moment('01/' + this._p.monthSelect.val() + '/' + this._p.yearSelect.val(), 'DD/MM/YYYY'));
	};
	
	// exception
	G.ui.GVExceptionsCalendar.prototype.model_exceptionInit = function(exceptions, doReset) {
		var i, ilen, exc, deletedYear;

		doReset = doReset != false;

		if(doReset){
			this._exceptions = [];
			this._exceptionsMap = {};
		}

		if(!isarray(exceptions) || exceptions.length == 0)
			return;

		exc = new G.ui.VOException(exceptions[0]);
		deletedYear = exc.year;

		for(i = this._exceptions.length - 1; i >= 0; --i){
			exc = this._exceptions[i];
			if(exc.year == deletedYear){
				delete this._exceptionsMap[exc.date];
				this._exceptions.splice(i, 1);
			}
		}

		for(i = 0, ilen = exceptions.length; i < ilen; ++i){
			exc = new G.ui.VOException(exceptions[i]);
			this._exceptions.push(exc);
			this._exceptionsMap[exc.date] = exc;
		}
		// console.log('[GVExceptionsCalendar.model_exceptionInit] exceptions: ', this._exceptions);

		this.ui_calRenderMonthStates();
	};
	G.ui.GVExceptionsCalendar.prototype.model_exceptionAt = function(d){
		if(moment.isMoment(d))
			d = d.format('DD/MM/YYYY');
		else if(!isstring(d)){
			console.warn('[GVExceptionsCalendar.model_exceptionAt] Unhandled parameter type', d);
			return null;
		}
		return this._exceptionsMap.hasOwnProperty(d) ? this._exceptionsMap[d] : null;
	};
	G.ui.GVExceptionsCalendar.prototype.model_exceptionRestore = function(){
		console.log('[GVExceptionsCalendar.model_exceptionRestore]');
		this.ui_slicesFromExceptionsMap();
		this._planning.model_navStateSet(this._planning.model_navStatesGet().EXCAL_EDIT);
	};
	G.ui.GVExceptionsCalendar.prototype.model_exceptionSave = function(){
		console.log('[GVExceptionsCalendar.model_exceptionSave]');

		var
			self = this,
			url = G.config.SERVER + 'frontend/planning/storePlanning',
			dates = [],
			slices = this._p.dsl.model_getPlanning().days[0],
			params, d
		;

		for(d = moment(this._dateSelStart); d.diff(this._dateSelEnd, 'days') <= 0; ++i){
			dates.push(d.format('DD/MM/YYYY'));
			d = d.add(1, 'd');
		}

		var planningId = this._planning.model_getPlanningId();
		params = {
			planning_id: planningId,
			exception_dates: JSON.stringify(dates),
			exception_tranches: JSON.stringify(slices)
		};

		this._planning.model_navStateSet(this._planning.model_navStatesGet().EXCAL_SAVING);

		$.ajax({
			url: url,
			type: 'POST',
			data: params,
			dataType: "json",
			error: function (xhr, textStatus, errorThrown) {
				showError('[GVExceptionsCalendar.model_exceptionSave] An error occurred', {
					url: url,
					params: params,
					xhr: xhr,
					textStatus: textStatus,
					errorThrown: errorThrown
				});
				self.model_navStateSet(self._navStates.ERROR);
			},
			success: function (data) {
				if (self._o.verbose)
					console.log('[GVExceptionsCalendar.model_exceptionSave] Success, data: ', data);
					
				console.log('[GVExceptionsCalendar.model_exceptionSave] Success, data: ', data);
				
				switch (data.status) {
					case 'error':
						showError(data.error, {
							url: url,
							params: params,
							data: data
						});
						self._planning.model_navStateSet(self._planning.model_navStatesGet().EXCAL_EDITED);
						return;

					case 'warning':
						showError(data.error, {
							url: url,
							params: params,
							data: data
						});
						self._planning.model_navStateSet(self._planning.model_navStatesGet().EXCAL_EDITED);
						return;

					case 'success':
						self.model_exceptionUpdateInMap(slices, dates);
						self._p.dsl.model_editedSet(false);
						self._planning.model_setSyncFlag(true);
						// console.log( '#state-planning-' + this._planning.model_getPlanningId() );
						$('#state-planning-' + planningId ).show();
						break;
				}
			}
		});
	};
	G.ui.GVExceptionsCalendar.prototype.model_exceptionDelete = function(){
		console.log('[GVExceptionsCalendar.model_exceptionDelete]');

		var
			self = this,
			url = G.config.SERVER + 'frontend/planning/deleteException',
			params, d,
			dates = []
		;

		for(d = moment(this._dateSelStart); d.diff(this._dateSelEnd, 'days') <= 0; ++i){
			dates.push(d.format('DD/MM/YYYY'));
			d = d.add(1, 'd');
		}

		params = {
			planning_id: this._planning.model_getPlanningId(),
			exception_dates: JSON.stringify(dates)
		};

		$.ajax({
			url: url,
			type: 'POST',
			data: params,
			dataType: "json",
			error: function (xhr, textStatus, errorThrown) {
				showError('[GVExceptionsCalendar.model_exceptionSave] An error occurred', {
					url: url,
					params: params,
					xhr: xhr,
					textStatus: textStatus,
					errorThrown: errorThrown
				});
				self.model_navStateSet(self._navStates.ERROR);
			},
			success: function (data) {
				switch (data.status) {
					case 'error':
						showError(data.status, {
							url: url,
							params: params,
							data: data
						});
						self._planning.model_navStateSet(self._planning.model_navStatesGet().ERROR);
						return;

					case 'success':
						if (self._o.verbose)
							console.log('[GVExceptionsCalendar.model_exceptionDelete] Success, data: ', data);
						break;
				}

				self._planning.model_setSyncFlag(true);

				for(var i = 0, ilen = dates.length, index, dateStr; i < ilen; ++i){
					dateStr = dates[i];
					index = self._exceptions.indexOf(self._exceptionsMap[dateStr]);

					if (self._o.verbose)
						console.log('\t - delete date: "' + dateStr + '" at: ' + index);

					if(index > 0)
						self._exceptions.splice(index, 1);
					delete self._exceptionsMap[dateStr];
				}
				self.ux_excalEditorClose();
			}
		});
	};
	G.ui.GVExceptionsCalendar.prototype.model_exceptionUpdateInMap = function(slices, dates){
		/** @type {number} */
		var i, ilen;
		/** @type {VOException} */
		var exc;
		
		/*
		console.log(
			'[GVExceptionsCalendar.model_exceptionUpdateInMap]',
			'\n\t - slices: ', slices,
			'\n\t - dates: ', dates
		);
		*/

		for(i = 0, ilen = dates.length; i < ilen; ++i){
			exc = new G.ui.VOException(dates[i], slices);
			if(this._exceptionsMap.hasOwnProperty(exc.date))
				this._exceptions.splice(this._exceptions.indexOf(this._exceptionsMap[exc.date]), 1);
			this._exceptions.push(exc);
			this._exceptionsMap[exc.date] = exc;
		}

		this.ui_calRenderMonthStates();
	};
	
	// exceptionClipboard
	G.ui.GVExceptionsCalendar.prototype.model_exceptionClipboardSet = function(d){
		this._exceptionClipboard = d;
		this._el.find('button.gvp-excal-paste').toggleClass('uicomp--disabled', d == null);
	};
	G.ui.GVExceptionsCalendar.prototype.model_exceptionClipboardCopy = function(){
		console.log('[GVExceptionsCalendar.model_exceptionClipboardCopy]');
		this.model_exceptionClipboardSet(this._p.dsl.model_getPlanning().days);
	};
	G.ui.GVExceptionsCalendar.prototype.model_exceptionClipboardPaste = function(){
		console.log('[GVExceptionsCalendar.model_exceptionClipboardPaste] exceptionClipboard: ', this._exceptionClipboard);
		this._p.dsl.model_import(this._exceptionClipboard, this._planning.model_getSlicesStates());
		this._planning.model_navStateSet(this._planning.model_navStatesGet().EXCAL_EDITED);
	};
	
	
	G.ui.GVExceptionsCalendar.prototype.ui_slicesFromExceptionsMap = function(){
		var dStr = this._dateSelStart.format('DD/MM/YYYY');

		// /*
		console.log(
			'[GVExceptionsCalendar.ui_slicesFromExceptionsMap]',
			'\n\t - dStr: ' + dStr,
			'\n\t - selDateStart: ' + this._dateSelStart.format('DD/MM/YYYY'),
			'\n\t - selDateEnd: ' + this._dateSelEnd.format('DD/MM/YYYY'),
			'\n\t - exceptionsMap has dStr: ' + this._exceptionsMap.hasOwnProperty(dStr),
			'\n\t - exceptionsMap value: ' + this._exceptionsMap[dStr]
		);
		// */
		this._p.dsl.model_import(
			this.model_dateSelIsRange() || !this._exceptionsMap.hasOwnProperty(dStr) ?
				[] :
				[this._exceptionsMap[dStr].slices],
			this._planning.model_getSlicesStates()
		);
	};
	G.ui.GVExceptionsCalendar.prototype.ui_showEditor = function(status){
		this._p.editor.toggle(status);
		this.ui_calRenderMonthStates();
	};
	G.ui.GVExceptionsCalendar.prototype.ui_calRenderMonth = function () {
		var
			i, str, d,
			currentMonth, currentYear,
			classNames, dayNames = G.config.LOCALE_RETRIEVE('date.daysShort');

		currentMonth = parseInt(this._dateCalendar.format('M'));
		currentYear = parseInt(this._dateCalendar.format('Y'));

		// console.log('[GVExceptionsCalendar.ui_calRenderMonth] date: ' + this._dateCalendar.format('DD/MM/YYYY'));


		// ---   table headers

		str = '<thead><tr>';
		for (i = 0; i < 7; ++i)
			str += '<td>' + dayNames[i] + '</td>';
		str += '</tr></thead>';
		str += '<tbody><tr>';


		// ---   table body

		d = moment(this._dateCalendar);
		d.subtract(this._dateCalendar.isoWeekday() - 1, 'd');

		i = 0;
		while (i < 50) {
			++i;

			classNames = [];
			if (parseInt(d.format('M')) != currentMonth)
				classNames.push('item--focused-out');

			str += '<td data-date="' + d.format('DD/MM/YYYY') + '" class="' + classNames.join(' ') + '">' + d.format('D') + '</td>';

			d = d.add(1, 'd');

			// console.log(' calDate:', this._dateCalendar.format('DD/MM/YYYY'), '\n d', d.format('DD/MM/YYYY'), '\n d.month:', d.month(), '\n currentMonth: ', currentMonth, '\n d.year: ', d.year(), '\n currentYear: ', currentYear);
			if (d.isoWeekday() == 1) {
				if (d.month() + 1 > currentMonth || d.year() > currentYear) {
					str += '</tr>';
					break;
				}
				else {
					str += '</tr><tr>';
				}
			}
		}
		str += '</tbody>';


		// ---   apply

		this._p.calendar.html(str);
		this.ui_calRenderMonthStates();
	};
	G.ui.GVExceptionsCalendar.prototype.ui_calRenderMonthStates = function(){
		var tds, i, ilen, today, diff, exc;

		tds = this._p.calendar.find('tbody td');

		// ---   check if today belongs to displayed month
		today = moment().startOf('day');
		if(this._dateCalendar.month() == today.month()){
			for(i = 0, ilen = tds.length; i < ilen; ++i){
				diff = moment(tds.eq(i).attr('data-date'), 'DD/MM/YYYY').diff(today);
				tds.eq(i).toggleClass('item--past', diff < 0);
				if(diff == 0)
					tds.eq(i).addClass('item--today');
			}
		}
		else{
			tds.toggleClass('item--past', this._dateCalendar.diff(today) < 0);
		}

		// ---   display exceptions belonging to displayed month
		tds.removeClass('item--has-alert');
		for (i = 0, ilen = this._exceptions.length; i < ilen; ++i) {
			exc = this._exceptions[i];
			tds.filter('[data-date="' + exc.date + '"]').addClass('item--has-alert');
		}

		// ---
		this.ui_calRenderMonthStatesDateSel(this._dateSelStart, this._dateSelEnd);
	};
	G.ui.GVExceptionsCalendar.prototype.ui_calRenderMonthStatesDateSel = function(selDateStart, selDateEnd){
		var d;

		if(!moment.isMoment(selDateStart)){
			if(this._o.verbose)
				console.log('[GVExceptionsCalendar.ui_calRenderMonthStatesDateSel] selDateStart is not a moment instance', selDateStart);
			return;
		}
		else if(!moment.isMoment(selDateEnd)){
			if(this._o.verbose)
				console.log('[GVExceptionsCalendar.ui_calRenderMonthStatesDateSel] selDateEnd is not a moment instance', selDateEnd);
			return;
		}
		else if(this._o.verbose){
			console.log(
				'[GVExceptionsCalendar.ui_calRenderMonthStatesDateSel] from: '
				+ selDateStart.format('DD/MM/YYYY')
				+ ' to: '
				+ selDateStart.format('DD/MM/YYYY')
			);
		}

		this._p.calendar.find('tbody td')
			.removeClass('item--selected')
			.each(function(index, el){
				el = $(el);
				d = moment(el.attr('data-date'), 'DD/MM/YYYY');
				el.toggleClass('item--selected', d.diff(selDateStart, 'days') >= 0 && d.diff(selDateEnd, 'days') <= 0);
			});
	};
}

if (!exists(G.ui.GVDaySlices)) {
	'use strict';
	
	/**
	 * @param humanId {string}
	 * @param planning {GVPlanning}
	 * @param elJqo {jQuery}
	 * @param options {_GVDaySlicesOptions}
	 * @constructor
	 */
	G.ui.GVDaySlices = function (humanId, planning, elJqo, options) {
		
		// --- initialize model
		
		/** @type {string} */
		this._humanId = humanId;
		/** @type {boolean} */
		this._initialized = false;
		/** @type {GVPlanning} */
		this._planning = planning;
		/** @type {_GVDaySlicesOptions} */
		this._o = deepmerge({
			feedbackCallback: null,
			planningId: -1,
			hourFrom: 0,
			hourTo: 24,
			hourParts: 4,
			mode: 'week',
			verbose: false
		}, options || {});
		/**
		 * Edition flag
		 * @type {boolean}
		 * @private
		 */
		this._edited = false;
		/** @type {_SliceState[]} */
		this._slicesStates = [];
		/** @type {_SliceState} */
		this._slicesStateDefault = null;
		/** @type {string[]} */
		this._daysLocale = G.config.LOCALE_RETRIEVE('date.daysShort');
		/** @type {_GVPlanningSlicesConfig} */
		this._planningSaved = {
			ranges: [],
			days: []
		};
		/** @type {_GVPlanningSlicesConfig} */
		this._planningCurrent = {
			ranges: [],
			days: []
		};
		/**
		 * allow developper to lock rendering during extensive update processes
		 * @type {boolean}
		 */
		this._rangesRenderLocked = false;
		/**
		 * while dragging to "paint" in block-type cells, store the position of the drag start position
		 * @type {null|Object.<{x: number, y: number}>}
		 */
		this._dragStatus = null;


		// --- initialize view

		this._el = elJqo;
		this._p = {
			grid: this._el.find('.gvdsl-grid'),
			caption: this._el.find('.gvdsl-caption'),
			stateSelector: this._el.find('.gvdsl-states-selector')
		};


		this.dom_build();


		// ---   initialize interactions

		this._cbs = {
			model_slicesStateSet: this.model_slicesStateSet.bind(this),
			ux_unsetHover: this.ux_unsetHover.bind(this),
			ux_colStateWatch: this.ux_colStateWatch.bind(this),
			ux_colState: this.ux_colState.bind(this),
			ux_colHover: this.ux_colHover.bind(this),
			ux_rowState: this.ux_rowState.bind(this),
			ux_rowHover: this.ux_rowHover.bind(this),
			ux_blockState: this.ux_blockState.bind(this),
			ux_blockStateWatch: this.ux_blockStateWatch.bind(this),
			ux_showTooltip: this.ux_showTooltip.bind(this),
			dom_renderRanges: this.dom_renderRanges.bind(this),

			form_timeInputChange: this.form_timeInputChange.bind(this),
			form_lineAdd: this.form_lineAdd.bind(this),
			form_stateSelect: this.form_stateSelect.bind(this),
			form_timeInputBlur: this.form_timeInputBlur.bind(this),
			form_stateSelectToggle: this.form_stateSelectToggle.bind(this),
			form_lineDelete: this.form_lineDelete.bind(this),
			form_lineUpdate: this.form_lineUpdate.bind(this)
		};

		this.events_init(true);


		// ---   launch

		this._el.addClass('gvdsl--mode-' + this._o.mode);
	};
	
	/**
	 * Enables/disables interactions.
	 * @param status {boolean} target status
	 */
	G.ui.GVDaySlices.prototype.events_init = function(status){

		if(this._initialized == status)
			return;

		this._initialized = status;

		if(this._initialized == false){
			$(window).off('resize', this._cbs.dom_renderRanges);
			$(window).off('orientationchange', this._cbs.dom_renderRanges);

			this._el
				// --- complete day
				.off('click', '.gvdsl__day', this._cbs.ux_rowState)
				.off('mouseenter', '.gvdsl__day', this._cbs.ux_rowHover)
				.off('mouseleave', '.gvdsl__day', this._cbs.ux_unsetHover)
				// ---	complete hour
				.off('mousedown', '.gvdsl__hour', this._cbs.ux_colStateWatch)
				.off('mouseenter', '.gvdsl__hour', this._cbs.ux_colHover)
				.off('mouseleave', '.gvdsl__hour', this._cbs.ux_unsetHover)
				// ---	hour part
				.off('mousedown', '.gvdsl__hour-part', this._cbs.ux_colStateWatch)
				.off('mouseenter', '.gvdsl__hour-part', this._cbs.ux_colHover)
				.off('mouseleave', '.gvdsl__hour-part', this._cbs.ux_unsetHover)
				// --- element
				.off('mousedown', '.gvdsl__block', this._cbs.ux_blockStateWatch)
				// ---  show range tooltip
				.off('gvdsl:mouseenter', '.gvdsl__range', this._cbs.ux_showTooltip)
				.off('gvdsl:mouseleave', '.gvdsl__range', this._cbs.ux_showTooltip)
				// ---   state selector
				.off('click', '.gvdsl__state-selector', this._cbs.model_slicesStateSet)
				// ---   slices form
				.off('click', 'button.slice-line__update', this._cbs.form_lineUpdate)
				.off('click', 'button.slice-line__delete', this._cbs.form_lineDelete)
				.off('click', 'button.slices-form-add-line', this._cbs.form_lineAdd)
				.off('select2:close', 'select.slices-form__state', this._cbs.form_stateSelect)
				.off('click', '.slices-form__line .state-bullet.item--toggler', this._cbs.form_stateSelectToggle)
			;
		}
		else{
			$(window).on('resize', this._cbs.dom_renderRanges);
			$(window).on('orientationchange', this._cbs.dom_renderRanges);

			this._el
				.on('dragstart', function (e) {
					e.preventDefault();
					return false;
				})
				// --- complete day
				.on('click', '.gvdsl__day', this._cbs.ux_rowState)
				.on('mouseenter', '.gvdsl__day', this._cbs.ux_rowHover)
				.on('mouseleave', '.gvdsl__day', this._cbs.ux_unsetHover)
				// ---	complete hour
				.on('mousedown ', '.gvdsl__hour', this._cbs.ux_colStateWatch)
				.on('mouseenter', '.gvdsl__hour', this._cbs.ux_colHover)
				.on('mouseleave', '.gvdsl__hour', this._cbs.ux_unsetHover)
				// ---	hour part
				.on('mousedown', '.gvdsl__hour-part', this._cbs.ux_colStateWatch)
				.on('mouseenter', '.gvdsl__hour-part', this._cbs.ux_colHover)
				.on('mouseleave', '.gvdsl__hour-part', this._cbs.ux_unsetHover)
				// --- element
				.on('mousedown', '.gvdsl__block', this._cbs.ux_blockStateWatch)
				// ---  show range tooltip
				.on('gvdsl:mouseenter', '.gvdsl__range', this._cbs.ux_showTooltip)
				.on('gvdsl:mouseleave', '.gvdsl__range', this._cbs.ux_showTooltip)
				// ---   state selector
				.on('click', '.gvdsl__state-selector', this._cbs.model_slicesStateSet)
				// ---   slices form
				.on('click', 'button.slice-line__update', this._cbs.form_lineUpdate)
				.on('click', 'button.slice-line__delete', this._cbs.form_lineDelete)
				.on('click', 'button.slices-form-add-line', this._cbs.form_lineAdd)
				.on('select2:close', 'select.slices-form__state', this._cbs.form_stateSelect)
				.on('click', '.slices-form__line .state-bullet.item--toggler', this._cbs.form_stateSelectToggle)
			;
		}
	};

	/**
	 * Expands/collapses day line display.
	 * @param row  {jQuery|jQuery[]}
	 * @param status ?{boolean}
	 */
	G.ui.GVDaySlices.prototype.form_toggleDayDisplay = function (row, status){
		var target, i, ilen, els, el, str;
		
		if(!row || !row.is('.gvdsl-row') || row.length != 1) {
			console.error('[GVDaySlices.form_toggleDayDisplay] Invalid pointer', row);
			return;
		}
		
		str = '';
		if(status == undefined || !isbool(status))
			status = row.is('.item--expanded') != true;
		
		if(status)
			this._p.grid.find('.gvdsl-row.item--expanded').removeClass('item--expanded');

		target = row.next('.gvdsl__slices-form');

		row.toggleClass('item--expanded', status);
		
		if(status){
			str = '';
			for(i = 0, els = row.find('.gvdsl__range'), ilen = els.length; i < ilen; ++i){
				el = els.eq(i);
				str += this.form_lineBuild(
					this._planning.model_sliceStateGet(el.attr('data-state')),
					el.attr('data-slice-start'),
					el.attr('data-slice-end')
				);
			}
			
			str += '<div class="slices-form__line">'
				+ '<button class="uicomp__button uicomp--green slices-form-add-line">'
					+ '<i class="fas fa-plus"></i>'
					+ '<span>' + G.config.LOCALE_RETRIEVE('gvplanning.dsl__add_slice_form_line') + '</span>'
				+ '</button>'
				+ '<p>' + G.config.LOCALE_RETRIEVE('gvplanning.dsl_time_input_info') + '</p>'
				+ '</div>' // end .slices-form__line
			;
		}
		
		target
			.html(str)
			.find('.state-bullet');
		G.ui.initSelect2(target);

		this.dom_renderRanges();
	};
	/**
	 * Builds line HTML formatted string.
	 * @param state {_SliceState}
	 * @param startTime {string} start time formatted as "00:00"
	 * @param endTime {string} end time formatted as "00:00"
	 * @return {string} HTML element string
	 */
	G.ui.GVDaySlices.prototype.form_lineBuild = function(state, startTime, endTime){
		/** @type {number} */
		var i, ilen;
		/** @type {string} */
		var str;
		/** @type {_SliceState} */
		var el;
		/** @type {boolean} */
		var useStatesSelect = this._slicesStates.length > 2;
		
		str = '<div class="slices-form__line slices-form__range-line gv-header__data-filters">'
			+ '<div class="state-bullet' + (useStatesSelect ? ' item--toggler' : '') + '" style="background-color:' + state.color + ';">'
			+ '</div>';
		
		str +=  '<div class="slices-form__states"><select class="slices-form__state" data-nosearch>';
		for(i = 0, ilen = this._slicesStates.length; i < ilen; ++i){
			el = this._slicesStates[i];
			if(el.uid == 'default')
				continue;
			str += '<option value="' + el.uid + '"' + (el.uid === state.uid ? ' selected' : '') + '>' + G.config.LOCALE_RETRIEVE('gvplanning.dslstate_' + el.uid) + '</option>';
		}
		
		str += '</select></div>'
		str += '<span class="slices-form__time">'
			+ '<label class="uicomp__label">' + G.config.LOCALE_RETRIEVE('gvplanning.excal__rangeFromLabel') + '</label>'
			+ '<input class="uicomp__input slices-form__from-time" type="time" title="" value="' + startTime  + '" />'
			+ '<label class="uicomp__label">' + G.config.LOCALE_RETRIEVE('gvplanning.excal__rangeToLabel') + '</label>'
			+ '<input class="uicomp__input slices-form__to-time" type="time" title="" value="' + endTime + '" />'
			+ '</span>'

			+ '<div class="slices-form__feedback"></div>'

			+ '<div class="slices-form__line__buttons">'
				+ '<button class="uicomp__button uicomp--green slice-line__update"><i class="fas fa-check"></i></button>'
				+ '<button class="uicomp__button uicomp--red slice-line__delete"><i class="fas fa-times"></i></button>'
			+ '</div>'

			+ '</div>'
		;
		return str;
	};
	/**
	 * Returns the slice definition line containing the target of the passed-in event.
	 * @param e {Event}
	 * @return {jQuery}
	 */
	G.ui.GVDaySlices.prototype.form_lineGet = function(e){
		return $(e.currentTarget).closest('.slices-form__range-line');
	};
	/**
	 * Returns the slices form containing the target of the passed-in event.
	 * @param e {Event}
	 * @return {jQuery}
	 */
	G.ui.GVDaySlices.prototype.form_formGet = function(e){
		return $(e.currentTarget).closest('.gvdsl__slices-form');
	};
	/**
	 * Adds a new slice definition line at the beginning of the form.
	 * @param e {Event}
	 */
	G.ui.GVDaySlices.prototype.form_lineAdd = function(e){
		if(this._o.verbose){
			console.log('[GVDaySlices.form_lineAdd]');
		}

		var line = $(this.form_lineBuild(
			this._slicesStates[0],
			this._convertTimeInput('00:00', true),
			this._convertTimeInput('00:59', false)
		));
		line.insertBefore(
			this.form_formGet(e).find('.slices-form__line').first()
		);
		G.ui.initSelect2(line);

		this.form_lineEditedHandler(e, 'create');
		this.dom_renderRanges();
		this.model_editedSet(true);
	};
	/**
	 * Deletes range definition form line ; launches update sequence.
	 * @param e {Event}
	 */
	G.ui.GVDaySlices.prototype.form_lineDelete = function(e){
		if(this._o.verbose){
			console.log('[GVDaySlices.form_lineDelete]');
		}
		
		this.form_lineEditedHandler(e, 'delete');
		this.dom_renderRanges();
		this.model_editedSet(true);
	};

	/**
	 *
	 * @param e
	 */
	G.ui.GVDaySlices.prototype.form_lineUpdate = function(e){
		var
			lineEl = this.form_lineGet(e),
			fromInp = lineEl.find('.slices-form__from-time'),
			toInp = lineEl.find('.slices-form__to-time');

		if(this._o.verbose){
			console.log('[GVDaySlices.form_lineUpdate]');
		}

		fromInp.val(this._convertTimeInput(fromInp.val(), true));
		toInp.val(this._convertTimeInput(toInp.val(), false));

		this.form_lineEditedHandler(e, 'update');
		this.dom_renderRanges();
		this.model_editedSet(true);


	};

	/**
	 * Handles time input change events ; secures user input and launches update sequence.
	 * @param e {Event}
	 */
	G.ui.GVDaySlices.prototype.form_timeInputChange = function(e){
		/*
		$(this._el).css({
			border: "2px solid #" + Math.floor(Math.random()* 0xffffff).toString(16)
		});
		*/
		if(this._planning.model_uxFormTypeGet() && document.activeElement != e.currentTarget){
			this.form_timeInputBlur(e);
		}
	};
	/**
	 * Handles time input blur events ; secures user input and launches update sequence.
	 * @param e {Event}
	 */
	G.ui.GVDaySlices.prototype.form_timeInputBlur = function(e){
		/** @type {jQuery} */
		var el = $(e.currentTarget);
		/** @type {string} */
		var
			valSrc = el.val(),
			val = this._convertTimeInput(valSrc, el.is('.slices-form__from-time')),
			oldVal = el.attr('data-old-val')
		;

		if(this._o.verbose) {
			console.log('[GVDaySlices.form_timeInputBlur]', '\n\t - oldVal:', oldVal, '\n\t - val:', val);
		}
		
		el.val(val);
		if(valSrc != oldVal)
			this.form_lineEditedHandler(e);
		el.attr('data-old-val', val);
	};
	/**
	 * Handles interactions on states
	 * @param e {Event}
	 * @param status
	 */
	G.ui.GVDaySlices.prototype.form_stateSelectToggle = function(e, status){
		var lineEl = this.form_lineGet(e);
		
		status = isbool(status) ? status : lineEl.is('.item--show-state');

		if(this._o.verbose){
			console.log('[GVDaySlices.form_stateSelectToggle] status: ', status);
		}
		lineEl.toggleClass('item--show-state', !status);
	};
	/**
	 * Handles changes from slices state select input.
	 * @param e {Event}
	 */
	G.ui.GVDaySlices.prototype.form_stateSelect = function(e){
		/** @type {jQuery} */
		var lineEl = this.form_lineGet(e);
		/** @type {_SliceState} */
		var state = this._planning.model_sliceStateGet(lineEl.find('select.slices-form__state').val());
		
		lineEl
			.find('.state-bullet').css({
				'background-color': state.color
			})
			.attr('data-uiid', lineEl);
		
		if(this._o.verbose){
			console.log('[GVDaySlices.form_stateSelect]');
		}
		
		this.form_lineEditedHandler(e);
		this.form_stateSelectToggle(e);
	};
	/**
	 * Handles changes within a form line.
	 * @param e {Event}
	 * @param action {string=}
	 */
	G.ui.GVDaySlices.prototype.form_lineEditedHandler = function(e, action){
		var
			getLineEls = function(){
				return formEl.find('.slices-form__line.slices-form__range-line');
			},
			permute,
			formEl = this.form_formGet(e),
			dayEl = formEl.prev('.gvdsl-row.gvdsl-row__day'),
			dayIndex = parseInt(dayEl.attr('data-day-index')),
			lineEls, inputFromTime, inputToTime,
			lineEl = this.form_lineGet(e);

		/** @type {{state: _SliceState, fromHour: string, toHour: string, fromIndex: ?number, toIndex: ?number}} */
		var lineConf;


		if(action === 'delete'){
			lineEl.remove();
			lineEls = getLineEls();
		}
		else if(action === 'create'){
			lineEls = getLineEls();
			lineEl = lineEls.eq(0);
		}
		else{
			lineEls = getLineEls();
		}

		if(isNaN(dayIndex)){
			return;
		}

		console.log('[GVDaySlices.form_lineEditedHandler]');

		this._rangesRenderLocked = true;
		renderLocked:{
			// clear previous states from this day
			this.dom_setBlocksState(dayEl.find('.gvdsl__block'), null);

			for(var iLine = 0, ilenLine = lineEls.length; iLine < ilenLine; ++iLine){
				lineEl = lineEls.eq(iLine);
				inputFromTime = lineEl.find('input.slices-form__from-time');
				inputToTime = lineEl.find('input.slices-form__to-time');
				lineConf = {
					state: this._planning.model_sliceStateGet(lineEl.find('select.slices-form__state').val()),
					fromHour: inputFromTime.val(),
					toHour: inputToTime.val(),
					fromIndex: Number.NaN,
					toIndex: Number.NaN
				};
				lineConf.fromIndex = this._convertHourToIndex(lineConf.fromHour);
				lineConf.toIndex = this._convertHourToIndex(lineConf.toHour);

				// permutes values if given in the wrong order
				permuteBlock: if(lineConf.fromIndex > lineConf.toIndex){
					if(inputFromTime.is(':focus')){
						break permuteBlock;
					}
					else if(inputToTime.is(':focus')){
						break permuteBlock;
					}

					permute = lineConf.fromIndex;
					lineConf.fromIndex = this._convertTimeInput(lineConf.toIndex, true);
					lineConf.toIndex = this._convertTimeInput(permute, false);

					permute = lineConf.fromHour;
					lineConf.fromHour = this._convertTimeInput(lineConf.toHour, true);
					lineConf.toHour = this._convertTimeInput(permute, false);

					inputFromTime
						.css({
							opacity: .2
						})
						.fadeTo(600, 1)
						.val(lineConf.fromHour);
					inputToTime
						.css({
							opacity: .2
						})
						.fadeTo(600, 1)
						.val(lineConf.toHour);
				}

				console.log('\t [' + iLine + '] create range: "' + (lineConf.state ? lineConf.state.uid : '-') + '" from: ' + lineConf.fromHour + ' to: ' + lineConf.toHour);
				this.dom_setBlocksState(this._cellsByDay[dayIndex].slice(lineConf.fromIndex, lineConf.toIndex), lineConf.state);
			}
		}

		this._rangesRenderLocked = false;
		this.dom_renderRanges(dayIndex);

		this.model_editedSet(true);
	};
	
	G.ui.GVDaySlices.prototype.ux_error = function (message, level) {
		if (this._o.feedbackCallback) {
			this._o.feedbackCallback(message, level);
		}
		console.warn('[' + level + ']', message);
	};
	/**
	 * Handles cell mousedown events.
	 * @param e {MouseEvent}
	 */
	G.ui.GVDaySlices.prototype.ux_blockStateWatch = function (e) {

		// FORM TYPE INTERFACE: toggle line opening status
		if(this._planning.model_uxFormTypeGet()){
			this.form_toggleDayDisplay(this.ux_rowGet(e));
		}
		
		// NO STATE IS SET: display an error
		else if (!this._state) {
			this.ux_error('no-state-selected', 'info');
		}
		
		// RIGHT CLICKS: cancel action
		else if (e.button && e.button == 2) {
			//...
		}
		
		// STARTS WATCH PROCESS
		else if (e.type == 'mousedown') {
			this._p.grid.on('mouseover', '.gvdsl__block', this._cbs.ux_blockState);
			$(document).on('mouseup', this._cbs.ux_blockStateWatch);
			$(window).on('mouseup', this._cbs.ux_blockStateWatch);

			this.ux_blockState(e);
		}
		
		// STOPS WATCH PROCESS
		else {
			// ckeck for state restoration
			if (exists(this._dragStatus) && exists(this._dragStatus.state)) {
				this.model_slicesStateSet(this._dragStatus.state);
			}
			// release drag lock
			this._dragStatus = null;

			this._p.grid.off('mouseover', '.gvdsl__block', this._cbs.ux_blockState);
			$(document).off('mouseup', this._cbs.ux_blockStateWatch);
			$(window).off('mouseup', this._cbs.ux_blockStateWatch);
		}
	};
	/**
	 * Returns row containing the event target.
	 * @param e {Event}
	 * @return {jQuery}
	 */
	G.ui.GVDaySlices.prototype.ux_rowGet = function(e){
		return (e || this._o.mode == 'week') ?
			$(e.currentTarget).closest('.gvdsl-row') :
			this._el.find('.gvdsl-row__day').eq(0);
	};
	/**
	 * Defines cell state from user interaction.
	 * @param e {Event}
	 */
	G.ui.GVDaySlices.prototype.ux_blockState = function (e) {
		var blockState, min, max;

		if (!this._state) {
			this.ux_error('no-state-selected', 'info');
			return;
		}
		
		/** @type {jQuery} */
		var
			block = $(e.target),
			row = block.parent('.gvdsl-row__day')
		;
		/** @type {number} */
		var
			xBlock = row.find('.gvdsl__block').index(block),
			yBlock = parseInt(row.attr('data-day-index'));
		
		if (!this._dragStatus) {
			this._dragStatus = {
				x: xBlock,
				y: yBlock
			};
			blockState = block.attr('data-state');
			if (blockState == this._state.uid) {
				this.model_slicesStateSet(this._slicesStateDefault.uid);
				this._dragStatus.state = blockState;
			}
			
			console.log('[GVDaySlices.ux_blockState] first call of the drag process', this._dragStatus);
		}
		else if (yBlock != this._dragStatus.y) {
			return;
		}

		if (xBlock > this._dragStatus.x) {
			min = this._dragStatus.x;
			max = xBlock;
		}
		else {
			min = xBlock;
			max = this._dragStatus.x;
		}
		max += 1;
		
		
		this.dom_setBlocksState(this._cellsByDay[yBlock].slice(min, max), this._state);
		this.model_editedSet(true);
	};
	/**
	 * Removes hover class to all cells.
	 * @param e {?Event}
	 */
	G.ui.GVDaySlices.prototype.ux_unsetHover = function (e) {
		this.ux_showTooltip(e);
		this._cellsAll.removeClass('gvdsl--target-hover');
	};
	/**
	 * Returns all cells from the line.
	 * @param e {Event}
	 * @return {jQuery|jQuery[]}
	 */
	G.ui.GVDaySlices.prototype.ux_rowSelect = function (e) {
		return $(e.currentTarget).closest('.gvdsl-row').find('.gvdsl__block');
	};
	/**
	 * Sets an hover class to all cells from the line.
	 * @param e {Event}
	 */
	G.ui.GVDaySlices.prototype.ux_rowHover = function (e) {
		this.ux_unsetHover();
		if(this._planning.model_uxFormTypeGet())
			return;
		this.ux_showTooltip(e);
		this.ux_rowSelect(e).addClass('gvdsl--target-hover');
	};
	/**
	 * Handles clicks on row (toggles display in form UI / set state in GUI).
	 * @param e {Event}
	 */
	G.ui.GVDaySlices.prototype.ux_rowState = function (e) {
		if(this._planning.model_uxFormTypeGet()){
			this.form_toggleDayDisplay($(e.currentTarget).closest('.gvdsl-row'));
		}
		else{
			if (!this._state)
				return this.ux_error('no-state-selected', 'info');
			
			this.dom_setBlocksState(this.ux_rowSelect(e), this._state);
			this.model_editedSet(true);
		}
	};
	G.ui.GVDaySlices.prototype.ux_colStateWatch = function (e) {
		if(this._planning.model_uxFormTypeGet()){
		
		}
		else if (e.type == 'mousedown') {
			this._p.grid
				.on('mouseover', '.gvdsl__hour', this._cbs.ux_colState)
				.on('mouseover', '.gvdsl__hour-part', this._cbs.ux_colState)
			;
			$(document)
				.on('mouseup', this._cbs.ux_colStateWatch);
			$(window)
				.on('mouseup', this._cbs.ux_colStateWatch);
			this.ux_colState(e);
		}
		else {
			this._p.grid
				.off('mouseover', '.gvdsl__hour', this._cbs.ux_colState)
				.off('mouseover', '.gvdsl__hour-part', this._cbs.ux_colState)
			;
			$(document).off('mouseup', this._cbs.ux_colStateWatch);
			$(window).off('mouseup', this._cbs.ux_colStateWatch);
		}
	};
	G.ui.GVDaySlices.prototype.ux_colSelect = function (e) {
		var el = $(e.currentTarget), index, selectors;

		// ---	complete hour
		if (el.hasClass('gvdsl__hour')) {
			index = el.closest('.gvdsl-row').find('.gvdsl__hour').index(el);
			selectors = [];
			for (var i = index * this._o.hourParts, iLen = i + this._o.hourParts; i < iLen; ++i) {
				selectors.push('.gvdsl__block:eq(' + i + ')');
			}
			return this._el.find('.gvdsl-row__day').find(selectors.join(', '));
		}
		// ---	hour parts
		else if (el.hasClass('gvdsl__hour-part')) {
			index = el.closest('.gvdsl-row').find('.gvdsl__hour-part').index(el);
			return this._el.find('.gvdsl-row__day').find('.gvdsl__block:eq(' + index + ')');
		}

		return $('#void');
	};
	G.ui.GVDaySlices.prototype.ux_colHover = function (e) {
		this.ux_unsetHover();
		if(this._planning.model_uxFormTypeGet())
			return;
		this.ux_showTooltip(e);
		this.ux_colSelect(e).addClass('gvdsl--target-hover');
	};
	G.ui.GVDaySlices.prototype.ux_colState = function (e) {
		if (!this._state) {
			this.ux_error('no-state-selected', 'info');
			return;
		}
		this.dom_setBlocksState(this.ux_colSelect(e), this._state);
		this.model_editedSet(true);
	};
	/**
	 *
	 * @param e {?Event}
	 */
	G.ui.GVDaySlices.prototype.ux_showTooltip = function(e){
		var
			status, el, title = '',
			tooltip = this._el.find('.gvdsl-tooltip');

		if(this._dragStatus !== null){
			status = false;
		}
		else if(exists(e)){
			if(e instanceof $){
				el = e;
				status = el.attr('data-state') != undefined;
			}
			else{
				el = $(e.currentTarget);
				status = (e.type == 'gvdsl:mouseenter' || e.type == 'mouseenter') && this._state != 'default';
			}

			if(status){
				title = el.attr('data-gvdsl-title');
				if(title.indexOf('~~') == 0){
					title = this._planning.locale(title.substr(2), this);
				}
			}
		}
		else{
			status = false;
		}

		tooltip.toggleClass('status-active', status);
		tooltip.find('.gvdsl-tooltip__desc').html(title);
	};
	
	/**
	 * Sets blocks "data-state" attributes.
	 * @usage does not process to display by itself
	 *
	 * @param blocks {jQuery|jQuery[]}
	 * @param state {_SliceState}
	 */
	G.ui.GVDaySlices.prototype.dom_setBlocksState = function (blocks, state) {
		if (!blocks || blocks.length == 0) {
			console.warn('[GVDaySlices.dom_setBlocksState] no target');
			return;
		}

		blocks.attr('data-state', state ? state.uid : null);

		if (!this._rangesRenderLocked) {
			this.dom_renderRanges();
		}
	};
	/**
	 * Renders range UI elements from range configuration.
	 * @param dayIndex ?{number}
	 */
	G.ui.GVDaySlices.prototype.dom_renderRanges = function (dayIndex) {
		var self = this, str, ranges, pickedRanges, iRange, iRangeLen, range;

		if(!this._el.is(':visible'))
			return;

		ranges = this.model_retrieveRanges().ranges;

		if (this._dragStatus) {
			dayIndex = this._dragStatus.y;
		}

		if(isan(dayIndex) && dayIndex >= 0){

			// clear ranges from line
			this._p.grid
				.find('.gvdsl-row__day[data-day-index="' + dayIndex + '"]')
				.find('.gvdsl__range')
				.remove();

			// retrieve ranges
			pickedRanges = [];
			for (iRange = 0, iRangeLen = ranges.length; iRange < iRangeLen; ++iRange) {
				range = ranges[iRange];
				if (range.day != dayIndex)
					continue;
				pickedRanges.push(range)
			}
			// console.log('[GVDaySlices.dom_renderRanges] in day #' + dayIndex + ' / for ' + pickedRanges.length + ' ranges', pickedRanges);
		}
		else{
			// clear previous ranges
			this._p.grid
				.find('.gvdsl__range')
				.remove();

			// copy all ranges
			pickedRanges = ranges.concat();
			// console.warn('[GVDaySlices.dom_renderRanges] in all day / for ' + pickedRanges.length + ' ranges', pickedRanges);
		}

		for (iRange = 0, iRangeLen = pickedRanges.length; iRange < iRangeLen; ++iRange) {
			range = pickedRanges[iRange];

			// console.log('\t - range[' + iRange + ']: ', range);
			range.startBlock.find('.gvdsl__range').remove();

			// --- create tooltip instance
			range.tipEl = $('<div class="gvdsl__range" '
				+ 'data-state="' + range.s + '" '
				+ 'data-slice-start="' + range.start + '" '
				+ 'data-slice-end="' + range.end + '" '
				+ 'data-gvdsl-title="~~dsl__range_tooltip~~STATE|' + range.s + '|START|' + range.start + '|END|' + range.end + '"'
				+ '><div class="gvdsl__range-area"></div></div>'
			);

			range.tipEl
				.css({
					width: range.endBlock.offset().left - range.startBlock.offset().left + range.startBlock.width()
				})
				.appendTo(range.startBlock)
				.find('.gvdsl__range-area')
				.css({
					'background-color': range.state.color
				});

			(function (range) {
				for (var a = range.startIndex; a <= range.endIndex; a++) {
					self._cellsGridArr[range.day][a]
						.on('mouseover', function () {
							range.tipEl
								.addClass('item--hover')
								.trigger('gvdsl:mouseenter');
						})
						.on('mouseout', function () {
							range.tipEl
								.removeClass('item--hover')
								.trigger('gvdsl:mouseleave');
						});
				}
			}(range));
		}
	};
	G.ui.GVDaySlices.prototype.dom_build = function () {
		var str, loc,
			self = this,
			iDay, iDayLen,
			classes, title,
			dayCells,
			iHour, iHourMod, iHourLen, hour;


		// ##################### BUILD STATES SELECTORS

		this.dom_buildStatesSelector();


		// ##################### BUILD GRID

		str = '';
		iHourLen = (24 * this._o.hourParts);

		// ---	hours display

		// hour
		str += '<div class="gvdsl-row gvdsl-row__hours">';
		str += '<div class="gvdsl__dayname"></div>';
		for (iHour = 0; iHour <= iHourLen; iHour++) {
			iHourMod = iHour % this._o.hourParts;
			classes = '';
			if (iHourMod == 0) {
				hour = Math.ceil(iHour / this._o.hourParts);

				classes += 'gvdsl__hour gvdsl--hour-start';
				if ((iHour / this._o.hourParts) % 6 == 0)
					classes += '-xl';
				if(iHour == iHourLen)
					classes += ' gvdsl__margin';

				str += '<div class="' + classes + '" data-gvdsl-title="~~dsl__hour_col_tooltip">'
					+ '<span ' + (hour % 2 != 0 ? ' class="hide--mobile" ' : '') + '>'
						+ Math.ceil(iHour / this._o.hourParts) + '<span class="hide--narrow-down">h</span>'
					+ '</span>';
			}
			else if (iHourMod == (this._o.hourParts - 1))
				str += '</div>';
		}
		str += '</div>';
		str += '</div>';

		// hour parts
		str += '<div class="gvdsl-row gvdsl-row__hour-parts">';
		str += '<div class="gvdsl__dayname"></div>';

		for (iHour = 0; iHour <= iHourLen; iHour++) {
			classes = (iHour == iHourLen) ? 'gvdsl__margin gvsl__margin-right' : 'gvdsl__hour-part';
			if ((iHour / this._o.hourParts) % 6 == 0)
				classes += ' gvdsl--hour-start-xl';

			str += '<div '
				+ 'class="' + classes + '" '
				+ 'data-gvdsl-title="~~dsl__hourparts_col_tooltip" ';
			if ((iHour != iHourLen) && loc)
				str += 'data-gvdsl-title="' + loc + '" ';
			str += '></div>';
		}
		str += '</div>';

		// ---	days display
		iDayLen = (this._o.mode == 'week') ? 7 : 1;
		for (iDay = 0; iDay < iDayLen; iDay++) {
			str += '<div class="gvdsl-row gvdsl-row__day" data-day-index="' + iDay + '">';
			str += '<div class="gvdsl__day gvdsl__dayname" data-gvdsl-title="~~dsl__day_row_tooltip">'
				+ ((this._o.mode == 'week') ? this._daysLocale[iDay] : '')
				+ '</div>';

			for (iHour = 0; iHour <= iHourLen; iHour++) {
				classes = (iHour == iHourLen) ? 'gvdsl__margin gvsl__margin-right' : 'gvdsl__block';
				if (iHour % this._o.hourParts == 0)
					classes += ((iHour / this._o.hourParts) % 6 == 0) ? ' gvdsl--hour-start-xl' : ' gvdsl--hour-start';
				str += '<div class="' + classes + '"></div>';
			}
			str += '</div>'
				+ '<div class="gvdsl__slices-form"></div>';
		}

		this._p.grid.append($(str));

		// --- store all cells

		this._cellsGridArr = [];
		this._cellsByDay = [];
		this._p.grid.find('.gvdsl-row__day').each(function (rowIndex, rowEl) {
			rowEl = $(rowEl);
			dayCells = [];
			rowEl.find('.gvdsl__block').each(function (blockIndex, blockEl) {
				dayCells.push($(blockEl));
			});
			self._cellsGridArr.push(dayCells);
			self._cellsByDay.push(rowEl.find('.gvdsl__block'));
		});
		this._cellsAll = this._p.grid.find('.gvdsl__block');
	};
	G.ui.GVDaySlices.prototype.dom_buildStatesSelector = function () {
		var
			states = this._slicesStates,
			i,
			ilen = isarray(states) ? states.length : 0,
			loc,
			strSelector = '',
			strCaption = ''
		;

		for (i = 0; i < ilen; ++i) {
			loc = this._planning.locale('dslstate_' + states[i].uid);

			strCaption += '<div class="gvdsl-caption__line">'
				+ '<i class="fas fa-square" style="color:' + states[i].color + ';"></i>'
				+ loc
				+ '</div>';

			strSelector += '<div class="gvdsl__state-selector" data-state="' + states[i].uid + '">'
				+ '<div class="state-selector-bullet" style="background-color: ' + states[i].color + ';"></div>'
				+ '<div class="gvdsl__states-label">' + loc + '</div>'
				+ '</div>';
		}

		this._p.caption.html(strCaption);
		this._p.stateSelector.html(strSelector);
	};
	G.ui.GVDaySlices.prototype.dom_applyBlocksStates = function () {
		var
			self = this,
			iDay, ilenDay, iRange, ilenRange, iBlock,
			ranges, range, rangeState, rangeStartIndex, rangeEndIndex,
			dayEls = this._p.grid.children('.gvdsl-row__day'),
			dayEl, dayBlocksEls
			;
		
		this._p.grid.find('.gvdsl__block').removeAttr('data-state');

		this._rangesRenderLocked = true;
		for(iDay = 0, ilenDay = this._planningCurrent.days.length; iDay < ilenDay; ++iDay) {
			dayEl = dayEls.eq(iDay);
			dayBlocksEls = dayEl.find('.gvdsl__block');
			
			ranges = this._planningCurrent.days[iDay];
			
			for (iRange = 0, ilenRange = ranges.length; iRange < ilenRange; ++iRange) {
				range = ranges[iRange];
				rangeStartIndex = this._convertHourToIndex(range.start);
				rangeEndIndex = this._convertHourToIndex(range.end);
				rangeState = this._planning.model_sliceStateGet(range.s);
				for (iBlock = rangeStartIndex; iBlock < rangeEndIndex; ++iBlock) {
					this.dom_setBlocksState(dayBlocksEls.eq(iBlock), rangeState);
				}
			}
		}
		this._rangesRenderLocked = false;

		// console.warn('[GVDaySlices.dom_applyBlocksStates] ranges: ', this._planningCurrent.ranges);
		if(this._planningCurrent.ranges.length > 0){
			setTimeout(function(){
				self.dom_renderRanges();
			}, 100);
		}
	};
	
	
	/**
	 * Getter for "edited" flag.
	 * @return {boolean} edited status
	 */
	G.ui.GVDaySlices.prototype.model_editedGet = function(){
		return this._edited;
	};
	/**
	 * Updates "edited" flag.
	 * @param status {boolean} target status
	 */
	G.ui.GVDaySlices.prototype.model_editedSet = function(status){
		var e;

		if(this._edited == status)
			return;

		this._edited = status;

		e = $.Event('GVDaySlices:edited');
		e.status = this._edited;
		this._el.trigger(e);
	};
	G.ui.GVDaySlices.prototype.model_createEmptyPlanning = function(){
		var planning = {
			days: [],
			ranges: []
		};

		for(var i = 0, ilen = (this._o.mode == 'week') ? 7 : 1; i < ilen; ++i)
			planning.days.push([]);

		return planning;
	};
	G.ui.GVDaySlices.prototype.model_slicesStateSet = function (state) {
		state = this._planning.model_sliceStateGet(state);

		if (state == false)
			return;

		this._state = state;
		this._p.stateSelector.find('.gvdsl__state-selector')
			.removeClass('status-active')
			.filter('[data-state="' + this._state.uid + '"]').addClass('status-active');

		this._el.trigger('stateSelected', {
			state: this._state
		});
	};
	G.ui.GVDaySlices.prototype.model_merge = function () {
		this._planningSaved = deepmerge(this._planningCurrent, {});
	};
	/**
	 *
	 * @returns {jQuery}
	 */
	G.ui.GVDaySlices.prototype.model_jqoGet = function(){
		return this._el;
	};
	G.ui.GVDaySlices.prototype.model_restore = function () {
		this._planningCurrent = deepmerge(this._planningSaved, {});
		this.model_editedSet(false);

		this.dom_applyBlocksStates();
		this.dom_renderRanges();
	};
	G.ui.GVDaySlices.prototype.model_import = function (days, states) {
		var i, ilen;

		if(!exists(days))
			days = this.model_createEmptyPlanning().days;

		if(this._o.verbose){
			console.log(
				'[GVDaySlices.model_import]',
				'\n\t - humanId:', this._humanId,
				'\n\t - days:', days,
				'\n\t - states:', states
			);
		}
		// ---   states

		this._slicesStates = states;
		for(i = 0, ilen = this._slicesStates.length; i < ilen; ++i){
			if(this._slicesStates[i].uid == 'default'){
				this._slicesStateDefault = this._slicesStates[i];
				break;
			}
		}
		if(this._slicesStateDefault == null)
			this._slicesStateDefault = this._slicesStates[0];

		this.dom_buildStatesSelector();
		this.model_slicesStateSet(this._slicesStates[0]);

		// ---   planning

		this._planningSaved = {
			days: days,
			ranges: []
		};
		for (i = 0, ilen = this._planningSaved.days.length; i < ilen; ++i)
			this._planningSaved.ranges = this._planningSaved.ranges.concat(this._planningSaved.days[i]);
		
		this.model_restore();
	};
	/**
	 * Getter for planning config.
	 * @return {_GVPlanningSlicesConfig}
	 */
	G.ui.GVDaySlices.prototype.model_getPlanning = function(){
		return this._planningCurrent;
	};
	/**
	 * Reads GUI to defines slices ranges.
	 * @return {_GVPlanningSlicesConfig}
	 */
	G.ui.GVDaySlices.prototype.model_retrieveRanges = function () {
		var
			stateUID,
			iDay, iDayLen, row,
			iRange, iRangeLen,
			iBlock, iBlockLen, block,
			rowRanges, outRange;

		
		if (!exists(this._slicesStates) || this._slicesStates.length == 0) {
			this._planningCurrent.ranges = [];
			return this._planningCurrent;
		}

		// console.time('[GVDaySlices.model_retrieveRanges]');

		// --- if a drag process is running remove all ranges belonging to the drag row
		if (this._dragStatus) {
			for (iRange = this._planningCurrent.ranges.length - 1; iRange >= 0; --iRange) {
				if (this._planningCurrent.ranges[iRange].day == this._dragStatus.y) {
					this._planningCurrent.ranges.splice(iRange, 1);
				}
			}
		}
		else {
			this._planningCurrent.ranges = [];
		}

		for (iDay = 0, iDayLen = (this._o.mode == 'week') ? 7 : 1; iDay < iDayLen; ++iDay) {

			// --- if a drag process is running, check only the  drag row
			if (this._dragStatus && this._dragStatus.y != iDay)
				continue;

			row = this._cellsGridArr[iDay];
			rowRanges = [];

			for (iBlock = 0, iBlockLen = row.length; iBlock < iBlockLen; ++iBlock) {
				block = row[iBlock];
				
				// no current range: create a new range
				if (!outRange) {
					stateUID = block.attr('data-state') || 'default';
					outRange = {
						s: stateUID,
						state: stateUID != 'default' ? this._planning.model_sliceStateGet(stateUID) : this._slicesStateDefault,
						day: iDay,
						start: this._convertTimeInput(this._convertIndexToHour(iBlock), true),
						startIndex: iBlock,
						startBlock: row[iBlock]
					};
				}
				// current range exists and block status is different from it
				else if (outRange && block.attr('data-state') !== outRange.s) {
					
					if (outRange.s != 'default') {
						outRange.end = this._convertTimeInput(this._convertIndexToHour(iBlock), false);
						outRange.endIndex = iBlock - 1;
						outRange.endBlock = row[iBlock - 1];
						rowRanges.push(outRange);
					}
					
					stateUID = block.attr('data-state') || 'default';
					outRange = {
						s: stateUID,
						state: stateUID != 'default' ? this._planning.model_sliceStateGet(stateUID) : this._slicesStateDefault,
						day: iDay,
						start: this._convertTimeInput(this._convertIndexToHour(iBlock), true),
						startIndex: iBlock,
						startBlock: row[iBlock]
					};
				}
			}

			// if a range is opened --> close and store data
			if (outRange && outRange.s != 'default') {
				outRange.end = this._convertTimeInput(this._convertIndexToHour(iBlock), false);
				outRange.endIndex = iBlockLen - 1;
				outRange.endBlock = row[iBlockLen - 1];
				rowRanges.push(outRange);
			}
			outRange = null;

			// copy row ranges
			this._planningCurrent.days[iDay] = [];
			for (iRange = 0, iRangeLen = rowRanges.length; iRange < iRangeLen; ++iRange) {
				this._planningCurrent.ranges.push(rowRanges[iRange]);
				this._planningCurrent.days[iDay].push({
					s: rowRanges[iRange].s,
					start: rowRanges[iRange].start,
					end: rowRanges[iRange].end
				});
			}
		}

		// console.warn('[GVDaySlices.model_retrieveRanges]', '\n\t - humanId:', this._humanId, '\n\t - planningCurrent: ', this._planningCurrent);
		// console.timeEnd('[GVDaySlices.model_retrieveRanges]');
		
		return this._planningCurrent;
	};
	
	
	/**
	 * Returns the ".gvdsl__block" element index corresponding to the passed-in time.
	 * @param s {string} "00:00"
	 * @return {number}
	 * @private
	 */
	G.ui.GVDaySlices.prototype._convertHourToIndex = function (s) {
		/** @type {string[]} */
		var tokens;
		/** @type {number} */
		var h, m;
		
		if(!isstring(s))
			return 0;
		
		tokens = s.split(':');
		if(tokens.length != 2)
			return 0;
		
		h = parseInt(tokens[0]);
		m = parseInt(tokens[1]);
		if (m % (60 / this._o.hourParts) != 0)
			m += 1;
		return (h * this._o.hourParts) + (m / (60 / this._o.hourParts));
	};
	/**
	 *
	 * @param i {number}    ".gvdsl__block" element index
	 * @return {string} Time string formatted as "00:00"
	 * @private
	 */
	G.ui.GVDaySlices.prototype._convertIndexToHour = function (i) {
		var h, m;
		
		h = Math.floor(i / this._o.hourParts);
		m = 60 / this._o.hourParts * (i % this._o.hourParts);
		h = (h + 24) % 24;

		h = h.toString();
		m = m.toString();
		return ((h.length < 2) ? '0' + h : h)
			+ ':'
			+ ((m.length < 2) ? '0' + m : m);
	};
	/**
	 * Ensures a two characters string from passed-in number.
	 * @param v {number}
	 * @return {string}
	 * @private
	 */
	G.ui.GVDaySlices.prototype._2Digit = function(v){
		/** @type {string} */
		var vstr = v.toString();
		return (vstr.length < 2) ? '0' + vstr : vstr;
	};
	/**
	 * Converts a time value to match a valid range definition (end on 59, 14, 29, 44).
	 * @param v {string} time (00:00) value to be secured
	 * @param isStart {boolean}  whether the passed-in time corresponds to the slice start definition
	 * @return {string}  secured time value
	 * @private
	 */
	G.ui.GVDaySlices.prototype._convertTimeInput = function(v, isStart){
		var vTokens;
		var h, m;
		
		vTokens = v.toString().split(':');
		if(vTokens.length != 2){
			console.log('[GVDaySlices._convertTimeInput] Illegal input', v);
			return '00:00';
		}
		
		h = parseInt(vTokens[0]);
		m = parseInt((Math.round(parseInt(vTokens[1]) / 15) * 15).toFixed(0));
		if(!isStart)
			m -= 1;
		
		if(m >= 60){
			m -= 60;
			h++;
		}
		else if(m < 0){
			m += 60;
			h--;
		}
		
		if(h >= 24)
			h -= 24;
		else if(h < 0)
			h += 24;
		
		return this._2Digit(h) + ':' + this._2Digit(m);
	};
}

if (!exists(G.ui.GVPlanning)) {
	'use strict';
	
	/**
	 * GlobalVisio planning edition component.
	 * GVPlanning class is the entry point for configuration, target DOM element is defined in "apps\frontend\views\partials\planning.volt"
	 *
	 * @param elJqo {jQuery}   target DOM object
	 * @param options {_GVPlanningOptions}
	 * @constructor
	 */
	G.ui.GVPlanning = function (elJqo, options) {
		/** @type {jQuery} */
		this._el = elJqo;
		/** @type {_GVPlanningOptions} */
		this._o = deepmerge({
			planningId: -1,
			title: 'Planning des heures où je suis bien',
			verbose: false
		}, options || {});
		/**
		 * @type {Object.<string, _SliceState[]>}
		 * @private
		 */
		this._slicesStatesConfigurations = {
			trend: [
				{ uid: 'occupation', color: G.clr.STATUS_ENUM.green, altColor: G.clr.STATUS_ENUM.greyLight },
				{ uid: 'default', color: G.clr.STATUS_ENUM.greyLight, altColor: G.clr.STATUS_ENUM.greyDefault },
				{ uid: 'vacances', color: G.clr.STATUS_ENUM.blue, altColor: G.clr.STATUS_ENUM.greyLight }
			],
			siemens_ecs: [
				{ uid: 'normal', color: G.clr.STATUS_ENUM.green, altColor: G.clr.STATUS_ENUM.greyLight },
				{ uid: 'reduit', color: G.clr.STATUS_ENUM.greyLight, altColor: G.clr.STATUS_ENUM.greyDefault }
			],
			siemens_on_off: [
				{ uid: 'marche', color: G.clr.STATUS_ENUM.green, altColor: G.clr.STATUS_ENUM.greyLight },
				{ uid: 'arret', color: G.clr.STATUS_ENUM.greyLight, altColor: G.clr.STATUS_ENUM.greyDefault }
			],
			siemens_chauffage: [
				{ uid: 'confort', color: G.clr.STATUS_ENUM.green, altColor: G.clr.STATUS_ENUM.greyLight },
				{ uid: 'preconfort', color: G.clr.STATUS_ENUM.blue, altColor: G.clr.STATUS_ENUM.greyLight },
				{ uid: 'eco', color: G.clr.STATUS_ENUM.greyLight, altColor: G.clr.STATUS_ENUM.greyDefault }
			],
			siemens: [
				{ uid: 'marche', color: G.clr.STATUS_ENUM.green, altColor: G.clr.STATUS_ENUM.greyLight },
				{ uid: 'arret', color: G.clr.STATUS_ENUM.greyLight, altColor: G.clr.STATUS_ENUM.greyDefault }
			],
			default: [
				{ uid: 'occupation', color: G.clr.STATUS_ENUM.green, altColor: G.clr.STATUS_ENUM.greyLight },
				{ uid: 'default', color: G.clr.STATUS_ENUM.greyLight, altColor: G.clr.STATUS_ENUM.greyDefault }
			]
		};
		
		
		/** @type {_SliceState[]} */
		this._slicesStates = null;
		/**
		 * whether or not planning uses form interface
		 * @type {boolean}
		 */
		this._uxFormType = false;
		
		/** @type {boolean} */
		this._syncFlag = false;
		/** @type {Object.<string, string>} */
		this._navStates = {
			EMPTY: 'state_void',
			LOADING: 'state_loading',
			ERROR: 'state_error',
			PLANNING: 'state_planning',
			PLANNING_EDITED: 'state_planning_edited',
			PLANNING_SAVING: 'state_planning_saving',
			EXCAL: 'state_excal',
			EXCAL_EDIT: 'state_excal_edit',
			EXCAL_EDITED: 'state_excal_edited',
			EXCAL_SAVING: 'state_excal_saving',
			DATA_SYNC: 'state_data_sync'
		};

		// --- pointers
		this._p = {};
		/** @type {jQuery} */
		this._p.mainMenuNav = this._el.find('nav.gvp-nav-sections');
		/** @type {jQuery} */
		this._p.mainMenuSelect = this._el.find('select.gvp-nav-sections');
		/** @type {string} */
		this._p.mainMenuSelectExcalOption = this._p.mainMenuSelect.find('option[value="state_excal"]').html();
		/** @type {jQuery[]} */
		this._p.mainMenuNavItems = this._p.mainMenuNav.find('a');
		/** @type {jQuery[]} */
		this._p.sections = this._el.find('.gvp-section');
		/** @type {jQuery} */
		this._p.sectionError = this._p.sections.filter('[data-section-id="state_error"]');
		/** @type {jQuery} */
		this._p.sectionLoading = this._p.sections.filter('[data-section-id="state_loading"]');
		/** @type {jQuery} */
		this._p.sectionPlanning = this._p.sections.filter('[data-section-id="state_planning"]');
		/** @type {jQuery} */
		this._p.sectionExcal = this._p.sections.filter('[data-section-id="state_excal"]');
		/** @type {GVLogger} */
		// this._p.syncLogger = new G.ui.GVLogger(this._el.find('section[data-section-id="state_data_sync"] .uicomp__logger'), { addOnTop: true, height: 180 });
		this._p.syncLogger =  G.ui.GVLogger.GetInstance();
		/** @type {GVDaySlices} */
		this._p.dslPlanning = new G.ui.GVDaySlices('dslPlanning', this, this._p.sectionPlanning.find('.gvdsl'), {
			mode: 'week',
			verbose: this._o.verbose
		});
		/** @type {GVExceptionsCalendar} */
		this._p.excal = new G.ui.GVExceptionsCalendar(this, this._p.sectionExcal.find('.gv-calendar-exceptions'), {
			verbose: this._o.verbose
		});
		
		
		// ---   interactions

		var self = this;
		this._cbs = {
			events_updateFormType: this.events_updateFormType.bind(this),
			model_navStateSet_fromLink: function(){
				self.model_navStateSet($(this).attr('data-section-id'));
				return false;
			},
			model_navStateSet_fromSelect: function(){
				self.model_navStateSet(self._p.mainMenuSelect.val());
			},
			model_navStateSet_fromEditedState: function(e){
				e.status ? self.model_navStateSet(self._navStates.PLANNING_EDITED) : self.model_navStateSet(self._navStates.PLANNING);
			},
			model_planningStore: function(){
				if(self._o.verbose)
					console.warn('[GVPlanning.model_planningStore]');
				self.model_planningStore();
			},
			model_restore: function(){
				if(self._o.verbose)
					console.warn('[GVPlanning.model_restore]');
				self._p.dslPlanning.model_restore();
				self.model_navStateSet(self._navStates.PLANNING);
			},
			sync_globalvisio2controler: function(){
				self.sync_globalvisio2controler();
			},
			sync_controler2globalvisio: function() {
				self.sync_controler2globalvisio();
			}
		};
		
		G.ui.tippedCreateSafeTitle(this._el);
		
		this.events_init(true);
		this.events_updateFormType();

		// ---   initial state
		
		this.model_navStateSet(this._navStates.EMPTY);
		if(exists(this._o.planningId) && this._o.planningId > 0){
			this.model_load();
		}
	};
	
	G.ui.GVPlanning.prototype.events_updateFormType = function(){
		var self = this;
		/** @type {boolean} */
		var old_uxFormType = this._uxFormType;
		/** @type {G.vo.ResponsiveBreak} */
		var rbk = G.Responsive.responsiveBreak;

		this._uxFormType = !rbk || rbk.id === 'tablet' || rbk.id === 'mobile' || G.ui.isTouch;

		this._el.toggleClass('gvp--form-type', this._uxFormType);
		
		if(old_uxFormType != this._uxFormType){
			this._p.dslPlanning.model_jqoGet().find('.gvdsl-row.item--expanded').each(function(index, row){
				self._p.dslPlanning.form_toggleDayDisplay($(row), false);
			});
		}
	};
	
	/**
	 * Enables/disables interactions.
	 * @param status {boolean} target status
	 */
	G.ui.GVPlanning.prototype.events_init = function(status){
		if(status == false){
			this._el
				.off('click', 'nav.gvp-nav-sections a' , this._cbs.model_navStateSet_fromLink)
				.off('change', 'select.gvp-nav-sections', this._cbs.model_navStateSet_fromSelect)
				.off('GVDaySlices:edited', '.gvp-section[data-section-id="state_planning"] .gvdsl', this._cbs.model_navStateSet_fromEditedState)
				.off('click', 'button.gvp-planning-save', this._cbs.model_planningStore)
				.off('click', 'button.gvp-planning-restore', this._cbs.model_restore)
				.off('click', 'button.gvp-data-sync-gv2c', this._cbs.sync_globalvisio2controler)
				.off('click', 'button.gvp-data-sync-c2gv', this._cbs.sync_controler2globalvisio)
			;
			
			$(document).off('responsiveBreak', this._cbs.events_updateFormType);
			
			this._p.dslPlanning.events_init(status);
			this._p.excal.events_init(status);
		}
		else{
			this.events_init(false);

			this._el
				.on('click', 'nav.gvp-nav-sections a' , this._cbs.model_navStateSet_fromLink)
				.on('change', 'select.gvp-nav-sections', this._cbs.model_navStateSet_fromSelect)
				.on('GVDaySlices:edited', '.gvp-section[data-section-id="state_planning"] .gvdsl', this._cbs.model_navStateSet_fromEditedState)
				.on('click', 'button.gvp-planning-save', this._cbs.model_planningStore)
				.on('click', 'button.gvp-planning-restore', this._cbs.model_restore)
				.on('click', 'button.gvp-data-sync-gv2c', this._cbs.sync_globalvisio2controler)
				.on('click', 'button.gvp-data-sync-c2gv', this._cbs.sync_controler2globalvisio)
			;
			
			$(document).on('responsiveBreak', this._cbs.events_updateFormType);
			
			this._p.dslPlanning.events_init(status);
			this._p.excal.events_init(status);

			G.ui.initSelect2(this._p.mainMenuSelect);
			G.ui.tippedInit(this._el);
		}
	};

	G.ui.GVPlanning.prototype.locale_stateBlockBuild = function(stateUID){
		var state;

		state = this.model_sliceStateGet(stateUID);
		return $('<span>' + this.locale('dslstate_' + state.uid) + '</span>')
			.css({
				'padding': '2px 4px',
				'border-radius': '2px',
				'background-color': state.color,
				'color': state.altColor
			})[0].outerHTML;
	};
	/**
	 * Converts miscalleneous complex strings such as range titles
	 * ie: "~~dsl__range_tooltip~~STATE|occupation|START|11:45|END|11:59"
	 *
	 * @param pointer {string}
	 * @param dsl {G.ui.GVDaySlices}
	 * @private
	 * @return {string|Array}
	 */
	G.ui.GVPlanning.prototype.locale = function(pointer, dsl){
		var i, ilen, loc, pointerTokens;

		pointerTokens = isstring(pointer) ? pointer.split('~~') : [null];

		loc = G.config.LOCALE_RETRIEVE('gvplanning.' + pointerTokens[0]);

		// replace included tokens
		if(pointerTokens.length > 1) {
			pointerTokens = pointerTokens[1].split('|');
			ilen = pointerTokens.length;
			if (ilen > 1 && ilen % 2 == 0) {
				for (i = 0; i < ilen; i += 2) {
					loc = (pointerTokens[i] == 'STATE') ?
						loc.replace('##STATE##', this.locale_stateBlockBuild(pointerTokens[i + 1])) :
						loc.replace('##' + pointerTokens[i] + '##', pointerTokens[i + 1]);
				}
			}
		}

		// replace ##CUR_STATE## pattern
		if(dsl)
			loc = loc.replace('##CUR_STATE##', this.locale_stateBlockBuild(dsl._state.uid));

		return loc;
	};
	
	/**
	 * Getter to planning jQuery element.
	 * @return {jQuery}
	 */
	G.ui.GVPlanning.prototype.ui_elGet = function(){
		return this._el;
	};
	
	/**
	 * Completes dataset through an AJAX call on "frontend/planning/getPlanning".
	 * @param planningId {number=}
	 * @param loadPlanning {boolean=}
	 * @param exceptionYear {number=}
	 */
	G.ui.GVPlanning.prototype.model_load = function (planningId, loadPlanning, exceptionYear) {
		var navStateSafe = this._navStateCurrent;
		
		// --- consolidate parameters
		if(!exists(planningId))
			planningId = this._o.planningId;
		loadPlanning = (loadPlanning != false);
		if(!exists(exceptionYear))
			exceptionYear = this._p.excal.model_dateCalendarGet().year();
		
		var
			self = this,
			divId = self._el[0].id,
			url = G.config.SERVER + 'frontend/planning/getPlanning',
			params = {
				planning_id: planningId,
				get_hebdo: loadPlanning ? 1 : 0,
				exception_year: exceptionYear
			};

		console.log('[GVPlanning.model_load] planningId: ' + planningId, params);
		
		this.model_navStateSet(this._navStates.LOADING);
		
		$.ajax({
			url: url,
			type: 'POST',
			data: params,
			dataType: "json",
			success: function (data) {
				switch (data.status) {
					case 'error':
						showError(data.status, {
							url: url,
							params: params,
							data: data
						});
						self.model_navStateSet(self._navStates.ERROR);
						return;

					case 'success':
						if (self._o.verbose)
							console.log('[GVPlanning.model_load] Success, data: ', data);
						break;
				}

				self._o.planningId = planningId;
				self._o.planningName = data.planning_name;

				self._planningType = data.hasOwnProperty('planning_type') ? data.planning_type.toLowerCase() : '';
				switch(self._planningType){
					case 'trend':
						self._slicesStates = self._slicesStatesConfigurations.trend;
						break;
					case 'siemens_ecs':
						self._slicesStates = self._slicesStatesConfigurations.siemens_ecs;
						break;
					case 'siemens_on_off':
						self._slicesStates = self._slicesStatesConfigurations.siemens_on_off;
						break;
					case 'siemens_chauffage':
						self._slicesStates = self._slicesStatesConfigurations.siemens_chauffage;
						break;
					case 'siemens':
						self._slicesStates = self._slicesStatesConfigurations.siemens;
						break;
					case 'globalio':
					case 'sofrel':
					case 'sauter':
						self._slicesStates = self._slicesStatesConfigurations.default;
						break;
					default:
						console.warn('[GVPlanning.model_load] Unhandled "planning_type": "' + self._planningType + '"');
						self._planningType = null;
						self._slicesStates = self._slicesStatesConfigurations.default;
						break;
				}

				// hide/show exceptions calendar according to automaton type
				var planningTypesWithoutExcal = ['globalio', 'sofrel', 'sauter'];
				if (planningTypesWithoutExcal.includes(self._planningType)) {
					console.log('[GVPlanning.model_load] Remove excal ',
						'\n\t - planningType:', self._planningType,
						self._el[0].id
					);
					// Onglet desktop
					$('#' + divId + ' .__tab.mod--default[data-tab-uuid="state_excal"]').hide();
					// Option mobile
					self._p.mainMenuSelect.find('option[value="state_excal"]').hide();
				} else {
					// Onglet desktop
					$('#' + divId + ' .__tab.mod--default[data-tab-uuid="state_excal"]').show();
					// Option mobile - si tu dois la rajouter dynamiquement
					if (self._p.mainMenuSelect.find('option[value="state_excal"]').length === 0) {
						self._p.mainMenuSelect.append($(self._p.mainMenuSelectExcalOption));
					}
				}

				G.ui.initSelect2(self._p.mainMenuSelect);

				self._p.mainMenuNavItems.filter('[data-section-id="state_excal"]').toggle(!planningTypesWithoutExcal.includes(self._planningType));
				if(self._o.verbose){
					console.log('[GVPlanning.model_load] Success ',
						'\n\t - planningType:', self._planningType,
						'\n\t - slicesStates: ', self._slicesStates
					);
				}

				if (exists(data.planning)) {
					self._p.dslPlanning.model_import(data.planning, self._slicesStates);
				}

				self._p.excal.model_exceptionInit(exists(data['exceptions']) ? data['exceptions'] : [], exists(data.planning));
				console.log('\t - exceptions:', self._p.excal._exceptions);

				if (data.write_allowed === false) {
					self._el.addClass('gvp--read-only');
					// Onglet desktop
					$('#' + divId + ' .__tab.mod--default[data-tab-uuid="state_data_sync"]').hide();
					// Option mobile
					self._p.mainMenuSelect.find('option[value="state_data_sync"]').hide();
				} else {
					self._el.removeClass('gvp--read-only');
					// Onglet desktop
					$('#' + divId + ' .__tab.mod--default[data-tab-uuid="state_data_sync"]').show();
					// Option mobile
					self._p.mainMenuSelect.find('option[value="state_data_sync"]').show();
				}
				G.ui.initSelect2(self._p.mainMenuSelect);

				if(loadPlanning && self.model_navCoreStateGet() == null){
					self.model_navStateSet(self._navStates.PLANNING);
				}
				else{
					self.model_navStateSet(self.model_navCoreStateGet(navStateSafe));
				}
			},
			error: function (xhr, textStatus, errorThrown) {
				showError('[GVPlanning.model_load] An error occurred', {
					url: url,
					params: params,
					xhr: xhr,
					textStatus: textStatus,
					errorThrown: errorThrown
				});
				self.model_navStateSet(self._navStates.ERROR);
			}
		})
	};
	/**
	 * Stores dataset through an AJAX call on "frontend/planning/storePlanning".
	 */
	G.ui.GVPlanning.prototype.model_planningStore = function(){
		var
			self = this,
			url = G.config.SERVER + 'frontend/planning/storePlanning',
			params = {
				planning_id: this._o.planningId,
				hebdo: JSON.stringify(this._p.dslPlanning.model_getPlanning().days)
			};
		var planningId = this._o.planningId;
		
		console.log('[GVPlanning.model_planningStore] params: ', params);
		
		self.model_navStateSet(this._navStates.PLANNING_SAVING);
		
		$.ajax({
			url: url,
			type: 'POST',
			data: params,
			dataType: "json",
			error: function (xhr, textStatus, errorThrown) {
				showError('[GVPlanning.model_planningStore] An error occurred', {
					url: url,
					params: params,
					xhr: xhr,
					textStatus: textStatus,
					errorThrown: errorThrown
				});
				self.model_navStateSet(self._navStates.ERROR);
			},
			success: function (data) {
				if (self._o.verbose){
					console.log('[GVPlanning.model_planningStore] Success, data: ', data);
				}
				
				if(data.status == 'error'){
					showError(data.error, {
						url: url,
						params: params,
						data: data
					});
					return;
				}
				
				if(data.status == 'warning'){
					showError(data.error, {
						url: url,
						params: params,
						data: data
					});
					return;
				}
				
				self._p.dslPlanning.model_merge();
				self.model_navStateSet(self._navStates.PLANNING);
				self.model_setSyncFlag(true);
				// console.log( '#state-planning-' + planningId );
				$('#state-planning-' + planningId ).show();
			}
		});
	};

	G.ui.GVPlanning.prototype.model_uxFormTypeGet = function(){
		return this._uxFormType;
	};
	G.ui.GVPlanning.prototype.model_getSlicesStates = function(){
		return this._slicesStates;
	};
	G.ui.GVPlanning.prototype.model_getPlanningId = function () {
		return this._o.planningId;
	};
	
	/**
	 * Retrieves slice state settings according to passed-in input.
	 * @param input {Event|_SliceState|*|string}
	 * @return {?_SliceState}
	 */
	G.ui.GVPlanning.prototype.model_sliceStateGet = function (input) {

		// retrieve state from event
		if (typeof input == 'object') {
			// ---> from event
			if (input.hasOwnProperty('currentTarget')) {
				input = $(input.currentTarget).attr('data-state');
			}
			// ---> from value object (ducktyping)
			else if (input.hasOwnProperty('uid') && input.hasOwnProperty('color')) {
				return input;
			}
		}

		// prevent illegal calls
		if (input == null || typeof input != 'string') {
			console.warn('[GVPlanning.model_sliceStateGet] Unable to retrieve state from passed-in parameter: ', input, (typeof input == 'object'));
			return null;
		}

		if(input == '')
			return this._slicesStateDefault;
		for (var i = 0, iLen = this._slicesStates.length; i < iLen; ++i) {
			if (this._slicesStates[i].uid == input) {
				return this._slicesStates[i];
			}
		}

		console.log('[GVPlanning.model_sliceStateGet] Unable to retrieve state from UID: "' + input + '" in:', this._slicesStates);
		return null;
	};
	/**
	 * Returns current state of required synchronization flag.
	 * @return {boolean}
	 */
	G.ui.GVPlanning.prototype.model_getSyncFlag = function(){
		return this._syncFlag;
	};
	/**
	 * Sets current state of required synchronization flag.
	 * @param status {boolean} target status
	 */
	G.ui.GVPlanning.prototype.model_setSyncFlag = function(status){
		this._syncFlag = status;
		this._p.mainMenuNavItems.filter('[data-section-id="' + this._navStates.DATA_SYNC + '"]').toggleClass('status-warning', this._syncFlag);
		
		var rbk = G.Responsive.responsiveBreak;
		if(rbk && (rbk.id === 'tablet' || rbk.id === 'mobile')){
			this.model_navStateSet(this._navStates.DATA_SYNC);
		}
	};

	G.ui.GVPlanning.prototype.model_navStatesGet = function () {
		return this._navStates;
	};
	G.ui.GVPlanning.prototype.model_navStateGet = function () {
		return this._navStateCurrent;
	};
	G.ui.GVPlanning.prototype.model_navCoreStateGet = function (state) {
		var s = this._navStates;

		if(state == undefined)
			state = this._navStateCurrent;

		switch(state){

			case s.PLANNING:
			case s.PLANNING_EDITED:
			case s.PLANNING_SAVING:
				return s.PLANNING;

			case s.EXCAL:
			case s.EXCAL_EDIT:
			case s.EXCAL_EDITED:
			case s.EXCAL_SAVING:
				return s.EXCAL;

			case s.DATA_SYNC:
				return s.DATA_SYNC;

			default:
				console.warn('[GVPlanning.model_navCoreStateGet] Illegal state: "' + state + '"');
				return null;
		}
	};
	G.ui.GVPlanning.prototype.model_navStateRestoreSelect = function(state){
		var
			self = this,
			s = self._navStates,
			displayState = function(state){
				self._p.mainMenuNavItems.filter('[data-section-id="' + state + '"]').addClass('status-active');
				self._p.sections.filter('[data-section-id="' + state + '"]').addClass('status-active');
				self._p.mainMenuSelect
					.val(state)
					.trigger('change.select2');
		};
		
		self._p.mainMenuNavItems.removeClass('status-active');
		self._p.sections.removeClass('status-active');
		
		switch (state) {
			case s.PLANNING:
			case s.PLANNING_EDITED:
			case s.PLANNING_SAVING:
				displayState(s.PLANNING);
				break;
			
			case s.DATA_SYNC:
				displayState(s.DATA_SYNC);
				break;
			
			case s.EXCAL:
			case s.EXCAL_EDIT:
			case s.EXCAL_EDITED:
			case s.EXCAL_SAVING:
				displayState(s.EXCAL);
				break;
			
			case s.ERROR:
				self._p.sectionError.addClass('status-active');
				self._p.mainMenuSelect.toggle(false);
				break;
			
			default:
				self._p.sectionLoading.addClass('status-active');
				break;
		}
		
		self._navStateCurrent = state;
		self._el.attr('data-state', state);
	};
	G.ui.GVPlanning.prototype.model_navStateSet = function (targetState, forceReset) {
		var
			loc,
			s = this._navStates;

		// ---   cancel useless calls
		if (targetState == this._navStateCurrent && forceReset != true) {
			if(this._o.verbose)
				console.log('[GVPlanning.model_navStateSet] Cancel useless state change, current and target states are identical: "' + targetState + '"');
			return;
		}
		if(this._o.verbose)
			console.log('[GVPlanning.model_navStateSet] Define state to: "' + targetState + '"', s);


		// ---   DISPLAY:
		switch (targetState) {

			case s.ERROR:
				break;

			case s.LOADING:
				if(this._navStateCurrent == s.EXCAL_EDITED){
					loc = G.config.LOCALE_RETRIEVE('gvplanning.excal__quit_no_save').toString();
					if (!window.confirm(loc)) {
						this._p.excal.model_dateCalendarSet(this._p.excal.model_dateCalendarGet());
						this.model_navStateRestoreSelect(this._navStateCurrent);
						return;
					}
				}
				break;

			case s.EMPTY:
				// ---   model
				this._exceptions = [];
				this._slicesStates = this._slicesStatesConfigurations.default;
				// ---   UI
				this._p.excal.model_exceptionInit(this._exceptions);
				this._p.dslPlanning.model_import([], this._slicesStates);
				break;

			case s.PLANNING:
				switch(this._navStateCurrent){
					case s.EXCAL_EDITED:
						loc = G.config.LOCALE_RETRIEVE('gvplanning.excal__quit_no_save').toString();
						if (!window.confirm(loc)) {
							this.model_navStateRestoreSelect(this._navStateCurrent);
							return;
						}
						break;
					case s.PLANNING_EDITED:
						if(this._p.dslPlanning.model_editedGet()){
							console.log('\t[GVPlanning.model_navStateSet] Cancel edited status loss from: ' + this._navStateCurrent + ' to: ' + targetState);
							return;
						}
						break;
				}

				this._el.find('.gvp-planning-restore, .gvp-planning-save').addClass('uicomp--disabled');
				this._p.dslPlanning.model_restore();
				break;

			case s.PLANNING_EDITED:
				if (!this.model_navStateAllowChange(targetState, s.PLANNING))
					return;
				this._el.find('.gvp-planning-restore, .gvp-planning-save').removeClass('uicomp--disabled');
				break;

			case s.PLANNING_SAVING:
				if (!this.model_navStateAllowChange(targetState, s.PLANNING_EDITED))
					return;
				// tweak footer display -> CSS
				// lock interface -> CSS
				break;

			case s.EXCAL:
				loc = G.config.LOCALE_RETRIEVE('gvplanning.quit_no_save').toString();
				if (this._navStateCurrent == s.PLANNING_EDITED && !window.confirm(loc)) {
					this.model_navStateRestoreSelect(this._navStateCurrent);
					return;
				}
				else{
					this._p.dslPlanning.model_restore();
				}

				this._p.excal.model_dateSelDelete();
				this._p.excal.ui_showEditor(false);
				break;

			case s.EXCAL_EDIT:
				// if (!this.model_navStateAllowChange(targetState, s.EXCAL, s.EXCAL_EDIT, s.EXCAL_EDITED, s.EXCAL_SAVING))
					// return;

				this._el.find('.gvp-excal-save, .gvp-excal-restore').addClass('uicomp--disabled');
				this._p.excal.ui_showEditor(true);
				this._p.excal.ux_dslGet().form_toggleDayDisplay(this._p.excal.ux_dslGet().ux_rowGet(), true);
				break;

			case s.EXCAL_EDITED:
				if (!this.model_navStateAllowChange(targetState, s.EXCAL_EDIT, s.EXCAL_SAVING))
					return;
				this._el.find('.gvp-excal-save, .gvp-excal-restore').removeClass('uicomp--disabled');
				break;

			case s.EXCAL_SAVING:
				if (!this.model_navStateAllowChange(targetState, s.EXCAL_EDITED))
					return;
				// tweak excal footer display -> CSS
				// lock interface -> CSS
				break;

			case s.DATA_SYNC:

				loc = G.config.LOCALE_RETRIEVE('gvplanning.excal__quit_no_save').toString();
				if(this._navStateCurrent == s.EXCAL_EDITED && !window.confirm(loc)){
					this.model_navStateRestoreSelect(this._navStateCurrent);
					return;
				}
				
				loc = G.config.LOCALE_RETRIEVE('gvplanning.quit_no_save').toString();
				if(this._navStateCurrent == s.PLANNING_EDITED && !window.confirm(loc)){
					this.model_navStateRestoreSelect(this._navStateCurrent);
					return;
				}
				
				break;
		}

		// ---   DISPLAY: menu and section
		this.model_navStateRestoreSelect(targetState);
	};
	G.ui.GVPlanning.prototype.model_navStateAllowChange = function () {
		var
			s,
			args = Array.prototype.slice.call(arguments),
			state = args.shift(),
			allowedStates = args || [];

		s = allowedStates.indexOf(this._navStateCurrent) >= 0;
		if (!s)
			console.warn('[GVPlanning._setStateIllegal] Illegal state change from: "' + this._navStateCurrent + '" to: "' + state + '"');
		return s;
	};
	
	G.ui.GVPlanning.prototype.sync_log = function(message, status, context){
		var
			self = this;
		if(this._navStateCurrent != this._navStates.DATA_SYNC){
			switch (status) {
				case 'error':
					showError(message, context);
					break;
				case 'success':
					showSuccess(message);
					break;
				default:
					showInfo(message);
					break;
			}
		}
		this._p.syncLogger.open(true);
		this._p.syncLogger.add(status, 'planning ' + self._o.planningName, message);
	};
	G.ui.GVPlanning.prototype.sync_globalvisio2controler = function(){
		var
			self = this,
			url,
			params = {
				type: this._planningType,
				planningId: this._o.planningId
			};
		
		if(this._planningType == 'globalio') {
			
			url = G.config.SERVER + 'frontend/planning/writeplanninghoraireglobalio';
			
			$.ajax({
				url: url,
				type: 'post',
				data: params,
				datatype: 'json',
				error: function (xhr, textStatus, errorThrown) {
					self.sync_log('An error occurred', 'error', {
						url: url,
						params: params,
						xhr: xhr,
						textStatus: textStatus,
						errorThrown: errorThrown
					});
				},
				beforeSend: function () {
					self.sync_log(G.config.LOCALE_RETRIEVE('general.writingInProgress'), 'info');
				},
				success: function (data) {
					if (data.status == "error"){
						self.sync_log(data.error, 'error');
					}
					else if (data.status == 'success') {
						var voieModbus = 'modbus';
						if( typeof(data.voie) != 'undefined' && data.voie == 2  ){
							var voieModbus = 'modbus2';
						}
						self.sync_log(G.config.LOCALE_RETRIEVE('general.commandsSent'), 'info');
						self.sync_checkWrite_globalio(data.adresseip, data.frame, data.equipementid, voieModbus);
					}
					else if (data.status == 'notify') {
						self.sync_log(G.config.LOCALE_RETRIEVE('general.commandsSent'), 'info');
						self.sync_log(G.config.LOCALE_RETRIEVE('general.notifyMail'), 'info');
					}
				}
			});
		}
		else if(this._planningType == 'siemens_chauffage' || this._planningType == 'siemens_ecs' || this._planningType == 'siemens_on_off' )  {
			url = G.config.SERVER + 'frontend/planning/writeplanninghorairesiemens';
			
			$.ajax({
				url: url,
				type: 'post',
				data: params,
				datatype: 'json',
				error: function (xhr, textStatus, errorThrown) {
					self.sync_log('An error occurred', 'error', {
						url: url,
						params: params,
						xhr: xhr,
						textStatus: textStatus,
						errorThrown: errorThrown
					});
				},
				beforeSend: function () {
					self.sync_log(G.config.LOCALE_RETRIEVE('general.writingInProgress'), 'info');
				},
				success: function (data) {
					if (data.status == "error"){
						self.sync_log(data.error, 'error');
					}
					else if (data.status == 'success') {
						self.sync_log(G.config.LOCALE_RETRIEVE('general.commandsSent'), 'info');
						self.sync_log(G.config.LOCALE_RETRIEVE('general.notifyMail'), 'info');
						// self.sync_checkWrite_globalio(data.adresseip, data.frame, data.equipementid);
					}
				}
			});
		}
		else {
			url = G.config.SERVER + 'frontend/planning/writeplanninghoraire';

			$.ajax({
				url: G.config.SERVER + 'apigv/planning/write',
				headers: {
					"Content-Type": "application/json",
					"Authorization": "Bearer "+G.model.userApiKey
				},
				type: 'POST',
				dataType: 'json',
				data: JSON.stringify(params),
				error: function (xhr, textStatus, errorThrown) {
					self.sync_log('Ajax error', 'error', {url: this.url, error: errorThrown});
				},
				beforeSend: function () {
					self.sync_log(G.config.LOCALE_RETRIEVE('general.writingInProgress'), 'info');
				},
				success: function (data) {
					if (data.status == "error"){
						self.sync_log(data.error, 'error');
						return;
					}
					self.sync_checkDevio(self._o.planningId, true);
				}
			});
		}
	};
	G.ui.GVPlanning.prototype.sync_controler2globalvisio = function(){
		var self = this;

		$.ajax({
			url: G.config.SERVER + 'apigv/planning/read/' + this._o.planningId,
			headers: {
				"Content-Type": "application/json",
				"Authorization": "Bearer "+G.model.userApiKey
			},
			type: 'GET',
			dataType: 'json',
			error: function (xhr, textStatus, errorThrown) {
				self.sync_log('Ajax error: ' + textStatus, 'error', {
					url: this.url,
					textStatus: textStatus,
					xhr: xhr,
					error: errorThrown
				});
			},
			beforeSend: function () {
				self.sync_log(G.config.LOCALE_RETRIEVE('general.writingInProgress'), 'info');
			},
			success: function (response) {
				if (response.status == "error"){
					self.sync_log(response.error, 'error');
					return;
				}

				if(self._planningType == 'globalio'){
					self.sync_log(G.config.LOCALE_RETRIEVE('gvplanning.sync_success'), 'success');
					self.model_load(self._o.planningId, true, moment().year());
				}
				else{
					var host = (typeof(response.response.host) != 'undefined') ? response.response.host : '';
					self.sync_checkDevio(self._o.planningId, false, host);
				}
			}
		});
	};

	G.ui.GVPlanning.prototype.sync_checkDevio = function(planningId, isWrite, host) {
		var self = this;

		isWrite = isWrite != false;

		$.ajax({
			url: G.config.SERVER + 'apigv/planning/checklectureph/' + this._o.planningId,
			headers: {
				"Content-Type": "application/json",
				"Authorization": "Bearer "+G.model.userApiKey
			},
			type: 'POST',
			dataType: 'json',
			data: JSON.stringify({
				planningId: this._o.planningId,
				mode: isWrite ? 'write' : 'read',
				host: host
			}),
			error: function (xhr, textStatus, errorThrown) {
				self.sync_log('Ajax error: ' + textStatus, 'error', {
					url: this.url,
					xhr: xhr,
					textStatus: textStatus,
					error: errorThrown
				});
			},
			success: function (data) {
				if (data.status == 'error'){
					self.sync_log(data.error, 'error');
				}
				else if (data.response.status == 'none') {
					self.sync_log(data.response.info, 'info');
					setTimeout(function () {
						self.sync_checkDevio(planningId, isWrite, host);
					}, 4000);
				}
				else if (data.response.status == 'success'){
					self.sync_log(data.response.info, 'success');
					self.sync_log(G.config.LOCALE_RETRIEVE('gvplanning.sync_success'), 'success');
					$('#state-planning-' + self._o.planningId ).hide();
					self.model_load(self._o.planningId, true, moment().year());
				}
			}
		});
	};

	G.ui.GVPlanning.prototype.sync_checkWrite_globalio = function(ipAddress, frame, equipementId, voieModbus) {
		var self = this;

		io.connect('https://io-02.global-visio.com:22443', { transports: [ 'websocket' ], secure: true })
			.on('connect', function () {
				self.sync_log(G.config.LOCALE_RETRIEVE('general.openedConnection'), 'info');
			})
			.on('connect_error', function () {
				self.sync_log(G.config.LOCALE_RETRIEVE('general.impossibleConnection'), 'error');
			})
			.on('return', function (jsonResponse) {
				var response = JSON.parse(jsonResponse);
				self.sync_checkWriteResponse_globalio(response, equipementId);
			})
			.emit(voieModbus, JSON.stringify({
				ip: ipAddress,
				cmd: frame
			}));
	};
	G.ui.GVPlanning.prototype.sync_checkWriteResponse_globalio = function(data, equipementId){
		var self = this;
		$.ajax({
			url: G.config.SERVER + 'apigv/globalio/response',
			headers: {
				"Content-Type": "application/json",
				"Authorization": "Bearer "+G.model.userApiKey
			},
			type: 'POST',
			dataType: 'json',
			data: JSON.stringify({
				response: JSON.stringify(data),
				equipementId: equipementId
			}),
			success: function (response) {
				if (response.status == "error"){
					self.sync_log(response.message, 'error');
				}
				else if (response.status == "writeok"){
					self.sync_log(response.response.info, 'success');
				}
				else if (response.status == "success"){
					self.sync_log(response.response.info, 'info');
				}
			}
		});
	};


	/**
	 * @static
	 * @private
	 */
	G.ui.GVPlanning._Instances = {};

	/**
	 * @static
	 */
	G.ui.GVPlanning.GetInstance = function(elJqo, options){
		var
			instance,
			id;

		// console.warn('G.ui.GVPlanning.GetInstance', elJqo, options);

		id = elJqo.attr('id');
		if(G.ui.GVPlanning._Instances.hasOwnProperty(id)){
			instance = G.ui.GVPlanning._Instances[id];
		}
		else{
			instance = new G.ui.GVPlanning(elJqo, options);
			G.ui.GVPlanning._Instances[id] = instance;
		}
		
		return instance;
	};
}
var G;
var proto;

if (!G)
	G = {};
if (!G.ui)
	G.ui = {};

/**
 * Defines which section is under user focus during scroll process
 */
G.ui.SectionWatcher = function (status, activeClassName) {
	this._activeClassName = (activeClassName === undefined) ? "state--active" : activeClassName;
	this._updateFromScrollCallback = this._updateFromScroll.bind(this);

	this.enable(status !== false);
}

proto = G.ui.SectionWatcher.prototype;

/** Defines whether instance must watch for scroll events to set active section. */
proto.enable = function (status) {
	status
		? window.addEventListener('scroll', this._updateFromScrollCallback)
		: window.removeEventListener('scroll', this._updateFromScrollCallback);

	// console.log('[SectionWatcher] enable: ', status);
	if (status) {
		this._updateFromScroll();
	}
}

/** @private */
proto._updateFromScroll = function () {
	var wrapper = document.getElementById('o-wrapper');
	var sections = wrapper.querySelectorAll(':scope > section');

	if (sections.length === 1) {
		this._setActiveSection(sections[0]);
		return;
	}

	var maxOverlap;
	sections.forEach(function (el) {
		var rect = el.getBoundingClientRect();
		var fullOverlap = Math.max(rect.bottom, document.documentElement.clientHeight) - Math.min(rect.y, 0);
		var overlap = Math.max(0, (rect.bottom - rect.y + document.documentElement.clientHeight) - fullOverlap);
		if (!maxOverlap || overlap > maxOverlap.value) {
			maxOverlap = {
				section: el,
				value: overlap
			};
		}
	});

	this._setActiveSection(maxOverlap.section);
}

/** @private */
proto._setActiveSection = function (section) {
	var self = this;
	var wrapper = document.getElementById('o-wrapper');
	var sections = wrapper.querySelectorAll(':scope > section');

	if (section === this._activeSection) {
		//console.log('Cancel active section update');
		return;
	}

	sections.forEach(function (el) {
		if (el !== section && el.classList.contains(self._activeClassName)) {
			el.classList.remove(self._activeClassName);
			el.dispatchEvent(new Event('section_blur'));
		}
	})

	this._activeSection = section;
	if (this._activeSection) {
		this._activeSection.classList.add(this._activeClassName);
		this._activeSection.dispatchEvent(new Event('section_focus'));
	}
}
var G, p;


if (!G)
	G = {};

if (!G.ui)
	G.ui = {};

if (!G.ui.SectionTabs) {

	G.ui.SectionTabsInit = function () {

		// --- find all sectiontabs occurences
		var sectionTabsInstances = $('.section-body > .section-tabs');
		sectionTabsInstances.each(function (index, sectiontabsEl) {
			new G.ui.SectionTabs(sectiontabsEl);
		});

		new G.ui.SectionWatcher(true);
	}
}

G.ui.SectionTabs = function (tabRoot) {
	var self = this;

	this._tabRoot = $(tabRoot);
	this._section = this._tabRoot.closest('section');
	this._section.data('SectionTabs', this);
	this._sectionId = this._section.attr('id');
	this._tabRoot.addClass('mod--initialized');
	// Un bloc d'onglets imbrique dans le contenu d'un autre bloc (ex. le planning
	// affiche dans l'onglet "planning horaire" de la fiche equipement) partage le
	// meme <section> que son parent : chaque nav ne pilote que ses propres contenus
	// et seul le bloc racine ecrit l'onglet courant dans l'URL.
	this._tabsScope = this._tabRoot.closest('.__content');
	this._urlDriven = this._tabsScope.length === 0;
	this._contentRoot = this._resolveContentRoot();

	// --- clear old state preview for mobile display
	this._tabRoot.off('click', '.__menu-preview .__summary');
	this._tabRoot.find(".__menu-preview").remove();

	// --- create state preview for mobile display
	this._statePreview = $(
		'<div class="__menu-preview">'
		+ '<div class="__summary">'
		+ '<div class="uicomp__icon uicomp--white"><i class="fal fa-ellipsis-v"></i></div>'
		+ '<div class="__label"></div>'
		+ '</div>'
		+ '<div class="__static-tabs"></div>'
		+ '</div>'
	);
	this._tabRoot.prepend(this._statePreview);

	// --- copy static buttons for mobile display
	this._statePreview
		.find('.__static-tabs')
		.append(
			this._tabRoot.find('.__tab.mod--static').clone()
		);

	// --- initialize tab change behaviour
	this._tabRoot.on('click', '[data-tab-uuid]', function (e) {
		self.setTabFocus($(e.target).closest('.__tab').attr('data-tab-uuid'));
	});

	// --- open menu on narrow- display
	/*this._tabRoot.on('click', '.__menu-preview .__summary', function () {
		self._openTabsMenu();
	});*/

	// --- focus
	this._section.on('section_blur', function () {
		self._setFocus(false);
	});
	this._section.on('section_focus', function () {
		self._setFocus(true);
	});

	// --- set active tab
	// Prioritise l'onglet indique dans l'URL au chargement de la page.
	var urlTabUuid = this._urlDriven ? this._getTabUuidFromUrl() : null;
	var initTab = this._findTabByUuid(urlTabUuid);
	var hasValidUrlTab = initTab.length > 0;
	if (initTab.length === 0) {
		initTab = this._tabRoot.find('.__tabs-group .__tab.mod--active');
	}
	if (initTab.length === 0) {
		initTab = this._tabRoot.find('.__tabs-group .__tab');
	}
	var initTabUuid = initTab.first().attr('data-tab-uuid');
	// Aucun onglet dans l'URL : l'onglet retenu par defaut est active comme s'il
	// avait ete clique, ce qui inscrit aussi le parametre dans l'URL pour que le
	// rechargement de la page conserve bien le meme onglet.
	// Si l'URL porte deja un tab inconnu de cette instance, on ne l'ecrase pas :
	// il peut appartenir a un autre bloc d'onglets de la page.
	this.setTabFocus(initTabUuid, !hasValidUrlTab && !urlTabUuid);
	// Convertit les anciennes URL ?tab=...#route vers #route?tab=....
	if (
		hasValidUrlTab
		&& window.location.hash
		&& new window.URLSearchParams(window.location.search).has(G.ui.SectionTabs.URL_PARAMETER)
	) {
		this._updateTabUuidInUrl(urlTabUuid);
	}

	// --- open/close tab menu on narrow- display
	this._tabRoot
		.find('.__summary')
		.on('click', function () {
			self._openTabsMenu();
		});
}

G.ui.SectionTabs.URL_PARAMETER = 'tab';

p = G.ui.SectionTabs.prototype;


// Isole les conteneurs de contenus pilotes par ce bloc d'onglets.
// Un conteneur appartient au bloc quand il se situe dans le meme contenu parent
// que la navigation : les conteneurs du bloc racine ne sont imbriques dans aucun
// .__content, ceux d'un bloc imbrique partagent le .__content de leur navigation.
/** @private */
p._resolveContentRoot = function () {
	var tabsScope = this._tabsScope;

	return this._section
		.find('.section-tabs__container')
		.filter(function () {
			var containerScope = $(this).closest('.__content');

			return tabsScope.length === 0
				? containerScope.length === 0
				: containerScope.is(tabsScope);
		});
}

// Liste les contenus pilotes par ce bloc d'onglets.
// find() traverse les blocs imbriques : on ne garde que les contenus directement
// rattaches au conteneur de ce bloc, sinon activer un onglet du bloc parent
// desactiverait au passage le contenu courant du bloc imbrique.
/** @private */
p._ownedContents = function () {
	var contentRoot = this._contentRoot;

	return contentRoot
		.find('.__content')
		.filter(function () {
			return $(this).closest('.section-tabs__container').is(contentRoot);
		});
}

// Retrouve un onglet disponible a partir de son identifiant.
/** @private */
p._findTabByUuid = function (uuid) {
	if (!uuid) {
		return $();
	}

	var tab = this._tabRoot
		.find('.__tabs-group .__tab[data-tab-uuid]')
		.filter(function () {
			return $(this).attr('data-tab-uuid') === uuid;
		});
	var content = this._ownedContents()
		.filter(function () {
			return $(this).attr('data-tab-uuid') === uuid;
		});

	return content.length > 0 ? tab : $();
}

// Lit l'identifiant de l'onglet dans le fragment ou dans la query classique.
/** @private */
p._getTabUuidFromUrl = function () {
	if (typeof window.URLSearchParams !== 'function') {
		return null;
	}

	// Dans une page routee par fragment, tab est lu apres le #.
	var hashQueryIndex = window.location.hash.indexOf('?');
	if (hashQueryIndex !== -1) {
		var hashParameters = new window.URLSearchParams(
			window.location.hash.substring(hashQueryIndex + 1)
		);
		var hashTabUuid = hashParameters.get(G.ui.SectionTabs.URL_PARAMETER);
		if (hashTabUuid) {
			return hashTabUuid;
		}
	}

	// Sinon, conserve le format classique et la compatibilite avec les anciennes URL.
	return new window.URLSearchParams(window.location.search).get(G.ui.SectionTabs.URL_PARAMETER);
}

// Met a jour l'onglet dans l'URL sans ajouter d'entree dans l'historique.
/** @private */
p._updateTabUuidInUrl = function (uuid) {
	if (
		typeof window.URLSearchParams !== 'function'
		|| !window.history
		|| typeof window.history.replaceState !== 'function'
	) {
		return;
	}

	var urlParameters = new window.URLSearchParams(window.location.search);
	var normalizedPathname = window.location.pathname.replace(/\/{2,}/g, '/');
	var hash = window.location.hash;
	var updatedUrl;

	if (hash) {
		// Place tab dans le fragment sans supprimer les autres parametres.
		urlParameters.delete(G.ui.SectionTabs.URL_PARAMETER);

		var hashQueryIndex = hash.indexOf('?');
		var hashPath = hashQueryIndex === -1 ? hash : hash.substring(0, hashQueryIndex);
		var hashParameters = new window.URLSearchParams(
			hashQueryIndex === -1 ? '' : hash.substring(hashQueryIndex + 1)
		);
		hashParameters.set(G.ui.SectionTabs.URL_PARAMETER, uuid);

		updatedUrl = normalizedPathname
			+ (urlParameters.toString() ? '?' + urlParameters.toString() : '')
			+ hashPath
			+ '?' + hashParameters.toString();
	}
	else {
		// Sans fragment, tab reste un parametre classique de la page.
		urlParameters.set(G.ui.SectionTabs.URL_PARAMETER, uuid);
		updatedUrl = normalizedPathname + '?' + urlParameters.toString();
	}

	window.history.replaceState(window.history.state, document.title, updatedUrl);
}


/** @private */
p._setFocus = function (status) {
	status = status === true;
	if (!status) {
		this._openTabsMenu(false);
	}
}

/** @private */
p._updateMenuSummary = function () {
	var
		sectionTitle = this._section.find('header.section-header h2').children().first().text(),
		tabTitle = this._tabRoot.find('.__tab.mod--active span').first().text();

	this._statePreview.find('.__summary .__label').html(
		'<div class="__section-summary">' + sectionTitle + '</div>'
		+ '<div class="__tab-summary">' + tabTitle + '</div>'
	);
}

/** @private */
p._lockPageScroll = function (status) {
	if (!isbool(status)) {
		status = $('body').hasClass('hud-nav-mode--closed');
	}
	$('body').toggleClass('hud-nav-mode--closed', !status);
}

/** @private */
p._openTabsMenu = function (status) {
	if (status === undefined) {
		status = !this._tabRoot.hasClass('mod--opened');
	}

	// console.log('[SectionTabs._openTabsMenu] status: ', status);

	this._tabRoot.toggleClass('mod--opened', status);

	this.setOverlayFocus(null);

	this._lockPageScroll(status);
}

p.setOverlayFocus = function (uuid) {
	var status = (uuid !== undefined) && (uuid !== null);
	var overlayPanels = $('.section-body-overlay[data-section-overlay-uuid]');

	// toogle status if panel is already opened
	if (status) {
		status = !overlayPanels
			.filter('[data-section-overlay-uuid="' + uuid + '"]')
			.hasClass('mod--active');
	}

	overlayPanels.removeClass('mod--active');
	if (status) {
		overlayPanels.filter('[data-section-overlay-uuid="' + uuid + '"]')
			.addClass('mod--active');
	}
	this._section
		.toggleClass('mod--overlay', status);

	this._lockPageScroll(status);
}

p.setTabFocus = function (uuid, updateUrl) {
	if (!uuid)
		return;

	var tabs = this._tabRoot
		.find('[data-tab-uuid]')
		.filter(function () {
			return $(this).attr('data-tab-uuid') === uuid;
		});
	var ownedContents = this._ownedContents();
	var contents = ownedContents
		.filter(function () {
			return $(this).attr('data-tab-uuid') === uuid;
		});

	if (tabs.length === 0)
		return;

	this._tabRoot
		.find('[data-tab-uuid]')
		.removeClass('mod--active');
	tabs.addClass('mod--active');

	ownedContents.removeClass('mod--active');
	contents.addClass('mod--active');

	// Seul le bloc racine ecrit dans l'URL : un bloc imbrique ecraserait l'onglet
	// de son parent, le parametre etant commun a toute la page.
	if (updateUrl !== false && this._urlDriven) {
		this._updateTabUuidInUrl(uuid);
		$(window).trigger('sectionTabs.locationChanged');
	}

	/*this._section
		.get(0)
		.scrollIntoView({
			behavior: 'auto',
			block: 'start',
			inline: 'start',
		});*/

	this._updateMenuSummary();
	this._openTabsMenu(false);
	this.setOverlayFocus(null);
}

var G;

if (!G) {
    G = {};
}

if (!G.ui) {
    G.ui = {};
}

G.ui.GVGenericSwal2 = class {
    constructor(swalConfig = {}) {
        this.defaultConfig = Object.freeze({
            icon: undefined,
            animation: true,
            showCloseButton: true,
            showCancelButton: true,
            showConfirmButton: true,
            reverseButtons: true,
            customClass: {
                closeButton: 'uicomp__button uicomp--transparent',
                input: 'uicomp__input',
                inputLabel: 'uicomp__label',
                confirmButton: 'uicomp__button uicomp--brand',
                denyButton: 'uicomp__button uicomp--grey',
                cancelButton: 'uicomp__button uicomp--red'
            }
        });
        this.swalInstance = Swal.mixin(
            Object.assign(
                Object.assign({}, this.defaultConfig), // clone de defaultConfig pour éviter des effets de bord
                swalConfig
            )
        );
    }
    getSwal() {
        return this.swalInstance;
    }
    fireSwal(swalConfig = {}) {
        this.swalInstance.fire(swalConfig);
    }
    closeSwal() {
        this.swalInstance.close();
    }
    onConfirm() {}
    onClose() {}
    onDeny() {}
}

G.ui.SWAL_FIXED_WIDTH = 1100;

G.ui.applyFixedSwalPopupLayout = function() {
    const popup = Swal.getPopup();
    if (popup) {
        popup.classList.remove("gv-swal-popup--indicator-fixed-wizard", "gv-swal-popup--indicator-fixed-simple");

        const actions = popup.querySelector(".swal2-actions");
        const progressSteps = popup.querySelector(".swal2-progress-steps");
        const title = popup.querySelector(".swal2-title");

        const existingHeader = popup.querySelector(".gv-swal-static-header");
        if (existingHeader) {
            while (existingHeader.firstChild) {
                popup.insertBefore(existingHeader.firstChild, existingHeader);
            }
            existingHeader.remove();
        }

        // Reset d'un éventuel wrapper précédent (Swal réutilise le même noeud popup).
        const existingCenter = popup.querySelector(".gv-swal-center-content");
        if (existingCenter) {
            while (existingCenter.firstChild) {
                popup.insertBefore(existingCenter.firstChild, existingCenter);
            }
            existingCenter.remove();
        }

        if (progressSteps) {
            popup.classList.add("gv-swal-popup--indicator-fixed-wizard");

            // Wizard: header statique (jauge + titre), contenu centré, actions en bas.
            const staticHeader = document.createElement("div");
            staticHeader.className = "gv-swal-static-header";
            popup.insertBefore(staticHeader, progressSteps);
            staticHeader.appendChild(progressSteps);
            if (title) {
                staticHeader.appendChild(title);
            }

            let centerContent = popup.querySelector(".gv-swal-center-content");
            if (!centerContent) {
                centerContent = document.createElement("div");
                centerContent.className = "gv-swal-center-content";
                popup.insertBefore(centerContent, actions || null);
            }

            const contentSelectors = [
                ".swal2-icon",
                ".swal2-image",
                ".swal2-html-container",
                ".swal2-input",
                ".swal2-file",
                ".swal2-textarea",
                ".swal2-select",
                ".swal2-radio",
                ".swal2-checkbox",
                ".swal2-validation-message"
            ];
            contentSelectors.forEach((selector) => {
                const node = popup.querySelector(selector);
                if (node && node.parentElement !== centerContent) {
                    centerContent.appendChild(node);
                }
            });
        } else {
            popup.classList.add("gv-swal-popup--indicator-fixed-simple");
        }
    }
};

G.ui.GVSwal2Loading = class extends G.ui.GVGenericSwal2 {
    constructor(swalConfig = {}) {
        super(
            Object.assign(
                {
                    title: "",
                    icon: undefined,
                    showCancelButton: false,
                    showConfirmButton: false,
                    showDenyButton: false,
                    showCloseButton: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                    didClose: () => {
                        Swal.hideLoading();
                    },
                },
                swalConfig
            )
        );
    }
}

G.ui.GVSwal2FormCreateIndicator = class extends G.ui.GVGenericSwal2 {
    constructor(swalConfig = {}, siteId, defaultSectionId = null, cbOnCreate = () => {}) {
        if (typeof defaultSectionId === 'function') {
            cbOnCreate = defaultSectionId;
            defaultSectionId = null;
        }

        super(
            Object.assign(
                {
                    animation: false,
                    focusConfirm: false,
                    focusDeny: false,
                    focusCancel: false,
                    width: G.ui.SWAL_FIXED_WIDTH,
                    heightAuto: false,
                    title: G.config.LOCALE_RETRIEVE('indicator.edition.createTitle'),
                    confirmButtonText: G.config.LOCALE_RETRIEVE('general.create'),
                    cancelButtonText: G.config.LOCALE_RETRIEVE('general.cancel'),
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    allowOutsideClick: false
                },
                swalConfig
            )
        );

        this.siteId = siteId;
        this.defaultSectionId = defaultSectionId
        this.cbOnCreate = cbOnCreate;
    }

    fireSwal(swalConfig = {}) {
        this.swalInstance.fire({
            html: `
                <form id="gv_swal_form_multistep">            
                    <div class="gvg-r gvg-r--gutter">
                        <div class="gvg-6on6 gvg-2on6--narrow">
                            <label class="uicomp__label">
                                ${G.config.LOCALE_RETRIEVE('general.nom')}
                            </label>
                            <input class="uicomp__input" type="text" name="nom" />                      
                        </div>

                        <div class="gvg-6on6 gvg-4on6--narrow">
                            <label class="uicomp__label">
                                ${G.config.LOCALE_RETRIEVE('indicator.edition.sections')}
                            </label>
                            <select id="select-indicator-section" name="section_id"
                                class="select2 select2-full-width"></select>                    
                        </div>

                        <div class="gvg-6on6 gvg-2on6--narrow">
                            <label class="uicomp__label">
                                ${G.config.LOCALE_RETRIEVE('indicator.edition.indicatorType')}
                            </label>
                            <select id="select-indicator-type" name="type"
                                class="select2 select2-full-width"></select>                 
                        </div>

                        <div class="gvg-6on6 gvg-4on6--narrow">
                            <label class="uicomp__label">&nbsp;</label>
                            <img
                                id="img-indicator-type"
                                alt="${G.config.LOCALE_RETRIEVE('indicator.edition.previewAlt')}"
                                style="width: 100%; height: 360px; padding: 0 5px;
                                    filter: drop-shadow(0px 0px 4px rgba(0,0,0,0.2));
                                    background: lightgrey; object-fit: contain"
                            />
                            <legend class="text-justify">
                                <em id="description-indicator-type"></em>
                            </legend>
                        </div>
                    </div>
                </form>
            `,
            didRender: () => {
                let self = this;

                $('#gv_swal_form_multistep').submit(function(e) {
                    e.preventDefault();
                });
                G.ui.initSelect2($("#select-indicator-type"));
                G.ui.initSelect2($("#select-indicator-section"));
                $.ajax({
                    url: `${G.config.SERVER}frontend/ajax/getComponentOfSite/${self.siteId}/indicator_all_type`,
                    type: 'GET',
                    async: true,
                    error: function (xhr, textStatus, errorThrown) {},
                    success: function (response, textStatus, xhr) {
                        if(response && response.status == "success") {
                            let indicatorTypeDefaultSelected = Object.keys(response.data)[0];
                            for (const [currentIndicatorType, indicatorTypeLabel] of Object.entries(response.data)) {
                                $("#select-indicator-type").append(
                                    new Option(indicatorTypeLabel, currentIndicatorType, currentIndicatorType === indicatorTypeDefaultSelected, currentIndicatorType === indicatorTypeDefaultSelected)
                                ).trigger('change');
                            }
                        }
                        else {}
                    }
                });
                $.ajax({
                    url: `${G.config.SERVER}frontend/ajax/getComponentOfSite/${self.siteId}/indicator_section`,
                    type: 'GET',
                    async: true,
                    error: function (xhr, textStatus, errorThrown) {},
                    success: function (response, textStatus, xhr) {
                        if(response && response.status == "success") {
                            let targetSectionId = self.defaultSectionId ?? response.data[0]?.id;
                            for(const indicatorSection of response.data) {
                                $('#select-indicator-section').append(
                                    new Option(
                                        `${indicatorSection.titre} (#${indicatorSection.id})`,
                                        indicatorSection.id,
                                    )
                                );
                            }
                            $('#select-indicator-section').val(targetSectionId).trigger('change');
                        }
                        else {}
                    }
                });
                $("#img-indicator-type").on("error", function () {
                    $("#img-indicator-type").attr("src", `${G.config.SERVER}img/indicators/type/preview_default.png`);
                });
                $("#select-indicator-type").on("change.select2", function () {
                    $("#img-indicator-type").attr("src", `${G.config.SERVER}img/indicators/type/preview_${$(this).val()}.png`);

                    $("#description-indicator-type").html(
                        G.config.LOCALE_RETRIEVE(`indicator.description.${$(this).val()}`)
                    );
                }).trigger("change.select2");

                $(Swal.getHtmlContainer()).find('#gv_swal_form_multistep')
                    .on('keydown', function (e) {
                        if (e.key !== 'Enter') return;

                        const $target = $(e.target);

                        // Cas où Enter doit garder son comportement normal
                        if (
                            $target.is('textarea') ||
                            $target.closest('.select2-container').length
                        ) {
                            return;
                        }

                        e.preventDefault();
                        e.stopPropagation();
                        Swal.clickConfirm();
                    })
                    .on("submit", function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                    });
            },
            didOpen: () => {
                G.ui.applyFixedSwalPopupLayout();

                let focusElFirst$ = $(Swal.getHtmlContainer()).find("input:not([type=hidden]), select, textarea").first();
                if (focusElFirst$.is("select.select2-hidden-accessible")) {
                    const select2Selection$ = focusElFirst$.next(".select2").find(".select2-selection").first();
                    if (select2Selection$.length) select2Selection$.trigger("focus");
                } else {
                    focusElFirst$.focus();
                }
            },
            preConfirm: async () => {
                let self = this;

                const response = await $.ajax({
                    url: `${G.config.SERVER}frontend/ajax/createEmptyIndicator/${self.siteId}`,
                    data: $("#gv_swal_form_multistep").serializeArray().reduce(function(obj, item) {
                        obj[item.name] = item.value;
                        return obj;
                    }, {}),
                    method: "POST",
                    async: false
                });
                if (response && (response.status ?? "error") !== "success") {
                    Swal.showValidationMessage(`${response["error"] ?? G.config.LOCALE_RETRIEVE('general.errorHasOccured')}`);
                } else {
                    return response["data"];
                }
            }
        }).then((result) => {
            if(result.isConfirmed) {
                if(result.value) {
                    this.cbOnCreate(result.value);
                    this.destroySwal();
                    Swal.fire({
                        width: G.ui.SWAL_FIXED_WIDTH,
                        heightAuto: false,
                        title: G.config.LOCALE_RETRIEVE('indicator.edition.createdTitle'),
                        text: G.config.LOCALE_RETRIEVE('indicator.edition.createdText'),
                        icon: "success",
                        footer: `<div class="text-flow"><a href="${G.config.SERVER}frontend/dashboard/gv#dashboard/site-${self.siteId}" class="fake-link"><strong>${G.config.LOCALE_RETRIEVE('indicator.edition.goToDashboard')} <i class="fal fa-external-link"></i></strong></a></div>`,
                        showConfirmButton: true,
                        confirmButtonText: "OK",
                        didOpen: () => {
                            G.ui.applyFixedSwalPopupLayout();
                        },
                        customClass: {
                            popup: 'gv-swal-popup--indicator-fixed',
                            closeButton: 'uicomp__button uicomp--transparent',
                            input: 'uicomp__input',
                            inputLabel: 'uicomp__label',
                            confirmButton: 'uicomp__button uicomp--brand',
                            denyButton: 'uicomp__button uicomp--grey',
                            cancelButton: 'uicomp__button uicomp--red'
                        }
                    });
                }
            }
            else {}
        });
    }

    destroySwal() {
        this.siteId = null;
        $("#gv_swal_form_multistep").off("submit");
        $("#img-indicator-type").off("error");
        $("#select-indicator-type").select2("destroy");
        $("#select-indicator-section").select2("destroy");

    }
}
G.ui.GVSwal2FormIndicatorSection = class extends G.ui.GVGenericSwal2 {
    constructor(swalConfig = {}, siteId, indicatorSectionId = null, cbOnSubmit = () => {}) {
        super(
            Object.assign(
                {
                    animation: false,
                    focusConfirm: false,
                    focusDeny: false,
                    focusCancel: false,
                    width: G.ui.SWAL_FIXED_WIDTH,
                    heightAuto: false,
                    title: "",
                    willOpen: () => {
                        $(this.swalInstance.getTitle()).html(this.formTitle ?? "");

                        $('#gv_swal_form_multistep').submit(function(e) {
                            e.preventDefault();
                        });
                    },
                    didRender: () => {
                        let self = this;

                        $("table").each(function(table$) {
                            if (DataTable.isDataTable($(this))) {
                                $(this).DataTable().columns.adjust().draw();
                            }
                        });

                        var elements = $('#gv_swal_form_multistep').find('input, select, textarea');
                        $.each(elements, function(index, element) {
                            // Utiliser $(element) pour le convertir en objet jQuery
                            let $element = $(element);
                            let elementType = $element.attr('type') || element.tagName.toLowerCase();
                            let elementName = $element.attr('name');
                            let elementPathDefaultValue = elementName.split('.');
                            let elementDefaultValue = self.formIndicatorSectionData;

                            try {
                                for (var i = 0, ilen = elementPathDefaultValue.length; i < ilen; ++i) {
                                    elementDefaultValue = elementDefaultValue[elementPathDefaultValue[i]];
                                }
                            } catch(err) {
                                elementDefaultValue = null;
                            }

                            if(exists(elementDefaultValue)) {
                                switch (elementType) {
                                    case 'text':
                                        $element.val(elementDefaultValue);
                                    case 'number':
                                        $element.val(elementDefaultValue);
                                        break;
                                    case 'hidden':
                                        if(Array.isArray(elementDefaultValue) || typeof elementDefaultValue === 'object') {
                                            $element.val(JSON.stringify(elementDefaultValue));
                                        }
                                        else {
                                            $element.val(elementDefaultValue);
                                        }
                                        break;
                                    case 'checkbox':
                                        $element.prop("checked", $element.val() == (parseInt(elementDefaultValue) ? 1 : 0));
                                        break;
                                    case 'radio':
                                        $element.prop("checked", $element.val() === elementDefaultValue);
                                        break;
                                    case 'select':
                                        $element.attr("data-default-value", String(elementDefaultValue));
                                        break;
                                    case 'textarea':
                                        $element.text(elementDefaultValue);
                                        break;
                                    default:
                                        break;
                                }
                            }

                        });

                        $(Swal.getHtmlContainer()).find('#gv_swal_form_multistep')
                            .on('keydown', function (e) {
                                if (e.key !== 'Enter') return;

                                const $target = $(e.target);

                                // Cas où Enter doit garder son comportement normal
                                if (
                                    $target.is('textarea') ||
                                    $target.closest('.select2-container').length
                                ) {
                                    return;
                                }

                                e.preventDefault();
                                e.stopPropagation();
                                Swal.clickConfirm();
                            })
                            .on("submit", function (e) {
                                e.preventDefault();
                                e.stopPropagation();
                            });
                    },
                    confirmButtonText: exists(indicatorSectionId) ? G.config.LOCALE_RETRIEVE('indicator.edition.confirmEdit') : G.config.LOCALE_RETRIEVE('general.create'),
                    cancelButtonText: G.config.LOCALE_RETRIEVE('general.cancel'),
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    allowOutsideClick: false
                },
                swalConfig
            )
        );

        this.indicatorSectionSiteId = siteId;
        this.indicatorSectionId = indicatorSectionId;
        this.isUpdate = exists(indicatorSectionId);
        this.formIndicatorSectionData = {};
        this.cbOnSubmit = cbOnSubmit;

        let self = this;

        if(exists(this.indicatorSectionId)) {
            const response = $.ajax({
                url: `${G.config.SERVER}apigv/indicators/section/${self.indicatorSectionId}`,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer "+G.model.userApiKey
                },
                method: "GET",
                async: false
            });
            if(response && response.responseJSON?.status === "success") {
                this.formIndicatorSectionData = response.responseJSON.response.section;
                this.formTitle = `${G.config.LOCALE_RETRIEVE('indicator.edition.editSection')} "${this.formIndicatorSectionData["titre"]}"`;
            }
            else {
                Swal.fire({
                    width: G.ui.SWAL_FIXED_WIDTH,
                    heightAuto: false,
                    title: response?.responseJSON?.message ?? G.config.LOCALE_RETRIEVE('general.errorHasOccured'),
                    icon: "error",
                    didOpen: () => {
                        G.ui.applyFixedSwalPopupLayout();
                    },
                    customClass: {
                        popup: 'gv-swal-popup--indicator-fixed',
                        closeButton: 'uicomp__button uicomp--transparent',
                        input: 'uicomp__input',
                        inputLabel: 'uicomp__label',
                        confirmButton: 'uicomp__button uicomp--brand',
                        denyButton: 'uicomp__button uicomp--grey',
                        cancelButton: 'uicomp__button uicomp--red'
                    }
                });
                return false;
            }

        } else {
            this.formTitle = `${G.config.LOCALE_RETRIEVE('indicator.edition.sectionCreation')}`;
            this.formIndicatorSectionData = {
                icone: 'overview'
            };
        }
    }

    fireSwal(swalConfig = {}) {
        let self = this;
        this.swalInstance.fire({
            html: `
                <form id="gv_swal_form_multistep">
                    <input class="uicomp__input" type="hidden" name="id" />
                    <div class="gvg-r gvg-r--gutter">
                        <div class="gvg-6on6 gvg-3on6--narrow">
                            <label class="uicomp__label">${G.config.LOCALE_RETRIEVE('general.title')}</label>
                            <input class="uicomp__input" type="text" name="titre" />                      
                        </div>
                        <div class="gvg-6on6 gvg-3on6--narrow">
                            <label class="uicomp__label">${G.config.LOCALE_RETRIEVE('general.subtitle')}</label>
                            <input class="uicomp__input" type="text" name="soustitre" />                      
                        </div>
                        <div class="gvg-6on6 gvg-3on6--narrow">
                            <label class="uicomp__label">${G.config.LOCALE_RETRIEVE('general.page')}</label>
                            <select id="select-indicator-page" name="dashboard_page_id" class="select2 select2-full-width"></select>                 
                        </div>
                        <div class="gvg-6on6 gvg-3on6--narrow">
                            <label class="uicomp__label">${G.config.LOCALE_RETRIEVE('indicator.edition.period')}</label>
                            <select id="select-indicator-section-period" name="periode" class="select2 select2-full-width"></select>                 
                        </div>
                        <div class="gvg-6on6 gvg-3on6--narrow">
                            <label class="uicomp__label">${G.config.LOCALE_RETRIEVE('indicator.edition.icon')}</label>
                            <div class="gv-iicon-selector">
                                <div class="gv-iicon-selector__preview">
                                    <div class="gv-iicon-selector__preview-icon" style="box-shadow: 0px 0px 3px rgba(0,0,0,0.2)"></div>
                                </div>
                                <div class="gv-iicon-selector__select">
                                    <label class="uicomp__label" for="icon">${G.config.LOCALE_RETRIEVE('indicator.edition.chooseIcon')}</label>
                                    <select class="select2-gviicon" name="icone"></select>
                                </div>
                            </div>
                        </div>
                        <div class="gvg-6on6">
                            <label class="gv-ui-ckeckbox" for="cbx_filter_date">
                                <input type="checkbox" id="cbx_filter_date" name="filterDate" value="1" /> 
                                <span class="value-map">${G.config.LOCALE_RETRIEVE('indicator.edition.showDateFilter')}</span>
                            </label>   
                            <span class="uicomp__text_help">${G.config.LOCALE_RETRIEVE('indicator.edition.displayValueForDate')}</span>
                        </div>
                        <div class="gvg-6on6">
                            <label class="gv-ui-ckeckbox" for="cbx_active">
                                <input type="checkbox" id="cbx_active" name="active" value="1" /> 
                                <span class="value-map">${G.config.LOCALE_RETRIEVE('indicator.edition.active')}</span>
                            </label>
                        </div>
                    </div>
                </form>
            `,
            didOpen: () => {
                G.ui.applyFixedSwalPopupLayout();

                $('.gv-iicon-selector').find('select.select2-gviicon')
                    .select2({
                        width: '100%',
                        templateResult: function (state) {
                            if (!state.id) {
                                return state.text;
                            }

                            return $(
                                '<div class="select2-results__option--gv-iicon-selector tooltip--footer" data-module="tooltip" data-title="' + state.id + '">'
                                + '<div class="select2-results__option--icon gv-iicon-' + state.id + '"></div>'
                                + '</div>'
                            );
                        },
                        data: G.model.icons.filter(function (el) {
                            return el !== '' && el.indexOf('el-') !== 0;
                        }),
                        language: G.model.lang,
                        dropdownCssClass: 'select2-dropdown--gv-iicon-selector'
                    })
                    .on('change', function () {
                        $(this).closest('.gv-iicon-selector')
                            .find('.gv-iicon-selector__preview-icon')
                            .removeClass()
                            .addClass('gv-iicon-selector__preview-icon gv-iicon-' + $(this).val());
                    })
                    .val(function() {
                        return $(this).attr("data-default-value") ?? "void"
                    })
                    .trigger('change');

                G.ui.initSelect2($("#select-indicator-section-period"));
                $.ajax({
                    url: `${G.config.SERVER}frontend/ajax/getComponentOfSite/${self.indicatorSectionSiteId}/indicator_period`,
                    type: 'GET',
                    async: true,
                    error: function (xhr, textStatus, errorThrown) {},
                    success: function (response, textStatus, xhr) {
                        if(response && response.status == "success") {
                            let indicatorPeriodDefaultSelected = $("#select-indicator-section-period").attr("data-default-value") ?? "null";
                            $("#select-indicator-section-period").prepend(new Option(G.config.LOCALE_RETRIEVE('indicator.edition.default'), null));
                            for (const [indicatorPeriodCode, indicatorPeriodLabel] of Object.entries(response.data)) {
                                $("#select-indicator-section-period").append(
                                    new Option(indicatorPeriodLabel, indicatorPeriodCode)
                                );
                            }
                            $("#select-indicator-section-period").val(indicatorPeriodDefaultSelected).trigger('change');
                        }
                        else {}
                    }
                });

                G.ui.initSelect2($("#select-indicator-page"));
                $.ajax({
                    url: `${G.config.SERVER}frontend/ajax/getComponentOfSite/${self.indicatorSectionSiteId}/dashboardPage`,
                    type: 'GET',
                    async: true,
                    error: function (xhr, textStatus, errorThrown) {},
                    success: function (response, textStatus, xhr) {
                        if(response && response.status == "success") {
                            let indicatorPeriodDefaultSelected = $("#select-indicator-page").attr("data-default-value") ?? "null";
                            $("#select-indicator-page").prepend(new Option(G.config.LOCALE_RETRIEVE('indicator.edition.none'), null));
                            for (const dashboardPage of response.data) {
                                $("#select-indicator-page").append(
                                    new Option(dashboardPage.titre, dashboardPage.id)
                                );
                            }
                            $("#select-indicator-page").val(indicatorPeriodDefaultSelected).trigger('change');
                        }
                        else {}
                    }
                });

                let focusElFirst$ = $(Swal.getHtmlContainer()).find("input:not([type=hidden]), select, textarea").first();
                if (focusElFirst$.is("select.select2-hidden-accessible")) {
                    const select2Selection$ = focusElFirst$.next(".select2").find(".select2-selection").first();
                    if (select2Selection$.length) select2Selection$.trigger("focus");
                } else {
                    focusElFirst$.focus();
                }

                $(Swal.getHtmlContainer()).find('.gv-ui-ckeckbox').each(function (index, el) {
                    $(el).find('input[type="checkbox"], input[type="radio"]').after($('<div class="gv-ui__mock"></div>'));
                });
            },
            preConfirm: async () => {
                let self = this;

                const response = await $.ajax({
                    url: `${G.config.SERVER}frontend/ajax/saveIndicateurSection/${self.indicatorSectionSiteId}`,
                    data: $("#gv_swal_form_multistep").serializeArray().reduce(function(obj, item) {
                        obj[item.name] = item.value;
                        return obj;
                    }, {}),
                    method: "POST",
                    async: false
                });
                if (response && (response.status ?? "error") !== "success") {
                    Swal.showValidationMessage(`${response["error"] ?? G.config.LOCALE_RETRIEVE('general.errorHasOccured')}`);
                } else {
                    return response["data"];
                }
            }
        }).then((result) => {
            if(result.isConfirmed) {
                if(result.value) {
                    Swal.fire({
                        width: G.ui.SWAL_FIXED_WIDTH,
                        heightAuto: false,
                        title: G.config.LOCALE_RETRIEVE('indicator.edition.sectionSavedTitle'),
                        text: G.config.LOCALE_RETRIEVE('indicator.edition.createdText'),
                        icon: "success",
                        footer: `<div class="text-flow"><a href="${G.config.SERVER}frontend/dashboard/gv#dashboard/site-${self.indicatorSectionSiteId}" class="fake-link"><strong>${G.config.LOCALE_RETRIEVE('indicator.edition.goToDashboard')} <i class="fal fa-external-link"></i></strong></a></div>`,
                        showConfirmButton: true,
                        confirmButtonText: "OK",
                        didOpen: () => {
                            G.ui.applyFixedSwalPopupLayout();
                        },
                        customClass: {
                            popup: 'gv-swal-popup--indicator-fixed',
                            closeButton: 'uicomp__button uicomp--transparent',
                            input: 'uicomp__input',
                            inputLabel: 'uicomp__label',
                            confirmButton: 'uicomp__button uicomp--brand',
                            denyButton: 'uicomp__button uicomp--grey',
                            cancelButton: 'uicomp__button uicomp--red'
                        }
                    });
                    this.cbOnSubmit(result.value);
                    this.destroySwal();
                }
            }
            else {}
        });
    }

    destroySwal() {
        this.formTitle = null;
        this.indicatorSectionSiteId = null;
        this.indicatorSectionId = null;
        this.formIndicatorSectionData = null;

        $("#gv_swal_form_multistep").off("submit");
        $("#select-indicator-period").select2("destroy");
    }
}

// Edition Swal — DashboardPage (Pages)
G.ui.GVSwal2FormIndicatorPage = class extends G.ui.GVGenericSwal2 {
    constructor(swalConfig = {}, siteId, dashboardPageId = null, cbOnSubmit = () => {}) {
        super(
            Object.assign(
                {
                    animation: false,
                    focusConfirm: false,
                    focusDeny: false,
                    focusCancel: false,
                    width: G.ui.SWAL_FIXED_WIDTH,
                    heightAuto: false,
                    title: "",
                    willOpen: () => {
                        $(this.swalInstance.getTitle()).html(this.formTitle ?? "");

                        $('#gv_swal_form_multistep').submit(function(e) {
                            e.preventDefault();
                        });
                    },
                    didRender: () => {
                        let self = this;

                        $("table").each(function() {
                            if (DataTable.isDataTable($(this))) {
                                $(this).DataTable().columns.adjust().draw();
                            }
                        });

                        const elements = $('#gv_swal_form_multistep').find('input, select, textarea');
                        $.each(elements, function(index, element) {
                            const $element = $(element);
                            const elementType = $element.attr('type') || element.tagName.toLowerCase();
                            const elementName = $element.attr('name');
                            if (!elementName) return;

                            const elementPath = elementName.split('.');
                            let elementDefaultValue = self.formDashboardPageData;

                            try {
                                for (let i = 0; i < elementPath.length; ++i) {
                                    elementDefaultValue = elementDefaultValue[elementPath[i]];
                                }
                            } catch (err) {
                                elementDefaultValue = null;
                            }

                            if (exists(elementDefaultValue)) {
                                switch (elementType) {
                                    case 'text':
                                    case 'number':
                                        $element.val(elementDefaultValue);
                                        break;
                                    case 'hidden':
                                        if (Array.isArray(elementDefaultValue) || typeof elementDefaultValue === 'object') {
                                            $element.val(JSON.stringify(elementDefaultValue));
                                        } else {
                                            $element.val(elementDefaultValue);
                                        }
                                        break;
                                    case 'checkbox':
                                        $element.prop("checked", $element.val() == (parseInt(elementDefaultValue) ? 1 : 0));
                                        break;
                                    case 'radio':
                                        $element.prop("checked", $element.val() === elementDefaultValue);
                                        break;
                                    case 'select':
                                        $element.attr("data-default-value", String(elementDefaultValue));
                                        break;
                                    case 'textarea':
                                        $element.text(elementDefaultValue);
                                        break;
                                    default:
                                        break;
                                }
                            }
                        });

                        $(Swal.getHtmlContainer()).find('#gv_swal_form_multistep')
                            .on('keydown', function (e) {
                                if (e.key !== 'Enter') return;

                                const $target = $(e.target);

                                // Cas où Enter doit garder son comportement normal
                                if (
                                    $target.is('textarea') ||
                                    $target.closest('.select2-container').length
                                ) {
                                    return;
                                }

                                e.preventDefault();
                                e.stopPropagation();
                                Swal.clickConfirm();
                            })
                            .on("submit", function (e) {
                                e.preventDefault();
                                e.stopPropagation();
                            });
                    },
                    confirmButtonText: exists(dashboardPageId)
                        ? G.config.LOCALE_RETRIEVE('indicator.edition.confirmEdit')
                        : G.config.LOCALE_RETRIEVE('general.create'),
                    cancelButtonText: G.config.LOCALE_RETRIEVE('general.cancel'),
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    allowOutsideClick: false
                },
                swalConfig
            )
        );

        this.dashboardPageSiteId = siteId;
        this.dashboardPageId = dashboardPageId;
        this.isUpdate = exists(dashboardPageId);
        this.formDashboardPageData = {};
        this.cbOnSubmit = cbOnSubmit;

        if (exists(this.dashboardPageId)) {
            const response = $.ajax({
                url: `${G.config.SERVER}apigv/indicators/dashboardPage/${this.dashboardPageId}`,
                method: "GET",
                headers: {
                    "Authorization": "Bearer " + G.model.userApiKey,
                    "Content-Type": "application/json"
                },
                async: false
            });

            if (response && response.responseJSON?.status === "success") {
                this.formDashboardPageData = response.responseJSON.response?.page ?? {};
                this.formTitle = `${G.config.LOCALE_RETRIEVE('indicator.page.editTitle')} "${this.formDashboardPageData["titre"]}"`;
            } else {
                Swal.fire({
                    width: G.ui.SWAL_FIXED_WIDTH,
                    heightAuto: false,
                    title: response?.responseJSON?.message ?? G.config.LOCALE_RETRIEVE('general.errorHasOccured'),
                    icon: "error",
                    didOpen: () => {
                        G.ui.applyFixedSwalPopupLayout();
                    },
                    customClass: {
                        closeButton: 'uicomp__button uicomp--transparent',
                        input: 'uicomp__input',
                        inputLabel: 'uicomp__label',
                        confirmButton: 'uicomp__button uicomp--brand',
                        denyButton: 'uicomp__button uicomp--grey',
                        cancelButton: 'uicomp__button uicomp--red'
                    }
                });
                return false;
            }
        } else {
            this.formTitle = G.config.LOCALE_RETRIEVE('indicator.page.createTitle');
            this.formDashboardPageData = {};
        }
    }

    fireSwal(swalConfig = {}) {
        let self = this;

        this.swalInstance.fire({
            html: `
                <form id="gv_swal_form_multistep">
                    <input class="uicomp__input" type="hidden" name="id" />

                    <div class="gvg-r gvg-r--gutter">
                        <div class="gvg-6on6 gvg-3on6--narrow">
                            <label class="uicomp__label">${G.config.LOCALE_RETRIEVE('general.title')}</label>
                            <input class="uicomp__input" type="text" name="titre" />
                        </div>

                        <div class="gvg-6on6 gvg-3on6--narrow">
                            <label class="uicomp__label">${G.config.LOCALE_RETRIEVE('indicator.edition.rightLevel')}</label>
                            <input class="uicomp__input" type="number" name="droit" min="0" max="10" step="1" />
                        </div>

                        <div class="gvg-6on6 gvg-3on6--narrow">
                            <label class="uicomp__label">${G.config.LOCALE_RETRIEVE('indicator.edition.zone')}</label>
                            <select id="select-dashboard-page-zone" name="zone_id" class="select2 select2-full-width"></select>
                        </div>

                        <div class="gvg-6on6 gvg-3on6--narrow">
                            <label class="uicomp__label">${G.config.LOCALE_RETRIEVE('indicator.page.logo')}</label>
                            <input class="uicomp__input" type="file" name="logo" />
                        </div>

                        <div class="gvg-6on6">
                            <div class="uicomp__hflow mod--valign-center mod--no-vmargin">
                                <label class="gv-ui-ckeckbox" for="cbx_active">
                                    <input type="checkbox" id="cbx_active" name="active" value="1" />
                                    <span class="value-map">${G.config.LOCALE_RETRIEVE('indicator.edition.active')}</span>
                                </label>
                                <label class="gv-ui-ckeckbox" for="cbx_default">
                                    <input type="checkbox" id="cbx_default" name="default" value="1" />
                                    <span class="value-map">${G.config.LOCALE_RETRIEVE('indicator.edition.default')}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </form>
            `,
            didOpen: () => {
                G.ui.applyFixedSwalPopupLayout();

                // Init Select2 zone
                G.ui.initSelect2($("#select-dashboard-page-zone"));

                // Charge les zones
                $.ajax({
                    url: `${G.config.SERVER}frontend/ajax/getComponentOfSite/${self.dashboardPageSiteId}/zone`,
                    type: 'GET',
                    async: true,
                    success: function(response) {
                        if (response && response.status === "success") {
                            const defaultSelected = $("#select-dashboard-page-zone").attr("data-default-value") ?? "null";
                            $("#select-dashboard-page-zone").prepend(new Option(G.config.LOCALE_RETRIEVE('indicator.edition.none'), null));

                            for (const zone of response.data) {
                                const label = zone.nom ?? zone.label ?? zone.titre ?? String(zone.id);
                                $("#select-dashboard-page-zone").append(new Option(label, zone.id));
                            }
                            $("#select-dashboard-page-zone").val(defaultSelected).trigger('change');
                        }
                    }
                });

                const focusElFirst$ = $(Swal.getHtmlContainer()).find("input:not([type=hidden]), select, textarea").first();
                if (focusElFirst$.is("select.select2-hidden-accessible")) {
                    const select2Selection$ = focusElFirst$.next(".select2").find(".select2-selection").first();
                    if (select2Selection$.length) select2Selection$.trigger("focus");
                } else {
                    focusElFirst$.focus();
                }

                // Mock checkbox UI
                $(Swal.getHtmlContainer()).find('.gv-ui-ckeckbox').each(function (index, el) {
                    $(el).find('input[type="checkbox"], input[type="radio"]').after($('<div class="gv-ui__mock"></div>'));
                });
            },
            preConfirm: async () => {
                const formEl = document.getElementById("gv_swal_form_multistep");
                const formData = new FormData(formEl);
                const logoFile = $(formEl).find('input[name="logo"]')[0]?.files?.[0] ?? null;

                const payload = {
                    id: formData.get("id") ? parseInt(formData.get("id")) : null,
                    titre: String(formData.get("titre") ?? "").trim(),
                    droit: parseInt(formData.get("droit") ?? "0"),
                    zone_id: null,
                    active: formData.has("active") ? 1 : 0,
                    default: formData.has("default") ? 1 : 0
                };

                const zoneId = formData.get("zone_id");
                if (zoneId !== null && zoneId !== "" && zoneId !== "null") {
                    payload.zone_id = parseInt(zoneId);
                }

                if (logoFile) {
                    const fdUpload = new FormData();
                    fdUpload.append("logo", logoFile);

                    let responseUploadLogo;
                    try {
                        responseUploadLogo = await $.ajax({
                            url: `${G.config.SERVER}apigv/upload/dashboardPageLogo/${self.dashboardPageSiteId}`,
                            method: "POST",
                            data: fdUpload,
                            processData: false,
                            contentType: false,
                            headers: {
                                "Authorization": "Bearer " + G.model.userApiKey
                            },
                            async: false
                        });
                    } catch (xhrError) {
                        Swal.showValidationMessage(xhrError?.responseJSON?.message ?? G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
                        return false;
                    }

                    if ((responseUploadLogo?.status ?? "error") !== "success") {
                        Swal.showValidationMessage(`${responseUploadLogo?.message ?? G.config.LOCALE_RETRIEVE('general.errorHasOccured')}`);
                        return false;
                    }

                    payload.logo = responseUploadLogo?.response?.filename ?? null;
                }

                try {
                    const response = await $.ajax({
                        url: `${G.config.SERVER}apigv/indicators/dashboardPage/${self.dashboardPageSiteId}`,
                        method: "POST",
                        data: JSON.stringify(payload),
                        headers: {
                            "Authorization": "Bearer " + G.model.userApiKey,
                            "Content-Type": "application/json"
                        },
                        async: false
                    });

                    if (response && (response.status ?? "error") !== "success") {
                        Swal.showValidationMessage(`${response["message"] ?? G.config.LOCALE_RETRIEVE('general.errorHasOccured')}`);
                    } else {
                        return response?.response?.page ?? null;
                    }
                } catch (xhrError) {
                    const message = xhrError?.responseJSON?.message ?? G.config.LOCALE_RETRIEVE('general.errorHasOccured');
                    Swal.showValidationMessage(message);
                }
            }
        }).then((result) => {
            if (result.isConfirmed && result.value) {
                Swal.fire({
                    width: G.ui.SWAL_FIXED_WIDTH,
                    heightAuto: false,
                    title: G.config.LOCALE_RETRIEVE('indicator.page.pageSavedTitle'),
                    text: G.config.LOCALE_RETRIEVE('general.saveSuccess'),
                    icon: "success",
                    showConfirmButton: true,
                    confirmButtonText: "OK",
                    didOpen: () => {
                        G.ui.applyFixedSwalPopupLayout();
                    },
                    customClass: {
                        closeButton: 'uicomp__button uicomp--transparent',
                        input: 'uicomp__input',
                        inputLabel: 'uicomp__label',
                        confirmButton: 'uicomp__button uicomp--brand',
                        denyButton: 'uicomp__button uicomp--grey',
                        cancelButton: 'uicomp__button uicomp--red'
                    }
                });

                this.cbOnSubmit(result.value);
                this.destroySwal();
            }
        });
    }

    destroySwal() {
        this.formTitle = null;
        this.dashboardPageSiteId = null;
        this.dashboardPageId = null;
        this.formDashboardPageData = null;

        $("#gv_swal_form_multistep").off("submit");
        try { $("#select-dashboard-page-zone").select2("destroy"); } catch(e) {}
    }
}


var hud;

if (!exists(hud)) {
	hud = {};
}

/**
 * @type {{subtitle: null, title: null}}
 */
hud.location = {
	title: null,
	subtitle: null
};

/**
 * @type {boolean}
 */
hud.PRODUCTION = false;

/**
 * Enumeration for HUD navigation modes.
 * @type {{favorites: string, site_settings: string, news: string, search: string, closed: string, admin: string, sites: string, user: string}}
 */
hud.NAV_MODE = {
	closed: 'closed',
	sections: 'sections',
	search: 'search',
	sites: 'sites',
	companies: 'companies',
	favorites: 'favorites',
	site_settings: 'site_settings',
	admin: 'admin',
	news: 'news',
	user: 'user'
};

/**
 * Default HUD navigation mode while opening with [CTRL] + [SHIFT] + [F]
 * @type {string}
 */
hud.NAV_MODE_DEFAULT = hud.NAV_MODE.favorites;

/**
 * Enumeration for webservice navigation modes.
 * @type {{site: string, assets: string, backend: string}}
 */
hud.SECTION_MODE = {
	assets: 'assets',
	assetsPrestation: 'assetsPrestation',
	site: 'site',
	sitePrestation: 'sitePrestation',
	backend: 'backend'
};

/**
 * shortest valid input length required to send a request
 * @type {number}
 */
hud.SEARCH_MIN_INPUT_LENGTH = 3;

/** @type {string[]} */
hud.RIGHTS_GROUPS = ['super-admin', 'admin-utilisateur', 'admin-kessel', 'administrateur', 'utilisateur', 'demo'];
/** @type {string[]} */
hud.PRESTATION_GROUPS = ['admin-prestation', 'prestation'];

/** @type {{site: boolean[], report: boolean[], equipment: boolean[], synopsis: boolean[], user: boolean[], enterprise: boolean[]}} */
hud.RIGHTS_EDIT = {
	//          super-admin    admin-utilisateur    admin-kessel      administrateur    utilisateur       demo           admin-abiga    admin-abiga_kessel      client
	label: [false, false, false, false, false, false, false, false, false],
	user: [true, true, true, true, false, false, true, true, false],
	equipment: [true, false, true, true, false, false, true, true, false],
	site: [true, true, true, true, false, false, true, true, false],
	report: [true, false, false, true, false, false, false, false, false],
	synopsis: [true, false, false, true, false, false, false, false, false],
	favorite: [true, true, true, true, true, true, true, true, true],
	enterprise: [true, false, true, true, false, false, true, true, false]
};

/**
 * Updates HUD titles display
 * @param title   {string}
 * @param subtitle {?string}
 */
hud.SET_ADMIN_TITLE = function (title, subtitle) {
	hud.location = {
		title: title,
		subtitle: subtitle
	};
	if (hud.instance)
		hud.instance.setAdminTitle();
};

/**
 * @constructor
 */
hud.HUDWidget = function () {

	// ------------------------------------------------------------------------------------------------------
	//    PROPERTIES
	// ------------------------------------------------------------------------------------------------------

	/** @type {hud.HUDWidget} */
	var s = this;

	/**  @type {Document}*/
	var d = document;

	/** @type {string} */
	this.siteRoot = window.location.origin + '/';

	/**
	 * @type {HTMLElement}
	 * @private
	 */
	this._el = null;

	/**
	 * @type {HTMLElement}
	 * @private
	 */
	this._searchEl = null;

	/**
	 * @type {number}
	 * @private
	 */
	this._userRightsIndex = -1;

	/**
	 * @type {hud.HUDFavorites}
	 * @private
	 */
	this._hudFavorites = null;

	/**
	 * @type {hud.HUDSearch}
	 * @private
	 */
	this._search = null;

	/**
	 * @type {string}
	 * @private
	 * @see  hud.NAV_MODE
	 */
	this._navMode = '';

	/**
	 * @type {string}
	 * @private
	 * @see  hud.SECTION_MODE
	 */
	this._sectionMode = 'assets';

	/** @type {HTMLElement|null} */
	this._fline = null;

	/**
	 * Context of the panel containing focused line
	 * @private
	 * @type {?{index: {number}, previousPanel: null|{HTMLElement}, nextPanel: null|{HTMLElement}, table: *, panel: *, master: null|{HTMLElement}}}
	 */
	this._fctx = null;

	/**
	 * @type {boolean}
	 * @private
	 */
	this._isMobile = false;

	/**
	 * @type {boolean}
	 * @private
	 */
	this._isAjaxHudgetSitesRunning = false;

	/**
	 * @type {boolean}
	 * @private
	 */
	this._isAjaxGetCompaniesRunning = false;

	/**
	 * @type {jqXHR|null}
	 * @private
	 */
	this._ajaxXhrNotifications = null;

	/**
	 * @type {jqXHR|null}
	 * @private
	 */
	this._isAjaxSeenAllUserNotificationsRunning = false;

	/**
	 * @type {number}
	 * @private
	 */
	this._nbOfAllUserNotifications = 0;

	/**
	 * @type {number}
	 * @private
	 */
	this._nbOfUserNotificationsUnread = 0;

	/**
	 * @type {number}
	 * @private
	 */
	this._userNotificationSetTimeoutId = null;

	// ------------------------------------------------------------------------------------------------------
	//    DOM UTILITIES AND ACCESSORS
	// ------------------------------------------------------------------------------------------------------

	/**
	 * Initializes instance.
	 */
	this.init = function () {
		s._el = d.getElementById('hud-core');
		s._searchEl = d.getElementById('huds__input');

		s._hudFavorites = new hud.HUDFavorites(this);

		s._search = new hud.HUDSearch(d.getElementById('huds__hud-search-pad'), this);
		s._search.init();

		s.setNavMode(hud.NAV_MODE.closed);

		s._interactionsEnable();

		s._loadUserNotification();
	};

	/**
	 *
	 */
	this.setAdminTitle = function () {
		var str;

		if (!hud.location) {
			console.log('pas hud.location');
			return;
		}

		s._summarySet(hud.location.title, hud.location.subtitle);

		var title = [];
		title.push(hud.location.title);
		title.push(hud.location.subtitle);
		title.push('Globalvisio');
		window.document.title = title.join(' | ');
	};

	/**
	 * @param m {string | null}
	 * @returns {HTMLElement}
	 */
	this.getPanels = function (m) {
		/** @type {HTMLElement} */
		var panel;
		m = m ? m : s._navMode;
		panel = d.getElementById('hudc__panels--' + m);
		if (!panel)
			console.log('[HUDWidget.getPanels] Unhandled navMode: ' + m);
		return panel;
	};


	// ------------------------------------------------------------------------------------------------------
	//    HUD MODES
	// ------------------------------------------------------------------------------------------------------

	/**
	 * Resets navigation state
	 * @param v {string}
	 */
	this.setNavMode = function (v) {
		var isOpened = (v !== hud.NAV_MODE.closed);

		// avoid useless state changes
		if (s._navMode === v)
			return s;

		if (!isOpened) {
			s._search.reset();
			s.getPanels(hud.NAV_MODE.search).querySelector('.hudc__table').innerHTML = '';
		}

		// model
		s._navMode = hud.NAV_MODE.hasOwnProperty(v) ? v : hud.NAV_MODE.closed;

		// global HUD state
		s._el.cleanClasses('nav-mode--');
		s._el.classList.add('nav-mode--' + s._navMode);

		// body state
		d.body.cleanClasses('hud-nav-mode--');
		d.body.classList.add('hud-nav-mode--' + s._navMode);

		// data-nav-mode sub-elements states
		s._el.querySelectorAll('[data-nav-mode]').forEach(function (el) {
			el.classList.toggle('state--active', el.getAttribute('data-nav-mode') === v);
		});

		// content
		d.getElementById('hudc__hud-content').classList.toggle('state--active', isOpened);

		if(v == 'sites' && $('#hudc__panel--site-type table').length == 0){
			if(!this._isAjaxHudgetSitesRunning) {
				this._isAjaxHudgetSitesRunning = true;
				$.ajax({
					url: "/frontend/ajax/hudgetsites",
					type: 'GET',
					error: function (xhr, textStatus, errorThrown) {
						G.ui.fatalError("ajax error: " + textStatus, {url: this.url, error: errorThrown});
					},
					success: function (data, textStatus, xhr) {
						if (data.substr(0, 4) == "$ERR") {
							showError(data.substr(4));
							return true;
						}
						$('#hudc__panels--sites').empty().append(data);
					},
					complete: function() {
						this._isAjaxHudgetSitesRunning = false;
					}
				});
			}
		} else if(v == 'companies' && $('#hudc__panel--site-companies table').length == 0){
			if(!this._isAjaxGetCompaniesRunning) {
				this._isAjaxGetCompaniesRunning = true;
				$.ajax({
					url: "/frontend/ajax/getcompanies",
					type: 'GET',
					error: function (xhr, textStatus, errorThrown) {
						G.ui.fatalError("ajax error: " + textStatus, {url: this.url, error: errorThrown});
					},
					success: function (data, textStatus, xhr) {
						if (data.substr(0, 4) == "$ERR") {
							showError(data.substr(4));
							return true;
						}
						$('#hudc__panels--companies').empty().append(data);
					},
					complete: function() {
						this._isAjaxGetCompaniesRunning = false;
					}
				});
			}
		}

		// update user_settings content
		if (v === hud.NAV_MODE.site_settings && s._el.querySelectorAll('[data-nav-mode="site_settings"][data-mode-setter]').length > 0 && !!G.model.siteSelected) {
			s._siteDataComplete();
		}

		else if (v === hud.NAV_MODE.favorites) {
			s._hudFavorites.showFavorites();
		}

		// display focus on first available list item
		if (isOpened)
			s.focusSetPanelDefault(null);

		// show section
        s.feedbackTitleDisplay();
        if (v !== hud.NAV_MODE.favorites) {
            s.feedbackContextDisplay('');
        }

		// set focus
		if (isOpened)
			this._search.focusSet();
	};

	/**
	 * @param v {string}
	 */
	this.setSectionMode = function (v) {
		s._sectionMode = v;

		// element state
		s._el.cleanClasses('section-mode--');
		s._el.classList.add('section-mode--' + s._sectionMode);

		// body state
		d.body.cleanClasses('hud-section-mode--');
		d.body.classList.add('hud-section-mode--' + s._sectionMode);

		s._el.querySelectorAll('[data-section-mode]').forEach(function (el) {
			el.classList.toggle('state--active', el.getAttribute('data-section-mode') === s._sectionMode);
		});

		p = d.getElementById('hudc__navmode-navigation').querySelector('li[data-nav-mode="site_settings"]');
		if (p)
			p.classList.toggle('state--disabled', (v === hud.SECTION_MODE.assets || v === hud.SECTION_MODE.assetsPrestation));

		p = d.getElementById('hudm-actions-panel').querySelector('li[data-nav-mode="site_settings"]');
		if (p)
			p.classList.toggle('state--disabled', (v === hud.SECTION_MODE.assets || v === hud.SECTION_MODE.assetsPrestation));

		if (s._navMode == hud.NAV_MODE.site_settings)
			s.setNavMode(hud.NAV_MODE.search);
	};


	// ------------------------------------------------------------------------------------------------------
	//    MODEL
	// ------------------------------------------------------------------------------------------------------

	/**
	 * @param {string}   what     edition target
	 * @return {boolean}          whether or not user has edition rights for target
	 */
	this.userCanEdit = function (what) {
		if (s._userRightsIndex < 0)
			s._userRightsIndex = hud.RIGHTS_GROUPS.indexOf(G.model.user.groupe.nom);
		return hud.RIGHTS_EDIT[what][s._userRightsIndex];
	};

	/**
	 * @return {boolean}
	 */
	this.userIsInGroupPrestation = function () {
		return hud.PRESTATION_GROUPS.indexOf(G.model.user.groupe.nom) !== -1;
	};

	/**
	 * Redefine session language.
	 * @param lang {string} target language
	 */
	this.langSet = function (lang) {
		var url = G.config.SERVER + 'apigv/profile/lang';
		$.ajax({
			url: url,
			method: "PUT",
			headers: {
				"Content-Type": "application/json",
				"Authorization": "Bearer "+G.model.userApiKey
			},
			data: JSON.stringify({
				"lang": lang
			}),
			datatype: 'json',
			error: function (xhr, textStatus, errorThrown) {
				showError("ajax error: " + textStatus, { url: url, error: errorThrown });
			},
			success: function (data) {
				if (data.status === 'success')
					location.reload();
			}
		});
	};

	/**
	 * @private
	 * @param p {string} path
	 * @returns {string|array}
	 */
	this._loc = function (p) {
		return G.config.LOCALE_RETRIEVE(p, null, false);
	};

	/**
	 * Handles "model.locationChanged' events from application model.
	 * @private
	 */
	this._locationChanged = function () {
		/** @type {G.vo.Site} */
		var site = G.model.siteSelected;
		/** @type {{G.vo.User} */
		var user = G.model.user;
		/** @type {string} */
		var str;
		/** @type {HTMLElement} */
		var panel, link, p;
		/** @type {NodeList} */
		var all;
		/** @type {boolean} */
		var isBackend = window.location.href.indexOf('backend/') > 0 && !document.body.classList.contains('state--frontend');
		/** @type {boolean} */
		var userHasGroupPrestation = this.userIsInGroupPrestation();

		// ---   close panel as location changed
		s.setNavMode(hud.NAV_MODE.closed);

		// ---   check if current page exists in favorites
		s._hudFavorites.updateLinks();

		// --- display selected site
		p = d.getElementById('hudc__panel--site').querySelector('tr.state--selected');
		if (p)
			p.classList.remove('state--selected');

		// ---   display assets section
		d.getElementById('hudm-sections-reportAssets').classList.toggle("mod--hidden", user.isDemo);
		d.getElementById('hudc-sections-reportAssets').classList.toggle("state--hidden", user.isDemo);
		d.getElementById('hudm-sections-interventions').classList.toggle("mod--hidden", !user.hasFullAccess && !user.hasRoleIntervention);
		d.getElementById('hudc-sections-interventions').classList.toggle("state--hidden", !user.hasFullAccess && !user.hasRoleIntervention);

		// ---   display navigation changes
		if (isBackend) {
			s.setSectionMode(hud.SECTION_MODE.backend);
			s.setAdminTitle();
		}
		else if (site && !userHasGroupPrestation) {
			s.setSectionMode(hud.SECTION_MODE.site);
			s._summarySet(site.nom, site.ville);
		}
		else if (site && userHasGroupPrestation) {
			s.setSectionMode(hud.SECTION_MODE.sitePrestation);
			s._summarySet(site.nom, site.ville);
		}
		else if (userHasGroupPrestation) {
			s.setSectionMode(hud.SECTION_MODE.assetsPrestation);
			s._summarySet(s._loc('hud.allAssetsLabel'), null);
		}
		else {
			s.setSectionMode(hud.SECTION_MODE.assets);
			s._summarySet(s._loc('hud.allAssetsLabel'), null);
		}

		//set subtitle
		if (G.model.sectionSelected != null) {
			s._summarySet(s._loc('sections.' + G.model.sectionSelected.id), null, false);
		}

		// ---  display site/site-type selection
		// ... in sites list
		if (site) {
			p = d.getElementById('hudc__panel--site').querySelector('tr[data-site="' + site.id + '"]');
			if (p)
				p.classList.add('state--selected');
		}
		else {
			p = d.getElementById('hudc__panel--site').querySelector('tr.state--selected');
			if (p)
				p.classList.remove('state--selected');
		}

		// ... in the site-type list
		panel = d.getElementById('hudc__panel--site-type');
		p = panel.querySelector('tr.state--selected');
		if (p)
			p.classList.remove('state--selected');
		if (site) {
			p = panel.querySelector('tr[data-site-type="' + site.typeSite.id + '"]');
			if (p)
				p.classList.add('state--selected');
		}


		// --- section site consumption
		$("#hudm-sections-consumption").toggleClass("mod--hidden", !(site && site.consommation))
		$("#hudc-sections-consumption").toggleClass("state--hidden", !(site && site.consommation))

		// --- section site conso detail
		$("#hudm-sections-consoDetail").toggleClass("mod--hidden", !(site && site.consoDetail))
		$("#hudc-sections-consoDetail").toggleClass("state--hidden", !(site && site.consoDetail))

		// --- section site monitoring table
		$("#hudm-sections-show_monitoring_table").toggleClass("mod--hidden", !(site && site.showMonitoringTable == 1))
		$("#hudc-sections-show_monitoring_table").toggleClass("state--hidden", !(site && site.showMonitoringTable == 1))

		// --- section site monitoring alerte
		$("#hudm-sections-pad__link-alerts").toggleClass("mod--hidden", !(site && site.hideAlertSection != 1))
		$("#hudc-sections-pad__link-alerts").toggleClass("state--hidden", !(site && site.hideAlertSection != 1))

		// show/hide synopsis link
		linkDashboard = d.getElementById('hudm-sections-pad__link-dashboard');


		// display synopsis links according to site settings
		str = '';
		if(linkDashboard !== null){
			if(site && site.dashboardPages && site.dashboardPages.length >= 1){
				linkDashboard.classList.add('hud__drop-down');
				str += '<a href="#" data-hash="dashboardPage" data-assets-rewrite="site, dashboardPage">'+G.config.LOCALE_RETRIEVE('sections.dashboard')+'</a>';
				str += '<ul>';
				for(var i = 0, ilen = site.dashboardPages.length, linkHash; i < ilen; ++i){
					linkHash = s.siteRoot + 'frontend/dashboard/gv#dashboardPage';
					str += '<li><a href="' + linkHash + '/site-' + site.id + '/dashboardPage-' + site.dashboardPages[i].id + '">' + site.dashboardPages[i].titre + '</a></li>';
					if('/frontend/dashboard/gv#dashboardPage/site-' + site.id + '/dashboardPage-' + site.dashboardPages[i].id == window.location.pathname + window.location.hash){
						s._summarySet(site.nom + ' - ' + site.dashboardPages[i].titre, site.ville);
					}
				}
				str += '</ul>';
			} else {
				linkDashboard.classList.remove('hud__drop-down');
				str += '<a href="#" data-hash="dashboard" data-assets-rewrite="site">'+G.config.LOCALE_RETRIEVE('sections.dashboard')+'</a>';

			}
			linkDashboard.innerHTML = str;
			
		}

		// show/hide synopsis link
		link = d.getElementById('hudm-sections-pad__link-synopsis');
		if(link !== null){
			link.classList.toggle('mod--hidden', site && site.synoptiques && site.synoptiques.length === 0);
			link.classList.toggle('hud__drop-down', site && site.synoptiques && site.synoptiques.length >= 1);
		}

		// display synopsis links according to site settings
		str = '';
		if(link !== null){
			if(site && site.synoptiques && site.synoptiques.length >= 1){
                for (var i = 0, ilen = site.synoptiques.length, linkHash; i < ilen; ++i) {
                    let synoptic       = site.synoptiques[i];
                    let synopticId     = synoptic.id;
                    let synopticSiteId = synoptic.siteId;
                    let synopticName   = synoptic.nom;

                    // Site patrimoine : les synoptiques peuvent venir des sites enfants
                    if (site.isEstateSite == 1) {
                        const synopticSite = site.estateSiteChilds.find(child => child.id == synopticSiteId) ?? null;

                        // Si le synoptique appartient à un enfant, on préfixe son nom
                        if (exists(synopticSite)) {
                            synopticName = `${synopticSite.nom} / ${synopticName}`;
                        }
                    }

                    linkHash = s.siteRoot + 'frontend/dashboard/gv#' + link.firstElementChild.getAttribute('data-hash');
                    str += '<li><a href="' + linkHash + '/site-' + site.id + '/synopsis-' + synopticId + '">' + synopticName + '</a></li>';
                }
			}
			link.querySelector('ul').innerHTML = str;
		}

		// links
		if (site) {
			// ---   update links a[data-assets-rewrite]
			s._el.querySelectorAll('a[data-assets-rewrite]').forEach(function (el) {
				/** @type {Array} */
				var tokens;
				/** @type {number} */
				var i, ilen;

				if (!el.hasAttribute('data-hash'))
					return;

				str = s.siteRoot + 'frontend/dashboard/gv#' + el.getAttribute('data-hash');

				try {
					tokens = el.getAttribute('data-assets-rewrite').split(',');
				}
				catch (err) {
					console.log('[HUDWidget._locationChanged] Unable to retrieve hash rewrite tokens from: "' + el.getAttribute('data-assets-rewrite') + '"');
					tokens = [];
				}

				// ["site", "synopsis"]
				for (i = 0, ilen = tokens.length; i < ilen; ++i) {
					switch (tokens[i]) {
						case 'site':
							str += '/site-' + site.id;
							break;
						case 'dashboardPage':
							if (site.dashboardPages.length > 0)
								str += '/dashboardpage-' + site.dashboardPages[0].id;
							break;
						case 'synopsis':
							if (site.synoptiques.length > 0)
								str += '/synopsis-' + site.synoptiques[0].id;
							break;
					}
				}
				el.setAttribute('href', str);
			});

			// ---   update links a[data-assets-replace]
			s._el.querySelectorAll('a[data-assets-replace]').forEach(function (el) {
				str = s.siteRoot + el.getAttribute('data-hash');
				if (!str || str == null){
					str = '';
				}
				if(typeof(str) == 'string'){
					str = str.replace('##site##', site.id);
					str = str.replace('##enterprise##', site?.entreprise?.id ?? "");
				}
				el.setAttribute('href', str);
				el.classList.remove('mod--disabled');
			});
		}
		else {
			s._el.querySelectorAll('a[data-assets-rewrite], a[data-assets-replace]').forEach(function (el) {
				el.removeAttribute('href');
				el.classList.remove('mod--disabled');
			});
		}


		p = d.getElementById('hudc__navmode-navigation').querySelector('li[data-nav-mode="sections"]');
		if (p)
			p.classList.toggle('state--disabled', (!G.model.siteSelected && d.body.classList.contains('state--backend')));


		// ---   set active links

		all = s._el.querySelectorAll('a.state--active');
		if (all) {
			all.forEach(function (el) {
				el.classList.remove('state--active');
			});
		}

		all = s._el.querySelectorAll('a[href$="' + window.location.pathname + window.location.hash + '"]');

		if (all) {
			all.forEach(function (el) {
				el.classList.add('state--active');
			});
		}
	};

	/**
	 * @param 	data {G.vo.Site|string|number|null}    site or site UIID
	 */
	this.siteSet = function (data) {
		if (!data)
			return G.model.setSite(null);
		else if (data.hasOwnProperty('id'))
			return G.model.setSite(data.id);
		G.model.setSite(data);
	};

	/**
	 * @private
	 */
	this._siteDataComplete = function () {
		/** @type {HTMLElement} */
		var panel = d.getElementById('hudc__panels--site_settings');

		if (panel.getAttribute('data-site-id') == G.model.siteSelected.id) {
			console.log('[HUDWidget._siteDataComplete] Cancel useless call for site: #' + G.model.siteSelected.id);
			return;
		}

		/** @type {string} */
		var addIcon = '<i class="far fa-plus-square"></i>';
		/** @type {HTMLElement} */
		var
			p,
			spacer;
		/** @type {number} */
		var
			i,
			ilen;

		/** @type {G.vo.Site} */
		var site = G.model.siteSelected;

		spacer = d.createElement('tr');
		spacer.classList.add('hudc__line', 'mod--spacer', 'mod--disabled');
		spacer.innerHTML = '<td colspan="3"></td>';

		if (exists(site)) {
			panel.setAttribute('data-site-id', G.model.siteSelected.id);

			// ---   complete synopsis list
			p = panel.querySelector('table.hudc__table[data-container="synopsis"]');
			p.innerHTML = '';

			for (i = 0, ilen = site.synoptiques ? site.synoptiques.length : 0; i < ilen; ++i) {
                let synoptic       = site.synoptiques[i];
                let synopticId     = synoptic.id;
                let synopticSiteId = synoptic.siteId;
                let synopticName   = synoptic.nom;
                let synopticSiteName = "";

                // Site patrimoine : les synoptiques peuvent venir des sites enfants
                if (site.isEstateSite == 1) {
                    const synopticSite = site.estateSiteChilds.find(child => child.id == synopticSiteId) ?? null;

                    // Si le synoptique appartient à un enfant, on ajoute le nom du site associé en 2e colonne
                    if (exists(synopticSite)) {
                        synopticSiteName = synopticSite.nom;
                    }
                }

                p.appendChild(s._lineCreate2Col(synopticName, synopticSiteName, s.siteRoot + 'backend/synoptique/create/' + synopticId, null));

            }

			p.appendChild(spacer.cloneNode());
			p.appendChild(s._lineCreate2Col(addIcon + s._loc('hud.addLabels.synopsis'), '', s.siteRoot + 'backend/synoptique/create', 'state--button'));


			// ---   complete equipments list
			p = panel.querySelector('table.hudc__table[data-container="equipment"]');
			p.innerHTML = '';

			for (i = 0, ilen = site.equipments ? site.equipments.length : 0; i < ilen; ++i)
				p.appendChild(s._lineCreate2Col(site.equipments[i]['nom'], site.equipments[i]['markName'], s.siteRoot + 'backend/equipement/create/' + site.equipments[i]['id'], null));

			// ---   complete reports list
			p = panel.querySelector('table.hudc__table[data-container="reports"]');
			p.innerHTML = '';

			for (i = 0, ilen = site.reports ? site.reports.length : 0; i < ilen; ++i)
				p.appendChild(s._lineCreate2Col(site.reports[i]['nom'], '', s.siteRoot + 'backend/rapport/create/' + site.reports[i]['id'], null));

			p.appendChild(spacer.cloneNode());
			p.appendChild(s._lineCreate2Col(addIcon + s._loc('hud.addLabels.report'), '', s.siteRoot + 'backend/rapport/create', 'state--button'));
		}
	};

	/**
	 * Displays title
	 * @param t {string}
	 * @param subt {?string}
	 * @param isSite {?string}
	 * @private
	 */
	this._summarySet = function (t, subt, isSite) {
		isSite = (isSite !== false);

		/** @type {string} */
		var s = '<span>' + t + '</span>';
		if (isSite && subt)
			s += '<small>' + subt + '</small>';
		d.getElementById('hudm-' + (isSite ? 'sites' : 'sections') + '-pad__summary').innerHTML = s;
	};

	/**
	 * @param label {string}
	 * @param comment {string}
	 * @param url {string}
	 * @param xtraClass {string|null}
	 * @return {HTMLElement}
	 * @private
	 */
	this._lineCreate2Col = function (label, comment, url, xtraClass) {
		/** @type {HTMLElement} */
		var l;

		l = d.createElement('tr');
		l.classList.add('hudc__line', xtraClass);
		l.innerHTML =
			'<td class="mod--label"><a href="' + url + '">' + label + '</a></td>'
			+ '<td class="mod--size-l">' + comment + '</td>';
		return l;
	};

	/**
	 * Displays section title in feedback zone.
	 */
	this.feedbackTitleDisplay = function () {
		d.getElementById('hudc__summary')
			.querySelector('.hudc__summary__title')
			.innerHTML = (s._navMode === hud.NAV_MODE.closed) ? '' : s._loc('hud.feedbackTitles.' + s._navMode);
	};

	/**
	 * Displays localizable context in feedback zone.
	 * @param locPath   {string}
	 * @param context {{}}
	 */
	this.feedbackLocContextDisplay = function (locPath, context) {
		/** @type {string} */
		var str, prop;
		str = s._loc(locPath);
		for (prop in context)
			str = str.replace('{' + prop + '}', context[prop]);
		s.feedbackContextDisplay(str);
	};

	/**
	 * Displays raw context in feedback zone.
	 * @param raw   {string|Array}
	 */
	this.feedbackContextDisplay = function (raw) {
		if (isarray(raw))
			raw = raw.join('&nbsp;›&nbsp;');

		d.getElementById('hudc__summary')
			.querySelector('.hudc__summary__feedback')
			.innerHTML = raw;
    };


	// ------------------------------------------------------------------------------------------------------
	//    FOCUS UTILITIES
	// ------------------------------------------------------------------------------------------------------

	// ######### FOCUS

	/** @private */
	this._focusClear = function () {
		this._el.querySelectorAll('tr.hudc__line.state--focused').forEach(function (el) {
			el.classList.remove('state--focused');
		});
		s._fline = null;
		s._fctx = null;
	};

	/**
	 * Applies focus on the passed-in line and handles slave list display filters.
	 * @param l   {HTMLElement}
	 * @private
	 */
	this._focusSetLine = function (l) {
		/** @type {Array} */
		var slavesList;
		var mbSlavesList;
		/** @type {number} */
		var i, ilen;
		/** @type NodeListOf<Element> */
		var panels;


		// ---   toggler behaviour
		if (s._isMobile && l && s._fline && l === s._fline && l.classList.contains('state--focused')) {
			s._focusClear();
			return;
		}

		s._focusClear();

		// ---   set focused line
		s._fline = l;

		if (!l)
			return console.warn('[HUDWidget._focusSetLine] Unable to set focus ; no line is focused yet');

		// --- cancel scroll adjustement for desktop version
		if (!s._isMobile)
			l.closest('.hudc__content').scrollTop = l.offsetTop;


		// ---   retrieve focus context

		s._fctx = {
			index: -1,
			previousPanel: null,
			nextPanel: null,
			table: l.closest('table.hudc__table'),
			panel: l.closest('.hudc__panel'),
			master: null
		};

		panels = s.getPanels(null).querySelectorAll('.hudc__panel');
		ilen = panels ? panels.length : 0;
		for (i = 0; i < ilen; ++i) {
			if (panels[i] === s._fctx.panel) {
				s._fctx.index = i;
				break;
			}
		}
		if (s._fctx.index < 0)
			console.log('[HUDWidget._focusSetLine] Unable to retrieve focused panel');
		else {
			s._fctx.previousPanel = s._fctx.index > 0 ? panels[s._fctx.index - 1] : null;
			s._fctx.nextPanel = s._fctx.index < ilen - 1 ? panels[s._fctx.index + 1] : null;
			s._fctx.master = s._fctx.table.hasAttribute('data-container') && s._fctx.previousPanel ?
				s._fctx.previousPanel.querySelector('tr.hudc__line[data-container="' + s._fctx.table.getAttribute('data-container') + '"]:not([data-mode-setter])') :
				null;
		}


		// --- display focus

		l.classList.add('state--focused');

		if (s._fctx && s._fctx.master)
			s._fctx.master.classList.add('state--focused');

		// --- apply change on slaves lists
		slavesList = s._fctx.nextPanel ? Array.from(s._fctx.nextPanel.querySelectorAll('table')) : [];
		if (!slavesList || slavesList.length === 0)
			return console.log('[HUDWidget._focusSetLine] No slaves list to update.');

		if (l.hasAttribute('data-container'))
			slavesList.forEach(function (el) {
				el.classList.toggle('state--hidden', el.getAttribute('data-container') !== l.getAttribute('data-container'));
			});
		else
			slavesList.forEach(function (el) {
				el.classList.add('state--hidden');
			});
	};

	/**
	 * Sets focus on the default line corresponding to the passed-in panel. If panel parameter is omitted, use the current navigation mode panel default.
	 * @param panel {Element|null}
	 */
	this.focusSetPanelDefault = function (panel) {
		/** @type {NodeListOf<HTMLElement>} */
		var l;

		if (s._isMobile)
			return;

		if (!panel) {
			panel = s.getPanels(null);
			if (!panel)
				return;
			panel = panel.querySelector('.hudc__panel.mod--focus-start');
		}

		if(s._navMode == 'sites'){
			if($('#hudc__panel--site-type table').length == 0){
				if(!this._isAjaxHudgetSitesRunning) {
					this._isAjaxHudgetSitesRunning = true;
					$.ajax({
						url: "/frontend/ajax/hudgetsites",
						type: 'GET',
						error: function (xhr, textStatus, errorThrown) {
							G.ui.fatalError("ajax error: " + textStatus, {url: this.url, error: errorThrown});
						},
						success: function (data, textStatus, xhr) {
							if (data.substr(0, 4) == "$ERR") {
								showError(data.substr(4));
								return true;
							}
							$('#hudc__panels--sites').empty().append(data);
						},
						complete: function() {
							this._isAjaxHudgetSitesRunning = false;
						}
					});
				}
			}
			l = panel.querySelectorAll('.hudc__table:not(.state--hidden) tr.hudc__line:not(.mod--disabled)');
			if (l && l.length > 0)
				s._focusSetLine(l[0]);
	
			if ($('.hudc__table tbody tr.mod--site-type').length == 1) {
				$('.hudc__table tbody tr.mod--site-type')[0].click();
			}
			return;
		}else if(s._navMode == 'companies'){
			if($('#hudc__panel--site-companies table').length == 0){
				if(!this._isAjaxGetCompaniesRunning) {
					this._isAjaxGetCompaniesRunning = true;
					$.ajax({
						url: "/frontend/ajax/getcompanies",
						type: 'GET',
						error: function (xhr, textStatus, errorThrown) {
							G.ui.fatalError("ajax error: " + textStatus, {url: this.url, error: errorThrown});
						},
						success: function (data, textStatus, xhr) {
							if (data.substr(0, 4) == "$ERR") {
								showError(data.substr(4));
								return true;
							}
							$('#hudc__panels--companies').empty().append(data);
						},
						complete: function() {
							this._isAjaxGetCompaniesRunning = false;
						}
					});
				}
			}
			l = panel.querySelectorAll('.hudc__table:not(.state--hidden) tr.hudc__line:not(.mod--disabled)');
			if (l && l.length > 0)
				s._focusSetLine(l[0]);
	
			if ($('.hudc__table tbody tr.mod--site-type').length == 1) {
				$('.hudc__table tbody tr.mod--site-type')[0].click();
			}
			return;
		} else {
			if (!panel) {
				console.log('[HUDWidget.focusSetPanelDefault] Unable to find a valid panel for navMode: "' + s._navMode + '"');
				return;
			}
			l = panel.querySelectorAll('.hudc__table:not(.state--hidden) tr.hudc__line:not(.mod--disabled)');
			if (l && l.length > 0)
				s._focusSetLine(l[0]);
	
			if ($('.hudc__table tbody tr.mod--site-type').length == 1) {
				$('.hudc__table tbody tr.mod--site-type')[0].click();
			}

		}
	};

	/**
	 * @param moveForward {boolean}
	 * @private
	 */
	this._focusHorChange = function (moveForward, target) {
		/** @type {HTMLElement} */
		var
			table,
			tgtLine,
			l = s._fline;

		if (s._isMobile) {
			console.log('\t - mobile context ; cancel call')
			return;
		}

		if (!l)
			return;

		if (moveForward && s._fctx.nextPanel) {
			s.focusSetPanelDefault(/** @type HTMLElement */s._fctx.nextPanel);
		}
		else if (!moveForward && s._fctx.previousPanel) {
			// find parent line
			table = l.closest('table.hudc__table');
			tgtLine = s._fctx.previousPanel.querySelector('tr.hudc__line[data-container="' + table.getAttribute('data-container') + '"]');
			if (tgtLine && table.hasAttribute('data-container'))
				return s._focusSetLine(tgtLine);
			// ...or use default
			return s.focusSetPanelDefault(/** @type HTMLElement */s._fctx.previousPanel);
		}
	};

	/**
	 * @param moveForward {boolean}
	 * @private
	 */
	this._focusVertChange = function (moveForward) {
		var newFocus;
		/** @type {boolean} */
		var found = false;

		if (!s._fline)
			return;

		newFocus = s._fline;
		while (!found) {
			newFocus = (moveForward ? newFocus.nextElementSibling : newFocus.previousElementSibling);
			if (!newFocus)
				break;
			found = !newFocus.classList.contains('mod--disabled');
		}
		if (newFocus)
			s._focusSetLine(newFocus);
	};

	/**
	 * @param moveForward {boolean}
	 * @private
	 */
	this._focusNavModeChange = function (moveForward) {
		/** @type {Array} */
		var elsArr = Array.from(d.getElementById('hudc__navmode-navigation')
			.querySelectorAll('[data-nav-mode][data-mode-setter][data-key-enabled]:not(.state--disabled)'));
		/** @type {number} */
		var index = -1;

		for (var i = 0, ilen = elsArr.length; i < ilen; ++i) {
			if (elsArr[i].getAttribute('data-nav-mode') === s._navMode) {
				index = i;
				break;
			}
		}

		if (i < 0)
			return;

		s.setNavMode(elsArr[(index + (moveForward ? 1 : -1) + ilen) % ilen].getAttribute('data-nav-mode'));
	};


	// ######### USER PANEL

	/**
	 * @type {number}
	 * @private
	 */
	this._userPanelOpenUIID = Number.NaN;

	/**
	 * @param e {Event}
	 * @private
	 */
	this._userPanelOpen = function (e) {
		/** @type {boolean} */
		var
			status = (e && e.type === 'mouseover'),
			applyCall = (e === null)
			;
		/** @type {HTMLElement} */
		var userPanel = d.getElementById('hudm-user-panel');

		if (status) {
			if (s._userPanelOpenUIID)
				clearTimeout(s._userPanelOpenUIID);
			userPanel.classList.add('state--opened');

			s._actionsPanelOpen(null);
			s._userNotificationPanelOpen(null);
		}
		else if (!applyCall) {
			s._userPanelOpenUIID = setTimeout(function () {
				s._userPanelOpen(null);
			}, 800);
		}
		else {
			if (s._userPanelOpenUIID)
				clearTimeout(s._userPanelOpenUIID);
			userPanel.classList.remove('state--opened');
		}
	};

	// ######### USER NOTIFICATION PANEL

	/**
	 * @type {number}
	 * @private
	 */
	this._userNotificationPanelOpenUIID = Number.NaN;

	/**
	 * @param e {Event}
	 * @private
	 */
	this._userNotificationPanelOpen = function (e) {
		/** @type {boolean} */
		var
			status = (e && e.type === 'mouseover'),
			applyCall = (e === null)
		;
		/** @type {HTMLElement} */
		var userNotificationPanel = d.getElementById('hudm-user-notification-panel');

		if (status) {
			if (s._userNotificationPanelOpenUIID)
				clearTimeout(s._userNotificationPanelOpenUIID);
			userNotificationPanel.classList.add('state--opened');
			this._declareAllUserNotificationsAsSeen();
			s._actionsPanelOpen(null);
			s._userPanelOpen(null);
		}
		else if (!applyCall) {
			s._userNotificationPanelOpenUIID = setTimeout(function () {
				s._userNotificationPanelOpen(null);
			}, 800);
		}
		else {
			if (s._userNotificationPanelOpenUIID)
				clearTimeout(s._userNotificationPanelOpenUIID);
			userNotificationPanel.classList.remove('state--opened');
		}
	}


	/**
	 * @private
	 */
	this._userNotificationPanelReflow = function () {
		d.getElementById('hudm-user-notification-panel').style.left = d.getElementById('hudm-user-notification').getBoundingClientRect().right + 'px';
	};


	// ######### ACTIONS PANEL

	/**
	 * @type {number}
	 * @private
	 */
	this._actionsPanelOpenUIID = Number.NaN;

	/**
	 * @param e {Event}
	 * @private
	 */
	this._actionsPanelOpen = function (e) {
		/** @type {boolean} */
		var
			status = (e && e.type === 'mouseover'),
			applyCall = (e === null)
			;
		/** @type {HTMLElement} */
		var actionPanel = d.getElementById('hudm-actions-panel');

		if (status) {
			if (s._actionsPanelOpenUIID)
				clearTimeout(s._actionsPanelOpenUIID);
			actionPanel.classList.add('state--opened');
			s._userPanelOpen(null);
			s._userNotificationPanelOpen(null);
		}
		else if (!applyCall) {
			s._actionsPanelOpenUIID = setTimeout(function () {
				s._actionsPanelOpen(null);
			}, 800);
		}
		else {
			if (s._actionsPanelOpenUIID)
				clearTimeout(s._actionsPanelOpenUIID);
			actionPanel.classList.remove('state--opened');
		}
	};

	/**
	 * @private
	 */
	this._actionsPanelReflow = function () {
		d.getElementById('hudm-actions-panel').style.left = d.getElementById('hudm-actions-pad').getBoundingClientRect().right + 'px';
	};



	// ------------------------------------------------------------------------------------------------------
	//    DOM
	// ------------------------------------------------------------------------------------------------------

	/**
	 * @param {string}         type
	 * @param {{}}             data
	 * @return {HTMLElement}
	 */
	this.domBuildSearchLine = function (type, data) {
		/** @type {HTMLElement} */
		var line;
		/** @type {?string} */
		var
			html = '',
			label = '',
			comment = '',
			linkDft,
			linkCustom = null,
			linkEdit = null,
			linkView = null;
		/** @type {G.vo.Model} */
		var m = G.model;
		/** @type {G.vo.Site} */
		var site = null;

		if(type === "site") site = Object.assign({}, data ?? null);
		else if(exists(data['site'])) site = Object.assign({}, data['site']);
		else site = null;

		if (!site && type !== 'enterprise' && type !== 'favorite' && type !== 'user' && type !== 'label') {
			console.warn('[!ERROR] [HUDSearch._showSearchResults] "' + type + '" ; Unable to find site for id: ' + data['site_id'], 'context: ', data);
			return null;
		}

		switch (type) {

			case 'label':
				label = '<span class="hudc__line__block"><em>' + s._loc(data.label) + '</em></span>';
				break;

			case 'favorite':
				label = '<span class="hudc__line__block"><em>' + data.label + '</em></span>';
				if (data.site)
					comment = '<span class="lhudc__line__block">' + data.site.nom + ', ' + data.site.ville + '</span>';
				linkView = data.url;
				linkCustom = '<a href="#" data-id="' + data.id + '" data-action="delete-favorite" class="hudc__line__icon-link">'
					+ '<i class="fas fa-times" data-id="' + data.id + '"></i>'
					+ '</a>';
				break;

			case 'equipment':
				//  { id, mnemonique, nom, marque, site_id }
				label = '<span class="hudc__line__block">[' + data['marque'] + ']</span>'
					+ '<span class="hudc__line__block"><em>' + data['nom'] + '</em></span>';
				comment = '<span class="lhudc__line__block">' + site.nom + ', ' + site.ville + '</span>';
				linkEdit = 'backend/equipement/create/' + data['id'];
				break;

			case 'enterprise':
				// { id, nom }
				label = '<span class="hudc__line__block"><em>' + data['nom'] + '</em></span>';
				linkEdit = 'backend/entreprise/create/' + data['id'];
				break;

			case 'user':
				// { id, nom, entreprise.nom }
				label = '<span class="hudc__line__block"><em>' + data['prenom'] + ' ' + data['nom'] + '</em>, ' + data['entreprise']['nom'] ?? "" + '</span>';
				linkEdit = 'backend/user/create/' + data['id'];
				break;

			case 'synopsis':
				// { id, nom, site.nom, site.ville }
				label = '<span class="hudc__line__block"><em>' + data['nom'] + '</em></span>';
				comment = '<span class="hudc__line__block">' + site.nom + ', ' + site.ville + '</span>';
				linkEdit = 'backend/synoptique/create/' + data['id'];
				linkView = 'frontend/dashboard/gv#exploitation/site-' + site.id + '/synopsis-' + data['id'];
				break;

			case 'site':
				// { id, nom, ville, entreprise.nom }
				label = '<span class="hudc__line__block"><em>' + site.nom + '</em>, ' + site.ville + '</span>';
				comment = '<span class="hudc__line__block">' + site?.entreprise?.nom ?? "" + '</span>';
				linkEdit = 'backend/site/dashboard/' + site.id;
				linkView = 'frontend/dashboard/gv#' + m.getHash(m.sectionSelected.id, site.id);
				break;
		}


		// ---   links

		if (linkEdit)
			linkEdit = s.siteRoot + linkEdit;
		if (linkView)
			linkView = s.siteRoot + linkView;

		if (!s.userCanEdit(type))
			linkEdit = null;
		linkDft = linkView || linkEdit;


		// ---   create table row line

		line = d.createElement('tr');
		line.classList.add('hudc__line', 'mod--' + type);


		// --- label exception

		if (type == 'label') {
			line.classList.add('mod--disabled');
			line.innerHTML = '<td class="mod--label resp--top resp--bottom" colspan="3">' + label + '</td>';
			return line;
		}
		else if (!linkDft)
			return null;


		// --- label
		html += '<td class="mod--label resp--top resp--has-actions">';
		if (linkDft)
			html += '<a href="' + linkDft + '">';
		html += label;
		if (linkDft)
			html += '</a>';
		html += '</td>';

		// --- comment
		html += '<td class="mod--size-l resp--bottom resp--has-actions">' + comment + '</td>';

		// --- links
		html += '<td class="mod--size-s resp--is-actions">';
		if (linkCustom)
			html += linkCustom;
		else {
			if (linkView)
				html += '<a href="' + linkView + '" class="hudc__line__icon-link"><i class="far fa-eye"></i></a>';
			if (linkEdit)
				html += '<a href="' + linkEdit + '" class="hudc__line__icon-link"><i class="far fa-edit"></i></a>';
		}
		html += '</td>';


		line.innerHTML = html;
		return line;
	};


	// ------------------------------------------------------------------------------------------------------
	//    INTERACTIONS
	// ------------------------------------------------------------------------------------------------------

	/**
	 * @private
	 */
	this._interactionsEnable = function () {

		d.querySelectorAll('a[data-action="add-favorite"]').forEach(function (el) {
			el.addEventListener('click', function (e) {
				e.preventDefault();
				s._hudFavorites.add();
				return false;
			});
		});

		d.querySelectorAll('a[data-action="add-comment"]').forEach(function (el) {
			el.addEventListener('click', function (e) {
				e.preventDefault();

                const now = moment().format('YYYY-MM-DDTHH:mm');

                const modalId = 'swal-comment-' + Date.now();

                const id = (name) => `${modalId}-${name}`;
                const sel = (name) => `#${id(name)}`;

                Swal.fire({
                    title: G.config.LOCALE_RETRIEVE('comment.add_comment'),
                    width: 600,
                    showCancelButton: true,
                    reverseButtons: true,
                    confirmButtonText: G.config.LOCALE_RETRIEVE('general.save'),
                    cancelButtonText: G.config.LOCALE_RETRIEVE('general.cancel'),
                    showLoaderOnConfirm: true,
                    allowOutsideClick: function () { return !Swal.isLoading(); },
                    customClass: {
                        closeButton:   'uicomp__button uicomp--transparent',
                        input:         'uicomp__input',
                        inputLabel:    'uicomp__label',
                        confirmButton: 'uicomp__button uicomp--brand',
                        denyButton:    'uicomp__button uicomp--grey',
                        cancelButton:  'uicomp__button uicomp--red'
                    },
                    footer: `
                        <div class="text-flow">
                            <a href="${G.config.SERVER}documentation/documentation/page/169" class="fake-link" target="_blank">
                                <strong>${G.config.LOCALE_RETRIEVE('comment.access_documentation')} <i class="fal fa-external-link"></i></strong>
                            </a>
                        </div>
                    `,
                    html: `
                        <form id="${id('form-commentaire')}">
                            <div class="gvg-r gvg-r--gutter">
                                <div class="gvg-6on6">
                                    <label class="uicomp__label is-required" for="${id('sel-site')}">${G.config.LOCALE_RETRIEVE('comment.site')}</label>
                                    <select id="${id('sel-site')}" name="site" class="select2 select2-full-width"></select>
                                </div>
                                <div class="gvg-6on6">
                                    <label class="uicomp__label" for="${id('sel-equipment')}">${G.config.LOCALE_RETRIEVE('comment.equipment')}</label>
                                    <select id="${id('sel-equipment')}" name="equipment" class="select2 select2-full-width"></select>
                                </div>
                                <div class="gvg-6on6">
                                    <label class="uicomp__label is-required" for="${id('sel-type')}">${G.config.LOCALE_RETRIEVE('comment.type')}</label>
                                    <select id="${id('sel-type')}" name="type" class="select2 select2-full-width"></select>
                                </div>
                                <div class="gvg-6on6">
                                    <label class="uicomp__label is-required" for="${id('txt-objet')}">${G.config.LOCALE_RETRIEVE('comment.object')}</label>
                                    <input id="${id('txt-objet')}" name="object" type="text" class="uicomp__input"
                                           placeholder="${G.config.LOCALE_RETRIEVE('comment.object')}" style="width:100%; max-width:none;" />
                                </div>
                                <div class="gvg-6on6">
                                    <label class="uicomp__label is-required" for="${id('txt-description')}">${G.config.LOCALE_RETRIEVE('comment.description')}</label>
                                    <textarea id="${id('txt-description')}" name="description" rows="3" class="uicomp__input"
                                              placeholder="${G.config.LOCALE_RETRIEVE('comment.description')}"
                                              style="width:100%; max-width:none; resize:vertical;"></textarea>
                                </div>
                                <div class="gvg-6on6">
                                    <label class="uicomp__label is-required" for="${id('txt-date')}">${G.config.LOCALE_RETRIEVE('comment.date')}</label>
                                    <input id="${id('txt-date')}" name="date" type="datetime-local" class="uicomp__input"
                                           value="${now}" style="width:100%; max-width:none; display: block;" />
                                </div>
                                <div class="gvg-6on6" ${G.model.user.isSuperAdmin ? '' : 'style="display:none;"'}>
                                    <label class="gv-ui-ckeckbox" for="${id('cbx-internal')}">
                                        <input type="checkbox" id="${id('cbx-internal')}" name="internal" value="1" />
                                        <span class="value-map">${G.config.LOCALE_RETRIEVE('comment.internal')}</span>
                                    </label>
                                </div>
                            </div>
                        </form>
                    `,
                    didRender: () => {
                        $(sel('form-commentaire')).on('submit', function (e) {
                            e.preventDefault();
                        });

                        G.ui.initSelect2($(sel('sel-type') + ', ' + sel('sel-site') + ', ' + sel('sel-equipment')));

                        $(sel('sel-equipment')).append(new Option(G.config.LOCALE_RETRIEVE('comment.none'), '', true, true)).trigger('change');

                        $.ajax({
                            url: G.config.SERVER + 'apigv/sites/list',
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': 'Bearer ' + G.model.userApiKey
                            },
                            dataType: 'json',
                            success: function (response) {
                                if (response?.status === 'success' && Array.isArray(response?.response?.sites)) {
                                    $(sel('sel-site')).append(new Option(G.config.LOCALE_RETRIEVE('comment.none'), '', true, true));

                                    response.response.sites.forEach(function (site) {
                                        $(sel('sel-site')).append(new Option(site.nom, site.id));
                                    });

                                    $(sel('sel-site')).trigger('change');
                                } else {
                                    showError(response?.message ?? G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
                                }
                            },
                            error: function (xhr) {
                                showError(xhr.responseJSON.message ?? G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
                            }
                        });

                        $(sel('sel-site')).on('change', function () {
                            const siteId = $(this).val();

                            $(sel('sel-equipment')).empty().trigger('change');

                            if (!siteId) {
                                $(sel('sel-equipment')).append(new Option(G.config.LOCALE_RETRIEVE('comment.none'), '', true, true)).trigger('change');
                                return;
                            }

                            $.ajax({
                                url: G.config.SERVER + 'apigv/sites/devices/' + siteId + '?onlyActive=1',
                                method: 'GET',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': 'Bearer ' + G.model.userApiKey
                                },
                                dataType: 'json',
                                success: function (response) {
                                    if (response?.status === 'success' && Array.isArray(response?.response?.devices)) {
                                        $(sel('sel-equipment')).append(new Option(G.config.LOCALE_RETRIEVE('comment.none'), '', true, true));

                                        response.response.devices.forEach(function (device) {
                                            $(sel('sel-equipment')).append(new Option(device.nom, device.id));
                                        });

                                        $(sel('sel-equipment')).trigger('change');
                                    } else {
                                        showError(response?.message ?? G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
                                    }
                                },
                                error: function (xhr) {
                                    showError(xhr.responseJSON?.message ?? G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
                                }
                            });
                        });

                        ['commentaire', 'intervention', 'maj'].forEach(function (val) {
                            const labels = {
                                commentaire:  G.config.LOCALE_RETRIEVE('comment.type_comment'),
                                intervention: G.config.LOCALE_RETRIEVE('comment.type_intervention'),
                                maj:          G.config.LOCALE_RETRIEVE('comment.type_update')
                            };
                            $(sel('sel-type')).append(new Option(labels[val], val));
                        });
                        $(sel('sel-type')).val('commentaire').trigger('change');

                        $(Swal.getHtmlContainer()).find('.gv-ui-ckeckbox').each(function (index, el) {
                            $(el).find('input[type="checkbox"], input[type="radio"]').after($('<div class="gv-ui__mock"></div>'));
                        });

                        $(Swal.getHtmlContainer()).find(sel('form-commentaire'))
                            .on('keypress', function (e) {
                                if (e.which === 13) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    Swal.clickConfirm();
                                }
                            });
                    },
                    didOpen: () => {
                        let focusElFirst$ = $(Swal.getHtmlContainer()).find("input:not([type=hidden]), select, textarea").first();
                        if (focusElFirst$.is("select.select2-hidden-accessible")) {
                            const select2Selection$ = focusElFirst$.next(".select2").find(".select2-selection").first();
                            if (select2Selection$.length) select2Selection$.trigger("focus");
                        } else {
                            focusElFirst$.focus();
                        }
                    },
                    preConfirm: async () => {
                        const objet       = $(sel('txt-objet')).val().trim();
                        const description = $(sel('txt-description')).val().trim();
                        const date        = $(sel('txt-date')).val().trim();
                        const site        = $(sel('sel-site')).val();
                        const equipment   = $(sel('sel-equipment')).val();
                        const type        = $(sel('sel-type')).val();
                        const internal    = $(sel('cbx-internal')).is(':checked') ? 1 : 0;

                        const newCommentParams = {
                            idSite:      site,
                            type:        type,
                            object:      objet,
                            description: description,
                            date:        date,
                            internal:    internal
                        };

                        if (equipment) { newCommentParams["idEquipement"] = equipment; }

                        if (!objet) {
                            Swal.showValidationMessage(
                                G.config.LOCALE_RETRIEVE('general.field_required')?.replace('{FIELD}', G.config.LOCALE_RETRIEVE('comment.object'))
                            );
                            return false;
                        }
                        if (!description) {
                            Swal.showValidationMessage(
                                G.config.LOCALE_RETRIEVE('general.field_required')?.replace('{FIELD}', G.config.LOCALE_RETRIEVE('comment.description'))
                            );
                            return false;
                        }
                        if (!date) {
                            Swal.showValidationMessage(
                                G.config.LOCALE_RETRIEVE('general.field_required')?.replace('{FIELD}', G.config.LOCALE_RETRIEVE('comment.date'))
                            );
                            return false;
                        }

                        const response = await $.ajax({
                            url: G.config.SERVER + 'apigv/profile/comment',
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': 'Bearer ' + G.model.userApiKey
                            },
                            data: JSON.stringify(newCommentParams),
                            dataType: 'json'
                        }).catch(function (xhr) {
                            Swal.showValidationMessage(
                                xhr.responseJSON?.message ?? G.config.LOCALE_RETRIEVE('general.errorHasOccured')
                            );
                        });

                        if (response && (response.status ?? 'error') !== 'success') {
                            Swal.showValidationMessage(response.message ?? G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
                        } else {
                            return response;
                        }
                    }
                }).then(function (result) {
                    if (!result.isConfirmed) return;

                    const data = result.value;

                    if (data?.status === "success") {
                        Swal.fire({
                            icon: 'success',
                            title: G.config.LOCALE_RETRIEVE('general.saveSuccess'),
                            confirmButtonText: "Ok",
                            customClass: {
                                closeButton:   'uicomp__button uicomp--transparent',
                                input:         'uicomp__input',
                                inputLabel:    'uicomp__label',
                                confirmButton: 'uicomp__button uicomp--brand',
                                denyButton:    'uicomp__button uicomp--grey',
                                cancelButton:  'uicomp__button uicomp--red'
                            }
                        });
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: G.config.LOCALE_RETRIEVE('general.error'),
                            text: data?.message ?? G.config.LOCALE_RETRIEVE('general.errorHasOccured'),
                            confirmButtonText: "Ok",
                            customClass: {
                                closeButton:   'uicomp__button uicomp--transparent',
                                input:         'uicomp__input',
                                inputLabel:    'uicomp__label',
                                confirmButton: 'uicomp__button uicomp--brand',
                                denyButton:    'uicomp__button uicomp--grey',
                                cancelButton:  'uicomp__button uicomp--red'
                            }
                        });
                    }
                });
				return false;
			});
		});

		d.querySelectorAll('a[data-action="add-dysfonctionnement"]').forEach(function (el) {
			el.addEventListener('click', function (e) {
				e.preventDefault();

				const modalId = 'swal-dys-' + Date.now();
				const id = (name) => `${modalId}-${name}`;
				const sel = (name) => `#${id(name)}`;

				Swal.fire({
					title: G.config.LOCALE_RETRIEVE('general.dysfonctionnementTitle'),
					draggable: true,
					width: 1000,
					showCancelButton: true,
					reverseButtons: true,
					confirmButtonText: G.config.LOCALE_RETRIEVE('general.save'),
					cancelButtonText: G.config.LOCALE_RETRIEVE('general.cancel'),
					showLoaderOnConfirm: true,
					allowOutsideClick: () => !Swal.isLoading(),
					customClass: {
						confirmButton: 'uicomp__button uicomp--brand',
						cancelButton:  'uicomp__button uicomp--grey'
					},
					footer: `
						<div class="text-flow">
							<a href="${G.config.SERVER}frontend/dashboard/ticket_list">
								<strong>${G.config.LOCALE_RETRIEVE('comment.my_tickets')} <i class="fal fa-external-link"></i></strong>
							</a>
						</div>
						
					`,
					html: `
						<form id="${id('form-dys')}">
							<div class="row" style="text-align:left;">
								<div class="gr-12">
									<label class="uicomp__label is-required" for="${id('sel-site')}">${G.config.LOCALE_RETRIEVE(`comment.site`)}</label>
									<select id="${id('sel-site')}" name="site" class="select2 select2-full-width" style="width:100%"></select>
								</div>
								<div class="gr-12">
									<label class="uicomp__label" for="${id('sel-device')}">${G.config.LOCALE_RETRIEVE('comment.equipment')}</label>
									<select id="${id('sel-device')}" name="device" class="select2 select2-full-width" style="width:100%"></select>
								</div>
								<div class="gr-12">
									<label class="uicomp__label is-required" for="${id('sel-priority')}">${G.config.LOCALE_RETRIEVE(`general.priority`)}</label>
									<select id="${id('sel-priority')}" name="priority" class="select2 select2-full-width" style="width:100%">
										<option value="1">${G.config.LOCALE_RETRIEVE(`comment.low`)}</option>
										<option value="2" selected>${G.config.LOCALE_RETRIEVE(`comment.normal`)}</option>
										<option value="3">${G.config.LOCALE_RETRIEVE(`comment.high`)}</option>
										<option value="4">${G.config.LOCALE_RETRIEVE(`comment.critical`)}</option>
									</select>
								</div>
								<div class="gr-12">
									<label class="uicomp__label is-required" for="${id('txt-object')}">${G.config.LOCALE_RETRIEVE(`comment.object`)}</label>
									<input id="${id('txt-object')}" name="object" type="text" class="uicomp__input" style="width:100%;" />
								</div>
								<div class="gr-12">
									<label class="uicomp__label is-required" for="${id('txt-description')}">${G.config.LOCALE_RETRIEVE(`comment.description`)}</label>
									<textarea id="${id('txt-description')}" name="description" class="uicomp__input" style="width:100%; height:100px;"></textarea>
								</div>
							</div>
						</form>
					`,
					didRender: () => {
						G.ui.initSelect2($(sel('sel-site') + ', ' + sel('sel-device') + ', ' + sel('sel-priority')));

						
						$.ajax({
							url: G.config.SERVER + 'apigv/sites/list',
							method: 'GET',
							headers: { 
								'Content-Type': 'application/json',
								'Authorization': 'Bearer ' + G.model.userApiKey 
							},
							success: function (response) {
								if (response?.status === 'success') {
									$(sel('sel-site')).append(new Option('', '-1', true, true));
									response.response.sites.forEach(s => $(sel('sel-site')).append(new Option(s.nom, s.id)));
									$(sel('sel-site')).trigger('change');
								}
							}
						});

						
						$(sel('sel-site')).on('change', function () {
							const siteId = $(this).val();

							const $dev = $(sel('sel-device'));
							$dev.empty().trigger('change');

							if (!siteId || siteId === "-1") return;

							$dev.append(new Option(G.config.LOCALE_RETRIEVE('comment.none'), '-1'))
							$dev.trigger('change');

							$.ajax({
								url: G.config.SERVER + 'apigv/sites/devices/' + siteId + '?onlyActive=1',
								method: 'GET',
								headers: { 
									'Content-Type': 'application/json',
									'Authorization': 'Bearer ' + G.model.userApiKey 
								},
								success: function (response) {
									if (response?.status === 'success') {
										response.response.devices.forEach(d => $dev.append(new Option(d.nom, d.id)));
										$dev.trigger('change');
									}
								}
							});
						});
					},
					preConfirm: async () => {
						let selectedDevice = $(sel('sel-device')).val();
						if(!selectedDevice || selectedDevice === '-1') {
							selectedDevice = null;
						}

						const data = {
							idSite: $(sel('sel-site')).val(),
							idEquipement: selectedDevice,
							priority: $(sel('sel-priority')).val(),
							object: $(sel('txt-object')).val().trim(),
							description: $(sel('txt-description')).val().trim(),
							url: window.location.href
						};

						if (data.idSite === "-1" || !data.object || !data.description) {
							Swal.showValidationMessage(G.config.LOCALE_RETRIEVE('general.completeRequiredFields'));
							return false;
						}


						return await $.ajax({
							url: G.config.SERVER + 'apigv/tickets/dysfunction', 
							method: 'POST',
							headers: { 
								'Content-Type': 'application/json',
								'Authorization': 'Bearer ' + G.model.userApiKey 
							},
							data: JSON.stringify(data),
							contentType: 'application/json'
						}).catch(err => {
							Swal.showValidationMessage(err.responseJSON?.message || "Erreur lors de l'enregistrement");
						});
					}
				}).then((result) => {
					if (result.isConfirmed) {
						Swal.fire({
							"title": G.config.LOCALE_RETRIEVE('general.saveConfirmation'),
							"text": G.config.LOCALE_RETRIEVE('general.dysfonctionnementSentSucess'),
							"icon": "success",
							customClass: {
								confirmButton: 'uicomp__button uicomp--brand'
							},
						});
					}
				});
			});
		});

		d.querySelectorAll('a[data-action="mode-edition"]').forEach(function (el) {
			el.addEventListener('click', function (e) {
				e.preventDefault();
				$('.data-edit, .data-remove, .data-section-edit').toggle();
				$('.data-input-readonly').each(function() {
					const isReadonly = $(this).is('[readonly]');
					$(this).prop('readonly', !isReadonly);
				});
				return false;
			});
		});

		$('.gv-iicon-selector__select').find('select.select2-gviicon')
			.select2({
				width: 'resolve',
				templateResult: function (state) {
					if (!state.id) {
						return state.text;
					}

					return $(
						'<div class="select2-results__option--gv-iicon-selector tooltip--footer" data-module="tooltip" data-title="' + state.id + '">'
						+ '<div class="select2-results__option--icon gv-iicon-' + state.id + '"></div>'
						+ '</div>'
					);
				},
				data: G.model.icons.filter(function (el) {
					return el !== '' && el.indexOf('header-') !== 0;
				}),
				language: 'fr',
				dropdownCssClass: 'select2-dropdown--gv-iicon-selector'
			})
			.on('change', function () {
				$(this).closest('.gv-iicon-selector')
					.find('.gv-iicon-selector__preview-icon')
					.removeClass()
					.addClass('gv-iicon-selector__preview-icon gv-iicon-' + $(this).val());
			})
			.on('select2:opening', function (e) {
				var
					sel = $(this),
					d = G.model.icons.filter(function (el) {
						return el !== '' && el.indexOf('header-') !== 0;
					});

				sel.empty();
				d.forEach(function (el) {
					sel.append(new Option(el, el, false, false));
				});
			});

		$('.gv-iicon-selector__select__section').find('select.select2-gviicon')
			.select2({
				width: 'resolve',
				templateResult: function (state) {
					if (!state.id) {
						return state.text;
					}

					return $(
						'<div class="select2-results__option--gv-iicon-selector tooltip--footer" data-module="tooltip" data-title="' + state.id + '">'
						+ '<div class="select2-results__option--icon gv-iicon-' + state.id + '"></div>'
						+ '</div>'
					);
				},
				data: [
					'header-graph', 'header-overview', 'header-alerts', 'header-gear', 'header-synopsis', 'header-modules', 'header-user', 'header-ody-overview', '',
					'header-file-calc', 'header-file-doc', 'header-file-contract', 'header-maintenance', 'header-real-time', 'header-historic'
				]
					.filter(function (el) {
						return el.indexOf('header-') == 0;
					}),
				language: 'fr',
				dropdownCssClass: 'select2-dropdown--gv-iicon-selector'
			})
			.on('change', function () {
				$(this).closest('.gv-iicon-selector')
					.find('.gv-iicon-selector__preview-icon')
					.removeClass()
					.addClass('gv-iicon-selector__preview-icon gv-iicon-' + $(this).val());
			})
			.trigger('change');

		$(document).on('change', '#dysfunction-sel-site', function (e) {
			$.ajax({
				url: '/apigv/sites/devices/' + $(this).val(),
				type: "GET",
				headers: {
					"Content-Type": "application/json",
					"Authorization": "Bearer "+G.model.userApiKey
				},
				data: {
					onlyActive: 1
				},
				dataType: "json",
				error: function (xhr, textStatus, errorThrown) {
					G.ui.fatalError("ajax error: " + textStatus, { url: this.url, error: errorThrown });
				},
				success: function (data) {
					var s = '<option value="-1"></option>';
					for (var i = 0; i < data.response.devices.length; i++) {
						var d = data.response.devices[i];
						s += '<option value="' + d.id + '">' + d.nom + '</option>';
					}
					$('#dysfunction-sel-device').empty().append(s).trigger('change.select2');

				}
			});
		});

		$(document).on('change', '#comment-sel-site', function (e) {
			$.ajax({
				url: '/apigv/sites/devices/' + $(this).val(),
				type: "GET",
				headers: {
					"Content-Type": "application/json",
					"Authorization": "Bearer "+G.model.userApiKey
				},
				data: {
					onlyActive: 1
				},
				dataType: "json",
				error: function (xhr, textStatus, errorThrown) {
					G.ui.fatalError("ajax error: " + textStatus, { url: this.url, error: errorThrown });
				},
				success: function (data) {
					var s = '<option value="-1"></option>';
					for (var i = 0; i < data.response.devices.length; i++) {
						var d = data.response.devices[i];
						s += '<option value="' + d.id + '">' + d.nom + '</option>';
					}
					$('#comment-sel-device').empty().append(s).trigger('change.select2');

				}
			});
		});

		// ---

		$(document).on('responsiveBreak', (function (e) {
			/** @type {boolean} */
			var oldValue = s._isMobile;

			s._isMobile = (e.responsiveBreak.id === 'mobile' || e.responsiveBreak.id === 'tablet');

			if (oldValue !== s._isMobile)
				s.setNavMode(hud.NAV_MODE.closed);
		}));

		// ---

		d.getElementById('hudm-logo').addEventListener('click', function (e) {
            // Mobile :
            // on appelle setLocation seulement si le HUD est fermé
            if (s._isMobile && s._navMode === hud.NAV_MODE.closed) {
                G.model.setLocation(null, null, null);
            }

            // Desktop :
            // on appelle setLocation seulement si Ctrl n'est pas pressé
            if (!s._isMobile && !e.ctrlKey) {
                G.model.setLocation(null, null, null);
            }
		});

		// ---   mobile specific interactions

		d.getElementById('hudm-sections-pad__summary').addEventListener('click', function () {
			s.setNavMode(hud.NAV_MODE.sections);
		});

		// ---   handle actions panel

		var actionPad = d.getElementById('hudm-actions-pad');
		actionPad.addEventListener('mouseover', function (e) {
			s._actionsPanelOpen(e);
		});
		actionPad.addEventListener('mouseout', function (e) {
			s._actionsPanelOpen(e);
		});

		var actionPanel = d.getElementById('hudm-actions-panel');
		actionPanel.addEventListener('mouseover', function (e) {
			s._actionsPanelOpen(e);
		});
		actionPanel.addEventListener('mouseout', function (e) {
			s._actionsPanelOpen(e);
		});

		window.addEventListener('resize', function () {
			s._actionsPanelReflow();
		});
		s._actionsPanelReflow();


		// ---   handle user panel

		var userPad = d.getElementById('hudm-user-pad');
		userPad.addEventListener('mouseover', function (e) {
			s._userPanelOpen(e);
		});
		userPad.addEventListener('mouseout', function (e) {
			s._userPanelOpen(e);
		});

		var userPanel = d.getElementById('hudm-user-panel');
		userPanel.addEventListener('mouseover', function (e) {
			s._userPanelOpen(e);
		});
		userPanel.addEventListener('mouseout', function (e) {
			s._userPanelOpen(e);
		});

		// ---   handle user notification
		var userNotification = d.getElementById('hudm-user-notification');
		userNotification.addEventListener('mouseover', function (e) {
			s._userNotificationPanelOpen(e);
		});
		userNotification.addEventListener('mouseout', function (e) {
			s._userNotificationPanelOpen(e);
		});
		var userNotificationPanel = d.getElementById('hudm-user-notification-panel');
		userNotificationPanel.addEventListener('mouseover', function (e) {
			s._userNotificationPanelOpen(e);
		});
		userNotificationPanel.addEventListener('mouseout', function (e) {
			s._userNotificationPanelOpen(e);
		});

		window.addEventListener('resize', function () {
			s._userNotificationPanelReflow();
		});
		s._userNotificationPanelReflow();

		// ---   section mode setters

		s._el.querySelectorAll('[data-mode-setter][data-section-mode]').forEach(function (el) {
			el.addEventListener('click', function () {
				s.siteSet(null);
				s.setNavMode(hud.NAV_MODE.closed);
			});
		});


		// ---   navigation mode setters

		s._el.querySelectorAll('[data-mode-setter][data-nav-mode]').forEach(function (el) {
			el.addEventListener('click', function (e) {
				e.preventDefault();
				s.setNavMode(el.getAttribute('data-nav-mode'));
				return false;
			});
		});


		// ---   handle click on sites summary => open search navigation
		d.getElementById('hudm-sites-pad__summary').addEventListener('click', function () {
			s.setNavMode(hud.NAV_MODE.sites);
		});

		// ---   handle click on site lines => select and set model
		d.querySelectorAll('.hudc__panel .btn-toggle-dashboardpages').forEach(function (el) {
			el.addEventListener('click', function () {
				var dashboardPageToShow = true;
				if(el.classList.contains('fa-minus-square')){
					dashboardPageToShow = false;
				}
				if(dashboardPageToShow){
					el.classList.remove('fa-plus-square');
					el.classList.add('fa-minus-square');
					d.querySelectorAll('tr.mod--dashboardPages[data-site="'+el.getAttribute('data-site')+'"]').forEach(function (elD) {
						elD.style.display='block';
					});
				} else {
					el.classList.remove('fa-minus-square');
					el.classList.add('fa-plus-square');
					d.querySelectorAll('tr.mod--dashboardPages[data-site="'+el.getAttribute('data-site')+'"]').forEach(function (elD) {
						elD.style.display='none';
					});
				}
			});
		});

		// ---   handle click on site lines => select and set model
		d.querySelectorAll('.hudc__panel tr.mod--site[data-site]').forEach(function (el) {
			el.addEventListener('click', function () {
				s.siteSet(el.getAttribute('data-site'));
				s.setSectionMode(hud.SECTION_MODE.site);
				s.setNavMode(hud.NAV_MODE.closed);
			});
		});

		// ---   handle click on language lines => set model

		d.querySelectorAll('table.hudc__table tr[data-lang]').forEach(function (el) {
			el.addEventListener('click', function () {
				s.langSet(el.getAttribute('data-lang'));
			});
		});
		d.querySelectorAll('.hudm-user-panel__lang-panel a[data-lang]').forEach(function (el) {
			el.addEventListener('click', function (e) {
				e.preventDefault();
				s.langSet(el.getAttribute('data-lang'));
				return false;
			});
		});

		// ---   handle click on master lines => select and set focus
		d.querySelectorAll('table.hudc__table tr[data-container]').forEach(function (el) {
			el.addEventListener('click', function () {
				s._focusSetLine(el);
				s._focusHorChange(true, $(this).parent().parent().data('container'));
			});
		});

		// ---   document event listeners
		d.body.addEventListener('keydown', s._keydown.bind(s));

		// ---   listen to location changes
		$(window).on('model.locationChanged', s._locationChanged.bind(this));
		$(window).on('sectionTabs.locationChanged', function () {
			s._hudFavorites.updateLinks();
		});
		if(
			G.model.state === G.state.backend
			||
			(G.model.state === G.state.frontend && window.location.pathname.indexOf("frontend/interface") != -1)
		) s._locationChanged();

	};

	/**
	 * @param e {KeyboardEvent}
	 * @private
	 */
	this._keydown = function (e) {
		/** @type {boolean} */
		var isClosed = s._navMode === hud.NAV_MODE.closed;

		// --- global override
		if (e.shiftKey && e.ctrlKey && e.key === 'E') {
			$('.data-edit, .data-remove, .data-section-edit').toggle();
			return true;
		}
		if (e.shiftKey && e.ctrlKey && e.key === 'F')
			return isClosed ? s.setNavMode(hud.NAV_MODE_DEFAULT) : s.setNavMode(hud.NAV_MODE.closed);


		// --- dispatch event to search input
		if (!isClosed) {
			switch (e.key) {

				// --- close panel
				case 'Escape':
					return s.setNavMode(hud.NAV_MODE.closed);

				// --- vertical navigation
				case 'ArrowDown':
				case 'ArrowUp':

					return e.shiftKey ?
						s._focusNavModeChange(e.key === 'ArrowDown') :
						s._focusVertChange(e.key === 'ArrowDown');

				// --- horizontal navigation
				case 'ArrowLeft':
				case 'ArrowRight':
					return s._focusHorChange(e.key === 'ArrowRight');

				// --- selection
				case 'Enter':

					if (!s._fline || !s._fctx)
						return;

					// line refers to a site => reset hud site
					if (s._fctx.panel.id === 'hudc__panel--site') {
						s.siteSet(s._fline.getAttribute('data-site'));
						s.setNavMode(hud.NAV_MODE.closed);
						return;
					}

					// line refers to a site-type => set focus to first site
					if (s._fctx.panel.id === 'hudc__panel--site-type') {
						console.log('-> enter: set site type, focus first site');
						return s._focusHorChange(true);
					}

					// line refers to a container section
					if (s._fline.hasAttribute('data-container')) {
						console.log('-> enter: container section');
						return s._focusClick();
					}

					// line refers to a section/navigation mode setter
					if (s._fline.hasAttribute('data-mode-setter')) {
						console.log('-> enter: mode setter');
						return s._focusClick();
					}

					return s._focusClick();



			}

			if (e.target === s._searchEl && s._navMode === hud.NAV_MODE.search) {
				return s._search.keydown(e);
			}
		}
	};

	/**
	 * @private
	 */
	this._focusClick = function () {
		var p;

		if (!s._fline)
			return;

		p = s._fline.querySelector('td:first-of-type a');
		(p && p.click) ?
			p.click() :
			s._fline.click();
	};

	/**
	 * Fonction rafraichaissant la valeur de l'élément DOM correspond au badge notifiant le nb de notifications non lues
	 * @private
	 */
	this._refreshBadgeUserNotification = function() {
		var userNotificationBadge = $("#hudm-user-notification").find(".badge-notification");
		userNotificationBadge.toggle((this._nbOfUserNotificationsUnread ?? 0) > 0)
		userNotificationBadge.html((this._nbOfUserNotificationsUnread ?? 0) > 9 ? "9+" : (this._nbOfUserNotificationsUnread ?? 0));
	};

	/**
	 * Clear tous les events des éléments DOM nécessaires au système de notification
	 * @private
	 */
	this._offEventForUserNotificationBtn = function() {
		var userNotificationDeleteAllBtn$ = $('#hudm-user-notification-delete-all-btn');
		var userNotificationReloadBtn$ = $('#hudm-user-notification-reload-btn');
		var userNotificationPanelBodyBlock$ = $('#hudm-user-notification-panel').find(".hudm-user-notification-panel__body-block");

		userNotificationDeleteAllBtn$.off("click");
		userNotificationReloadBtn$.off("click");
		userNotificationPanelBodyBlock$.find(".hudm-user-notification-delete-btn").off("click");
	};

	/**
	 * Init tous les events des éléments DOM nécessaires au système de notification
	 * @private
	 */
	this._initEventForUserNotificationBtn = function() {
		var userNotificationDeleteAllBtn$ = $('#hudm-user-notification-delete-all-btn');
		var userNotificationReloadBtn$ = $('#hudm-user-notification-reload-btn');
		var userNotificationPanelBodyBlock$ = $('#hudm-user-notification-panel').find(".hudm-user-notification-panel__body-block");
		var self = this;

		userNotificationDeleteAllBtn$.on("click", function() {
			if(self._ajaxXhrNotifications) self._ajaxXhrNotifications.abort();

			self._ajaxXhrNotifications = $.ajax({
				url: '/apigv/profile/notificationDeleteAll',
				type: "DELETE",
				headers: {
					"Content-Type": "application/json",
					"Authorization": "Bearer "+G.model.userApiKey
				},
				beforeSend: function () {
					userNotificationDeleteAllBtn$.prop("disabled", true);
				},
				error: function (xhr, textStatus, errorThrown) {
					showError(G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
				},
				success: function (response) {
					if(response["status"] == "success") {
						userNotificationPanelBodyBlock$.empty();
						userNotificationPanelBodyBlock$.html(G.config.LOCALE_RETRIEVE('general.noNotification'));
					} else {
						showError(response["error"] ?? G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
					}
				},
				complete: function () {
					self._ajaxXhrNotifications = null;
				}
			});
		});

		userNotificationReloadBtn$.on("click", function() {
			self._loadUserNotification();
		});

		userNotificationPanelBodyBlock$.find(".hudm-user-notification-delete-btn").on("click", function() {
			const userNotificationId = $(this).data("notification-id");
			var userNotificationBlock$ = $(this).parent().parent(".hudm-user-notification-panel__body-block__notification-item");
			var userNotificationReloadBtn$ = $('#hudm-user-notification-reload-btn');

			if(self._ajaxXhrNotifications) self._ajaxXhrNotifications.abort();

			self._ajaxXhrNotifications = $.ajax({
				url: '/apigv/profile/notification',
				type: "DELETE",
				headers: {
					"Content-Type": "application/json",
					"Authorization": "Bearer "+G.model.userApiKey
				},
				data: JSON.stringify({
					notificationId: userNotificationId
				}),
				dataType: "json",
				beforeSend: function () {
					userNotificationDeleteAllBtn$.prop("disabled", true);
					userNotificationReloadBtn$.prop("disabled", true);
				},
				error: function (xhr, textStatus, errorThrown) {
					showError(G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
				},
				success: function (response) {
					if(response["status"] == "success") {
						userNotificationBlock$.off("click");
						userNotificationBlock$.remove();
						self._nbOfAllUserNotifications = self._nbOfAllUserNotifications - 1;
						userNotificationDeleteAllBtn$.prop("disabled", self._nbOfAllUserNotifications == 0);

						if(self._nbOfAllUserNotifications == 0) {
							userNotificationPanelBodyBlock$.empty();
							userNotificationPanelBodyBlock$.html(G.config.LOCALE_RETRIEVE('general.noNotification'));
						}
					} else {
						showError(response["error"] ?? G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
					}
				},
				complete: function () {
					userNotificationReloadBtn$.prop("disabled", false);
					self._ajaxXhrNotifications = null;
				}
			});
		});
	};

	/**
	 * Init d'un timeout pour recharger la liste des notifications tous les 5 minutes
	 * @private
	 */
	this._initSetTimeoutToReloadNotification = function() {
		var self = this;
		self._userNotificationSetTimeoutId = setTimeout(function () {
			self._loadUserNotification();
		}, 300000);
	}

	/**
	 * Destruction du timeout servant à recharger la liste des notifications
	 * @private
	 */
	this._destroySetTimeoutToReloadNotification = function() {
		clearTimeout(this._userNotificationSetTimeoutId);
	}

	/**
	 * Définit toutes les notifications en lues en faisant une appel ajax à un service backend et mettant à jour le dom
	 * @private
	 */
	this._declareAllUserNotificationsAsSeen = function() {
		var self = this;
		if((self._nbOfUserNotificationsUnread ?? 0) > 0 && !self._isAjaxSeenAllUserNotificationsRunning) {
			$.ajax({
				url: '/apigv/profile/notificationSeenAll',
				type: "PUT",
				headers: {
					"Content-Type": "application/json",
					"Authorization": "Bearer "+G.model.userApiKey
				},
				dataType: "json",
				beforeSend: function() {
					self._isAjaxSeenAllUserNotificationsRunning = true;
				},
				error: function (xhr, textStatus, errorThrown) {
					G.ui.fatalError(textStatus, { url: this.url, textStatus: textStatus, error: errorThrown, params: JSON.stringify(data) });
				},
				success: function (response) {
					if (response["status"] == "success") {
						self._nbOfUserNotificationsUnread = 0;
						self._refreshBadgeUserNotification();
					}
				},
				complete: function () {
					self._isAjaxSeenAllUserNotificationsRunning = false;
				}
			});
		}
	}

	/**
	 * Chargement des notification en initialisation tous les éléments DOM nécessaires
	 * @private
	 */
	this._loadUserNotification = function() {
		var self = this;
		var userNotificationPanelBodyBlock$ = $('#hudm-user-notification-panel').find(".hudm-user-notification-panel__body-block");
		var userNotificationDeleteAllBtn$ = $('#hudm-user-notification-delete-all-btn');
		var userNotificationReloadBtn$ = $('#hudm-user-notification-reload-btn');

		this._offEventForUserNotificationBtn();
		this._destroySetTimeoutToReloadNotification();

		if(this._ajaxXhrNotifications) this._ajaxXhrNotifications.abort();

		this._ajaxXhrNotifications = $.ajax({
			url: '/apigv/profile/notification',
            type: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer "+G.model.userApiKey
            },
            dataType: "json",
			beforeSend: function() {
				userNotificationPanelBodyBlock$.empty();
				userNotificationDeleteAllBtn$.prop("disabled", true);
				userNotificationReloadBtn$.prop("disabled", true);
			},
			error: function (xhr, textStatus, errorThrown) {
				userNotificationPanelBodyBlock$.html(G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
			},
			success: function (response) {
				if(response["status"] != "success") {
					userNotificationPanelBodyBlock$.html(response["error"] ?? G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
				} else if(response["response"]["data"].length == 0) {
					userNotificationPanelBodyBlock$.html(G.config.LOCALE_RETRIEVE('general.noNotification'));
				} else {
					var countUserNotifications = response["response"]["data"].length;
					var countUserNotificationsUnRead = response["response"]["data"].filter(userNotification => exists(userNotification["hasBeenSeen"]) && userNotification["hasBeenSeen"] == 0).length;
					userNotificationDeleteAllBtn$.prop("disabled", false);
					self._nbOfAllUserNotifications = countUserNotifications;
					self._nbOfUserNotificationsUnread = countUserNotificationsUnRead;
					self._refreshBadgeUserNotification();

					for(var indexNotificationArr = 0; indexNotificationArr < countUserNotifications; indexNotificationArr++) {
						var notificationUserObjIterated = response["response"]["data"][indexNotificationArr];
						userNotificationPanelBodyBlock$.append(`
							<div class="hudm-user-notification-panel__body-block__notification-item">
								<div class="hudm-user-notification-panel__body-block__notification-item__header">
									<strong>${notificationUserObjIterated["title"]}</strong>
									<button class="uicomp__icon uicomp--small hudm-user-notification-delete-btn" data-notification-id="${notificationUserObjIterated["id"]}"><i class="fas fa-trash"></i></button>
								</div>
								<p>${notificationUserObjIterated["description"]}</p>
								<div class="hudm-user-notification-panel__body-block__notification-item__footer">
									${ notificationUserObjIterated["createdAt"] ? moment(notificationUserObjIterated["createdAt"]).format('DD/MM/YYYY HH:mm') : ""}						
								</div>
							</div>
						`);
					}
				}
			},
			complete: function() {
				userNotificationReloadBtn$.prop("disabled", false);
				self._initEventForUserNotificationBtn();
				self._ajaxXhrNotifications = null;
				self._initSetTimeoutToReloadNotification();
			}
		});
	};
};

/** @type {HUDWidget}    */
hud.instance = null;

var hud;


if (!exists(hud)) {
	hud = {};
}

if (!exists(hud.HUDSearch)) {

	/**
	 * @param el {HTMLElement}
	 * @param hudWidget {hud.HUDWidget}
	 * @constructor
	 */
	hud.HUDSearch = function (el, hudWidget) {

		// ------------------------------------------------------------------------------------------------------
		//    PROPERTIES
		// ------------------------------------------------------------------------------------------------------

		/** @type {hud.HUDSearch} */
		var s = this;

		/**  @type {Document}*/
		var d = document;
		
		/**
		 * @type {boolean}
		 * @private
		 */
		var SEARCH_VERBOSE = false;

		/**
		 * @type {hud.HUDWidget}
		 * @private
		 */
		this._hudWidget = hudWidget;

		/**
		 * @type {number}
		 * @private
		 */
		this._sIndex = 0;

		/**
		 * Localized search labels, stored by references
		 * @type {{site: string, enterprise: string, equipment: string, synopsis: string, favorite: string, user: string}}
		 * @private
		 */
		this._searchLabels = G.config.LOCALE_RETRIEVE('hud.search.labels');

		/**
		 * Localized search patterns, stored by references
		 * @type {{site: string, enterprise: string, equipment: string, synopsis: string, favorite: string, user: string}}
		 * @private
		 */
		this._searchPatterns = G.config.LOCALE_RETRIEVE('hud.search.patterns');

		/**
		 * Search target references
		 * @type {*[]}
		 * @private
		 */
		this._searchKeys = [];

		/**
		 * Localized search patterns, stored in array
		 * @type {*[]}
		 * @private
		 */
		this._searchPatternsArr = [];

		/**
		 * @type HTMLInputElement
		 * @private
		 */
		this._ipt = null;

		/**
		 * @type {number}
		 * @private
		 */
		this._inputSearchUIID = Number.NaN;

		/**
		 * @type {{}}
		 * @private
		 */
		this._inputSearchContext = {};

		/**
		 * @type {number}
		 * @private
		 */
		this._searchTimeOutDelay = 300;

		/** @type {string} */
		this._searchURL = '/apigv/profile/search';


		// ------------------------------------------------------------------------------------------------------
		//    INTERACTIONS
		// ------------------------------------------------------------------------------------------------------

		/**
		 * Resets search input and settings.
		 */
		this.reset = function () {
			s._inputSearchContext = {};

			s._ipt.value = '';
			d.getElementById('huds__tags-container').innerHTML = '';

			s._inputChange();
		};

		/**
		 * Sets user focus within search text input.
		 */
		this.focusSet = function () {
			s._ipt.focus();
		};

		/**
		 * Handles keyboard events.
		 * @param e {KeyboardEvent}
		 */
		this.keydown = function (e) {
			if (e.key === 'Enter') {
				e.preventDefault();
			}
		};

		/**
		 * @private
		 */
		this._inputChange = function () {
			var
				val,
				containerEl = d.getElementById('huds__tags-container'),
				tagEl,
				pattern,
				uiid,
				tags,
				prop,
				replaceRegEx = new RegExp(':(' + s._searchPatternsArr.join('|') + ')', 'ig')
			;

			s._hudWidget.setNavMode(hud.NAV_MODE.search);

			s._sIndex++;
			val = s._ipt.value;

			if(SEARCH_VERBOSE){
				console.log('[HudSearch._inputChange] [' + s._sIndex + ']', 'val: "' + val + '" (' + val.trim().length + ')');
			}
			
			// ######   SEARCH PATTERNS

			val = val.replace(replaceRegEx, function replace(match) {

				// retrieve pattern uiid
				pattern = match.substr(1);
				pattern = pattern.trim();
				for (prop in s._searchPatterns) {
					if (s._searchPatterns[prop] === pattern) {
						uiid = prop;
						break;
					}
				}

				// found pattern has already been registered
				if (containerEl.querySelector('.huds__tag-block[data-pattern="' + uiid + '"]')) {
					if(SEARCH_VERBOSE){
						console.log('[HUDSearch._createTargetType] Reference "' + uiid + '" already exists');
					}
					return '';
				}

				// create tag element
				tagEl = d.createElement('div');
				tagEl.setAttribute('data-pattern', uiid);
				tagEl.classList.add('huds__tag-block', 'search-pad__block');
				tagEl.innerHTML = '<span class="huds__tag-block__label">' + s._searchLabels[uiid] + '</span>'
					+ '<span class="hudi hudi__close-s hudi--white"></span>';
				containerEl.append(tagEl);
				return '';
			});

			if (val.lastIndexOf(' ') >= 0 && val.lastIndexOf(' ') === val.length - 1) {
				if(SEARCH_VERBOSE){
					console.log('[HUDWidget._inputChange] Clean multiple trailing spaces');
				}
				val = val.trim() + ' ';
			}

			// apply processed and cleaned value
			s._ipt.value = val;


			// ######   RETRIEVE CURRENT TAGS

			tags = [];
			tagEl = containerEl.querySelectorAll('.huds__tag-block');
			if (tagEl && tagEl.length > 0) {
				tagEl.forEach(function (el) {
					tags.push(el.getAttribute('data-pattern'));
				});
			}


			// ######   CANCELLED CALLS

			// avoid too short calls
			if (val.trim().length < hud.SEARCH_MIN_INPUT_LENGTH) {
				s._inputSearchContext.searchPattern = null;
				s._hudWidget.feedbackLocContextDisplay('hud.searchResultsNoInput', {
					searchMinCaracters: hud.SEARCH_MIN_INPUT_LENGTH
				});
				s._showSearchResults(null, hud.NAV_MODE.search);
				return;
			}

			//
			if (s._inputSearchContext
				&& val.trim() === s._inputSearchContext.searchPattern
				&& tags.join(',') === s._inputSearchContext.searchTypes.join(',')
			) {
				if(SEARCH_VERBOSE){
					console.log(
						'[HUDWidget._inputChange] Cancel useless search',
						'searchPattern: "' + s._inputSearchContext.searchPattern + '"',
						'types: ' + s._inputSearchContext.searchTypes.join(',')
					);
				}
				return;
			}

			// store search params for a later use
			s._inputSearchContext = {
				lang: G.model.lang,
				queryUID: s._sIndex,
				searchPattern: val.trim(),
				searchTypes: tags
			};

			// delay search request
			s._clearSearchTimeout();
			s._inputSearchUIID = window.setTimeout(s._cb.inputSearch, s._searchTimeOutDelay);
		};


		/**
		 * @private
		 */
		this._clearSearchTimeout = function(){
			if (isan(s._inputSearchUIID)) {
				window.clearTimeout(s._inputSearchUIID);
				s._inputSearchUIID = Number.NaN;
			}
		};

		/**
		 * Executes search (AJAX request).
		 * @private
		 */
		this._inputSearch = function () {
			s._clearSearchTimeout();

			if(!s._inputSearchContext.searchPattern){
				if(SEARCH_VERBOSE) {
					console.log('[HUDSearch._inputSearch] Cancel AJAX request ; searchPattern is null');
				}
				return;
			}

			$.ajax({
				url: s._searchURL,
				headers: {
					"Content-Type": "application/json",
					"Authorization": "Bearer "+G.model.userApiKey
				},
				type: 'POST',
				data: JSON.stringify(s._inputSearchContext),
				datatype: 'json',
				beforeSend: function(){
					s._hudWidget.feedbackContextDisplay('<i class="fas fa-spinner fa-pulse"></i>');
					s._showSearchResults(null, hud.NAV_MODE.search);
				},
				error: function (xhr, textStatus, errorThrown) {
					showError("ajax error: " + textStatus, {url: s._searchURL, error: errorThrown});
				},
				success: function (data) {
					/** @type {number} */
					var numResults = 0;
					/** @type {{}} */
					var context;

					if (data.status === 'success') {

						// counts returned items
						if (!isarray(data.response.results)) {
							for (var prop in data.response.results) {
								if (data.response.results.hasOwnProperty(prop))
									numResults += data.response.results[prop].length;
							}
						}

						// build context for display method
						context = {
							numResults: numResults,
							pattern: data.response.searchPattern
						};

						// display results
						s._hudWidget.feedbackLocContextDisplay((numResults === 0) ? 'hud.searchResultsNoResult' : 'hud.searchResultsDefault', context);
						s._showSearchResults(data.response.results, hud.NAV_MODE.search);
					}
					else {
						showError('[HUDSearch._inputSearch] AJAX error on: "' + s._searchURL + '"', data);
					}
				}
			});
		};

		/**
		 * Displays a list of enumerable elements (in search or favorites mode).
		 * @param results    {{}|null}
		 * @param navMode    {string|null}    navigation mode see hud.NAV_MODE
		 * @private
		 */
		this._showSearchResults = function (results, navMode) {
			/** @type {HTMLElement} */
			var
				table,
				line;
			/** @type {string[]} */
			var types = ['site', 'synopsis', 'equipment', 'user', 'enterprise'];
			/** @type {number} */
			var
				typesCount = 0,
				itemsCount = 0;

			s._hudWidget.setNavMode(navMode);

			table = s._hudWidget.getPanels(null).querySelector('.hudc__table');
			table.innerHTML = '';

			if (results) {

				types.forEach(function(type){
					if (!results.hasOwnProperty(type))
						return;

					if (typesCount > 0)
						table.append(s._domBuildSpacerLine());
					typesCount++;

					table.append(
						s._domCreateHeadingLine(G.config.LOCALE_RETRIEVE('hud.search.labels.' + type, undefined, undefined))
					);

					for (var j = 0, jlen = results[type].length; j < jlen; ++j) {
						line = s._hudWidget.domBuildSearchLine(type, results[type][j]);
						if (line) {
							table.append(line);
							itemsCount++;
						}
					}
				});

				table.querySelectorAll('a').forEach(function (el) {
					el.addEventListener('click', function () {
						s._hudWidget.setNavMode(hud.NAV_MODE.closed);
						return true;
					});
				});

				s._hudWidget.focusSetPanelDefault(null);
			}
		};

		/**
		 * @return {HTMLElement}
		 * @private
		 */
		this._domBuildSpacerLine = function () {
			var line = d.createElement('tr');
			line.classList.add('hudc__line', 'mod--spacer', 'mod--disabled');
			line.innerHTML = '<td colspan="3"></td>';
			return line;
		};

		/**
		 * @param label {string}
		 * @returns {HTMLElement}
		 * @private
		 */
		this._domCreateHeadingLine = function (label) {
			/** @type {HTMLElement} */
			var line;

			line = d.createElement('tr');
			line.classList.add('hudc__line', 'mod--section', 'mod--disabled');
			line.innerHTML = '<td class="mod--label resp--top-xl resp--bottom" colspan="3">' + label + '</td>';
			return line;
		};


		// ------------------------------------------------------------------------------------------------------
		//    INITIALIZATION
		// ------------------------------------------------------------------------------------------------------

		/** @private */
		this._cb = {
			change: s._inputChange.bind(s, false),
			inputSearch: s._inputSearch.bind(s)
		};

		/**
		 * Initializes instance.
		 */
		this.init = function () {
			s._ipt = d.querySelector('input#huds__input');

			for (var prop in this._searchPatterns) {
				s._searchKeys.push(prop);
				s._searchPatternsArr.push(s._searchPatterns[prop]);
			}

			d.getElementById('huds__tags-container').addEventListener('click', function (e) {
				if (e.target.matches('.huds__tag-block')) {
					e.target.remove();
					s._inputChange(false);
				}
			});

			d.getElementById('huds__cancel').addEventListener('click', function () {
				s.reset();
			});

			s._ipt.addEventListener('input', s._cb.change);

			if (s._ipt.value.trim() !== '') {
				s._inputChange(false);
			}
		};
	};
}
var hud;


if (!exists(hud)) {
	hud = {};
}

if (!exists(hud.HUDFavorites)) {


	/**
	 * @param hudWidget {hud.HUDWidget}
	 * @constructor
	 */
	hud.HUDFavorites = function(hudWidget){

		/** @type {hud.HUDFavorites} */
		let s = this;

		/**
		 * @type {hud.HUDWidget}
		 * @private
		 */
		this._hudWidget = hudWidget;

        /**
         * @type {G.vo.Fav[]}
         * @private
         */
        this._userFavorites = [];


		// ------------------------------------------------------------------------------------------------------
		//    FAVORITES
		// ------------------------------------------------------------------------------------------------------
		this._getCurrentPageUrl = function(){
			return window.location.pathname + window.location.search + window.location.hash;
		};

		/**
		 * Whether current page belongs to user favorites.
		 * @return {boolean}
		 */
		this.favoritesHasPage = function(){
			/** @type {string} */
			var url = s._getCurrentPageUrl();
			/** @type {G.vo.Fav[]} */
			var favs = s._userFavorites;
			/** @type {number} */
			var i, ilen;

			for(i = 0, ilen = favs.length; i < ilen; ++i){
				if(favs[i].url === url)
					return true;
			}
			return false;
		};

		this.remove = function(uiid){
			var url = '/apigv/profile/favoriteDelete/'+uiid;

			$.ajax({
				url: url,
				type: "DELETE",
				headers: {
					"Content-Type": "application/json",
					"Authorization": "Bearer "+G.model.userApiKey
				},
				data: {},
				datatype: 'json',
				error: function (xhr, textStatus, errorThrown) {
					if(typeof(xhr.message) != "undefined"){
						showError(xhr.message);
					}else {
						showError("ajax error: " + textStatus, {url: url, error: errorThrown, xhr: xhr});
					}
				},
				success: function (data) {
					var unregistered = false;
					for(var i = 0, ilen = s._userFavorites.length; i < ilen; ++i){
						if(s._userFavorites[i].id == uiid){
							s._userFavorites.splice(i, 1);
							showSuccess(G.config.LOCALE_RETRIEVE('hud.favorite_removed'));
							unregistered = true;
							s.showFavorites();
							break;
						}
					}
					if(!unregistered)
						showError('[HUDFavorites.remove] Unable to retrieve favorite from uiid: ' + uiid, s._userFavorites);
				}
			});
		};

		this.add = function(){
			var
				url = '/apigv/profile/favoriteAdd',
				d = {
					url: s._getCurrentPageUrl(),
					label: window.document.title.split('|')[0],
					site_id: G.model.siteSelected ? G.model.siteSelected.id : null
				};

			$.ajax({
				url: url,
				type: "POST",
				headers: {
					"Content-Type": "application/json",
					"Authorization": "Bearer "+G.model.userApiKey
				},
				data: JSON.stringify(d),
				datatype: 'json',
				beforeSend: function() {
					showInfo(G.config.LOCALE_RETRIEVE('hud.favorite_added_in_progress'));
				},
				error: function (xhr, textStatus, errorThrown) {
					showError("ajax error: " + textStatus, {url: url, error: errorThrown});
				},
				/** @param data {{status: boolean, favorite_id: string}} */
				success: function (data) {
					if(data.status === 'success'){
						d.id = data.response.id;
						d.site = data.response.site;
						s._userFavorites.push(new G.vo.Fav(d));
						showSuccess(G.config.LOCALE_RETRIEVE('hud.favorite_added'));
						s.showFavorites();
					}
				}
			});
		};

		this.updateLinks = function(){
			/** @type {boolean} */
			var hasPage = s.favoritesHasPage();

			document.querySelectorAll('a[data-action="add-favorite"]').forEach(function(el){
				el.style.display = (!hasPage ? 'block' : 'none');
			});
			document.querySelectorAll('a[data-action="delete-favorite"]').forEach(function(el){
				if(el.closest('.hudc__line.mod--favorite'))
					return;
				el.style.display = (hasPage ? 'block' : 'none');
			});
		};

		this._removeHandler = function(e){
			/** @type {string} */
			var url = s._getCurrentPageUrl();
			/** @type {G.vo.Fav[]} */
			var favs = s._userFavorites;
			/** @type {number} */
			var i, ilen;
			/** @type {string} */
			var uiid;

			if(e.target.hasAttribute('data-id')){
				uiid = e.target.getAttribute('data-id');
			}
			else{
				for(i = 0, ilen = favs.length; i < ilen; ++i){
					if(favs[i].url === url)
						uiid = favs[i].id;
				}
			}

			if(uiid)
				s.remove(uiid);

			e.preventDefault();
			return false;
		};

		this._removeCallback = s._removeHandler.bind(this);

        this.showFavorites = function(){
            var table, line;
            var lines;
            let j, jlen = 0;

            s._userFavorites = [];

            s._hudWidget.setNavMode(hud.NAV_MODE.favorites);
            s._hudWidget.feedbackTitleDisplay();
            s._hudWidget.feedbackContextDisplay('');

            table = s._hudWidget.getPanels(null).querySelector('.hudc__table tbody');

            lines = table.querySelectorAll('tr:not(.mod--keepline)');
            if(lines){
                lines.forEach(function(el){
                    el.parentNode.removeChild(el);
                });
            }

            s._hudWidget.feedbackContextDisplay('<i class="fas fa-spinner fa-pulse"></i>');

            $.ajax({
                url: `/apigv/profile/favorite`,
                type: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer "+G.model.userApiKey
                },
                datatype: 'json',
                error: function (xhr, textStatus, errorThrown) {
                    s._hudWidget.feedbackContextDisplay('');
                    showError(G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
                },
                success: function (data) {
                    if(data?.status === 'success') {
                        for (let i = 0, len = data.response.favorites.length; i < len; ++i) {
                            s._userFavorites.push(new G.vo.Fav(data.response.favorites[i]));
                        }
                        jlen = data.response.favorites.length;
                    }

                    s._hudWidget.feedbackContextDisplay('');

                    if(jlen === 0){
                        line = s._hudWidget.domBuildSearchLine('label', {
                            label: 'hud.favorite_none'
                        });
                        if(line)
                            table.append(line);
                    }
                    else{
                        for(j = 0; j < jlen; ++j) {
                            line = s._hudWidget.domBuildSearchLine('favorite', s._userFavorites[j]);
                            if (line)
                                table.append(line);
                        }
                    }

                    s.updateLinks();
                    document.querySelectorAll('a[data-action="delete-favorite"]').forEach(function(el){
                        el.removeEventListener('click', s._removeCallback);
                        el.addEventListener('click', s._removeCallback);
                    });
                }
            });
        };
	};
}

var G, p;

if (!exists(G))
	G = {};

if (!exists(G.ui))
	G.ui = {};

if (!exists(G.ui.GVNotification)) {
	G.ui.GVNotification = function () { }

	var notyfInstance = null;
	function getNotyf() {
		if (!notyfInstance && typeof Notyf !== 'undefined') {
			notyfInstance = new Notyf({
				duration: 8000,
				position: {
					x: 'left',
					y: 'bottom',
				},
				dismissible: true,
				types: [
					{
						type: 'success',
						background: '#96bf55',
						duration: 8000,
						dismissible: true
					},
					{
						type: 'error',
						background: '#c35853',
						duration: 8000,
						dismissible: true
					},
					{
						type: 'information',
						background: '#5ba5ba',
						duration: 8000,
						dismissible: true
					}
				]
			});
		}
		return notyfInstance;
	}

	G.ui.GVNotification.Add = function (level, message, timeout, iconHtml) {
		var notyf = getNotyf();
		if (!notyf) {
			console.warn("[GVNotification fallback] Notyf n'est pas chargé. Message : " + message);
			return null;
		}

		var type = level;
		if (level === 'info') {
			type = 'information';
		}

		var duration = (timeout === -1 || timeout === 0) ? 0 : (timeout || 8000);

		return notyf.open({
			type: type,
			message: message,
			duration: duration
		});
	}

	G.ui.GVNotification.Clear = function (notificationInstance) {
		var notyf = getNotyf();
		if (notyf && notificationInstance) {
			notyf.dismiss(notificationInstance);
		}
	}

	G.ui.GVNotification.ClearAll = function () {
		var notyf = getNotyf();
		if (notyf) {
			notyf.dismissAll();
		}
	}
}




function showError(text, context, timeout) {
	context
		? console.warn('[!ERROR] ' + text, 'context: ', context)
		: console.warn('[!ERROR] ' + text);
	return G.ui.GVNotification.Add('error', text, timeout);
}
function showSuccess(text, timeout) {
	return G.ui.GVNotification.Add('success', text, timeout);
}
function showInfo(text, timeout) {
	return G.ui.GVNotification.Add('information', text, timeout);
}
function showInfoStatic(text) {
	return G.ui.GVNotification.Add('information', text, -1);
}
function notificationsClearAll(timeout) {
	G.ui.GVNotification.ClearAll(timeout);
}
/*
function notificationsClearAll(timeout) {
	return true;
}
function showError(text, context){
	noty({
		layout: 'bottomRight',
		timeout:5000,
		type:'error',
		text: text
	});
	if(exists(context))
		console.warn('[!ERROR] ' + text, 'context: ', context);
	else
		console.warn('[!ERROR] ' + text);
	return false;
}
function showSuccess(text){
	noty({
		layout: 'bottomRight',
		timeout:5000,
		type:'success',
		text: text
	});
	return true;
}
function showInfo(text){
	noty({
		layout: 'bottomRight',
		timeout:5000,
		type:'information',
		text: text
	});
	return true;
}
function showInfoLong(text){
	noty({
		layout: 'bottomRight',
		timeout:10000,
		type:'information',
		text: text
	});
	return true;
}
function showInfoStatic(text){
	noty({
		layout: 'bottomRight',
		timeout:false,
		type:'information',
		text: text
	});
	return true;
}
*/
function checkResult(method) {
	$.ajax({
		url: '/backend/devio/checkresult',
		type: "POST",
		dataType: "json",
		data: {
			none: 'none'
		},
		beforeSend: function (xhr) {
			$('.info-log').append('<p>Check trhisto results</p>');
		},
		error: function (xhr, textStatus) {
			console.error("ajax error: " + textStatus);
		},
		success: function (data) {
			if (!!data.working) {
				$('.info-log').append('<p>No result yet ' + data.responseText + '</p>');
				setTimeout(function () {
					checkResult(method);
				}, 5000);
			}
			else {
				if (!!data.result) {
					socket.emit('dvio', data.result);
				} else {
					showError('Une erreur est survenue');
				}
			}

		}
	});
}
var MONITORING = {};

MONITORING.EVT_REFRESH_CHART = 'gv:refresh_chart';

MONITORING.CLASS_INDICATOR_ACTIVE = 'card--focused-in';
MONITORING.CLASS_INDICATOR_INACTIVE = 'card--focused-out';
MONITORING.CLASS_PANEL_ACTIVE = 'panel-data--active';
MONITORING.CLASS_PANEL = 'indicators-panel-data';

MONITORING.CLASS_INDICATOR_PANEL_DATE = 'indicator_chart_integrated_panel_date';

MONITORING.VERBOSE = true;

/**
 * Show/hide chart container within data panel.
 * @private
 */
MONITORING._showChart = function (indicator, target) {
	var
		container = indicator.closest('.indicators-container'),
		panelEls = container
			.find('.indicators-panel-data')
			.find('.panel-container'),
		targetEl = panelEls.filter('.' + target);

	// show the required containerwidget-content
	panelEls.each(function (index, el) {
		el = $(el);
		el.toggle(el.is('.' + target));
	});

	// hide or show header bar
	container.find('.indicators-panel-data__inner > .gv-header')
		.toggle(['planning-container', 'heating-curve-container', 'last-histo-points-container'].indexOf(target) < 0);

	if (targetEl.is('.hch-container'))
		HCH.chartReset(HCH.getContainer(targetEl, HCH.INDICATOR_CLASS_CONTAINER));
};

/**
 * Display/hide data panel date block.
 * @param indicator
 * @param status
 * @private
 */
MONITORING._showDate = function (indicator, status) {
	indicator
		.closest('.indicators-container')
		.find('.indicators-panel-data')
		.find('.gv-header').css({
		display: status ? null : 'none'
	});
};

/**
 * Display/hide loading wheel.
 * @param container
 * @param status
 * @private
 */
MONITORING._showLoading = function (container, status) {
	container.find('.hch-preloader').toggle(status);
	container.find('.hch-graph').toggle(!status);
	var cuve = container.parent().find('.cuve-container');
	if (!status){
		container.find('.ind__refresh').prop('disabled', false).removeClass('is-loading');
	}
	if (cuve.exists()) {
		if (!status){
			MONITORING._expandOdyUtils_showCuve(false);
		}
		cuve.toggle(!status);
	}
};

/**
 * Execute Les calculs DJU via API et affiche les résultats dans un tableau
 * @param indicateurId		ID de l'indicator
 * @param resultSelector	jQuery selecteur du conteneur
 * @param options			Valeur de calcul
 */
MONITORING.executeDjuCalc = function(indicateurId, resultSelector, options) {
	options = options || {};
	var djuRealP = options.djuRealP || $('#ind-'+indicateurId+'-dju_real_p').val();
	var djuRealP1 = options.djuRealP1 || $('#ind-'+indicateurId+'-dju_real_p_1').val();
	var djuTarget = options.djuTarget || $('#ind-'+indicateurId+'-dju_target').val();
	var consoP = options.consoP || $('#ind-'+indicateurId+'-conso_p').val();
	var consoP1 = options.consoP1 || $('#ind-'+indicateurId+'-conso_p_1').val();
	var unit = options.unit || $('#ind-'+indicateurId+'-unit').val();
	var period = options.period || $('#ind-'+indicateurId+'-period').val();
	
	if(MONITORING.VERBOSE){
		console.table({
			func: '------------- MONITORING.executeDjuCalc',
			indicateurId: indicateurId,
			djuReal: djuRealP,
			djuRealPrevious: djuRealP1,
			djuRealTarget: djuTarget,
			conso: consoP,
			consoPrevious: consoP1,
			unit: unit,
			period: period
		});
	}
	
	$.ajax({
		url: G.config.SERVER + 'frontend/histo/executeDjuCalc',
		type: 'POST',
		data: {
			idIndicateur: indicateurId,
			djuReal: djuRealP,
			djuRealPrevious: djuRealP1,
			djuRealTarget: djuTarget,
			conso: consoP,
			consoPrevious: consoP1,
			unit: unit,
			period: period
		},
		datatype: 'json',
		error: function (xhr, textStatus, errorThrown) {
			G.ui.fatalError(textStatus, { url: this.url, textStatus: textStatus, error: errorThrown, params: JSON.stringify(data) });
		},
		success: function (d) {
			if(MONITORING.VERBOSE){
				console.log('\t [MONITORING.executeDjuCalc] data', d);
			}
			if(d.status == 'error'){
				showError(d.error);
				return false;
			}
			if(d.status == 'success'){
				var s = '<table class="ui-lean gv-table">';
				s += '<thead>' +
					 	'<tr>'+
								'<th>Période</th>'+
								'<th>Brute</th>'+
								'<th>Ajustée</th>'+
							'</tr>' + 
					 '</thead>' + 
					 '<tbody>' + 
					 	'<tr>' + 
					 		'<td>'+d.period+'</td>' + 
					 		'<td>'+d.period_brute+' '+d.unit+'</td>' + 
					 		'<td>'+d.period_ajuste+' '+d.unit+'</td>' + 
					 	'</tr>' + 
					 	'<tr>' + 
					 		'<td>'+d.period_previous+'</td>' + 
					 		'<td>'+d.previous_brute+' '+d.unit+'</td>' + 
					 		'<td>'+d.previous_ajuste+' '+d.unit+'</td>' + 
					 	'</tr>' + 
					 '</tbody>' + 
					 '<tfoot>' + 
					 	'<tr>' + 
					 		'<th>Tendance</th>' + 
					 		'<th>'+d.tendance_brute+'%</th>' + 
					 		'<th>'+d.tendance_ajuste+'%</th>' + 
					 	'</tr>' + 
					 '</tfoot>' + 
					'</table>';
				$(resultSelector).empty().append(s);
				showInfo(d.txt);
			}
		}
	});
};

/**
 * Resets data panel date settings (do not try to refresh content).
 * @param paneldata_jqo    paneldata pointer (instance of .indicators-panel-data)
 * @param from             start date (format DD/MM/YYYY)
 * @param to               end date (format DD/MM/YYYY)
 * @param period
 */
MONITORING.setDates = function (paneldata_jqo, from, to, period, periodDefault) {
	if (!exists(period))
		period = '';
	paneldata_jqo
		.attr('data-from', from)
		.attr('data-to', to)
		.attr('data-period', period)
		.attr('data-default-period', periodDefault)
	;
};

/**
 * Refresh panel content based on panel settings ('data-from', 'data-to' attributes + active indicator cell).
 * @param from_jqo  pointer to indicators section
 */
MONITORING.refreshPanelContent = function (from_jqo) {
	from_jqo
		.find('.' + MONITORING.CLASS_INDICATOR_ACTIVE)
		.find('.ind__expand')
		.trigger(MONITORING.EVT_REFRESH_CHART);
};

/**
 * Charge les donnée de l'indicateur selon son type
 * @param e
 * @param indicator
 * @param indicatorsContainer
 * @param dataPanel
 */
MONITORING.refreshIndicator = function (e, indicator, indicatorsContainer, dataPanel) {
	// Le Top 10 Conso n'autorise que la période "mois plein" : on verrouille le select de période pour
	// cet indicateur. Ce dispatcher étant le point de passage commun à tous les types d'indicateurs, le
	// select est automatiquement réactivé dès qu'un autre indicateur de la section est affiché.
	var periodOnlyAllowFullMonth = indicator.hasClass('indicator--type-top_conso');
	$('#indicators-panel-data-' + dataPanel.attr('data-sectionid') + ' .period-select')
		.prop('disabled', periodOnlyAllowFullMonth)
		.trigger('change.select2');

	// MULTI-GRAPHIQUE : le selecteur de graphique est partage dans l'en-tete du panneau. Il n'est
	// visible que pour un indicateur multi_chart (les autres types utilisent aussi cet expand).
	dataPanel.find('.multi-chart-selector').toggle(indicator.is('.indicator--type-multi_chart'));


	var isgv = indicatorsContainer.attr('data-service') === 'globalvisio';
	if (isgv) {
		args = [indicatorsContainer, indicator, dataPanel];
		if (indicator.is('.indicator--type-graphique'))
			MONITORING._expandIndicatorGraph.apply(null, args);
		else if (indicator.is('.indicator--type-graphique-linked'))
			MONITORING._expandIndicatorGraph.apply(null, args);
		else if (indicator.is('.indicator--type-multi_chart'))
			MONITORING._expandIndicatorMultiChart.apply(null, args);
		else if (indicator.is('.indicator--type-prestation'))
			MONITORING._expandIndicatorPrestation.apply(null, args);
		else if (indicator.is('.indicator-type--calcul-lowtemp'))
			MONITORING._expandIndicatorLowTemp.apply(null, args);
		else if (indicator.is('.indicator-type--agrege'))
			MONITORING._expandIndicatorAgrege.apply(null, args);
		else if (indicator.is('.indicator--type-planning')){
			MONITORING._expandIndicatorPlanning.apply(null, args);}
		else if (indicator.is('.indicator--type-alarme')) 
			MONITORING.expandIndicator(e, false);
		else if (indicator.is('.indicator--type-heating_curve'))
			MONITORING._expandIndicatorHeatingCurve.apply(null, args);
		else if (indicator.is('.indicator--type-last_histo_points'))
			MONITORING._expandIndicatorLastHistoPoints.apply(null, args);
		else
		{
			console.log('\t [MONITORING.expandIndicator] _expandIndicatorDefault');
			MONITORING._expandIndicatorDefault.apply(null, args);
		}
	}
}


/**
 * @param e             source event
 * @param openStatus    panel target opened state
 */
MONITORING.expandIndicator = function (e, openStatus) {
	var
		targetScrollPos,hchContainer, indicatorsContainer, indicator, indicatorSiblings, dataPanel,
		siblingOffsetTop, indicatorIndex, indicatorOffsetTop, msnry, bcl
	;

	//	######	CONSOLIDATE DATA
	indicatorsContainer = $(e.target).closest('.indicators-container');
	indicator = $(e.target).closest('.indicator');
	indicatorSiblings = indicatorsContainer.children('.indicator');
	dataPanel = indicatorsContainer.find('.indicators-panel-data');
	hchContainer = HCH.getContainer(dataPanel, HCH.INDICATOR_CLASS_CONTAINER);
	bcl = document.body.classList;

	if (!indicator.existsOnce()) {
		indicator = indicatorsContainer.find('.indicator.' + MONITORING.CLASS_INDICATOR_ACTIVE);
	}

	if (!isbool(openStatus)) {
		openStatus = !indicator.hasClass(MONITORING.CLASS_INDICATOR_ACTIVE);
	}

	// ######	SET INDICATOR STATUS
	indicatorSiblings.removeClass(MONITORING.CLASS_INDICATOR_ACTIVE);

	// ######	REFRESH Masonry LAYOUT
	msnry = Masonry.data(indicatorsContainer[0]);
	if(msnry) {
		msnry.off("layoutComplete");
		msnry.reloadItems();
		msnry.layout();

		// ---	relayout masonry when the data panel resizes (one observer per panel)
		const panel = dataPanel[0];
		if (panel && !panel._masonryResizeObserver) {
			panel._masonryResizeObserver = new ResizeObserver(() => {
				const m = Masonry.data(indicatorsContainer[0]);
				if (m) m.layout();
			});
			panel._masonryResizeObserver.observe(panel);
		}
	}

	if (openStatus){
		indicatorSiblings.addClass(MONITORING.CLASS_INDICATOR_INACTIVE);
		indicator
			.removeClass(MONITORING.CLASS_INDICATOR_INACTIVE)
			.addClass(MONITORING.CLASS_INDICATOR_ACTIVE)
		;
	}
	else{
		indicatorSiblings.removeClass(MONITORING.CLASS_INDICATOR_INACTIVE);
	}


	// ######	SET DATA-PANEL STATUS & POSITION

	dataPanel.toggleClass(MONITORING.CLASS_PANEL_ACTIVE, openStatus);

	if (openStatus) {

		if (!indicator.exists()) {
			console.warn('\t [MONITORING.expandIndicator] Illegal operation: no target indicator');
			return;
		}

		dataPanel.insertAfter(indicator);

		// ---	reload masonry layout
		if(msnry) {
			MONITORING._initMasonryViewIndicatorContainers("indicators-container", function() {
				// utilisation settimeout car la récupération top n'est pas mis à jour tout de suite
				// donc on le met dans un cycle de traitement à part à traiter
				setTimeout(function() {
					switch(true) {
						case bcl.contains('responsive--mobile'):
						case bcl.contains('responsive--tablet'):
							targetScrollPos = Math.ceil(dataPanel.offset().top - 74);
							break;
						case bcl.contains('responsive--desktop'):
						case bcl.contains('responsive--desktop-max'):
						case bcl.contains('responsive--desktop-large-max'):
							targetScrollPos = Math.ceil((dataPanel.offset().top + dataPanel.height()) - window.innerHeight + 10);
							break;
						default:
							targetScrollPos = Math.ceil(dataPanel.offset().top - 50);
					}
					msnry.off("layoutComplete");
					$('html, body')
						.stop()
						.animate({'scrollTop': targetScrollPos}, 250);

				}, 0);
			});
		} else {
			switch(true) {
				case bcl.contains('responsive--mobile'):
				case bcl.contains('responsive--tablet'):
					targetScrollPos = Math.ceil(dataPanel.offset().top - 74);
					break;
				case bcl.contains('responsive--desktop'):
				case bcl.contains('responsive--desktop-max'):
				case bcl.contains('responsive--desktop-large-max'):
					targetScrollPos = Math.ceil((dataPanel.offset().top + dataPanel.height()) - window.innerHeight + 10);
					break;
				default:
					targetScrollPos = Math.ceil(dataPanel.offset().top - 50);
			}

			$('html, body')
				.stop()
				.animate({'scrollTop': targetScrollPos}, 250);
		}
	}
	else {

		// ---	clean panel content before leaving
		HCH.chartReset(hchContainer);
		dataPanel.find('.html-container').empty();
		dataPanel.removeAttr("style");

		// ---	reload masonry layout
		if(msnry) {
			msnry.off("layoutComplete");
			msnry.reloadItems();
			msnry.layout();
		}
	}

	if (!openStatus)
		return;

	// ######	RETRIEVE CORRESPONDING DATA
	MONITORING._showLoading(hchContainer, true);
	MONITORING.refreshIndicator(e,indicator,indicatorsContainer,dataPanel);
};


// ------------ GLOBALVISIO INDICATORS PANEL

/** @private */
MONITORING._expandIndicatorLowTemp = function (container, indicator, dataPanel) {
	var indicateurId = indicator.attr('data-indicateur-id');
	var target = indicator.attr('data-target');

	dataPanel.attr('indicator-id-selected', indicateurId);

	MONITORING._showChart(indicator, 'html-container');
	$.ajax({
		url: G.config.SERVER + 'apigv/indicators/calcul/'+target,
		type: 'GET',
		headers: {
			"Content-Type": "application/json",
			"Authorization": "Bearer "+G.model.userApiKey
		},
		error: function (xhr, textStatus, errorThrown) {
			console.warn('[MONITORING._expandIndicatorLowTemp] Ajax error: ' + textStatus, {
				xhr: xhr,
				textStatus: textStatus,
				errorThrown: errorThrown
			});
		},
		success: function (data) {
			var
				i, ilen, eq,
				tableStr = '';

			if (HCH._checkJSONError(data))
				return;

			tableStr += '<h4>' + data.name.toUpperCase() + '</h4>'
				+ '<h5>Liste des logements sous le seuil de ' + data.threshold + '°C</h5>'
				+ '<table class="gv-table">'
				+ '<thead>'
				+ '<tr>'
				+ '<th>Nom</th>'
				+ '<th>Température moyenne</th>'
				+ '<th>Date</th>'
				+ '</tr>'
				+ '</thead>'
				+ '<tbody>';

			for (i = 0, ilen = data.detail.details.length; i < ilen; i++) {
				eq = data.detail.details[i];
				tableStr += '<tr>'
					+ '<td>' + eq.equipement + '</td>'
					+ '<td>' + eq.valeur + '</td>'
					+ '<td>' + eq.date + '</td>'
					+ '</tr>';
			}

			tableStr += '</tbody>'
				+ '</table>';

			MONITORING._showDate(indicator, false);
			container.find('.html-container').html(tableStr);
		}
	});
};

/** @private */
MONITORING._expandIndicatorAgrege = function (container, indicator, dataPanel) {
	var indicatorId = indicator.attr('data-indicateur-id');
	dataPanel.attr('indicator-id-selected', indicatorId);

	MONITORING._showChart(indicator, 'html-container');
	$.ajax({
		url: G.config.SERVER + 'apigv/indicators/loadAgrege/'+indicatorId,
		type: 'GET',
		headers: {
			"Content-Type": "application/json",
			"Authorization": "Bearer "+G.model.userApiKey
		},
		error: function (xhr, textStatus, errorThrown) {
			console.warn('[MONITORING._expandIndicatorLowTemp] Ajax error: ' + textStatus, {
				xhr: xhr,
				textStatus: textStatus,
				errorThrown: errorThrown
			});
		},
		success: function (data) {
			data = data.response;
			var
				i, ilen, eq, value,
				tableStr = '';

			if (HCH._checkJSONError(data))
				return;

            const displaySite = data.displaySite ?? false;

			tableStr += '<h4>' + data.name.toUpperCase() + '</h4>'
				+ '<h5>' + data.title.toUpperCase() + '</h5>'
				+ '<table class="gv-table">'
				+ '<thead>'
				+ '<tr>';
            if(displaySite) {
                tableStr += '<th>'+G.config.LOCALE_RETRIEVE('general.site')+'</th>';
            }
            tableStr += ''
                + '<th>'+G.config.LOCALE_RETRIEVE('general.nom')+'</th>'
				+ '<th>'+G.config.LOCALE_RETRIEVE('general.value')+'</th>'
				+ '<th>'+G.config.LOCALE_RETRIEVE('general.date')+'</th>'
				+ '</tr>'
				+ '</thead>'
				+ '<tbody>';

			if(data.points.length == 0){
				tableStr += '<tr>'
					+ '<td colspan=" ' + (displaySite ? 4 : 3) + '">'+G.config.LOCALE_RETRIEVE('general.anyMatchingPoint')+'</td>'
					+ '</tr>';
			}

			for (i = 0, ilen = data.points.length; i < ilen; i++) {
				eq = data.points[i];
				var value = '';
				if(exists(eq.value.value)){
					var value = eq.value.value;
				} else if(exists(eq.value)){
					var value = eq.value;
				}
				tableStr += '<tr>';
                if(displaySite) {
                    tableStr += '<td>' + eq.site + '</td>';
                }
                tableStr += ''
					+ '<td>' + eq.labelHumain + '</td>'
					+ '<td>' + value + '</td>'
					+ '<td>' + eq.valueDate + '</td>'
					+ '</tr>';
			}

			tableStr += '</tbody>'
				+ '</table>';

			MONITORING._showDate(indicator, false);
			container.find('.html-container').html(tableStr);
		}
	});
};

/** @private */
MONITORING._expandIndicatorAnalyse = function (container, indicator, dataPanel) {
	var indicateurId = indicator.attr('data-indicateur-id');
	dataPanel.attr('indicator-id-selected', indicateurId);

	if(MONITORING.VERBOSE)
		console.log('[MONITORING._expandIndicatorAnalyse] indicateurId: ' + indicateurId);

	MONITORING._showChart(indicator, 'hch-container');

	$.ajax({
		url: G.config.SERVER + 'frontend/ajax/loadDataAnalyse',
		type: 'POST',
		data: {
			indicateurId: indicateurId
		},
		error: function (xhr, textStatus, errorThrown) {
			console.warn('[MONITORING._expandIndicatorAnalyse] Ajax error: ' + textStatus, {
				xhr: xhr,
				textStatus: textStatus,
				errorThrown: errorThrown
			});
		},
		success: function (data) {
			var
				i, ilen, j, jlen, eq, point, pointLabel, value,
				tableStr = '',
				pointLabels = [];

			if (HCH._checkJSONError(data))
				return;

			G.ui.initSelect2();

			tableStr += '<header class="gv-header"><div class="gv-header__title">'
				+ '<h3>' + indicator.find('header h3').html().toUpperCase() + '</h3>'
				+ '<h4>' + indicator.find('header h4').html().toUpperCase() + '</h4>'
				+ '</div></header>'
				+ '<br />'
				+ '<table class="gv-table gv-table--no-stripes">';
		}
	});
};

/** @private */
MONITORING._expandIndicatorPrestation = function (container, indicator, dataPanel) {
	var indicateurId = indicator.attr('data-indicateur-id');
	var typePrestation = indicator.attr('data-type');

	dataPanel.attr('indicator-id-selected', indicateurId);

	if(MONITORING.VERBOSE)
		console.log('[MONITORING._expandIndicatorPrestation] typePrestation: ' + typePrestation);

	MONITORING._showChart(indicator, 'html-container');

	$.ajax({
		url: G.config.SERVER + 'frontend/application/loadDataPrestation',
		type: 'POST',
		data: {
			typePrestation: typePrestation
		},
		error: function (xhr, textStatus, errorThrown) {
			console.warn('[MONITORING._expandIndicatorPrestation] Ajax error: ' + textStatus, {
				xhr: xhr,
				textStatus: textStatus,
				errorThrown: errorThrown
			});
		},
		success: function (data) {
			var
				i, ilen, j, jlen, ev, point, pointLabel, value,
				tableStr = '';

			if (HCH._checkJSONError(data))
				return;

			tableStr += '<header class="gv-header"><div class="gv-header__title">'
				+ '<h3>' + data.title + '</h3>'
				+ '<h4>' + data.subtitle + '</h4>'
				+ '</div></header>'
				+ '<br />'
				+ '<table class="ui-lean">';
			
			for (i = 0, ilen = data.events.length; i < ilen; i++) {
				ev = data.events[i];

				if (i === 0) {
					tableStr += '<thead><tr>'
						+ '<th></th>'
						+ '<th>Site</th>'
						+ '<th>Description</th>'
						+ '<th>Prestataire</th>'
						+ '<th>Début</th>'
						+ '<th>Fin</th>'
						+ '</tr></thead>'
						+ '<tbody>';
				}

				tableStr += '<tr class="status--info">'
						+'<td>'
							+ '<div class="uicomp__hflow mod--valign-center mod--nowrap">'
								+ '<div class="uicomp__button uicomp--small uicomp--'+ev['color']+' mod--fixedw-30"><i class="fal '+ev['icon']+'"></i></div>'
							+ '</div>'
						+'</td>'
						+ '<td>'+ev['siteName']+'</td>'
						+ '<td>'+ev['description']+'</td>'
						+ '<td>'+ev['prestataire']+'</td>'
						+ '<td>'+ev['start']+'</td>'
						+ '<td>'+ev['end']+'</td>'
						+ '</tr>';
			}
			
			for (i = 0, ilen = data.apps.length; i < ilen; i++) {
				app = data.apps[i];

				if (i === 0) {
					tableStr += '<thead><tr>'
						+ '<th></th>'
						+ '<th>Site</th>'
						+ '<th>Description</th>'
						+ '<th>Prestataire</th>'
						+ '<th>Dernier scan</th>'
						+ '</tr></thead>'
						+ '<tbody>';
				}

				tableStr += '<tr class="status--info">'
						+'<td>'
							+ '<div class="uicomp__hflow mod--valign-center mod--nowrap">'
								+ '<div class="uicomp__button uicomp--small uicomp--'+app['color']+' mod--fixedw-30"><i class="fal '+app['icon']+'"></i></div>'
							+ '</div>'
						+'</td>'
						+ '<td>'+app['siteName']+'</td>'
						+ '<td>'+app['description']+'</td>'
						+ '<td>'+app['prestataire']+'</td>'
						+ '<td>'+app['lastScanned']+'</td>'
						+ '</tr>';
			}

			tableStr += '</tbody>'
				+ '</table>';

			MONITORING._showDate(indicator, false);
			container.find('.html-container').html(tableStr);
		}
	});
};

MONITORING._zoneShowHistory = function(target, pointId){
	var
		linkCell = target.closest('td'),
		linkClosestLine = linkCell.closest('tr'),
		linkClosestLineCells = linkClosestLine.find('td'),
		detailLine = target
			.closest('table')
			.find('tr.detail-line')
		;

	return;
};

/** @private */
MONITORING._expandIndicatorDefault = function (container, indicator, dataPanel) {
	
	var indicateurId = indicator.attr('data-indicateur-id');
	var period;
	var periodSelect = dataPanel.attr('data-period');
	var periodDefault = dataPanel.attr('data-default-period');
	var periodIndicator = indicator.attr('data-period');
	var periodOnlyAllowFullMonth = indicator.hasClass('indicator--type-top_conso');
	var indicatorExpandedChanged = indicateurId != dataPanel.attr('indicator-id-selected');

	if(indicatorExpandedChanged) {
		if(periodIndicator != 'undefined' && periodIndicator != '') {
			period = periodIndicator;
		}
		else if (periodOnlyAllowFullMonth) {
			period = 4;
		}
		else {
			period = periodDefault;
		}
	}
	else {
		period = periodSelect;
	}

	dataPanel.attr('data-period', period);
	dataPanel.attr('indicator-id-selected', indicateurId);

	var sectionId = dataPanel.attr('data-sectionid');
	$('#indicators-panel-data-'+sectionId+' .period-select').val(period).trigger('change.select2');
	var dateinput = $('#indicators-panel-data-'+sectionId+' input.datepicker').val();
	var mDateInput = moment(dateinput, 'DD/MM/YYYY');

	switch(parseInt(period)) {
		case 0:
			var startDate = mDateInput;
			break;
		case 1:
			var startDate = mDateInput.clone().subtract(6, 'd');
			break;
		case 2: // mois glissant
			var startDate = mDateInput.clone().subtract(1, 'M');
			break;
		case 4: //full month
			var startDate = mDateInput.clone().startOf('month');
			break;
		case 8: // trimestre
			var startDate = mDateInput.clone().subtract(3, 'M');
			break;
		case 12: // current_year
			var startDate = mDateInput.clone().subtract(11, 'M');
			break;
		case 13: // year
			var startDate = mDateInput.clone().subtract(11, 'M');
			break;
		case 14: // last_years
			var startDate = mDateInput.clone().subtract(10, 'Y');
			break;
		default:
			var startDate = mDateInput.clone().subtract(1, 'M');
	}

	startDate = startDate.format('DD/MM/YYYY');
	var endDate = mDateInput.format('DD/MM/YYYY');

	if(MONITORING.VERBOSE)
		console.log('[MONITORING._expandIndicatorDefault] indicatorId: ' + indicateurId);

	MONITORING.setDates(indicator, startDate, endDate, period, periodDefault);
	MONITORING._showDate(indicator, true);
	MONITORING._showChart(indicator, 'hch-container');

	if(indicator.is('.indicator--type-aggregated') ) {
		HCH.loadDataAggregated(
			HCH.getContainer(container, HCH.INDICATOR_CLASS_CONTAINER),
			indicator.data('indicateur-objettype'),
			{
				date: dataPanel.attr('data-to'),
				dateDebut: startDate,
				dateFin: endDate,
				periode: period,
				sectionId: dataPanel.attr('data-sectionid')
			},
			function () {
				MONITORING._showLoading(container, false);
			});
	}
	else if (indicator.is('.indicator-site--product') || indicator.is('.indicator-site--water')) {
		HCH.loadDataSite(
			HCH.getContainer(container, HCH.INDICATOR_CLASS_CONTAINER),
			indicator.data('siteid'),
			indicator.data('indicateur-objettype'),
			{
				date: dataPanel.attr('data-to'),
				dateDebut: startDate,
				dateFin: endDate,
				periode: period,
				sectionId: dataPanel.attr('data-sectionid')
			},
			function () {
				MONITORING._showLoading(container, false);
			});
	}
	else {
		HCH.loadIndicator(
			HCH.getContainer(container, HCH.INDICATOR_CLASS_CONTAINER),
			indicateurId, {
				date: dataPanel.attr('data-to'),
				dateDebut: startDate,
				periode: period,
				sectionId: dataPanel.attr('data-sectionid')
			},
			function () {
				MONITORING._showLoading(container, false);
			});
	}
};

/** @private */
MONITORING._expandIndicatorPlanning = function (container, indicator, dataPanel) {
	var indicateurId = indicator.attr('data-indicateur-id');

	dataPanel.attr('indicator-id-selected', indicateurId);

	MONITORING._showLoading(container, false);
	MONITORING._showChart(indicator, 'planning-container');

	if(MONITORING.VERBOSE)
		console.log('[MONITORING._expandIndicatorPlanning] Load planning: ' + indicator.attr('data-target'));

	G.ui.GVPlanning.GetInstance(container.find('.gvp')).model_load(indicator.attr('data-target'), true);
};

/** @private */
MONITORING._expandIndicatorGraph = function (container, indicator, dataPanel) {
	var indicateurId = indicator.attr('data-indicateur-id');
	var graphId = (typeof(indicator.attr('data-graphique-linked')) != 'undefined') ? indicator.attr('data-graphique-linked') : indicator.attr('data-target');
	MONITORING._showDate(indicator, true);
	MONITORING._showChart(indicator, 'hch-container');

	var period;
	var periodSelect = dataPanel.attr('data-period');
	var periodDefault = dataPanel.attr('data-default-period');
	var periodIndicator = indicator.attr('data-period');
	var indicatorExpandedChanged = indicateurId != dataPanel.attr('indicator-id-selected');

	if(indicatorExpandedChanged) {
		if(periodIndicator != 'undefined' && periodIndicator != '') {
			period = periodIndicator;
		}
		else {
			period = periodDefault;
		}
	}
	else {
		period = periodSelect;
	}

	dataPanel.attr('data-period', period);
	dataPanel.attr('indicator-id-selected', indicateurId);
	period = parseInt(period);

	var sectionId = dataPanel.attr('data-sectionid');
	$('#indicators-panel-data-'+sectionId+' .period-select').val(period).trigger('change.select2');
	var dateinput = $('#indicators-panel-data-'+sectionId+' input.datepicker').val();
	var mDateInput = moment(dateinput, 'DD/MM/YYYY');
	if(period === 0){
		var startDate = mDateInput;
	} else if(period === 4) { //full month
		var startDate = mDateInput.clone().startOf('month');
	} else if(period === 1) { //week
		var startDate = mDateInput.clone().subtract(6, 'd');
	} else if(period === 14) { //10 years
		var startDate = mDateInput.clone().subtract(10, 'Y');
	} else if(period === 13) { //year
		var startDate = mDateInput.clone().subtract(11, 'M');
	} else if(period === 12) { //week
		var startDate = mDateInput.clone().subtract(11, 'M');
	} else {
		var startDate = mDateInput.clone().subtract(1, 'M');
	}
	startDate = startDate.format('DD/MM/YYYY');

	HCH.loadGraph(HCH.getContainer(container, HCH.INDICATOR_CLASS_CONTAINER), graphId, {
		dateDebut: startDate,
		from: startDate,
		to: dataPanel.attr('data-to'),
		dateFin: dataPanel.attr('data-to'),
		periode: period,
		indicatorId: indicator.attr('data-indicateur-id'),
		sectionId: dataPanel.attr('data-sectionid')
	}, function () {
		MONITORING._showLoading(container, false);
	});
};

/**
 * MULTI-GRAPHIQUE (grande dimension, affichage integre) : alimente depuis la reponse
 * getDataIndicateur (d.multiCharts). On remplit le selecteur de graphique a partir de
 * l'Ajax (plus de rendu serveur), on precharge le graphique par defaut, puis on charge
 * le graphique courant dans l'indicateur. Rappele a chaque getDataIndicateur (periode /
 * changement de selecteur), donc le chargement ne se fait plus au rendu de la vue.
 * @private
 */
MONITORING._indicatorsUpdate_multiChart = function (d) {
	if (!exists(d.multiCharts) || !isarray(d.multiCharts)) {
		return;
	}

	// Regroupe les graphiques renvoyes par indicateur.
	var chartsByIndicator = {};
	d.multiCharts.forEach(function (mc) {
		(chartsByIndicator[mc.indicateurId] = chartsByIndicator[mc.indicateurId] || []).push(mc);
	});

	Object.keys(chartsByIndicator).forEach(function (indicateurId) {
		var indicator = $('#indicator-' + indicateurId);
		// Seul l'affichage integre est gere ici ; la version "bouton" se charge a l'expand.
		if (!indicator.is('.indicator--tpl-chart-integrated.indicator--type-multi_chart')) {
			return;
		}

		var charts = chartsByIndicator[indicateurId];
		var selMultiChart$ = indicator.find('.indicator_sel_multi_chart');

		// Remplit le selecteur depuis l'Ajax si ce n'est pas deja fait (on conserve la selection ensuite).
		if (selMultiChart$.find('option').length === 0 && charts.length > 0) {
			var defaultChart = charts.filter(function (c) { return c.isDefault; })[0] || charts[0];
			charts.forEach(function (c) {
				selMultiChart$.append($('<option></option>').attr('value', c.chartId).text(c.chartName));
			});
			selMultiChart$.val(String(defaultChart.chartId));
			G.ui.initSelect2(selMultiChart$);
		}

		var graphId = selMultiChart$.val();
		if (!graphId || graphId === '-1') {
			HCH.chartReset(HCH.getContainer(indicator.find('.hch-container-chart'), null));
			return;
		}

		var hchContainer = indicator.find('.hch-container');
		var hchContainerChart = indicator.find('.hch-container-chart');
		MONITORING._showLoading(hchContainerChart, true);
		HCH.loadGraph(HCH.getContainer(hchContainerChart, null), graphId, {
			from: hchContainer.attr('data-from'),
			dateDebut: hchContainer.attr('data-from'),
			to: hchContainer.attr('data-to'),
			dateFin: hchContainer.attr('data-to'),
			periode: hchContainer.attr('data-period'),
			indicatorId: indicateurId,
			sectionId: indicator.attr('data-indicateur-section-id')
		}, function () {
			var chart = HCH._getChart(hchContainerChart);
			if (chart) {
				chart.setTitle({ text: selMultiChart$.find('option:selected').text() }, false);
				chart.reflow();
			}
			MONITORING._showLoading(hchContainerChart, false);
		});
	});
};

/**
 * MULTI-GRAPHIQUE (petite dimension) : expand avec selecteur de graphique.
 * Reutilise le hch-container partage (comme le graphique) : on remplit le select
 * depuis getDataIndicateur, on precharge le graphique par defaut, puis chaque
 * changement de graphique recharge via HCH.loadGraph en conservant la periode.
 * @private
 */
MONITORING._expandIndicatorMultiChart = function (container, indicator, dataPanel) {
	var indicateurId = indicator.attr('data-indicateur-id');
	MONITORING._showDate(indicator, true);
	MONITORING._showChart(indicator, 'hch-container');

	// Le selecteur de graphique vit dans l'en-tete du panneau partage : on l'affiche pour multi_chart
	// (il est masque pour les autres types, cf. refreshIndicator).
	var selectorWrap$ = dataPanel.find('.multi-chart-selector');
	selectorWrap$.show();

	// Graphe affiche dans le hch-container partage du panneau (comme l'indicateur graphique).
	var multiChartHch = HCH.getContainer(container, HCH.INDICATOR_CLASS_CONTAINER);
	HCH.chartReset(multiChartHch);

	// --- Periode (meme logique que _expandIndicatorGraph) : on respecte la periode
	//     de l'indicateur a la premiere ouverture, puis celle choisie dans le panneau.
	var period;
	var periodSelect = dataPanel.attr('data-period');
	var periodDefault = dataPanel.attr('data-default-period');
	var periodIndicator = indicator.attr('data-period');
	var indicatorExpandedChanged = indicateurId != dataPanel.attr('indicator-id-selected');

	if (indicatorExpandedChanged) {
		period = (periodIndicator != 'undefined' && periodIndicator != '') ? periodIndicator : periodDefault;
	} else {
		period = periodSelect;
	}

	dataPanel.attr('indicator-id-selected', indicateurId);
	period = parseInt(period);

	var sectionId = dataPanel.attr('data-sectionid');
	var periodSelectEl = $('#indicators-panel-data-' + sectionId + ' .period-select');
	// Aucune periode definie (periodePanel + periode par defaut du panneau vides) : on retombe sur
	// la premiere option du select de periode plutot que de laisser le select vide.
	if (isNaN(period)) {
		period = parseInt(periodSelectEl.find('option').first().val());
	}
	dataPanel.attr('data-period', period);
	periodSelectEl.val(period).trigger('change.select2');

	// Calcule la date de debut a partir de la date de fin du panneau et de la periode.
	function mcComputeStartDate() {
		var dateinput = $('#indicators-panel-data-' + sectionId + ' input.datepicker').val();
		var mDateInput = moment(dateinput, 'DD/MM/YYYY');
		var startDate;
		if (period === 0) {
			startDate = mDateInput;
		} else if (period === 4) { // full month
			startDate = mDateInput.clone().startOf('month');
		} else if (period === 1) { // week
			startDate = mDateInput.clone().subtract(6, 'd');
		} else if (period === 14) { // 10 years
			startDate = mDateInput.clone().subtract(10, 'Y');
		} else if (period === 13 || period === 12) { // year / 12 months
			startDate = mDateInput.clone().subtract(11, 'M');
		} else {
			startDate = mDateInput.clone().subtract(1, 'M');
		}
		return startDate.format('DD/MM/YYYY');
	}

	var selMultiChart$ = selectorWrap$.find('.indicator_sel_multi_chart');

	// Charge dans le hch-container partage le graphique actuellement selectionne.
	function mcLoadSelectedChart() {
		var graphId = selMultiChart$.val();
		if (!graphId || graphId === '-1') {
			return;
		}
		var startDate = mcComputeStartDate();
		MONITORING._showLoading(multiChartHch, true);
		HCH.loadGraph(multiChartHch, graphId, {
			dateDebut: startDate,
			from: startDate,
			to: dataPanel.attr('data-to'),
			dateFin: dataPanel.attr('data-to'),
			periode: period,
			indicatorId: indicateurId,
			sectionId: sectionId
		}, function () {
			MONITORING._showLoading(multiChartHch, false);
		});
	}

	if (!indicatorExpandedChanged) {
		// Meme indicateur (changement de periode) : on recharge le graphique deja selectionne.
		mcLoadSelectedChart();
		return;
	}

	// Nouvel indicateur : on (re)construit la liste des graphiques associes.
	selMultiChart$.off('change.multichart');
	if (selMultiChart$.data('select2')) {
		selMultiChart$.select2('destroy');
	}
	selMultiChart$.empty();

	$.ajax({
		url: G.config.SERVER + 'frontend/ajax/getDataIndicateur',
		type: 'POST',
		data: { 'idIndicateurs': [indicateurId] },
		dataType: 'json',
		error: function () {
			showError(G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
		},
		success: function (response) {
			var charts = (response.multiCharts ?? []).filter(function (chart) {
				return String(chart.indicateurId) === String(indicateurId);
			});

			selMultiChart$.select2({
				width: '100%',
				data: charts.map(function (chart) {
					return { id: chart.chartId, text: chart.chartName };
				})
			});

			if (charts.length === 0) {
				HCH.chartReset(multiChartHch);
				return;
			}

			// Recharge a chaque bascule de graphique (periode conservee).
			selMultiChart$.on('change.multichart', mcLoadSelectedChart);

			// Presaisit le graphique par defaut (sinon le premier de la liste) ; le trigger
			// 'change' met a jour select2 et declenche le chargement initial via change.multichart.
			var defaultChart = charts.filter(function (chart) { return chart.isDefault; })[0];
			selMultiChart$.val(String((defaultChart || charts[0]).chartId)).trigger('change');
		}
	});
};

/** @private */
MONITORING._expandIndicatorHeatingCurve = function (container, indicator, dataPanel) {
	var indicateurId = indicator.attr('data-indicateur-id');

	dataPanel.attr('indicator-id-selected', indicateurId);

	MONITORING._showLoading(container, false);
	MONITORING._showChart(indicator, 'heating-curve-container');
	if(MONITORING.VERBOSE) {
		console.log('[MONITORING._expandIndicatorHeatingCurve] Load heating curve');
	}

	let characteristicCurveGraph = null;
	const selHeatingCurveOfInd$ = dataPanel.find(".indicator_sel_heating_curve");
	selHeatingCurveOfInd$.off("change.select2");
	selHeatingCurveOfInd$.empty();
	if (selHeatingCurveOfInd$.data('select2')) {
		selHeatingCurveOfInd$.select2('destroy');
	}
	
	$.ajax({
		url: G.config.SERVER + 'frontend/ajax/getDataIndicateur',
		type: 'POST',
		data: {
			"idIndicateurs": [indicator.data("indicateur-id")]
		},
		datatype: 'json',
		error: function (xhr, textStatus, errorThrown) {
			showError(G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
		},
		success: function (response) {
			selHeatingCurveOfInd$.select2({
				width: '100%',
				data: (response.heating_curves ?? []).map(function(heatingCurve) {
					return {
						id: heatingCurve.heatingCurveId,
						text: heatingCurve.heatingCurveName
					}
				})
			});
			selHeatingCurveOfInd$.on("change.select2", function(event) {
				dataPanel.find('#indicator_heating_curve_chart_save, #indicator_heating_curve_chart_reset, #indicator_heating_curve_chart_add_point, #indicator_heating_curve_chart_remove_point').off('click');
				dataPanel.find('.indicator_heating_curve_chart .indicator_heating_curve_inp_slope').off('change');
				dataPanel.off('change', '.indicator_heating_curve_chart .courb_point_axis_field');

				const heatingCurveChart$ = dataPanel.find('#indicator_heating_curve_chart');
				const heatingCurveIdSelected = $(this).val();

				if(!heatingCurveIdSelected) {
					heatingCurveChart$.html(`<p>${G.config.LOCALE_RETRIEVE('indicator.noHeatingCurveConfigured')}</p>`);
					return;
				}

				$.ajax({
					url: `${G.config.SERVER}frontend/ajax/heatingCurve/${heatingCurveIdSelected}`,
					type: 'GET',
					dataType: "json",
					beforeSend: function () {
						heatingCurveChart$.empty();
						dataPanel.find(".indicator_heating_curve_chart .indicator_heating_curve_preloader").show();
						dataPanel.find(".indicator_heating_curve_chart .indicator_heating_curve_chart_message").hide();
						dataPanel.find(".indicator_heating_curve_chart .indicator_heating_curve_table_chart").hide();
						dataPanel.find(".indicator_heating_curve_chart .indicator_heating_curve_chart_actions").hide();
						dataPanel.find(".indicator_heating_curve_chart .indicator_heating_curve_points_title").hide();
					},
					error: function (xhr, textStatus, thrownError) {
						showError(G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
					},
					success: function (response) {
						const heatingCurveData = response.heating_curve ?? {};
						const heatingCurveDataSafe = { ...heatingCurveData };

						if(Object.keys(heatingCurveData).length === 0 || !heatingCurveData) {
							heatingCurveChart$.html(`<p>${G.config.LOCALE_RETRIEVE('indicator.noHeatingCurveConfigured')}</p>`);
							return;
						}

						if (heatingCurveData.mode == "default") {
							if (typeof (heatingCurveData.dotsNumMini) == "undefined") {
								heatingCurveChart$.html(`<p>${G.config.LOCALE_RETRIEVE('indicator.noHeatingCurveConfigured')}</p>`);
								return;
							}
						}

						if(exists(characteristicCurveGraph)) {
							characteristicCurveGraph.jqoTarget.off("modelUpdated");
							characteristicCurveGraph.jqoTarget.off("modelExported");
							characteristicCurveGraph.destroy();
						}
						characteristicCurveGraph = new G.ui.CharacteristicCurveGraph(heatingCurveChart$, heatingCurveData);
						characteristicCurveGraph.jqoTarget.on('modelUpdated', function(e, settings) {
							if(exists(settings.linearMaxTemp)) dataPanel.find('.indicator_heating_curve_chart .indicator_heating_curve_inp_slope_temp_max').val(settings.linearMaxTemp);
							if(exists(settings.linearSlope)) dataPanel.find('.indicator_heating_curve_chart .indicator_heating_curve_inp_slope').val(parseFloat(settings.linearSlope).toFixed(1));
							if(exists(settings.coll) && isarray(settings.coll)) {
								$(".indicator_heating_curve_table_chart tbody").empty();
								if(settings.coll.length == 0) {
									dataPanel.find(".indicator_heating_curve_chart .indicator_heating_curve_table_chart tbody").append(`
									<tr>
										<td colspan="3">${G.config.LOCALE_RETRIEVE('datatable.emptyTable')}</td>
									</tr>
								`);
								} else {
									for (const [index, dotColl] of characteristicCurveGraph.o.dotsColl.entries()) {
										dataPanel.find(".indicator_heating_curve_chart .indicator_heating_curve_table_chart tbody").append(`
										<tr>
											<td>${index + 1}</td>
											<td class="text-center"><input type="number" class="uicomp__input courb_point_axis_field" data-point-id="${dotColl.uid}" data-point-axis="x" value="${dotColl["x"]}" ${dotColl["x_type"] == "const" ? "disabled" : ""}/></td>
											<td class="text-center"><input type="number" class="uicomp__input courb_point_axis_field" data-point-id="${dotColl.uid}" data-point-axis="y" value="${dotColl["y"]}" ${dotColl["y_type"] == "const" ? "disabled" : ""}/></td>
										</tr>
									`);
									}
								}

								dataPanel.find(".indicator_heating_curve_chart .indicator_heating_curve_points_title").show();
								dataPanel.find(".indicator_heating_curve_chart .indicator_heating_curve_table_chart").show();
							}
						});
						characteristicCurveGraph.jqoTarget.on('modelUpdated', function(e, coll, dotsMini, dotsMaxi) {
							if (dotsMaxi == dotsMini) {
								dataPanel.find('.indicator_heating_curve_chart #indicator_heating_curve_chart_add_point').css('visibility', 'hidden');
								dataPanel.find('.indicator_heating_curve_chart #indicator_heating_curve_chart_remove_point').css('visibility', 'hidden');
							} else {
								dataPanel.find('.indicator_heating_curve_chart #indicator_heating_curve_chart_add_point')
									.prop('disabled', coll.length >= dotsMaxi)
									.css('visibility', 'visible');
								dataPanel.find('.indicator_heating_curve_chart #indicator_heating_curve_chart_remove_point')
									.prop('disabled', coll.length <= dotsMini)
									.css('visibility', 'visible');
							}
						});
						characteristicCurveGraph.jqoTarget.on('modelExported', function(e, coll) {
							$.ajax({
								url: `${G.config.SERVER}frontend/ajax/heatingCurve/${heatingCurveIdSelected}`,
								type: 'GET',
								error: function (xhr, textStatus, thrownError) {
									console.error('[Synopsis.utilitiesInitCourbe] "' + url + '", ajax error: ' + textStatus, thrownError);
								},
								success: function (response) {
									const newHeatingCurveConfig = response.heating_curve;
									newHeatingCurveConfig["coll"] = coll;
									newHeatingCurveConfig["write"] = [];

									if(newHeatingCurveConfig.mode == "linear") {
										if(newHeatingCurveConfig["coll"]["linearSlope"] && newHeatingCurveConfig["linearSlopePointId"]) {
											newHeatingCurveConfig["write"].push({
												'target'        : 'linearSlope',
												'pointId'       : newHeatingCurveConfig["linearSlopePointId"],
												'mnemonique'    : newHeatingCurveConfig["linearSlopeLabelAutomat"],
												'value'         : newHeatingCurveConfig["coll"]["linearSlope"]
											});
										}
										if(newHeatingCurveConfig["coll"]["linearStep"] && newHeatingCurveConfig["linearStepPointId"]) {
											newHeatingCurveConfig["write"].push({
												'target'        : 'linearStep',
												'pointId'       : newHeatingCurveConfig["linearStepPointId"],
												'mnemonique'    : newHeatingCurveConfig["linearStepLabelAutomat"],
												'value'         : newHeatingCurveConfig["coll"]["linearStep"]
											});
										}

									}

									var heatingCurveCommand = [];
									for (var cc = 0; cc < newHeatingCurveConfig.write.length; cc++) {
										var d = newHeatingCurveConfig.write[cc];
										heatingCurveCommand.push({
											"pointId": d.pointId,
											"value": d.value,
											"mnemonique": d.mnemonique
										});
									}
									if (exists(newHeatingCurveConfig.coll.coll)) {
										for (var cc = 0; cc < newHeatingCurveConfig.coll.coll.length; cc++) {
											if (newHeatingCurveConfig["baelz"] ?? false) {
												heatingCurveCommand.push({
													"pointId": newHeatingCurveConfig.dotsColl[cc].x_pointId,
													"value": parseInt(newHeatingCurveConfig.coll.coll[cc].x),
													"mnemonique": newHeatingCurveConfig.dotsColl[cc].x_label_automate
												});
												heatingCurveCommand.push({
													"pointId": newHeatingCurveConfig.dotsColl[cc].y_pointId,
													"value": parseInt(newHeatingCurveConfig.coll.coll[cc].y),
													"mnemonique": newHeatingCurveConfig.dotsColl[cc].y_label_automate
												});
											} else {
												if (newHeatingCurveConfig.dotsColl[cc].x_type === 'dynamic') {
													heatingCurveCommand.push({
														"pointId": newHeatingCurveConfig.dotsColl[cc].x_pointId,
														"value": parseInt(newHeatingCurveConfig.coll.coll[cc].x),
														"mnemonique": newHeatingCurveConfig.dotsColl[cc].x_label_automate
													});
												}
												if (newHeatingCurveConfig.dotsColl[cc].y_type === 'dynamic') {
													heatingCurveCommand.push({
														"pointId": newHeatingCurveConfig.dotsColl[cc].y_pointId,
														"value": parseInt(newHeatingCurveConfig.coll.coll[cc].y),
														"mnemonique": newHeatingCurveConfig.dotsColl[cc].y_label_automate
													});
												}
											}
										}
									}

									if (heatingCurveCommand.length > 0) {
										$.ajax({
											url: `${G.config.SERVER}frontend/ajax/heatingCurveCommand/${heatingCurveIdSelected}`,
											type: "POST",
											data: {
												data: heatingCurveCommand,
												baelz: newHeatingCurveConfig["baelz"] ?? false
											},
											datatype: 'json',
											beforeSend: function() {
												showInfo(G.config.LOCALE_RETRIEVE('general.saveInProgress'))
											},
											error: function (xhr, textStatus) {
												showError(G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
											},
											success: function (response) {
												showSuccess(G.config.LOCALE_RETRIEVE('indicator.writeParamsProgrammed'));
												showSuccess(G.config.LOCALE_RETRIEVE('indicator.notifyByEmail'));
											}
										});
									}

								}
							});
						});
						characteristicCurveGraph.modelUpdate();

						dataPanel.find(".indicator_heating_curve_chart .indicator_heating_curve_chart_message").toggle(heatingCurveData.meta.writeInProgess);
						if(heatingCurveData.meta.writeInProgess && heatingCurveData.meta.lastRequest) {
							dataPanel.find(".indicator_heating_curve_chart_message").text(
								G.config.LOCALE_RETRIEVE('general.writingRequestSinceTo').replace(
									"{DATE}",
									new Date(heatingCurveData.meta.lastRequest).toLocaleString()
								)
							);
						}

						dataPanel.find('.indicator_heating_curve_chart .indicator_heating_curve_chart_actions').toggle(G.model.user.droit >= heatingCurveData.right ?? 7);

						dataPanel.find('.indicator_heating_curve_chart .indicator_heating_curve_chart_slope').toggle(heatingCurveData.mode != 'default');
						if(!dataPanel.find('.indicator_heating_curve_chart .indicator_heating_curve_chart_slope').is(":visible")) {
							dataPanel.find(".indicator_heating_curve_chart .indicator_heating_curve_points_title").show();
						}

						if (exists(heatingCurveData.linearMaxTemp)) {
							dataPanel.find('.indicator_heating_curve_chart .indicator_heating_curve_inp_slope_temp_max').val(heatingCurveData.linearMaxTemp);
						}
						if (exists(heatingCurveData.linearSlope)) {
							dataPanel.find('.indicator_heating_curve_chart .indicator_heating_curve_inp_slope').val(heatingCurveData.linearSlope);
						}

						dataPanel.find('#indicator_heating_curve_chart_save').on('click', function () {
							characteristicCurveGraph.modelExport();
						});
						dataPanel.find('#indicator_heating_curve_chart_reset').on('click', function () {
							var collSafe = null;
							if(heatingCurveData.mode == "default") {
								// @see https://stackoverflow.com/a/9886013
								collSafe = JSON.parse(JSON.stringify(heatingCurveDataSafe.dotsColl));
							} else {
								collSafe = { ...heatingCurveDataSafe };
							}

							characteristicCurveGraph.modelImport(collSafe);
						});

						dataPanel.find('#indicator_heating_curve_chart_add_point').on('click', function () {
							$(this).prop('disabled', true);
							characteristicCurveGraph.collEditPointAdd();
						});

						dataPanel.find('#indicator_heating_curve_chart_remove_point').on('click', function () {
							$(this).prop('disabled', true);
							characteristicCurveGraph.collEditPointRemove();
						});
						dataPanel.find('.indicator_heating_curve_chart .indicator_heating_curve_inp_slope').on('change', function(event) {
							let slopeInput$ = $(event.currentTarget);
							characteristicCurveGraph.plugin.updateSlope(
								slopeInput$.val()
							);
						});
						dataPanel.on('change', '.indicator_heating_curve_chart .courb_point_axis_field', function(event) {
							let courbPointAxisField$ = $(event.currentTarget);
							characteristicCurveGraph.plugin.updateAxisByUid(
								courbPointAxisField$.data("point-id"),
								courbPointAxisField$.data("point-axis"),
								courbPointAxisField$.val()
							);
						});
					},
					complete: function() {
						dataPanel.find('.indicator_heating_curve_chart .indicator_heating_curve_preloader').hide();
					}
				});
			});

			selHeatingCurveOfInd$
				.find('option:eq(0)')
				.attr('selected','selected');
			selHeatingCurveOfInd$.trigger('change.select2');
		}
	});

}

/** @private */
MONITORING._expandIndicatorLastHistoPoints = function (container, indicator, dataPanel) {
	var indicateurId = indicator.attr('data-indicateur-id');

	dataPanel.attr('indicator-id-selected', indicateurId);

	MONITORING._showLoading(container, false);
	MONITORING._showChart(indicator, 'last-histo-points-container');
	if(MONITORING.VERBOSE) {
		console.log('[MONITORING._expandIndicatorLastHistoPoints] Loading');
	}

	const filterDates = indicator.data("indicator-params")["filter_dates"] ?? "end";

	$(".indicator_last_histo_points_start").toggle(["start", "start_and_end"].includes(filterDates));
	$(".indicator_last_histo_points_end").toggle(["end", "start_and_end"].includes(filterDates));
	$(".indicator_last_histo_points_icon_arrow").toggle(filterDates === "start_and_end");

	$.fn.dataTable.ext.errMode = 'none';
	var csvExportButton$ = dataPanel.find(".indicator_export_csv_last_histo_points");
	csvExportButton$.off("click");
	var datePickerStart$ = dataPanel.find('.indicator_last_histo_points_datepicker_start');
	var timeSelStart$ = dataPanel.find('.indicator_last_histo_points_time_sel_start');
	var datePickerEnd$ = dataPanel.find('.indicator_last_histo_points_datepicker_end');
	var timeSelEnd$ = dataPanel.find('.indicator_last_histo_points_time_sel_end');
	var btnRefresh = dataPanel.find('.indicator_last_histo_points_reload');

	datePickerStart$.off("change");
	timeSelStart$.off("change");
	if(timeSelStart$.hasClass("select2-hidden-accessible")) timeSelStart$.select2("destroy");
	if(["start", "start_and_end"].includes(filterDates)) {
		timeSelStart$.select2({
			width: 'resolve'
		});
	}

	datePickerEnd$.off("change");
	timeSelEnd$.off("change");
	if(timeSelEnd$.hasClass("select2-hidden-accessible")) timeSelEnd$.select2("destroy");
	if(["end", "start_and_end"].includes(filterDates)) {
		timeSelEnd$.select2({
			width: 'resolve'
		});
	}

	var tableIndicatorCounterResult$ = dataPanel.find(".table_indicator_last_histo_points_result");
	if(DataTable.isDataTable(tableIndicatorCounterResult$)) {
		var dtIndicatorCounterResult$ = tableIndicatorCounterResult$.DataTable();
		if(dtIndicatorCounterResult$.settings()[0].jqXHR) dtIndicatorCounterResult$.settings()[0].jqXHR.abort();
		dtIndicatorCounterResult$.destroy();
	}

	var loadLastHisto = function() {
		
		$.ajax({
			url: G.config.SERVER + 'frontend/ajax/getDataIndicateur',
			type: 'POST',
			data: {
				"idIndicateurs": [indicator.data("indicateur-id")]
			},
			datatype: 'json',
			error: function (xhr, textStatus, errorThrown) {
				showError(G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
			},
			success: function (response) {
				const pointIds = (response.last_histo_points ?? []).map(function(last_histo_point) {
					return last_histo_point.point_id
				});

                var $tableIndicator = dataPanel.find(".table_indicator_last_histo_points_result");
                $tableIndicator.off('xhr.dt.displaySite').on('xhr.dt.displaySite', function(e, settings, json) {
                    if (json && json.status === 'success' && json.response && json.response.config) {
                        var api = new $.fn.dataTable.Api(settings);
                        api.column(0).visible(!!json.response.config.displaySite);
                    }
                });

                var dtIndicatorCounterResult = $tableIndicator.DataTable({
                    destroy: true,
                    dom: 'Brtip',
                    order: [[0, "asc"], [1, "asc"]],
                    pageLength: 25,
                    buttons: [
                        {
                            extend: "csvHtml5",
                            text: "CSV",
                            className: "uicomp__button mod--hidden",
                            fieldBoundary: '"',
                            fieldSeparator: ";"
                        }
                    ],
                    ajax: {
                        url: G.config.SERVER + 'frontend/ajax/loadLastHistoOfPoints',
                        type: 'GET',
                        data: {
                            "pointIds": pointIds,
                            "indicateurId": indicator.data("indicateur-id"),
                            "dateStart": ["start", "start_and_end"].includes(filterDates) ? `${datePickerStart$.val()} ${timeSelStart$.val()}` : null,
                            "dateEnd": ["end", "start_and_end"].includes(filterDates) ? `${datePickerEnd$.val()} ${timeSelEnd$.val()}` : null
                        },
                        beforeSend: function() {
                            btnRefresh.prop("disabled", true);
                        },
                        dataSrc: function (json) {
                            if (json.status == "success") {
                                return Object.values(json.response.data); // <-- .data ajouté
                            } else {
                                showError(json.message ?? G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
                                return [];
                            }
                        },
                        error: function(request, textStatus, errorThrown) {
                            if (request.statusText !== "abort") showError(G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
                        },
                        complete: function() {
                            btnRefresh.prop("disabled", false);
                        }
                    },
                    columnDefs: [
                        { visible: ["start", "start_and_end"].includes(filterDates), targets: [3, 4] },
                        { visible: ["end", "start_and_end"].includes(filterDates), targets: [5, 6] },
                    ],
                    columns: [
                        { data: 'site' },
                        { data: 'equipment' },
                        { data: 'pointLabelHuman' },
                        { data: 'start_value' },
                        { data: 'start_date' },
                        { data: 'end_value' },
                        { data: 'end_date' }
                    ],
                    drawCallback: function(settings) {
                        csvExportButton$.off("click");
                        csvExportButton$.click(function() { dtIndicatorCounterResult.button(0).trigger(); });
                        MONITORING._initMasonryViewIndicatorContainers("indicators-container");
                    },
                    language: G.config.LOCALE_RETRIEVE('datatable')
                });
			}
		});
	}

	datePickerStart$.prop("max", moment().format('YYYY-MM-DD'));
	datePickerEnd$.prop("max", moment().format('YYYY-MM-DD'));

	btnRefresh.click(loadLastHisto);

	const momentFirstDayOfMonth = moment().startOf('year');
	timeSelStart$.val(momentFirstDayOfMonth.format("HH:mm")).trigger("change.select2");
	datePickerStart$.val(momentFirstDayOfMonth.format('YYYY-MM-DD')).trigger("change");

	const momentNow = moment();
	const minuteNearestToMomentNow = momentNow.minute() % 5;
	momentNow.subtract(minuteNearestToMomentNow, "minutes");
	timeSelEnd$.val(momentNow.format("HH:mm")).trigger("change.select2");
	datePickerEnd$.val(momentNow.format('YYYY-MM-DD')).trigger("change");

	loadLastHisto();
}

// ------------ ODYSECURE INDICATORS PANEL
/** @private */
MONITORING._expandOdyIndicator = function (indicateur, idIndicateur, entree, date, periode) {
	var url = MONITORING._expandOdyUtils_buildUrl('getHistoryFromEntree', entree, date, periode);

	if(MONITORING.VERBOSE)
		console.log('[MONITORING._expandOdyIndicator] url: "' + url + '"');

	$.getJSON(url, function (data) {

		var chartConfig = {
			tooltip: {
				formatter: function () {
					var
						s = '',
						specIds = [
							'_expandOdyIndicator__static-alert-high',
							'_expandOdyIndicator__static-hyst-high',
							'_expandOdyIndicator__static-objective',
							'_expandOdyIndicator__static-hyst-low',
							'_expandOdyIndicator__static-alert-low'
						],
						chart = this.points[0].series.chart;

					s += '<div class="tooltip-title">' + Highcharts.dateFormat('%d/%m/%Y à %H:%m', new Date(this.x)) + '</div>';
					s += '<div class="tooltip-rows">';
					this.points.forEach(function (el) {

						if (specIds.indexOf(el.series.userOptions.id) >= 0)
							return;

						var
							classname = el.series.userOptions.className,
							options = el.series.tooltipOptions;

						if (!isfilled(classname) || classname.indexOf('hidden-dataset') < 0) {
							s += '<div class="tooltip-row">'
								+ '<div class="tooltip-row__label"><span class="bullet" style="background-color:' + G.clr.ODY_ARR[el.series.colorIndex] + ';"></span>' + el.series.name + '</div>'
								+ '<div class="tooltip-row__value">';
							if (options.hasOwnProperty('valuePrefix'))
								s += options.valuePrefix;
							if (el.point.hasOwnProperty('low')) {
								s += Highcharts.numberFormat(el.point.low, el.series.valueDecimals) + ' - ' + Highcharts.numberFormat(el.point.high, el.series.valueDecimals)
							} else {
								s += Highcharts.numberFormat(el.y, el.series.valueDecimals);
							}
							if (options.hasOwnProperty('valueSuffix'))
								s += options.valueSuffix;
							s += '</div></div>';
						}
					});

					s += '<div class="tooltip-row tooltip-row--spacer"></div>';

					specIds.forEach(function (id, index) {
						var series, options;

						series = chart.get(id);
						if (!series)
							return;
						options = series.options;

						s += '<div class="tooltip-row">'
							+ '<div class="tooltip-row__label"><span class="bullet" style="background-color:' + G.clr.ODY_ARR[series.colorIndex] + ';"></span>' + series.name + '</div>'
							+ '<div class="tooltip-row__value">';
						if (options.hasOwnProperty('valuePrefix'))
							s += options.valuePrefix;
						s += Highcharts.numberFormat(series.data[0].y, series.valueDecimals);
						if (options.hasOwnProperty('valueSuffix'))
							s += options.valueSuffix;
						s += '</div></div>';
					});
					s += '</div>';
					return s;
				}
			},
			yAxis: [
				{
					title: {
						text: null
					}
				}
			],
			series: [
				{
					id: '_expandOdyIndicator__value',
					// type: 'line',
					name: data[0].name,
					data: data[0].data,
					zIndex: 1,
					className: 'dataset--thick',
					colorIndex: G.clr.ODY_ARR.indexOf(G.clr.ODY_ENUM.chartLine),
					marker: {
						symbol: 'circle',
						colorIndex: G.clr.ODY_ARR.indexOf(G.clr.ODY_ENUM.chartLine)
					}
				},
				{
					id: '_expandOdyIndicator__arearange',
					type: 'arearange',
					name: 'Plage', // @todo i18n
					data: data[1].data,
					colorIndex: G.clr.ODY_ARR.indexOf(G.clr.ODY_ENUM.chartMedian),
					className: 'ody-arearange',
					zIndex: 0,
					marker: {
						symbol: 'circle',
						colorIndex: G.clr.ODY_ARR.indexOf(G.clr.ODY_ENUM.chartMedian)
					}
				}
			]
		};

		if (exists(data[0].objectif[0]) && data[0].objectif[0][1] !== 0) {
			chartConfig.series.push({
				id: '_expandOdyIndicator__static-objective',
				type: 'line',
				name: 'Objectif', // @todo i18n
				data: data[0].objectif,
				zIndex: 2,
				colorIndex: G.clr.ODY_ARR.indexOf(G.clr.ODY_ENUM.greend),
				className: 'dataset--thin',
				marker: {
					symbol: 'circle',
					colorIndex: G.clr.ODY_ARR.indexOf(G.clr.ODY_ENUM.greend)
				}
			});
		}

		if (exists(data[0].alarme_haut_type) && data[0].alarme_haut_type !== 0) {
			chartConfig.series.push({
				id: '_expandOdyIndicator__static-alert-high',
				type: 'line',
				name: 'Alerte Haute', // @todo i18n
				data: data[0].alarme_haut,
				className: 'dataset--ultrathin',
				colorIndex: G.clr.ODY_ARR.indexOf(G.clr.ODY_ENUM.alarmError),
				zIndex: 1,
				marker: {
					symbol: 'circle',
					colorIndex: G.clr.ODY_ARR.indexOf(G.clr.ODY_ENUM.alarmError)
				}
			});
			chartConfig.series.push({
				id: '_expandOdyIndicator__static-hyst-high',
				type: 'line',
				name: 'Hystérésis Haute', // @todo i18n
				data: data[0].hysteresis_haut,
				zIndex: 1,
				colorIndex: G.clr.ODY_ARR.indexOf(G.clr.ODY_ENUM.alarmWarning),
				className: 'dataset--light dataset--dashed',
				marker: {
					symbol: 'circle',
					colorIndex: G.clr.ODY_ARR.indexOf(G.clr.ODY_ENUM.alarmWarning)
				}
			});
		}

		if (exists(data[0].alarme_bas_type) && data[0].alarme_bas_type !== 0) {
			chartConfig.series.push({
				id: '_expandOdyIndicator__static-alert-low',
				type: 'line',
				name: 'Alerte Basse', // @todo i18n
				data: data[0].alarme_bas,
				colorIndex: G.clr.ODY_ARR.indexOf(G.clr.ODY_ENUM.alarmError),
				className: 'dataset--thin',
				zIndex: 1,
				marker: {
					symbol: 'circle',
					colorIndex: G.clr.ODY_ARR.indexOf(G.clr.ODY_ENUM.alarmError)
				}
			});
			chartConfig.series.push({
				id: '_expandOdyIndicator__static-hyst-low',
				type: 'line',
				name: 'Hystérésis Basse', // @todo i18n
				data: data[0].hysteresis_bas,
				zIndex: 1,
				colorIndex: G.clr.ODY_ARR.indexOf(G.clr.ODY_ENUM.alarmWarning),
				className: 'dataset--light dataset--dashed',
				marker: {
					symbol: 'circle',
					colorIndex: G.clr.ODY_ARR.indexOf(G.clr.ODY_ENUM.alarmWarning)
				}
			});
		}

		MONITORING._expandOdyUtils_printGraph(indicateur, chartConfig, false);
	});
};
// --- ODYSECURE UTILS

/**
 * @private
 */
MONITORING._expandOdyUtils_printGraph = function (indicateur, chartConfig, showCuve) {
	var indicatorContainer = indicateur.closest('.indicators-container'),
		containerEl = HCH.getContainer(indicatorContainer, HCH.INDICATOR_CLASS_CONTAINER),
		chart = HCH._getChart(containerEl);

	HCH.chartReset(containerEl);

	MONITORING._showLoading(containerEl, false);

	MONITORING._expandOdyUtils_showCuve(showCuve);

	chart.update(
		Highcharts.merge(HCH.ConfigOdysecureCore, chartConfig, MONITORING._expandOdyUtils_getTitleConfig(indicateur)),
		true,
		true,
		false
	);

	HCH._chartReflow(containerEl, true);
};

/**
 * @returns {string}
 * @private
 */
MONITORING._expandOdyUtils_buildUrl = function (service, entree, date, periode) {
	return 'https://odysecure.odyssee-environnement.fr/backend/chart/' + service + '/'
		+ date.replace(new RegExp("/", 'g'), "-")
		+ "/" + entree
		+ "/" + periode;
};

/**
 * @param indicateur
 * @returns {{title: {text: *}, subtitle: {text: string}}}
 * @private
 */
MONITORING._expandOdyUtils_getTitleConfig = function (indicateur) {
	var
		indicatorContainer = indicateur.closest('.indicators-container'),
		panelData = indicatorContainer.find('.hch-container'),
		from = panelData.attr('data-date-from'),
		to = panelData.attr('data-date-to');

	return {
		title: {
			text: indicateur.find('header h3').text()
		},
		subtitle: {
			text: G.config.LOCALE_RETRIEVE(from === to ? 'hch.subtitleFromToSingle' : 'hch.subtitleFromTo')
				.replace('{DATE_FROM}', from)
				.replace('{DATE_TO}', to)
		}
	};
};

/** @private */
MONITORING._expandOdyUtils_showCuve = function (status) {
	$('#panel-data-content-ody')
		.find('.hch-container')
		.toggleClass('gvg-5on6', status)
		.toggleClass('gvg-6on6', !status);
	$('#cuve-container').toggle(status);
};

/** @private */
MONITORING._expandOdyUtils_fill = function () {
	var
		tk = $('#btn-cuve').attr('data-cuve').split(','),
		cons = Math.round((tk[1] - tk[2]) * 100) / 100,
		h = $('.cuve').height() - 5
		lvlh = tk[3] / tk[0] * h
	;

	//capacité cuve | niveau précédent | niveau actuel | appro | alarm

	$('.level--previous')
		.css('height', tk[1] / tk[0] * h)
		.find('b').html(cons + ' kg consommé' + (cons > 1 ? 's' : '')) // @todo i18n
		.toggle(tk[1] != tk[2]);

	$('.level--current').css({
		'background-color': G.clr.ODY_ENUM.chartMedian,
		'margin-bottom': 0,
		'height': tk[2] / tk[0] * h
	})
		.find('b').html(tk[2] + ' kg. restant'); // @todo i18n

	$('.level--odysel').css('height', 0);
	$('.level--appro, .level--alarm').css('height', lvlh);
	$('.cuve--value').html('');
};

/** @private */
MONITORING._expandOdyUtils_fillOdysel = function () {
	var
		tk = $('#btn-cuve').attr('data-cuve').split(','),
		h = $('.cuve').height() - 5,
		cons = Math.round((tk[1] - tk[2]) * 100) / 100,
		lvlh = tk[2] / tk[0] * h
	;

	$('.level--previous').css('height', tk[1] / tk[0] * h)
		.find('b').html(cons + ' kg consommé' + (cons > 1 ? 's' : ''))
		.toggle(tk[1] !== tk[2]);

	$('.level--current')
		.css({
			"background-color": "#BBBBBB",
			"margin-bottom": lvlh / 5,
			"height": 4 * (lvlh / 5)
		})
		.find('b').html('');

	$('.level--odysel').css({
		"background-color": G.clr.ODY_ENUM.chartMedian,
		"height": lvlh / 5,
		"opacity": 0.5,
		"z-index": 5
	});
	$('.level--appro, .level--alarm').css('height', tk[3] / tk[0] * h);
	$('.cuve--value').html('');
};

MONITORING.getAggregatedData = function (date, mode) {
	data = (date == null || typeof(date) == "undefined") ? "" : date;
	$.ajax({
		url: '/apigv/user/getConsumptionAggregated/'+date,
		headers: {
			"Content-Type": "application/json",
			"Authorization": "Bearer "+G.model.userApiKey
		},
		type: 'GET',
		dataType: 'json',
		error: function (xhr, textStatus) {
			showError(xhr.responseJSON.message);
		},
		success: function (data) {
			if (data.status == 'error') {
				showError(data.message);
				return false;
			}
			data = data.response;
			if (exists(data.seriesproduct) && data.seriesproduct.value.length > 0) {
				var ind = $('#indicator-piechart-product'); 
				var pie = $('#indicator-piechart-consoproduct'); 
				var p = data.seriesproduct;
				if(exists(p.date)){
					ind
						.find('.ind__date-ts')
						.html(p.date);	
				}
				HCH.chartReset(pie);

				HCH.chartContext(pie, {
					siteId: 0
				}, true);

				HCH.init(
					pie,
					Highcharts.merge(HCH.ConfigPieChartCore, {
						chart: {
							plotBackgroundColor: null,
							plotBorderWidth: null,
							plotShadow: false,
							margin: [0, 0, 0, 0],
							height: pie.parent(".pie-chart__container__chart").height(),
							events: {
								load: function() {
									var dataBlock;
									var total = 0;
									var str_ind_content_wrapper = "";
									var str_data_block_txt_value = "";
									let indicator_is_large = false;

									if(exists(p.label)) {
										str_ind_content_wrapper += `<h6><strong>${p.label}</strong></h6>`;
									}
									str_ind_content_wrapper += "<ul>";
									for (const serieHch of this.series) {
										total += serieHch.total;
										for (const serieHchPoint of serieHch.points) {
											var cEl = document.createElement('li');
											cEl.innerHTML = '<span class="txt-label">' + serieHchPoint.name + '</span><i class="fas fa-circle" style="font-size: .8em; color:' + G.clr.GV_ARR[serieHchPoint.colorIndex] + ';"></i>'
												+ '<span class="txt-value">' + Highcharts.numberFormat(serieHchPoint.y, 1) + '</span><span>'+p.unit+'</span>';
											str_ind_content_wrapper += cEl.outerHTML;
										}
									}
									str_ind_content_wrapper += "</ul>";

									if(p.dimensions === "full_width") {
										indicator_is_large = true;
									}
									else {
										const [indicatorWidth, indicatorHeight] = (p?.dimensions ?? "1:1").split(":").map(Number);
										indicator_is_large = indicatorWidth > 1 && indicatorHeight > 1;
									}

									const display_btn_ind_detail_toggler = !indicator_is_large;
									const suffix_class_captions = indicator_is_large ? "large" : "detail";

									ind
										.find('.pie-chart__container__action .ind__detail-toggler')
										.toggle(display_btn_ind_detail_toggler);
									ind
										.find(`.ind__detail-inner .ind__content-wrapper.pie-chart__captions`)
										.empty();
									ind
										.find(`.ind__content-wrapper.pie-chart__captions.pie-chart__captions--${suffix_class_captions}`)
										.html(str_ind_content_wrapper);

									str_data_block_txt_value = total;
									if(p.unit) str_data_block_txt_value += `<small>${p.unit}</small>`;

									dataBlock = $('#data-brick__ind-' + p.indicateurId + '__ref-value');
									dataBlock
										.find('.txt-value')
										.html(str_data_block_txt_value);
									dataBlock
										.find('.txt-label')
										.html(G.config.LOCALE_RETRIEVE('indicator.total'))
										.toggle(true)
									;
								}
							}
						},
						plotOptions: {
							pie: {
								dataLabels: {
									enabled: false
								}
							}
						},
						tooltip: {
							animation: false,
							padding: 0,
							hideDelay: 150,
							formatter: function () {
								var
									options = this.series.tooltipOptions,
									str = '';

								str += '<div class="tooltip-rows">';
								str += '<div class="tooltip-row" >'
									+ '<div class="tooltip-row__label"><span class="bullet" style="background-color:' + G.clr.GV_ARR[this.point.colorIndex] + '"></span>' + this.point.name + '</div>'
									+ '<div class="tooltip-row__value">';

								if (options.hasOwnProperty('valuePrefix'))
									str += options.valuePrefix;

								str += this.point.percentage.toFixed(1)+"%";
								str += '</div></div>';

								return str;
							},
							useHTML: true
						},
						navigation: {
							buttonOptions: {
								enabled: false
							}
						},
						legend: {
							enabled: false,
						},
						series: [{
							data: p.value.map(function(v) {
								return {
									name: v.label,
									y: v.value,
									colorIndex: v.color
								}
							})
						}]
					}),
					false,
					false,
					false,
					G.config.LOCALE_RETRIEVE('highchart'),
					false
				);
			} else {
				const container = document.getElementById('indicator-piechart-consoproduct');
				container.innerHTML = '<div class="hch-nodata-message">'+G.config.LOCALE_RETRIEVE('highchart.noData')+'</div>';
				container.classList.add('hch-container--nodata');
			}
			if (exists(data.serieswater) && data.serieswater.value.length > 0) {
				var ind = $('#indicator-piechart-water'); 
				var pie = $('#indicator-piechart-consowater'); 
				var p = data.serieswater;
				if(exists(p.date)){
					ind
						.find('.ind__date-ts')
						.html(p.date);	
				}
				HCH.chartReset(pie);

				HCH.chartContext(pie, {
					siteId: 0
				}, true);

				HCH.init(
					pie,
					Highcharts.merge(HCH.ConfigPieChartCore, {
						chart: {
							plotBackgroundColor: null,
							plotBorderWidth: null,
							plotShadow: false,
							margin: [0, 0, 0, 0],
							height: pie.parent(".pie-chart__container__chart").height(),
							events: {
								load: function() {
									var dataBlock;
									var total = 0;
									var str_ind_content_wrapper = "";
									var str_data_block_txt_value = "";
									let indicator_is_large = false;

									if(exists(p.label)) {
										str_ind_content_wrapper += `<h6><strong>${p.label}</strong></h6>`;
									}
									str_ind_content_wrapper += "<ul>";
									for (const serieHch of this.series) {
										total += serieHch.total;
										for (const serieHchPoint of serieHch.points) {
											var cEl = document.createElement('li');
											cEl.innerHTML = '<span class="txt-label">' + serieHchPoint.name + '</span><i class="fas fa-circle" style="font-size: .8em; color:' + G.clr.GV_ARR[serieHchPoint.colorIndex] + ';"></i>'
												+ '<span class="txt-value">' + Highcharts.numberFormat(serieHchPoint.y, 1) + '</span><span>'+p.unit+'</span>';
											str_ind_content_wrapper += cEl.outerHTML;
										}
									}
									str_ind_content_wrapper += "</ul>";

									if(p.dimensions === "full_width") {
										indicator_is_large = true;
									}
									else {
										const [indicatorWidth, indicatorHeight] = (p?.dimensions ?? "1:1").split(":").map(Number);
										indicator_is_large = indicatorWidth > 1 && indicatorHeight > 1;
									}

									const display_btn_ind_detail_toggler = !indicator_is_large;
									const suffix_class_captions = indicator_is_large ? "large" : "detail";

									ind
										.find('.pie-chart__container__action .ind__detail-toggler')
										.toggle(display_btn_ind_detail_toggler);
									ind
										.find(`.ind__detail-inner .ind__content-wrapper.pie-chart__captions`)
										.empty();
									ind
										.find(`.ind__content-wrapper.pie-chart__captions.pie-chart__captions--${suffix_class_captions}`)
										.html(str_ind_content_wrapper);

									str_data_block_txt_value = total;
									if(p.unit) str_data_block_txt_value += `<small>${p.unit}</small>`;

									dataBlock = $('#data-brick__ind-' + p.indicateurId + '__ref-value');
									dataBlock
										.find('.txt-value')
										.html(str_data_block_txt_value);
									dataBlock
										.find('.txt-label')
										.html(G.config.LOCALE_RETRIEVE('indicator.total'))
										.toggle(true)
									;
								}
							}
						},
						plotOptions: {
							pie: {
								dataLabels: {
									enabled: false
								}
							}
						},
						tooltip: {
							animation: false,
							padding: 0,
							hideDelay: 150,
							formatter: function () {
								var
									options = this.series.tooltipOptions,
									str = '';

								str += '<div class="tooltip-rows">';
								str += '<div class="tooltip-row" >'
									+ '<div class="tooltip-row__label"><span class="bullet" style="background-color:' + G.clr.GV_ARR[this.point.colorIndex] + '"></span>' + this.point.name + '</div>'
									+ '<div class="tooltip-row__value">';

								if (options.hasOwnProperty('valuePrefix'))
									str += options.valuePrefix;

								str += this.point.percentage.toFixed(1)+"%";
								str += '</div></div>';

								return str;
							},
							useHTML: true
						},
						navigation: {
							buttonOptions: {
								enabled: false
							}
						},
						legend: {
							enabled: false,
						},
						series: [{
							data: p.value.map(function(v) {
								return {
									name: v.label,
									y: v.value,
									colorIndex: v.color
								}
							})
						}]
					}),
					false,
					false,
					false,
					G.config.LOCALE_RETRIEVE('highchart'),
					false
				);
			} else {

				/*var ind = $('#indicator-piechart-water');
				$('#indicator-piechart-water .pie-chart__container__chart').hide();
				$('#indicator-piechart-water .pie-chart__captions--large').css("text-align", "center");
				$('#indicator-piechart-water .pie-chart__captions--large').html(G.config.LOCALE_RETRIEVE('highchart.noData')); //no_data_available*/
				const container = document.getElementById('indicator-piechart-consowater');
				container.innerHTML = '<div class="hch-nodata-message">'+G.config.LOCALE_RETRIEVE('highchart.noData')+'</div>';
				container.classList.add('hch-container--nodata');
			}
		}
	});
};

// ------------ INDICATORS VALUES UPDATE
MONITORING.indicatorsUpdate = function (odyOnly, indicateurId, date, mode, sectionId) {
	var
		data = {
			date: null,
			mode: mode,
			idIndicateurs: [],
			idIndicatorsWithChartIntegrated: []
		},
		container = $('.indicators-container'),
		promiseIndicatorsUpdate = [];
	
	if(typeof(sectionId) != 'undefined'){
		container = $('#indicators-container-'+sectionId);
	}

	if(MONITORING.VERBOSE)
		console.time('[MONITORING.indicatorsUpdate]');

	if (!exists(odyOnly) || !isbool(odyOnly))
		odyOnly = false;

	// ---	odysecure indicators require a date settings

	if (odyOnly) {
		data.date = $('#section-monitoring-odysecure')
			.find('.filters-date-selector')
			.attr('date');
	}

	if(typeof(indicateurId) == 'undefined' || indicateurId == null){
		container.find('article.indicator').each(function () {
			var self = $(this);
			if((!odyOnly || self.is('.indicator--odysecure'))
				&& !self.is('.indicator--info-block')){
				if(self.is('.indicator--tpl-chart-integrated.indicator--type-graphique')) data.idIndicatorsWithChartIntegrated.push(self.attr('data-indicateur-id'));
				else data.idIndicateurs.push(self.attr('data-indicateur-id'));
				self.addClass('indicator--loading');
			}
		});
		if(typeof(date) != 'undefined'){
			data.date = date;
		}
	} else {
		var ind = $('#indicator-'+indicateurId);
		if(ind.is('.indicator--tpl-chart-integrated.indicator--type-graphique')) data.idIndicatorsWithChartIntegrated.push(indicateurId);
		else data.idIndicateurs.push(indicateurId);

		data.date = date;
	}
	
	// avoid useless ajax call
	if(data.idIndicateurs.length == 0 && data.idIndicatorsWithChartIntegrated.length == 0){
		MONITORING._indicatorsUpdateSuccess({
			status: 'cancelled'
		});
	}

	promiseIndicatorsUpdate.push(new Promise((resolve, reject) => {
		
		$.ajax({
			url: G.config.SERVER + 'frontend/ajax/getDataIndicateur',
			type: 'POST',
			data: data,
			datatype: 'json',
			error: function (xhr, textStatus, errorThrown) {
				G.ui.fatalError(textStatus, { url: this.url, textStatus: textStatus, error: errorThrown, params: JSON.stringify(data) });
				reject()
			},
			success: function (d) {
				if(MONITORING.VERBOSE){
					console.log('\t [MONITORING.indicatorsUpdate] Successfully updated indicators');
					console.timeEnd('[MONITORING.indicatorsUpdate]');
				}

				resolve(d);
			}
		});
	}));

	for (const idIndicatorWithChartIntegrated of data.idIndicatorsWithChartIntegrated) {
		let indChartIntegrated = $(`#indicator-${idIndicatorWithChartIntegrated}`);
		let hchContainer = indChartIntegrated.find(".hch-container");
		let hchContainerChart = indChartIntegrated.find(".hch-container-chart");
		let indChartIntegratedGraphId = (typeof(indChartIntegrated.attr('data-graphique-linked')) != 'undefined') ? indChartIntegrated.attr('data-graphique-linked') : indChartIntegrated.attr('data-target');
		let indPanelDate = indChartIntegrated.find("." + MONITORING.CLASS_INDICATOR_PANEL_DATE);

		promiseIndicatorsUpdate.push(new Promise((resolve) => {
			MONITORING._showLoading(hchContainerChart, true);
			HCH.loadGraph(HCH.getContainer(hchContainerChart, null), indChartIntegratedGraphId, {
				from: hchContainer.attr("data-from"),
				dateDebut: hchContainer.attr("data-from"),
				to: hchContainer.attr("data-to"),
				dateFin: hchContainer.attr("data-to"),
				periode: hchContainer.attr("data-period"),
				indicatorId: idIndicatorWithChartIntegrated,
				sectionId: sectionId
			}, function () {
				indChartIntegrated.find('div.toggle-chart').hide();
				indChartIntegrated.find('div.switch-chart-pie').hide();
                indChartIntegrated.find('button.ind__refresh').hide();

				var chart = HCH._getChart(hchContainerChart)
				chart.setTitle(
					{ text: indChartIntegrated.attr('data-indicateur-name') },
					false
				);
				chart.reflow();
				MONITORING._showLoading(hchContainerChart, false);

				resolve();
			});
		}));
	}

	Promise.all(promiseIndicatorsUpdate)
		.then((values) => {
			MONITORING._indicatorsUpdateSuccess(values[0] ?? {});
		})
		.catch((error) => {
			showError(G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
		});
};

/** @private */
MONITORING._indicatorsUpdateSuccess = function (d) {

	if(MONITORING.VERBOSE){
		console.log('[MONITORING._indicatorsUpdateSuccess] status: ' + d.status);
		console.log('\t - d: ', d);
		if(d.status === 'error')
			console.log('\t - error: ', d.error);
		['action', 'agrege', 'alarme', 'calcul', 'conso', 'perf', 'perf_solar', 'slider', 'odygauge', 'valeur', 'odyssee', 'piechart', 'inventory_equipment', 'heatmapchart', 'sankey'].forEach(function(prop){
			if(exists(d[prop]))
				console.log('\t - ' + prop + ': ', d[prop]);
		});
	}
	
	if(d.status !== 'error'){
		$('.indicator').removeClass('indicator--uninitialized');
		$('.indicator').removeClass('indicator--loading');
		
		MONITORING._indicatorsUpdate_action(d);
		MONITORING._indicatorsUpdate_alarme(d);
		MONITORING._indicatorsUpdate_agrege(d);
		MONITORING._indicatorsUpdate_array(d);
		MONITORING._indicatorsUpdate_calcul(d);
		MONITORING._indicatorsUpdate_co2(d);
		MONITORING._indicatorsUpdate_conso(d);
		MONITORING._indicatorsUpdate_ecart(d);
		MONITORING._indicatorsUpdate_event(d);
		MONITORING._indicatorsUpdate_html(d);
		MONITORING._indicatorsUpdate_humidity(d);
		MONITORING._indicatorsUpdate_odyradar(d);
		MONITORING._indicatorsUpdate_odysel(d);
		MONITORING._indicatorsUpdate_perf(d);
		MONITORING._indicatorsUpdate_perfSolar(d);
		MONITORING._indicatorsUpdate_planning(d);
		MONITORING._indicatorsUpdate_valeur(d);
		MONITORING._indicatorsUpdate_slider(d);
		MONITORING._indicatorsUpdate_piechart(d);
		MONITORING._indicatorsUpdate_tank(d);
		MONITORING._indicatorsUpdate_temperature(d);
		MONITORING._indicatorsUpdate_trio(d);
		MONITORING._indicatorsUpdate_heatingCurve(d);
		MONITORING._indicatorsUpdate_lastHistoPoints(d);
		MONITORING._indicatorsUpdate_inventory_equipment(d);
		MONITORING._indicatorsUpdate_postit(d);
		MONITORING._indicatorsUpdate_terminalRegulation(d);
		MONITORING._indicatorsUpdate_heatmapchart(d);
        MONITORING._indicatorsUpdate_sankey(d);
        MONITORING._indicatorsUpdate_multiChart(d);
    }
};
/** @private */
MONITORING._indicatorsUpdate_sharedActions = function(p){
	var
		tmp,
		ind = $('#indicator-' + p.indicateurId),
		getDate = function(d, asDays){
		var str;

		asDays = isbool(asDays) ? asDays : false;
		if(asDays)
			str = moment(d, 'DD/MM/YYYY');
		else
			str = moment(d, 'DD/MM/YYYY HH:mm:ss');
		return str;
	};

	switch(p.unit){
		case 'm3':
			p.unit = 'm<sup>3</sup>';
			break;
		case 'm2':
			p.unit = 'm<sup>2</sup>';
			break;
	}

	p.displayValue = !isbool(p.displayValue) || p.displayValue === 1;

	// ---   status

	p.status = isdefined(p.status) ? p.status : 'status-default';
	if(p.status.indexOf('status-') !== 0)
		p.status = 'status-' + p.status;
	switch(p.status){
		case 'status-ok':
		case 'status-success':
			p.statusColor = 'green';
			break;
		case 'status-warning':
			p.statusColor = 'orange';
			break;
		case 'status-alert':
			p.statusColor = 'red';
			break;
		case 'status-info':
			p.statusColor = 'blue';
			break;
		case 'status-default':
			p.statusColor = null;
			break;
		default:
			p.statusColor = null;
			console.warn('[MONITORING._indicatorsUpdate_sharedActions] Unhandled status:' + p.status, p);
			break;
	}
	ind.attr('data-status', p.status);

	// ---   date
	p.dateStr = '';
	if(exists(p.from) && exists(p.to) && p.from != p.to) {
		p.dateStr = G.config.LOCALE_RETRIEVE('general.fromTo')
			.replace('{DATE_FROM}', getDate(p.from, true).format('DD/MM'))
			.replace('{DATE_TO}', getDate(p.to, true).format('DD/MM/YYYY'))
		;
	}
	else if (exists(p.from))
		p.dateStr = p.from;
	else if (exists(p.date)){
		if(getDate(p.date, false).format('HH:mm') == "00:00"){
			p.dateStr = getDate(p.date, false).format('DD/MM/YYYY');
			
		} else {
			p.dateStr = getDate(p.date, false).format('DD/MM/YYYY HH:mm');

		}

	}

	if(exists(p.fictitious) && p.fictitious) {
		tmp = $('#indicator-' + p.indicateurId + ' .ind__date-ts');
		tmp
			.addClass('mod--fictitious')
			.addClass('gv-tip')
			.attr('title', G.config.LOCALE_RETRIEVE('indicator.fictitiousTooltip'))
		;
		G.ui.tippedInit(tmp);
	} else {
		tmp = $('#indicator-' + p.indicateurId + ' .ind__date-ts');
		tmp
			.removeClass('mod--fictitious');
	}

	if(p.type !== 'multi') {
		tmp = $('#indicator-' + p.indicateurId + ' .ind__date-ts');
		tmp.html(p.dateStr);
		if(p.obsolete){
			tmp
				.addClass('mod--obsolete')
				.addClass('gv-tip')
				.attr('title', G.config.LOCALE_RETRIEVE('indicator.obsoleteTooltip'))
			;
			G.ui.tippedInit(tmp);
		}
	} else if(exists(p.displayDate) && p.displayDate) {
		// tmp = $('#indicator-' + p.indicateurId + ' .txt-date');
		tmp = $('#data-brick__ind-'+p.indicateurId+'__pnt-'+p.pointId+ ' .txt-date');
		tmp.html(p.dateStr);
	}

	MONITORING._indicatorsUpdate_iconSet(p);

	return p;
};
/** @private */
MONITORING._indicatorsUpdate_iconSet = function(p){
	if(!isfilled(p.icon)) {
		return;
	}
	$('#indicator-' + p.indicateurId + '__icon')
		.removeClass()
		.addClass('ind__icon')
		.addClass(p.icon);
};


/** @private */
MONITORING._indicatorsUpdate_action = function(d){
	var i, ilen, p, dataBlock, ind, unit;

	if(!exists(d.action))
		return;

	for (i = 0, ilen = d.action.length; i < ilen; i++) {
		p = d.action[i];

		unit = $('#ind__input-edit-' + p.pointId).closest('.ind-data-brick').find('.ind__input-units');
		if(isfilled(p.unit)){
			unit
				.text(p.unit)
				.show();
		}
		else{
			unit
				.text('')
				.hide();
		}
		p = MONITORING._indicatorsUpdate_sharedActions(p);
		var value = (exists(p.raw_value)) ? p.raw_value : p.value;
		if(p.mode != 'select'){
			var value = p.value;
		}
		MONITORING.indicatorsUpdateValue_action(p.indicateurId, p.pointId, value, p);
	}
};

MONITORING.indicatorsUpdateValue_action = function(indId, pointId, val, p){
	if(MONITORING.VERBOSE)
		console.log('[MONITORING.indicatorsUpdateValue_action]', {indId: indId, pointId: pointId, val: val });

	var inp = $('#ind__input-edit-' + pointId);
	if(p.mode == 'select'){
		inp = $('#ind__select-edit-' + pointId);
		inp
			.attr('data-init-value', val)
			.val(val);
	} else {
		if(inp.is('[type="checkbox"]')){
			inp
				.attr('data-init-value', val ? 'istrue' : 'isfalse')
				.prop('checked', val);
		}
		else{
			inp
				.attr('data-init-value', val)
				.val(val);
		}
	}
	inp.trigger('change');
};

MONITORING.actionChange = function(e){
	var inp = $(e.target),
		val,
		isChanged,
		ind = inp.closest('.indicator');

	if(inp.is('[type="checkbox"]')){
		val = inp.is(':checked');
		ind.find('.ind__value-map').each(function(index, el){
			el = $(el);
			el.toggleClass('hidden', val !== el.is('[data-value-map="istrue"]'))
		});
		isChanged = inp.is(':checked') !== (inp.attr('data-init-value') === 'istrue');
	}
	else{
		val = inp.val();
		isChanged = parseFloat(val) !== parseFloat(inp.attr('data-init-value'));
	}

	ind.toggleClass('indicator--edited', isChanged);

	inp.closest('.ind-data-brick').toggleClass('ind-data-brick--edited', isChanged);

	if(ind.is('.indicator-type--action_multi')){
		ind.find('.ind-data-brick').each(function(index, el){
			el = $(el);
			el.toggleClass('ind-data-brick--disabled', isChanged && !el.is('.ind-data-brick--edited'));
		});
	}
}
MONITORING.actionInputRestore = function(s){
	MONITORING.actionInputUpdate(s, MONITORING.getActionContext(s).inpStoredVal);
};
MONITORING.actionInputUpdate = function(s, value){
	var actionSettings = MONITORING.getActionContext(s);

	if(isbool(value) !== actionSettings.inpIsToggler){
		console.warn('[MONITORING.actionInputUpdate] Invalid configuration, value can not fit in input',
			'\n\t - value:', value,
			'\n\t - inpIsToggler:', actionSettings.inpIsToggler,
			'\n\t - actionSettings:', actionSettings
		);
		return;
	}

	if(MONITORING.VERBOSE)
		console.log('[MONITORING.actionInputUpdate]',
			'\n\t - value:', value,
			'\n\t - actionSettings:', actionSettings
		);

	if(actionSettings.inpIsToggler){
		actionSettings.inp
			.attr('data-init-value', value ? 'istrue' : 'isfalse')
			.prop('checked', value)
			.trigger('change')
		;
	}
	else{
		actionSettings.inp
			.attr('data-init-value', value)
			.val(value)
			.trigger('change')
		;
	}

	if(MONITORING.VERBOSE)
		console.log(actionSettings.settings.pointUID, actionSettings.inp.attr('data-init-value'))
};

/** @private */
MONITORING._indicatorsUpdate_co2 = function(d){
	var i, ilen, j, p, dataBlock, ind, str;

	if(!exists(d.co2))
		return;

	for (i = 0, ilen = d.co2.length; i < ilen; i++) {
		p = d.co2[i];

		p = MONITORING._indicatorsUpdate_sharedActions(p);

		if(!p.detail)
			p.detail = "no-data";
		if(!p.secondaryValue)
			p.secondaryValue = null;

		dataBlock = $('#data-brick__ind-' + p.indicateurId + '__ref-value');
		dataBlock
			.find('.txt-value')
			.html(p.value);
		dataBlock
			.find('.txt-label')
			.html(p.value_text)
			.toggle(true)
		;

		ind = $('#indicator-' + p.indicateurId);

		ind
			.find('.ind__detail-inner .ind__detail-toggler')
			.addClass('uicomp--' + p.statusColor)
		;

		str = '';
		if(p.comment !== null)
			str += '<h6 class="mod--status-text">Détails</h6>';
		for(j = 0; j < p.comment.length; j++){
			str += '<p>'+p.comment[j].label+': '+p.comment[j].indice+'</p>';
		}

		ind
			.find('.ind__detail-inner .ind__content-wrapper')
			.html(str);
		ind
			.find('.ind__detail .ind__detail-toggler span')
			.html(p.mainValue);

		if(typeof(p.month) != 'undefined' && p.month !== null){
			ind
				.find('.ind__date-ts')
				.html(p.month+' '+p.year);	
		} else if(typeof(p.year) != 'undefined' && p.year !== null){
			ind
				.find('.ind__date-ts')
				.html(p.year);	
		}
	}
};

/** @private */
MONITORING._indicatorsUpdate_humidity = function(d){
	var i, ilen, j, p, dataBlock, ind, str;

	if(!exists(d.humidity))
		return;

	for (i = 0, ilen = d.humidity.length; i < ilen; i++) {
		p = d.humidity[i];

		p = MONITORING._indicatorsUpdate_sharedActions(p);

		if(!p.detail)
			p.detail = "no-data";
		if(!p.secondaryValue)
			p.secondaryValue = null;

		dataBlock = $('#data-brick__ind-' + p.indicateurId + '__ref-value');
		dataBlock
			.find('.txt-value')
			.html(p.value);
		dataBlock
			.find('.txt-label')
			.html(p.value_text)
			.toggle(true)
		;

		ind = $('#indicator-' + p.indicateurId);

		ind
			.find('.ind__detail-inner .ind__detail-toggler')
			.addClass('uicomp--' + p.statusColor)
		;

		str = '';
		if(p.comment !== null)
			str += '<h6 class="mod--status-text">Détails</h6>';
		for(j = 0; j < p.comment.length; j++){
			str += '<p>'+p.comment[j].label+': '+p.comment[j].indice+'h</p>';
		}

		ind
			.find('.ind__detail-inner .ind__content-wrapper')
			.html(str);
		ind
			.find('.ind__detail .ind__detail-toggler span')
			.html(p.mainValue);

		if(typeof(p.month) != 'undefined' && p.month !== null){
			ind
				.find('.ind__date-ts')
				.html(p.month+' '+p.year);	
		} else if(typeof(p.year) != 'undefined' && p.year !== null){
			ind
				.find('.ind__date-ts')
				.html(p.year);	
		}
	}
};

/** @private */
MONITORING._indicatorsUpdate_temperature = function(d){
	var i, ilen, j, p, dataBlock, ind, str;

	if(!exists(d.temperature))
		return;

	for (i = 0, ilen = d.temperature.length; i < ilen; i++) {
		p = d.temperature[i];

		p = MONITORING._indicatorsUpdate_sharedActions(p);

		if(!p.detail)
			p.detail = "no-data";
		if(!p.secondaryValue)
			p.secondaryValue = null;

		dataBlock = $('#data-brick__ind-' + p.indicateurId + '__ref-value');
		dataBlock
			.find('.txt-value')
			.html(p.value);
		dataBlock
			.find('.txt-label')
			.html(p.value_text)
			.toggle(true)
		;

		ind = $('#indicator-' + p.indicateurId);

		ind
			.find('.ind__detail-inner .ind__detail-toggler')
			.addClass('uicomp--' + p.statusColor)
		;

		str = '';
		if(p.comment !== null)
			str += '<h6 class="mod--status-text">Détails</h6>';
		for(j = 0; j < p.comment.length; j++){
			str += '<p>'+p.comment[j].label+': '+p.comment[j].indice+'h</p>';
		}

		ind
			.find('.ind__detail-inner .ind__content-wrapper')
			.html(str);
		ind
			.find('.ind__detail .ind__detail-toggler span')
			.html(p.mainValue);

		if(typeof(p.month) != 'undefined' && p.month !== null){
			ind
				.find('.ind__date-ts')
				.html(p.month+' '+p.year);	
		} else if(typeof(p.year) != 'undefined' && p.year !== null){
			ind
				.find('.ind__date-ts')
				.html(p.year);	
		}
	}
};

/** @private */
MONITORING._indicatorsUpdate_piechart = function(d){
	var i, ilen, p, ind, pie, dataBlock;

	if(!exists(d.piechart))
		return;

	for (i = 0, ilen = d.piechart.length; i < ilen; i++) {

		p = MONITORING._indicatorsUpdate_sharedActions(d.piechart[i]);

		ind = $('#indicator-' + p.indicateurId);
		pie = $('#indicator-piechart-' + p.indicateurId)
		if(MONITORING.VERBOSE)
			console.log('------------------------ piechart #' + p.indicateurId, p);


		HCH.chartReset(pie);

		HCH.chartContext(pie, {
			siteId: 0
		}, true);

		HCH.init(
			pie,
			Highcharts.merge(HCH.ConfigPieChartCore, {
				chart: {
					plotBackgroundColor: null,
					plotBorderWidth: null,
					plotShadow: false,
					margin: [0, 0, 0, 0],
					height: pie.parent(".pie-chart__container__chart").height(),
					events: {
						load: function() {
							var dataBlock;
							var total = 0;
							var str_ind_content_wrapper = "";
							var str_data_block_txt_value = "";
							let indicator_is_large = false;

							if(exists(p.label)) {
								str_ind_content_wrapper += `<h6><strong>${p.label}</strong></h6>`;
							}
							str_ind_content_wrapper += "<ul>";
							for (const serieHch of this.series) {
								total += serieHch.total;
								for (const serieHchPoint of serieHch.points) {
									var cEl = document.createElement('li');
									cEl.innerHTML = '<span class="txt-label">' + serieHchPoint.name + '</span><i class="fas fa-circle" style="font-size: .8em; color:' + G.clr.GV_ARR[serieHchPoint.colorIndex] + ';"></i>'
										+ '<span class="txt-value">' + Highcharts.numberFormat(serieHchPoint.percentage, 1) + '</span><span>%</span>';
									str_ind_content_wrapper += cEl.outerHTML;
								}
							}
							str_ind_content_wrapper += "</ul>";

							if(p.dimensions === "full_width") {
								indicator_is_large = true;
							}
							else {
								const [indicatorWidth, indicatorHeight] = (p?.dimensions ?? "1:1").split(":").map(Number);
								indicator_is_large = indicatorWidth > 1 && indicatorHeight > 1;
							}

							const display_btn_ind_detail_toggler = !indicator_is_large;
							const suffix_class_captions = indicator_is_large ? "large" : "detail";

							ind
								.find('.pie-chart__container__action .ind__detail-toggler')
								.toggle(display_btn_ind_detail_toggler);
							ind
								.find(`.ind__detail-inner .ind__content-wrapper.pie-chart__captions`)
								.empty();
							ind
								.find(`.ind__content-wrapper.pie-chart__captions.pie-chart__captions--${suffix_class_captions}`)
								.html(str_ind_content_wrapper);

							str_data_block_txt_value = total;
							if(p.unit) str_data_block_txt_value += `<small>${p.unit}</small>`;

							dataBlock = $('#data-brick__ind-' + p.indicateurId + '__ref-value');
							dataBlock
								.find('.txt-value')
								.html(str_data_block_txt_value);
							dataBlock
								.find('.txt-label')
								.html(G.config.LOCALE_RETRIEVE('indicator.total'))
								.toggle(true)
							;
						}
					}
				},
				plotOptions: {
					series: {
						dataLabels: {
							enabled: false
						},
						animation: {
							duration: 500
						}
					}
				},
				tooltip: {
					valueSuffix: p.unit,
					outside: true,
					useHTML: true
				},
				navigation: {
					buttonOptions: {
						enabled: false
					}
				},
				legend: {
					enabled: false,
				},
				series: [{
					data: p.value.map(function(v) {
						return {
							name: v.label,
							y: v.value,
							colorIndex: v.color
						}
					})
				}]
			}),
			false,
			false,
			false,
			G.config.LOCALE_RETRIEVE('highchart'),
			false
		);

		// HCH.init() termine toujours en état "nodata" : on le corrige selon les données réelles
		const chart = HCH._getChart(pie);
		const hasData = chart.series.some(s => s.points.some(pt => pt.y > 0));
		HCH._chartState(pie, hasData ? HCH._statesMap.data : HCH._statesMap.nodata);
		pie.find('.hch-nodata-message').remove();
		if(!hasData)
			pie.append('<div class="hch-nodata-message">' + G.config.LOCALE_RETRIEVE('highchart.noData') + '</div>');

		if(typeof(p.month) != 'undefined' && p.month !== null){
			ind
				.find('.ind__date-ts')
				.html(p.month+' '+p.year);	
		}
	}
}
/** @private */
MONITORING._indicatorsUpdate_slider = function(d){
	var i, ilen, p, sliderContainer, ind, indParams, container, selector, valueEl;

	if(!exists(d.slider))
		return;

	for (i = 0, ilen = d.slider.length; i < ilen; i++) {

		p = MONITORING._indicatorsUpdate_sharedActions(d.slider[i]);
		ind = $('.indicator[data-indicateur-id="' + p.indicateurId + '"]');

		indParams = JSON.parse(ind.attr('data-indicator-params'));
		sliderContainer = $('#indicator-' + p.indicateurId + '__slider');

		// ---   gauge
		if(exists(indParams) && indParams.mode === 'gauge') {
			$.data(sliderContainer[0], 'GVGauge').setValue(p.value);
		}
		// ---   slider
		else {
			valueEl = sliderContainer.find('.isb__value');
			if(exists(p.warning)){
				valueEl.html('<div style="font-size: 1.2rem;line-height: 1em;">' + p.warning + '</div>');
				continue;
			} 
			if(!exists(p.value) || p.value === null) {
				valueEl.html('<div style="font-size: 1.2rem;line-height: 1em;">' + G.config.LOCALE_RETRIEVE('indicator.aucunesDonneesDisponibles') + '</div>');
			}
			else {
				valueEl.html(G.i18n.printVal(p.value, null, p.unit));

				sliderContainer
					.find('.isb__pointer')
					.addClass(p.type)
					.css({
						display: 'block',
						left: (MONITORING._indicatorsInitGetRelSlider(p.indicateurId, p.value, {
							maxRounded: sliderContainer.attr('data-max-rounded'),
							minRounded: sliderContainer.attr('data-min-rounded')
						}) * 100) + '%'
					});

				sliderContainer
					.find('.isb__line')
					.removeClass('.isb-line--active')
					.filter(function () {
						var
							v = parseFloat(p.value),
							mini = parseFloat($(this).attr('data-tick-from')),
							maxi = parseFloat($(this).attr('data-tick-to'))
						;
						return v > mini && v <= maxi;
					})
					.addClass('isb-line--active');
			}
		}
	}
};
/** @private */
MONITORING._indicatorsUpdate_conso = function(d){
	var i, ilen, p;

	if(!exists(d.conso))
		return;

	for(i = 0, ilen = d.conso.length; i < ilen; ++i){
		p = MONITORING._indicatorsUpdate_sharedActions(d.conso[i]);

		// ---   value
		brickEl = $('#data-brick__ind-' + p.indicateurId  + '__ref-value')
			.attr('title', p.dateStr)
		;

		var status = p.status;
		if(exists(p.warning)){
			brickEl
				.find('.txt-label')
				.addClass('text-'+status.replace('status-', ''))
				.html(p.warning);
			continue;
		} 
		// var comment = ((exists(p.ratio_calc)) && p.ratio_calc !== null) ? '<br/>'+p.ratio_calc+'<small>'+p.ratio_calc_unite+'/m<sup>2</sup></small>' : null;	
		brickEl
		.find('.txt-value')
		.html(G.i18n.printVal(p.value, null, p.unit))
		.toggle(true)
		;
		
		if(exists(p.ratio_calc) && p.ratio_calc !== null){
			brickElRatio = $('#data-brick__ind-' + p.indicateurId  + '__ref-ratio').show();
			var comment = ((exists(p.ratio_calc_dju)) && p.ratio_calc_dju !== null) ? '<br/>'+p.ratio_calc_dju+'<small>kWh/DJU</small>' : null;	
			brickElRatio = $('#data-brick__ind-' + p.indicateurId  + '__ref-ratio')
				.attr('title', p.dateStr)
			;
			brickElRatio
				.find('.txt-value')
				.html(G.i18n.printVal(p.ratio_calc, null, p.ratio_calc_unite, comment))
				.toggle(true)
			;
		} else {
			brickElRatio = $('#data-brick__ind-' + p.indicateurId  + '__ref-ratio').hide();
		}

		if(exists(p.second_value) && p.second_value !== null){
			brickElSecond = $('#data-brick__ind-' + p.indicateurId  + '__ref-second').show();
			brickElSecond
				.find('.txt-value')
				.html(G.i18n.printVal(p.second_value, null, p.second_unit))
				.toggle(true)
			;
		} else {
			brickElSecond = $('#data-brick__ind-' + p.indicateurId  + '__ref-second').hide();
		}

		// ---   ratio
		brickEl = $('#data-brick__ind-' + p.indicateurId + '__ref-trend');
		if(brickEl.exists() && exists(p.ratio) && p.ratio !== null){
			brickEl
				.find('.txt-value')
				.html(G.i18n.printNum(p.ratio) + '%');
		}

		if(exists(p.qpointmax)){
			$('#data-brick__ind-' + p.indicateurId  + '__ref-qpointmax').show();
			var qpointmaxunit = ' m<sup>3</sup>/h';
			if(exists(p.qpointmax_unit)){
				qpointmaxunit = ' '+p.qpointmax_unit;

			}
			brickEl = $('#data-brick__ind-' + p.indicateurId  + '__ref-qpointmax')
				.find('.txt-value')
				.html(G.i18n.printNum(p.qpointmax) + qpointmaxunit);
		} else {
			$('#data-brick__ind-' + p.indicateurId  + '__ref-qpointmax').hide();
		}

		if(exists(p.dju_real)){
			$('#ind-'+p.indicateurId+'-dju_real_p').val(p.dju_real);
			$('#ind-'+p.indicateurId+'-conso_p').val(p.value);
			if(p.month !== null){
				$('#ind-'+p.indicateurId+'-period').val(p.month+'_'+p.year);
			} else {
				$('#ind-'+p.indicateurId+'-period').val(p.year);
			}
		}
		if(exists(p.dju_real_p_1)){
			$('#ind-'+p.indicateurId+'-dju_real_p_1').val(p.dju_real_p_1);
		}
		if(exists(p.unit)){
			$('#ind-'+p.indicateurId+'-unit').val(p.unit);
		}
		if(exists(p.previousValue) && p.previousValue !== null){
			$('#ind-'+p.indicateurId+'-conso_p_1').val(p.previousValue);
		} else {
			$('#ind-'+p.indicateurId+'-conso_p_1').val('-');
		}

		ind = $('#indicator-' + p.indicateurId);
		if(typeof(p.month) != 'undefined' && p.month !== null){
			ind
				.find('.ind__date-ts')
				.html(p.month+' '+p.year);	
		} else if(typeof(p.year) != 'undefined' && p.year !== null){
			ind
				.find('.ind__date-ts')
				.html(p.year);	
		}
	}
};
/** @private */
MONITORING._indicatorsUpdate_trio = function(d){
	var i, ilen, p;

	if(!exists(d.trio))
		return;

	for(i = 0, ilen = d.trio.length; i < ilen; ++i){
		p = MONITORING._indicatorsUpdate_sharedActions(d.trio[i]);

		ind = $('#indicator-' + p.indicateurId);
		var status = p.status;
		if(exists(p.pointStatus) && p.pointStatus !== null){
			status = p.pointStatus;
		}
		if(exists(p.secondStatus) && p.secondStatus !== null){
			status = p.secondStatus;
		}
		if(exists(p.thirdStatus) && p.thirdStatus !== null){
			status = p.thirdStatus;
		}
		p.status = isdefined(status) ? status : 'status-default';
		if(p.status.indexOf('status-') !== 0)
			p.status = 'status-' + p.status;
		switch(p.status){
			case 'status-ok':
			case 'status-success':
				p.statusColor = 'green';
				break;
			case 'status-warning':
				p.statusColor = 'orange';
				break;
			case 'status-alert':
				p.statusColor = 'red';
				break;
			case 'status-default':
				p.statusColor = null;
				break;
			default:
				p.statusColor = null;
				console.warn('[MONITORING._indicatorsUpdate_sharedActions] Unhandled status:' + p.status, p);
				break;
		}
		ind
			.find('.ind__detail-inner .ind__detail-toggler')
			.addClass('uicomp--' + p.statusColor)
		;

		if(!ind.is('.indicator--odysecure')){
			ind.attr('data-status', p.status);
		}
		
		if(exists(p.pointValue) && p.pointValue !== null){
			brickEl = $('#data-brick__ind-' + p.indicateurId  + '__pnt-' + p.pointId + '__ref-point')
			brickEl
				.find('.txt-value')
				.html(G.i18n.printVal(p.pointValue, null, p.pointUnit, null))
				.toggle(true)
			;
		}
		
		if(exists(p.secondValue) && p.secondValue !== null){
			brickElSecond = $('#data-brick__ind-' + p.indicateurId  + '__pnt-' + p.secondId + '__ref-second')
			brickElSecond
				.find('.txt-value')
				.html(G.i18n.printVal(p.secondValue, null, p.secondUnit, null))
				.toggle(true)
			;
		}
		
		if(exists(p.thirdValue) && p.thirdValue !== null){
			brickElThird = $('#data-brick__ind-' + p.indicateurId  + '__pnt-' + p.thirdId + '__ref-third')
			brickElThird
				.find('.txt-value')
				.html(G.i18n.printVal(p.thirdValue, null, p.thirdUnit, null))
				.toggle(true)
			;
		}

		ind = $('#indicator-' + p.indicateurId);
		if(typeof(p.month) != 'undefined' && p.month !== null){
			ind
				.find('.ind__date-ts')
				.html(p.month+' '+p.year);	
		} else if(typeof(p.year) != 'undefined' && p.year !== null){
			ind
				.find('.ind__date-ts')
				.html(p.year);	
		}
	}
};

/** @private */
MONITORING._indicatorsUpdate_array = function(d){
	var i, ilen, p;

	if(!exists(d.array))
		return;

	for(i = 0, ilen = d.array.length; i < ilen; ++i) {
		p = MONITORING._indicatorsUpdate_sharedActions(d.array[i]);
		var value = (p.value === null) ? "-" : p.value;
		if(exists(p.valueHuman) && p.valueHuman !== null && p.valueHuman != ""){
			var value = p.valueHuman;
		}
		
		if(exists(p.mode) && p.mode == "default"){
			brickEl = $('#indicator-' + p.indicateurId  + ' table tr[data-pointid=' + p.pointId + '] td:nth-child(2) span')
				.html(value + ' ' + p.unit);
			if(exists(p.type) && p.type != ""){
				switch(p.type){
					case 'success':
						var tmpType = "ok";
						break;
					case 'alert':
						var tmpType = "defaut";
						break;
					case 'waring':
						var tmpType = "avert";
						break;
				}
				brickEl = $('#indicator-' + p.indicateurId  + ' table tr[data-pointid=' + p.pointId + '] td:nth-child(2)')
					.removeClass("ok defaut avert").addClass("etat "+tmpType);
			}

		} else {
			if(value != '-')
				brickEl = $('#indicator-' + p.indicateurId  + ' table tr[data-pointid=' + p.pointId + '] td:nth-child(2)').html(value + ' ' + p.unit);
			else 
				brickEl = $('#indicator-' + p.indicateurId  + ' table tr[data-pointid=' + p.pointId + '] td:nth-child(2)').html(value);
		}

		if(value != '-'){
			brickEl = $('#indicator-' + p.indicateurId  + ' table tr[data-pointid=' + p.pointId + '] td:nth-child(3)')
				.html(p.date);
		}
	}
};

/** @private */
MONITORING._indicatorsUpdate_calcul = function(d){
	var i, ilen, p;

	if(!exists(d.calcul))
		return;

	for(i = 0, ilen = d.calcul.length; i < ilen; ++i) {
		p = MONITORING._indicatorsUpdate_sharedActions(d.calcul[i]);

		brickEl = $('#data-brick__ind-' + p.indicateurId  + '__ref-value')
			.find('.txt-value')
			.toggleClass('mod--status-text', !exists(p.trend))
			.html(p.value + ' ' + p.unit);

		brickEl = $('#data-brick__ind-' + p.indicateurId  + '__ref-trend')
			.find('.txt-value')
			.addClass('mod--status-text')
			.html(G.i18n.printNum(p.trend) + '%');
	}
};
/** @private */
MONITORING._indicatorsUpdate_agrege = function(d){
	var i, ilen, p;

	if(!exists(d.agrege))
		return;

	for(i = 0, ilen = d.agrege.length; i < ilen; ++i){
		p = d.agrege[i];
		if(exists(p.icon))
			p.icon = 'gv-iicon-' + p.icon;
		p = MONITORING._indicatorsUpdate_sharedActions(p);

		brickEl = $('#data-brick__ind-' + p.indicateurId );
		brickEl
			.addClass('gv-tip')
			.attr('title', (p.obsolete ? G.config.LOCALE_RETRIEVE('indicator.obsoleteTooltip') + ': ' : '') + p.dateStr);

		brickEl
			.find('.txt-value')
			.toggleClass('mod--status-text', p.type == 'agrege')
			.html(G.i18n.printVal(p.value, null, p.unit))
			.toggle(p.displayValue)
		;
		if(!p.displayValue){
			brickEl
				.find('.txt-label')
				.addClass('txt-value')
			;
		}
	}
};
/** @private */
MONITORING._indicatorsUpdate_ecart = function(d){
	var i, ilen, p;

	if(!exists(d.ecart))
		return;

	for(i = 0, ilen = d.ecart.length; i < ilen; ++i){
		p = d.ecart[i];
		if(exists(p.icon))
			p.icon = 'gv-iicon-' + p.icon;
		p = MONITORING._indicatorsUpdate_sharedActions(p);

		brickEl = $('#data-brick__ind-' + p.indicateurId );
		brickEl
			.addClass('gv-tip')
			.attr('title', (p.obsolete ? G.config.LOCALE_RETRIEVE('indicator.obsoleteTooltip') + ': ' : '') + p.dateStr);

		brickEl
			.find('.txt-value')
			.toggleClass('mod--status-text', p.type == 'ecart')
			.html(G.i18n.printVal(p.value, null, p.unit))
			.toggle(p.displayValue)
		;
		if(!p.displayValue){
			brickEl
				.find('.txt-label')
				.addClass('txt-value')
			;
		}
	}
};
/** @private */
MONITORING._indicatorsUpdate_event = function(d){
	var i, ilen, p;

	if(!exists(d.event))
		return;

	for(i = 0, ilen = d.event.length; i < ilen; ++i){
		p = d.event[i];
		p = MONITORING._indicatorsUpdate_sharedActions(p);
		
		//update nb event per point per day
		$('#event-'+p.pointId).html(p.value);
	}
};
/** @private */
MONITORING._indicatorsUpdate_html = function(d){
	var i, ilen, p;

	if(!exists(d.html))
		return;

	var zoneIds = [];
	for(i = 0, ilen = d.html.length; i < ilen; ++i){
		p = d.html[i];
		p = MONITORING._indicatorsUpdate_sharedActions(p); 

		brickEl = $('#data-brick__ind-' + p.indicateurId  + '__pnt-' + p.pointId);
		brickEl.html(p.value);
		brickElPeriode = $('#date-brick__ind-' + p.indicateurId).html(p.date);
		if(zoneIds.indexOf(p.zoneId) === -1){
			zoneIds.push(p.zoneId);
		}
	}
	console.log(zoneIds);
	for(i = 0, ilen = zoneIds.length; i < ilen; ++i){
		var zoneId = zoneIds[i];
		var consoRoom = parseInt($('#zone-conso_'+zoneId+' td:nth-child(2)').text());
		var consoPrise = parseInt($('#zone-conso_'+zoneId+' td:nth-child(3)').text());
		var consoLight = parseInt($('#zone-conso_'+zoneId+' td:nth-child(4)').text());
		var consoCuisine = parseInt($('#zone-conso_'+zoneId+' td:nth-child(5)').text());
		var consoFinal = consoRoom - (consoPrise + consoLight + consoCuisine);
		$('#data-brick__zone-'+zoneId+'__-conso_room').html(consoFinal);
	}
};
/** @private */
MONITORING._indicatorsUpdate_valeur = function(d){
	var i, ilen, p;

	if(!exists(d.valeur))
		return;

	for(i = 0, ilen = d.valeur.length; i < ilen; ++i){
		p = d.valeur[i];
		if(exists(p.icon))
			p.icon = 'gv-iicon-' + p.icon;
		p = MONITORING._indicatorsUpdate_sharedActions(p); 

		ind = $('#indicator-' + p.indicateurId);
		if(exists(p.pointId) && p.pointId !== null){
			brickEl = $('#data-brick__ind-' + p.indicateurId  + '__pnt-' + p.pointId);
			brickEl
				.addClass('gv-tip')
				.attr('title', (p.obsolete ? G.config.LOCALE_RETRIEVE('indicator.obsoleteTooltip') + ': ' : '') + p.dateStr);

		} else {
			brickEl = $('#data-brick__ind-' + p.indicateurId);
		}

		var status = p.status;
		if(exists(p.warning)){
			brickEl
				.find('.txt-label')
				.addClass('text-'+status.replace('status-', ''))
				.html(p.warning);
			continue;
		}

		if(p.type === 'multi' && p.obsolete){
			brickEl
				.find('.txt-label')
				.addClass('mod--obsolete')
				.attr('data-tippedpos', 'left');
			G.ui.tippedInit(brickEl);
		}
		var isJson= false;
		let jsonP = {};
		try {
			jsonP = JSON.parse(p.value);
			if(typeof(jsonP) == 'object' && jsonP != null){
				isJson = true;
			}
			
		} catch(e){

		}

		if(isJson){
			var strValue='';
			if(typeof(jsonP['min_value']) != 'undefined'){
				strValue += '<div class="txt-label">Minimum</div>';
				strValue += '<div class="txt-value">'+jsonP['min_value']+'<small>'+p.unit+'</small></div>';
				strValue += '<div class="txt-date">'+jsonP['min_value_date']+'</div>';
				if(typeof(jsonP['max_value']) != 'undefined'){
					strValue += '<div class="txt-label">Maximum</div>';
					strValue += '<div class="txt-value">'+jsonP['max_value']+'<small>'+p.unit+'</small></div>';
					strValue += '<div class="txt-date">'+jsonP['max_value_date']+'</div>';
				}
				if(typeof(jsonP['avg']) != 'undefined'){
					strValue += '<div class="txt-label">Moyenne</div>';
					strValue += '<div class="txt-value">'+jsonP['avg']+'<small>'+p.unit+'</small></div>';
				}
			} else {
				for(var key in jsonP){
					strValue += '<br/>'+key+': '+jsonP[key];
				}

			}
			brickEl.removeClass('ind-data-brick--xl');
			brickEl
				.find('.txt-value')
				.toggleClass('mod--status-text', p.type == 'valeur')
				.empty()
				.html(G.i18n.printVal(strValue, null))
				// .html(p.value)
				.toggle(p.displayValue)
			;
		} else {
			brickEl
				.find('.txt-value')
				.toggleClass('mod--status-text', p.type == 'valeur')
				.html(G.i18n.printVal(p.value, null, p.unit))
				// .html(p.value)
				.toggle(p.displayValue)
			;
		}
		if(!p.displayValue){
			brickEl
				.find('.txt-label')
				.addClass('txt-value')
			;
		}

		if(exists(p.min) && p.min != '-'){
			$('#data-brick__ind-' + p.indicateurId  + '__pnt-0__ref-min').show();
			brickElMin = $('#data-brick__ind-' + p.indicateurId  + '__pnt-0__ref-min');
			brickElMin
				.find('.txt-value')
				.html(G.i18n.printVal(p.min, null, p.unit))
				.toggle(true)
			;
		} else {
			$('#data-brick__ind-' + p.indicateurId  + '__pnt-0__ref-min').hide();
		}

		if(exists(p.max) && p.max != '-'){
			$('#data-brick__ind-' + p.indicateurId  + '__pnt-0__ref-max').show();
			brickElMax = $('#data-brick__ind-' + p.indicateurId  + '__pnt-0__ref-max');
			brickElMax
				.find('.txt-value')
				.html(G.i18n.printVal(p.max, null, p.unit))
				.toggle(true)
			;
		} else {
			$('#data-brick__ind-' + p.indicateurId  + '__pnt-0__ref-max').hide();
		}

		if(typeof(p.month) != 'undefined' && p.month !== null){
			ind
				.find('.ind__date-ts')
				.html(p.month+' '+p.year);	
		} else if(typeof(p.year) != 'undefined' && p.year !== null){
			ind
				.find('.ind__date-ts')
				.html(p.year);	
		}
	}
};
/** @private */
MONITORING._indicatorsUpdate_alarme = function(d){
	var i, ilen, p;

	if(!exists(d.alarme))
		return;

	for(i = 0, ilen = d.alarme.length; i < ilen; ++i) {
		p = MONITORING._indicatorsUpdate_sharedActions(d.alarme[i]);

		if(p.displayValue){
			$('#data-brick__ind-' + p.indicateurId + '__ref-label')
				.find('.txt-value')
				.html(p.value);
		}

		p.icon = 'gv-iicon-check';
		if(p.value === "off" || p.value === false){
			p.icon = 'gv-iicon-alert-sign-red';
		}
		MONITORING._indicatorsUpdate_iconSet(p);
	}
};
/** @private */
MONITORING._indicatorsUpdate_planning = function(d){
	var i, ilen, p;

	if(!exists(d.planning))
		return;

	for(i = 0, ilen = d.planning.length; i < ilen; ++i) {
		p = MONITORING._indicatorsUpdate_sharedActions(d.planning[i]);

		if(p.draft == 1){
			$('#state-planning-' + p.planningId).show();
		} else {
			$('#state-planning-' + p.planningId).hide();
		}
		if(p.lastSync != '' || p.lastWrite != ''){
			$('#indicator-' + p.indicateurId).addClass('has-comment');
			var txtSync = 'Dernière synchronisation: '+p.lastSync;
			if(p.lastWrite != '' && p.lastWrite != null){
				txtSync += '<br/>Dernière écriture: ' + p.lastWrite;
			}
			$('#indicator-' + p.indicateurId)
				.find('.ind__description-inner')
				.html(txtSync);
		}
		
		MONITORING._indicatorsUpdate_iconSet(p);
	}
};
/** @private */
MONITORING._indicatorsUpdate_odyradar = function(d){
	var i, ilen, p;

	if(!exists(d.odyradar))
		return;

	for(i = 0, ilen = d.odyradar.length; i < ilen; ++i) {
		p = d.odyradar[i];
		p = MONITORING._indicatorsUpdate_sharedActions(p);

		var status = p.status;
		brickEl=$("#data-brick__ind-"+p.indicateurId)
					.addClass("gv-tip")
					.attr("title",(p.obsolete?G.config.LOCALE_RETRIEVE("indicator.obsoleteTooltip")+": ":"")+p.dateStr);
		if(exists(p.warning)){
			brickEl= $("#data-brick__ind-"+p.indicateurId+"__ref-level")
				.find('.txt-label')
				.addClass('text-'+status.replace('status-', ''))
				.html(p.warning);
		} else {
			brickEl= $("#data-brick__ind-"+p.indicateurId+"__ref-level")
					.find(".txt-value")
					.html(G.i18n.printVal(p.value,null,p.unit));
			if(exists(p.txt_value)){
				brickEl= $("#data-brick__ind-"+p.indicateurId+"__ref-level")
						.find(".txt-label")
						.html(p.txt_value);
			} else {
				brickEl= $("#data-brick__ind-"+p.indicateurId+"__ref-level")
						.find(".txt-label")
						.html('');
			}
		}
		
		if(!exists(p.nb_days)){
			$("#data-brick__ind-"+p.indicateurId+"__ref-nb_days").hide();
		} else {
			brickEl=$("#data-brick__ind-"+p.indicateurId+"__ref-nb_days")
				.find(".txt-value")
				.html(G.i18n.printVal(p.nb_days,null,""));
		}

		var strTitle = '';
		$("#tank--level-"+p.indicateurId).css("height",p.tank_level+"px");		

		var str = '';
		if(exists(p.product_left)){
			str += '<h6 class="mod--status-text">Produit restant :</h6>';
			str += '<p><b>'+G.i18n.printVal(p.product_left,null,"")+'</b>kg</p>';
		}
		if(exists(p.product_consumed)){
			str += '<h6 class="mod--status-text">Produit consommé jour :</h6>';
			str += '<p><b>'+G.i18n.printVal(p.product_consumed,null,"")+'</b>kg</p>';
		}
		if(exists(p.height_product_left)){
			str += '<h6 class="mod--status-text">Hauteur produit restant :</h6>';
			str += '<p><b>'+G.i18n.printVal(p.height_product_left,null,"")+'</b>cm</p>';
			strTitle += (strTitle == "") ? "" : "<br/>";
			strTitle += 'Hauteur produit restant: '+p.height_product_left+'cm';
		}
		if(exists(p.tank_height)){
			strTitle += (strTitle == "") ? "" : "<br/>";
			strTitle +='Hauteur de la cuve: '+p.tank_height+'cm';
		}
		if(!exists(p.alarme) || p.alarme === null){
			$("#tank--alarm-"+p.indicateurId).hide();
		} else {
			$("#tank--alarm-"+p.indicateurId).show();
			$("#tank--alarm-"+p.indicateurId).css("bottom", p.alarme+"px");
			strTitle += (strTitle == "") ? "" : "<br/>";
			strTitle += 'Alarme seuil bas: '+p.rawAlarme+'cm';
		}
		if(!exists(p.reappro) || p.reappro === null){
			$("#tank--reappro-"+p.indicateurId).hide();
		} else {
			strTitle += (strTitle == "") ? "" : "<br/>";
			strTitle += 'Alarme seuil commande: '+p.rawReappro+'cm';
			$("#tank--reappro-"+p.indicateurId).show();
			$("#tank--reappro-"+p.indicateurId).css("bottom", p.reappro+"px");
		}
		$("#tank-layer-"+p.indicateurId).attr('title', strTitle);
		G.ui.tippedInit($("#tank-layer-"+p.indicateurId));
		ind = $('#indicator-' + p.indicateurId);
		ind
			.find('.ind__detail-inner .ind__content-wrapper')
			.html(str);

		//update odyradar conso
		indConso = $('.indicator--type-odyradar_conso[data-objet="'+p.objetId+'"]').first();
		if(typeof(indConso) != 'undefined'){
			var indicatorConsoId = indConso.data('indicateur-id');
			indConso.attr('data-status', 'status-default');
			$("#data-brick__ind-"+indicatorConsoId+"__ref-value")
				.find(".txt-value")
				.addClass('mod--status-text')
				.html(G.i18n.printNum(p.product_consumed)+' kg');
		} else {
			indConso = $('.indicator--type-odyradar_conso[data-odysecureid="'+p.odyradarEntryId+'"]').first();
			if(typeof(indConso) != 'undefined'){
				var indicatorConsoId = indConso.data('indicateur-id');
				$("#data-brick__ind-"+indicatorConsoId+"__ref-value")
					.find(".txt-value")
					.addClass('mod--status-text')
					.html(G.i18n.printNum(p.product_consumed)+' kg');
			}
		}
	}
};
/** @private */
MONITORING._indicatorsUpdate_odysel = function(d){
	var i, ilen, p;

	if(!exists(d.odysel))
		return;

	for(i = 0, ilen = d.odysel.length; i < ilen; ++i) {
		p = d.odysel[i];
		p = MONITORING._indicatorsUpdate_sharedActions(p);
		var strTitle = '';
 
		var status = p.status;
		brickEl=$("#data-brick__ind-"+p.indicateurId)
					.addClass("gv-tip")
					.attr("title",(p.obsolete?G.config.LOCALE_RETRIEVE("indicator.obsoleteTooltip")+": ":"")+p.dateStr);

		if(exists(p.warning)){
			brickEl= $("#data-brick__ind-"+p.indicateurId+"__ref-level")
				.find('.txt-label')
				.addClass('text-'+status.replace('status-', ''))
				.html(p.warning);
		} else {
			brickEl= $("#data-brick__ind-"+p.indicateurId+"__ref-level")
					.find(".txt-value")
					.html(G.i18n.printVal(p.value,null,p.unit));
		}
		
		if(exists(p.tank_height)){
			strTitle += (strTitle == "") ? "" : "<br/>";
			strTitle +='Hauteur de la cuve: '+p.tank_height+'cm';
		}
		if(!exists(p.alarme) || p.alarme === null){
			$("#tank--alarm-"+p.indicateurId).hide();
		} else {
			$("#tank--alarm-"+p.indicateurId).show();
			$("#tank--alarm-"+p.indicateurId).css("bottom", p.alarme+"px");
			strTitle += (strTitle == "") ? "" : "<br/>";
			strTitle += 'Alarme seuil bas: '+p.rawAlarme+'cm';
		}
		if(!exists(p.reappro) || p.reappro === null){
			$("#tank--reappro-"+p.indicateurId).hide();
		} else {
			strTitle += (strTitle == "") ? "" : "<br/>";
			strTitle += 'Alarme seuil ajout de sel : '+p.rawReappro+'cm';
			$("#tank--reappro-"+p.indicateurId).show();
			$("#tank--reappro-"+p.indicateurId).css("bottom", p.reappro+"px");
		}
		if(!exists(p.comment)){
			$('#data-brick__ind-'+p.indicateurId+'__ref-last_generation').hide();
		} else {
			("#data-brick__ind-"+p.indicateurId+"__ref-last_generation")
					.find(".txt-value")
					.html(p.comment);
			$('#data-brick__ind-'+p.indicateurId+'__ref-last_generation').show();
		}

		$("#tank-layer-"+p.indicateurId).attr('title', strTitle);
		G.ui.tippedInit($("#tank-layer-"+p.indicateurId));
		$("#tank--level-"+p.indicateurId).css({"bottom":"0","height":p.tank_level+"px", "background-color":"rgb(187, 187, 187)"});
		// $("#tank--odysel-"+p.indicateurId).css({"height":"15px", "background-color":"rgb(0, 158, 224)"});

	}
};
/** @private */
MONITORING._indicatorsUpdate_tank = function(d){
	var i, ilen, p;

	if(!exists(d.tank))
		return;

	for(i = 0, ilen = d.tank.length; i < ilen; ++i) {
		p = d.tank[i];
		p = MONITORING._indicatorsUpdate_sharedActions(p);

		brickEl=$("#data-brick__ind-"+p.indicateurId)
					.addClass("gv-tip")
					.attr("title",(p.obsolete?G.config.LOCALE_RETRIEVE("indicator.obsoleteTooltip")+": ":"")+p.dateStr);

		brickEl= $("#data-brick__ind-"+p.indicateurId+"__ref-level")
					.find(".txt-value")
					.html(G.i18n.printVal(p.value,null,p.unit));
		brickEl=$("#data-brick__ind-"+p.indicateurId+"__ref-percent")
					.find(".txt-value")
					.html(G.i18n.printVal(p.percent,null,"%"));
		$("#tank--level-"+p.indicateurId).css("height",160*p.percent/100+"px");
	}
};
/** @private */
MONITORING._indicatorsUpdate_perf = function(d){
	var i, ilen, p, v;

	if(!exists(d.perf))
		return;

	for(i = 0, ilen = d.perf.length; i < ilen; ++i) {
		p = d.perf[i];
		p.icon = 'gv-iicon-' + p.icon;
		switch (p.status) {
			case 'status-ok':
				p.icon +=  '-green';
				break;
			case 'status-alert':
				p.icon +=  '-red';
				break;
			case 'status-warning':
				p.icon +=  '-orange';
				break;
			default:
				p.icon += '-default';
				break;
		}
		p = MONITORING._indicatorsUpdate_sharedActions(p);

		if(p.percent === null){
			p.percent = '-';
		}

		if(p.goal === null){
			p.goal = '-';
		}

		brickEl = $('#data-brick__ind-' + p.indicateurId  + '__ref-value')
			.find('.txt-value')
			.addClass('mod--status-text')
			.html(p.percent + '%');
	

		v = G.i18n.printVal(p.value, null, p.unit);
		if(p.percent > 0)
			v = '+' + v;

		brickEl = $('#data-brick__ind-' + p.indicateurId  + '__ref-goal')
			.find('.txt-value')
			.html(G.i18n.printVal(p.goal, null, p.unit));
		brickEl = $('#data-brick__ind-' + p.indicateurId  + '__ref-conso')
			.find('.txt-value')
			.html(G.i18n.printVal(p.value, null, p.unit));

		ind = $('#indicator-' + p.indicateurId);
		var str = '';
		if(p.mode == 'chauffage' || p.mode == 'chauffage_sans_temp'){
			if(typeof(p.value_raw) != 'undefined' && typeof(p.temp_avg) != 'undefined'){
				str += '<h6 class="mod--status-text">Mesuré</h6>';
				str += '<p><b>'+p.value_raw+'</b>kWh</p>';

				if(exists(p.temp_avg) && p.temp_avg !== null){
					str += '<h6 class="mod--status-text">Paramètres d\'ajustement</h6>';
					str += '<p>';
					str += 'Tint: <b>'+p.temp_avg+'°C</b> (ref. 21°C) '; 
					str += '</p>';
				}
				
				str += '<p>';
				str += 'DJU Réel: <b>'+p.dju_reel+'</b> (ref. '+p.dju_ref+')'; 
				str += '</p>';
			}
		} else if(p.mode == 'energy_ecs'){
			if(typeof(p.cecs_energy_without_bouclage) != 'undefined'){
				str += '<h6 class="mod--status-text">Consommation Energie sans bouclage</h6>';
				str += '<p><b>'+p.cecs_energy_without_bouclage+'</b>kWh</p>';
			}
			
			if(typeof(p.cecs_energy) != 'undefined' && typeof(p.cecs_water) != 'undefined'){
				str += '<h6 class="mod--status-text">Consommation Energie</h6>';
				str += '<p><b>'+p.cecs_energy+'</b>kWh</p>';
	
				str += '<h6 class="mod--status-text">Consommation Eau</h6>';
				str += '<p><b>'+p.cecs_water+'m3</b></p>';
			}
		} else if(p.mode == 'ratio_ecs'){
			if(typeof(p.cecs_energy) != 'undefined'){
				str += '<h6 class="mod--status-text">Consommation Energie</h6>';
				str += '<p><b>'+p.cecs_energy+'</b>kWh</p>';
			}
			if(typeof(p.cecs_water) != 'undefined'){
				str += '<h6 class="mod--status-text">Consommation Eau</h6>';
				str += '<p><b>'+p.cecs_water+'</b>m3</p>';
			}
		} else if(p.mode == 'ratio_chauffage'){
			if(typeof(p.cecs_energy) != 'undefined'){
				str += '<h6 class="mod--status-text">Consommation Energie</h6>';
				str += '<p><b>'+p.cecs_energy+'</b>kWh</p>';
			}
			if(typeof(p.dju_reel) != 'undefined'){
				str += '<h6 class="mod--status-text">DJU réel</h6>';
				str += '<p><b>'+p.dju_reel+'</b></p>';
			}
		}

		if(typeof(p.month) != 'undefined' && p.month !== null){
			ind
				.find('.ind__date-ts')
				.html(p.month+' '+p.year);	
		}
			
		ind
			.find('.ind__detail-inner .ind__content-wrapper')
			.html(str);
	}
};

/** @private */
MONITORING._indicatorsUpdate_perfSolar = function(d){
	var i, ilen, p, v;

	if(!exists(d.perf_solar))
		return;

	for(i = 0, ilen = d.perf_solar.length; i < ilen; ++i) {
		p = d.perf_solar[i];
		if(MONITORING.VERBOSE){
			console.log('[MONITORING._indicatorsUpdate_perfSolar]', p);
		}
		p.icon = 'gv-iicon-' + p.icon;
		switch (p.status) {
			case 'status-ok':
				p.icon +=  '-green';
				break;
			case 'status-alert':
				p.icon +=  '-red';
				break;
			case 'status-warning':
				p.icon +=  '-orange';
				break;
			default:
				p.icon += '-default';
				break;
		}
		p = MONITORING._indicatorsUpdate_sharedActions(p);

		v = G.i18n.printVal(p.value, null, p.unit);
		if(p.percent > 0)
			v = '+' + v;
		brickEl = $('#data-brick__ind-' + p.indicateurId  + '__ref-value')
			.find('.txt-value')
			.addClass('mod--status-text')
			.html(v);

		brickEl = $('#data-brick__ind-' + p.indicateurId  + '__ref-goal')
			.find('.txt-value')
			.html(G.i18n.printVal(p.obj_apport, null, p.unit));
		brickEl = $('#data-brick__ind-' + p.indicateurId  + '__ref-percent')
			.find('.txt-value')
			.html(p.percent+'%');

		ind = $('#indicator-' + p.indicateurId);

		ind
			.find('.ind__detail-inner .ind__detail-toggler')
			.addClass('uicomp--' + p.statusColor)
		;

		var str = '';
		str += '<h6 class="mod--status-text">Apport</h6>';
		str += '<p><b>'+p.percent+'%</b> ('+p.value+' kWh / '; 
		str += ''+p.obj_apport+' kWh théorique)</p>';

		
		str += '<h6 class="mod--status-text">Volume</h6>';
		str += '<p><b>'+p.percent_volume+'%</b> ('+p.volume+' L / '; 
		str += ''+p.obj_volume+' L théorique)</p>';
			
		ind
			.find('.ind__detail-inner .ind__content-wrapper')
			.html(str);
		
	}
};

/** @private */
MONITORING._indicatorsUpdate_heatingCurve = function(d){
	if(!exists(d.heating_curves)) {
		return;
	}
};

/** @private */
MONITORING._indicatorsUpdate_lastHistoPoints = function(d){
	if(!exists(d.last_histo_points)) {
		return;
	}
};

/** @private */
MONITORING._indicatorsUpdate_inventory_equipment = function(d){
	var i, ilen, ind, chartInventoryEquipment, inventoryEquipment;
	const chartColors = [
		G.clr.GV_ENUM.ui_green,
		G.clr.GV_ENUM.ui_red,
		G.clr.GV_ENUM.ui_grey
	];

	if(!exists(d.inventory_equipments))
		return;

	for (i = 0, ilen = d.inventory_equipments.length; i < ilen; i++) {
		inventoryEquipment = d.inventory_equipments[i];
		ind = $('#indicator-' + inventoryEquipment.indicateurId);
		chartInventoryEquipment = $('#indicator-inventory_equipment-' + inventoryEquipment.indicateurId);

		if(MONITORING.VERBOSE){
			console.log('[MONITORING._indicatorsUpdate_inventory_equipment]', inventoryEquipment);
			console.log('------------------------ chartInventoryEquipment #' + inventoryEquipment.indicateurId, inventoryEquipment);
		}

		HCH.chartReset(chartInventoryEquipment);

		HCH.chartContext(chartInventoryEquipment, {
			siteId: inventoryEquipment.indicateurSiteId
		}, true);

		HCH.init(
			chartInventoryEquipment,
			Highcharts.merge(HCH.ConfigPieChartCore, {
				chart: {
					plotBackgroundColor: null,
					plotBorderWidth: null,
					plotShadow: false,
					margin: [0, 0, 0, 0],
					styledMode: false,
					className: undefined,
					colorCount: 0,
					height: chartInventoryEquipment.parent(".inventory_equipment__container__chart").height(),
					events: {
						load: function() {
							var str_ind_content_wrapper = "<ul>";
							for (const serieHch of this.series) {
								for (const serieHchPoint of serieHch.points) {
									var cEl = document.createElement('li');
									cEl.innerHTML = '<span class="txt-label">' + serieHchPoint.name + '</span><i class="fas fa-circle" style="font-size: .8em; color:' + chartColors[serieHchPoint.colorIndex] + ';"></i>'
										+ '<span class="txt-value">' + Highcharts.numberFormat(serieHchPoint.percentage, 0) + '</span><span>%</span>';
									str_ind_content_wrapper += cEl.outerHTML;
								}
							}
							str_ind_content_wrapper += "</ul>"

							ind
								.find('.inventory_equipment__captions')
								.html(str_ind_content_wrapper);
						}
					}
				},
				plotOptions: {
					series: {
						dataLabels: {
							enabled: true,
							distance: -20,
							format: '{point.y}',
							color: "#ffffff",
							style: {
								fontSize: '1.2em',
								textOutline: 'none',
								opacity: 0.8
							},
							filter: {
								operator: '>',
								property: 'y',
								value: 0
							}
						},
						animation: {
							duration: 500
						},
						colors: chartColors,
						innerSize: '40%' // vue donut
					}
				},
				tooltip: {
					outside: true,
					useHTML: true,
					formatter: function () {
						var	str = '';

						str += '<div class="tooltip-rows">';
						str += '<div class="tooltip-row" >'
							+ '<div class="tooltip-row__label"><span class="bullet" style="background-color:' + chartColors[this.point.colorIndex] + '"></span>' + this.point.name + '</div>'
							+ '<div class="tooltip-row__value">';

						str += this.point.y;
						str += '</div></div>';

						return str;
					}
				},
				navigation: {
					buttonOptions: {
						enabled: false
					}
				},
				legend: {
					enabled: false,
				},
				series: [{
					data: [
						{
							name: G.config.LOCALE_RETRIEVE('indicator.online'),
							y: inventoryEquipment?.resume[1] ?? 0,
							colorIndex: 0
						},
						{
							name: G.config.LOCALE_RETRIEVE('indicator.offline'),
							y: inventoryEquipment?.resume[2] ?? 0,
							colorIndex: 1
						},
						{
							name: G.config.LOCALE_RETRIEVE('indicator.notInstalled'),
							y: inventoryEquipment?.resume[0] ?? 0,
							colorIndex: 2
						}
					]
				}]
			}),
			false,
			false,
			false,
			G.config.LOCALE_RETRIEVE('highchart'),
			false
		);
	}
}

/** @private */
MONITORING._indicatorsUpdate_postit = function(d) {
	if(!exists(d.postit)) return;

	for(i = 0, ilen = d.postit.length; i < ilen; ++i) {
		var postit = d.postit[i];
		if (MONITORING.VERBOSE) {
			console.log('[MONITORING._indicatorsUpdate_postit]', postit);
		}
		var indicator = $('#indicator-' + postit.indicateurId);
		indicator.find(".ind__content .txt-postit").val(postit.indicateurPostit ?? "");
	}
}

/** @private */
MONITORING._indicatorsUpdate_terminalRegulation = function(d) {
	if (!exists(d.terminalRegulations)) return;

	for (let i = 0; i < d.terminalRegulations.length; i++) {
		const reg = d.terminalRegulations[i];

		if (MONITORING.VERBOSE) {
			console.log('[MONITORING._indicatorsUpdate_terminalRegulation]', reg);
		}

		const $indicator = $('#indicator-' + reg.indicatorId);

		const setText = (suffix, label, value, unit) => {
			if(typeof(label) != "undefined" && label != ""){
				$indicator.find(`#${suffix}-${reg.indicatorId}-label`).html(`${label}&nbsp;:&nbsp;`);
				$indicator.find(`#${suffix}-${reg.indicatorId}-value`).html(`${value}${unit}`);
			}
		};

		// Température ambiante
		$indicator.find(`#tr-amb-${reg.indicatorId}`).text(`${reg?.ambientTemperature?.value ?? "NaN"}${reg?.ambientTemperature?.unit ?? ""}`);

		if(exists(reg?.firstComplementaryReading)) {
			setText(
				'tr-cr1',
				reg?.firstComplementaryReading?.label ?? "",
				reg?.firstComplementaryReading?.value ?? "",
				reg?.firstComplementaryReading?.unit ?? ""
			);
		}
		if(exists(reg?.secondComplementaryReading)) {
			setText(
				'tr-cr2',
				reg?.secondComplementaryReading?.label ?? "",
				reg?.secondComplementaryReading?.value ?? "",
				reg?.secondComplementaryReading?.unit ?? ""
			);
		}

		// Points de consigne
		const updateSetPoint = (setPoint, key) => {
			$indicator.find(`#ind__input-edit-${setPoint.pointId}`)
				.val(setPoint.value)
				.attr("data-init-value", setPoint.value);

			$indicator.find(`#tr-${key}-unit-${reg.indicatorId}`).text(setPoint.unit);

			$indicator.find(`#tr-${key}-icon-${reg.indicatorId}`)
				.removeClass()
				.addClass(`${setPoint.icon} gv-iicon-28`);

			if(exists(setPoint?.iconTooltip)) {
				$indicator.find(`#tr-${key}-icon-${reg.indicatorId}`)
					.parent(".gv-iicon-wrapper-28")
					.addClass("gv-tip")
					.attr("title", setPoint?.iconTooltip);
				G.ui.tippedInit($indicator);
			}

		};

		if(exists(reg?.firstSetPoint)) updateSetPoint(reg.firstSetPoint, 'sp1');
		$indicator.find(".tr-sp2-container").toggle(!(["temp", "temp_heat", "temp_cold"].includes(reg.type)));
		if( !(["temp", "temp_heat", "temp_cold"].includes(reg.type)) ) {
			if(exists(reg?.secondSetPoint)) updateSetPoint(reg.secondSetPoint, 'sp2');
		}
	}
}

/** @private */
MONITORING._indicatorsUpdate_heatmapchart = function(d){
	if(!exists(d.heatmapchart))
		return;

	for (let i = 0, ilen = d.heatmapchart.length; i < ilen; i++) {
		let p, ind, heatmap;

		p = MONITORING._indicatorsUpdate_sharedActions(d.heatmapchart[i]);

		ind = $('#indicator-' + p.indicatorId);
		heatmap = $('#indicator-heatmap-' + p.indicatorId);
		let indContainerChart = ind.find(".heatmap__container__chart");

		if(MONITORING.VERBOSE)
			console.log('------------------------ heatmap #' + p.indicatorId, p);

		const weekDaysLocalized = G.config.LOCALE_RETRIEVE('date.days'); // Jours localisés (ordre : Lundi → Dimanche)
		const fromDayIndex = moment(p.from, "DD/MM/YYYY").isoWeekday() - 1;   // Lundi = 1 → index 0
		const weekDaysOrderedByFrom = [
			...weekDaysLocalized.slice(fromDayIndex),
			...weekDaysLocalized.slice(0, fromDayIndex)
		];

		const hourlyAggregates = new Map();
		(p?.value ?? []).forEach(({ x, y }) => {
			const date = moment(x);
			const dayIndex = weekDaysOrderedByFrom.indexOf(
				weekDaysLocalized[date.isoWeekday() - 1]
			);
			const hourIndex = date.hour();
			const key = `${dayIndex}_${hourIndex}`;

			if (!hourlyAggregates.has(key)) {
				hourlyAggregates.set(key, { sum: 0, count: 0 });
			}

			const entry = hourlyAggregates.get(key);
			entry.sum += y;
			entry.count++;
		});
		const aggregatedData = Array.from(hourlyAggregates.entries()).map(([key, { sum, count }]) => {
			const [day, hour] = key.split('_').map(Number);
			const avg = Math.round(sum / count);
			return [hour, day, avg];
		});

		HCH.chartReset(heatmap);

		HCH.chartContext(heatmap, {
			siteId: 0
		}, true);

		const indHeatmapMode = G.clr.HEATMAP_MODES[p.colorPalette] || G.clr.HEATMAP_MODES.neutral;
		const indHeatmapColorAxis = {};
		indHeatmapColorAxis["min"] = exists(p.min) ? p.min : undefined;
		indHeatmapColorAxis["max"] = exists(p.max) ? p.max : undefined;
		indHeatmapColorAxis["minColor"] = indHeatmapMode.minColor;
		indHeatmapColorAxis["maxColor"] = indHeatmapMode.maxColor;
		indHeatmapColorAxis["stops"] = indHeatmapMode.colors.map((color, i, arr) => [i / (arr.length - 1), color]);
		indHeatmapColorAxis["labels"] = {
			format: `{value} ${p?.unit ?? ""}`
		}

		HCH.init(
			heatmap,
			Highcharts.merge(
				HCH.ConfigHeatMapChartCore,
				{
					chart: {
						height: ind.find(".ind__content").height()
					},
					xAxis: {
						categories: [...Array(24).keys()].map(h => h.toString().padStart(2, '0') + ':00'),
							tickInterval: 3
					},
					yAxis: {
						categories: weekDaysOrderedByFrom,
							reversed: true,
							title: null
					},
					colorAxis: indHeatmapColorAxis,
					legend: {
						align: 'right',
							layout: 'vertical',
							margin: 0,
							verticalAlign: 'top',
							y: 50,
							symbolHeight: 300
					},
					tooltip: {
						padding: 0,
						hideDelay: 150,
						useHTML: true,
						outside: true,
						style: { zIndex: 10 },
						formatter: function () {
							const dayIndex = this.point.y; // 0..6
							const hour = this.point.x; // 0..23
							const value = this.point.value;
							const seriesName = this.series.name;
							const color = this.point.color;

							// Calcule la date réelle à partir de p.from
							const date = moment(p.from, "DD/MM/YYYY")
								.add(dayIndex, 'days')
								.hour(hour)
								.minute(0)
								.second(0);

							// Trouve le bon jour en fonction du décalage par rapport à p.from
							const fromDayIndex = moment(p.from, "DD/MM/YYYY").isoWeekday() - 1; // lundi = 0
							const localizedDayName = weekDaysLocalized[(fromDayIndex + dayIndex) % 7];

							// Formate la date et l’heure (sans dépendre de moment.locale)
							const formattedDate = date.format("DD/MM/YYYY HH:mm");

							// Structure HTML identique à ton tooltip actuel
							return `
									<div class="tooltip-title">${localizedDayName}, ${formattedDate}</div>
									<div class="tooltip-rows">
									  <div class="tooltip-row">
										<div class="tooltip-row__label"><span class="bullet" style="background-color: ${color}"></span>${seriesName}</div>
										<div class="tooltip-row__value">${value} ${p?.unit ?? ""}</div>
									  </div>
									</div>
								`;
						}
					},
					series: [{
						name: p.name,
						data: aggregatedData
					}]
				}
			),
			false,
			false,
			false,
			G.config.LOCALE_RETRIEVE('highchart'),
			false
		);
		HCH._chartState(heatmap, HCH._statesMap.data);
		HCH._chartSetTitle(heatmap, {
			name: p.indicatorName
		}, p.from, p.to);
	}
}

/** @private */
MONITORING._indicatorsUpdate_sankey = function(d){
    if(!exists(d.sankey))
        return;

    for (let i = 0, ilen = d.sankey.length; i < ilen; i++) {
        let p, ind, sankey;

        p = MONITORING._indicatorsUpdate_sharedActions(d.sankey[i]);

        ind = $('#indicator-' + p.indicatorId);
        sankey = $('#indicator-sankey-' + p.indicatorId);

        if(MONITORING.VERBOSE)
            console.log('------------------------ sankey #' + p.indicatorId, p);

        MONITORING._showLoading(sankey, false);

        HCH.chartReset(sankey);

        HCH.chartContext(sankey, {
            siteId: 0
        }, true);

        HCH.init(
            sankey,
            Highcharts.merge(
                HCH.ConfigSankeyChartCore,
                {
                    chart: {
                        height: ind.find(".ind__content").height(),
                        events: {
                            render: function () {
                                var serie = this.series && this.series[0];
                                if(!serie)
                                    return;
                                (serie.points || []).forEach(function (point) {
                                    if(point.graphic && !point.isNode && point.fromNode && point.toNode){
                                        var el = point.graphic.element;
                                        el.style.stroke = 'rgba(0,0,0,0.001)';
                                        el.style.strokeWidth = '12px';
                                        el.style.pointerEvents = 'all';
                                    }
                                });
                            }
                        }
                    },
                    tooltip: {
                        padding: 0,
                        hideDelay: 150,
                        useHTML: true,
                        outside: true,
                        style: { zIndex: 10 },
                        formatter: function () {
                            if(exists(this.point) && exists(this.point.fromNode) && exists(this.point.toNode)) {
                                return `
                                <div class="tooltip-title">${p.indicatorName}</div>
                                <div class="tooltip-rows">
                                  <div class="tooltip-row">
                                    <div class="tooltip-row__value">${this.point.fromNode.name} → ${this.point.toNode.name}: <b>${this.point.weight} ${this.point?.unit ?? ""}</b></div>
                                  </div>
                                </div>
                            `;
                            }
                            else {
                                return "";
                            }
                        }
                    },
                    series: [{
                        data: (p?.value ?? [])
                            .map(function (link) {
                                return Object.assign({}, link, { weight: Math.max(0, link.weight) });
                            })
                            .filter(function (link) {
                                return link.weight > 0;
                            })
                    }]
                }
            ),
            true,
            false,
            false,
            G.config.LOCALE_RETRIEVE('highchart'),
            false
        );

        // on met à jour le datepicker
        ind.find('input.datepicker').val(
            moment(p.to, 'DD/MM/YYYY').format('DD/MM/YYYY')
        );

        HCH._chartState(sankey, HCH._statesMap.data);
        HCH._chartSetTitle(sankey, {
            name: p.indicatorName
        }, p.from, p.to);
    }
}

// ------------ INDICATOR SPECIAL ACTIONS

MONITORING.indicatorsInit = function () {
	var
		i, ilen, p, filteredIndicators, params, settings,
		indicators = $(document).find('.indicator')
	;

	if(MONITORING.VERBOSE){
		console.log('[MONITORING.indicatorsInit] ' + indicators.length + ' indicators');
	}

	MONITORING._initMasonryViewIndicatorContainers("indicators-container", function() {
		indicators.removeClass('indicator--uninitialized');
		// TODO voir pour faire un seul init au lieu d'un deuxième
		MONITORING._initMasonryViewIndicatorContainers("indicators-container")
	});

	// ---   ODYSECURE GAUGE
	filteredIndicators = indicators.filter('.indicator--odysecure-gauge');
	filteredIndicators.each(function (index, ind) {
		ind = $(ind);
		params = JSON.parse(ind.attr('data-indicator-params'));
		selector = '#' + ind.attr('id') + ' .gauge-container';
		valueEl = $.data(
			$(selector)[0], 'GVGauge',
			new G.ui.GVGauge(selector, {
				range: {
					valueStart: 0,
					valueEnd: 2 * params.objectif,
					color: '#999999',
					marginX: 0,
					marginY: 30
				},
				tilts: {
					data: [
						{value: (params.objectif - params.delta)},
						{value: (params.objectif + params.delta)}
					]
				},
				format: {
					unit: '',
					precision: 2,
				},
				units: {
					enabled: false
				},
				ticks: {
					data: [
						{valueStart: 0, valueEnd: (params.objectif - params.delta), style: 'status-alert'},
						{
							valueStart: (params.objectif + params.delta),
							valueEnd: (2 * params.objectif),
							style: 'status-alert'
						},
						{
							valueStart: (params.objectif - params.delta),
							valueEnd: (params.objectif + params.delta),
							style: 'status-ok'
						},
					]
				},
				value: {
					font: "normal normal 500 44px 'Barlow Semi Condensed'",
					offsetY: -10
				}
			})
		);
	});

	// ---   SLIDERS & GAUGES

	filteredIndicators = indicators.filter('.indicator-type--slider');
	filteredIndicators.each(function (index, ind) {
		ind = $(ind);
		params = ind.attr('data-indicator-params');
		if(!exists(params) || params === "")
			return;

		params = JSON.parse(params);
		var min = 0;
		var max = 100;
		if(exists(params.min)){
			// min = (params.min < 1) ? parseFloat(params.min) :  parseInt(params.min);
			min = parseFloat(params.min);
		}
		if(exists(params.max)){
			// max = (params.max < 1) ? parseFloat(params.max) :  parseInt(params.max);
			max = parseFloat(params.max);
		}

		settings = {
			mode: exists(params.mode) ? params.mode : 'slider',
			min: min,
			max: max,
			unite: exists(params.unite) ? params.unite : '',
			ticks: []
		};


		if(exists(params.tick)){
			// Reformate les seuils du slider
			for (i = 0, ilen = params.tick.length; i < ilen; ++i) {
				p = params.tick[i];
				settings.ticks.push({
					from: parseFloat(p[0]),
					to: parseFloat(p[1]),
					color: p[2]
				});
			}
			MONITORING._indicatorsRenderSliderOrGauge(ind.attr('data-indicateur-id'), settings);
		}
	});


	// --- behaviours

	$(document)
		// --- detail panel management
		.off('click', '.ind__detail-toggler')
		.on('click', '.ind__detail-toggler', function(e){
			e.preventDefault();
			e.stopPropagation();

			const indicator$ = $(e.currentTarget).closest('.indicator');
			const indicatorId = indicator$.data('indicateur-id');

			// Vérifier si l'indicateur a l'attribut is_dju avant d'afficher la popup de calcul DJU
			const isDju = $(`#ind-${indicatorId}-is_dju`).val() || '';
			if (isDju!="1") {
				$(e.currentTarget).closest('.indicator').toggleClass('indicator--detail-opened');
				return;
			}

			const consoP = $(`#ind-${indicatorId}-conso_p`).val() || '';
			const consoP1 = $(`#ind-${indicatorId}-conso_p_1`).val() || '';
			const period = $(`#ind-${indicatorId}-period`).val() || '';
			const period1 = $(`#ind-${indicatorId}-period_1`).val() || '';
			const unit = $(`#ind-${indicatorId}-unit`).val() || '';
			
			// Valeur DJU pré-remplies
			const djuRealP = $(`#ind-${indicatorId}-dju_real_p`).val() || '';
			const djuRealP1 = $(`#ind-${indicatorId}-dju_real_p_1`).val() || '';
			
			Swal.fire({
				title: "Analyse de consommation énergétique<br><small style='font-size: 0.7em; font-weight: normal;'>Comparer la consommation réelle avec l'objectif</small>",
				width: 800,
				showCloseButton: true,
				showCancelButton: false,
				showConfirmButton: false,
				allowOutsideClick: true,
				customClass: {
					closeButton: 'uicomp__button uicomp--transparent',
					input: 'uicomp__input',
					inputLabel: 'uicomp__label',
					confirmButton: 'uicomp__button uicomp--brand',
					denyButton: 'uicomp__button uicomp--grey',
					cancelButton: 'uicomp__button uicomp--red'
				},
				html: `
					<div>
						<input type="hidden" id="swal-ind-${indicatorId}-conso_p" value="${consoP}" />
						<input type="hidden" id="swal-ind-${indicatorId}-conso_p_1" value="${consoP1}" />
						<input type="hidden" id="swal-ind-${indicatorId}-period" value="${period}" />
						<input type="hidden" id="swal-ind-${indicatorId}-period_1" value="${period1}" />
						<input type="hidden" id="swal-ind-${indicatorId}-unit" value="${unit}" />
						
						<h3>Paramètres de calcul</h3>
						<div class="gvg-r gvg-r--gutter">
							<div class="gvg-3on6">
								<label class="uicomp__label" for="swal-ind-${indicatorId}-period-select">Période</label>
								<select id="swal-ind-${indicatorId}-period-select" name="periode" class="select2 select2-full-width"></select>
							</div>
							<div class="gvg-3on6">
								<label class="uicomp__label" for="swal-ind-${indicatorId}-date-select">Date</label>
								<div class="uicomp__input uicomp__input--date" style="width: 100%;">
									<input type="text" id="swal-ind-${indicatorId}-date-select" class="uicomp__input" readonly>
									<i class="far fa-calendar"></i>
								</div>
							</div>
							<div class="gvg-3on6">
								<label class="uicomp__label" for="swal-ind-${indicatorId}-dju_real_p">DJU Réel (période)</label>
								<input type="text" id="swal-ind-${indicatorId}-dju_real_p" value="${djuRealP}" class="uicomp__input">
							</div>
							<div class="gvg-3on6">
								<label class="uicomp__label" for="swal-ind-${indicatorId}-dju_real_p_1">DJU Réel P-1</label>
								<input type="text" id="swal-ind-${indicatorId}-dju_real_p_1" value="${djuRealP1}" class="uicomp__input">
							</div>
							<div class="gvg-3on6">
								<label class="uicomp__label" for="swal-ind-${indicatorId}-dju_target">DJU Cible</label>
								<input type="text" id="swal-ind-${indicatorId}-dju_target" value="" class="uicomp__input">
							</div>
							<div class="gvg-6on6 text-center">
								<button class="uicomp__button uicomp--brand btn-dju-calc" data-indicateur-id="${indicatorId}">Calculer</button>
							</div>
						</div>
						
						<hr class="uicomp" id="swal-ind-${indicatorId}-separator" style="display: none;">
						<h3 id="swal-ind-${indicatorId}-results-title" style="display: none;">Résultats</h3>
						<div id="swal-ind-${indicatorId}-dju-resultat"></div>
					</div>
				`,
				didRender: () => {
					const c$ = $(Swal.getHtmlContainer());
					
					// Initialiser le select2 de période
					G.ui.initSelect2(c$.find(`#swal-ind-${indicatorId}-period-select`));
					
					// Remplir le select de période
					const periodSelect = c$.find(`#swal-ind-${indicatorId}-period-select`);
					periodSelect.append(new Option('Mois', '2'));
					periodSelect.append(new Option('Année', '3'));
					
					// Récupérer la valeur par défaut du select du template
					const templateSelectValue = $(`#indicator-${indicatorId}`).find('.ind__period').val() || '2';
					periodSelect.val(templateSelectValue);
					
					// Initialiser Pikaday pour le champ de date avec le premier jour du mois précédent
					const today = new Date();
					const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
					
					new Pikaday({
						field: c$.find(`#swal-ind-${indicatorId}-date-select`)[0],
						format: 'DD/MM/YYYY',
						i18n: G.config.LOCALE_RETRIEVE('pickaday'),
						defaultDate: lastMonth,
						setDefaultDate: true
					});
				
					// Fonction pour mettre à jour les valeurs DJU via l'API
					const updateDJUValues = () => {
						const period = c$.find(`#swal-ind-${indicatorId}-period-select`).val();
						const dateValue = c$.find(`#swal-ind-${indicatorId}-date-select`).val();
							
							if (!period || !dateValue) {
								return;
							}
						
					// Pikaday retourne au format DD/MM/YYYY, l'API attend d/m/Y
					const dateFormatted = dateValue;
						
						// Appel AJAX à la nouvelle route API
						$.ajax({
							url: G.config.SERVER + 'frontend/ajax/getDjuValues',
							type: 'POST',
							data: {
								period: period,
								date: dateFormatted,
								indicateurId: indicatorId
							},
							datatype: 'json',
							success: function (response) {
								if (response.status === 'success') {
									// Mettre à jour les champs DJU
									c$.find(`#swal-ind-${indicatorId}-dju_real_p`).val(response.dju_real || '');
									c$.find(`#swal-ind-${indicatorId}-dju_real_p_1`).val(response.dju_real_p_1 || '');
								} else {
									console.error('Erreur API DJU:', response.message);
								}
							},
							error: function (error) {
								console.error('Erreur lors de la récupération des DJU:', error);
							}
						});
					};
					
					// Ajouter les écouteurs de changement
					c$.find(`#swal-ind-${indicatorId}-period-select`).on('change', updateDJUValues);
					c$.find(`#swal-ind-${indicatorId}-date-select`).on('change', updateDJUValues);
					
					// Calcul DJU
					c$.find('.btn-dju-calc').on('click', function() {
						const indId = $(this).data('indicateur-id');
						// Lire les valeurs actuelles des champs (potentiellement mises à jour par l'API)
						const djuRealP = c$.find(`#swal-ind-${indId}-dju_real_p`).val();
						const djuRealP1 = c$.find(`#swal-ind-${indId}-dju_real_p_1`).val();
						const djuTarget = c$.find(`#swal-ind-${indId}-dju_target`).val();
						const consoP = c$.find(`#swal-ind-${indId}-conso_p`).val();
						const consoP1 = c$.find(`#swal-ind-${indId}-conso_p_1`).val();
						const unit = c$.find(`#swal-ind-${indId}-unit`).val();
						// Récupérer la période et la date sélectionnées
						const periodSelect = c$.find(`#swal-ind-${indId}-period-select`).val();
						const dateValue = c$.find(`#swal-ind-${indId}-date-select`).val();

						if (!djuRealP || !djuRealP1 || !djuTarget) {
							Swal.showValidationMessage('Veuillez remplir tous les champs DJU');
							return;
						}

						// Masquer le message d'erreur si le calcul fonctionne
						$(Swal.getValidationMessage()).hide();

						// Etat de chargement
						c$.find('.btn-dju-calc').prop('disabled', true).html('<i class="fal fa-spinner fa-spin"></i> Calcul...');

					// Pikaday retourne au format DD/MM/YYYY, l'API attend d/m/Y
					const dateFormatted = dateValue;

					// D'abord mettre à jour la période côté serveur
					$.ajax({
						url: G.config.SERVER + 'apigv/indicators/update',
						headers: {
							"Content-Type": "application/json",
							"Authorization": "Bearer "+G.model.userApiKey
						},
						type: 'PUT',
						data: JSON.stringify({
							idIndicator: indId,
							period: periodSelect
						}),
						datatype: 'json',
						success: function (updateResult) {
								// Récupérer les données de l'indicateur avec la date sélectionnée
								$.ajax({
									url: G.config.SERVER + 'frontend/ajax/getDataIndicateur',
									type: 'POST',
									data: {
										"idIndicateurs": [indId],
										"date": dateFormatted
									},
									datatype: 'json',
									error: function (xhr, textStatus, errorThrown) {
										c$.find('.btn-dju-calc').prop('disabled', false).html('Calculer');
										console.error('Erreur lors de la récupération des données de l\'indicateur', textStatus);
									},
									success: function (response) {
										var builtPeriod = '';
										var updatedConsoP = '';
										var updatedConsoP1 = '';
										
										if(response.conso && response.conso.length > 0) {
											var p = response.conso[0];
											if(p.month !== null){
												builtPeriod = p.month+'_'+p.year;
											} else {
												builtPeriod = p.year;
											}
											
											updatedConsoP = p.value || '';
											updatedConsoP1 = p.previousValue || '';
										}

										// Appelle la fonction de calcul DJU avec les valeurs actuelles des champs
										MONITORING.executeDjuCalc(indId, `#swal-ind-${indId}-dju-resultat`, {
											djuRealP: djuRealP,
											djuRealP1: djuRealP1,
											djuTarget: djuTarget,
											consoP: updatedConsoP,
											consoP1: updatedConsoP1,
											unit: unit,
											period: builtPeriod
										});

										// Reset état de chargement et affichage des résultats
										c$.find('.btn-dju-calc').prop('disabled', false).html('Calculer');
										c$.find(`#swal-ind-${indId}-separator`).show();
										c$.find(`#swal-ind-${indId}-results-title`).show();
									}
								});
							},
							error: function (xhr, textStatus, errorThrown) {
								c$.find('.btn-dju-calc').prop('disabled', false).html('Calculer');
								console.error('Erreur lors de la mise à jour de la période', textStatus);
							}
						});
					});
				}
			});
		})
		// --- detail panel management
		.off('change', '.ind__period')
		.on('change', '.ind__period', function(e){
			var period = $(this).val();
			
			$.ajax({
				url: G.config.SERVER + 'apigv/indicators/update',
				headers: {
					"Content-Type": "application/json",
					"Authorization": "Bearer "+G.model.userApiKey
				},
				type: 'PUT',
				data: JSON.stringify({
					idIndicator: $(e.currentTarget).closest('.indicator').data('indicateur-id'),
					period: period
				}),
				datatype: 'json',
				error: function (xhr, textStatus, errorThrown) {
					G.ui.fatalError(textStatus, { url: this.url, textStatus: textStatus, error: errorThrown, params: JSON.stringify(data) });
				},
				success: function (d) {
					if(MONITORING.VERBOSE){
						console.log('\t [MONITORING.indicatorEdit] data', d);
					}
					if(d.status == 'success'){
						MONITORING.indicatorsUpdate(false, $(e.currentTarget).closest('.indicator').data('indicateur-id'), '');
					}
				}
			});
		})
		.off('click', '.ind__refresh')
		.on('click', '.ind__refresh', function(e){
			// Désactiver le bouton recharger
			const $btn =  $(this)
			$btn.prop('disabled', true).addClass('is-loading');

			// Sélectionne le conteneur d'indicateurs et le panel de données
			var indicatorsContainer = $(this).closest('.indicators-container');
			var indicator = indicatorsContainer.find('.indicator.' + MONITORING.CLASS_INDICATOR_ACTIVE);
			var dataPanel = indicatorsContainer.find('.indicators-panel-data');

			// Affiche le loader et recharge les données de l'indicateur
			MONITORING._showLoading(HCH.getContainer(dataPanel, HCH.INDICATOR_CLASS_CONTAINER), true);
			MONITORING.refreshIndicator(e,indicator,indicatorsContainer,dataPanel);
		})
		// --- panel expand & panel management
		.off('click', '.ind__expand, .ind__expand-btn')
		.on('click', '.ind__expand, .ind__expand-btn', function(e){
			// Désactiver le bouton recharger
			const $btn = $(e.target).closest('.indicators-container').find('.ind__refresh');
			$btn.prop('disabled', true).addClass('is-loading');
			MONITORING.expandIndicator(e);
		})
		.off(MONITORING.EVT_REFRESH_CHART, '.ind__expand')
		.on(MONITORING.EVT_REFRESH_CHART, '.ind__expand', function(e){
			MONITORING.expandIndicator(e, true);
		})
		.off('click', '.' + MONITORING.CLASS_PANEL + ' .close-button')
		.on('click', '.' + MONITORING.CLASS_PANEL + ' .close-button', function(e){
			MONITORING.expandIndicator(e, false);
		})
		// --- reload data management
		.off('click', '.ind__reload')
		.on('click', '.ind__reload', function(e){
			e.preventDefault();
			IO_POINTS.readPoint(IO_POINTS.getSettings($(e.currentTarget).closest('.indicator')));
		})
		// --- zone sensor list info
		.off('click', '.zone-show-histo')
		.on('click', '.zone-show-histo', function(e){
			e.preventDefault();
			MONITORING._zoneShowHistory($(e.currentTarget), $(e.currentTarget).attr('data-point-id'));
			return false;
		})
		// --- action write value management
		.off('click', '.ind__write-point')
		.on('click', '.ind__write-point', function(e){
			var dataHolder, s;

			e.preventDefault();

			dataHolder = $(e.currentTarget)
				.closest('.indicator')
				.find('.ind-data-brick.ind-data-brick--edited');
			if(dataHolder.length == 0){
				dataHolder = $(e.currentTarget).closest('.indicator-vert-block');

				if(dataHolder.length == 0){
					console.log('[ind__write-point click] No edited input');
					return;
				}
			}

			s = IO_POINTS.getSettings(dataHolder);
			var actionSettings = MONITORING.getActionContext(s);
			if(MONITORING.VERBOSE)
				console.log('[ind__write-point click]', { dataHolder: dataHolder, s: s}, actionSettings);

			if(s.checkping == "1")
				IO_POINTS.checkPingToWritePoint(s);
			else if(s.equipementMarque == 'trend' || s.equipementMarque == 'sofrel' || s.equipementMarque == 'sauter' || s.equipementMarque == 'saia' || s.equipementMarque == 'bacnet' || s.equipementMarque == 'bacnet_bbmd'){
				IO_POINTS.writePoint(s, actionSettings.inpValue);
			}
			else if(s.equipementMarque == 'siemens')
				IO_POINTS.writeSiemens(s, actionSettings.inpValue, actionSettings.mode);
			else
				IO_POINTS.getModbusFrameToWritePoint_Globalio(s);
		})
		// --- action change value management
		.off('change', '.ind__input-edit')
		.on('change', '.ind__input-edit', function(e){
			MONITORING.actionChange(e);
		})
		// --- panel expand & panel management
		.off('click', '.ind__date-previous, .ind__date-next')
		.on('click', '.ind__date-previous, .ind__date-next', function(e){
			var indicator = $(e.currentTarget).closest('.indicator');
			var mode = 'down';
			console.log("INDIC_DATE", mode, indicator);
			if($(this).hasClass('ind__date-next')){
				var mode = 'up';
			}
			var date = '';
			var tmpDateSplitted = $('#indicator-' + indicator.data('indicateurId') + ' .ind__date-ts').text().split(' ');
			var tmpDate = tmpDateSplitted[0].split('/');
			console.log(tmpDateSplitted, tmpDate);
			//MOIS
			if(tmpDateSplitted.length == 1){
				if(tmpDate.length == 3){
					var m = moment(tmpDate[2]+'-'+tmpDate[1]+'-'+tmpDate[0]);
					console.log(m.format('YYYY/MM/DD'));
					if(mode == 'up'){
						m.add(1, 'days');
					} else {
						m.subtract(1, 'days');
					}
					date = m.format('YYYY/MM/DD');
					console.log(date);
				} else{
					var m = moment(tmpDateSplitted+'-01-01');
				   if(mode == 'up'){
					   m.add(1, 'years');
				   } else {
					   m.subtract(1, 'years');
				   }
				   date = m.format('YYYY/MM/DD');

				}
			} else if(tmpDateSplitted.length == 2) { //ANNEE
				if(tmpDate.length == 3){
					var m = moment(tmpDate[2]+'-'+tmpDate[1]+'-'+tmpDate[0]+' '+tmpDateSplitted[1]);
					if(mode == 'up'){
						m.add(1, 'days');
					} else {
						m.subtract(1, 'days');
					}
					date = m.format('YYYY/MM/DD');
				} else {
					var tmpMonth = G.config.LOCALE_RETRIEVE('date.monthes').indexOf(tmpDateSplitted[0]) + 1;
					if(tmpMonth.toString().length == 1){
						tmpMonth = '0'+tmpMonth;
					} 
					var m = moment(tmpDateSplitted[1]+'-'+tmpMonth+'-01');
					
					if(mode == 'up'){
						m.add(1, 'months');
					} else {
						m.subtract(1, 'months');
					}
					date = m.format('YYYY/MM/DD');

				}
			}else if(tmpDateSplitted.length == 3) { //JOUR
				var m = moment(tmpDate[2]+'-'+tmpDate[1]+'-'+tmpDate[0]);
				console.log(tmpDate[2]+'-'+tmpDate[1]+'-'+tmpDate[0]);
				if(mode == 'up'){
					m.add(1, 'days');
				} else {
					m.subtract(1, 'days');
				}
				date = m.format('YYYY/MM/DD');
				
			} else {
				if(tmpDate.length >= 2){
					var m = moment(tmpDate[2]+'-'+tmpDate[1]+'-'+tmpDate[0]+' '+tmpDateSplitted[1]);
					
					if(mode == 'up'){
						m.add(2, 'months');
					}
					date = m.format('YYYY/MM/DD');
				} else {
					date = $('#indicator-' + indicator.data('indicateurId') + ' .ind__date-ts').text();
				}
			}
			MONITORING.indicatorsUpdate(false, $(e.currentTarget).closest('.indicator').data('indicateurId'), date, mode);
		})
		// -- edit indicator
		.off('click', '.data-edit')
		.on('click', '.data-edit', function(){
			const engine = new G.ui.GVIndicatorEditionEngineV3({
				indicatorId: $(this).data('indicatorid'),
				siteId: G.model.siteSelected.id,
				onSaved: function(indicator) {
				const articleIndicator$ = $(`#indicator-${indicator.id}`);
				const articleIndicatorIcone$ = $(`#indicator-${indicator.id}`).find(`#indicator-${indicator.id}__icon`);
				const indicatorNextSibling$ = articleIndicator$.next('.indicator');
				const indicatorOldSection$ = articleIndicator$.parents("section");
				const indicatorOldSectionId = indicatorOldSection$.exists() ? indicatorOldSection$.attr("data-sectionid") ?? "0" : "0";

				articleIndicator$.find(".indicator-title").html(indicator.nom);
				articleIndicator$.attr("class", articleIndicator$.attr('class').replace(/\bindicator--size-dimensions-\d-1\b/g, '').trim()); // suppression classe dimensions indicator
				articleIndicator$.addClass(`indicator--size-dimensions-${(indicator.dimensions ?? "1:1").replace(':', '-')}`);
				if(articleIndicatorIcone$.exists()) {
					articleIndicatorIcone$.attr("class", articleIndicatorIcone$.attr('class').replace(/gv-iicon-[a-zA-Z]+/g, '').trim())
					if(indicator.icone) {
						articleIndicatorIcone$.addClass(`gv-iicon-${indicator.icone}`)
					}
				}

				if(articleIndicator$.hasAttr("data-indicateur-section-id")) {
					articleIndicator$.attr("data-indicateur-section-id", indicator.section_id);
				}
				if(articleIndicator$.hasAttr("data-target")) {
					articleIndicator$.attr("data-target", indicator.target);
				}
				if(articleIndicator$.hasAttr("data-indicateur-name")) {
					articleIndicator$.attr("data-indicateur-name", indicator.nom);
				}
				if(articleIndicator$.hasAttr("data-indicator-params")) {
					articleIndicator$.attr("data-indicator-params", JSON.stringify(indicator.parametres));
				}
				if(articleIndicator$.hasAttr("data-indicator-period") && indicator.periodePanel) {
					articleIndicator$.attr("data-indicator-period", indicator.periodePanel);
				}
				if(articleIndicator$.hasAttr("data-graphique-linked") && indicator.graphique_id) {
					articleIndicator$.attr("data-graphique-linked", indicator.graphique_id);
				}
				if(articleIndicator$.hasAttr("data-point-id") && indicator.point_id) {
					articleIndicator$.attr("data-point-id", indicator.point_id);
				}
				if(articleIndicator$.hasAttr("data-point-label") && indicator?.point?.labelAutomate) {
					articleIndicator$.attr("data-point-id", indicator.point.labelAutomate);
				}
				if(articleIndicator$.hasAttr("data-equipement-id") && indicator?.point?.equipement?.id) {
					articleIndicator$.attr("data-equipement-id", indicator.point.equipement.id);
				}
				if(articleIndicator$.hasAttr("data-equipement-marque") && indicator?.point?.equipement?.site?.id && indicator?.point?.equipement?.marque?.nom) {
					articleIndicator$.attr("data-equipement-marque", indicator.point.equipement.site.id == 1527 ? "bacnet" : indicator.point.equipement.marque.nom.toLowerCase());
				}
				if(articleIndicator$.hasAttr("data-equipement-mnemonique") && indicator?.point?.equipement?.mnemonique) {
					articleIndicator$.attr("data-equipement-mnemonique", indicator.point.equipement.mnemonique);
				}
				if(articleIndicator$.hasAttr("data-equipement-checkping") && indicator?.point?.equipement?.checkping) {
					articleIndicator$.attr("data-equipement-checkping", indicator.point.equipement.checkping);
				}
				if(articleIndicator$.hasAttr("data-equipement-host")) {
					if(indicator?.point?.equipement?.acquisition) {
						switch(indicator.point.equipement.acquisition.nom.toLowerCase()) {
							case 'devio05':
								articleIndicator$.attr("data-equipement-host", "devio5");
								break;
							case 'devio06':
								articleIndicator$.attr("data-equipement-host", "devio6");
								break;
							case 'devio07':
								articleIndicator$.attr("data-equipement-host", "devio7");
								break;
							default:
								articleIndicator$.attr("data-equipement-host", "devio6");
						}
					}
					else if([3251, 80].includes(indicator?.point?.equipement?.site?.id)) {
						articleIndicator$.attr("data-equipement-host", "devio7");
					}
					else if(["bacnet", "sauter"].includes(indicator?.point?.equipement?.marque?.nom)) {
						articleIndicator$.attr("data-equipement-host", "devio5");
					}
					else {
						articleIndicator$.attr("data-equipement-host", "devio6");
					}
				}
				if(articleIndicator$.hasAttr("data-equipement-frontal") && indicator?.point?.equipement?.motDePasse) {
					articleIndicator$.attr("data-equipement-frontal", indicator.point.equipement.motDePasse == "ikoola" ? "io-02.global-visio.com" : "io.global-visio.com");
				}
				if(articleIndicator$.hasAttr("data-voie") && indicator?.point?.voieModbus) {
					articleIndicator$.attr("data-voie", indicator.point.voieModbus);
				}

				if(indicatorOldSectionId != (indicator.section_id ?? "0")) {
					let newSectionIndicator$ = $(`#section-monitoring-${indicator.section_id}`);
					if(newSectionIndicator$.exists()) {
						// jquery move element into other parent => https://stackoverflow.com/a/16285059/20583776
						newSectionIndicator$.find(".indicators-container").append(articleIndicator$);
					}
				} else if (indicatorNextSibling$.exists() && indicatorNextSibling$.parent().is(articleIndicator$.parent())) {
					// Reaffirme l'ordre DOM d'origine avant le recalcul Masonry.
					articleIndicator$.insertBefore(indicatorNextSibling$);
				}

				MONITORING._initMasonryViewIndicatorContainers("indicators-container");
				}
			});

			engine.fire();
		})
		// -- slider: remove tick
		.off('click', '.btn-delete-step')
		.on('click', '.btn-delete-step', function(e){
			e.preventDefault();
			$(this).parent().parent().remove();
		})
		// -- slider: add tick
		.off('click', '#btn-add-step')
		.on('click', '#btn-add-step', function(e){
			e.preventDefault();
			if($('#step-from').val() == ''){
				showError('Please fill the from value');
				return false;
			}
			if($('#step-to').val() == ''){
				showError('Please fill the to value');
				return false;
			}
			var line = 	'<tr class="tick-rule">' +
							'<td><input type="text" class="uicomp__input step-from" value="'+$('#step-from').val()+'" /></td>' + 
							'<td><input type="text" class="uicomp__input step-to" value="'+$('#step-to').val()+'" /></td>' + 
							'<td><input type="text" class="uicomp__input step-status" value="'+$('#step-status').val()+'" /></td>' + 
							'<td><a href="#" class="btn-delete-step"><i class="fas fa-trash" aria-hidden="true"></i></a></td>' + 
						'</tr>';
			$('#indicator-div-ticks tbody').append(line);
			$('#step-from, #step-to').val('');
		})
		.off('click', '.data-remove')
		.on('click', '.data-remove', function(){
			const $id = $(this).data('indicatorid');
			const $indicator = $('#indicator-'+$id);
			if(confirm('Confirmez vous la suppression de l\'indicateur?')){
				$.ajax({
					url: G.config.SERVER + 'apigv/indicators/delete/'+ $id,
					type: 'DELETE',
					headers: {
						"Content-Type": "application/json",
						"Authorization": "Bearer "+G.model.userApiKey
					},
					data: {},
					datatype: 'json',
					error: function (xhr, textStatus, errorThrown) {
						showError(xhr.responseJSON.message ?? G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
					},
					success: function (d) {
						if(MONITORING.VERBOSE){
							console.log('\t [MONITORING.indicatorRemove] data', d);
						}
						if(d.status == 'success'){
							$indicator.remove();
							MONITORING._initMasonryViewIndicatorContainers("indicators-container");
							showInfo(d.response.txt);
						}
						else{
							showError(d.message ?? G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
						}
					}
				});
			}
		})
		// -- edit section
		.off('click', '.data-section-edit')
		.on('click', '.data-section-edit', function(){
			const swalInst = new G.ui.GVSwal2FormIndicatorSection({}, G.model.siteSelected.id, $(this).data('sectionid'), function(indicatorSection) {
				const indicatorSection$ = $(`#section-monitoring-${indicatorSection.id}`);
				const indicatorHasFilterData = parseInt(indicatorSection.filterDate ?? 0) === 1;
				indicatorSection$.find(".section-title").html(indicatorSection.titre);
				indicatorSection$.find(".section-subtitle").html(indicatorSection.soustitre);
				indicatorSection$.find(".__filters").toggle(indicatorHasFilterData);
				if(indicatorSection.icone) {
					if(indicatorSection.icone.substring(0, 3) !== 'fal') {
						indicatorSection$.find(".gv-iicon-wrapper").html(`<i class="gv-iicon gv-iicon-${indicatorSection.icone}"></i>`);
					}
					else {
						indicatorSection$.find(".gv-iicon-wrapper").html(`<i class="${indicatorSection.icone}"></i>`);
					}
				}
			});
			swalInst.fireSwal();
		});
	;

	const cbInitMasonryViewIndicatorContainers = () => MONITORING._initMasonryViewIndicatorContainers("indicators-container");
	window.removeEventListener("resize", cbInitMasonryViewIndicatorContainers);
	window.addEventListener("resize", cbInitMasonryViewIndicatorContainers);
};

// Rend un slider ou une jauge a partir d'un format de seuils commun.
MONITORING._indicatorsRenderSliderOrGauge = function (indicatorId, data) {
	var selector = '#indicator-' + indicatorId + '__slider';
	var container = $(selector);
	var mode = data && data.mode ? data.mode : 'slider';

	if (!container.exists()) {
		return;
	}

	container.empty();

	if (mode === 'slider') {
		MONITORING._indicatorsInitSlider(indicatorId, data);
		return;
	}

	var gaugeTicks = (data.ticks || []).map(function (tick) {
		return {
			valueStart: parseFloat(tick.from),
			valueEnd: parseFloat(tick.to),
			style: tick.color
		};
	});
	var tilts = gaugeTicks.length > 0 ? [{value: gaugeTicks[0].valueStart}] : [];

	gaugeTicks.forEach(function (tick) {
		tilts.push({value: tick.valueEnd});
	});

	var gaugeSettings = {
		range: {
			valueStart: parseFloat(data.min),
			valueEnd: parseFloat(data.max),
			color: '#999999',
			margin: 18
		},
		tilts: {
			font: "normal normal 400 12px 'Barlow Semi Condensed'",
			lblOffset: 30,
			data: tilts
		},
		format: {
			unit: '',
			precision: 1
		},
		units: {
			enabled: false
		},
		ticks: {
			thicknessDefault: 3,
			data: gaugeTicks
		},
		value: {
			font: "normal normal 500 38px 'Barlow Semi Condensed'",
			offsetY: 4
		}
	};

	$.data($(selector)[0], 'GVGauge', new G.ui.GVGauge(selector, gaugeSettings));
};

/** @private */
MONITORING._indicatorsInitGetRelSlider = function (indicatorId, v, data) {
	var el;

	if (!exists(data)) {
		el = $('#slider-container-' + indicatorId);
		data = {
			minRounded: el.attr('data-min-rounded'),
			maxRounded: el.attr('data-max-rounded')
		};
	}
	return Math.round((v - data.minRounded) / (data.maxRounded - data.minRounded) * 10000) / 10000;
};

/** @private */
MONITORING._indicatorsInitSlider = function (indicatorId, data) {
	var
		i, ilen, tick, elLines, elMarkers,
		el = $('#indicator-' + indicatorId + '__slider'),
		unitsTicksTarget = 4,
		unitsRangeTarget,
		unitsRoundRanges = [0.01,0.025, .05, .1, .25, .5, 1, 2, 5, 10, 20, 25, 50, 100, 200, 250, 500, 1000, 2000, 2500, 5000, 10000],
		unitsRange,
		dataDelta = data.max - data.min,
		
		// ---   Rounds value to the given precision
		roundTo = function (v, precision) {
			if(v < 1){
				return v;
			}
			return Math.round(v / precision) * precision;
		};

	// --- initial build
	el.html(
		'<div class="isb__indicator-slider-box">'
			+ '<div class="isb__lines"></div>'
			+ '<div class="isb__markers"></div>'
			+ '<div class="isb__pointer">'
				+ '<div class="isb__pointer-arrow"></div>'
			+ '</div>'
			+ '<div class="isb__value mod--status-text"></div>'
		+ '</div>'
	);
	elLines = el.find('.isb__lines');
	elMarkers = el.find('.isb__markers');


	// ---   compute units ticks

	unitsRangeTarget = dataDelta / unitsTicksTarget;
	for (i = unitsRoundRanges.length - 1; i > 0; --i) {
		if (unitsRoundRanges[i] <= unitsRangeTarget) {
			unitsRange = unitsRoundRanges[i];
			break;
		}
	}

	data.minRounded = roundTo(data.min, unitsRange);
	el.attr('data-min-rounded', data.minRounded);
	data.maxRounded = roundTo(data.max, unitsRange);
	el.attr('data-max-rounded', data.maxRounded);
	
	// ---   add unit ticks
	i = data.minRounded;
	str = '';

	str += '<div class="isb__marker"  style="left:' + (MONITORING._indicatorsInitGetRelSlider(indicatorId, i, data) * 100) + '%;"><div class="unit-tick">' + i + '</div></div>';
	while (i < data.maxRounded) {
		i += unitsRange;
		str += '<div class="isb__marker"  style="left:' + (MONITORING._indicatorsInitGetRelSlider(indicatorId, i, data) * 100) + '%;"><div class="unit-tick">' + parseFloat(i.toFixed(3)) + '</div></div>';
	}
	elMarkers.append(str);


	// ---  add slider areas
	for (i = 0, ilen = data.ticks.length; i < ilen; ++i) {
		tick = data.ticks[i];
		elLines.append($('<div '
			+ 'class="isb__line gv-tip ' + tick.color + '" '
			+ 'data-tippedpos="bottom" data-tipped-options="offset: { y: 10 }"'
			+ 'title="' + tick.from + data.unite + ' - ' + tick.to + data.unite + '" '
			+ 'data-tick-from="' + tick.from + '" '
			+ 'data-tick-to="' + tick.to + '" '
			+ 'style="'
			+ 'left:' + ((MONITORING._indicatorsInitGetRelSlider(indicatorId, tick.from, data) * 100) + '%') + ';'
			+ 'width:' + (((MONITORING._indicatorsInitGetRelSlider(indicatorId, tick.to, data) - MONITORING._indicatorsInitGetRelSlider(indicatorId, tick.from, data)) * 100) + '%') + ';'
			+ '" '
			+ '></div>'));
	}
	G.ui.tippedInit(elLines);
};


/**
 * Retrieves action input context.
 * @usage      settings parameter s can be built through <IO_POINTS.getSettings>
 * @returns    {{ settings: *, inpIsToggler: boolean, inpValue: (boolean|number), inp: jQuery, ind: jQuery, inpStoredVal: (boolean|number) }}
 */
MONITORING.getActionContext = function(s){
	var ind, inp, inpIsToggler, inpValue, inpStoredVal;

	ind = $('.indicator[' + IO_POINTS._attr.indicateurUID + '="' + s.indicateurUID + '"]').eq(0);

	var mode='input';
	inp = ind.find('#ind__input-edit-' + s.pointUID);
	if(!inp.exists()){
		inp = ind.find('#ind__select-edit-' + s.pointUID);
		mode='select';
	}
	if(!inp.exists())
		console.warn("[MONITORING.getActionContext] Unable to retrieve ", s);
	else{
		inpIsToggler = inp.attr('type') === 'checkbox';
		inpValue = inpIsToggler ? inp.is(':checked') : inp.val();
		inpStoredVal = inpIsToggler ? inp.attr('data-init-value') === 'istrue' : parseFloat(inp.attr('data-init-value'));
	}

	return {
		settings: s,
		ind: ind,
		inp: inp,
		inpIsToggler: inpIsToggler,
		inpValue: inpValue,
		inpStoredVal: inpStoredVal,
		mode: mode
	};
};


MONITORING._initMasonryViewIndicatorContainers = function (containerClass, cbOnLayoutComplete = function() {}) {
    var bcl = document.body.classList;

    $(`.${containerClass}`).each(function () {
        const containerEl = this;
        const $container = $(containerEl);

        let columnWidthIndicator;
        switch (true) {
            case bcl.contains('responsive--mobile'):
                columnWidthIndicator = $container.outerWidth();
                break;
            case bcl.contains('responsive--tablet'):
                columnWidthIndicator = $container.outerWidth() / 2;
                break;
            case bcl.contains('responsive--desktop'):
                columnWidthIndicator = $container.outerWidth() / 3;
                break;
            case bcl.contains('responsive--desktop-max'):
                columnWidthIndicator = $container.outerWidth() / 4;
                break;
            case bcl.contains('responsive--desktop-large-max'):
                columnWidthIndicator = $container.outerWidth() / 5;
                break;
            default:
                columnWidthIndicator = $container.outerWidth();
        }

        let msnry = Masonry.data(containerEl);

        if (msnry) {
            msnry.options.columnWidth = columnWidthIndicator;
            msnry.once('layoutComplete', function () {
                cbOnLayoutComplete();
            });
            msnry.reloadItems();
            msnry.layout();
        } else {
            msnry = new Masonry(containerEl, {
                percentPosition: true,
                columnWidth: columnWidthIndicator,
                itemSelector: '.indicator, .indicators-panel-data',
                initLayout: false
            });
            msnry.once('layoutComplete', function () {
                cbOnLayoutComplete();
            });
            msnry.layout();
        }
    });
};

if (!window.G) {
    window.G = {};
}

G.ui = G.ui || {};
G.ui.GVIndicatorEditionV3Components = G.ui.GVIndicatorEditionV3Components || {};

(function () {
    const components = G.ui.GVIndicatorEditionV3Components;

    // # Retourne le texte d'erreur traduit associe au type de validation courant.
    function buildValidationMessage(field, messageKey, fallbackText, ui) {
        const messageTemplate = (ui && ui.validation && ui.validation[messageKey]) || fallbackText;

        return messageTemplate;
    }

    const validators = {
        // Vérifie qu'une valeur est renseignée.
        required: function (value) {
            if (value === null || value === undefined) {
                return false;
            }
            if (typeof value === "string" && value.trim() === "") {
                return false;
            }
            if (Array.isArray(value) && value.length === 0) {
                return false;
            }
            return true;
        },

        // Vérifie que la valeur est une chaîne de caractères.
        "plain-text": function (value) {
            if (value === null || value === undefined || value === "") {
                return true;
            }
            return typeof value === "string";
        },

        // Vérifie que la valeur est un entier (positif ou négatif).
        integer: function (value) {
            if (value === null || value === undefined || value === "") {
                return true;
            }
            return /^-?\d+$/.test(String(value).trim());
        },

        // Vérifie que la valeur est supérieure ou égale à 0.
        "min-0": function (value) {
            if (value === null || value === undefined || value === "") {
                return true;
            }
            return Number(value) >= 0;
        },

        // Verifie que la valeur courante est inferieure ou egale au champ dependant.
        "inferior-to": function (value, field, state, dependencyPath) {
            const dependencyValue = components.getByPath(state, resolveValidationDependencyPath(dependencyPath));
            return !areComparableValues(value, dependencyValue) || Number(value) <= Number(dependencyValue);
        },

        // Verifie que la valeur courante est superieure ou egale au champ dependant.
        "superior-to": function (value, field, state, dependencyPath) {
            const dependencyValue = components.getByPath(state, resolveValidationDependencyPath(dependencyPath));
            return !areComparableValues(value, dependencyValue) || Number(value) >= Number(dependencyValue);
        }
    };

    // Normalise une regle de validation au format : { name: "rule-name", parameter: param-value }
    function normalizeValidationRule(rule) {
        if (typeof rule === "string") {
            return { name: rule, parameter: null };
        }

        if (!rule || typeof rule !== "object") {
            return { name: "", parameter: null };
        }

        const ruleNames = Object.keys(rule);
        if (!ruleNames.length) {
            return { name: "", parameter: null };
        }

        return { name: ruleNames[0], parameter: rule[ruleNames[0]] };
    }

    // Resoue le chemin du champ dont depend une validation parametrable.
    function resolveValidationDependencyPath(parameter) {
        if (typeof parameter === "string") {
            return parameter;
        }

        if (parameter && typeof parameter === "object") {
            return parameter.path || parameter.field || parameter.name || "";
        }

        return "";
    }

    // Ignore la comparaison tant qu'une des deux valeurs n'est pas numerique.
    function areComparableValues(value, dependencyValue) {
        return value !== null && value !== undefined && value !== ""
            && dependencyValue !== null && dependencyValue !== undefined && dependencyValue !== ""
            && Number.isFinite(Number(value)) && Number.isFinite(Number(dependencyValue));
    }

    G.ui.GVIndicatorFormValidationV3 = {
        // Exécute les validations d'un champ et retourne un message clair si une règle échoue.
        validateField: function (field, state, ui) {
            const fieldValidators = Array.isArray(field.validations) ? field.validations : [];
            const value = arguments.length > 3 ? arguments[3] : components.getByPath(state, field.name);
            const validationMessages = {
                required: function () {
                    return buildValidationMessage(field, "required", "Veuillez renseigner le champ :", ui);
                },
                "plain-text": function () {
                    return buildValidationMessage(field, "plainText", "Le champ doit contenir un texte simple :", ui);
                },
                integer: function () {
                    return buildValidationMessage(field, "integer", "Le champ doit contenir un nombre entier :", ui);
                },
                "min-0": function () {
                    return buildValidationMessage(field, "minZero", "Le champ doit contenir une valeur supérieure ou égale à 0 :", ui);
                },
                "inferior-to": function () {
                    return buildValidationMessage(field, "inferiorTo", "La valeur doit etre inferieure ou egale au champ associe :", ui);
                },
                "superior-to": function () {
                    return buildValidationMessage(field, "superiorTo", "La valeur doit etre superieure ou egale au champ associe :", ui);
                }
            };

            for (let i = 0; i < fieldValidators.length; i++) {
                const validationRule = normalizeValidationRule(fieldValidators[i]);
                const validatorName = validationRule.name;
                const validator = validators[validatorName];
                if (typeof validator === "function" && !validator(value, field, state, validationRule.parameter)) {
                    if (typeof validationMessages[validatorName] === "function") {
                        return validationMessages[validatorName]();
                    }

                    return buildValidationMessage(field, "invalid", "Le champ est invalide :", ui);
                }
            }

            return null;
        },

        // Valide une nouvelle valeur et decide si elle peut remplacer celle actuellement stockee.
        applyFieldValue: function (field, value, state, ui) {

            // Verifie ensuite si cette valeur est valide dans le contexte actuel du formulaire.
            const validationMessage = this.validateField(field, state, ui, value);

            // Si aucune erreur n'est detectee, la valeur normalisee peut etre enregistree.
            if (!validationMessage) {
                return {
                    value: value,
                    accepted: true,
                    message: null
                };
            }

            // Si la valeur est refusee, on conserve l'ancienne valeur deja presente dans le state.
            return {
                value: components.getByPath(state, field.name),
                accepted: false,
                message: validationMessage
            };
        }

    };
})();

if (!window.G) {
    window.G = {};
}

G.ui = G.ui || {};
G.ui.GVIndicatorEditionV3Components = G.ui.GVIndicatorEditionV3Components || {};
G.ui.GVIndicatorEditionV3Utils = G.ui.GVIndicatorEditionV3Utils || {};

(function () {
    // # Stocke, pour chaque objet state du formulaire, la config de validation associee a chacun de ses champs.
    const validationContexts = new WeakMap();

    // # Memorise quelle config de validation est associee a chaque champ du state.
    function registerFieldValidation(state, field, ui) {
        if (!state || !field || !field.name) {
            return;
        }

        if (!validationContexts.has(state)) {
            validationContexts.set(state, {});
        }

        validationContexts.get(state)[field.name] = { field: field, ui: ui || {} };
    }

    // # Lit une valeur imbriquee a partir d'un chemin du type "a.b.c".
    function getByPath(object, path) {
        const pathKeys = String(path).split(".");
        let currentValue = object;

        for (let index = 0; index < pathKeys.length; index++) {
            if (currentValue === null || currentValue === undefined) {
                return undefined;
            }

            currentValue = currentValue[pathKeys[index]];
        }

        return currentValue;
    }

    // # Ecrit une valeur imbriquee a partir d'un chemin du type "a.b.c".
    function setByPath(object, path, value, options) {
        const writeOptions = options || {};

        // Si le champ est associe a un contexte de validation, on l'applique pour bloquer ou valider la modification
        const context = validationContexts.has(object)
            ? validationContexts.get(object)[path]
            : null;

        if (context && writeOptions.validate !== false) {
            value = G.ui.GVIndicatorFormValidationV3.applyFieldValue(
                context.field,
                value,
                object,
                context.ui
            ).value;
        }

        // Decoupe le chemin ("a.b.c") pour pouvoir parcourir l'objet niveau par niveau.
        const pathKeys = String(path).split(".");
        let pointer = object;

        // Descend progressivement dans l'objet en creant les niveaux manquants si besoin.
        for (let index = 0; index < pathKeys.length - 1; index++) {
            if (!pointer[pathKeys[index]] || typeof pointer[pathKeys[index]] !== "object") {
                pointer[pathKeys[index]] = {};
            }

            pointer = pointer[pathKeys[index]];
        }

        // Ecrit finalement la valeur sur la derniere cle du chemin.
        pointer[pathKeys[pathKeys.length - 1]] = value;
        return value;
    }

    // # Retourne le texte final d'un libelle, qu'il vienne d'une traduction ou d'un texte brut.
    function resolveUiText(config, propertyName, fallbackText) {
        if (!config || typeof config !== "object") {
            return fallbackText !== undefined ? fallbackText : "";
        }

        if (config[propertyName] !== undefined && config[propertyName] !== null) {
            return config[propertyName];
        }

        return fallbackText !== undefined ? fallbackText : "";
    }

    // # Construit une balise option jQuery pour les select.
    function buildOption(optionValue, optionLabel) {
        return $("<option></option>").val(optionValue).text(optionLabel);
    }

    // # Remplace les placeholders {x.y} d'un template avec les donnees source.
    function resolveTemplate(template, source) {
        return String(template).replace(/\{([^}]+)\}/g, function (_, path) {
            const value = getByPath(source, path);
            return value === null || value === undefined ? "" : value;
        });
    }

    // # Detruit un Select2 si le select l'utilise vraiment encore.
    function destroySelect2(selectElement) {
        const select = $(selectElement);
        if (!select.length || !select.hasClass("select2-hidden-accessible")) {
            return;
        }

        try {
            select.select2("destroy");
        } catch (error) {}
    }

    // # Detruit proprement une instance tierce qui expose eventuellement `off()` et `destroy()`.
    function destroyThirdPartyInstance(instance) {
        if (!instance) {
            return;
        }
        try {
            if (typeof instance.off === "function") {
                instance.off();
            }
        } catch (error) {}
        try {
            if (typeof instance.destroy === "function") {
                instance.destroy();
            }
        } catch (error) {}
    }

    // # Determine le libelle a afficher pour une option.
    function resolveOptionLabel(item, field) {
        if (field.optionLabelTemplate) {
            return resolveTemplate(field.optionLabelTemplate, item);
        }

        // Fallback s'il n'y a pas de template explicite pour l'affichage de l'option
        return item.nom || item.titre || item.label || item.name || item.labelHumain || item.id || item.value || "";
    }

    // # Convertit un status metier en couleur visuelle reutilisable dans les apercus d'indicateur.
    function getStatusColor(status) {
        switch (status) {
            case "status-alert":
                return G.clr.GV_ENUM.red;
            case "status-warning":
                return G.clr.GV_ENUM.yellow;
            case "status-ok":
                return G.clr.GV_ENUM.greenl;
            default:
                return "";
        }
    }

    // # Traduit un status metier en nom de classe CSS pour les pastilles de rendu.
    function getStatusColorClass(status) {
        switch (status) {
            case "status-alert":
                return "gv-indicator-color-dot--status-alert";
            case "status-warning":
                return "gv-indicator-color-dot--status-warning";
            case "status-ok":
                return "gv-indicator-color-dot--status-ok";
            default:
                return "";
        }
    }

    // # Traduit un index de palette GlobalVisio en nom de classe CSS stable.
    function getPaletteColorClass(colorIndex) {
        if (colorIndex === null || colorIndex === undefined || colorIndex === "") {
            return "";
        }

        return "gv-indicator-color-dot--palette-" + String(colorIndex).replace(/[^0-9-]/g, "");
    }

    // # Normalise une regle metier dans un format toujours complet.
    function normalizeRule(rule, position) {
        const ruleParams = rule && typeof rule.parametres === "object" && rule.parametres !== null
            ? rule.parametres
            : {};

        return {
            id: rule && rule.id ? rule.id : null,
            position: rule && rule.position !== undefined && rule.position !== null ? Number(rule.position) : position,
            operateur: rule && rule.operateur ? rule.operateur : ">",
            valeur: rule && rule.valeur !== undefined && rule.valeur !== null ? String(rule.valeur) : "",
            parametres: {
                icone: ruleParams.icone || "",
                affichage_valeur: ruleParams.affichage_valeur || "oui",
                status: ruleParams.status || "status-info",
                valeur_substitue: ruleParams.valeur_substitue !== undefined && ruleParams.valeur_substitue !== null
                    ? String(ruleParams.valeur_substitue)
                    : ""
            }
        };
    }

    // # Normalise toute une liste de regles.
    function normalizeRules(rules) {
        if (!Array.isArray(rules)) {
            return [];
        }

        return rules.map(function (rule, index) {
            return normalizeRule(rule, index);
        });
    }

    // # Convertit les regles en lignes compatibles DataTable.
    function mapRulesToRows(rules) {
        return normalizeRules(rules).map(function (rule, index) {
            return $.extend(true, {}, rule, {
                position: rule.position !== undefined && rule.position !== null ? Number(rule.position) : index,
                DT_RowId: "DT_RowId_" + (rule.id || (Date.now() + "_" + index))
            });
        });
    }

    // # Construit les colonnes DataTable a partir de la config ou des donnees.
    function buildDatatableColumnsFromConfig(field, rows) {
        const configuredColumns = Array.isArray(field.columns) ? field.columns : [];

        if (configuredColumns.length > 0) {
            return configuredColumns.map(function (column) {
                return $.extend({}, column, {
                    title: resolveUiText(column, "title", column.title || "")
                });
            });
        }

        const firstRow = Array.isArray(rows) && rows.length ? rows[0] : null;
        if (!firstRow || typeof firstRow !== "object") {
            return [
                { title: "Id", data: "id", defaultContent: "" },
                { title: "Nom", data: "nom", defaultContent: "" }
            ];
        }

        return Object.keys(firstRow).map(function (key) {
            return {
                title: key,
                data: key,
                defaultContent: ""
            };
        });
    }

    // # Verifie qu'une valeur est un objet simple.
    function isPlainObject(value) {
        if (!value || Object.prototype.toString.call(value) !== "[object Object]") {
            return false;
        }

        const prototype = Object.getPrototypeOf(value);
        return prototype === Object.prototype || prototype === null;
    }

    // # Fusionne deux objets imbriques sans perdre la structure existante.
    function mergeObjects(target, source) {
        const output = isPlainObject(target) ? $.extend(true, {}, target) : {};

        Object.keys(source || {}).forEach(function (key) {
            const sourceValue = source[key];
            const targetValue = output[key];

            if (isPlainObject(sourceValue) && isPlainObject(targetValue)) {
                output[key] = mergeObjects(targetValue, sourceValue);
                return;
            }

            if (isPlainObject(sourceValue)) {
                output[key] = mergeObjects({}, sourceValue);
                return;
            }

            output[key] = sourceValue;
        });

        return output;
    }

    
    // # Extrait une liste de donnees depuis la reponse d'une requete Ajax.
    function extractResponsePayload(response, ajaxConfig) {
        // Determine le chemin de la reponse contenant les donnees a extraire.
        const config = ajaxConfig || {};
        const responsePath = config.responsePath || config.responseDataKey || "data";
        const pathKeys = String(responsePath).split(".");
        let payload = response;

        // Parcourt le chemin (ex: "response.data.items") jusqu'aux donnees.
        for (let index = 0; index < pathKeys.length; index++) {
            if (payload === null || payload === undefined) {
                return [];
            }

            payload = payload[pathKeys[index]];
        }

        // Si les donnees sont deja une liste, on la retourne telle quelle.
        if (Array.isArray(payload)) {
            return payload;
        }

        // Si les donnees sont un objet cle/valeur, on le convertit en liste d'objets.
        if (payload && typeof payload === "object") {
            return Object.keys(payload).map(function (key) {
                return {
                    id: key,
                    nom: payload[key]
                };
            });
        }

        // Aucun format exploitable trouve.
        return [];
    }

    // # Ajoute recursivement une valeur dans un FormData.
    function appendFormData(formData, value, key) {
        if (value === undefined) {
            return;
        }

        if (value === null) {
            formData.append(key, "");
            return;
        }

        if (value instanceof File) {
            formData.append(key, value);
            return;
        }

        if (Array.isArray(value)) {
            value.forEach(function (item, index) {
                appendFormData(formData, item, key + "[" + index + "]");
            });
            return;
        }

        if (typeof value === "object") {
            Object.keys(value).forEach(function (propertyName) {
                appendFormData(formData, value[propertyName], key ? key + "[" + propertyName + "]" : propertyName);
            });
            return;
        }

        formData.append(key, value);
    }

    // # Convertit un objet JS classique en FormData.
    function objectToFormData(payload) {
        const formData = new FormData();

        Object.keys(payload || {}).forEach(function (propertyName) {
            appendFormData(formData, payload[propertyName], propertyName);
        });

        return formData;
    }

    // # Detecte si une structure contient au moins un fichier.
    function containsFile(value) {
        if (value instanceof File) {
            return true;
        }

        if (Array.isArray(value)) {
            return value.some(function (item) {
                return containsFile(item);
            });
        }

        if (value && typeof value === "object") {
            return Object.keys(value).some(function (propertyName) {
                return containsFile(value[propertyName]);
            });
        }

        return false;
    }

    $.extend(G.ui.GVIndicatorEditionV3Components, {
        getByPath: getByPath,
        setByPath: setByPath,
        registerFieldValidation: registerFieldValidation,
        resolveUiText: resolveUiText,
        buildOption: buildOption,
        resolveTemplate: resolveTemplate,
        destroySelect2: destroySelect2,
        destroyThirdPartyInstance: destroyThirdPartyInstance,
        resolveOptionLabel: resolveOptionLabel,
        getStatusColor: getStatusColor,
        getStatusColorClass: getStatusColorClass,
        getPaletteColorClass: getPaletteColorClass,
        normalizeRule: normalizeRule,
        normalizeRules: normalizeRules,
        mapRulesToRows: mapRulesToRows,
        buildDatatableColumnsFromConfig: buildDatatableColumnsFromConfig
    });

    $.extend(G.ui.GVIndicatorEditionV3Utils, {
        mergeObjects: mergeObjects,
        extractResponsePayload: extractResponsePayload,
        objectToFormData: objectToFormData,
        containsFile: containsFile
    });
})();

if (!window.G) {
    window.G = {};
}

G.ui = G.ui || {};

(function () {
    // Affiche le nom et le type de l'indicateur au-dessus du fil d'Ariane.
    function buildWizardRailIndicatorMeta(popup, wizardRail) {
        const meta = popup.__gvWizardIndicatorMeta || {};
        const indicatorMeta = document.createElement("div");
        const indicatorName = document.createElement("div");
        const indicatorType = document.createElement("div");

        indicatorMeta.className = "gv-swal-wizard__indicator-meta";
        indicatorName.className = "gv-swal-wizard__indicator-name";
        indicatorType.className = "gv-swal-wizard__indicator-type";
        indicatorName.textContent = meta.name || "";
        indicatorType.textContent = (meta.indicatorTypeLabel ? meta.indicatorTypeLabel + " : " : "") + (meta.type || "");

        indicatorMeta.appendChild(indicatorName);
        indicatorMeta.appendChild(indicatorType);

        if (meta.documentationPageId) {
            const documentationLink = document.createElement("a");
            documentationLink.className = "gv-swal-wizard__indicator-documentation gv-tip";
            documentationLink.href = G.config.SERVER + "documentation/documentation/page/" + meta.documentationPageId;
            documentationLink.target = "_blank";
            documentationLink.rel = "noopener noreferrer";
            documentationLink.title = meta.documentationTitle || "";
            documentationLink.setAttribute("aria-label", meta.documentationTitle || "");
            documentationLink.innerHTML = '<i class="fal fa-question-circle"></i>';
            indicatorType.appendChild(documentationLink);
        }

        wizardRail.appendChild(indicatorMeta);
        G.ui.tippedInit($(indicatorMeta));
    }

    // Ajoute une aide clavier discrete a droite des boutons d'action.
    function buildWizardKeyboardHelp(popup, actions) {
        if (!actions || !popup.__gvWizardShortcutsHint || actions.querySelector(".gv-swal-wizard__keyboard-help")) {
            return;
        }

        const keyboardHelp = document.createElement("span");
        keyboardHelp.className = "gv-swal-wizard__keyboard-help gv-tip";
        keyboardHelp.title = popup.__gvWizardShortcutsHint;
        keyboardHelp.setAttribute("aria-label", popup.__gvWizardShortcutsHint);
        // Tipped affiche du HTML et ignore les retours a la ligne d'un texte simple.
        keyboardHelp.setAttribute("data-tippedtitle", popup.__gvWizardShortcutsHint.replace(/\n/g, "<br>"));
        keyboardHelp.setAttribute("data-tippedpos", "top");
        keyboardHelp.innerHTML = '<i class="fal fa-keyboard"></i>';
        actions.appendChild(keyboardHelp);
        G.ui.tippedInit($(keyboardHelp));
    }

    // Construit la colonne gauche verticale du wizard a partir des metadonnees de step.
    function buildWizardRailNavigation(popup, wizardRail) {
        const sidebarItems = Array.isArray(popup.__gvWizardSidebarItems) ? popup.__gvWizardSidebarItems : [];
        const currentStepIndex = Number.isInteger(popup.__gvWizardCurrentStepIndex) ? popup.__gvWizardCurrentStepIndex : 0;
        const railNavigation = document.createElement("div");
        railNavigation.className = "gv-swal-wizard__nav";

        sidebarItems.forEach(function (item, index) {
            const railItem = document.createElement("div");
            const railBullet = document.createElement("div");
            const railText = document.createElement("div");
            const railTitle = document.createElement("div");

            railItem.className = "gv-swal-wizard__nav-item";
            railBullet.className = "gv-swal-wizard__nav-bullet";
            railText.className = "gv-swal-wizard__nav-text";
            railTitle.className = "gv-swal-wizard__nav-title";

            if (index < currentStepIndex) {
                railItem.classList.add("gv-swal-wizard__nav-item--done");
                railBullet.innerHTML = '<i class="fal fa-check"></i>';
            } else {
                railBullet.textContent = String(index + 1);
            }

            if (index === currentStepIndex) {
                railItem.classList.add("gv-swal-wizard__nav-item--current");
            }

            railTitle.textContent = item && item.title ? item.title : "";

            railText.appendChild(railTitle);
            railItem.appendChild(railBullet);
            railItem.appendChild(railText);
            railNavigation.appendChild(railItem);
        });

        wizardRail.appendChild(railNavigation);
    }

    // Deplace le contenu standard de SweetAlert dans la zone centrale du wizard.
    function moveSwalContentIntoCenter(popup, centerContent) {
        [
            ".swal2-icon",
            ".swal2-image",
            ".swal2-html-container",
            ".swal2-input",
            ".swal2-file",
            ".swal2-textarea",
            ".swal2-select",
            ".swal2-radio",
            ".swal2-checkbox",
            ".swal2-validation-message"
        ].forEach(function (selector) {
            const node = popup.querySelector(selector);
            if (node && node.parentElement !== centerContent) {
                centerContent.appendChild(node);
            }
        });
    }

    // Retire la croix native du cycle de tabulation pour laisser la navigation clavier au wizard.
    function removeCloseButtonFromTabOrder(popup) {
        const closeButton = popup.querySelector(".swal2-close");

        if (!closeButton) {
            return;
        }

        closeButton.setAttribute("tabindex", "-1");
    }

    // Recompose la popup en structure header + rail gauche + contenu central.
    G.ui.applyIndicatorPopupLayout = function () {
        const popup = Swal.getPopup();
        if (!popup) {
            return;
        }

        const actions = popup.querySelector(".swal2-actions");
        const title = popup.querySelector(".swal2-title");
        const existingBody = popup.querySelector(".gv-swal-wizard__body");

        // La popup porte le bloc BEM auquel appartiennent tous les elements du wizard.
        popup.classList.add("gv-swal-wizard");

        // Une fois la structure posee, seule la navigation laterale change entre les steps.
        if (existingBody) {
            const existingRail = existingBody.querySelector(".gv-swal-wizard__rail");
            while (existingRail.firstChild) {
                existingRail.firstChild.remove();
            }
            buildWizardRailIndicatorMeta(popup, existingRail);
            buildWizardRailNavigation(popup, existingRail);
            removeCloseButtonFromTabOrder(popup);
            buildWizardKeyboardHelp(popup, actions);
            return;
        }

        const wizardHeader = document.createElement("div");
        wizardHeader.className = "gv-swal-wizard__header";
        const wizardBody = document.createElement("div");
        wizardBody.className = "gv-swal-wizard__body";
        const wizardRail = document.createElement("div");
        wizardRail.className = "gv-swal-wizard__rail";
        const centerContent = document.createElement("div");
        centerContent.className = "gv-swal-wizard__content";

        removeCloseButtonFromTabOrder(popup);

        if (title) {
            wizardHeader.appendChild(title);
        }

        buildWizardRailIndicatorMeta(popup, wizardRail);
        buildWizardRailNavigation(popup, wizardRail);
        moveSwalContentIntoCenter(popup, centerContent);

        wizardBody.appendChild(wizardRail);
        wizardBody.appendChild(centerContent);
        popup.insertBefore(wizardHeader, actions || null);
        popup.insertBefore(wizardBody, actions || null);
        buildWizardKeyboardHelp(popup, actions);
    };

    // Retire le cadre du wizard tout en conservant les noeuds natifs pour afficher le feedback dans la meme Swal.
    G.ui.removeIndicatorWizardLayout = function () {
        const popup = Swal.getPopup();
        if (!popup) {
            return;
        }

        const actions = popup.querySelector(".swal2-actions");
        const wizardHeader = popup.querySelector(".gv-swal-wizard__header");
        const wizardBody = popup.querySelector(".gv-swal-wizard__body");
        const centerContent = popup.querySelector(".gv-swal-wizard__content");
        const title = wizardHeader.querySelector(".swal2-title");
        const keyboardHelp = actions.querySelector(".gv-swal-wizard__keyboard-help");

        popup.insertBefore(title, actions);

        while (centerContent.firstChild) {
            popup.insertBefore(centerContent.firstChild, actions);
        }

        if (keyboardHelp) {
            keyboardHelp.remove();
        }
        wizardHeader.remove();
        wizardBody.remove();
        popup.classList.remove("gv-swal-wizard");
        popup.classList.remove("gv-swal-popup--indicator-wizard");
    };

    // Retire la croix de la popup finale du cycle de tabulation.
    G.ui.prepareIndicatorFeedbackPopup = function () {
        const popup = Swal.getPopup();
        if (!popup) {
            return;
        }

        removeCloseButtonFromTabOrder(popup);
    };
})();

if (!window.G) {
    window.G = {};
}

G.ui = G.ui || {};

(function () {
    function getSwalClasses() {
        return {
            popup: "gv-swal-popup gv-swal-popup--indicator-layout",
            closeButton: "uicomp__button uicomp--transparent",
            input: "uicomp__input",
            inputLabel: "uicomp__label",
            confirmButton: "uicomp__button uicomp--brand",
            denyButton: "uicomp__button uicomp--grey",
            cancelButton: "uicomp__button uicomp--red"
        };
    }

    function getFormStepSwalClasses() {
        return $.extend({}, getSwalClasses(), {
            popup: "gv-swal-popup gv-swal-popup--indicator-layout gv-swal-popup--indicator-wizard",
            denyButton: "uicomp__button uicomp--red"
        });
    }

    function getFeedbackSwalClasses(extraPopupClass) {
        return $.extend({}, getSwalClasses(), {
            popup: "gv-swal-popup gv-swal-popup--indicator-layout gv-swal-popup--indicator-feedback" + (extraPopupClass ? " " + extraPopupClass : "")
        });
    }

    G.ui.GVIndicatorEditionV3PopupConfig = {
        getFormStepPopupConfig: function (options) {
            const ui = (options && options.ui) || {};
            const popupOptions = options || {};

            return {
                animation: false,
                focusConfirm: false,
                focusDeny: false,
                focusCancel: false,
                position: "center",
                width: G.ui.SWAL_FIXED_WIDTH,
                heightAuto: false,
                title: popupOptions.title || "",
                html: popupOptions.html,
                showCloseButton: true,
                showCancelButton: false,
                showDenyButton: true,
                showConfirmButton: true,
                reverseButtons: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                confirmButtonText: popupOptions.confirmButtonText || ui.next,
                denyButtonText: popupOptions.denyButtonText || ui.previous,
                customClass: getFormStepSwalClasses(),
                willOpen: function () {
                    G.ui.applyIndicatorPopupLayout();
                }
            };
        },

        getSavingPopupConfig: function (ui) {
            ui = ui || {};
            return {
                position: "center",
                width: G.ui.SWAL_FIXED_WIDTH,
                heightAuto: false,
                title: ui.editTitle || "",
                html: "",
                text: "",
                footer: "",
                showCloseButton: false,
                showConfirmButton: false,
                showDenyButton: false,
                showCancelButton: false,
                allowOutsideClick: false,
                customClass: getFeedbackSwalClasses("gv-swal-popup--loading")
            };
        },

        getSuccessPopupConfig: function (siteId, ui) {
            ui = ui || {};
            return {
                position: "center",
                width: G.ui.SWAL_FIXED_WIDTH,
                heightAuto: false,
                title: ui.editTitle,
                focusConfirm: true,
                text: ui.updatedText,
                icon: "success",
                footer: '<div class="text-flow"><a href="' + G.config.SERVER + "frontend/dashboard/gv#dashboard/site-" + siteId + '" class="fake-link"><strong>' + ui.goToDashboard + ' <i class="fal fa-external-link"></i></strong></a></div>',
                showCloseButton: true,
                showConfirmButton: true,
                showCancelButton: false,
                confirmButtonText: "OK",
                customClass: getFeedbackSwalClasses()
            };
        },

        getErrorPopupConfig: function (message, ui) {
            ui = ui || {};
            return {
                position: "center",
                width: G.ui.SWAL_FIXED_WIDTH,
                heightAuto: false,
                focusConfirm: true,
                icon: "error",
                title: ui.error,
                text: message,
                showCloseButton: true,
                showConfirmButton: true,
                showCancelButton: false,
                confirmButtonText: "OK",
                customClass: getFeedbackSwalClasses(),
                didOpen: function () {
                    G.ui.prepareIndicatorFeedbackPopup();
                }
            };
        }
    };
})();

/*
# TEXT-LIKE COMPONENT
# TYPE JSON: "text", "number", "textarea"
# RENDU: champ simple de type input texte, input numerique ou textarea.
# SELECTION DU COMPOSANT: le builder route ici quand `field.type` vaut "text", "number" ou "textarea".
# ROLE: sert aux champs libres classiques des popups d'edition.
# OPTIONS UTILES: `inputType`, `attributes`, `label`, `labelKey`, `helper`, `helperKey`, `columnClass`, `fullWidth`.
*/

if (!window.G) {
    window.G = {};
}

G.ui = G.ui || {};
G.ui.GVIndicatorEditionV3Components = G.ui.GVIndicatorEditionV3Components || {};

(function () {
    const components = G.ui.GVIndicatorEditionV3Components;

    // Construit un champ texte, numerique ou textarea avec son pre-remplissage et ses evenements.
    function createTextLikeField(field, fieldId, currentValue, state, onChange) {
        const input = buildTextLikeInput(field, fieldId);
        applyTextLikeAttributes(input, field);
        applyTextLikeInitialValue(input, currentValue);
        bindTextLikeEvents(input, field, state, onChange);
        return input;
    }

    // Cree l'input ou textarea puis lui pose ses attributs communs de formulaire.
    function buildTextLikeInput(field, fieldId) {
        const input = field.type === "textarea"
            ? $('<textarea class="uicomp__input gv-indicator-textarea"></textarea>')
            : $('<input type="' + getTextLikeInputType(field) + '" class="uicomp__input" />');

        input.attr("id", fieldId);
        input.attr("name", field.name);

        if (field.readOnly === true) {
            input.prop("readonly", true);
        }

        return input;
    }

    // Recopie les attributs HTML natifs declares dans le JSON.
    function applyTextLikeAttributes(input, field) {
        if (!field.attributes || typeof field.attributes !== "object") {
            return;
        }

        Object.keys(field.attributes).forEach(function (attributeName) {
            input.attr(attributeName, field.attributes[attributeName]);
        });
    }

    // Rejoue simplement la valeur par defaut si le backend en a fourni une.
    function applyTextLikeInitialValue(input, currentValue) {
        if (currentValue !== null && currentValue !== undefined) {
            input.val(currentValue);
        }
    }

    // Branche la synchro entre la saisie visible, le state du builder et les dependances eventuelles.
    function bindTextLikeEvents(input, field, state, onChange) {
        input.on("input change", function (event) {
            const value = $(this).val();
            const shouldValidateOnChange = shouldValidateTextLikeChange(field, event.type);

            // Le state du builder reste la source de verite; le DOM ne sert qu'a l'edition visuelle.
            const validatedValue = components.setByPath(state, field.name, value, {
                validate: shouldValidateOnChange
            });

            // Sur les champs numeriques, on laisse vivre la saisie intermediaire pendant `input`
            // (ex: "-", "-2.", "0.") puis on resynchronise le DOM sur `change`.
            if (shouldValidateOnChange && shouldSyncValidatedValueBackToDom(field, event.type)) {
                $(this).val(validatedValue === undefined || validatedValue === null ? "" : validatedValue);
            }

            onChange(value);
        });
    }

    // Retourne le vrai type HTML a utiliser pour l'input quand on n'est pas sur un textarea.
    function getTextLikeInputType(field) {
        return field.inputType || field.type;
    }

    // Evite de casser une saisie numerique intermediaire tant que l'utilisateur n'a pas quitte le champ.
    function shouldSyncValidatedValueBackToDom(field, eventType) {
        const inputType = getTextLikeInputType(field);

        if (inputType === "number" && eventType === "input") {
            return false;
        }

        return true;
    }

    // Active la validation immediate seulement sur les champs qui l'ont explicitement demandee.
    function shouldValidateTextLikeChange(field, eventType) {
        if (field.validateOnChange !== true) {
            return false;
        }

        return shouldSyncValidatedValueBackToDom(field, eventType);
    }

    components.createTextLikeField = createTextLikeField;
})();

/*
# CHECKBOX COMPONENT
# TYPE JSON: "checkbox"
# RENDU: case a cocher avec habillage graphique GlobalVisio.
# ROLE: sert aux booleens simples.
# OPTIONS UTILES: `label`, `helper`, `columnClass`, `card`.
*/

if (!window.G) {
    window.G = {};
}

G.ui = G.ui || {};
G.ui.GVIndicatorEditionV3Components = G.ui.GVIndicatorEditionV3Components || {};

(function () {
    const components = G.ui.GVIndicatorEditionV3Components;

    // Construit une checkbox simple avec son rendu standard ou card.
    function createCheckboxField(field, fieldId, currentValue, state, onChange) {
        const wrapper = buildCheckboxWrapper(field, fieldId);
        const input = buildCheckboxInput(field, fieldId, currentValue);
        initializeCheckboxState(field, state, currentValue);
        appendCheckboxContent(wrapper, input, field);
        bindCheckboxEvents(input, field, state, onChange);
        return wrapper;
    }

    // Cree le conteneur racine qui regroupe l'input et son rendu visuel.
    function buildCheckboxWrapper(field, fieldId) {
        return $('<label class="gv-ui-ckeckbox"></label>')
            .attr("for", fieldId)
            .toggleClass("gv-ui-ckeckbox--card", !!field.card);
    }

    // Cree l'input checkbox et rejoue la valeur initiale venue du backend.
    function buildCheckboxInput(field, fieldId, currentValue) {
        return $('<input type="checkbox" />')
            .attr("id", fieldId)
            .attr("name", field.name)
            .val("1")
            .prop("checked", !!Number(currentValue || 0));
    }

    // Ecrit des le montage la valeur 0/1 dans le state pour que visibleWhen voie le bon etat initial.
    function initializeCheckboxState(field, state, currentValue) {
        components.setByPath(state, field.name, !!Number(currentValue || 0) ? 1 : 0);
    }

    // Monte le markup visuel standard ou card autour de la checkbox.
    function appendCheckboxContent(wrapper, input, field) {
        const label = $('<span class="value-map"></span>').html(components.resolveUiText(field, "label", field.name));

        wrapper.append(input).append($('<div class="gv-ui__mock"></div>'));

        if (!field.card) {
            wrapper.append(label);
            return;
        }

        // En mode card, le libelle et l'aide sont affiches dans un meme bloc.
        const cardContent = $('<div class="gvg-r mod--valign-top"></div>');
        label.addClass("gvg-6on6");
        cardContent.append(label);

        if (field.helper) {
            cardContent.append($('<span class="uicomp__text_help gvg-6on6"></span>').html(field.helper));
        }

        wrapper.append(cardContent);
    }

    // Synchronise la checkbox vers le state en conservant une valeur 1 ou 0.
    function bindCheckboxEvents(input, field, state, onChange) {
        // Quand la valeur change on redéfinie la valeur du state
        input.on("change", function () {
            const value = $(this).is(":checked") ? 1 : 0;
            components.setByPath(state, field.name, value);
            onChange(value);
        });
    }

    components.createCheckboxField = createCheckboxField;
})();

/*
# RADIO GROUP COMPONENT
# TYPE JSON: "radio_group"
# RENDU: groupe de boutons radio avec habillage graphique GlobalVisio.
# ROLE: sert aux choix exclusifs sans rendu en cartes.
# OPTIONS UTILES: `options`, `defaultValue`, `label`, `helper`, `columnClass`.
*/

if (!window.G) {
    window.G = {};
}

G.ui = G.ui || {};
G.ui.GVIndicatorEditionV3Components = G.ui.GVIndicatorEditionV3Components || {};

(function () {
    const components = G.ui.GVIndicatorEditionV3Components;

    // Construit un groupe radio horizontal avec ses options et sa valeur active.
    function createRadioGroupField(field, fieldId, currentValue, state, onChange) {
        const container = $('<div class="uicomp__hflow"></div>');
        const options = Array.isArray(field.options) ? field.options : [];
        const selectedValue = resolveRadioGroupSelectedValue(field, currentValue, state);

        options.forEach(function (option, index) {
            container.append(buildRadioGroupOption(field, fieldId, option, index, selectedValue, state, onChange));
        });

        return container;
    }

    // Rejoue la valeur actuelle ou applique la valeur par defaut si le champ n'en a pas encore.
    function resolveRadioGroupSelectedValue(field, currentValue, state) {
        if ((currentValue === null || currentValue === undefined || currentValue === "") && field.defaultValue !== undefined) {
            components.setByPath(state, field.name, field.defaultValue);
            return field.defaultValue;
        }

        return currentValue;
    }

    // Construit une option radio complete avec son input, son habillage et son libelle.
    function buildRadioGroupOption(field, fieldId, option, index, selectedValue, state, onChange) {
        const optionId = fieldId + "-option-" + index;
        const label = $('<label class="gv-ui-ckeckbox"></label>').attr("for", optionId);
        const input = buildRadioGroupInput(field, option, optionId, selectedValue);

        label.append(input)
            .append($('<div class="gv-ui__mock"></div>'))
            .append($('<span class="value-map"></span>').html(components.resolveOptionLabel(option, field)));
        bindRadioGroupEvents(input, field, option, state, onChange);
        return label;
    }

    // Cree un input radio unique et le coche si c'est l'option actuellement active.
    function buildRadioGroupInput(field, option, optionId, selectedValue) {
        return $('<input type="radio" />')
            .attr("id", optionId)
            .attr("name", field.name)
            .val(option.value)
            .prop("checked", String(option.value) === String(selectedValue));
    }

    // Remonte la nouvelle valeur vers le state quand un radio devient actif.
    function bindRadioGroupEvents(input, field, option, state, onChange) {
        input.on("change", function () {
            if (!this.checked) {
                return;
            }

            components.setByPath(state, field.name, option.value);
            onChange(option.value);
        });
    }

    components.createRadioGroupField = createRadioGroupField;
})();

/*
# CHOICE CARDS COMPONENT
# TYPE JSON: "choice_cards"
# RENDU: cartes cliquables GlobalVisio basees sur checkbox ou radio.
# SELECTION DU COMPOSANT: le builder route ici quand `field.type` vaut "choice_cards".
# ROLE: sert aux choix visuels du type source image, nombre de points, options exclusives ou multiples.
# OPTIONS UTILES: `options`, `multiple`, `defaultValue`, `optionColumnClass`, `columnClass`.
# FORMAT DES OPTIONS: `value`, `label`, `labelKey`, `description`, `descriptionKey`, `columnClass`.
*/

if (!window.G) {
    window.G = {};
}

G.ui = G.ui || {};
G.ui.GVIndicatorEditionV3Components = G.ui.GVIndicatorEditionV3Components || {};

(function () {
    const components = G.ui.GVIndicatorEditionV3Components;

    // Construit une grille de cartes cliquables basees sur checkbox ou radio.
    function createChoiceCardsField(field, fieldId, currentValue, state, onChange) {
        const context = createChoiceCardsContext(field, fieldId, currentValue, state, onChange);
        buildChoiceCardsLayout(context);
        bindChoiceCardsEvents(context);
        finalizeChoiceCardsInitialization(context);
        return buildChoiceCardsPublicApi(context);
    }

    // Prepare les donnees partagees par les briques du composant.
    function createChoiceCardsContext(field, fieldId, currentValue, state, onChange) {
        return {
            field: field,
            fieldId: fieldId,
            state: state,
            onChange: onChange,
            options: Array.isArray(field.options) ? field.options : [],
            initialValue: resolveInitialChoiceCardsValue(field, currentValue),
            layout: createChoiceCardsLayout()
        };
    }

    // Monte toutes les cartes dans le conteneur racine.
    function buildChoiceCardsLayout(context) {
        context.options.forEach(function (option, index) {
            context.layout.container.append(buildChoiceCard(context, option, index));
        });
    }

    // Branche les changements utilisateur une seule fois sur tous les inputs du composant.
    function bindChoiceCardsEvents(context) {
        context.layout.container.find("input").on("change", function () {
            handleChoiceCardsChange(context, this);
        });
    }

    // Pousse l'etat initial dans le state pour que le payload colle au rendu visible des l'ouverture.
    function finalizeChoiceCardsInitialization(context) {
        syncChoiceCardsState(context, context.initialValue);
    }

    // Expose l'API minimale attendue par le builder.
    function buildChoiceCardsPublicApi(context) {
        return {
            element: context.layout.container,
            inputs: context.layout.container.find("input"),
            getValue: function () {
                return components.getByPath(context.state, context.field.name);
            }
        };
    }

    // ---- CONSTRUCTION DOM ----

    // Cree simplement le conteneur racine des cartes.
    function createChoiceCardsLayout() {
        return {
            container: $('<div class="gvg-r gvg-r--gutter gv-indicator-choice-cards"></div>')
        };
    }

    // Construit une carte complete avec sa colonne, son input et son contenu texte.
    function buildChoiceCard(context, option, index) {
        const optionId = buildChoiceCardOptionId(context.fieldId, index);
        const card = $('<div></div>').addClass(resolveChoiceCardColumnClass(context.field, option, context.options.length));
        const label = $('<label class="gv-ui-ckeckbox gv-ui-ckeckbox--card"></label>').attr("for", optionId);

        label
            .append(buildChoiceCardInput(context, option, optionId))
            .append($('<div class="gv-ui__mock"></div>'))
            .append(buildChoiceCardContent(option));
        card.append(label);

        return card;
    }

    // Cree l'input checkbox ou radio de la carte selon le mode simple ou multiple.
    function buildChoiceCardInput(context, option, optionId) {
        const input = $('<input />')
            .attr("id", optionId)
            .attr("name", resolveChoiceCardInputName(context.field))
            .attr("type", context.field.multiple ? "checkbox" : "radio")
            .attr("value", option.value);

        applyChoiceCardCheckedState(input, context, option);
        return input;
    }

    // Coche ou non l'input selon la valeur initiale pre-remplie.
    function applyChoiceCardCheckedState(input, context, option) {
        if (context.field.multiple) {
            input.prop("checked", context.initialValue.indexOf(String(option.value)) !== -1);
            return;
        }

        input.prop(
            "checked",
            context.initialValue !== null && String(option.value) === String(context.initialValue)
        );
    }

    // Monte le bloc texte visible dans la carte avec son label et sa description eventuelle.
    function buildChoiceCardContent(option) {
        const content = $('<div class="gvg-r mod--valign-top"></div>');
        const valueMap = $('<span class="value-map gvg-6on6"></span>').text(components.resolveUiText(option, "label", option.value));
        const description = components.resolveUiText(option, "description", "");

        content.append(valueMap);

        if (description) {
            content.append($('<span class="uicomp__text_help gvg-6on6"></span>').text(description));
        }

        return content;
    }

    // ---- EVENEMENTS / STATE ----

    // Relit la selection visible puis la pousse dans le state metier.
    function handleChoiceCardsChange(context, inputElement) {
        const input = $(inputElement);

        if (context.field.multiple) {
            syncChoiceCardsState(context, readChoiceCardsMultipleValue(context));
            return;
        }

        if (!input.is(":checked")) {
            return;
        }

        syncChoiceCardsState(context, input.val());
    }

    // Ecrit la valeur finale dans le state puis notifie le builder si besoin.
    function syncChoiceCardsState(context, value) {
        components.setByPath(context.state, context.field.name, value);
        context.onChange(value);
    }

    // ---- UTILITAIRES ----

    // Rejoue la valeur backend existante ou la valeur par defaut du champ avant le premier rendu.
    function resolveInitialChoiceCardsValue(field, currentValue) {
        if (field.multiple) {
            return normalizeCurrentValues(field, currentValue);
        }

        if (currentValue !== null && currentValue !== undefined && currentValue !== "") {
            return currentValue;
        }

        return field.defaultValue !== undefined ? field.defaultValue : null;
    }

    // Normalise la valeur courante en string ou tableau de string
    function normalizeCurrentValues(field, currentValue) {
        if (field.multiple) {
            return Array.isArray(currentValue) ? currentValue.map(String) : [];
        }

        return currentValue === null || currentValue === undefined ? null : String(currentValue);
    }

    // Relit les cartes cochees pour reconstruire la liste multiple complete.
    function readChoiceCardsMultipleValue(context) {
        return context.layout.container.find('input[type="checkbox"]:checked').map(function () {
            return $(this).val();
        }).get();
    }

    // Construit l'id DOM stable d'une carte a partir de son index.
    function buildChoiceCardOptionId(fieldId, index) {
        return fieldId + "-option-" + index;
    }

    // Retourne le nom HTML du champ selon qu'il accepte une ou plusieurs valeurs.
    function resolveChoiceCardInputName(field) {
        return field.multiple ? field.name + "[]" : field.name;
    }

    // Calcule la largeur par defaut d'une carte quand la config JSON n'en impose pas une.
    function resolveChoiceCardColumnClass(field, option, optionsCount) {
        const defaultColumnClass = optionsCount <= 4
            ? (optionsCount === 1 ? "gvg-6on6" : "gvg-6on6 gvg-" + Math.floor(12 / optionsCount) + "--narrow")
            : "gvg-6on6 gvg-3--narrow";

        return option.columnClass || field.optionColumnClass || defaultColumnClass;
    }

    components.createChoiceCardsField = createChoiceCardsField;
})();

/*
# SELECT COMPONENT
# TYPE JSON: "select"
# RENDU: select Select2 pleine largeur avec options statiques ou dynamiques.
# SELECTION DU COMPOSANT: le builder route ici quand `field.type` vaut "select".
# ROLE: sert aux listes deroulantes standards des popups d'edition.
# OPTIONS UTILES: `options`, `ajax`, `allowEmpty`, `emptyOptionLabel`, `emptyOptionLabelKey`, `optionLabelTemplate`, `reloadOptionsFor`.
*/

if (!window.G) {
    window.G = {};
}

G.ui = G.ui || {};
G.ui.GVIndicatorEditionV3Components = G.ui.GVIndicatorEditionV3Components || {};

(function () {
    const components = G.ui.GVIndicatorEditionV3Components;

    function createSelectField(field, fieldId, currentValue, state, onChange, helpers) {
        const select = buildSelectInput(field, fieldId);
        applySelectEmptyOption(select, field);
        bindSelectEvents(select, field, state, onChange);

        const componentApi = {
            element: select,
            populate: function (options) {
                populateSelectOptions(select, field, state, options);
                refreshSelectWidget(select);
            },
            destroy: function () {
                components.destroySelect2(select);
                select.off();
            }
        };

        componentApi.ready = Promise.resolve().then(function () {
            if (Array.isArray(field.options)) {
                componentApi.populate(field.options);
                return true;
            }

            if (field.ajax) {
                return helpers.loadFieldOptionsFromConfig(field.ajax || {}, field).then(function (options) {
                    componentApi.populate(options);
                    return true;
                });
            }

            return true;
        });

        return componentApi;
    }

    // Cree le select brut et pose ses attributs de formulaire.
    function buildSelectInput(field, fieldId) {
        const select = $('<select class="select2 select2-full-width"></select>')
            .attr("id", fieldId)
            .attr("name", field.name);

        if (field.readOnly === true) {
            select.prop("disabled", true);
        }

        return select;
    }

    // Ajoute l'option vide seulement quand le champ l'autorise.
    function applySelectEmptyOption(select, field) {
        if (field.allowEmpty) {
            select.append(components.buildOption("", components.resolveUiText(field, "emptyOptionLabel", "")));
        }
    }

    // Remonte chaque changement utilisateur vers le state du builder.
    function bindSelectEvents(select, field, state, onChange) {
        select.on("change", function () {
            const value = $(this).val();
            const normalizedValue = value === "" ? null : value;

            components.setByPath(state, field.name, normalizedValue);
            onChange(normalizedValue);
        });
    }

    // Remplit le select avec ses options puis recale la valeur active dans le state.
    function populateSelectOptions(select, field, state, options) {
        const normalizedOptions = Array.isArray(options) ? options : [];
        const currentStateValue = components.getByPath(state, field.name);

        if (field.allowEmpty) {
            select.find("option").not(":first").remove();
        } else {
            select.empty();
        }

        normalizedOptions.forEach(function (item) {
            select.append(components.buildOption(resolveSelectOptionValue(item), components.resolveOptionLabel(item, field)));
        });

        if (hasSelectCurrentValue(normalizedOptions, currentStateValue)) {
            select.val(String(currentStateValue));
            return;
        }

        if (field.allowEmpty) {
            select.val("");
            components.setByPath(state, field.name, null);
            return;
        }

        if (normalizedOptions.length > 0) {
            const firstOptionValue = resolveSelectOptionValue(normalizedOptions[0]);
            select.val(String(firstOptionValue));
            components.setByPath(state, field.name, firstOptionValue);
            return;
        }

        components.setByPath(state, field.name, null);
    }

    // Redemarre Select2 apres remplacement des options HTML.
    function refreshSelectWidget(select) {
        components.destroySelect2(select);
        G.ui.initSelect2(select.parent());
        select.trigger("change.select2");
    }

    // Retourne la valeur metier d'une option quel que soit son format source.
    function resolveSelectOptionValue(item) {
        return item.id !== undefined ? item.id : item.value;
    }

    // Verifie si la valeur actuellement stockee existe encore dans la nouvelle liste d'options.
    function hasSelectCurrentValue(options, currentStateValue) {
        return currentStateValue !== null
            && currentStateValue !== undefined
            && options.some(function (item) {
                return String(resolveSelectOptionValue(item)) === String(currentStateValue);
            });
    }

    components.createSelectField = createSelectField;
})();

/*
# ICON COMPONENT
# TYPE JSON: "icon"
# RENDU: select d'icones GlobalVisio avec preview a gauche et liste Select2 a droite.
# SELECTION DU COMPOSANT: le builder route ici quand `field.type` vaut "icon".
# ROLE: sert a choisir une icone d'indicateur avec le meme principe visuel que la V2.
# OPTIONS UTILES: `label`, `labelKey`, `innerLabel`, `innerLabelKey`, `helper`, `helperKey`.
*/

if (!window.G) {
    window.G = {};
}

G.ui = G.ui || {};
G.ui.GVIndicatorEditionV3Components = G.ui.GVIndicatorEditionV3Components || {};

(function () {
    const components = G.ui.GVIndicatorEditionV3Components;

    // Construit le composant icone complet avec preview et select Select2.
    function createIconField(field, fieldId, currentValue, state, onChange, helpers) {
        const context = createIconContext(field, fieldId, currentValue, state, onChange, helpers);
        buildIconLayout(context);
        initializeIconSelect(context);
        bindIconEvents(context);
        finalizeIconInitialization(context);
        return buildIconPublicApi(context);
    }

    // Prepare toutes les donnees partagees par les briques du composant.
    function createIconContext(field, fieldId, currentValue, state, onChange, helpers) {
        return {
            field: field,
            fieldId: fieldId,
            currentValue: currentValue,
            state: state,
            onChange: onChange,
            helpers: helpers,
            icons: resolveIconChoices(field),
            layout: createIconLayout(field, fieldId)
        };
    }

    // Monte simplement le DOM du composant.
    function buildIconLayout(context) {
        appendIconInnerLabel(context);
        assembleIconLayout(context);
    }

    // Alimente le select puis active Select2 avec le rendu icone.
    function initializeIconSelect(context) {
        populateIconSelect(context);
        setupIconSelect2(context);
    }

    // Branche le changement de valeur du select.
    function bindIconEvents(context) {
        context.layout.select.on("change", function () {
            applyIconSelection(context, $(this).val() || "void");
        });
    }

    // Applique la valeur initiale et synchronise la preview.
    function finalizeIconInitialization(context) {
        const initialValue = context.currentValue || "void";
        context.layout.select.val(initialValue).trigger("change");
        updateIconPreview(context, initialValue);
    }

    // Retourne l'API attendue par le builder.
    function buildIconPublicApi(context) {
        return {
            container: context.layout.container,
            element: context.layout.select,
            destroy: function () {
                components.destroySelect2(context.layout.select);
                context.layout.select.off();
            }
        };
    }

    // ---- CONSTRUCTION DOM ----

    // Cree la structure DOM de base du composant icone.
    function createIconLayout(field, fieldId) {
        return {
            container: $('<div class="gv-iicon-selector"></div>'),
            preview: $(
                '<div class="gv-iicon-selector__preview">'
                + '    <div class="gv-iicon-selector__preview-icon"></div>'
                + "</div>"
            ),
            selectWrapper: $('<div class="gv-iicon-selector__select"></div>'),
            selectInnerLabel: components.resolveUiText(field, "innerLabel", ""),
            select: $('<select class="select2-gviicon select2-full-width"></select>').attr("id", fieldId).attr("name", field.name)
        };
    }

    // Ajoute le label interne si la config du composant en demande un.
    function appendIconInnerLabel(context) {
        if (!context.layout.selectInnerLabel) {
            return;
        }

        context.layout.selectWrapper.append(
            $('<label class="uicomp__label"></label>')
                .attr("for", context.fieldId)
                .text(context.layout.selectInnerLabel)
        );
    }

    // Assemble la preview a gauche et le select a droite.
    function assembleIconLayout(context) {
        context.layout.selectWrapper.append(context.layout.select);
        context.layout.container.append(context.layout.preview).append(context.layout.selectWrapper);
    }

    // ---- INITIALISATION SELECT ----

    // Injecte toutes les options d'icone disponibles dans le select.
    function populateIconSelect(context) {
        context.layout.select.append(components.buildOption("", ""));
        context.icons.forEach(function (item) {
            context.layout.select.append(components.buildOption(item.id, item.nom));
        });
    }

    // Active Select2 avec un rendu visuel base sur la classe CSS de l'icone.
    function setupIconSelect2(context) {
        context.layout.select.select2({
            width: "100%",
            templateResult: function (selectState) {
                return renderIconOption(selectState);
            },
            language: G.model.lang,
            dropdownCssClass: "select2-dropdown--gv-iicon-selector"
        });
    }

    // Rendu visuel d'une ligne du dropdown Select2.
    function renderIconOption(selectState) {
        if (!selectState.id) {
            return selectState.text;
        }

        // Select2 affiche ici uniquement le pictogramme; le code icone reste accessible via le tooltip/footer.
        return $(
            '<div class="select2-results__option--gv-iicon-selector tooltip--footer" data-module="tooltip" data-title="' + selectState.id + '">'
            + '    <div class="select2-results__option--icon gv-iicon-' + selectState.id + '"></div>'
            + "</div>"
        );
    }

    // ---- METIER ----

    // Applique une icone choisie au state, a la preview et au callback du builder.
    function applyIconSelection(context, value) {
        components.setByPath(context.state, context.field.name, value);
        updateIconPreview(context, value);
        context.onChange(value);
    }

    // Met a jour la preview locale a partir de la classe CSS de l'icone.
    function updateIconPreview(context, icon) {
        context.layout.preview.find(".gv-iicon-selector__preview-icon")
            .removeClass()
            .addClass("gv-iicon-selector__preview-icon gv-iicon-" + (icon || "void"));
    }

    // ---- UTILITAIRES ----

    // Recupere la liste brute des icones d'indicateur autorisees dans les popups d'edition.
    function getAvailableIconOptions() {
        return (G.model.icons || []).filter(function (icon) {
            return icon !== "" && icon.indexOf("header-") !== 0 && icon.indexOf("el-") !== 0;
        }).map(function (icon) {
            return {
                id: icon,
                nom: icon
            };
        });
    }

    // Recupere la liste d'icones du champ ou, par defaut, la source globale GlobalVisio.
    function resolveIconChoices(field) {
        if (field && Array.isArray(field.options)) {
            return field.options.map(function (icon) {
                return typeof icon === "string" ? { id: icon, nom: icon } : icon;
            });
        }

        return getAvailableIconOptions();
    }

    components.createIconField = createIconField;
    components.getAvailableIconOptions = getAvailableIconOptions;
})();

/*
# IMAGE COMPONENT
# TYPE JSON: "image"
# RENDU: preview d'image a gauche et configuration a droite avec cartes de source, select de zone et upload.
# SELECTION DU COMPOSANT: le builder route ici quand `field.type` vaut "image".
# ROLE: sert a reproduire le comportement de selection d'image de la V2.
# OPTIONS UTILES: `sourceOptions`, `sourceTypePath`, `zonePath`, `customPath`, `zoneAjax`, `sitePreviewBasePath`, `zonePreviewBasePath`, `customPreviewBasePath`, `previewTitle`, `configurationTitle`, `zoneLabel`, `customLabel`, `maxSizeKb`.
*/

if (!window.G) {
    window.G = {};
}

G.ui = G.ui || {};
G.ui.GVIndicatorEditionV3Components = G.ui.GVIndicatorEditionV3Components || {};

(function () {
    const components = G.ui.GVIndicatorEditionV3Components;

    // Construit le composant image complet avec preview, choix de source, zone et upload custom.
    function createImageField(field, fieldId, state, helpers) {
        const context = createImageContext(field, fieldId, state, helpers);
        buildImageLayout(context);
        bindImageEvents(context);
        finalizeImageInitialization(context);
        return buildImagePublicApi(context);
    }

    // Prepare toutes les donnees partagees entre les briques du composant.
    function createImageContext(field, fieldId, state, helpers) {
        return {
            field: field,
            fieldId: fieldId,
            state: state,
            helpers: helpers,
            sourceTypePath: field.sourceTypePath || "parametres.img_src_type",
            zonePath: field.zonePath || "parametres.img_src_zone",
            customPath: field.customPath || "parametres.img_src",
            uploadStatePath: field.uploadStatePath || "__uploads.parametres_img_src",
            sourceOptions: Array.isArray(field.sourceOptions) ? field.sourceOptions : [],
            zonePlaceholder: components.resolveUiText(field, "zonePlaceholder", ""),
            zonesCache: null,
            layout: createImageLayout(field, fieldId) // Cree la structure DOM de base
        };
    }

    // Monte toute la structure visuelle du composant.
    function buildImageLayout(context) {
        appendImageSourceCards(context);
        appendImageSpecificControls(context);
        assembleImageLayout(context);
    }

    // Branche tous les evenements utilisateur du composant.
    function bindImageEvents(context) {
        bindImagePreviewEvents(context);
        bindImageSourceEvents(context);
        bindImageZoneEvents(context);
        bindImageUploadEvents(context);
    }

    // Applique le premier etat visible et initialise les widgets secondaires.
    function finalizeImageInitialization(context) {
        initializeImageZoneSelect2(context);
        initializeImageCurrentSource(context);
    }

    // Expose l'API minimale attendue par le builder.
    function buildImagePublicApi(context) {
        return {
            element: context.layout.container,
            inputs: {
                zoneSelect: context.layout.zoneSelect,
                customInput: context.layout.customInput
            },
            destroy: function () {
                destroyImageField(context);
            }
        };
    }

    // ---- CONSTRUCTION DOM ----

    // Cree la structure DOM de base sans encore brancher les comportements.
    function createImageLayout(field, fieldId) {
        const previewHeight = field.previewHeight || 240;
        const container = $('<div class="gv-indicator-image-field"></div>');
        const rootRow = $('<div class="gvg-r gvg-r--gutter"></div>');
        const previewColumn = $('<div class="gvg-3on6--narrow gvg-6on6"></div>');
        const configurationColumn = $('<div class="gvg-3on6--narrow gvg-6on6 gvg-r gvg-r--gutter"></div>');
        const previewHeading = $("<h3></h3>").text(components.resolveUiText(field, "previewTitle", ""));
        const configurationHeading = $("<h3></h3>").text(components.resolveUiText(field, "configurationTitle", ""));
        const preview = $("<img />")
            .attr("id", fieldId + "-preview")
            .attr("alt", components.resolveUiText(field, "previewAlt", ""))
            .attr("style", "min-width: 100%; width: 100%; min-height: " + previewHeight + "px; height: " + previewHeight + "px; padding: 0 5px; background-color: #fff; filter: drop-shadow(0px 0px 4px rgba(0,0,0,0.2))");
        const zoneContainer = $('<div class="gvg-6on6 container-field-img-src-zone"></div>');
        const zoneLabel = $('<label class="uicomp__label"></label>').attr("for", fieldId + "-zone").text(components.resolveUiText(field, "zoneLabel", ""));
        const zoneSelect = $('<select class="select2 select2-full-width"></select>')
            .attr("id", fieldId + "-zone")
            .attr("name", field.zonePath || "parametres.img_src_zone");
        const customContainer = $('<div class="gvg-6on6 container-field-img-src-custom"></div>');
        const customLabel = $('<label class="uicomp__label"></label>').attr("for", fieldId + "-custom").text(components.resolveUiText(field, "customLabel", ""));
        const customInput = $('<input type="file" class="uicomp__input" />')
            .attr("id", fieldId + "-custom")
            .attr("name", field.customPath || "parametres.img_src")
            .attr("accept", field.accept || ".jpg, .jpeg, .png");

        configurationColumn.append(configurationHeading);

        return {
            container: container,
            rootRow: rootRow,
            previewColumn: previewColumn,
            configurationColumn: configurationColumn,
            previewHeading: previewHeading,
            configurationHeading: configurationHeading,
            preview: preview,
            zoneContainer: zoneContainer,
            zoneLabel: zoneLabel,
            zoneSelect: zoneSelect,
            customContainer: customContainer,
            customLabel: customLabel,
            customInput: customInput
        };
    }

    // Cree une carte radio par type de source disponible dans la config JSON.
    function appendImageSourceCards(context) {
        context.sourceOptions.forEach(function (option, index) {
            context.layout.configurationColumn.append(buildImageSourceCard(context, option, index));
        });
    }

    // Construit une carte radio unique pour une source d'image.
    function buildImageSourceCard(context, option, index) {
        const radioId = context.fieldId + "-source-" + index;
        const card = $('<div class="gvg-3on6--narrow gvg-6on6"></div>');
        const label = $('<label class="gv-ui-ckeckbox gv-ui-ckeckbox--card"></label>').attr("for", radioId);
        const input = $('<input type="radio" />')
            .attr("id", radioId)
            .attr("name", context.sourceTypePath)
            .attr("value", option.value);
        const content = $('<div class="gvg-r mod--valign-top"></div>');
        const valueMap = $('<span class="value-map gvg-6on6"></span>').text(components.resolveUiText(option, "label", option.value));

        if (option.value === getCurrentImageSourceType(context)) {
            input.prop("checked", true);
        }

        content.append(valueMap);
        // Ce composant genere lui-meme le faux rendu radio pour ne plus dependre d'un balayage global du builder.
        label.append(input).append($('<div class="gv-ui__mock"></div>')).append(content);
        card.append(label);
        return card;
    }

    // Ajoute le select de zone et l'input d'upload dans la colonne de configuration.
    function appendImageSpecificControls(context) {
        context.layout.zoneContainer.append(context.layout.zoneLabel).append(context.layout.zoneSelect);
        context.layout.customContainer.append(context.layout.customLabel).append(context.layout.customInput);
        context.layout.configurationColumn.append(context.layout.zoneContainer).append(context.layout.customContainer);
    }

    // Assemble la mise en page finale du composant avec la colonne preview et la colonne configuration.
    function assembleImageLayout(context) {
        context.layout.previewColumn.append(context.layout.previewHeading).append(context.layout.preview);
        context.layout.rootRow.append(context.layout.previewColumn).append(context.layout.configurationColumn);
        context.layout.container.append(context.layout.rootRow);
    }

    // ---- EVENEMENTS ----

    // Gere les erreurs de chargement de la preview.
    function bindImagePreviewEvents(context) {
        context.layout.preview.on("error", function () {
            // Si l'image courante casse, on vide simplement la preview pour ne pas afficher une icone navigateur.
            context.layout.preview.removeAttr("src");
        });
    }

    // Gere le changement de source principale.
    function bindImageSourceEvents(context) {
        context.layout.container.find('input[name="' + context.sourceTypePath + '"]').on("change", function () {
            if (!$(this).is(":checked")) {
                return;
            }

            // Le choix de source pilote a la fois le rendu visible et les dependances de preview/chargement.
            components.setByPath(context.state, context.sourceTypePath, $(this).val());
            notifyImageStateChange(context, context.sourceTypePath);
            applyImageSourceType(context, $(this).val());
        });
    }

    // Gere le changement de zone selectionnee.
    function bindImageZoneEvents(context) {
        context.layout.zoneSelect.on("change", function () {
            const zonePhoto = $(this).val();
            components.setByPath(context.state, context.zonePath, zonePhoto || null);
            notifyImageStateChange(context, context.zonePath);

            if (zonePhoto) {
                updateImagePreview(context, getZonePreviewUrl(context, zonePhoto));
            } else {
                updateImagePreview(context, "");
            }
        });
    }

    // Gere l'upload d'une image personnalisee.
    function bindImageUploadEvents(context) {
        context.layout.customInput.on("change", function () {
            handleImageUploadChange(context, this);
        });
    }

    // ---- INITIALISATION ----

    // Initialise select2 sur le select de zone une fois qu'il existe dans le DOM.
    function initializeImageZoneSelect2(context) {
        setTimeout(function () {
            context.layout.zoneSelect.select2({
                width: "100%",
                placeholder: context.zonePlaceholder,
                language: G.model.lang
            });
            context.layout.zoneSelect.trigger("change.select2");
        }, 0);
    }

    // Initialise le state sur la source active puis force le premier rendu correspondant.
    function initializeImageCurrentSource(context) {
        const currentSourceType = getCurrentImageSourceType(context);

        components.setByPath(context.state, context.sourceTypePath, currentSourceType);
        notifyImageStateChange(context, context.sourceTypePath);

        if (context.layout.container.find('input[name="' + context.sourceTypePath + '"]:checked').length) {
            context.layout.container.find('input[name="' + context.sourceTypePath + '"]:checked').trigger("change");
        } else {
            applyImageSourceType(context, currentSourceType);
        }
    }

    // ---- METIER / FLUX ----

    // Bascule l'UI entre image site, image de zone et image personnalisee.
    function applyImageSourceType(context, sourceType) {
        // Une seule source est visible a la fois, mais toutes les valeurs restent dans le state pour le futur payload.
        switch (sourceType) {
            case "img_src_site":
                updateImagePreview(context, getSitePreviewUrl(context));
                context.layout.customContainer.hide();
                context.layout.zoneContainer.hide();
                break;
            case "img_src_zone":
                context.layout.customContainer.hide();
                context.layout.zoneContainer.show();
                loadImageZones(context);
                if (context.layout.zoneSelect.val()) {
                    updateImagePreview(context, getZonePreviewUrl(context, context.layout.zoneSelect.val()));
                }
                break;
            case "img_src_custom":
                previewUploadedImageFile(context, components.getByPath(context.state, context.uploadStatePath));
                context.layout.customContainer.show();
                context.layout.zoneContainer.hide();
                break;
            default:
                updateImagePreview(context, getSitePreviewUrl(context));
                context.layout.customContainer.hide();
                context.layout.zoneContainer.hide();
                break;
        }
    }

    // Recharge le select de zones en preservant au mieux la selection historique ou par defaut.
    function populateImageZoneSelect(context, zones) {
        const normalizedZones = Array.isArray(zones) ? zones : [];
        const savedZoneValue = components.getByPath(context.state, context.zonePath);
        let defaultZone = normalizedZones[1] || normalizedZones[0] || null;

        // En edition on tente de retrouver la zone deja sauvee, sinon on reproduit le fallback observe sur la V2.
        if (savedZoneValue) {
            defaultZone = normalizedZones.find(function (zone) {
                return zone.photo && String(zone.photo) === String(savedZoneValue);
            }) || normalizedZones.find(function (zone) {
                return String(zone.id) === String(savedZoneValue);
            }) || defaultZone;
        }

        context.layout.zoneSelect.empty();

        if (context.zonePlaceholder) {
            context.layout.zoneSelect.append(components.buildOption("", context.zonePlaceholder));
        }

        normalizedZones.forEach(function (zone) {
            // La valeur sauvegardee reste la photo quand elle existe, pour rester compatible avec l'ancien format.
            const optionValue = zone.photo || zone.id;
            const isSelected = !!defaultZone && String(defaultZone.id) === String(zone.id);
            context.layout.zoneSelect.append(new Option(zone.nom, optionValue, isSelected, isSelected));
        });

        context.layout.zoneSelect.trigger("change");
    }

    // Charge la liste des zones du site puis la garde en cache pendant la vie de la popup.
    function loadImageZones(context) {
        if (context.zonesCache) {
            // Les zones changent rarement pendant la vie de la popup, donc on evite de recharger inutilement.
            populateImageZoneSelect(context, context.zonesCache);
            return;
        }

        const resolvedAjaxConfig = context.helpers.resolveTemplateValue(context.field.zoneAjax || {});
        const ajaxRequest = {
            url: resolvedAjaxConfig.url,
            type: resolvedAjaxConfig.method || "GET",
            dataType: resolvedAjaxConfig.dataType || "json",
            beforeSend: function () {
                context.layout.zoneSelect.empty();
            }
        };

        if (resolvedAjaxConfig.headers) {
            ajaxRequest.headers = resolvedAjaxConfig.headers;
        }

        $.ajax(ajaxRequest).done(function (response) {
            // Le backend peut renvoyer des formats legerement differents; le helper harmonise avant remplissage du select.
            context.zonesCache = context.helpers.extractResponsePayload(response, resolvedAjaxConfig);
            populateImageZoneSelect(context, context.zonesCache);
        });
    }

    // Gere les validations et la preview locale lors d'un nouvel upload.
    function handleImageUploadChange(context, inputElement) {
        const file = inputElement.files && inputElement.files.length > 0 ? inputElement.files[0] : null;

        // Le fichier est garde en memoire dans le state runtime pour etre reinjecte au moment du POST.
        components.setByPath(context.state, context.uploadStatePath, file);
        notifyImageStateChange(context, context.uploadStatePath);

        if (!file) {
            updateImagePreview(context, getCustomPreviewUrl(context));
            return;
        }

        if (context.field.maxSizeKb && file.size / 1024 > context.field.maxSizeKb) {
            inputElement.value = "";
            components.setByPath(context.state, context.uploadStatePath, null);
            notifyImageStateChange(context, context.uploadStatePath);
            updateImagePreview(context, getCustomPreviewUrl(context));
            return;
        }

        previewUploadedImageFile(context, file);
    }

    // ---- PREVIEW ----

    // Remplace l'image visible dans la preview par la source calculee.
    function updateImagePreview(context, previewUrl) {
        if (previewUrl) {
            context.layout.preview.attr("src", previewUrl);
        } else {
            // Si aucune source exploitable n'existe, on vide l'image pour eviter une preview trompeuse.
            context.layout.preview.removeAttr("src");
        }
    }

    // Construit une preview locale immediate quand l'utilisateur choisit un nouveau fichier.
    function previewUploadedImageFile(context, file) {
        if (!file) {
            updateImagePreview(context, getCustomPreviewUrl(context));
            return;
        }

        // La preview locale evite d'attendre l'enregistrement serveur pour montrer l'image choisie.
        const reader = new FileReader();
        reader.onloadend = function () {
            updateImagePreview(context, reader.result);
        };
        reader.readAsDataURL(file);
    }

    // Retourne l'URL de preview de l'image de site.
    function getSitePreviewUrl(context) {
        return buildImagePreviewUrl(context.field.sitePreviewBasePath || "img/sites/", components.getByPath(context.state, context.field.siteAssetPath || "site_logo"));
    }

    // Retourne l'URL de preview de l'image personnalisee deja enregistree.
    function getCustomPreviewUrl(context) {
        return buildImagePreviewUrl(context.field.customPreviewBasePath || "img/indicators/custom/", components.getByPath(context.state, context.customPath));
    }

    // Retourne l'URL de preview de la zone actuellement selectionnee.
    function getZonePreviewUrl(context, zonePhoto) {
        return buildImagePreviewUrl(context.field.zonePreviewBasePath || "img/circuits/", zonePhoto);
    }

    // Transforme une base de dossier + un nom de fichier en URL de preview exploitable par le front.
    function buildImagePreviewUrl(basePath, assetValue) {
        if (!basePath || !assetValue) {
            return "";
        }

        // Les chemins de preview sont reconstruits ici a partir des bases fournies par la config JSON.
        return G.config.SERVER + String(basePath).replace(/^\/+/, "") + assetValue;
    }

    // ---- UTILITAIRES ----

    // Notifie le builder qu'une valeur de state a change pour relancer les dependances si besoin.
    function notifyImageStateChange(context, path) {
        context.helpers.onStateChange(path, components.getByPath(context.state, path));
    }

    // Nettoie les listeners et widgets attaches au composant avant fermeture de la popup.
    function destroyImageField(context) {
        components.destroySelect2(context.layout.zoneSelect);
        context.layout.preview.off();
        context.layout.zoneSelect.off();
        context.layout.customInput.off();
        context.layout.container.find('input[name="' + context.sourceTypePath + '"]').off();
    }

    // Retrouve quelle source est actuellement active, soit depuis le DOM soit depuis le state initial.
    function getCurrentImageSourceType(context) {
        // On lit d'abord le DOM si l'utilisateur a deja clique, sinon on retombe sur le state initial/pre-rempli.
        const checkedInput = context.layout.container.find('input[name="' + context.sourceTypePath + '"]:checked').first();

        if (checkedInput.length) {
            return checkedInput.val();
        }

        return components.getByPath(context.state, context.sourceTypePath) || context.field.defaultSourceType || "img_src_site";
    }

    components.createImageField = createImageField;
})();

/*
# RULES COMPONENT
# TYPE JSON: "rules"
# RENDU: tableau editable de regles avec reordering, edition inline et suppression.
# SELECTION DU COMPOSANT: le builder route ici quand `field.type` vaut "rules".
# ROLE: sert a gerer les regles conditionnelles d'un indicateur, comme sur l'indicateur valeur.
# OPTIONS UTILES: `showAddButton`, `tableTitle`, `displayOptions`, `statusOptions`, `addButtonLabel`.
*/

if (!window.G) {
    window.G = {};
}

G.ui = G.ui || {};
G.ui.GVIndicatorEditionV3Components = G.ui.GVIndicatorEditionV3Components || {};

(function () {
    const components = G.ui.GVIndicatorEditionV3Components;

    // Construit le composant de regles complet: toolbar, DataTable editable et reordering.
    function createDatatableRulesField(fieldId, field, state, helpers) {
        const context = createRulesContext(fieldId, field, state, helpers);
        buildRulesLayout(context);
        initializeRulesDatatable(context);
        bindRulesEvents(context);
        finalizeRulesInitialization(context);
        return buildRulesPublicApi(context);
    }

    // Point d'entree public expose au builder pour le type `rules`.
    function createRulesField(fieldId, field, state, helpers) {
        return createDatatableRulesField(fieldId, field, state, helpers);
    }

    // Prepare toutes les donnees partagees entre toolbar, editor, DataTable et state.
    function createRulesContext(fieldId, field, state, helpers) {
        const icons = components.getAvailableIconOptions();

        components.setByPath(state, field.name, components.normalizeRules(components.getByPath(state, field.name)));

        return {
            fieldId: fieldId,
            field: field,
            state: state,
            helpers: helpers,
            showAddButton: field.showAddButton !== false,
            editorIsSubmitting: false,
            datatable: null,
            editor: null,
            iconOptions: icons.map(function (icon) {
                return { label: icon.nom, value: icon.id };
            }),
            displayOptions: resolveRulesDisplayOptions(field),
            statusOptions: resolveRulesStatusOptions(field),
            layout: createRulesLayout(fieldId, field)
        };
    }

    // Monte le shell visuel puis ajoute eventuellement le bouton d'ajout.
    function buildRulesLayout(context) {
        assembleRulesLayout(context);
        appendRulesAddButton(context);
    }

    // Cree l'editor inline puis la DataTable principale.
    function initializeRulesDatatable(context) {
        context.editor = createRulesEditor(context);
        context.datatable = createRulesDatatable(context);
    }

    // Branche les evenements de toolbar, editor et table.
    function bindRulesEvents(context) {
        bindRulesAddButton(context);
        bindRulesEditorEvents(context);
        bindRulesDatatableEvents(context);
    }

    // Synchronise une premiere fois le state et ajuste les largeurs.
    function finalizeRulesInitialization(context) {
        syncRulesState(context);
        adjustRulesColumns(context);
    }

    // Expose l'API publique du composant au builder.
    function buildRulesPublicApi(context) {
        return {
            element: context.layout.container,
            getValue: function () {
                // Le composant travaille en tableau dans le state, mais le backend legacy attend une chaine JSON.
                return JSON.stringify(getNormalizedRulesState(context));
            },
            commitDraft: function () {
                return submitActiveRulesInlineEdition(context).then(function () {
                    syncRulesState(context);
                    return true;
                });
            },
            destroy: function () {
                destroyRulesField(context);
            }
        };
    }

    // ---- CONSTRUCTION DOM ----

    // Cree la structure DOM de base qui accueillera toolbar et table.
    function createRulesLayout(fieldId, field) {
        return {
            container: $('<div class="gv-indicator-rules"></div>'),
            toolbar: $('<div class="gvg-r mod--align-space-between mod--valign-bottom gv-indicator-rules__toolbar"></div>'),
            toolbarTitle: $('<div><h3></h3></div>'),
            toolbarActions: $('<div class="text-right"></div>'),
            table: $('<table class="ui-lean gv-table gv-table--auto-wrap--body gv-indicator-rules__table"></table>').attr("id", fieldId + "-table"),
            addButton: null
        };
    }

    // Assemble le titre, la zone d'actions et la table dans le conteneur racine.
    function assembleRulesLayout(context) {
        context.layout.toolbarTitle.find("h3").text(components.resolveUiText(context.field, "tableTitle", "Règles"));
        context.layout.toolbar.append(context.layout.toolbarTitle).append(context.layout.toolbarActions);
        context.layout.container.append(context.layout.toolbar).append(context.layout.table);
    }

    // Cree visuellement le bouton d'ajout si ce composant l'autorise.
    function appendRulesAddButton(context) {
        if (!context.showAddButton) {
            return;
        }

        context.layout.addButton = $('<button type="button" class="uicomp__button uicomp--brand"></button>')
            .text(components.resolveUiText(context.field, "addButtonLabel", "Ajouter une règle"));
        context.layout.toolbarActions.append(context.layout.addButton);
    }

    // ---- INITIALISATION DATATABLE ----

    // Cree l'editeur inline DataTable Editor.
    function createRulesEditor(context) {
        return new DataTable.Editor({
            idSrc: "DT_RowId",
            fields: [
                { title: "", name: "id", type: "readonly" },
                { title: "", name: "DT_RowId", type: "readonly" },
                { title: "", name: "indicateur_id", type: "readonly" },
                { title: "", name: "position", type: "readonly" },
                {
                    title: "",
                    name: "operateur",
                    type: "select",
                    options: [
                        { label: "<", value: "<" },
                        { label: ">", value: ">" },
                        { label: "=", value: "=" }
                    ]
                },
                { title: "", name: "valeur", type: "text" },
                { title: "", name: "parametres.icone", type: "select", options: context.iconOptions },
                { title: "", name: "parametres.affichage_valeur", type: "select", options: context.displayOptions },
                { title: "", name: "parametres.status", type: "select", options: context.statusOptions },
                { title: "", name: "parametres.valeur_substitue", type: "text" }
            ],
            table: "#" + context.layout.table.attr("id")
        });
    }

    // Cree la DataTable editable qui devient la source de verite du composant.
    function createRulesDatatable(context) {
        return context.layout.table.DataTable({
            destroy: true,
            paging: false,
            info: false,
            searching: false,
            lengthChange: false,
            autoWidth: false,
            order: [[3, "asc"]],
            dom: "t",
            columnDefs: [
                { targets: [0, 1, 2], visible: false, searchable: false },
                { targets: "_all", orderable: false },
                { targets: [3, 9], className: "row-not-editable" }
            ],
            columns: buildRulesDatatableColumns(context),
            data: components.mapRulesToRows(components.getByPath(context.state, context.field.name)),
            rowId: "DT_RowId",
            rowReorder: {
                update: true,
                dataSrc: "position",
                editor: null
            },
            language: (context.helpers && context.helpers.ui && context.helpers.ui.datatable) || {}
        });
    }

    // Construit les colonnes visibles du tableau de regles.
    function buildRulesDatatableColumns(context) {
        return [
            { title: "Id", data: "id", defaultContent: null },
            { title: "", data: "DT_RowId", defaultContent: "" },
            { title: components.resolveUiText(context.field, "indicatorIdLabel", "Indicateur"), data: "indicateur_id", defaultContent: "" },
            {
                title: "",
                data: "position",
                className: "reorder mod--collapse text-center",
                defaultContent: null,
                render: function (data, type) {
                    if (type === "display") {
                        return '<i class="fas fa-grip-horizontal"></i>';
                    }

                    return data;
                }
            },
            { title: components.resolveUiText(context.field, "operatorLabel", "Opérateur"), data: "operateur", defaultContent: "" },
            { title: components.resolveUiText(context.field, "valueLabel", "Valeur"), data: "valeur", defaultContent: "" },
            {
                title: components.resolveUiText(context.field, "iconLabel", "Icône"),
                data: "parametres.icone",
                className: "mod--collapse text-center",
                defaultContent: "",
                render: function (data, type) {
                    if (type === "display") {
                        return '<div class="gv-iicon-wrapper-26"><div class="gv-iicon gv-iicon-' + data + '"></div></div>';
                    }

                    return data;
                }
            },
            {
                title: components.resolveUiText(context.field, "displayLabel", "Aff. valeur"),
                data: "parametres.affichage_valeur",
                defaultContent: "",
                render: function (data, type) {
                    if (type === "display") {
                        const displayOption = context.displayOptions.find(function (option) {
                            return option.value === data;
                        });

                        return displayOption ? displayOption.label : data;
                    }

                    return data;
                }
            },
            {
                title: components.resolveUiText(context.field, "statusLabel", "État"),
                data: "parametres.status",
                defaultContent: "",
                render: function (data, type) {
                    if (type === "display") {
                        const statusOption = context.statusOptions.find(function (option) {
                            return option.value === data;
                        });

                        return statusOption ? statusOption.label : data;
                    }

                    return data;
                }
            },
            {
                title: components.resolveUiText(context.field, "substitutedValueLabel", "Substitution"),
                data: "parametres.valeur_substitue",
                defaultContent: ""
            },
            {
                title: "",
                data: null,
                className: "row-remove dt-center",
                render: function () {
                    return '<div class="uicomp__icon uicomp--small"><i class="fas fa-trash"></i></div>';
                }
            }
        ];
    }

    // ---- EVENEMENTS ----

    // Branche le bouton d'ajout si present.
    function bindRulesAddButton(context) {
        if (!context.layout.addButton) {
            return;
        }

        context.layout.addButton.on("click", function () {
            addEmptyRuleRow(context);
        });
    }

    // Branche les evenements d'ouverture, validation et soumission de l'editor inline.
    function bindRulesEditorEvents(context) {
        context.editor.on("preOpen", function () {
            disableRulesTechnicalFields(context);
            adjustRulesColumns(context);
        });

        context.editor.on("open", function () {
            context.layout.table.find("select").addClass("select2-full-width");
            G.ui.initSelect2(context.layout.table);
            adjustRulesColumns(context);
            Swal.disableButtons();
        });

        context.editor.on("close", function () {
            adjustRulesColumns(context);
            Swal.enableButtons();
        });

        context.editor.on("preSubmit", function () {
            context.editorIsSubmitting = true;
        });

        context.editor.on("submitSuccess submitUnsuccessful submitComplete", function () {
            context.editorIsSubmitting = false;
        });

        context.editor.on("initCreate", function () {
            context.editor.field("position").set(context.datatable.rows().count());
            context.editor.field("DT_RowId").set("DT_RowId_" + Date.now());
            context.editor.hide("position");
            adjustRulesColumns(context);
        });

        context.editor.on("initEdit", function () {
            context.editor.hide("position");
            adjustRulesColumns(context);
        });

        context.editor.on("submitSuccess", function () {
            sortRulesByPosition(context);
            syncRulesState(context);
        });
    }

    // Branche les clics et le reorder de la DataTable.
    function bindRulesDatatableEvents(context) {
        context.datatable.on("row-reorder", function (event, details, changes) {
            // On laisse Editor propager les nouvelles positions pour garder le meme mecanisme que les autres tables editables.
            context.editor
                .edit(changes.nodes, false, { submit: "changed" })
                .multiSet(changes.dataSrc, changes.values)
                .submit();

            sortRulesByPosition(context);
            syncRulesState(context);
        });

        context.datatable.on("click", "tbody td:not(:first-child, .row-not-editable)", function () {
            context.editor.inline(context.datatable.cells(this.parentNode, "*").nodes(), {
                onBlur: "submit",
                submitTrigger: -1,
                submitHtml: '<div class="uicomp__icon uicomp--small"><i class="fas fa-save"></i></div>'
            });
        });

        context.datatable.on("click", "tbody td.row-remove", function () {
            context.datatable.row($(this).parents("tr")).remove().draw();
            syncRulesState(context);
        });

        context.datatable.on("draw", function () {
            syncRulesState(context);
        });
    }

    // ---- METIER ----

    // Reconstruit le JSON final des regles a partir des lignes actuellement presentes dans la table.
    function syncRulesState(context) {
        const nextRules = context.datatable.rows().data().toArray().map(function (rule, index) {
            return components.normalizeRule(rule, index);
        });

        components.setByPath(context.state, context.field.name, nextRules);
    }

    // Si une edition inline est encore ouverte pendant le save global, on la ferme proprement avant de continuer.
    function submitActiveRulesInlineEdition(context) {
        const editorUiIsVisible = context.layout.table.find("div.DTE").length > 0;

        if (!editorUiIsVisible && !context.editorIsSubmitting) {
            return Promise.resolve();
        }

        return new Promise(function (resolve) {
            const handledEvents = "submitComplete submitUnsuccessful submitError";
            const finish = function () {
                context.editor.off(handledEvents, finish);
                resolve();
            };

            context.editor.on(handledEvents, finish);
            if (editorUiIsVisible) {
                // Si une cellule est encore en edition inline au moment du save global, on force d'abord sa validation.
                context.editor.submit();
            }
        });
    }

    // Cree une nouvelle ligne vide puis ouvre directement son edition inline.
    function addEmptyRuleRow(context) {
        const newRule = buildEmptyRuleRow(context);
        context.datatable.row.add(newRule).draw(false);
        sortRulesByPosition(context);
        syncRulesState(context);
        adjustRulesColumns(context);
        openRulesInlineEditorForRow(context, newRule.DT_RowId);
    }

    // Prepare une nouvelle regle vide deja compatible avec le format attendu par le backend legacy.
    function buildEmptyRuleRow(context) {
        return {
            id: null,
            DT_RowId: "DT_RowId_" + Date.now(),
            indicateur_id: null,
            position: context.datatable.rows().count(),
            operateur: "<",
            valeur: "",
            parametres: {
                icone: "",
                affichage_valeur: "oui",
                status: "status-info",
                valeur_substitue: ""
            }
        };
    }

    // Ouvre automatiquement l'edition inline de la nouvelle ligne pour accelerer la saisie.
    function openRulesInlineEditorForRow(context, rowId) {
        const row = context.datatable.row("#" + rowId);
        if (!row.node()) {
            return;
        }

        const editableCell = $(row.node()).find("td").not(":first-child, .row-not-editable").first();
        if (editableCell.length) {
            editableCell.trigger("click");
        }
    }

    // Maintient l'ordre visuel aligne sur le champ `position` des regles.
    function sortRulesByPosition(context) {
        context.datatable.order([3, "asc"]).draw();
    }

    // Passe en lecture seule les champs purement techniques de l'editor.
    function disableRulesTechnicalFields(context) {
        context.editor.field("id").disable();
        context.editor.field("position").disable();
        context.editor.field("indicateur_id").disable();
        context.editor.field("DT_RowId").disable();
    }

    // Force DataTable a recalculer ses largeurs apres chaque ouverture ou mutation importante.
    function adjustRulesColumns(context) {
        window.requestAnimationFrame(function () {
            if (context.datatable) {
                context.datatable.columns.adjust().draw(false);
            }
        });
    }

    // Nettoie toolbar, DataTable et Editor pour eviter les handlers persistants entre deux popups.
    function destroyRulesField(context) {
        if (context.layout.addButton) {
            context.layout.addButton.off();
        }

        context.layout.table.off();
        components.destroyThirdPartyInstance(context.editor);
        components.destroyThirdPartyInstance(context.datatable);
        context.editor = null;
        context.datatable = null;
    }

    // ---- UTILITAIRES ----

    // Normalise les choix d'affichage de valeur.
    function resolveRulesDisplayOptions(field) {
        return (field.displayOptions || [
            { value: "oui", label: components.resolveUiText(field, "displayYesLabel", "Oui") },
            { value: "non", label: components.resolveUiText(field, "displayNoLabel", "Non") }
        ]).map(function (option) {
            return {
                label: components.resolveUiText(option, "label", option.value),
                value: option.value
            };
        });
    }

    // Normalise les choix de status disponibles dans les regles.
    function resolveRulesStatusOptions(field) {
        return (field.statusOptions || [
            { value: "status-info", label: "Normal" },
            { value: "status-ok", label: "Succès" },
            { value: "status-warning", label: "Avertissement" },
            { value: "status-alert", label: "Alerte" }
        ]).map(function (option) {
            return {
                label: components.resolveUiText(option, "label", option.value),
                value: option.value
            };
        });
    }

    // Relit les regles du state dans leur format normalise avant serialisation finale.
    function getNormalizedRulesState(context) {
        return components.normalizeRules(components.getByPath(context.state, context.field.name));
    }

    components.createRulesField = createRulesField;
})();

/*
# DATATABLE SELECTOR COMPONENT
# TYPE JSON: "datatable_select_single", "datatable_select_multiple"
# RENDU: DataTable de selection simple ou multiple avec synchronisation directe vers le state.
# SELECTION DU COMPOSANT: le builder route ici quand `field.type` vaut "datatable_select_single" ou "datatable_select_multiple".
# ROLE: sert aux cas planning, chart, point unique, liste multiple de points, heating curves, etc.
# OPTIONS UTILES: `options`, `ajax`, `columns`, `valueProperty`.
*/

if (!window.G) {
    window.G = {};
}

G.ui = G.ui || {};
G.ui.GVIndicatorEditionV3Components = G.ui.GVIndicatorEditionV3Components || {};

(function () {
    const components = G.ui.GVIndicatorEditionV3Components;

    // Construit le selecteur DataTable simple ou multiple.
    function createDatatableSelectorField(fieldId, field, state, helpers) {
        const context = createDatatableSelectorContext(fieldId, field, state, helpers);
        buildDatatableSelectorLayout(context);
        const ready = loadDatatableSelectorRows(context).then(function (rows) {
            initializeDatatableSelector(context, rows);
            return true;
        });

        return {
            element: context.layout.container,
            ready: ready,
            getValue: function () {
                return readDatatableSelectorSubmitValue(context);
            },
            destroy: function () {
                destroyDatatableSelector(context);
            }
        };
    }

    // Prepare les donnees partagees entre chargement, table et synchronisation.
    function createDatatableSelectorContext(fieldId, field, state, helpers) {
        const currentValue = components.getByPath(state, field.name);
        const isMultiple = field.type === "datatable_select_multiple";

        return {
            fieldId: fieldId,
            field: field,
            state: state,
            helpers: helpers,
            isMultiple: isMultiple,
            initialSelection: formatDefaultSelectionForRestore(currentValue, isMultiple, field),
            datatable: null,
            layout: createDatatableSelectorLayout(fieldId, field)
        };
    }

    // Monte le shell DOM du composant autour de la table.
    function buildDatatableSelectorLayout(context) {
        context.layout.container
            .append(context.layout.table);
    }

    // Charge les lignes puis construit la DataTable avec sa selection.
    function initializeDatatableSelector(context, rows) {
        context.datatable = createDatatableSelectorTable(context, rows);
        bindDatatableSelectorEvents(context);
        restoreDatatableSelectorSelection(context);
        syncDatatableSelectorSelection(context);
        adjustDatatableSelectorColumns(context);
    }

    // ---- CONSTRUCTION DOM ----

    // Cree le conteneur racine et la balise table.
    function createDatatableSelectorLayout(fieldId, field) {
        return {
            container: $('<div class="gv-indicator-datatable-selector"></div>'),
            table: $('<table class="ui-lean gv-table gv-table--auto-wrap--body gv-indicator-table"></table>').attr("id", fieldId + "-table")
        };
    }

    // ---- CHARGEMENT ----

    // Resolve la source de lignes: options brutes ou sourcing Ajax generique.
    function loadDatatableSelectorRows(context) {
        // Priorite aux options deja embarquees dans le JSON; sinon on bascule sur le sourcing Ajax generique.
        if (Array.isArray(context.field.options)) {
            return Promise.resolve(context.field.options);
        }

        if (context.field.ajax) {
            return context.helpers.loadFieldOptionsFromConfig(context.field.ajax || {}, context.field);
        }

        return Promise.resolve([]);
    }

    // ---- DATATABLE ----

    // Cree la DataTable de selection avec les colonnes derivees de la config ou des donnees.
    function createDatatableSelectorTable(context, rows) {
        const normalizedRows = Array.isArray(rows) ? rows : [];
        const columns = buildDatatableSelectorColumns(context, normalizedRows);
        const datatableConfig = {
            destroy: true,
            autoWidth: false,
            paging: context.field.paging !== false,
            info: context.field.info !== false,
            searching: context.field.searching !== false,
            lengthChange: context.field.lengthChange !== false,
            data: normalizedRows,
            columns: columns,
            select: {
                style: context.isMultiple ? "multi" : "single",
                selector: "td:first-child",
                info: context.field.selectionInfo !== false
            },
            pageLength: Number(context.field.pageLength || 100),
            lengthMenu: Array.isArray(context.field.lengthMenu)
                ? context.field.lengthMenu
                : [[10, 25, 50, 100, -1], [10, 25, 50, 100, "Tous"]],
            dom: typeof context.field.dom === "string" && context.field.dom !== ""
                ? context.field.dom
                : "lfrtip",
            order: Array.isArray(context.field.order)
                ? context.field.order
                : [[0, "desc"], [1, "desc"]],
            language: (context.helpers && context.helpers.ui && context.helpers.ui.datatable) || {}
        };

        if (Array.isArray(context.field.buttons) && context.field.buttons.length > 0) {
            datatableConfig.buttons = context.field.buttons;
        }

        return context.layout.table.DataTable(datatableConfig);
    }

    // Branche la synchronisation de state a chaque clic de selection.
    function bindDatatableSelectorEvents(context) {
        context.datatable.on("select deselect", function (_, __, type) {
            if (type === "row") {
                // Chaque clic de selection resynchronise aussitot la valeur exploitable par le builder.
                syncDatatableSelectorSelection(context);
            }
        });
    }

    // Rejoue la selection pre-remplie une fois la DataTable reconstruite.
    function restoreDatatableSelectorSelection(context) {
        if (context.isMultiple) {
            context.datatable.rows(function (_, rowData) {
                const rowValue = String(components.getByPath(rowData, context.field.valueProperty || "id"));
                return context.initialSelection.indexOf(rowValue) !== -1;
            }).select();
            return;
        }

        if (context.initialSelection !== null) {
            context.datatable.rows(function (_, rowData) {
                const rowValue = String(components.getByPath(rowData, context.field.valueProperty || "id"));
                return rowValue === context.initialSelection;
            }).select();
        }
    }

    // Redemande un recalcul de largeurs apres construction.
    function adjustDatatableSelectorColumns(context) {
        window.requestAnimationFrame(function () {
            if (context.datatable) {
                context.datatable.columns.adjust().draw(false);
            }
        });
    }

    // Nettoie la DataTable de selection et les handlers portes par son DOM local.
    function destroyDatatableSelector(context) {
        context.layout.table.off();
        components.destroyThirdPartyInstance(context.datatable);
        context.datatable = null;
    }

    // ---- STATE ----

    // Synchronise la selection courante de la table vers le state.
    function syncDatatableSelectorSelection(context) {
        components.setByPath(context.state, context.field.name, readDatatableSelectorStateValue(context));
    }

    // Relit la selection actuelle de la table au format metier garde dans le state.
    function readDatatableSelectorStateValue(context) {
        if (context.isMultiple) {
            return readMultipleDatatableSelectionValue(context);
        }

        return readSingleDatatableSelectionValue(context);
    }

    // Transforme eventuellement la valeur finale avant envoi pour coller au contrat historique du backend.
    function readDatatableSelectorSubmitValue(context) {
        const stateValue = readDatatableSelectorStateValue(context);

        if (context.isMultiple && context.field.submitAsJson === true) {
            return JSON.stringify(stateValue);
        }

        return stateValue;
    }

    // Construit la liste multiple finale a partir des lignes actuellement cochees.
    function readMultipleDatatableSelectionValue(context) {
        const selectedRows = context.datatable.rows({ selected: true }).data().toArray();
        return selectedRows.map(function (row) {
            if (context.field.selectedRowTemplate) {
                return applyDatatableSelectionTemplate(context.field.selectedRowTemplate, row, context);
            }

            return String(components.getByPath(row, context.field.valueProperty || "id"));
        });
    }

    // Construit la valeur unique finale a partir de la ligne actuellement selectionnee.
    function readSingleDatatableSelectionValue(context) {
        const selectedRow = context.datatable.rows({ selected: true }).data().toArray()[0];
        return selectedRow ? components.getByPath(selectedRow, context.field.valueProperty || "id") : null;
    }

    // ---- UTILITAIRES ----

    // Reformate uniquement les donnees par defaut pour que restoreDatatableSelectorSelection() puisse les comparer aux lignes de la table.
    function formatDefaultSelectionForRestore(currentValue, isMultiple, field) {
        if (isMultiple) {
            if (!Array.isArray(currentValue)) {
                return [];
            }

            return currentValue.map(function (item) {
                if (item !== null && typeof item === "object") {
                    return String(components.getByPath(item, field.selectedValuePath || field.valueProperty || "id"));
                }

                return String(item);
            });
        }

        return currentValue === null || currentValue === undefined ? null : String(currentValue);
    }

    // Construit la colonne select-checkbox puis les colonnes metier.
    function buildDatatableSelectorColumns(context, rows) {
        return [buildDatatableSelectorCheckboxColumn(context)].concat(
            components.buildDatatableColumnsFromConfig(context.field, rows)
        );
    }

    // Reproduit la premiere colonne de selection DataTable de la V2.
    function buildDatatableSelectorCheckboxColumn(context) {
        return {
            data: context.field.valueProperty || "id",
            defaultContent: "",
            className: "select-checkbox",
            orderable: false,
            render: function (data, type, row) {
                if (type === "sort") {
                    return isDatatableRowInitiallySelected(context, row);
                }

                return "";
            }
        };
    }

    // Sert uniquement au tri initial pour remonter les lignes deja selectionnees comme en V2.
    function isDatatableRowInitiallySelected(context, row) {
        const rowValue = String(components.getByPath(row, context.field.valueProperty || "id"));

        if (context.isMultiple) {
            return context.initialSelection.indexOf(rowValue) !== -1;
        }

        return context.initialSelection === rowValue;
    }

    // Rejoue la structure du template pour reconstruire, a la meme forme, l'objet qui sera envoye dans le payload.
    // Exemple:
    // - si le template vaut {"point_id":"{id}","indicateur_id":"{indicatorId}"}
    // - et que la ligne selectionnee contient { id: 12 }
    // - alors le resultat devient {"point_id":"12","indicateur_id":"59999"}
    function applyDatatableSelectionTemplate(template, row, context) {
        if (Array.isArray(template)) {
            // Si le template contient une liste, on transforme chaque element de cette liste avec la meme logique.
            return template.map(function (item) {
                return applyDatatableSelectionTemplate(item, row, context);
            });
        }

        if (template && typeof template === "object") {
            // Si le template est un objet, on reconstruit un nouvel objet cle par cle
            // en reappliquant la transformation sur chaque sous-valeur.
            const output = {};

            Object.keys(template).forEach(function (key) {
                output[key] = applyDatatableSelectionTemplate(template[key], row, context);
            });

            return output;
        }

        if (typeof template === "string") {
            // Si on tombe sur une chaine, c'est ici que les placeholders entre accolades sont remplaces.
            // Exemples:
            // - {id} lit la colonne `id` de la ligne DataTable selectionnee
            // - {nom} lit la colonne `nom`
            // - {indicatorId} lit une valeur globale ajoutee manuellement au contexte du template
            return components.resolveTemplate(template, buildDatatableSelectionTemplateSource(row, context));
        }

        // Les valeurs deja fixes (null, boolean, nombre brut...) sont conservees telles quelles.
        return template;
    }

    // Expose aux templates la ligne courante et quelques variables globales.
    function buildDatatableSelectionTemplateSource(row, context) {
        // Les placeholders standards comme {id}, {nom}, {labelHumain} viennent directement de `row`.
        // Les cas speciaux comme {indicatorId} sont ajoutes ici a cote des colonnes de la ligne.
        return $.extend({}, row || {}, {
            indicatorId: context && context.helpers ? context.helpers.indicatorId : null,
            siteId: context && context.helpers ? context.helpers.siteId : null,
            userApiKey: G && G.model ? G.model.userApiKey : null
        });
    }

    components.createDatatableSelectorField = createDatatableSelectorField;
})();

/*
# INDICATOR POINTS COMPONENT
# TYPE JSON: "indicator_points"
# ROLE: selection, edition, tri et suppression des points lies a l'indicateur.
# CONFIGURATION: `equipmentAjax`, `pointAjax`, `equipmentOptions`, `maxRows`,
# `columns`, `editorFields`, `showColor`, `showType`, `showChartType`.
*/

if (!window.G) {
    window.G = {};
}

G.ui = G.ui || {};
G.ui.GVIndicatorEditionV3Components = G.ui.GVIndicatorEditionV3Components || {};

(function () {
    const components = G.ui.GVIndicatorEditionV3Components;

    // ---- CREATION DU COMPOSANT ----

    // Cree le contexte puis initialise la vue, les donnees et les interactions du tableau.
    function createIndicatorPointsField(fieldId, field, state, helpers) {
        const context = createIndicatorPointsContext(fieldId, field, state, helpers);

        buildIndicatorPointsLayout(context);
        initializeIndicatorPointsTable(context);
        bindIndicatorPointsEvents(context);

        G.ui.initSelect2(context.toolbar);
        syncIndicatorPointsState(context);

        const ready = loadEquipmentOptions(context).then(function () {
            if (context.equipmentSelect.val()) {
                components.setByPath(context.state, context.equipmentStatePath, context.equipmentSelect.val());
                return loadPointOptions(context);
            }

            return true;
        }).then(function () {
            adjustIndicatorPointsColumns(context);
            return true;
        });

        return {
            element: context.container,
            ready: ready,
            destroy: function () {
                destroyIndicatorPointsField(context);
            }
        };
    }

    // Regroupe les references DOM et les valeurs partagees par les sous-fonctions.
    function createIndicatorPointsContext(fieldId, field, state, helpers) {
        const addButtonLabel = components.resolveUiText(field, "addButtonLabel", "");

        return {
            fieldId: fieldId,
            field: field,
            state: state,
            helpers: helpers,
            container: $('<div class="gv-indicator-points"></div>'),
            hiddenInput: $('<input type="hidden" />').attr("id", fieldId).attr("name", field.name),
            toolbar: $('<div class="gvg-r gvg-r--gutter mod--valign-bottom"></div>'),
            equipmentColumn: $('<div class="gvg-2on6--narrow gvg-6on6"></div>'),
            pointColumn: $('<div class="gvg-2on6--narrow gvg-6on6"></div>'),
            buttonColumn: $('<div class="gvg-1on6--narrow gvg-6on6"></div>'),
            equipmentSelect: $('<select class="select2 select2-full-width"></select>').attr("id", fieldId + "-equipment"),
            pointSelect: $('<select class="select2 select2-full-width"></select>').attr("id", fieldId + "-point"),
            addButton: $('<button type="button" class="uicomp__button uicomp--brand"></button>')
                .attr("title", addButtonLabel)
                .attr("aria-label", addButtonLabel)
                .html('<i class="fas fa-plus"></i>'),
            tableTitle: $('<h3></h3>').text(components.resolveUiText(field, "tableTitle", "")),
            table: $('<table class="ui-lean gv-table gv-table--auto-wrap--body gv-indicator-table"></table>').attr("id", fieldId + "-table"),
            maxRows: field.maxRows || 3,
            equipmentStatePath: field.equipmentStatePath || "__runtime.selected_equipment_id",
            datatable: null,
            editor: null
        };
    }

    // Construit la barre de selection et le tableau sans la logique metier.
    function buildIndicatorPointsLayout(context) {
        const field = context.field;

        context.equipmentColumn.append(
            $('<label class="uicomp__label"></label>')
                .attr("for", context.equipmentSelect.attr("id"))
                .text(components.resolveUiText(field, "equipmentLabel", "Equipement")),
            context.equipmentSelect
        );

        context.pointColumn.append(
            $('<label class="uicomp__label"></label>')
                .attr("for", context.pointSelect.attr("id"))
                .text(components.resolveUiText(field, "pointLabel", "Point")),
            context.pointSelect
        );

        context.buttonColumn.append(context.addButton);

        context.toolbar.append(
            context.equipmentColumn,
            context.pointColumn,
            context.buttonColumn
        );

        context.container.append(
            context.hiddenInput,
            context.toolbar
        );

        if (context.tableTitle.text()) {
            context.container.append(context.tableTitle);
        }

        context.container.append(context.table);
    }

    // ---- ETAT ET OPTIONS ----

    // Lit les lignes courantes du formulaire.
    function getIndicatorPointsRows(context) {
        const value = components.getByPath(context.state, context.field.name);
        return Array.isArray(value) ? value : [];
    }

    // Recopie les lignes visibles dans le state et dans le champ cache du formulaire.
    function syncIndicatorPointsState(context) {
        if (!context.datatable) {
            return;
        }

        const rows = context.datatable.rows().data().toArray();
        components.setByPath(context.state, context.field.name, rows);
        context.hiddenInput.val(JSON.stringify(rows));
        context.addButton.prop("disabled", rows.length >= context.maxRows);
    }

    // Normalise les lignes initiales pour garantir un identifiant DataTables et une position.
    function normalizeIndicatorPointsRows(rows) {
        return rows.map(function (row, index) {
            const normalizedRow = $.extend(true, {}, row);
            if (!normalizedRow.DT_RowId) {
                normalizedRow.DT_RowId = "DT_RowId_" + (normalizedRow.id || (Date.now() + "_" + index));
            }
            if (normalizedRow.position === undefined || normalizedRow.position === null) {
                normalizedRow.position = index + 1;
            }
            return normalizedRow;
        });
    }

    // Injecte une liste d'options dans un select
    function fillSelectOptions(context, selectElement, options, labelResolver) {
        selectElement.empty();
        (options || []).forEach(function (option, index) {
            const value = option.id !== undefined ? option.id : option.value;
            const label = typeof labelResolver === "function"
                ? labelResolver(option)
                : components.resolveOptionLabel(option, context.field);
            selectElement.append(new Option(label, value, index === 0, index === 0));
        });
        selectElement.trigger("change");
    }

    // Charge les équipements depuis la configuration locale ou via une requête AJAX.
    function loadEquipmentOptions(context) {
        const field = context.field;

        // Si les options sont déjà fournies dans la configuration, les charge directement.
        if (Array.isArray(field.equipmentOptions)) {
            fillSelectOptions(
                context,
                context.equipmentSelect,
                field.equipmentOptions,
                function (equipment) {
                    return components.resolveTemplate("{nom} (#{id})", equipment);
                }
            );

            return Promise.resolve();
        }

        // Si aucun chargement AJAX n'est configuré, il n'y a rien à faire.
        if (
            !field.equipmentAjax
        ) {
            return Promise.resolve();
        }

        // Récupère les équipements depuis l'endpoint configuré puis remplit la liste déroulante.
        return context.helpers
            .loadFieldOptionsFromConfig(field.equipmentAjax, field)
            .then(function (options) {
                fillSelectOptions(
                    context,
                    context.equipmentSelect,
                    options,
                    function (equipment) {
                        return components.resolveTemplate(
                            field.equipmentOptionLabelTemplate || "{nom} (#{id})",
                            equipment
                        );
                    }
                );
            });
    }

    // Recharge les points disponibles quand l'équipement sélectionné change.
    function loadPointOptions(context) {
        const field = context.field;

        // Si aucun chargement AJAX n'est configuré, il n'y a rien à faire.
        if (
            !field.pointAjax
        ) {
            return Promise.resolve();
        }

        // Ajoute l'équipement sélectionné aux paramètres obligatoires de la requête.
        const ajaxConfig = $.extend(true, {}, field.pointAjax, {
            requiredPaths: (field.pointAjax.requiredPaths || []).concat(
                context.equipmentStatePath
            )
        });

        // Récupère les points correspondant à l'équipement puis remplit la liste déroulante.
        return context.helpers
            .loadFieldOptionsFromConfig(ajaxConfig, field)
            .then(function (options) {
                fillSelectOptions(
                    context,
                    context.pointSelect,
                    options,
                    function (point) {
                        return point.labelHumain || point.nom || point.label || point.id;
                    }
                );
            });
    }

    // ---- COLONNES ET CHAMPS EDITABLES ----

    // Retourne les options de couleur utilisees par le select inline.
    function getIndicatorPointsColorOptions(context) {
        const colors = context.helpers.ui && context.helpers.ui.colors ? context.helpers.ui.colors : {};
        return context.field.colorOptions || [
            { label: colors.default || "", value: null }, { label: colors.gray || "", value: 0 },
            { label: colors.blue || "", value: 1 }, { label: colors.lightBlue || "", value: 6 },
            { label: colors.brown || "", value: 3 }, { label: colors.yellow || "", value: 4 },
            { label: colors.orange || "", value: 9 }, { label: colors.red || "", value: 5 },
            { label: colors.pink || "", value: 10 }, { label: colors.lightGreen || "", value: 2 },
            { label: colors.purple || "", value: 8 }, { label: colors.green || "", value: 7 },
            { label: colors.black || "", value: 11 }, { label: colors.darkPurple || "", value: 12 },
            { label: colors.darkPink || "", value: 13 }, { label: colors.lightRed || "", value: 14 },
            { label: colors.lightOrange || "", value: 15 }
        ];
    }

    // Retire des champs internes les colonnes des options desactivees par la config.
    function filterIndicatorPointsColumns(context, columns) {
        return columns.filter(function (column) {
            if (column.data === "color") return context.field.showColor !== false;
            if (column.data === "type") return context.field.showType !== false;
            if (column.data === "typeGraphique") return context.field.showChartType !== false;
            return true;
        });
    }

    // Construit les champs que DataTables Editor affiche lors de l'edition inline.
    function getIndicatorPointsEditorFields(context) {
        const field = context.field;
        if (Array.isArray(field.editorFields)) return field.editorFields;
        const fields = [
            { title: "", name: "id", type: "readonly" }, { title: "", name: "DT_RowId", type: "readonly" },
            { title: "", name: "position", type: "readonly" }, { title: "", name: "point.equipement.nom", type: "readonly" },
            { title: "", name: "point_id", type: "readonly" }, { title: "", name: "point.labelHumain", type: "readonly" },
            { title: "", name: "label", type: "text" },
            { title: "", name: "color", type: "select", def: null, options: getIndicatorPointsColorOptions(context) },
            { title: "", name: "type", type: "select", options: [
                { label: components.resolveUiText(field, "defaultOptionLabel", ""), value: null }, { label: "arearange", value: "arearange" }
            ] },
            { title: "", name: "typeGraphique", type: "select", options: [
                { label: components.resolveUiText(field, "defaultOptionLabel", ""), value: null }, { label: "column_stack", value: "column_stack" },
                { label: "arearange", value: "arearange_v2" }, { label: "histogramme", value: "histogramme" }
            ] }
        ];
        return fields.filter(function (item) {
            if (item.name === "color") return field.showColor !== false;
            if (item.name === "type") return field.showType !== false;
            if (item.name === "typeGraphique") return field.showChartType !== false;
            return true;
        });
    }

    // Construit les colonnes visibles du tableau, avec le rendu de couleur et de suppression.
    function getIndicatorPointsColumns(context) {
        const field = context.field;
        if (Array.isArray(field.columns)) return field.columns;
        return filterIndicatorPointsColumns(context, [
            { title: "Id", data: "id", visible: false, defaultContent: null },
            { title: "", data: "DT_RowId", visible: false, defaultContent: "" },
            { title: "", data: "position", className: "reorder mod--collapse text-center row-not-editable", defaultContent: "", render: function (data, type) { return type === "display" ? '<i class="fas fa-grip-horizontal"></i>' : data; } },
            { title: components.resolveUiText(field, "equipmentColumnLabel", "Equipement"), data: "point.equipement.nom", className: "row-not-editable", defaultContent: "" },
            { title: "Point Id", data: "point_id", visible: false, defaultContent: null },
            { title: components.resolveUiText(field, "pointColumnLabel", "Point"), data: "point.labelHumain", className: "row-not-editable", defaultContent: "" },
            { title: components.resolveUiText(field, "labelColumnLabel", "Libelle"), data: "label", defaultContent: "" },
            { title: components.resolveUiText(field, "colorColumnLabel", "Couleur"), data: "color", defaultContent: "", render: function (data, type) { if (type !== "display" || data === null || data === undefined || data === "") return data || ""; return renderIndicatorPointColorDot(data); } },
            { title: components.resolveUiText(field, "typeColumnLabel", "Type"), data: "type", defaultContent: "" },
            { title: components.resolveUiText(field, "chartTypeColumnLabel", "Type graphique"), data: "typeGraphique", defaultContent: "", render: function (data) { return data === -1 ? components.resolveUiText(field, "defaultOptionLabel", "") : data; } },
            { title: "", data: null, className: "row-remove row-not-editable dt-center", render: function () { return '<div class="uicomp__icon uicomp--small"><i class="fas fa-trash"></i></div>'; } }
        ]);
    }

    // ---- DATATABLE ET EDITEUR ----

    // Cree DataTables Editor et le tableau a partir de la configuration du champ.
    function initializeIndicatorPointsTable(context) {
        const tableId = "#" + context.table.attr("id");
        context.editor = new DataTable.Editor({ idSrc: "DT_RowId", fields: getIndicatorPointsEditorFields(context), table: tableId });
        context.datatable = context.table.DataTable({
            destroy: true, paging: false, info: false, searching: false, lengthChange: false, autoWidth: false,
            data: normalizeIndicatorPointsRows(getIndicatorPointsRows(context)), columns: getIndicatorPointsColumns(context),
            rowId: "DT_RowId", rowReorder: { update: true, dataSrc: "position", editor: context.editor },
            columnDefs: (context.field.columnDefs || []).concat([{ targets: "_all", orderable: false }]),
            language: (context.helpers.ui && context.helpers.ui.datatable) || {}
        });
    }

    // Ajuste les largeurs apres l'initialisation ou l'ouverture d'un editeur inline.
    function adjustIndicatorPointsColumns(context) {
        setTimeout(function () {
            if (context.datatable) context.datatable.columns.adjust().draw(false);
        }, 0);
    }

    // Rend la pastille de couleur via une classe CSS plutot qu'un style inline.
    function renderIndicatorPointColorDot(colorIndex) {
        return '<div class="text-center"><i class="fas fa-circle gv-indicator-color-dot ' + components.getPaletteColorClass(colorIndex) + '"></i></div>';
    }

    // ---- EVENEMENTS ----

    // Branche l'édition inline, le réordonnancement, la suppression et l'ajout d'une ligne.
    function bindIndicatorPointsEvents(context) {
        const editor = context.editor;
        const table = context.table;
        const datatable = context.datatable;

        // Juste avant l'ouverture de l'éditeur : désactive les champs techniques non modifiables.
        editor.on("preOpen", function () {
            [
                "id",
                "position",
                "DT_RowId",
                "point.equipement.nom",
                "point_id",
                "point.labelHumain"
            ].forEach(function (fieldName) {
                if (editor.field(fieldName)) {
                    editor.field(fieldName).disable();
                }
            });

            adjustIndicatorPointsColumns(context);
        });

        // Quand l'éditeur inline est ouvert : initialise les Select2, ajuste le tableau et bloque les boutons de la popup.
        editor.on("open", function () {
            table.find("select").addClass("select2-full-width");
            G.ui.initSelect2(table);
            adjustIndicatorPointsColumns(context);
            Swal.disableButtons();
        });

        // Quand l'éditeur se ferme : réajuste le tableau et réactive les boutons de la popup.
        editor.on("close", function () {
            adjustIndicatorPointsColumns(context);
            Swal.enableButtons();
        });

        // À l'initialisation d'une création ou d'une édition : cache le champ position géré automatiquement.
        editor.on("initCreate initEdit", function () {
            if (editor.field("position")) {
                editor.hide("position");
            }

            adjustIndicatorPointsColumns(context);
        });

        // Après une modification enregistrée avec succès : retrie les lignes par position et synchronise le state.
        editor.on("submitSuccess", function () {
            datatable.order([2, "asc"]).draw();
            syncIndicatorPointsState(context);
        });

        // Après le déplacement manuel d'une ligne : enregistre les nouvelles positions puis synchronise le state.
        datatable.on("row-reorder", function (event, details, changes) {
            editor
                .edit(changes.nodes, false, { submit: "changed" })
                .multiSet(changes.dataSrc, changes.values)
                .submit();

            syncIndicatorPointsState(context);
        });

        // Au clic sur une cellule modifiable : ouvre toute la ligne en édition inline.
        datatable.on(
            "click",
            "tbody td:not(:first-child, .row-not-editable, .row-remove)",
            function () {
                editor.inline(
                    datatable.cells(this.parentNode, "*").nodes(),
                    {
                        onBlur: "submit",
                        submitTrigger: -1,
                        submitHtml:
                            '<div class="uicomp__icon uicomp--small">' +
                                '<i class="fas fa-save"></i>' +
                            "</div>"
                    }
                );
            }
        );

        // Au clic sur la poubelle : supprime la ligne du tableau puis synchronise le state.
        datatable.on("click", "tbody td.row-remove", function () {
            datatable
                .row($(this).parents("tr"))
                .remove()
                .draw(false);

            syncIndicatorPointsState(context);
        });

        // Après chaque redraw du tableau : recopie les lignes affichées dans le state et le champ caché.
        datatable.on("draw", function () {
            syncIndicatorPointsState(context);
        });

        // Quand l'équipement sélectionné change : mémorise son identifiant et recharge ses points.
        context.equipmentSelect.on("change", function () {
            components.setByPath(
                context.state,
                context.equipmentStatePath,
                $(this).val() || null
            );

            loadPointOptions(context);
        });

        // Au clic sur le bouton d'ajout : ajoute au tableau le point actuellement sélectionné.
        context.addButton.on("click", function () {
            addIndicatorPointFromSelection(context);
        });
    }

    // Ajoute la combinaison equipement/point selectionnee dans le tableau.
    function addIndicatorPointFromSelection(context) {
        // Cherche les équipements/points séléctionnées
        const equipment = context.equipmentSelect.select2("data")[0];
        const point = context.pointSelect.select2("data")[0];
        if (!equipment || !point || context.datatable.rows().count() >= context.maxRows) return;

        // Construit la ligne à ajouter
        const row = {
            id: null, DT_RowId: "DT_RowId_" + Date.now(), position: context.datatable.rows().count() + 1,
            point_id: point.id,
            point: { id: point.id, labelHumain: point.text, equipement: { id: equipment.id, nom: equipment.text.replace(/\s*\(#\d+\)\s*$/, "") } },
            label: point.text
        };
        if (context.field.showColor !== false) row.color = "";
        if (context.field.showType !== false) row.type = "";
        if (context.field.showChartType !== false) row.typeGraphique = "";
        context.datatable.row.add(row).draw(false);
        context.datatable.order([2, "asc"]).draw();
        // Met à jour le state
        syncIndicatorPointsState(context);
    }

    // Nettoie les widgets et evenements locaux de ce composant avant fermeture de la popup.
    function destroyIndicatorPointsField(context) {
        components.destroySelect2(context.equipmentSelect);
        components.destroySelect2(context.pointSelect);
        context.equipmentSelect.off();
        context.pointSelect.off();
        context.addButton.off();
        context.table.off();
        context.hiddenInput.off();
        components.destroyThirdPartyInstance(context.editor);
        components.destroyThirdPartyInstance(context.datatable);
        context.editor = null;
        context.datatable = null;
    }

    components.createIndicatorPointsField = createIndicatorPointsField;
})();

/*
# SLIDER COMPONENT
# TYPE JSON: "slider"
# RENDU: formulaire d'ajout rapide + tableau editable de seuils numeriques + apercu du slider.
# SELECTION DU COMPOSANT: le builder route ici quand `field.type` vaut "slider".
# ROLE: sert a configurer les tranches min/max/couleur d'un slider ou d'une jauge.
# OPTIONS UTILES: `name`, `minFieldName`, `maxFieldName`, `minStatePath`, `maxStatePath`, `stateOptions`, `startLabel`, `endLabel`, `stateLabel`.
*/

if (!window.G) {
    window.G = {};
}

G.ui = G.ui || {};
G.ui.GVIndicatorEditionV3Components = G.ui.GVIndicatorEditionV3Components || {};

(function () {
    const components = G.ui.GVIndicatorEditionV3Components;



    // Construit tout le composant slider: saisie des paliers, table editable et apercu visuel.
    function createSliderField(fieldId, field, state, helpers) {
        const context = createTicksContext(fieldId, field, state, helpers);
        initializeTicksToolbar(context);
        initializeTicksDatatable(context);
        const templatesReady = loadTicksTemplates(context);

        // Branche tout le comportement interactif du composant.
        bindTicksEditorEvents(context);
        bindTicksDatatableEvents(context);
        bindTicksToolbarEvents(context);

        finalizeTicksInitialization(context);
        return {
            element: context.layout.container,
            ready: templatesReady,
            destroy: function () {
                destroyTicksField(context);
            }
        };
    }

    // Prepare tous les objets partages par les differentes briques du composant.
    function createTicksContext(fieldId, field, state, helpers) {
        const layout = buildTicksLayout(fieldId, field, helpers);

        return {
            fieldId: fieldId,
            field: field,
            state: state,
            helpers: helpers || {},
            layout: layout,
            stateOptions: resolveTicksStateOptions(field, helpers),
            datatable: null,
            editor: null,
            isDestroyed: false
        };
    }

    // Renseigne les options de couleur du formulaire d'ajout rapide.
    function initializeTicksToolbar(context) {
        context.stateOptions.forEach(function (option, index) {
            context.layout.stateSelect.append(new Option(option.label, option.value, index === 0, index === 0));
        });
    }

    // Instancie l'editeur inline puis la DataTable principale.
    function initializeTicksDatatable(context) {
        context.editor = createTicksEditor(context.layout.table, context.stateOptions);
        context.datatable = createTicksDatatable(context.layout.table, context.field, getTicksRowsFromState(context), context.helpers);
    }

    // Charge les modeles de paliers puis les injecte dans la collection du bouton bleu.
    function loadTicksTemplates(context) {
        return context.helpers.loadFieldOptionsFromConfig(context.field.templatesAjax, {
            name: context.field.name + ".templates"
        }).then(function (templates) {
            if (context.isDestroyed) {
                return;
            }

            rebuildTicksTemplateCollection(context, templates);
        }, function () {
            if (context.isDestroyed) {
                return;
            }

            rebuildTicksTemplateCollection(context, []);
        });
    }

    // Remplit la collection avec les modeles disponibles ou un etat vide non cliquable.
    function rebuildTicksTemplateCollection(context, templates) {
        let templateButtons = [{
            text: context.field.noTemplateAvailableLabel,
            enabled: false
        }];

        if (templates.length) {
            templateButtons = templates.map(function (template) {
                return {
                    text: template.label,
                    action: function () {
                        applyTicksTemplate(context, template.ticks);
                    }
                };
            });
        }

        context.datatable.button(0).collectionRebuild(templateButtons);
    }

    // Remplace les paliers courants par ceux du modele selectionne.
    function applyTicksTemplate(context, templateTicks) {
        const rows = templateTicks.map(function (tick, index) {
            return {
                DT_RowId: "DT_RowId_" + index + "_" + Date.now(),
                start: tick.start,
                end: tick.end,
                state: tick.state
            };
        });

        context.datatable.clear();
        context.datatable.rows.add(rows);
        context.datatable.draw();
    }

    // Termine l'initialisation visuelle et met le state en coherence avec la table.
    function finalizeTicksInitialization(context) {
        G.ui.initSelect2(context.layout.toolbar);
        syncTicksRows(context);
        adjustTicksColumns(context);
    }

    // ---- EVENEMENTS ----

    // Branche les evenements de l'editeur inline de DataTable.
    function bindTicksEditorEvents(context) {
        context.editor.on("preOpen", function () {
            if (context.editor.field("DT_RowId")) {
                context.editor.field("DT_RowId").disable();
            }
        });

        // Quand la popup s'ouvre
        context.editor.on("open", function () {
            context.layout.table.find("select").addClass("select2-full-width");
            G.ui.initSelect2(context.layout.table);
            adjustTicksColumns(context);
            Swal.disableButtons();
        });

        context.editor.on("close", function () {
            adjustTicksColumns(context);
            Swal.enableButtons();
        });

        // Vérifie la validité des intervalles lors de l'édition
        context.editor.on("preSubmit", function () {
            return validateTicksInlineEdition(context, this);
        });

        // Met à jour le state et l'appercu après l'édition
        context.editor.on("submitSuccess", function () {
            syncTicksRows(context);
        });
    }

    // Branche les evenements portes par la DataTable elle-meme.
    function bindTicksDatatableEvents(context) {
        // Click sur une cellule editable, passe la ligne en mode édition
        context.datatable.on("click", "tbody td:not(.row-not-editable)", function () {
            context.editor.inline(context.datatable.cells(this.parentNode, "*").nodes(), {
                onBlur: "submit",
                submitTrigger: -1,
                submitHtml: '<div class="uicomp__icon uicomp--small"><i class="fas fa-save"></i></div>'
            });
        });

        // Supprime une ligne de la table
        context.datatable.on("click", "tbody td.row-remove", function () {
            context.datatable.row($(this).parents("tr")).remove().draw();
            syncTicksRows(context);
        });

        // Chaque fois que la table est mise à jours on met à jour le state et l'appercu
        context.datatable.on("draw", function () {
            syncTicksRows(context);
        });
    }

    // Branche les controles du bouton d'ajout.
    function bindTicksToolbarEvents(context) {
        context.layout.addButton.on("click", function () {
            addTicksRowFromToolbar(context);
        });
    }

    // ---- TABLEAU / STATE ----

    // Lit la valeur deja presente dans le state et la transforme en lignes exploitables par DataTable.
    function getTicksRowsFromState(context) {
        const value = components.getByPath(context.state, context.field.name);

        if (!Array.isArray(value)) {
            return [];
        }

        // Le state compact [[min, max, status], ...] est transforme en lignes DataTable plus faciles a editer.
        return value.map(function (tick, index) {
            return {
                DT_RowId: "DT_RowId_" + index + "_" + Date.now(),
                start: tick[0],
                end: tick[1],
                state: tick[2]
            };
        });
    }

    // Recalcule tout le state du composant depuis la source de donnée: la DataTable.
    function syncTicksRows(context) {
        const rows = getSortedTicksRows(context);
        const serializedTicks = [];
        let minValue;
        let maxValue;

        // On recalcule min/max a partir des lignes reelles plutot que de passer par d'encien hidden inputs.
        rows.forEach(function (row) {
            minValue = minValue === undefined ? row.start : Math.min(minValue, row.start);
            maxValue = maxValue === undefined ? row.end : Math.max(maxValue, row.end);
            serializedTicks.push([parseFloat(row.start), parseFloat(row.end), row.state]);
        });

        components.setByPath(context.state, context.field.name, serializedTicks);
        components.setByPath(context.state, context.field.minStatePath || "__runtime.indicatorTicksMin", minValue);
        components.setByPath(context.state, context.field.maxStatePath || "__runtime.indicatorTicksMax", maxValue);
        context.layout.hiddenInput.val(JSON.stringify(serializedTicks));
        context.layout.minHiddenInput.val(minValue === undefined ? "" : minValue);
        context.layout.maxHiddenInput.val(maxValue === undefined ? "" : maxValue);
        refreshTicksPreview(context, rows);
    }

    // Ajoute une ligne a partir des controles du haut puis laisse la DataTable retrier par debut.
    function addTicksRowFromToolbar(context) {
        const startValue = parseFloat(context.layout.startInput.val());
        const endValue = parseFloat(context.layout.endInput.val());
        const statusValue = context.layout.stateSelect.val();

        if (!isValidTicksRange(startValue, endValue)) {
            return;
        }

        if (!hasNoTicksOverlap(context, startValue, endValue, null)) {
            return;
        }

        context.datatable.row.add({
            DT_RowId: "DT_RowId_" + Date.now(),
            start: startValue,
            end: endValue,
            state: statusValue
        }).draw(false);

        syncTicksRows(context);
        context.layout.startInput.val("");
        context.layout.endInput.val("");
    }

    // Verifie qu'une edition inline ne produit pas un intervalle invalide ou chevauchant.
    function validateTicksInlineEdition(context, editorInstance) {
        const tickRowId = editorInstance.field("DT_RowId").val();
        const tickStart = parseFloat(editorInstance.field("start").val());
        const tickEnd = parseFloat(editorInstance.field("end").val());

        // La validation est faite avant submit Editor pour bloquer tout intervalle incoherent directement dans la popup.
        if (!isValidTicksRange(tickStart, tickEnd)) {
            editorInstance.field("end").error(components.resolveUiText(context.field, "invalidRangeLabel", "Intervalle invalide"));
            return false;
        }

        if (!hasNoTicksOverlap(context, tickStart, tickEnd, tickRowId)) {
            editorInstance.field("end").error(components.resolveUiText(context.field, "overlapLabel", "Les intervalles ne doivent pas se chevaucher"));
            return false;
        }

        return true;
    }

    // ---- APERCU ----

    // Reconstruit l'apercu du slider a partir des lignes actuellement visibles dans la table.
    function refreshTicksPreview(context, rows) {
        const previewRows = Array.isArray(rows) ? rows : getSortedTicksRows(context);
        const previewSettings = buildTicksPreviewSettings(context, previewRows);

        if (!previewSettings) {
            // Si aucun palier n'existe encore, il n'y a rien a afficher dans l'apercu.
            $("#indicator-" + context.layout.previewIndicatorId + "__slider").empty();
            return;
        }

        // On reutilise le vrai renderer historique du slider pour garder exactement le meme apercu.
        MONITORING._indicatorsRenderSliderOrGauge(context.layout.previewIndicatorId, previewSettings);
    }

    // Construit l'objet de configuration attendu par le renderer du slider.
    function buildTicksPreviewSettings(context, rows) {
        let minValue;
        let maxValue;
        const previewSettings = {
            mode: getTicksPreviewMode(context),
            min: null,
            max: null,
            unite: "",
            ticks: []
        };

        // On reconstruit entierement les bornes et tranches a partir des lignes actuellement visibles.
        rows.forEach(function (row) {
            minValue = minValue === undefined ? parseFloat(row.start) : Math.min(minValue, parseFloat(row.start));
            maxValue = maxValue === undefined ? parseFloat(row.end) : Math.max(maxValue, parseFloat(row.end));
            previewSettings.ticks.push({
                from: parseFloat(row.start),
                to: parseFloat(row.end),
                color: row.state
            });
        });

        if (minValue === undefined || maxValue === undefined) {
            return null;
        }

        previewSettings.min = minValue;
        previewSettings.max = maxValue;
        return previewSettings;
    }

    // Determine si l'apercu doit etre rendu en mode slider ou gauge.
    function getTicksPreviewMode(context) {
        const modePath = context.field.modeStatePath || String(context.field.name || "").replace(/\.tick$/, ".mode");
        const modeValue = components.getByPath(context.state, modePath);

        // Le mode du slider est lu directement dans le state pour suivre le select de l'etape precedente.
        return modeValue || "slider";
    }

    // ---- CONSTRUCTION DOM ----

    // Construit toute la structure DOM du composant, sans encore brancher DataTable ni l'apercu dynamique.
    function buildTicksLayout(fieldId, field, helpers) {
        // Conteneur principal du composant.
        const container = $('<div class="gv-indicator-ticks"></div>');

        // Champs caches utilises pour la soumission du formulaire.
        const hiddenInput = $('<input type="hidden" />').attr("id", fieldId).attr("name", field.name);
        const minHiddenInput = $('<input type="hidden" />').attr("id", fieldId + "-min").attr("name", field.minFieldName || "indicatorTicksMin");
        const maxHiddenInput = $('<input type="hidden" />').attr("id", fieldId + "-max").attr("name", field.maxFieldName || "indicatorTicksMax");

        // Barre d'ajout rapide des nouveaux paliers.
        const toolbar = $('<div class="gvg-r gvg-r--gutter mod--valign-bottom"></div>');

        // Champs de saisie du nouvel intervalle.
        const startInput = $('<input type="number" class="uicomp__input" />').attr("id", fieldId + "-start");
        const endInput = $('<input type="number" class="uicomp__input" />').attr("id", fieldId + "-end");
        const stateSelect = $('<select class="select2 select2-full-width"></select>').attr("id", fieldId + "-state");

        // Bouton d'ajout d'un nouveau palier.
        const addButtonLabel = components.resolveUiText(field, "addButtonLabel", components.resolveUiText(field, "addButtonLabelKey", ""));
        const addButton = $('<button type="button" class="uicomp__button uicomp--brand"></button>')
            .attr("title", addButtonLabel)
            .attr("aria-label", addButtonLabel)
            .html('<i class="fas fa-plus"></i>');

        // Tableau des paliers et identifiant de l'apercu.
        const table = $('<table class="ui-lean gv-table gv-table--auto-wrap--body"></table>').attr("id", fieldId + "-table");
        const contentRow = $('<div class="gvg-r gvg-r--gutter"></div>');
        const previewIndicatorId = "preview-" + fieldId;

        // Assemble la barre d'ajout rapide.
        toolbar
            .append(buildTicksToolbarColumn(startInput, components.resolveUiText(field, "startLabel", "Debut"), "gvg-6on6 gvg-1on6--narrow"))
            .append(buildTicksToolbarColumn(endInput, components.resolveUiText(field, "endLabel", "Fin"), "gvg-6on6 gvg-1on6--narrow"))
            .append(buildTicksToolbarColumn(stateSelect, components.resolveUiText(field, "stateLabel", "Etat"), "gvg-6on6 gvg-2on6--narrow"))
            .append($('<div class="gvg-6on6 gvg-1on6--narrow"></div>').append(addButton));

        // Assemble les zones tableau et apercu.
        contentRow
            .append(buildTicksTableSection(field, table, helpers))
            .append(buildTicksPreviewSection(field, previewIndicatorId, helpers));

        // Assemble la structure complete du composant.
        container
            .append(hiddenInput)
            .append(minHiddenInput)
            .append(maxHiddenInput)
            .append(toolbar)
            .append(contentRow);

        return {
            container: container,
            hiddenInput: hiddenInput,
            minHiddenInput: minHiddenInput,
            maxHiddenInput: maxHiddenInput,
            toolbar: toolbar,
            startInput: startInput,
            endInput: endInput,
            stateSelect: stateSelect,
            addButton: addButton,
            table: table,
            previewIndicatorId: previewIndicatorId
        };
    }

    // Construit une colonne simple de la barre d'ajout rapide avec son label et son controle.
    function buildTicksToolbarColumn(input, label, columnClass) {
        return $('<div></div>').addClass(columnClass || "gvg-2on6--narrow gvg-6on6")
            .append($('<label class="uicomp__label"></label>').attr("for", input.attr("id")).text(label))
            .append(input);
    }

    // Construit uniquement la zone tableau des seuils.
    function buildTicksTableSection(field, table, helpers) {
        return $('<div class="gvg-6on6 gvg-3on6--narrow"></div>')
            .append(
                $('<div class="gv-indicator-ticks__panel"></div>')
                    .append($('<h3></h3>').text(components.resolveUiText(field, "tableTitle", helpers.ui && helpers.ui.ticks ? helpers.ui.ticks.steps : "")))
                    .append(table)
            );
    }

    // Construit uniquement la zone d'apercu du slider/jauge.
    function buildTicksPreviewSection(field, previewIndicatorId, helpers) {
        const previewIndicator = $(
            '<div class="indicator indicator--size-dimensions-5-1">'
            + '    <div class="ind__inner">'
            + '        <div class="ind__content">'
            + '            <div id="indicator-' + previewIndicatorId + '__slider" class="ind__slider-container"></div>'
            + '        </div>'
            + '    </div>'
            + '</div>'
        );
        const previewHelp = $(
            '<div class="gvfeedback mod--information mod--small">'
            + '    <div class="__icon"><i class="fas fa-info-circle"></i></div>'
            + '    <div class="__content">' + components.resolveUiText(field, "previewHelper", helpers.ui && helpers.ui.ticks ? helpers.ui.ticks.sliderPreviewHelp : "") + '</div>'
            + '</div>'
        );

        return $('<div class="gvg-6on6 gvg-3on6--narrow"></div>')
            .append(
                $('<div class="gv-indicator-ticks__panel"></div>')
                    .append($('<h3></h3>').text(components.resolveUiText(field, "previewTitle", helpers.ui && helpers.ui.ticks ? helpers.ui.ticks.preview : "")))
                    .append(previewIndicator)
                    .append(previewHelp)
            );
    }

    // ---- DATATABLE / EDITOR ----

    // Cree l'editeur inline de DataTable pour modifier une ligne de seuil existante.
    function createTicksEditor(table, stateOptions) {
        return new DataTable.Editor({
            idSrc: "DT_RowId",
            fields: [
                { title: "", name: "DT_RowId", type: "readonly" },
                { title: "", name: "start", type: "text", attr: { type: "number" } },
                { title: "", name: "end", type: "text", attr: { type: "number" } },
                { title: "", name: "state", type: "select", def: "status-alert", options: stateOptions }
            ],
            table: "#" + table.attr("id")
        });
    }

    // Cree la DataTable qui affiche la liste complete des seuils.
    function createTicksDatatable(table, field, rows, helpers) {
        return table.DataTable({
            destroy: true,
            autoWidth: false,
            paging: false,
            info: false,
            searching: false,
            lengthChange: false,
            dom: "Bt",
            buttons: [
                {
                    text: field.applyTemplateLabel + '&nbsp;<i class="fas fa-cloud-download-alt"></i>',
                    extend: "collection",
                    className: "uicomp__button uicomp--blue",
                    popoverTitle: '<div class="gvfeedback mod--warning mod--small">'
                        + '    <div class="__icon"><i class="fas fa-exclamation-triangle"></i></div>'
                        + '    <div class="__content">' + field.applyTemplateWarning + "</div>"
                        + "</div>",
                    buttons: [],
                    collectionLayout: "fixed",
                    autoClose: true
                }
            ],
            order: [[1, "asc"]],
            data: rows,
            columns: [
                { title: "", data: "DT_RowId", visible: false },
                { title: components.resolveUiText(field, "startColumnLabel", "Debut"), data: "start", defaultContent: "" },
                { title: components.resolveUiText(field, "endColumnLabel", "Fin"), data: "end", defaultContent: "" },
                {
                    title: components.resolveUiText(field, "stateColumnLabel", "Etat"),
                    data: "state",
                    defaultContent: "",
                    render: function (data, type) {
                        if (type === "display") {
                            // La colonne d'etat ne montre qu'un point colore, comme dans le rendu historique.
                            return renderTicksStateDot(data);
                        }

                        return data;
                    }
                },
                {
                    title: "",
                    data: null,
                    className: "row-remove dt-center",
                    render: function () {
                        return '<div class="uicomp__icon uicomp--small"><i class="fas fa-trash"></i></div>';
                    }
                }
            ],
            columnDefs: [
                { targets: [1], width: "35%" },
                { targets: [2], width: "35%", orderable: false },
                { targets: [3, 4], width: "15%", orderable: false }
            ],
            language: (helpers.ui && helpers.ui.datatable) || {}
        });
    }

    // ---- UTILITAIRES ----

    // Retourne les choix de statut/couleur configures pour ce composant.
    function resolveTicksStateOptions(field, helpers) {
        return field.stateOptions || [
            { label: helpers.ui && helpers.ui.ticks ? helpers.ui.ticks.red : "", value: "status-alert" },
            { label: helpers.ui && helpers.ui.ticks ? helpers.ui.ticks.orange : "", value: "status-warning" },
            { label: helpers.ui && helpers.ui.ticks ? helpers.ui.ticks.green : "", value: "status-ok" }
        ];
    }

    // Retourne les lignes de la table triees par valeur de debut pour garder un ordre stable.
    function getSortedTicksRows(context) {
        return context.datatable.rows({ order: "current" }).data().toArray().slice().sort(function (left, right) {
            return parseFloat(left.start) - parseFloat(right.start);
        });
    }

    // Redemande a DataTable de recalculer ses largeurs apres ouverture ou modification.
    function adjustTicksColumns(context) {
        setTimeout(function () {
            if (context.datatable) {
                context.datatable.columns.adjust().draw(false);
            }
        }, 0);
    }

    // Rend la pastille d'etat via une classe CSS plutot qu'une couleur inline.
    function renderTicksStateDot(status) {
        return '<div class="text-center"><i class="fas fa-circle gv-indicator-color-dot ' + components.getStatusColorClass(status) + '"></i></div>';
    }

    // Nettoie le formulaire rapide, la DataTable et l'editor inline avant destruction du DOM Swal.
    function destroyTicksField(context) {
        context.isDestroyed = true;
        components.destroySelect2(context.layout.stateSelect);
        context.layout.startInput.off();
        context.layout.endInput.off();
        context.layout.stateSelect.off();
        context.layout.addButton.off();
        context.layout.table.off();
        context.layout.hiddenInput.off();
        context.layout.minHiddenInput.off();
        context.layout.maxHiddenInput.off();
        components.destroyThirdPartyInstance(context.editor);
        components.destroyThirdPartyInstance(context.datatable);
        context.editor = null;
        context.datatable = null;
    }

    // Verifie qu'un intervalle est numeriquement valide avant tout ajout ou edition.
    function isValidTicksRange(startValue, endValue) {
        return !Number.isNaN(startValue) && !Number.isNaN(endValue) && startValue < endValue;
    }

    // Verifie qu'un nouveau palier ne chevauche aucun des paliers deja presents.
    function hasNoTicksOverlap(context, startValue, endValue, currentRowId) {
        // Chaque intervalle doit etre disjoint des autres pour garder une lecture deterministe du slider/jauge.
        return context.datatable.rows().data().toArray()
            .filter(function (tick) {
                return tick.DT_RowId !== currentRowId;
            })
            .every(function (tick) {
                return endValue <= parseFloat(tick.start) || startValue >= parseFloat(tick.end);
            });
    }

    components.createSliderField = createSliderField;
})();

if (!window.G) {
    window.G = {};
}

G.ui = G.ui || {};
G.ui.GVIndicatorEditionV3Components = G.ui.GVIndicatorEditionV3Components || {};

(function () {
    const components = G.ui.GVIndicatorEditionV3Components;

    // # Retourne le constructeur correspondant au type declare dans la config JSON.
    function createFieldInstance(field, context) {
        const factories = {
            text: function () {
                return { element: components.createTextLikeField(field, context.fieldId, context.currentValue, context.state, context.onChange) };
            },
            number: function () {
                return { element: components.createTextLikeField(field, context.fieldId, context.currentValue, context.state, context.onChange) };
            },
            textarea: function () {
                return { element: components.createTextLikeField(field, context.fieldId, context.currentValue, context.state, context.onChange) };
            },
            hr: function () {
                return {};
            },
            checkbox: function () {
                return { element: components.createCheckboxField(field, context.fieldId, context.currentValue, context.state, context.onChange) };
            },
            radio_group: function () {
                return { element: components.createRadioGroupField(field, context.fieldId, context.currentValue, context.state, context.onChange) };
            },
            choice_cards: function () {
                return components.createChoiceCardsField(field, context.fieldId, context.currentValue, context.state, context.onChange);
            },
            select: function () {
                return components.createSelectField(field, context.fieldId, context.currentValue, context.state, context.onChange, context.componentHelpers);
            },
            icon: function () {
                return components.createIconField(field, context.fieldId, context.currentValue, context.state, context.onChange, context.componentHelpers);
            },
            image: function () {
                return components.createImageField(field, context.fieldId, context.state, context.componentHelpers);
            },
            rules: function () {
                return components.createRulesField(context.fieldId, field, context.state, context.componentHelpers);
            },
            datatable_select_single: function () {
                return components.createDatatableSelectorField(context.fieldId, field, context.state, context.componentHelpers);
            },
            datatable_select_multiple: function () {
                return components.createDatatableSelectorField(context.fieldId, field, context.state, context.componentHelpers);
            },
            indicator_points: function () {
                return components.createIndicatorPointsField(context.fieldId, field, context.state, context.componentHelpers);
            },
            slider: function () {
                return components.createSliderField(context.fieldId, field, context.state, context.componentHelpers);
            }
        };

        if (!factories[field.type]) {
            throw new Error("Unknown indicator field type: " + field.type);
        }

        return factories[field.type]();
    }

    G.ui.GVIndicatorEditionV3ComponentList = {
        createFieldInstance: createFieldInstance
    };
})();

if (!window.G) {
    window.G = {};
}

G.ui = G.ui || {};

(function () {
    G.ui.GVIndicatorEditionEngineV3 = class {
        // Initialise le moteur d'edition avec le contexte minimum necessaire.
        constructor(options) {
            // Id de l'indicateur que la popup est en train de modifier.
            this.indicatorId = options.indicatorId;
            // Id du site auquel appartient cet indicateur.
            this.siteId = options.siteId;
            // Fonction a appeler quand la sauvegarde a reussi.
            this.onSaved = typeof options.onSaved === "function" ? options.onSaved : function () {};
            // Configuration brute du formulaire renvoyee par l'API.
            this.formConfig = null;
            // Nom, type et documentation associes a l'indicateur courant.
            this.indicatorMeta = {};
            this.ui = {};
            // Etat courant du formulaire avec les valeurs en cours d'edition.
            this.state = {};
            // Cache local des listes d'options deja chargees.
            this.optionCache = {};
            // References des composants JS instancies sur l'etape ouverte.
            this.fieldInstances = {};
            // Configuration de l'etape actuellement affichee.
            this.currentStepConfig = null;
            // Donnees deja preparees pour le POST final.
            this.payloadState = {};
            this.saveStarted = false;
            this.currentWizardStepIndex = 0;
            this.boundWizardConfirmHandler = null;
            this.boundWizardDenyHandler = null;
            this.boundWizardShortcutHandler = null;
            this.isWizardNavigating = false;
            // Dit si les steps 2..N sont en cours de prechargement en arriere-plan.
            this.isRemainingStepsPreloading = false;
            // Dit si le prechargement des steps 2..N a deja ete fait pour cette ouverture.
            this.areRemainingStepsPreloaded = false;
            // Promise partagee du prechargement pour ne jamais le lancer deux fois.
            this.remainingStepsPreloadPromise = null;
        }



        // ---- FORMULAIRE COMPLET ----

        // Point d'entree principal: charge la config JSON et les valeurs par defaut, puis lance le wizard.
        fire() {
            // Appelle apigv pour recuperer la config du formulaire d'edition
            $.ajax({
                url: G.config.SERVER + "apigv/indicators/configEditionForm/" + this.indicatorId,
                type: "GET",
                dataType: "json",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    Authorization: "Bearer " + G.model.userApiKey
                }
            }).done(function (response) {
                // On stocke la configuration brute du formulaire
                this.formConfig = response.response.form || { steps: [] };
                this.indicatorMeta = response.response.indicator || {};
                this.ui = response.response.ui || {};
                // On stoque l'etat du formulaire (valeur par defaut)
                // Copie profonde JSON pour partir des defaults backend sans garder de reference partagee modifiable.
                this.state = JSON.parse(JSON.stringify(response.response.defaults || {}));
                this.payloadState = {};
                this.saveStarted = false;
                this.currentWizardStepIndex = 0;
                this.isWizardNavigating = false;
                this.isRemainingStepsPreloading = false;
                this.areRemainingStepsPreloaded = false;
                this.remainingStepsPreloadPromise = null;
                // Le wizard garde une seule popup ouverte et change seulement son contenu.
                this.runFormStepFlow();
            }.bind(this)).fail(function (xhr) {
                const genericError = G.config.LOCALE_RETRIEVE("error_has_occured");
                const errorMessage = xhr && xhr.responseJSON && xhr.responseJSON.message
                    ? xhr.responseJSON.message
                    : genericError;

                Swal.fire(
                    G.ui.GVIndicatorEditionV3PopupConfig.getErrorPopupConfig(
                        errorMessage,
                        {
                            error: genericError
                        }
                    )
                );
            }.bind(this));
        }

        // Ouvre le wizard sous forme d'une unique popup qui change d'etape sans se refermer.
        async runFormStepFlow() {
            this.currentWizardStepIndex = 0;
            await this.openWizardPopup();
        }

        // Retourne la liste des etapes declarees dans la config.
        getSteps() {
            return Array.isArray(this.formConfig && this.formConfig.steps) ? this.formConfig.steps : [];
        }

        // Indique si l'index courant correspond a la fenetre finale de confirmation/envoi.
        isConfirmationStep(stepIndex) {
            return stepIndex === this.getSteps().length;
        }

        // Retourne l'index de step actuellement affiche dans l'unique popup du wizard.
        getCurrentWizardStepIndex() {
            return Number.isInteger(this.currentWizardStepIndex) ? this.currentWizardStepIndex : 0;
        }

        // Retourne un titre simple qui evolue avec la step courante sans imposer une nouvelle config metier.
        getPopupTitleForStep(stepIndex, totalPopupSteps) {
            return this.ui.popup.editTitle || "";
        }

        // Retourne les libelles de navigation affiches dans la colonne gauche du wizard.
        getWizardSidebarItems() {
            const formSteps = this.getSteps();
            const sidebarItems = formSteps.map(function (stepConfig) {
                return {
                    title: stepConfig.sidebarTitle || ""
                };
            });

            sidebarItems.push({
                title: this.ui.popup.confirmationTitle || ""
            });

            return sidebarItems;
        }

        // Retourne les informations affichees au-dessus du fil d'Ariane.
        getWizardIndicatorMeta() {
            return {
                name: this.state.nom || this.indicatorMeta.name || "",
                type: this.indicatorMeta.type || "",
                documentationPageId: this.indicatorMeta.documentation_page_id,
                indicatorTypeLabel: this.ui.popup.indicatorTypeLabel || "",
                documentationTitle: this.ui.popup.documentationTitle || ""
            };
        }



        // ---- SAUVEGARDE FINALE ----

        // Envoie le formulaire vers l'endpoint en choisissant automatiquement objet simple ou FormData.
        submitIndicatorUpdateRequest() {
            const utils = G.ui.GVIndicatorEditionV3Utils;
            const payload = utils.mergeObjects({}, this.payloadState);

            // Si le payload contient un fichier on utilise formData
            const mustUseFormData = utils.containsFile(payload);

            const ajaxOptions = {
                url: G.config.SERVER + "frontend/ajax/editIndicator/" + this.indicatorId,
                type: "POST",
                dataType: "json",
                data: mustUseFormData ? utils.objectToFormData(payload) : payload
            };

            if (mustUseFormData) {
                ajaxOptions.processData = false;
                ajaxOptions.contentType = false;
            }

            // Envoie de la requete
            return new Promise(function (resolve) {
                $.ajax(ajaxOptions).done(function (response) {
                    resolve(response);
                }).fail(function (xhr) {
                    resolve({
                        status: "error",
                        error: xhr && xhr.responseJSON ? xhr.responseJSON.message : this.ui.errors.generic
                    });
                }.bind(this));
            }.bind(this));
        }

        // Transforme le wizard ouvert en popup de chargement puis en succes ou erreur.
        async saveIndicatorAndShowFeedback() {
            G.ui.removeIndicatorWizardLayout();
            Swal.update(G.ui.GVIndicatorEditionV3PopupConfig.getSavingPopupConfig(this.ui.popup));
            Swal.showLoading();

            const response = await this.submitIndicatorUpdateRequest();
            const isSuccess = response && (response.status ?? "error") === "success";
            Swal.hideLoading();

            // La meme Swal affiche l'erreur sans reconstruire une nouvelle popup.
            if (!isSuccess) {
                const errorMessage = response && (response.error || response.message)
                    ? (response.error || response.message)
                    : this.ui.errors.generic;

                Swal.update(G.ui.GVIndicatorEditionV3PopupConfig.getErrorPopupConfig(errorMessage, this.ui.popup));
                G.ui.prepareIndicatorFeedbackPopup();
                this.focusFeedbackPopupPrimaryButton();
                return false;
            }

            this.onSaved(response.data);
            // La meme Swal remplace le loading par le contenu final de succes.
            Swal.update(G.ui.GVIndicatorEditionV3PopupConfig.getSuccessPopupConfig(this.siteId, this.ui.popup));
            G.ui.prepareIndicatorFeedbackPopup();
            this.focusFeedbackPopupPrimaryButton();

            return true;
        }

        // Place le focus sur le bouton principal d'une popup finale pour activer Enter sans clic prealable.
        focusFeedbackPopupPrimaryButton() {
            // Swal.update termine le rendu du bouton apres l'appel courant: le focus attend la frame suivante.
            window.requestAnimationFrame(function () {
                const confirmButton = Swal.getConfirmButton();

                if (confirmButton) {
                    confirmButton.focus();
                }
            });
        }

    };
})();

if (!window.G) {
    window.G = {};
}

G.ui = G.ui || {};

(function () {
    // Ajoute les methodes suivantes a la classe GVIndicatorEditionEngineV3
    Object.assign(G.ui.GVIndicatorEditionEngineV3.prototype, {


        // ---- POPUP D'UNE STEP ----

        // Ouvre le wizard dans une seule popup, puis laisse le contenu interne changer a chaque step.
        openWizardPopup: async function () {
            await Swal.fire($.extend(true, {}, this.buildCurrentWizardPopupConfig(), {
                // Prepare les metadonnees de la popup avant que le layout ne recompose son DOM.
                willOpen: function (popup) {
                    this.writeWizardPopupMetadata(popup);
                    G.ui.applyIndicatorPopupLayout();
                }.bind(this),
                // Monte les composants de la step une fois la popup visible.
                didOpen: async function () {
                    await this.bindCurrentWizardStep();
                    this.finishCurrentWizardStepDisplay();
                }.bind(this),
                // Nettoie la step courante avant toute fermeture reelle de la popup.
                willClose: function () {
                    this.removeWizardActionButtonHandlers();
                    this.removeFormShortcuts();
                }.bind(this),
                // Termine le nettoyage une fois la popup effectivement detruite.
                didDestroy: function () {
                    this.destroyCurrentStepFieldInstances();
                }.bind(this)
            }));
        },

        // Construit la configuration Swal de la step actuellement affichee.
        buildCurrentWizardPopupConfig: function () {
            const stepIndex = this.getCurrentWizardStepIndex();
            const isConfirmationStep = this.isConfirmationStep(stepIndex);
            const stepConfig = this.getSteps()[stepIndex] || null;

            return G.ui.GVIndicatorEditionV3PopupConfig.getFormStepPopupConfig({
                title: this.getPopupTitleForStep(stepIndex),
                html: isConfirmationStep ? this.buildConfirmationStepHtml() : this.buildStepHtml(stepConfig),
                confirmButtonText: isConfirmationStep ? this.ui.popup.confirmEdit : this.ui.popup.next,
                denyButtonText: stepIndex === 0 ? this.ui.popup.cancel : this.ui.popup.previous,
                ui: this.ui
            });
        },

        // Construit le contenu simple de la step finale de confirmation.
        buildConfirmationStepHtml: function () {
            return ""
                + '<div class="gv-indicator-confirmation-step">'
                + '    <div class="swal2-icon swal2-question swal2-icon-show gv-indicator-confirmation-step__icon">'
                + '        <div class="swal2-icon-content">?</div>'
                + "    </div>"
                + '    <div class="gv-indicator-confirmation-step__text">' + (this.ui.popup.confirmEditQuestion || "") + "</div>"
                + "</div>";
        },

        // Injecte sur le noeud popup les infos lues ensuite par le layout.
        writeWizardPopupMetadata: function (popup) {
            popup.__gvWizardSidebarItems = this.getWizardSidebarItems();
            popup.__gvWizardCurrentStepIndex = this.getCurrentWizardStepIndex();
            popup.__gvWizardIndicatorMeta = this.getWizardIndicatorMeta();
            popup.__gvWizardShortcutsHint = this.ui.popup.shortcutsHint || "";
        },

        // Remplace le contenu de la popup existante par celui de la nouvelle step.
        refreshCurrentWizardPopup: async function () {
            const popup = Swal.getPopup();
            if (!popup) {
                return;
            }

            this.removeWizardActionButtonHandlers();
            this.destroyCurrentStepFieldInstances();
            this.writeWizardPopupMetadata(popup);
            const stepPopupConfig = this.buildCurrentWizardPopupConfig();

            // Seuls les textes et le contenu changent; le cadre fixe de la Swal reste intact.
            Swal.update({
                title: stepPopupConfig.title,
                html: stepPopupConfig.html,
                confirmButtonText: stepPopupConfig.confirmButtonText,
                denyButtonText: stepPopupConfig.denyButtonText
            });
            G.ui.applyIndicatorPopupLayout();
            await this.bindCurrentWizardStep();
            this.finishCurrentWizardStepDisplay();
        },

        // Instancie la step courante dans la popup deja ouverte.
        bindCurrentWizardStep: async function () {
            const stepIndex = this.getCurrentWizardStepIndex();
            const stepConfig = this.getSteps()[stepIndex] || null;
            const isConfirmationStep = this.isConfirmationStep(stepIndex);

            if (!isConfirmationStep && stepConfig) {
                const htmlContainer = $(Swal.getHtmlContainer());

                this.setStepLoadingState(true);

                try {
                    // Creation des composants de l'etape a partir de la config de celle-ci.
                    await this.bindStepFields(htmlContainer, stepConfig);
                    // Si la popup a ete fermee pendant le chargement, on arrete ici sans rejouer la fin du montage.
                    if (!Swal.getPopup() || !Swal.isVisible()) {
                        return;
                    }
                    // Mise a jour de l'affichage et de la navigation une fois tous les composants charges.
                    this.applyConditionalVisibility(stepConfig);
                } catch (error) {
                    // La step reste utilisable, mais indique clairement qu'au moins une source distante n'a pas charge.
                    if (Swal.getPopup() && Swal.isVisible()) {
                        Swal.showValidationMessage(this.ui.errors.generic);
                    }
                } finally {
                    this.setStepLoadingState(false);
                }
            } else {
                this.currentStepConfig = null;
                this.setStepLoadingState(false);
            }

            this.bindWizardActionButtonHandlers();
            this.bindFormShortcuts();
        },

        // Branche les boutons Swal sur la navigation interne du wizard sans fermer la popup.
        bindWizardActionButtonHandlers: function () {
            const stepIndex = this.getCurrentWizardStepIndex();
            const isConfirmationStep = this.isConfirmationStep(stepIndex);
            const confirmButton = Swal.getConfirmButton();
            const denyButton = Swal.getDenyButton();

            if (confirmButton) {
                this.boundWizardConfirmHandler = function (event) {
                    event.preventDefault();
                    event.stopImmediatePropagation();

                    if (isConfirmationStep) {
                        this.handleWizardFinalSave();
                        return;
                    }

                    this.handleWizardNextStep();
                }.bind(this);

                confirmButton.addEventListener("click", this.boundWizardConfirmHandler, true);
            }

            if (denyButton) {
                this.boundWizardDenyHandler = function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();

                    if (stepIndex === 0) {
                        Swal.close();
                        return;
                    }

                    this.handleWizardPreviousStep();
                }.bind(this);

                denyButton.addEventListener("click", this.boundWizardDenyHandler, true);
            }
        },

        // Nettoie les handlers temporaires branches sur les boutons natifs de SweetAlert.
        removeWizardActionButtonHandlers: function () {
            const confirmButton = Swal.getConfirmButton();
            const denyButton = Swal.getDenyButton();

            if (confirmButton && this.boundWizardConfirmHandler) {
                confirmButton.removeEventListener("click", this.boundWizardConfirmHandler, true);
            }

            if (denyButton && this.boundWizardDenyHandler) {
                denyButton.removeEventListener("click", this.boundWizardDenyHandler, true);
            }

            this.boundWizardConfirmHandler = null;
            this.boundWizardDenyHandler = null;
        },

        // Bascule la popup deja ouverte vers une autre step du wizard.
        navigateToWizardStep: async function (targetStepIndex) {
            this.currentWizardStepIndex = targetStepIndex;
            Swal.resetValidationMessage();
            await this.refreshCurrentWizardPopup();
        },

        // Valide la step courante puis affiche la suivante sans fermer la popup.
        handleWizardNextStep: async function () {
            const utils = G.ui.GVIndicatorEditionV3Utils;
            const stepIndex = this.getCurrentWizardStepIndex();
            const stepConfig = this.getSteps()[stepIndex] || null;

            if (this.isStepLoading || this.isWizardNavigating || this.isWaitingForRemainingStepsPreload() || !stepConfig) {
                return;
            }

            this.isWizardNavigating = true;
            this.setStepLoadingState(true);

            try {
                await this.commitPendingStepDrafts(stepConfig);

                const validationErrors = this.collectFieldValidationErrors(this.getEditableFieldsOfStep(stepConfig));
                if (validationErrors.length) {
                    this.showCurrentStepValidationErrors(stepConfig, validationErrors);
                    return;
                }

                this.clearCurrentStepValidationErrors(stepConfig);
                this.payloadState = utils.mergeObjects(this.payloadState, this.serializeCurrentStepForm());
                await this.navigateToWizardStep(stepIndex + 1);
            } finally {
                this.isWizardNavigating = false;
                this.setStepLoadingState(false);
            }
        },

        // Revient a la step precedente sans laisser SweetAlert detruire la popup.
        handleWizardPreviousStep: async function () {
            const stepIndex = this.getCurrentWizardStepIndex();
            const stepConfig = this.getSteps()[stepIndex] || null;
            const isConfirmationStep = this.isConfirmationStep(stepIndex);

            if (this.isStepLoading || this.isWizardNavigating || stepIndex === 0) {
                return;
            }

            this.isWizardNavigating = true;
            this.setStepLoadingState(true);

            try {
                if (isConfirmationStep) {
                    await this.navigateToWizardStep(stepIndex - 1);
                    return;
                }

                if (!stepConfig) {
                    return;
                }

                await this.commitPendingStepDrafts(stepConfig);

                const validationErrors = this.collectFieldValidationErrors(this.getEditableFieldsOfStep(stepConfig));
                if (validationErrors.length) {
                    this.showCurrentStepValidationErrors(stepConfig, validationErrors);
                    return;
                }

                this.clearCurrentStepValidationErrors(stepConfig);
                await this.navigateToWizardStep(stepIndex - 1);
            } finally {
                this.isWizardNavigating = false;
                this.setStepLoadingState(false);
            }
        },

        // Valide le formulaire puis transforme la popup courante en retour de sauvegarde.
        handleWizardFinalSave: async function () {
            const stepIndex = this.getCurrentWizardStepIndex();
            const isConfirmationStep = this.isConfirmationStep(stepIndex);

            if (this.isStepLoading || this.isWizardNavigating || this.saveStarted || !isConfirmationStep) {
                return;
            }

            // Avant l'envoi final, on valide tous les champs encore visibles/editables.
            const validationErrors = this.collectFieldValidationErrors(this.getAllEditableFields());
            if (validationErrors.length) {
                Swal.showValidationMessage(validationErrors[0].message);
                return;
            }

            this.saveStarted = true;
            this.removeWizardActionButtonHandlers();
            this.removeFormShortcuts();
            await this.saveIndicatorAndShowFeedback();
        },

        // Assemble le squelette HTML de tous les champs de l'etape.
        // Les vrais composants (Select2, DataTable, upload...) sont injectes plus tard dans bindCurrentWizardStep().
        buildStepHtml: function (stepConfig) {
            // Boucle sur chaque champs de la step.
            const fieldsHtml = this.getStepEntries(stepConfig).map(function (entry) {
                return this.renderStepEntry(entry);
            }, this).join("");

            return ""
                + '<form id="gv_swal_form_multistep" class="gv-indicator-form">'
                + '    <div class="gvg-r gvg-r--gutter gv-indicator-step-fields" hidden>'
                + fieldsHtml
                + "    </div>"
                + "</form>";
        },

        // Genere le squelette HTML d'un champ simple ou d'une ligne de champs.
        renderStepEntry: function (entry) {
            if (!entry || typeof entry !== "object") {
                return "";
            }

            // Une entree "row" conserve plusieurs champs sur une meme ligne, sinon un champ seul est rendu.
            if (entry.type === "row" && Array.isArray(entry.fields)) {
                const cardCheckboxCount = entry.fields.filter(function (field) {
                    return field.type === "checkbox" && field.card === true;
                }).length;
                const rowClass = "gvg-6on6 gv-indicator-row"
                    + (cardCheckboxCount > 1 ? " gv-indicator-row--equal-height-cards" : "");

                return ""
                    + '<div class="' + rowClass + '">'
                    + '    <div class="' + (entry.rowClass || "gvg-r gvg-r--gutter") + '">'
                    + entry.fields.map(function (field) {
                        return this.renderFieldShell(field);
                    }, this).join("")
                    + "    </div>"
                    + "</div>";
            }

            return this.renderFieldShell(entry);
        },

        // Construit le conteneur HTML commun d'un champ avant d'y injecter son vrai composant.
        // Ce shell contient la mise en page, le label et le texte d'aide, mais aucun controle interactif.
        // Les composants JS seront ensuite instancies dans le bloc .gv-indicator-field__control.
        renderFieldShell: function (field) {
            const fieldId = this.getFieldDomId(field);
            const isFullWidth = field.fullWidth === true || ["icon", "image", "indicator_points", "datatable_select_single", "datatable_select_multiple", "rules", "textarea", "hr", "slider"].indexOf(field.type) !== -1;
            const columnClass = field.columnClass || (isFullWidth ? "gvg-6on6" : "gvg-6on6 gvg-3on6--narrow");
            const components = G.ui.GVIndicatorEditionV3Components;
            const helperText = field.type === "checkbox" && field.card
                ? ""
                : components.resolveUiText(field, "helper", "");
            const fieldLabel = components.resolveUiText(field, "label", field.name);
            // Le type metier reste inchange, seul son nom de modificateur CSS est normalise en BEM.
            const fieldTypeClass = String(field.type).replace(/_/g, "-");
            let labelHtml = "";

            if (field.type === "hr") {
                // Un champ hr ne contient aucun controle: il ne sert qu'a inserer une separation visuelle.
                return ""
                    + '<div class="' + columnClass + ' gv-indicator-field gv-indicator-field--hr" data-field-name="' + field.name + '">'
                    + "    <hr>"
                    + "</div>";
            }

            // Ajout des labels du champ.
            if (!field.hideShellLabel && field.type === "rules") {
                labelHtml = '<label class="uicomp__label">' + fieldLabel + "</label>";
            } else if (!field.hideShellLabel && field.type !== "checkbox") {
                labelHtml = '<label class="uicomp__label" for="' + fieldId + '">' + fieldLabel + "</label>";
            }

            return ""
                + '<div class="' + columnClass + ' gv-indicator-field gv-indicator-field--' + fieldTypeClass + (isFullWidth ? " gv-indicator-field--full" : "") + '" data-field-name="' + field.name + '">'
                + labelHtml
                // Ce bloc reste vide ici: il sert juste de point d'ancrage pour le vrai composant instancie apres ouverture de la popup.
                + '    <div class="gv-indicator-field__control"></div>'
                + '    <div class="gv-indicator-field__messages">'
                + (helperText ? '<span class="uicomp__text_help">' + helperText + "</span>" : "")
                + '        <span class="uicomp__text_help gv-indicator-field__error" hidden></span>'
                + "    </div>"
                + "</div>";
        },



        // ---- COMPOSANTS DE LA STEP ----

        // Detruit proprement les composants instancies sur l'etape courante avant de jeter le DOM Swal.
        destroyCurrentStepFieldInstances: function () {
            this.destroyFieldInstances(this.fieldInstances);
            this.fieldInstances = {};
            this.currentStepConfig = null;
            this.isStepLoading = false;
        },

        // Active ou desactive temporairement les boutons d'action pendant le chargement complet de la step.
        setStepLoadingState: function (isLoading) {
            this.isStepLoading = isLoading === true;
            this.updateWizardActionAvailability();
        },

        // Met a jour l'etat des boutons d'action selon le chargement courant et le prechargement en arriere-plan.
        updateWizardActionAvailability: function () {
            const confirmButton = $(Swal.getConfirmButton());
            const denyButton = $(Swal.getDenyButton());
            const shouldBlockNextStep = this.isWaitingForRemainingStepsPreload();

            if (confirmButton.length) {
                confirmButton.prop("disabled", this.isStepLoading || this.isWizardNavigating || shouldBlockNextStep);
            }

            if (denyButton.length) {
                denyButton.prop("disabled", this.isStepLoading || this.isWizardNavigating);
            }
        },

        // Revele le conteneur des champs seulement quand tous les composants de la step sont prets.
        showCurrentStepFields: function () {
            $(Swal.getHtmlContainer()).find(".gv-indicator-step-fields").prop("hidden", false);
        },

        // Revele les champs une fois leurs composants prets dans la popup de hauteur fixe.
        finishCurrentWizardStepDisplay: function () {
            this.showCurrentStepFields();
            this.startRemainingStepsBackgroundPreload();
            this.focusCurrentWizardKeyboardTarget();
        },

        // Instancie tous les champs d'une etape et conserve leurs references.
        bindStepFields: async function (container, stepConfig) {
            this.destroyCurrentStepFieldInstances();
            this.fieldInstances = {};

            try {
                await this.createFieldInstancesForContainer(container, stepConfig, this.fieldInstances);
            } finally {
                // La step visible reste connue meme si une source distante n'a pas pu charger.
                this.currentStepConfig = stepConfig;
                this.clearCurrentStepValidationErrors(stepConfig);
            }
        },

        // Cree les champs dans l'ordre de la config pour que les sources dependantes lisent un state deja initialise.
        createFieldInstancesForContainer: async function (container, stepConfig, fieldInstances) {
            const previousStepConfig = this.currentStepConfig;
            let loadingError = null;

            this.currentStepConfig = stepConfig;

            try {
                const fields = this.getStepFields(stepConfig);

                for (let fieldIndex = 0; fieldIndex < fields.length; fieldIndex++) {
                    const field = fields[fieldIndex];

                    try {
                        const fieldInstance = this.createField(field, container);
                        fieldInstances[field.name] = fieldInstance;

                        if (fieldInstance && fieldInstance.ready) {
                            await Promise.resolve(fieldInstance.ready);
                        }
                    } catch (error) {
                        loadingError = loadingError || error;
                    }
                }
            } finally {
                this.currentStepConfig = previousStepConfig;
            }

            if (loadingError) {
                throw loadingError;
            }

            return fieldInstances;
        },

        // Dit si l'utilisateur doit attendre la fin du prechargement avant de quitter la premiere step.
        isWaitingForRemainingStepsPreload: function () {
            return this.getCurrentWizardStepIndex() === 0
                && this.isRemainingStepsPreloading === true
                && this.areRemainingStepsPreloaded !== true;
        },

        // Lance une seule fois le prechargement des steps suivantes apres le chargement complet de la premiere.
        startRemainingStepsBackgroundPreload: function () {
            if (this.getCurrentWizardStepIndex() !== 0 || this.areRemainingStepsPreloaded || this.remainingStepsPreloadPromise) {
                this.updateWizardActionAvailability();
                return;
            }

            if (this.getSteps().length <= 1) {
                this.areRemainingStepsPreloaded = true;
                this.updateWizardActionAvailability();
                return;
            }

            this.isRemainingStepsPreloading = true;
            this.updateWizardActionAvailability();
            this.remainingStepsPreloadPromise = this.preloadRemainingStepsInBackground().catch(function () {
                // Une step en erreur sera rechargee normalement quand l'utilisateur l'ouvrira.
            }).finally(function () {
                this.isRemainingStepsPreloading = false;
                this.areRemainingStepsPreloaded = true;
                this.remainingStepsPreloadPromise = null;
                this.updateWizardActionAvailability();
            }.bind(this));
        },

        // Monte chaque step future dans un sandbox cache pour absorber son cout d'initialisation avant le premier clic sur Suivant.
        preloadRemainingStepsInBackground: async function () {
            const steps = this.getSteps();

            for (let stepIndex = 1; stepIndex < steps.length; stepIndex++) {
                if (!Swal.getPopup() || !Swal.isVisible()) {
                    return;
                }

                await this.preloadStepInSandbox(steps[stepIndex], stepIndex);
            }
        },

        // Cree hors ecran une vraie step, attend que ses composants soient prets, puis la detruit proprement.
        preloadStepInSandbox: async function (stepConfig, stepIndex) {
            const sandbox = $('<div class="gv-indicator-preload-sandbox"></div>')
                .attr("data-preload-step-index", stepIndex)
                .append(this.buildStepHtml(stepConfig));

            $("body").append(sandbox);
            sandbox.find(".gv-indicator-step-fields").prop("hidden", false);

            let fieldInstances = {};

            try {
                await this.createFieldInstancesForContainer(sandbox, stepConfig, fieldInstances);
            } finally {
                this.destroyFieldInstances(fieldInstances);
                sandbox.remove();
            }
        },

        // Detruit une collection d'instances de composants sans toucher au state principal du builder.
        destroyFieldInstances: function (fieldInstances) {
            Object.keys(fieldInstances || {}).forEach(function (fieldName) {
                const fieldInstance = fieldInstances[fieldName];

                if (!fieldInstance || !fieldInstance.destroy) {
                    return;
                }

                try {
                    fieldInstance.destroy();
                } catch (error) {}
            });
        },

        // Retourne le callback standard a executer quand un champ modifie le state.
        getFieldChangeHandler: function (field) {
            return function () {
                this.clearCurrentStepValidationErrors(this.currentStepConfig);
                // On recalcule d'abord les zones visibles de l'etape.
                this.applyConditionalVisibility(this.currentStepConfig);

                // Certains champs declarent explicitement d'autres selects a recharger.
                const reloadTargets = Array.isArray(field.reloadOptionsFor) ? field.reloadOptionsFor : [];
                reloadTargets.forEach(function (targetFieldName) {
                    this.refreshFieldOptions(targetFieldName);
                }, this);
            }.bind(this);
        },

        // Branche Enter/Escape sur la popup pour reproduire exactement les boutons vert/rouge de la step courante.
        bindFormShortcuts: function () {
            this.removeFormShortcuts();

            this.boundWizardShortcutHandler = function (event) {
                this.handleWizardShortcutKey(event);
            }.bind(this);

            document.addEventListener("keydown", this.boundWizardShortcutHandler, true);
        },

        // Retire l'ecoute clavier globale attachee pendant la vie de la popup.
        removeFormShortcuts: function () {
            if (!this.boundWizardShortcutHandler) {
                return;
            }

            document.removeEventListener("keydown", this.boundWizardShortcutHandler, true);
            this.boundWizardShortcutHandler = null;
        },

        // Route chaque touche de navigation vers le meme bouton que l'utilisateur aurait clique.
        handleWizardShortcutKey: function (event) {
            const popup = Swal.getPopup();

            if (!popup || !Swal.isVisible()) {
                return;
            }

            // Un textarea doit garder Enter pour inserer un retour a la ligne, pas pour changer de step.
            if (this.isTextareaHandlingKeyboard(event)) {
                return;
            }

            // Quand un Select2 est ouvert, Enter/Escape doivent d'abord piloter sa liste interne.
            if (this.isSelectDropdownHandlingKeyboard(popup, event)) {
                return;
            }

            if (event.key === "Escape") {
                this.triggerWizardSecondaryActionFromKeyboard(event);
                return;
            }

            if (event.key === "Enter") {
                this.triggerWizardPrimaryActionFromKeyboard(event);
            }
        },

        // Laisse un textarea utiliser Enter normalement pour ecrire sur plusieurs lignes.
        isTextareaHandlingKeyboard: function (event) {
            const target = event && event.target;

            if (!target || event.key !== "Enter") {
                return false;
            }

            return target.tagName === "TEXTAREA";
        },

        // Laisse Select2 gerer ses propres touches tant que son menu est ouvert.
        isSelectDropdownHandlingKeyboard: function (popup, event) {
            if (!event || (event.key !== "Enter" && event.key !== "Escape")) {
                return false;
            }

            return popup.querySelector(".select2-container--open") !== null;
        },

        // Rejoue le bouton rouge de la popup courante: annuler sur la step 1, precedent sur les suivantes.
        triggerWizardSecondaryActionFromKeyboard: function (event) {
            const denyButton = Swal.getDenyButton();

            if (!this.canTriggerWizardButtonFromKeyboard(denyButton)) {
                return;
            }

            this.preventWizardShortcutDefault(event);
            denyButton.click();
        },

        // Rejoue le bouton vert de la popup courante: suivant sur une step, confirmer sur la derniere.
        triggerWizardPrimaryActionFromKeyboard: function (event) {
            const confirmButton = Swal.getConfirmButton();

            if (!this.canTriggerWizardButtonFromKeyboard(confirmButton)) {
                return;
            }

            this.preventWizardShortcutDefault(event);
            confirmButton.click();
        },

        // Ignore les raccourcis si le bouton vise n'existe pas ou qu'il est desactive.
        canTriggerWizardButtonFromKeyboard: function (button) {
            return !!(button && button.disabled !== true);
        },

        // Neutralise le comportement natif du navigateur avant de rejouer l'action du wizard.
        preventWizardShortcutDefault: function (event) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        },

        // Fabrique une instance de composant selon le type de champ declare dans le JSON.
        createField: function (field, container) {
            const components = G.ui.GVIndicatorEditionV3Components;
            const componentList = G.ui.GVIndicatorEditionV3ComponentList;

            // Recupere le conteneur HTML du champ et sa zone de controle.
            const fieldRoot = container.find('[data-field-name="' + field.name + '"]');
            const controlRoot = fieldRoot.find(".gv-indicator-field__control");

            // Prepare les informations communes a tous les composants.
            const fieldId = this.getFieldDomId(field);
            components.registerFieldValidation(this.state, field, this.ui); // Enregistre les contraintes de validation
            const currentValue = components.getByPath(this.state, field.name);
            const onChange = this.getFieldChangeHandler(field);

            // Ces helpers sont fournis aux composants pour leur eviter de connaitre le builder complet.
            const componentHelpers = {
                resolveTemplateValue: this.resolveTemplateValue.bind(this),
                extractResponsePayload: G.ui.GVIndicatorEditionV3Utils.extractResponsePayload,
                loadFieldOptionsFromConfig: this.loadFieldOptionsFromConfig.bind(this),
                ui: this.ui,
                onStateChange: onChange,
                indicatorId: this.indicatorId,
                siteId: this.siteId
            };

            // La table de routage des types vit dans un fichier dedie pour garder le builder independant des composants.
            const fieldInstance = componentList.createFieldInstance(field, {
                fieldId: fieldId,
                currentValue: currentValue,
                state: this.state,
                onChange: onChange,
                componentHelpers: componentHelpers
            });
            const rootElement = fieldInstance.container || fieldInstance.element;

            if (rootElement && controlRoot.length) {
                controlRoot.append(rootElement);
            }

            return fieldInstance;
        },

        // Charge les options d'un champ a partir de sa configuration Ajax.
        loadFieldOptionsFromConfig: function (ajaxConfig, field) {
            const utils = G.ui.GVIndicatorEditionV3Utils;

            // Utilise le nom du champ pour isoler le cache entre plusieurs selects.
            const cacheScope = field && field.name ? field.name : "anonymous";

            // Si une variable necessaire a la requete n'est pas encore disponible, il n'y a rien a charger.
            if (this.isAjaxDependencyMissing(ajaxConfig || {})) {
                return Promise.resolve([]);
            }

            // Remplace les variables du template ({...}) par leurs valeurs actuelles.
            const resolvedAjaxConfig = this.resolveTemplateValue(ajaxConfig || {});

            // Construit une cle unique representant cette requete.
            const cacheKey = cacheScope + "::" + JSON.stringify({
                url: resolvedAjaxConfig.url,
                method: resolvedAjaxConfig.method || "GET",
                headers: resolvedAjaxConfig.headers || {},
                data: resolvedAjaxConfig.data || null,
                body: resolvedAjaxConfig.body || null
            });

            // Si cette requete a deja ete executee, reutilise le resultat dans le cache.
            if (this.optionCache[cacheKey]) {
                return Promise.resolve(this.optionCache[cacheKey]);
            }

            // Prepare la configuration de la requete Ajax.
            const ajaxRequest = {
                url: resolvedAjaxConfig.url,
                type: resolvedAjaxConfig.method || "GET",
                dataType: resolvedAjaxConfig.dataType || "json"
            };

            // Ajoute les entetes HTTP si necessaire.
            if (resolvedAjaxConfig.headers) {
                ajaxRequest.headers = resolvedAjaxConfig.headers;
            }

            // Ajoute les parametres de la requete.
            if (resolvedAjaxConfig.data) {
                ajaxRequest.data = resolvedAjaxConfig.data;
            }

            // Si un body est fourni, il remplace les parametres classiques.
            if (resolvedAjaxConfig.body !== undefined) {
                ajaxRequest.data = JSON.stringify(resolvedAjaxConfig.body);
            }

            // Execute la requete puis transforme la reponse en liste d'options.
            return $.ajax(ajaxRequest).then(function (response) {
                const options = utils.extractResponsePayload(response, ajaxConfig || {});

                // Met le resultat en cache pour eviter un nouvel appel identique.
                this.optionCache[cacheKey] = options;

                return options;
            }.bind(this));
        },

        // Recharge les options d'un champ cible apres changement d'un champ dont il depend.
        refreshFieldOptions: function (fieldName) {
            const fieldInstance = this.fieldInstances[fieldName];
            const fieldConfig = this.getFieldConfigByName(fieldName);

            if (!fieldInstance || !fieldInstance.populate || !fieldConfig || !fieldConfig.ajax) {
                return;
            }

            this.loadFieldOptionsFromConfig(fieldConfig.ajax || {}, fieldConfig).then(function (options) {
                fieldInstance.populate(options);
            });
        },

        // Place le focus sur le premier champ editable visible sans ouvrir les select2.
        focusFirstEditableField: function () {
            const htmlContainer = $(Swal.getHtmlContainer());
            const fieldRoots = htmlContainer.find(".gv-indicator-field");

            for (let index = 0; index < fieldRoots.length; index++) {
                const fieldRoot = $(fieldRoots[index]);

                if (fieldRoot.hasClass("gv-indicator-field--conditionally-hidden")) {
                    continue;
                }

                const editableField = fieldRoot
                    .find("input, textarea, select")
                    .filter(":visible:not(:disabled):not([readonly])")
                    .not("[type=hidden], [type=checkbox], [type=radio], [type=file], [type=button], [type=submit]")
                    .first();

                if (editableField.length) {
                    editableField.trigger("focus");

                    if (editableField.is("input[type=text], input[type=number], input[type=email], input[type=search], input:not([type])")) {
                        editableField.select();
                    }

                    return;
                }

                const select2Selection = fieldRoot.find(".select2-selection:visible").first();
                if (select2Selection.length) {
                    this.focusSelectLikeField(select2Selection);
                    return;
                }
            }
        },

        // Pose le focus sur le vrai noeud interactif d'un select Select2 sans ouvrir sa liste.
        focusSelectLikeField: function (selectLikeField) {
            const domNode = $(selectLikeField).get(0);

            if (!domNode || typeof domNode.focus !== "function") {
                return;
            }

            domNode.focus();
        },

        // Pose le focus clavier initial selon la nature de la step courante.
        focusCurrentWizardKeyboardTarget: function () {
            const isConfirmationStep = this.isConfirmationStep(this.getCurrentWizardStepIndex());

            // On attend la frame suivante pour laisser au navigateur le temps d'appliquer la visibilite reelle du contenu.
            window.requestAnimationFrame(function () {
                if (!Swal.getPopup() || !Swal.isVisible()) {
                    return;
                }

                if (isConfirmationStep) {
                    this.focusWizardPopupForKeyboard();
                    return;
                }

                this.focusFirstEditableField();
            }.bind(this));
        },

        // Met le focus sur la popup elle-meme pour que Enter/Escape marchent sans clic prealable.
        focusWizardPopupForKeyboard: function () {
            const popup = Swal.getPopup();

            if (!popup) {
                return;
            }

            popup.focus();
        },



        // ---- ETAT ET VALIDATION DE STEP ----

        // Recherche la definition d'un champ par son nom dans l'ensemble des etapes.
        getFieldConfigByName: function (fieldName) {
            const steps = this.getSteps();

            for (let stepIndex = 0; stepIndex < steps.length; stepIndex++) {
                const fields = this.getStepFields(steps[stepIndex]);
                for (let fieldIndex = 0; fieldIndex < fields.length; fieldIndex++) {
                    if (fields[fieldIndex].name === fieldName) {
                        return fields[fieldIndex];
                    }
                }
            }

            return null;
        },

        // Retourne seulement les champs editables et visibles d'une etape pour la validation.
        getEditableFieldsOfStep: function (stepConfig) {
            return this.getStepFields(stepConfig).filter(function (field) {
                return field.type !== "rules"
                    && field.readOnly !== true
                    && this.isFieldVisible(field);
            }, this);
        },

        // Force les composants en cours d'edition a finaliser leur contenu avant de changer de step.
        commitPendingStepDrafts: function (stepConfig) {
            const fields = this.getStepFields(stepConfig);
            const pendingCommits = [];

            fields.forEach(function (field) {
                const fieldInstance = this.fieldInstances[field.name];

                if (fieldInstance && fieldInstance.commitDraft) {
                    pendingCommits.push(Promise.resolve(fieldInstance.commitDraft()));
                }
            }, this);

            return Promise.all(pendingCommits);
        },

        // Reconstruit le payload correspondant a la step courante a partir du formulaire et des composants.
        serializeCurrentStepForm: function () {
            const form = $(Swal.getHtmlContainer()).find("#gv_swal_form_multistep");
            const components = G.ui.GVIndicatorEditionV3Components;
            const builder = this;

            if (!form.length) {
                return {};
            }

            const serializedData = form.serializeArray().reduce(function (result, item) {
                const fieldConfig = builder.getFieldConfigByName(item.name);

                if (fieldConfig && fieldConfig.readOnly === true) {
                    return result;
                }

                if (fieldConfig && !builder.isFieldVisible(fieldConfig)) {
                    return result;
                }

                // Le helper partage reconstruit la structure imbriquee a partir du nom technique du champ.
                components.setByPath(result, item.name, item.value);
                return result;
            }.bind(this), {});

            // Les fichiers n'entrent pas dans serializeArray, on les reinjecte a la main.
            form.find('input[type="file"]').each(function () {
                const inputName = String(this.name || "");

                if (!inputName) {
                    return;
                }

                const fieldConfig = builder.getFieldConfigByName(inputName);
                if (fieldConfig && fieldConfig.readOnly === true) {
                    return;
                }

                if (fieldConfig && !builder.isFieldVisible(fieldConfig)) {
                    return;
                }

                if (!this.files.length) {
                    return;
                }

                components.setByPath(
                    serializedData,
                    inputName,
                    this.files.length === 1 ? this.files[0] : Array.from(this.files)
                );
            });

            // On force les checkbox a remonter 0 ou 1 pour coller au contrat historique.
            form.find('input[type="checkbox"]').each(function () {
                const input = $(this);
                const inputName = String(input.attr("name") || "");

                if (!inputName) {
                    return;
                }

                const fieldConfig = builder.getFieldConfigByName(inputName);
                if (fieldConfig && fieldConfig.readOnly === true) {
                    return;
                }

                if (fieldConfig && !builder.isFieldVisible(fieldConfig)) {
                    return;
                }

                components.setByPath(serializedData, inputName, input.is(":checked") ? 1 : 0);
            });

            // Les composants riches exposent ici leur vraie valeur metier pour eviter de dupliquer un etat cache dans le DOM.
            this.getStepFields(this.currentStepConfig).forEach(function (field) {
                const fieldInstance = this.fieldInstances[field.name];

                if (!fieldInstance || !fieldInstance.getValue) {
                    return;
                }

                if (!this.isFieldVisible(field)) {
                    return;
                }

                if (field.readOnly === true) {
                    return;
                }

                components.setByPath(serializedData, field.name, fieldInstance.getValue());
            }, this);

            return serializedData;
        },

        // Retourne tous les champs editables de toutes les etapes pour la validation finale.
        getAllEditableFields: function () {
            return this.getSteps().reduce(function (fields, stepConfig) {
                return fields.concat(this.getEditableFieldsOfStep(stepConfig));
            }.bind(this), []);
        },

        // Evalue la regle visibleWhen d'un champ pour savoir s'il doit etre montre.
        isFieldVisible: function (field) {
            const visibleWhen = field.visibleWhen;
            const components = G.ui.GVIndicatorEditionV3Components;

            // Sans regle visibleWhen, le champ n'est jamais masque.
            if (!visibleWhen) {
                return true;
            }

            // Charge la valeur a comparer.
            const dependencyPath = visibleWhen.path || visibleWhen.field || visibleWhen.name;
            const dependencyValue = dependencyPath ? components.getByPath(this.state, dependencyPath) : undefined;

            // Le champ est masque si la valeur dependante n'est dans aucune des valeurs autorisees.
            if (Array.isArray(visibleWhen.in)) {
                return visibleWhen.in.map(String).indexOf(String(dependencyValue)) !== -1;
            }

            // Le champ est masque si la valeur dependante est exactement celle qu'on veut exclure.
            if (visibleWhen.notEquals !== undefined) {
                return String(dependencyValue) !== String(visibleWhen.notEquals);
            }

            // Le champ est masque si la valeur dependante n'est pas egale a la valeur attendue.
            if (visibleWhen.equals !== undefined) {
                return String(dependencyValue) === String(visibleWhen.equals);
            }

            // Le champ est masque si la valeur dependante est vide, nulle, false ou 0.
            if (visibleWhen.truthy) {
                return !!dependencyValue;
            }

            // Si aucune condition connue n'est definie, on ne masque pas le champ.
            return true;
        },

        // Retourne la liste detaillee des erreurs de validation de la step courante.
        collectFieldValidationErrors: function (fields) {
            return (fields || []).reduce(function (errors, field) {
                const validationMessage = G.ui.GVIndicatorFormValidationV3.validateField(field, this.state, this.ui);

                if (validationMessage) {
                    errors.push({
                        fieldName: field.name,
                        message: validationMessage
                    });
                }

                return errors;
            }.bind(this), []);
        },

        // Retire les styles d'erreur inline pour repartir d'un affichage propre.
        clearCurrentStepValidationErrors: function (stepConfig) {
            if (!stepConfig) {
                return;
            }

            const htmlContainer = $(Swal.getHtmlContainer());

            this.getStepFields(stepConfig).forEach(function (field) {
                const fieldRoot = htmlContainer.find('[data-field-name="' + field.name + '"]');
                fieldRoot.removeClass("gv-indicator-field--error");
                fieldRoot.find(".gv-indicator-field__error").attr("hidden", true).text("");
            });
        },

        // Affiche les erreurs juste sous les champs concernes puis place le focus sur la premiere.
        showCurrentStepValidationErrors: function (stepConfig, validationErrors) {
            const htmlContainer = $(Swal.getHtmlContainer());

            this.clearCurrentStepValidationErrors(stepConfig);

            (validationErrors || []).forEach(function (error) {
                const fieldRoot = htmlContainer.find('[data-field-name="' + error.fieldName + '"]');
                fieldRoot.addClass("gv-indicator-field--error");
                fieldRoot.find(".gv-indicator-field__error").removeAttr("hidden").text(error.message || "");
            });

            this.focusFirstInvalidField(validationErrors);
        },

        // Place le focus sur le premier champ invalide pour accelerer la correction clavier.
        focusFirstInvalidField: function (validationErrors) {
            const firstError = (validationErrors || [])[0];

            if (!firstError) {
                return;
            }

            const fieldRoot = $(Swal.getHtmlContainer()).find('[data-field-name="' + firstError.fieldName + '"]');

            if (!fieldRoot.length || fieldRoot.hasClass("gv-indicator-field--conditionally-hidden")) {
                return;
            }

            const editableField = fieldRoot
                .find("input, textarea, select")
                .filter(":visible:not(:disabled):not([readonly])")
                .not("[type=hidden], [type=checkbox], [type=radio], [type=file], [type=button], [type=submit]")
                .first();

            if (editableField.length) {
                editableField.trigger("focus");
                return;
            }

            const select2Selection = fieldRoot.find(".select2-selection:visible").first();
            if (select2Selection.length) {
                this.focusSelectLikeField(select2Selection);
            }
        },

        // Masque visuellement un champ conditionnel tout en gardant sa place dans la grille.
        setFieldConditionalVisibility: function (fieldRoot, isVisible) {
            const shouldShow = isVisible !== false;

            fieldRoot.toggleClass("gv-indicator-field--conditionally-hidden", !shouldShow);
            fieldRoot.attr("aria-hidden", shouldShow ? "false" : "true");

            if (!shouldShow) {
                fieldRoot.removeClass("gv-indicator-field--error");
                fieldRoot.find(".gv-indicator-field__error").attr("hidden", true).text("");
            }
        },

        // Affiche ou masque les champs dependants selon l'etat courant du formulaire.
        applyConditionalVisibility: function (stepConfig) {
            if (!stepConfig) {
                return;
            }
            const htmlContainer = $(Swal.getHtmlContainer());
            // Pour chaque champ d'une etape on regarde s'il doit etre visible ou non.
            this.getStepFields(stepConfig).forEach(function (field) {
                const fieldRoot = htmlContainer.find('[data-field-name="' + field.name + '"]');
                if (!fieldRoot.length) {
                    return;
                }
                // On le masque visuellement sans casser la place qu'il reserve dans la mise en page.
                this.setFieldConditionalVisibility(fieldRoot, this.isFieldVisible(field));
            }, this);
        },

        // Applique la validation sur une liste de champs.
        validateFields: function (fields) {
            const validationErrors = this.collectFieldValidationErrors(fields);
            return validationErrors.length ? validationErrors[0].message : null;
        },


        // ---- OUTILS DE STEP ----

        // Calcule un id DOM stable pour un champ du formulaire.
        getFieldDomId: function (field) {
            // Remplace les caracteres non valides par "-" afin d'obtenir un id HTML stable a partir du nom technique.
            return "gv-indicator-" + String(field.name).replace(/[^a-zA-Z0-9_-]/g, "-");
        },

        // Remplace les placeholders ({...}) d'une configuration par leurs valeurs actuelles.
        resolveTemplateValue: function (template) {
            const components = G.ui.GVIndicatorEditionV3Components;

            // Si la valeur est un tableau, remplace les placeholders de chaque element.
            if (Array.isArray(template)) {
                return template.map(function (value) {
                    return this.resolveTemplateValue(value);
                }.bind(this));
            }

            // Si la valeur est un objet, parcourt toutes ses proprietes recursivement.
            if (template && typeof template === "object") {
                return Object.keys(template).reduce(function (result, key) {
                    result[key] = this.resolveTemplateValue(template[key]);
                    return result;
                }.bind(this), {});
            }

            // Les valeurs non textuelles n'ont rien a remplacer.
            if (typeof template !== "string") {
                return template;
            }

            // Reutilise le helper commun de templating avec un dictionnaire source enrichi.
            return components.resolveTemplate(template, $.extend(true, {}, this.state, {
                siteId: this.siteId,
                indicatorId: this.indicatorId,
                userApiKey: G.model.userApiKey
            }));
        },

        // Verifie si une requete Ajax ne peut pas encore partir faute de dependances remplies dans le state.
        isAjaxDependencyMissing: function (ajaxConfig) {
            const requiredPaths = Array.isArray(ajaxConfig.requiredPaths) ? ajaxConfig.requiredPaths : [];
            const components = G.ui.GVIndicatorEditionV3Components;

            return requiredPaths.some(function (path) {
                const value = components.getByPath(this.state, path);
                return value === null || value === undefined || value === "";
            }, this);
        },

        // Retourne les entrees brutes d'une etape: champs directs ou lignes.
        getStepEntries: function (stepConfig) {
            return Array.isArray(stepConfig && stepConfig.fields) ? stepConfig.fields : [];
        },

        // Renvoie la liste a plat des configs de chaque champ de la step.
        getStepFields: function (stepConfig) {
            const fields = [];

            const appendEntries = function (entries) {
                (entries || []).forEach(function (entry) {
                    if (!entry || typeof entry !== "object") {
                        return;
                    }

                    if (entry.type === "row" && Array.isArray(entry.fields)) {
                        appendEntries(entry.fields);
                        return;
                    }

                    fields.push(entry);
                });
            };

            appendEntries(this.getStepEntries(stepConfig));

            return fields;
        }


    });
})();

var G;

if (!G) {
    G = {};
}

if (!G.ui) {
    G.ui = {};
}

/**
 * Classe définissant un tableau dédié à l'affichage de données de consommation par mois sur une année
 * Ce tableau sera relié :
 *      à une URL ajax vers où on recupérera les données de conso sous forme de JSON
 *      à un composant select (si existe) qui permettra de changer les données de consommation du tableau en fonction de la sélection du composant select
 * La route JSON renvoyant les données de conso devront être au format suivant :
 *  {
 *     "status": "success",
 *     "data": {
 *         "categories": [
 *             {
 *                 "id": "",
 *                 "label": ""
 *             }
 *         ],
 *         "rows": [
 *             {
 *                 "identifier": "",
 *                 "label": "",
 *                 "description": "",
 *                 "categoryId": "",
 *                 "style": "",
 *                 "unit": "",
 *                 "editable": "",
 *                 "objectId": "",
 *                 "update_in_progress": "",
 *                 "months": {
 *                     "1":  { "value": "", "color": "" },
 *                     "2":  { "value": "", "color": "" },
 *                     "3":  { "value": "", "color": "" },
 *                     "4":  { "value": "", "color": "" },
 *                     "5":  { "value": "", "color": "" },
 *                     "6":  { "value": "", "color": "" },
 *                     "7":  { "value": "", "color": "" },
 *                     "8":  { "value": "", "color": "" },
 *                     "9":  { "value": "", "color": "" },
 *                     "10": { "value": "", "color": "" },
 *                     "11": { "value": "", "color": "" },
 *                     "12": { "value": "", "color": "" }
 *                 },
 *                 "total": { "value": "", "color": "" }
 *             }
 *         ]
 *     }
 *  }
 */
G.ui.TableConsumption = class {
    /**
     *
     * @param tableDomId id du tableau de consommation
     * @param sectionMonitoringId id du sectionMonitoring à charger
     * @param tableCanBeEdited
     * @param buttonSaveId
     * @param buttonReloadId
     * @param buttonResetId
     * @param selectYearDomId id du composant select permettant de définir les années de conso à afficher
     * @param defaultYearToSelect année par défaut à charger à l'initialisation
     * @param onInitCb
     * @param onUpdateCb
     * @constructor
     */
    constructor(tableDomId, sectionMonitoringId, tableCanBeEdited, buttonSaveId, buttonReloadId, buttonResetId, selectYearDomId, defaultYearToSelect, spanNbChangesDomId, onInitCb = () => {}, onUpdateCb = () => {}) {
        this.tableRoot = $(`#${tableDomId}`);
        this.tableCanBeEdited = Boolean(tableCanBeEdited);
        this.buttonSave = $(`#${buttonSaveId}`);
        this.buttonReload = $(`#${buttonReloadId}`);
        this.buttonReset = $(`#${buttonResetId}`);
        this.selectYear = $(`#${selectYearDomId}`).length > 0 ? $(`#${selectYearDomId}`) : null;
        this.selectedYear = defaultYearToSelect;
        this.spanNbChanges = $(`#${spanNbChangesDomId}`).length > 0 ? $(`#${spanNbChangesDomId}`) : null;

        // url de la route à interroger pour récupérer les données de consommation
        this.ajaxUrlForGet = `${G.config.SERVER}frontend/ajax/objectSiteMonitoringAnnual/${sectionMonitoringId}`;
        // url de la route à interroger pour envoyer des modifications sur les données de consommation
        this.ajaxUrlForUpdate = `${G.config.SERVER}frontend/ajax/updateObjectValue`;
        this.ajaxXhrForGet = null;
        this.ajaxXhrForUpdate = null;
        this.ajaxXhrForUpdate = null;

        this.modificationValuesByUser = [];
        this.cbOnUpdateTable = onUpdateCb;

        this.selectYear.val(this.selectedYear);
        this.spanNbChanges.parent("div").hide();

        this.initTable();
        this.initActionButton();

        onInitCb();
    }

    initTable() {
        let self = this;
        const monthes = G.config.LOCALE_RETRIEVE("date.monthesShort");

        if(this.tableCanBeEdited) {
            this.tableRoot
                .off("click", ".button_edit_action")
                .on("click", ".button_edit_action", function(event) {
                    const elementId = $(event.currentTarget).data("element-id");
                    const elementObjectId = $(event.currentTarget).data("element-object-id");
                    const elementUnit = $(event.currentTarget).data("element-unit");
                    const elementValueMonthIndex = $(event.currentTarget).data("element-value-month");
                    const elementValueMonth = G.config.LOCALE_RETRIEVE("date.monthesShort")[elementValueMonthIndex - 1];
                    const elementValueYear = $(event.currentTarget).data("element-value-year");
                    let labelCustomAdditionalField$ = $(`<label class="uicomp__label is-required">${G.config.LOCALE_RETRIEVE('general.comment')}</label>`);
                    let customAdditionalField$ = $(`<input type="text" name="comment" class="uicomp__input" required />`);

                    self.openModalForManualValueEntry(elementId, elementObjectId, elementValueMonthIndex, elementValueYear, `${elementUnit} (${elementValueMonth} ${elementValueYear})`, labelCustomAdditionalField$, customAdditionalField$);
                });

            if(this.spanNbChanges) { this.spanNbChanges.parent("div").show(); }
        }

        this.tableRoot.wrap('<div class="table-consumption-wrapper"></div>');
        this.tableRoot.append(`
            <colgroup>
                <col class="col-label" />
                <col class="col-unit" />
                <col class="col-month" span="12" />
                <col class="col-total" />
            </colgroup>
            <thead>
                <tr>
                    <th class="table_consumption_cell_label table_consumption_cell_label_sticky"></th>
                    <th class="table_consumption_cell_unit_sticky">${G.config.LOCALE_RETRIEVE('general.unit')}</th>
                    <th>${monthes[0]}</th>
                    <th>${monthes[1]}</th>
                    <th>${monthes[2]}</th>
                    <th>${monthes[3]}</th>
                    <th>${monthes[4]}</th>
                    <th>${monthes[5]}</th>
                    <th>${monthes[6]}</th>
                    <th>${monthes[7]}</th>
                    <th>${monthes[8]}</th>
                    <th>${monthes[9]}</th>
                    <th>${monthes[10]}</th>
                    <th>${monthes[11]}</th>
                    <th class="table_consumption_cell_total">${G.config.LOCALE_RETRIEVE('indicator.total')}</th>
                </tr>
            </thead>
            <tbody></tbody>
        `);

        this.reloadDataFromTable();

        if(this.selectYear) {
            this.selectYear.change((event) => {
                self.selectedYear = self.selectYear.val();
                self.clearLocallyModificatationByUser();
                self.refreshViewWithUserModification();
                self.reloadDataFromTable();
            });
        }
    }

    initActionButton() {
        let self = this;

        this.buttonSave.off("click");
        this.buttonReset.off("click");
        this.buttonReload.off("click");

        if(this.tableCanBeEdited) {
            this.buttonSave.on("click", function() {
                if(self.ajaxXhrForUpdate) self.ajaxXhrForUpdate.abort();

                self.ajaxXhrForUpdate = $.ajax({
                    url : `${self.ajaxUrlForUpdate}`,
                    type : 'POST',
                    data: {
                        data: self.modificationValuesByUser
                    },
                    beforeSend: function() {
                        self.buttonReload.attr('disabled', true);
                        showInfo(G.config.LOCALE_RETRIEVE('general.saveInProgress'));
                    },
                    success: function(response) {
                        if(response.status === "success") {
                            showSuccess(G.config.LOCALE_RETRIEVE('general.saveSuccess'));

                            for (const modificationValueByUser of self.modificationValuesByUser) {
                                let tableConsumptionCell$ = self.findTableConsumptionCell(modificationValueByUser["id"], "label", modificationValueByUser["year"]);
                                if(tableConsumptionCell$) {
                                    tableConsumptionCell$.find(".cell_icon_row_status").html(`
                                    <span class="far fa-pen-square gv-tip" title="${G.config.LOCALE_RETRIEVE('general')["row_data_is_editable"]}" style="color: #96BF55"></span>
                                    <span class="far fa-spinner fa-spin gv-tip" title="${G.config.LOCALE_RETRIEVE('general')["row_data_update_in_progress"]}" style="color: #5BA5BA"></span>
                                `);
                                    G.ui.tippedInit(tableConsumptionCell$);
                                }
                            }
                            if(!self.tableRoot.find("tr.table_consumption_status_message").exists()) {
                                var countTableHeader = self.tableRoot.find("thead tr th").length;
                                self.tableRoot.find("tbody").prepend(`
                                    <tr class="table_consumption_status_message"><td colspan="${countTableHeader}" style="background-color: #5ba5ba; color: white;">
                                        <span class="far fa-spinner fa-spin gv-tip"></span>&nbsp;
                                        ${G.config.LOCALE_RETRIEVE('general')["modifications_are_being_processed"]}
                                    </td></tr>
                                `);
                            }

                            self.clearLocallyModificatationByUser();
                            self.refreshViewWithUserModification();
                            self.refreshStateDisabledActionButton();
                            self.cbOnUpdateTable();
                        } else {
                            showError(response.error ?? G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
                        }
                    },
                    error: function(xhr) {
                        showError(G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
                    },
                    complete: function() {
                        self.buttonReload.attr('disabled', false);
                        self.ajaxXhrForUpdate = null;
                    }
                });
            });
            this.buttonReload.on("click").on("click", function() {
                self.reloadDataFromTable();
            });
        }

        this.buttonReset.on("click", function() {
            self.clearLocallyModificatationByUser();
            self.refreshViewWithUserModification();
            self.reloadDataFromTable();
        });

        this.refreshStateDisabledActionButton();
    }

    refreshStateDisabledActionButton() {
        if(!isarray(this.modificationValuesByUser)) this.clearLocallyModificatationByUser();

        const shouldBtnSaveAndResetBeDisabled = !(this.tableCanBeEdited) || isarrayempty(this.modificationValuesByUser);

        this.buttonSave.attr('disabled', shouldBtnSaveAndResetBeDisabled);
        this.buttonReset.attr('disabled', shouldBtnSaveAndResetBeDisabled);
    }

    reloadDataFromTable() {
        let self = this;
        const tableBodyRoot = self.tableRoot.find("tbody");
        let countTableHeader = self.tableRoot.find("thead tr th").length;

        if(this.ajaxXhrForGet) this.ajaxXhrForGet.abort();

        this.ajaxXhrForGet = $.ajax({
            url : `${this.ajaxUrlForGet}?year=${this.selectedYear}`,
            type : 'GET',
            dataType : 'json',
            beforeSend: function() {
                self.buttonReload.attr('disabled', true);
                self.refreshStateDisabledActionButton();
                tableBodyRoot.empty();
                tableBodyRoot.append(`
                    <tr><td colspan="${countTableHeader}">${G.config.LOCALE_RETRIEVE('datatable.loadingRecords')}</td></tr>
                `);
            },
            success: function(response) {
                tableBodyRoot.empty();

                if(response == null || response.status === "error") {
                    if(this.selectYear) this.selectYear.hide();
                    tableBodyRoot.append(`
                        <tr><td colspan="${countTableHeader}">${G.config.LOCALE_RETRIEVE('general')["errorHasOccured"]}</td></tr>
                    `);
                }
                else if(response.status === "success" && response.data.rows.length === 0) {
                    if(this.selectYear) this.selectYear.hide();
                    tableBodyRoot.append(`
                        <tr><td colspan="${countTableHeader}">${G.config.LOCALE_RETRIEVE('datatable')["emptyTable"]}</td></tr>
                    `);
                }
                else {
                    // Récupération des données à traiter
                    const categories = response.data.categories;
                    const rows       = response.data.rows;

                    let data_update_in_progress = false;

                    // Parcours des catégories à définir dans le tableau de consommation
                    for(const category of categories) {
                        // Récupération des rows appartenant à cette catégorie
                        const categoryRows = rows.filter(row => row["categoryId"] == category["id"]);

                        tableBodyRoot.append(`<tr>
                            <td class="table_consumption_cell_category table_consumption_cell_category_sticky">${category["name"]}</td>
                            <td class="table_consumption_cell_category table_consumption_cell_fill_category" colspan="${countTableHeader - 1}"></td>
                        </tr>`);

                        for(const consumption of categoryRows) {
                            if(consumption["update_in_progress"]) data_update_in_progress = true;

                            const tableRootRow$ = $("<tr></tr>");
                            if(exists(consumption["style"])) {
                                tableRootRow$.addClass(consumption["style"]);
                            }

                            let tableCellLabel$ = self.createTableConsumptionCell(consumption["identifier"], "label", self.selectedYear);
                            const tableRowEditableBadge          = consumption["editable"]          ? `<span class="far fa-pen-square gv-tip text-green" title="${G.config.LOCALE_RETRIEVE('general')["row_data_is_editable"]}"></span>` : "";
                            const tableRowDescriptionBadge       = consumption["description"]       ? `<span class="far fa-info-circle gv-tip text-info" title="${consumption["description"]}"></span>` : "";
                            const tableRowUpdateInProgressBadge  = consumption["update_in_progress"]? `<span class="far fa-spinner fa-spin gv-tip" title="${G.config.LOCALE_RETRIEVE('general')["row_data_update_in_progress"]}" style="color: #5BA5BA"></span>` : "";

                            const badges     = [tableRowDescriptionBadge, tableRowEditableBadge, tableRowUpdateInProgressBadge].filter(Boolean);
                            const badgesHtml = badges.length > 0 ? `&nbsp;${badges.join("&nbsp;")}` : "";

                            tableCellLabel$.html(`${consumption["label"]}<span class="cell_icon_row_status">${badgesHtml}</span>`);
                            tableCellLabel$.addClass("table_consumption_cell_label");
                            tableCellLabel$.addClass("table_consumption_cell_label_sticky");

                            let tableCellUnit$ = self.createTableConsumptionCell(consumption["identifier"], "unit", self.selectedYear);
                            tableCellUnit$.addClass("table_consumption_cell_unit_sticky");
                            tableCellUnit$.html(consumption["unit"]);

                            tableRootRow$.append(tableCellLabel$);
                            tableRootRow$.append(tableCellUnit$);

                            for(let monthIndex = 1; monthIndex <= 12; monthIndex++) {
                                // ← Accès via consumption["months"][monthIndex] au lieu de consumption[monthIndex]
                                const monthData = consumption["months"][monthIndex];

                                let tableCell$ = self.createTableConsumptionCell(consumption["identifier"], monthIndex, self.selectedYear);
                                tableCell$.addClass(monthData["color"]);

                                if(self.tableCanBeEdited && consumption["editable"] && exists(consumption["objectId"])) tableCell$.addClass("mod--editable");

                                tableCell$.append(`
                                    <div class="cell_button_value_brut">
                                        <span class="cell_button_value_brut_initial">${monthData["value"]}</span>
                                        <span class="cell_button_value_brut_edited"></span>
                                    </div>
                                `);

                                if(self.tableCanBeEdited && consumption["editable"] && exists(consumption["objectId"])) {
                                    tableCell$.append(`
                                        <div class="cell_button_edit_action">
                                            <button 
                                                class="uicomp__button uicomp--small uicomp--full-width button_edit_action"
                                                data-element-id="${consumption["identifier"]}"
                                                data-element-object-id="${consumption["objectId"]}"
                                                data-element-unit="${consumption["unit"]}"
                                                data-element-value-month="${monthIndex}"
                                                data-element-value-year="${self.selectedYear}"
                                                >
                                                ${G.config.LOCALE_RETRIEVE('general.update')}
                                            </button>
                                        </div>
                                    `);
                                }
                                tableRootRow$.append(tableCell$);
                            }

                            let tableCellTotal$ = $("<td></td>");
                            tableCellTotal$.addClass("table_consumption_cell_total");
                            tableCellTotal$.addClass(consumption["total"]["color"]);
                            tableCellTotal$.html(consumption["total"]["value"]);
                            tableRootRow$.append(tableCellTotal$);

                            tableBodyRoot.append(tableRootRow$);
                        }
                    }

                    if(data_update_in_progress && !self.tableRoot.find("tr.table_consumption_status_message").exists()) {
                        tableBodyRoot.prepend(`
                            <tr class="table_consumption_status_message"><td colspan="${countTableHeader}" style="background-color: #5ba5ba; color: white;">
                                <span class="far fa-spinner fa-spin gv-tip"></span>&nbsp;
                                ${G.config.LOCALE_RETRIEVE('general')["modifications_are_being_processed"]}
                            </td></tr>
                        `);
                    }

                    G.ui.tippedInit(tableBodyRoot);
                }

                self.refreshViewWithUserModification();
                self.refreshStateDisabledActionButton();
            },
            error: function(xhr) {
                tableBodyRoot.empty();
                if(this.selectYear) this.selectYear.hide();
                let countTableHeader = self.tableRoot.find("thead tr th").length
                tableBodyRoot.append(`
                    <tr><td colspan="${countTableHeader}">${G.config.LOCALE_RETRIEVE('general')["errorHasOccured"]}</td></tr>
                `);
            },
            complete: function() {
                self.buttonReload.attr('disabled', false);
                self.ajaxXhrForGet = null;
            }
        });
    }

    saveLocallyModificationByUser(id, objectId, monthIndex, year, value, comment) {
        if(!isarray(this.modificationValuesByUser)) this.modificationValuesByUser = [];

        // Supprimer la valeur modifié avant qui est sur la même période saisi par l'utilisateur
        this.modificationValuesByUser = this.modificationValuesByUser.filter(function(objectModification) {
            return !(objectModification["id"] === id && objectModification["objectId"] === objectId && objectModification["month"] === monthIndex && objectModification["year"] === year)
        });

        this.modificationValuesByUser.push({
            id: id,
            objectId: objectId,
            month: monthIndex,
            year: year,
            value: value,
            comment: comment
        });
    }

    refreshViewWithUserModification() {
        const isThereModificationValuesByUser = this.modificationValuesByUser.length > 0;
        this.tableRoot.find(".cell_button_value_brut_edited").empty();
        this.tableRoot.find(".cell_button_value_brut_initial").show();
        this.tableRoot.find(".mod--edited")
            .removeClass("mod--edited")
            .removeClass("gv-tip")
            .removeAttr("title")
            .removeData("old-value");
        this.tableRoot.find("tbody tr.row_status_warning_modification_has_to_be_save").remove();

        for (const modificationValueByUser of this.modificationValuesByUser) {
            let tableConsumptionCell$ = this.findTableConsumptionCell(modificationValueByUser["id"], modificationValueByUser["month"], modificationValueByUser["year"]);
            const modificationOldValueByUser = numberFormat(tableConsumptionCell$.find(".cell_button_value_brut_initial").text());

            if(tableConsumptionCell$) {
                const newValueFormatted = numberFormat(modificationValueByUser["value"], 0, '.', ' ');

                tableConsumptionCell$.addClass("mod--edited");
                tableConsumptionCell$.addClass("gv-tip");

                // Masquer l'initiale, afficher la nouvelle dans l'edited
                tableConsumptionCell$.find(".cell_button_value_brut_initial").hide(); // ← ajouter
                tableConsumptionCell$.find(".cell_button_value_brut_edited").text(newValueFormatted);

                // Tooltip avec ancienne ET nouvelle valeur
                tableConsumptionCell$.data("old-value", modificationOldValueByUser);
                tableConsumptionCell$.attr("title", `Ancienne valeur : ${modificationOldValueByUser}<br>Nouvelle valeur : ${newValueFormatted}`);
                G.ui.tippedInit(tableConsumptionCell$);
            }
        }

        if(isThereModificationValuesByUser && !this.tableRoot.find("tbody tr.row_status_warning_modification_has_to_be_save").exists()) {
            var countTableHeader = this.tableRoot.find("thead tr th").length;
            this.tableRoot.find("tbody").prepend(`
            <tr class="row_status_warning_modification_has_to_be_save"><td colspan="${countTableHeader}" style="background-color: #dbb928; color: white;">
                <span class="far fa-exclamation-triangle gv-tip"></span>&nbsp;
                ${G.config.LOCALE_RETRIEVE('general')["please_save_your_modifications"]}
            </td></tr>
        `);
        }

        if(this.spanNbChanges) { this.spanNbChanges.text(this.modificationValuesByUser.length); }
    }

    clearLocallyModificatationByUser() {
        this.modificationValuesByUser = [];
        if(this.spanNbChanges) { this.spanNbChanges.text("0"); }
    }

    openModalForManualValueEntry(elementId, elementObjectId, elementValueMonth, elementValueYear, labelValueSuffix = "", labelCustomAdditionalField$ = null, customAdditionalField$ = null) {
        let self = this;
        let isCustomFieldToBeAdding = exists(customAdditionalField$) && exists(labelCustomAdditionalField$);
        let customFieldHtml = "";

        if (isCustomFieldToBeAdding) {
            customFieldHtml = `
                <div class="gvg-6on6 gvg-3on6--narrow">
                    ${$("<div></div>").append(labelCustomAdditionalField$.clone()).html()}
                    ${$("<div></div>").append(customAdditionalField$.clone()).html()}
                </div>
            `;
        }

        Swal.fire({
            title: G.config.LOCALE_RETRIEVE('general.update'),
            html: `
                <div id="swal-consumption-manual-value-entry" class="gvg-r gvg-r--gutter text-left">
                    <div class="gvg-6on6 ${isCustomFieldToBeAdding ? "gvg-3on6--narrow" : ""}">
                        <label class="uicomp__label is-required">
                            ${G.config.LOCALE_RETRIEVE('general.value')} ${labelValueSuffix ?? ""}
                        </label>
                        <input type="number" name="value" class="uicomp__input" step="0.01" required autocomplete="off" />
                    </div>
                    ${customFieldHtml}
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: G.config.LOCALE_RETRIEVE('synopsis.applyChanges'),
            cancelButtonText: G.config.LOCALE_RETRIEVE('general.cancel'),
            allowOutsideClick: false,
            customClass: {
                actions: "uicomp__hflow mod--align-center mod--nowrap",
                closeButton: "uicomp__button uicomp--transparent",
                input: "uicomp__input",
                inputLabel: "uicomp__label",
                confirmButton: "uicomp__button uicomp--brand",
                denyButton: "uicomp__button uicomp--grey",
                cancelButton: "uicomp__button uicomp--red"
            },
            buttonsStyling: false,
            reverseButtons: true,
            preConfirm: function () {
                const popup = Swal.getPopup();
                const manualModificationValuesByUser = {
                    id: elementId,
                    objectId: elementObjectId,
                    month: elementValueMonth,
                    year: elementValueYear,
                    value: $(popup).find('[name="value"]').val(),
                    comment: $(popup).find('[name="comment"]').val()
                };

                if (!manualModificationValuesByUser.value) {
                    Swal.showValidationMessage(G.config.LOCALE_RETRIEVE('general.invalidValue'));
                    return false;
                }

                if (isCustomFieldToBeAdding && !manualModificationValuesByUser.comment) {
                    Swal.showValidationMessage(G.config.LOCALE_RETRIEVE('general.comment'));
                    return false;
                }

                return manualModificationValuesByUser;
            }
        }).then(function (result) {
            if (!result.isConfirmed || !result.value) {
                return;
            }

            self.saveLocallyModificationByUser(
                result.value.id,
                result.value.objectId,
                result.value.month,
                result.value.year,
                result.value.value,
                result.value.comment
            );
            self.refreshViewWithUserModification();
            self.refreshStateDisabledActionButton();
        });
    }

    createTableConsumptionCell(identifier, columnLabel, year) {
        let cell$ = $("<td></td>");
        cell$.attr("id", `table_consumption_cell_${identifier}_${columnLabel}_${year}`)
        return cell$;
    }
    findTableConsumptionCell(identifier, columnLabel, year) {
        return this.tableRoot.find(`#table_consumption_cell_${identifier}_${columnLabel}_${year}`);
    }

};

G.ui.TableMonitoringEditor = class {
    static PREFIX_CAT_UUID = "cat";
    static PREFIX_COMP_UUID = "comp";

    static PREFIX_VALUE_OPT_EQUIPMENT = "eq_";
    static PREFIX_VALUE_OPT_OBJECT = "ob_";

    constructor(rootEl, siteId, sectionMonitoringId, cfg = {}) {
        if (!rootEl) throw new Error("TableEditorConsumption: rootEl manquant.");

        this.el = rootEl;
        this.el.classList.add("table-monitoring-editor");

        this.onChange = typeof cfg.onChange === "function" ? cfg.onChange : () => {};

        this._instanceId = this._uid("instance");

        this.siteId = Number.parseInt(siteId, 10);
        this.sectionMonitoringId = Number.parseInt(sectionMonitoringId, 10);

        let sectionMonitoring = {};
        let site = {};
        let estateSiteChilds = {};
        let equipments = [];
        let componentStyles = [];
        let displayModeCounters = [];
        let objects = [];

        const responseLoadSectionMonitoring = $.ajax({
            url: `${G.config.SERVER}apigv/sectionMonitoring/index/${sectionMonitoringId}`,
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer "+G.model.userApiKey
            },
            method: "GET",
            async: false
        });
        if(responseLoadSectionMonitoring && responseLoadSectionMonitoring.responseJSON.status === "success") {
            sectionMonitoring = responseLoadSectionMonitoring.responseJSON.response.sectionMonitoring;
        }
        else {
            throw new Error("TableEditorConsumption: erreur du chargement de l'onglet du tableau de suivi");
        }

        const responseSiteInfo = $.ajax({
            url: `${G.config.SERVER}apigv/sites/infos/${siteId}`,
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer "+G.model.userApiKey
            },
            method: "GET",
            async: false
        });
        if(responseSiteInfo && responseSiteInfo.responseJSON.status === "success") {
            site = responseSiteInfo.responseJSON.response.site;
            estateSiteChilds = (site.estateSiteChilds ?? []).reduce((acc, child) => {
                acc[Number.parseInt(child.id, 10)] = child;
                return acc;
            }, {});
            equipments = site.equipements;
        }
        else {
            throw new Error("TableEditorConsumption: erreur du chargement du site de l'onglet du tableau de suivi");
        }

        const responseLoadObjects = $.ajax({
            url: `${G.config.SERVER}apigv/sites/objects/${siteId}`,
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer "+G.model.userApiKey
            },
            method: "GET",
            async: false
        });
        if(responseLoadObjects && responseLoadObjects.responseJSON.status === "success") {
            objects = responseLoadObjects.responseJSON.response.objects;
        }
        else {
            throw new Error("TableEditorConsumption: erreur du chargement des objets du site associé au tableau de suivi");
        }

        const responseListAllComponentStyles = $.ajax({
            url: `${G.config.SERVER}apigv/sectionMonitoring/listComponentStyles`,
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer "+G.model.userApiKey
            },
            method: "GET",
            async: false
        });
        if(responseListAllComponentStyles && responseListAllComponentStyles.responseJSON.status === "success") {
            componentStyles = responseListAllComponentStyles.responseJSON.response.styles;
        }

        const responseListDisplayModeCounter = $.ajax({
            url: `${G.config.SERVER}apigv/sectionMonitoring/listDisplayModeCounter`,
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer "+G.model.userApiKey
            },
            method: "GET",
            async: false
        });
        if(responseListDisplayModeCounter && responseListDisplayModeCounter.responseJSON.status === "success") {
            displayModeCounters = responseListDisplayModeCounter.responseJSON.response.displayModeCounter;
        }

        this._state = {
            categories: this._buildStateCategoriesFromDataApi(sectionMonitoring.sectionMonitoringCategories),
            editingCat: null,
            editingComponent: null,
            isDirty: false
        };

        this.opts = {
            srcPoints: [
                { value: null, label: G.config.LOCALE_RETRIEVE('editorConsumption.optNone') },
                {
                    label: G.config.LOCALE_RETRIEVE('editorConsumption.groupMetar'),
                    options: exists(site?.metar) ? [
                        { value: `${this.constructor.PREFIX_VALUE_OPT_EQUIPMENT}${site?.metar.id}`, label: site?.metar.nom }
                    ] : []
                },
                {
                    label: G.config.LOCALE_RETRIEVE('editorConsumption.groupEquipment'),
                    options: equipments.map(equipment => {
                        const childSite = estateSiteChilds[Number.parseInt(equipment.site_id, 10)] ?? null;
                        return {
                            "value": `${this.constructor.PREFIX_VALUE_OPT_EQUIPMENT}${equipment.id}`,
                            "label": (!!site.isEstateSite && exists(childSite)) ? `${childSite.nom} / ${equipment.nom}` : equipment.nom
                        }
                    })
                },
                {
                    label: G.config.LOCALE_RETRIEVE('editorConsumption.groupObject'),
                    options: objects.map(object => {
                        const childSite = estateSiteChilds[Number.parseInt(object.site_id, 10)] ?? null;
                        return {
                            "value": `${this.constructor.PREFIX_VALUE_OPT_OBJECT}${object.id}`,
                            "label": (!!site.isEstateSite && exists(childSite)) ? `${childSite.nom} / ${object.nom} (#${object.type})` : `${object.nom} (#${object.type})`
                        }
                    })
                }
            ],
            points: [],
            styles: [
                { "value": null, "label": G.config.LOCALE_RETRIEVE('editorConsumption.optDefault') },
                ...Object.entries(componentStyles).map(([key, value]) => {
                    return {
                        "value": key,
                        "label": value
                    };
                })
            ],
            displayModeCounters: [
                { "value": null, "label": "Défaut" },
                ...Object.entries(displayModeCounters).map(([key, value]) => {
                    return {
                        "value": key,
                        "label": value
                    };
                })
            ]
        };

        // bind handlers
        this._onClick = this._onClick.bind(this);
        this._onInput = this._onInput.bind(this);
        this._onKeyDown = this._onKeyDown.bind(this);

        this.el.addEventListener("click", this._onClick);
        $(this.el).on("change.tableMonitoring", "select[data-role='compField']", this._onInput);
        this.el.addEventListener("input", this._onInput);
        this.el.addEventListener("keydown", this._onKeyDown);

        this.render();
    }

    destroy() {
        this._state = null;
        this.opts = null
        this.siteId = null;
        this._instanceId = null;
        this.sectionMonitoringId = null;
        this.el.removeEventListener("click", this._onClick);
        $(this.el).off("change.tableMonitoring");
        this.el.removeEventListener("input", this._onInput);
        this.el.removeEventListener("keydown", this._onKeyDown);
        this.el.innerHTML = "";
    }

    _buildStateCategoriesFromDataApi(categories) {
        return categories.map((cat, idxCat) => ({
            id: Number.parseInt(cat.id, 10),
            name: cat.name ?? "Nouvelle catégorie",
            position: cat.position ?? idxCat,
            expanded: false,
            components: Array.isArray(cat.sectionMonitoringComponents) ? cat.sectionMonitoringComponents.map((comp, idxComp) => ({
                id: Number.parseInt(comp.id, 10),
                label: comp.label ?? "",
                description: comp.description ?? "",
                style: comp.style ?? "",
                displayCounterMode: comp.displayCounterMode ?? "",
                position: comp.position ?? idxComp,
                object: {
                   id: comp?.object?.id ?? null,
                   name: comp?.object?.nom ?? ""
                },
                point: exists(comp.point) ? {
                    id: comp.point.id,
                    labelHuman: comp.point.labelHumain,
                    isM2C: !!(comp.point.isM2C ?? 0),
                    virtual: !!(comp.point.virtuel ?? 0),
                    unit: {
                        id: comp?.point?.unite?.id ?? null,
                        symbol: comp?.point?.unite?.symbole ?? ""
                    },
                    datatype: {
                        id: comp?.point?.typeDonnees?.id ?? null,
                        name: comp?.point?.typeDonnees?.nom ?? ""
                    },
                    equipment: {
                        id: comp?.point?.equipement?.id ?? null,
                        name: comp?.point?.equipement?.nom ?? ""
                    }
                } : null
            })) : [],
        }));
    }

    _buildOptPointsFromDataApi(points) {
        return points.map((point, idxPoint) => ({
            id: Number.parseInt(point.id, 10),
            labelHuman: point.labelHumain,
            isM2C: !!(point.isM2C ?? 0),
            virtual: !!(point.virtuel ?? 0),
            unit: {
                id: point?.unite_id ?? null,
                symbol: point?.unite ?? ""
            },
            datatype: {
                id: point?.type_donnees_id ?? null,
                name: point?.type ?? ""
            },
            equipment: {
                id: point?.equipement_id ?? null,
                name: point?.equipmentName ?? ""
            }
        }));
    }


    _loadPointsForSource(srcPointValue, selPoint, selectedPointId = null) {

        if(typeof srcPointValue == "string" && srcPointValue.startsWith(this.constructor.PREFIX_VALUE_OPT_OBJECT)) {
            srcPointValue = srcPointValue.replace(this.constructor.PREFIX_VALUE_OPT_OBJECT, "objet-");
        }
        else if (typeof srcPointValue == "string" && srcPointValue.startsWith(this.constructor.PREFIX_VALUE_OPT_EQUIPMENT)) {
            srcPointValue = srcPointValue.replace(this.constructor.PREFIX_VALUE_OPT_EQUIPMENT, "");
        }
        else {
            srcPointValue = null;
        }

        const responseLoadSrcPoints = exists(srcPointValue) ? $.ajax({
            url: `${G.config.SERVER}apigv/points/loads/${srcPointValue}`,
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer "+G.model.userApiKey
            },
            async: false,
            method: "POST",
            data: JSON.stringify({
                equipementId: srcPointValue,
                siteId: this.siteId,
                onlyM2cOrCounter: true
            })
        }) : null;

        selPoint.innerHTML = "";
        selPoint.appendChild(
            this._h("option", { value: "" }, "Aucun")
        );

        this.opts.points = [];

        if(responseLoadSrcPoints && responseLoadSrcPoints.responseJSON.status === "success") {
            this.opts.points = this._buildOptPointsFromDataApi(responseLoadSrcPoints.responseJSON.response.points || []);

            let hasSelectedValue = false;

            this.opts.points.forEach((point) => {

                const pointValue = String(point.id);

                const opt = this._h(
                    "option",
                    { value: pointValue },
                    point.labelHuman
                );

                if (selectedPointId && pointValue === String(selectedPointId)) {
                    opt.selected = true;
                    hasSelectedValue = true;
                }

                selPoint.appendChild(opt);
            });

            if (!hasSelectedValue) {
                selPoint.value = "";
            }
        }
        else {
            console.warn("TableEditorConsumption: erreur chargement point via la srcpoints");
        }

        $(selPoint).trigger("change.select2");
    }

    /* -----------------------
       Render
    ----------------------- */
    render() {
        const scrollY = window.scrollY; // ← sauvegarde position avant reconstruction car innerHtml="" réinitilise la position du scroll

        this.el.innerHTML = "";

        const list = this._h("div", { className: "table-monitoring-editor__list" });

        const toolbar = this._h("div", { className: "table-monitoring-editor__toolbar" });

        /*const btnPreview = this._h("button", {
                className: "uicomp__button uicomp--grey",
                id: `btn-preview-section-monitoring-${this._instanceId}`,
                type: "button",
                "data-action": "toolbar.preview",
            },
            this._h("i", { className: "fas fa-eye" }),
            this._h("span", null, "Aperçu")
        );*/

        const btnSave = this._h("button", {
                className: "uicomp__button uicomp--green",
                id: `btn-save-section-monitoring-${this._instanceId}`,
                type: "button",
                "data-action": "toolbar.save",
                disabled: !this._state.isDirty ? true : null,  // ✅ désactivé si pas de modif
            },
            this._h("i", { className: "fas fa-save" }),
            this._h("span", null, G.config.LOCALE_RETRIEVE('editorConsumption.save'))
        );

        /*toolbar.appendChild(btnPreview);*/
        toolbar.appendChild(btnSave);
        list.appendChild(toolbar);

        this._state.categories.forEach((cat, ci) => {
            const card = this._renderCategory(cat, ci);
            list.appendChild(card);
        });

        list.appendChild(
            this._h("button", { className: "table-monitoring-editor__btnAddCat", type: "button", "data-action": "cat.add" },
                this._h("i", {
                    className: "fas fa-plus",
                    "aria-hidden": "true"
                }),
                this._h("span", null, G.config.LOCALE_RETRIEVE('editorConsumption.addCategory'))
            )
        );

        this.el.appendChild(list);

        window.scrollTo({ top: scrollY, behavior: "instant" }); // ← restauration position après reconstruction
    }

    _renderCategory(cat, ci) {
        const card = this._h("div", { className: "table-monitoring-editor__cat" });

        const header = this._h("div", {
            className: "table-monitoring-editor__catHeader"
        });

        const left = this._h("div", { className: "table-monitoring-editor__catHeaderLeft" });

        // name (span or input)
        if (this._state.editingCat === cat.id) {
            const input = this._h("input", {
                className: "table-monitoring-editor__catNameInput",
                value: cat.name,
                placeholder: G.config.LOCALE_RETRIEVE('editorConsumption.categoryNamePlaceholder'),
                "data-role": "catNameInput",
                "data-cat-id": cat.id,
            });

            // ← ajout : ferme le mode édition quand on quitte le champ
            input.addEventListener('blur', () => {
                this._state.editingCat = null;
                this.render();
                this._emit();
            });

            left.appendChild(input);
        }
        else {
            left.appendChild(
                this._h("span", {
                    className: "table-monitoring-editor__catName",
                    title: cat.name,
                    "data-action": "cat.edit",
                    "data-cat-id": cat.id,
                }, cat.name)
            );
        }

        left.appendChild(
            this._h("span", { className: "table-monitoring-editor__catComponentsCount" }, `${cat.components.length} ${G.config.LOCALE_RETRIEVE(cat.components.length > 1 ? 'editorConsumption.componentCount_other' : 'editorConsumption.componentCount_one')}`)
        );

        header.appendChild(left);

        // actions
        const actions = this._h("div", { className: "table-monitoring-editor__catActions" });

        actions.appendChild(this._h("button", {
            type: "button",
            className: "table-monitoring-editor__iconBtn",
            "data-action": "cat.toggle",
            "data-cat-id": cat.id,
        }, this._h("i", {
            className: cat.expanded ? "fas fa-chevron-up" : "fas fa-chevron-down",
            "aria-hidden": "true"
        })));

        actions.appendChild(this._h("button", {
                type: "button",
                className: "table-monitoring-editor__iconBtn",
                disabled: ci === 0 ? true : null,
                "data-action": "cat.move",
                "data-dir": "-1",
                "data-cat-id": cat.id,
            },
            this._h("i", {
                className: "fas fa-long-arrow-up",
                "aria-hidden": "true"
            })
        ));

        actions.appendChild(this._h("button", {
                type: "button",
                className: "table-monitoring-editor__iconBtn",
                disabled: ci === this._state.categories.length - 1 ? true : null,
                "data-action": "cat.move",
                "data-dir": "1",
                "data-cat-id": cat.id,
            },
            this._h("i", {
                className: "fas fa-long-arrow-down",
                "aria-hidden": "true"
            })
        ));

        actions.appendChild(this._h("button", {
                type: "button",
                className: "table-monitoring-editor__iconBtn table-monitoring-editor__iconBtn--danger",
                "data-action": "cat.delete",
                "data-cat-id": cat.id,
            },
            this._h("i", {
                className: "fas fa-times",
                "aria-hidden": "true"
            })
        ));

        header.appendChild(actions);
        card.appendChild(header);

        // components
        if (cat.expanded) {
            card.appendChild(this._renderComponents(cat));
        }

        return card;
    }

    _renderComponents(cat) {
        const wrap = this._h("div", { className: "table-monitoring-editor__components" });

        if (cat.components.length === 0) {
            wrap.appendChild(this._h("p", { className: "table-monitoring-editor__empty" }, G.config.LOCALE_RETRIEVE('editorConsumption.noComponent')));
        }

        cat.components.forEach((comp, compIdx) => {
            wrap.appendChild(this._renderComponentRow(cat, comp, compIdx));
        });

        wrap.appendChild(
            this._h("button", {
                    type: "button",
                    className: "table-monitoring-editor__btnAddComponent",
                    "data-action": "comp.add",
                    "data-cat-id": cat.id,
                },
                this._h("i", {
                    className: "fas fa-plus",
                    "aria-hidden": "true"
                }),
                G.config.LOCALE_RETRIEVE('editorConsumption.addComponent')
            )
        );

        return wrap;
    }

    _renderComponentRow(cat, comp, compIdx) {
        const row = this._h("div", { className: "table-monitoring-editor__componentRow" });

        const body = this._h("div", { className: "table-monitoring-editor__componentBody" });

        const isOpen = this._state.editingComponent === comp.id;

        const hdr = this._h("div", {
            className: "table-monitoring-editor__componentRowHeader",
            "data-action": "comp.toggle",
            "data-comp-id": comp.id,
        });

        const left = this._h("div", { className: "table-monitoring-editor__componentRowHeaderLeft" });

        left.appendChild(
            this._h("span", {
                className: `table-monitoring-editor__componentTitle ${comp.label ? "" : "table-monitoring-editor__componentTitle--is-empty"}`,
                title: comp.label || G.config.LOCALE_RETRIEVE('editorConsumption.newComponent'),
            }, comp.label || G.config.LOCALE_RETRIEVE('editorConsumption.newComponent'))
        );

        if (!isStrEmpty(comp?.point?.unit?.symbol)) left.appendChild(this._h("span", { className: "table-monitoring-editor__componentChip" }, comp.point.unit.symbol));
        if (!isStrEmpty(comp?.point?.datatype?.name)) left.appendChild(this._h("span", { className: "table-monitoring-editor__componentChip" }, comp.point.datatype.name));

        hdr.appendChild(left);
        hdr.appendChild(this._h("span", { className: `table-monitoring-editor__componentChevron ${isOpen ? "is-open" : ""}` },
            this._h("i", {
                className: "fas fa-chevron-down",
                "aria-hidden": "true"
            })));

        body.appendChild(hdr);

        if (isOpen) {
            body.appendChild(this._renderComponentForm(cat, comp));
        }

        row.appendChild(body);

        // row actions
        const acts = this._h("div", { className: "table-monitoring-editor__componentRowActions" });

        acts.appendChild(this._h("button", {
            type: "button",
            className: "table-monitoring-editor__iconBtnSm",
            disabled: compIdx === 0 ? true : null,
            "data-action": "comp.move",
            "data-dir": "-1",
            "data-cat-id": cat.id,
            "data-comp-id": comp.id,
        },
            this._h("i", {
                className: "fas fa-long-arrow-up",
                "aria-hidden": "true"
            })
        ));

        acts.appendChild(this._h("button", {
            type: "button",
            className: "table-monitoring-editor__iconBtnSm",
            disabled: compIdx === cat.components.length - 1 ? true : null,
            "data-action": "comp.move",
            "data-dir": "1",
            "data-cat-id": cat.id,
            "data-comp-id": comp.id,
        },
            this._h("i", {
                className: "fas fa-long-arrow-down",
                "aria-hidden": "true"
            })
        ));

        acts.appendChild(this._h("button", {
            type: "button",
            className: "table-monitoring-editor__iconBtnSm table-monitoring-editor__iconBtnSm--danger",
            "data-action": "comp.delete",
            "data-cat-id": cat.id,
            "data-comp-id": comp.id,
        },
            this._h("i", {
                className: "fas fa-times",
                "aria-hidden": "true"
            })));

        row.appendChild(acts);

        return row;
    }

    _renderComponentForm(cat, comp) {
        const form = this._h("div", { className: "table-monitoring-editor__form" });
        const grid = this._h("div", { className: "gvg-r gvg--gutter" });

        // helper to build fields
        const field = (label, control, extraClass = "", helpBlockTxt = "") => {
            return this._h("div", { className: `${extraClass}` },
                this._h("label", { className: "uicomp__label" }, label),
                control
            );
        }

        let selPoint = this._select([], comp?.point?.id ?? null, cat.id, comp.id, "point", (e, ctx) => {
            const selectedPoint = this.opts.points
                ?.find(p => String(p.id) === String(ctx.value)) ?? null;
            this._updateComponentPointHeader(cat.id, comp.id, selectedPoint);

            if (selectedPoint) {
                const cat = this._findCat(ctx.catId);
                if (!cat) return;
                const comp = this._findComponent(cat, ctx.compId);
                if (!comp) return;

                comp.label = selectedPoint.labelHuman;
                comp.point = selectedPoint;

                // Mettre à jour l'input label dans le DOM
                const labelInput = this.el.querySelector(
                    `input[data-role="compField"][data-comp-id="${ctx.compId}"][data-key="label"]`
                );
                if (labelInput) labelInput.value = selectedPoint.labelHuman;

                // Mettre à jour le titre dans le header de la row
                this._updateComponentHeader(ctx.catId, ctx.compId, selectedPoint.labelHuman);

                this._emit();
            }
        });

        let srcPointSelected;
        if(exists(comp?.object?.id)) {
            srcPointSelected = `${this.constructor.PREFIX_VALUE_OPT_OBJECT}${comp.object.id}`;
        }
        else if (exists(comp?.point?.equipment?.id)) {
            srcPointSelected = `${this.constructor.PREFIX_VALUE_OPT_EQUIPMENT}${comp.point.equipment.id}`;
        }
        else {
            srcPointSelected = null;
        }
        grid.appendChild(field(G.config.LOCALE_RETRIEVE('editorConsumption.fieldSourcePoints'), this._select(this.opts.srcPoints, srcPointSelected, cat.id, comp.id, "srcpoint", (e, ctx) => {
            const cat = this._findCat(ctx.catId);
            if (cat) {
                const comp = this._findComponent(cat, ctx.compId);
                if (exists(comp) && typeof ctx.value === "string" && ctx.value.startsWith(this.constructor.PREFIX_VALUE_OPT_OBJECT)) {
                    const objectId = Number.parseInt(ctx.value.replace(this.constructor.PREFIX_VALUE_OPT_OBJECT, ""), 10);
                    const objectName = ctx.label;
                    comp.object = { id: objectId, name: objectName };
                }
            }
            this._loadPointsForSource(ctx.value, selPoint);

        }), "gvg-6 gvg-4--narrow", "Pour activer les corrections manuelles, veuillez définir un objet (=unité de calcul globalvisio)"));

        this._loadPointsForSource(srcPointSelected, selPoint, comp?.point?.id ?? null);

        grid.appendChild(field(G.config.LOCALE_RETRIEVE('editorConsumption.fieldPoint'), selPoint, "gvg-6 gvg-4--narrow"));
        grid.appendChild(field(G.config.LOCALE_RETRIEVE('editorConsumption.fieldLabel'), this._input("text", comp.label, G.config.LOCALE_RETRIEVE('editorConsumption.placeholderLabel'), cat.id, comp.id, "label"), "gvg-6 gvg-4--narrow"));
        grid.appendChild(field(G.config.LOCALE_RETRIEVE('editorConsumption.fieldAnnotation'), this._input("text", comp.description, G.config.LOCALE_RETRIEVE('editorConsumption.placeholderAnnotation'), cat.id, comp.id, "description"), "gvg-12"));
        grid.appendChild(field(G.config.LOCALE_RETRIEVE('editorConsumption.fieldStyle'), this._select(this.opts.styles, comp.style, cat.id, comp.id, "style"), "gvg-6 gvg-3--narrow"));
        grid.appendChild(field(G.config.LOCALE_RETRIEVE('editorConsumption.fieldDisplayCounterMode'), this._select(this.opts.displayModeCounters, comp.displayCounterMode, cat.id, comp.id, "displayCounterMode"), "gvg-6 gvg-3--narrow"));

        grid.appendChild(this._h("div", { className: "linebreak" }));

        G.ui.initSelect2($(grid));
        $(grid).find('.gv-ui-ckeckbox').each(function (index, el) {
            $(el).find('input[type="checkbox"], input[type="radio"]').after($('<div class="gv-ui__mock"></div>'));
        });

        form.appendChild(grid);
        return form;
    }

    getState() {
        return structuredClone(this._state);
    }

    setState(newState) {
        return this._state = newState;
    }

    _buildPayload() {
        const state = this.getState();

        return state.categories.map(cat => {
            if (cat.id === null || (typeof cat.id === "string" && cat.id.startsWith(this.constructor.PREFIX_CAT_UUID))) {
                delete cat.id;
            }

            delete cat.expanded;

            cat.components = cat.components.map(comp => {
                if (comp.id === null || (typeof comp.id === "string" && comp.id.startsWith(this.constructor.PREFIX_COMP_UUID))) {
                    delete comp.id;
                }
                return comp;
            });

            return cat;
        });
    }

    /* -----------------------
       Internals
    ----------------------- */


    _uid(prefix) {
        const arrUint32 = new Uint32Array(1);
        self.crypto.getRandomValues(arrUint32);
        return `${prefix}-${arrUint32[0]}`;
    }

    _findCat(catId) {
        return this._state.categories.find((c) => c.id === catId) || null;
    }

    _findComponent(cat, compId) {
        return cat.components.find((comp) => comp.id === compId) || null;
    }

    _refreshCategoryPositions() {
        this._state.categories.forEach((cat, index) => {
            cat.position = index;
        });
    }

    _refreshComponentPositions(cat) {
        if (!cat || !Array.isArray(cat.components)) return;

        cat.components.forEach((comp, index) => {
            comp.position = index;
        });
    }

    _emit() {
        this._state.isDirty = true;

        const btnSave = this.el.querySelector(`#btn-save-section-monitoring-${this._instanceId}`);
        if (btnSave) btnSave.disabled = false;

        this.onChange(this.getState());
    }

    _updateComponentHeader(catId, compId, compLabel = "") {
        const titleEl = this.el.querySelector(
            `.table-monitoring-editor__componentRowHeader[data-comp-id="${compId}"] .table-monitoring-editor__componentTitle`
        );

        if (!titleEl) return;

        const text = compLabel || "Nouveau composant";
        titleEl.textContent = text;
        titleEl.title = text;
        titleEl.classList.toggle("table-monitoring-editor__componentTitle--is-empty", !compLabel);
    }

    _updateComponentPointHeader(catId, compId, point) {
        const hdrLeft = this.el.querySelector(
            `.table-monitoring-editor__componentRowHeader[data-comp-id="${compId}"] .table-monitoring-editor__componentRowHeaderLeft`
        );
        if (!hdrLeft) return;

        // Mettre à jour les chips sans toucher au titre
        hdrLeft.querySelectorAll(".table-monitoring-editor__componentChip").forEach(el => el.remove());

        if (point?.unit?.symbol) {
            hdrLeft.appendChild(this._h("span", { className: "table-monitoring-editor__componentChip" }, point.unit.symbol));
        }
        if (point?.datatype?.name) {
            hdrLeft.appendChild(this._h("span", { className: "table-monitoring-editor__componentChip" }, point.datatype.name));
        }
    }

    _closestAction(target) {
        return target?.closest?.("[data-action]") || null;
    }

    _onClick(e) {
        const btn = this._closestAction(e.target);
        if (!btn) return;

        const action = btn.dataset.action;

        const rawCatId = btn.dataset.catId;
        const catId = rawCatId != null && !rawCatId.startsWith(this.constructor.PREFIX_CAT_UUID)
            ? Number.parseInt(rawCatId, 10)
            : rawCatId ?? null;

        const rawCompId = btn.dataset.compId;
        const compId = rawCompId != null && !rawCompId.startsWith(this.constructor.PREFIX_COMP_UUID)
            ? Number.parseInt(rawCompId, 10)
            : rawCompId ?? null;

        switch (action) {
            /* ---- categories ---- */
            case "cat.toggle": {
                const cat = this._findCat(catId);
                if (!cat) return;

                const isCurrentlyExpanded = cat.expanded;

                // ← ferme toutes les catégories
                this._state.categories.forEach(c => c.expanded = false);

                // ← ouvre uniquement celle cliquée (si elle était fermée)
                cat.expanded = !isCurrentlyExpanded;

                this.render();
                break;
            }

            case "cat.edit": {
                this._state.editingCat = catId;
                this.render();
                // focus input après render
                queueMicrotask(() => {
                    const input = this.el.querySelector(`[data-role="catNameInput"][data-cat-id="${catId}"]`);
                    input?.focus?.();
                    input?.select?.();
                });
                //this._emit();
                break;
            }

            case "cat.editDone": {
                this._state.editingCat = null;
                this.render();
                this._emit();
                break;
            }

            case "cat.move": {
                const dir = Number(btn.dataset.dir || 0);
                const idx = this._state.categories.findIndex((c) => c.id === catId);
                const ni = idx + dir;
                if (idx < 0 || ni < 0 || ni >= this._state.categories.length) return;
                [this._state.categories[idx], this._state.categories[ni]] = [this._state.categories[ni], this._state.categories[idx]];
                this._refreshCategoryPositions();
                this.render();
                this._emit();
                break;
            }

            case "cat.delete": {
                this._state.categories = this._state.categories.filter((c) => c.id !== catId);
                if (this._state.editingCat === catId) this._state.editingCat = null;
                this._refreshCategoryPositions();
                this.render();
                this._emit();
                break;
            }

            case "cat.add": {
                // ← ferme toutes les catégories existantes avant d'ajouter
                this._state.categories.forEach(c => c.expanded = false);

                const newCat = {
                    id: this._uid(this.constructor.PREFIX_CAT_UUID),
                    name: G.config.LOCALE_RETRIEVE('editorConsumption.newCategory'),
                    expanded: true,
                    components: [],
                };
                this._state.categories.push(newCat);
                this._refreshCategoryPositions();
                this._state.editingCat = newCat.id;
                this.render();
                queueMicrotask(() => {
                    const input = this.el.querySelector(`[data-role="catNameInput"][data-cat-id="${newCat.id}"]`);
                    input?.focus?.();
                    input?.select?.();
                });
                this._emit();
                break;
            }

            /* ---- components ---- */
            case "comp.toggle": {
                this._state.editingComponent = (this._state.editingComponent === compId) ? null : compId;
                this.render();
                //this._emit();
                break;
            }

            case "comp.add": {
                const cat = this._findCat(catId);
                if (!cat) return;
                const newComp = {
                    id: this._uid(this.constructor.PREFIX_COMP_UUID),
                    label: "",
                    description: "",
                    style: "",
                    displayCounterMode: false,
                    position: -1,
                    object: {
                        id: null,
                        name: ""
                    },
                    point: {
                        id: null,
                        labelHuman: "",
                        isM2C: false,
                        virtual: false,
                        unit: {
                            id: null,
                            symbol: ""
                        },
                        datatype: {
                            id: null,
                            name: ""
                        },
                        equipment: {
                            id: null,
                            name: ""
                        }
                    }
                };
                cat.components.push(newComp);
                cat.expanded = true;
                this._state.editingComponent = newComp.id;
                this._refreshComponentPositions(cat);
                this.render();
                this._emit();
                break;
            }

            case "comp.delete": {
                const cat = this._findCat(catId);
                if (!cat) return;
                cat.components = cat.components.filter((p) => p.id !== compId);
                if (this._state.editingComponent === compId) this._state.editingComponent = null;
                this._refreshComponentPositions(cat);
                this.render();
                this._emit();
                break;
            }

            case "comp.move": {
                const dir = Number(btn.dataset.dir || 0);
                const cat = this._findCat(catId);
                if (!cat) return;
                const idx = cat.components.findIndex((p) => p.id === compId);
                const ni = idx + dir;
                if (idx < 0 || ni < 0 || ni >= cat.components.length) return;
                [cat.components[idx], cat.components[ni]] = [cat.components[ni], cat.components[idx]];
                this._refreshComponentPositions(cat);
                this.render();
                this._emit();
                break;
            }

            case "toolbar.preview": {
                console.log("Aperçu demandé", this.getState());
                break;
            }

            case "toolbar.save": {
                let self = this;
                const btnSave = this.el.querySelector(`#btn-save-section-monitoring-${this._instanceId}`);

                // Récupère l'icône, sauvegarde ses classes, met le spinner
                const iconEl = btnSave?.querySelector('i');
                const originalClasses = iconEl ? iconEl.className : null;
                if (iconEl) iconEl.className = 'fas fa-spinner fa-spin';

                if (btnSave) btnSave.disabled = true;
                this._state.isDirty = false;

                // Restaure l'icône dans tous les cas
                const restoreIcon = () => {
                    if (iconEl && originalClasses) iconEl.className = originalClasses;
                };

                $.ajax({
                    url: `${G.config.SERVER}apigv/sectionMonitoring/editCategories/${this.sectionMonitoringId}`,
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + G.model.userApiKey
                    },
                    method: "POST",
                    data: JSON.stringify(this._buildPayload()),
                    async: false,
                    beforeSend: function() {
                        showInfo(G.config.LOCALE_RETRIEVE('general.saveInProgress'));
                    },
                    success: function(response) {
                        restoreIcon();
                        if (response.status === "success") {
                            const sectionMonitoring = response.response.sectionMonitoring;

                            self.setState({
                                categories: self._buildStateCategoriesFromDataApi(sectionMonitoring.sectionMonitoringCategories),
                                editingCat: null,
                                editingComponent: null,
                                isDirty: false
                            });

                            self.render();

                            showSuccess(G.config.LOCALE_RETRIEVE('general.saveSuccess'));
                        }
                        else {
                            if (btnSave) btnSave.disabled = false;
                            this._state.isDirty = true;
                            showError(response.error ?? G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
                        }
                    },
                    error: function(xhr) {
                        restoreIcon();
                        if (btnSave) btnSave.disabled = false;
                        this._state.isDirty = true;
                        showError(G.config.LOCALE_RETRIEVE('general.errorHasOccured'));
                    }
                });

                break;
            }

            default:
                break;
        }
    }

    _onInput(e) {
        const t = e.target;
        if (!t) return;

        // cat name
        if (t.dataset.role === "catNameInput") {
            const rawCatId = t.dataset.catId;
            const catId = rawCatId != null && !rawCatId.startsWith(this.constructor.PREFIX_CAT_UUID)
                ? Number.parseInt(rawCatId, 10)
                : rawCatId ?? null;

            const cat = this._findCat(catId);
            if (!cat) return;
            cat.name = t.value;
            // pas de render à chaque frappe (optionnel) -> on laisse fluide
            this._emit();
            return;
        }

        // composant field
        if (t.dataset.role === "compField") {
            const rawCatId = t.dataset.catId;
            const catId = rawCatId != null && !rawCatId.startsWith(this.constructor.PREFIX_CAT_UUID)
                ? Number.parseInt(rawCatId, 10)
                : rawCatId ?? null;

            const rawCompId = t.dataset.compId;
            const compId = rawCompId != null && !rawCompId.startsWith(this.constructor.PREFIX_COMP_UUID)
                ? Number.parseInt(rawCompId, 10)
                : rawCompId ?? null;

            const key = t.dataset.key;
            const cat = this._findCat(catId);
            if (!cat) return;

            const comp = this._findComponent(cat, compId);
            if (!comp) return;

            // "point" est géré par le onChange custom de _select — on ne touche pas
            if (key === "point" || key === "srcpoint") return;

            if (t.type === "checkbox") { comp[key] = t.checked; }
            else { comp[key] = t.value; }

            this._emit();
            if (key === "label") {
                this._updateComponentHeader(catId, compId, comp[key]);
            }
            return;
        }
    }

    _onKeyDown(e) {
        const t = e.target;
        if (!t) return;

        // Enter sur nom catégorie => terminer édition
        if (t.dataset.role === "catNameInput" && e.key === "Enter") {
            this._state.editingCat = null;
            this.render();
            this._emit();
        }
    }

    _select(options, selected, catId, compId, key, onChange = null) {
        const sel = this._h("select", {
            className: "select2 select2-full-width",
            "data-role": "compField",
            "data-cat-id": catId,
            "data-comp-id": compId,
            "data-key": key,
        });

        options.forEach((o) => {
            // Cas optgroup
            if (Array.isArray(o.options)) {
                const group = this._h("optgroup", { label: o.label });

                o.options.forEach((child) => {
                    const opt = this._h("option", { value: child.value }, child.label);
                    if (child.value === selected) opt.selected = true;
                    group.appendChild(opt);
                });

                sel.appendChild(group);
                return;
            }

            // Cas option simple
            const opt = this._h("option", { value: o.value }, o.label);
            if (o.value === selected) opt.selected = true;
            sel.appendChild(opt);
        });

        if (typeof onChange === "function") {
            $(sel).on("change", (e) => {
                onChange(e, {
                    select: sel,
                    value: sel.value,
                    label: sel.options[sel.selectedIndex]?.text ?? "",
                    catId: catId,
                    compId: compId,
                    key: key,
                });
            });
        }

        return sel;
    }

    _input(type, value, placeholder, catId, compId, key) {
        return this._h("input", {
            type,
            className: "uicomp__input",
            value: value ?? "",
            placeholder,
            "data-role": "compField",
            "data-cat-id": catId,
            "data-comp-id": compId,
            "data-key": key,
        });
    }

    _checkbox(checked, catId, compId, key, label) {
        const input = this._h("input", {
            type: "checkbox",
            checked: !!checked,
            "data-role": "compField",
            "data-cat-id": catId,
            "data-comp-id": compId,
            "data-key": key,
        });

        return this._h(
            "label",
            { className: "gv-ui-ckeckbox" },
            input,
            this._h("span", { className: "value-map" }, label)
        );
    }

    _h(tag, attrs, ...children) {
        const el = document.createElement(tag);

        if (attrs) {
            for (const [k, v] of Object.entries(attrs)) {
                if (v == null) continue;
                if (k === "className") el.className = v;
                else if (k === "style") el.setAttribute("style", v);
                else if (k === "checked") el.checked = !!v;
                else if (k === "disabled") el.disabled = !!v;
                else if (k === "value") el.value = v;
                else el.setAttribute(k, v);
            }
        }

        for (const ch of children) {
            if (ch == null || ch === false) continue;
            if (Array.isArray(ch)) {
                ch.forEach((x) => x && el.appendChild(typeof x === "string" ? document.createTextNode(x) : x));
            } else if (typeof ch === "string" || typeof ch === "number") {
                el.appendChild(document.createTextNode(String(ch)));
            } else {
                el.appendChild(ch);
            }
        }

        return el;
    }
}
